import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DataFrameType: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  UUID: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export enum AiExecutionStrategy {
  Reflective = 'REFLECTIVE',
  Simple = 'SIMPLE'
}

export type AcceptCompanyInviteResult = {
  __typename?: 'AcceptCompanyInviteResult';
  accountId?: Maybe<Scalars['UUID']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum AccountCategory {
  Portfolio = 'PORTFOLIO',
  Venture = 'VENTURE'
}

export enum AccountExpiryStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  ExpiringSoon = 'EXPIRING_SOON',
  InGrace = 'IN_GRACE',
  NoExpiry = 'NO_EXPIRY'
}

export type AccountInput = {
  businessActivities?: InputMaybe<Array<Scalars['Int']['input']>>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  csrdLikelihoodThreshold?: InputMaybe<Scalars['Float']['input']>;
  csrdMagnitudeThreshold?: InputMaybe<Scalars['Float']['input']>;
  csrdNImpactLikelihoodThreshold?: InputMaybe<Scalars['Float']['input']>;
  csrdNImpactSeverityThreshold?: InputMaybe<Scalars['Float']['input']>;
  csrdNImpactThresholdReason?: InputMaybe<Scalars['String']['input']>;
  csrdPImpactLikelihoodThreshold?: InputMaybe<Scalars['Float']['input']>;
  csrdPImpactScopeThreshold?: InputMaybe<Scalars['Float']['input']>;
  csrdPImpactThresholdReason?: InputMaybe<Scalars['String']['input']>;
  csrdRequirement?: InputMaybe<Scalars['JSON']['input']>;
  csrdThresholdReason?: InputMaybe<Scalars['String']['input']>;
  defaultReferencePeriods?: InputMaybe<Array<Scalars['String']['input']>>;
  entityLevelPaiConsideration?: InputMaybe<Scalars['String']['input']>;
  esgActionsActive?: InputMaybe<Scalars['Boolean']['input']>;
  expiryDate?: InputMaybe<Scalars['Date']['input']>;
  hasNoEligibleBusinessActivities?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenKpis?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  legalEntityIdentifier?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  modules?: InputMaybe<Array<Module>>;
  nace?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameOfFinancialMarketParticipant?: InputMaybe<Scalars['String']['input']>;
  remunerationPolicies?: InputMaybe<Scalars['String']['input']>;
  requireImpactSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  showCsrdIntro?: InputMaybe<Scalars['Boolean']['input']>;
  subsidiaries?: InputMaybe<Array<Scalars['String']['input']>>;
  sustainabilityRiskIntegration?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AccountCategory>;
  usageType?: InputMaybe<UsageType>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export enum AccountMembershipRole {
  Admin = 'ADMIN',
  Editor = 'EDITOR',
  Reviewer = 'REVIEWER'
}

export type AccountSectionLinkInput = {
  accountId?: InputMaybe<Scalars['UUID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  sectionId?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountSectionLinkType = {
  __typename?: 'AccountSectionLinkType';
  account: AccountType;
  accountId: Scalars['UUID']['output'];
  comment: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  section: SectionType;
  sectionId: Scalars['Int']['output'];
};

export type AccountType = {
  __typename?: 'AccountType';
  accountMemberships: Array<AccountUserMembershipType>;
  areEuTaxonomyActivitiesInSyncWithQuestionnaire: Scalars['Boolean']['output'];
  assignedGroups: Array<PortfolioGroupType>;
  bookedModules: Array<Module>;
  businessActivities: Array<ConceptType>;
  companyInfo?: Maybe<QuestionnaireType>;
  completionRates: CompletionRateType;
  countries?: Maybe<Array<Scalars['String']['output']>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdGroups: Array<PortfolioGroupType>;
  csrdLikelihoodThreshold?: Maybe<Scalars['Float']['output']>;
  csrdMagnitudeThreshold?: Maybe<Scalars['Float']['output']>;
  csrdNImpactLikelihoodThreshold?: Maybe<Scalars['Float']['output']>;
  csrdNImpactSeverityThreshold?: Maybe<Scalars['Float']['output']>;
  csrdNImpactThresholdReason?: Maybe<Scalars['String']['output']>;
  csrdPImpactLikelihoodThreshold?: Maybe<Scalars['Float']['output']>;
  csrdPImpactScopeThreshold?: Maybe<Scalars['Float']['output']>;
  csrdPImpactThresholdReason?: Maybe<Scalars['String']['output']>;
  csrdRequirement?: Maybe<Scalars['JSON']['output']>;
  csrdThresholdReason?: Maybe<Scalars['String']['output']>;
  defaultReferencePeriods: Array<Scalars['String']['output']>;
  entityLevelPaiConsideration: Scalars['String']['output'];
  esgActionsActive: Scalars['Boolean']['output'];
  esgToken?: Maybe<Scalars['String']['output']>;
  esgs?: Maybe<Array<QuestionnaireType>>;
  euTaxonomyQuestionnaire?: Maybe<QuestionnaireType>;
  expiryDate?: Maybe<Scalars['Date']['output']>;
  expiryStatus: AccountExpiryStatus;
  fundSustainableObjectives: Array<SfdrStrategyType>;
  funds?: Maybe<Array<FundType>>;
  hasKfw: Scalars['Boolean']['output'];
  hasNoEligibleBusinessActivities?: Maybe<Scalars['Boolean']['output']>;
  hiddenKpis?: Maybe<Array<Scalars['Int']['output']>>;
  id: Scalars['UUID']['output'];
  impactGoal?: Maybe<ImpactGoalType>;
  impactGoalToken?: Maybe<Scalars['String']['output']>;
  isSuspended: Scalars['Boolean']['output'];
  legalEntityIdentifier: Scalars['String']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  membershipRoles: Array<AccountMembershipRole>;
  metricAssignments?: Maybe<Array<MetricAssignmentType>>;
  metricAssignmentsCount: Scalars['Int']['output'];
  metricsToken?: Maybe<Scalars['String']['output']>;
  modules?: Maybe<Array<Module>>;
  movedToUrls?: Maybe<Array<Scalars['String']['output']>>;
  nace?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  nameOfFinancialMarketParticipant: Scalars['String']['output'];
  portfolioLinks?: Maybe<Array<PortfolioVentureLinkType>>;
  questionnaires?: Maybe<Array<QuestionnaireType>>;
  remunerationPolicies: Scalars['String']['output'];
  reportingPeriodType: MetricReportingPeriodType;
  requireImpactSubmission?: Maybe<Scalars['Boolean']['output']>;
  showCsrdIntro: Scalars['Boolean']['output'];
  subsidiaries: Array<Scalars['String']['output']>;
  sustainabilityRiskIntegration: Scalars['String']['output'];
  teamMemberToken?: Maybe<Scalars['String']['output']>;
  type: AccountCategory;
  usageType?: Maybe<UsageType>;
  users?: Maybe<Array<UserType>>;
  usersCount: Scalars['Int']['output'];
  ventureLinks?: Maybe<Array<PortfolioVentureLinkType>>;
  website?: Maybe<Scalars['String']['output']>;
};

export type AccountUserMembershipType = {
  __typename?: 'AccountUserMembershipType';
  role: AccountMembershipRole;
  user: UserType;
};

export type ActivityInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  geographyId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  riskProfile?: InputMaybe<EnumActivityRiskProfile>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumActivityType>;
  valueChainId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ActivityStakeholderLinkInput = {
  activityId?: InputMaybe<Scalars['UUID']['input']>;
  financialMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  impactMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  stakeholderId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ActivityStakeholderLinkType = {
  __typename?: 'ActivityStakeholderLinkType';
  activity: ActivityType;
  activityId: Scalars['UUID']['output'];
  financialMaterial: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  impactMaterial: Scalars['Boolean']['output'];
  stakeholder: StakeholderType;
  stakeholderId: Scalars['UUID']['output'];
};

export type ActivityType = {
  __typename?: 'ActivityType';
  IROs: Array<IroType>;
  description: Scalars['String']['output'];
  geographyId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  industry: Scalars['String']['output'];
  location: Scalars['String']['output'];
  name: Scalars['String']['output'];
  riskProfile: EnumActivityRiskProfile;
  sortOrder: Scalars['Float']['output'];
  type: EnumActivityType;
  valueChainId: Scalars['UUID']['output'];
};

export type AddUserInput = {
  accountId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName?: Scalars['String']['input'];
  hasAcceptedPortfolioSharing?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: Scalars['String']['input'];
  password: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};

export type AddVentureAndUserInput = {
  accountId: Scalars['String']['input'];
  companyInfo?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  esgToken?: InputMaybe<Scalars['String']['input']>;
  firstName?: Scalars['String']['input'];
  hasAcceptedPortfolioSharing?: InputMaybe<Scalars['Boolean']['input']>;
  impactGoalToken?: InputMaybe<Scalars['String']['input']>;
  impactStrategy?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: Scalars['String']['input'];
  logo?: InputMaybe<Scalars['String']['input']>;
  metricsToken?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  ventureName: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
};

export type AggregatedQuestionnaireResultType = {
  __typename?: 'AggregatedQuestionnaireResultType';
  details?: Maybe<DetailsType>;
  score: Scalars['Float']['output'];
  sectionLabel: Scalars['String']['output'];
};

export enum AggregatedQuestionnaireResultsVentureFilterType {
  Ix = 'IX',
  Portfolio = 'PORTFOLIO'
}

export type AggregatedResult = {
  __typename?: 'AggregatedResult';
  actualAvg?: Maybe<Scalars['Float']['output']>;
  actualSum?: Maybe<Scalars['Float']['output']>;
  calculationType: MetricCalculationType;
  defaultGoalType?: Maybe<Scalars['String']['output']>;
  distinctVentureCnt?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  targetAvg?: Maybe<Scalars['Float']['output']>;
  targetSum?: Maybe<Scalars['Float']['output']>;
  unitName?: Maybe<Scalars['String']['output']>;
  withValueVentureCnt?: Maybe<Scalars['Int']['output']>;
};

export type AggregationCompletionDetailType = {
  __typename?: 'AggregationCompletionDetailType';
  excludedVentureIdsActual?: Maybe<Array<Scalars['String']['output']>>;
  excludedVentureIdsTarget?: Maybe<Array<Scalars['String']['output']>>;
  includedVentureIdsActual?: Maybe<Array<Scalars['String']['output']>>;
  includedVentureIdsTarget?: Maybe<Array<Scalars['String']['output']>>;
  totalVentureIdsActual?: Maybe<Array<Scalars['String']['output']>>;
  totalVentureIdsTarget?: Maybe<Array<Scalars['String']['output']>>;
};

export enum AnnualAggregationMethod {
  Avg = 'AVG',
  MostRecent = 'MOST_RECENT',
  Sum = 'SUM'
}

export type AssetAllocationTargetsInput = {
  percentEnvironmental?: InputMaybe<Scalars['Float']['input']>;
  percentEnvironmentalNotTaxonomyAligned?: InputMaybe<Scalars['Float']['input']>;
  percentEnvironmentalTaxonomyAligned?: InputMaybe<Scalars['Float']['input']>;
  percentSocial?: InputMaybe<Scalars['Float']['input']>;
  percentSustainable?: InputMaybe<Scalars['Float']['input']>;
  percentTaxonomyAlignedEnabling?: InputMaybe<Scalars['Float']['input']>;
  percentTaxonomyAlignedFossil?: InputMaybe<Scalars['Float']['input']>;
  percentTaxonomyAlignedNuclear?: InputMaybe<Scalars['Float']['input']>;
  percentTaxonomyAlignedTransitional?: InputMaybe<Scalars['Float']['input']>;
};

export type AssetAllocationTargetsType = {
  __typename?: 'AssetAllocationTargetsType';
  percentEnvironmental?: Maybe<Scalars['Float']['output']>;
  percentEnvironmentalNotTaxonomyAligned?: Maybe<Scalars['Float']['output']>;
  percentEnvironmentalTaxonomyAligned?: Maybe<Scalars['Float']['output']>;
  percentSocial?: Maybe<Scalars['Float']['output']>;
  percentSustainable?: Maybe<Scalars['Float']['output']>;
  percentTaxonomyAlignedEnabling?: Maybe<Scalars['Float']['output']>;
  percentTaxonomyAlignedFossil?: Maybe<Scalars['Float']['output']>;
  percentTaxonomyAlignedNuclear?: Maybe<Scalars['Float']['output']>;
  percentTaxonomyAlignedOther?: Maybe<Scalars['Float']['output']>;
  percentTaxonomyAlignedTransitional?: Maybe<Scalars['Float']['output']>;
};

export type AuditLogType = {
  __typename?: 'AuditLogType';
  context: Scalars['JSON']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<UserType>;
  dataId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  newData?: Maybe<Scalars['JSON']['output']>;
  operationType?: Maybe<Scalars['String']['output']>;
  originalData?: Maybe<Scalars['JSON']['output']>;
  tableName?: Maybe<Scalars['String']['output']>;
};

export type AverageTotalGhgReductionType = {
  __typename?: 'AverageTotalGhgReductionType';
  center: Scalars['Float']['output'];
  lowerBound: Scalars['Float']['output'];
  upperBound: Scalars['Float']['output'];
};

export type BatchImpactLockInput = {
  impactIds: Array<Scalars['Int']['input']>;
  lockingLevel: MetricValueLockLevel;
  operation: MetricValueLockOperation;
  reason: Scalars['String']['input'];
};

export type BatchMetricValueGranularLockInput = {
  items: Array<MetricAssignmentPeriodLockInput>;
  lockingLevel?: MetricValueLockLevel;
  operation?: MetricValueLockOperation;
  reason?: Scalars['String']['input'];
  scope?: MetricValueLockScope;
};

export type BatchMetricValueGranularLockResult = {
  __typename?: 'BatchMetricValueGranularLockResult';
  errors: Array<BatchMetricValueLockError>;
  updatedMetricAssignmentIds: Array<Scalars['Int']['output']>;
};

export type BatchMetricValueLockError = {
  __typename?: 'BatchMetricValueLockError';
  message: Scalars['String']['output'];
  metricAssignmentId: Scalars['Int']['output'];
};

export type BatchMetricValueLockInput = {
  lockingLevel?: MetricValueLockLevel;
  metricAssignmentIds: Array<Scalars['Int']['input']>;
  operation?: MetricValueLockOperation;
  reason?: Scalars['String']['input'];
  scope?: MetricValueLockScope;
};

export type BatchSubmitReviewEventInput = {
  comment: Scalars['String']['input'];
  eventType: ReviewEventType;
  reviewRequestId: Scalars['UUID']['input'];
  ventureIds: Array<Scalars['UUID']['input']>;
};

export type BatchSubmitReviewEventItemGraphType = {
  __typename?: 'BatchSubmitReviewEventItemGraphType';
  error?: Maybe<Scalars['String']['output']>;
  event?: Maybe<ReviewEventGraphType>;
  ok: Scalars['Boolean']['output'];
  ventureId: Scalars['UUID']['output'];
};

export type BatchSubmitReviewEventResultGraphType = {
  __typename?: 'BatchSubmitReviewEventResultGraphType';
  failureCount: Scalars['Int']['output'];
  results: Array<BatchSubmitReviewEventItemGraphType>;
  successCount: Scalars['Int']['output'];
};

export type CalculatedFundReportType = {
  __typename?: 'CalculatedFundReportType';
  accountOnPais?: Maybe<Scalars['String']['output']>;
  actionsTakenToMeetEsCharacteristics?: Maybe<Scalars['String']['output']>;
  alignmentWithOecdGuidelines?: Maybe<Scalars['String']['output']>;
  assetAllocation?: Maybe<Scalars['String']['output']>;
  benchmarkDescription?: Maybe<Scalars['String']['output']>;
  bindingElementsOfInvestmentStrategy?: Maybe<Scalars['String']['output']>;
  broadMarketIndexComparison?: Maybe<Scalars['String']['output']>;
  companyGovernancePolicy?: Maybe<Scalars['String']['output']>;
  esCharacteristicsDescription?: Maybe<Scalars['String']['output']>;
  fundName?: Maybe<Scalars['String']['output']>;
  fundPerformanceComparedToBroadMarketIndexOptions?: Maybe<Array<TemplateType>>;
  fundPerformanceComparedToReferenceBenchmark?: Maybe<Scalars['String']['output']>;
  fundPerformanceComparedToReferenceBenchmarkOptions?: Maybe<Array<TemplateType>>;
  fundPerformanceOnSustainabilityIndicatorsOptions?: Maybe<Array<TemplateType>>;
  fundSpecificInfo?: Maybe<Scalars['String']['output']>;
  hasAlignedEnvironmentalInvestments?: Maybe<Scalars['Boolean']['output']>;
  hasEnvironmentalInvestments?: Maybe<Scalars['Boolean']['output']>;
  hasFossilActivities?: Maybe<Scalars['Boolean']['output']>;
  hasFossilOrNuclearActivities?: Maybe<Scalars['Boolean']['output']>;
  hasNoFossilNorNuclearActivities?: Maybe<Scalars['Boolean']['output']>;
  hasNonAlignedEnvironmentalInvestments?: Maybe<Scalars['Boolean']['output']>;
  hasNuclearActivities?: Maybe<Scalars['Boolean']['output']>;
  hasSocialObjective?: Maybe<Scalars['Boolean']['output']>;
  hasSustainableInvestmentObjective?: Maybe<Scalars['Boolean']['output']>;
  howDidInvestmentsNotCauseHarm?: Maybe<Scalars['String']['output']>;
  indexCalculationMethodology?: Maybe<Scalars['String']['output']>;
  investmentAlignedIndexExplanation?: Maybe<Scalars['String']['output']>;
  investmentStrategy?: Maybe<Scalars['String']['output']>;
  investments?: Maybe<Scalars['JSON']['output']>;
  investmentsAlignedWithEuTaxonomyComparisonWithPreviousPeriods?: Maybe<Scalars['String']['output']>;
  investmentsCategorizationChartData?: Maybe<Scalars['JSON']['output']>;
  investmentsCategorizationChartDataPrecontractual?: Maybe<Scalars['JSON']['output']>;
  isArticle8: Scalars['Boolean']['output'];
  isArticle8Plus: Scalars['Boolean']['output'];
  isArticle8PlusWithAlignedEnvironmentalInvestments?: Maybe<Scalars['Boolean']['output']>;
  isArticle8PlusWithNonAlignedEnvironmentalInvestments?: Maybe<Scalars['Boolean']['output']>;
  isArticle8PlusWithSocialObjective?: Maybe<Scalars['Boolean']['output']>;
  isArticle9: Scalars['Boolean']['output'];
  isConsideringPais?: Maybe<IsConsideringPais>;
  isConsideringTaxonomy?: Maybe<Scalars['Boolean']['output']>;
  isIndexDesignated?: Maybe<Scalars['Boolean']['output']>;
  legalEntityIdentifier?: Maybe<Scalars['String']['output']>;
  minimumRateToReduceScope?: Maybe<Scalars['String']['output']>;
  nameOfFinancialMarketParticipant?: Maybe<Scalars['String']['output']>;
  percentSustainableInvestmentsWhilePromotingEsCharacteristics?: Maybe<Scalars['String']['output']>;
  percentSustainableInvestmentsWithEnvironmentalObjective?: Maybe<Scalars['String']['output']>;
  percentSustainableInvestmentsWithSocialObjective?: Maybe<Scalars['String']['output']>;
  percentageOfInvestmentsAlignedWithEuTaxonomy?: Maybe<Scalars['JSON']['output']>;
  purposeOfOtherOrNotSustainableInvestmentsIncludingSafeguards?: Maybe<Scalars['String']['output']>;
  purposeOfOtherOrNotSustainableInvestmentsIncludingSafeguardsPrecontractual?: Maybe<Scalars['String']['output']>;
  referenceBenchmarkDifferenceToBroadMarketOptions?: Maybe<Array<TemplateType>>;
  shareOfInvestmentsInTransitionalAndEnablingActivities?: Maybe<Scalars['String']['output']>;
  shareOfInvestmentsInTransitionalAndEnablingActivitiesPrecontractual?: Maybe<Scalars['String']['output']>;
  shareOfSociallySustainableInvestments?: Maybe<Scalars['String']['output']>;
  shareOfSociallySustainableInvestmentsPrecontractual?: Maybe<Scalars['String']['output']>;
  shareOfSustainableInvestmentsWithEnvironmentalObjectiveNonEuTaxonomyAligned?: Maybe<Scalars['String']['output']>;
  shareOfSustainableInvestmentsWithEnvironmentalObjectiveNonEuTaxonomyAlignedPrecontractual?: Maybe<Scalars['String']['output']>;
  sustainabilityIndicatorsDescriptionPrecontractual?: Maybe<Scalars['String']['output']>;
  sustainabilityIndicatorsPerformanceDescription?: Maybe<Scalars['String']['output']>;
  sustainabilityIndicatorsPerformanceDescriptionComparedToPrevious?: Maybe<Scalars['String']['output']>;
  sustainabilityRelatedInvestmentAssetAllocation?: Maybe<Scalars['String']['output']>;
  sustainabilityRelatedInvestmentAssetAllocationPrecontractual?: Maybe<Scalars['String']['output']>;
  sustainabilityRelatedInvestmentEconomicSector?: Maybe<Scalars['String']['output']>;
  sustainableInvestmentsMadeByFund?: Maybe<Scalars['String']['output']>;
  sustainableInvestmentsMadeByFundPrecontractual?: Maybe<Scalars['String']['output']>;
  sustainableInvestmentsWithEnvironmentalObjectiveEuTaxonomyAlignment?: Maybe<Scalars['String']['output']>;
  sustainableInvestmentsWithEnvironmentalObjectiveEuTaxonomyAlignmentPrecontractual?: Maybe<Scalars['String']['output']>;
  sustainablyAlignedIndexExplanation?: Maybe<Scalars['String']['output']>;
  useOfDerivatives?: Maybe<Scalars['String']['output']>;
  whyDidProductConsiderPais?: Maybe<Scalars['String']['output']>;
};

export type CategoryInput = {
  accountId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  labelI18n?: InputMaybe<Scalars['JSON']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryQueryInput = {
  accountId?: InputMaybe<Scalars['UUID']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  onlyRootElements?: InputMaybe<Scalars['Boolean']['input']>;
  parentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryType = {
  __typename?: 'CategoryType';
  createdAt: Scalars['DateTime']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  label: Scalars['String']['output'];
  labelI18n: Scalars['JSON']['output'];
  metrics?: Maybe<Array<MetricType>>;
  parent?: Maybe<CategoryType>;
  parentId?: Maybe<Scalars['Int']['output']>;
  subcategories?: Maybe<Array<CategoryType>>;
};

export type ChatgptTranslationInput = {
  inputText: Scalars['String']['input'];
  sourceLanguage?: InputMaybe<Scalars['String']['input']>;
  /** The target language for the translation: ("en", "de") */
  targetLanguage: Scalars['String']['input'];
};

export type ChatgptTranslationOutput = {
  __typename?: 'ChatgptTranslationOutput';
  inputText: Scalars['String']['output'];
  sourceLanguage?: Maybe<Scalars['String']['output']>;
  /** The target language for the translation: ("en", "de") */
  targetLanguage: Scalars['String']['output'];
  translatedText: Scalars['String']['output'];
};

export type ComboMutation = {
  __typename?: 'ComboMutation';
  acceptCompanyInvite: AcceptCompanyInviteResult;
  addAccount: AccountType;
  addActivity: ActivityType;
  addActivityStakeholderLink: ActivityStakeholderLinkType;
  addConcept: ConceptType;
  addEvidence: EvidenceType;
  addEvidenceLink: EvidenceLinkType;
  addFeedback: Scalars['Boolean']['output'];
  addFund: AccountType;
  addIro: IroType;
  addIroSectionLink: IroSectionLinkType;
  addIroStakeholderLink: IroStakeholderLinkType;
  addMetricAggregation: MetricAggregationType;
  addMetricAggregationBatch: Array<MetricAggregationType>;
  addMetricAndAssignmentBatch: Array<MetricAssignmentType>;
  addMetricAssignmentBatch: Array<MetricAssignmentType>;
  addMetricMetricLink: Scalars['Boolean']['output'];
  addPortfolioVentureLink: Array<PortfolioVentureLinkType>;
  addQuestionnaire: Array<QuestionnaireType>;
  addQuestionnaireSectionLink: Scalars['Boolean']['output'];
  addReportAnswer: ReportAnswerType;
  addSection: SectionType;
  addSfdrStrategy: FundType;
  addStakeholder: StakeholderType;
  addTemplateText: TemplateTextType;
  addUser: UserType;
  addValueChain: ValueChainType;
  addVentureAndUser: UserType;
  assignVenturesToGroup: Array<PortfolioVentureLinkType>;
  batchLockImpacts: Array<ImpactType>;
  batchLockMetricAssignmentValues: Array<MetricAssignmentType>;
  batchLockMetricAssignmentValuesGranular: BatchMetricValueGranularLockResult;
  batchSubmitReviewEvent: BatchSubmitReviewEventResultGraphType;
  changeHiddenKpiSettings: AccountType;
  changeReportingPeriodType: AccountType;
  createDemoPortfolio: CreateDemoPortfolioType;
  createImpact: ImpactType;
  createImpactGoal: ImpactGoalType;
  createImpactGoals: Array<ImpactGoalType>;
  createSourceAssignment: ImpactType;
  createUserinputConceptLinkWithCustomSelectedConcept: UserInputConceptLinkType;
  createVentureAccountAndInviteUser: CreateVentureAccountAndInviteUserResult;
  delActivityStakeholderLink: Scalars['Boolean']['output'];
  delEvidence: Scalars['Boolean']['output'];
  delEvidenceLink: Scalars['Boolean']['output'];
  delFunds: Scalars['Boolean']['output'];
  delIroSectionLink: Scalars['Boolean']['output'];
  delIroStakeholderLink: Scalars['Boolean']['output'];
  delQuestionnaireSectionLink: Scalars['Boolean']['output'];
  delSection: Scalars['Boolean']['output'];
  delStakeholder: Scalars['Boolean']['output'];
  deleteAccount: Scalars['Boolean']['output'];
  deleteActivity: Scalars['Boolean']['output'];
  deleteEmissionSource: GhgSavingPotentialType;
  deleteGroup: PortfolioGroupType;
  deleteImpact: DeleteInfoType;
  deleteImpactSolution: DeleteInfoType;
  deleteIro: Scalars['Boolean']['output'];
  deleteMetricAggregation: Scalars['Boolean']['output'];
  deleteMetricAggregationBatch: Scalars['Boolean']['output'];
  deleteMetricAssignment: Scalars['Boolean']['output'];
  deletePortfolioVentureLink: Scalars['Boolean']['output'];
  deletePromptTemplateVersion: Scalars['Boolean']['output'];
  deleteQuestionnaireAndUserInputs: Scalars['Boolean']['output'];
  deleteReportingRequest: Scalars['Boolean']['output'];
  deleteReviewRequest: Scalars['Boolean']['output'];
  deleteSfdrStrategy: FundType;
  deleteSourceAssignment: ImpactType;
  deleteTaxonomy: Scalars['Boolean']['output'];
  deleteTemplateText: Scalars['Boolean']['output'];
  deleteUserFeedback: Scalars['Boolean']['output'];
  deleteValueChain: Scalars['Boolean']['output'];
  executePrompt: PromptRunType;
  generatePortfolioTeamMemberSignupLinksCsv: Scalars['String']['output'];
  instantiateGhgReductionImpact: ImpactGoalType;
  inviteUser: InviteUserResult;
  oneTimeNotification: Scalars['Boolean']['output'];
  recalculateComputedKpisInPortfolio: Scalars['String']['output'];
  regenerateModuleTokens: AccountType;
  regenerateTeamMemberToken: Scalars['String']['output'];
  setAccountUserRole: AccountUserMembershipType;
  setAccountUserRoles: Array<AccountUserMembershipType>;
  setIxAdmin: UserType;
  submitEuAlignmentQuestionnaire: AccountType;
  submitQuestionnaire: QuestionnaireAssignmentType;
  submitReviewEvent: ReviewEventGraphType;
  syncEuTaxonomyActivitiesWithQuestionnaire: AccountType;
  syncVenturesWithSfdrFundSettings: FundType;
  unlinkSelectedConcept: UserInputType;
  updateAccount: AccountType;
  updateActivity: ActivityType;
  updateActivityStakeholderLink: ActivityStakeholderLinkType;
  updateAssetAllocationTargets: FundType;
  updateConcept: ConceptType;
  updateEvidence: EvidenceType;
  updateEvidenceLink: EvidenceLinkType;
  updateFund: FundType;
  updateImpact: ImpactType;
  /** @deprecated Use batchLockImpacts. Goal-level editability is deprecated. */
  updateImpactGoal: ImpactGoalType;
  updateIro: IroType;
  updateIroSectionLink: IroSectionLinkType;
  updateIroStakeholderLink: IroStakeholderLinkType;
  updateMetricAggregation: MetricAggregationType;
  updateMetricAssignment: MetricAssignmentType;
  updatePortfolioVentureLink: PortfolioVentureLinkType;
  updatePrecontractualReport: FundType;
  updateQuestion: QuestionType;
  updateQuestionSectionLink: QuestionSectionLinkType;
  updateQuestionnaire: QuestionnaireType;
  updateQuestionnaireNavigation: QuestionnaireNavigationType;
  updateRealUser: UserType;
  updateReportAnswer: ReportAnswerType;
  updateSection: SectionType;
  updateSelectedConcept: UserInputType;
  updateSelectedOptions: QuestionnaireAssignmentType;
  updateSfdrStrategy: FundType;
  updateSourceAssignment: SourceAssignmentType;
  updateStakeholder: StakeholderType;
  updateTemplateText: TemplateTextType;
  updateText: QuestionnaireAssignmentType;
  updateUserFeedback?: Maybe<UserFeedbackType>;
  updateUserInput: QuestionnaireAssignmentType;
  updateValueChain: ValueChainType;
  updateVentureComment: PortfolioVentureLinkType;
  upsertAccountSectionLink: AccountSectionLinkType;
  upsertCategory: CategoryType;
  upsertEmissionSource?: Maybe<GhgSavingPotentialType>;
  upsertEsgComparison: QuestionnaireComparisonType;
  upsertGhgSavingPotential: GhgSavingPotentialType;
  upsertGroup: PortfolioGroupType;
  upsertImpactSolution: ImpactSolutionType;
  upsertMeasure: ConceptType;
  upsertMetric: MetricType;
  upsertMetricValues: Array<MetricValueType>;
  upsertOption: OptionType;
  upsertPromptRun: PromptRunType;
  upsertPromptTemplate: PromptTemplateType;
  upsertPromptTemplateVersion: PromptTemplateVersionType;
  upsertReferencePeriod: ReferencePeriodType;
  upsertReportingRequest: ReportingRequestGraphType;
  upsertReviewRequest: ReviewRequestGraphType;
  upsertTaxonomy: TaxonomyType;
  validateFormula?: Maybe<FormulaValidateResponse>;
};


export type ComboMutationAcceptCompanyInviteArgs = {
  token: Scalars['String']['input'];
};


export type ComboMutationAddAccountArgs = {
  account: AccountInput;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type ComboMutationAddActivityArgs = {
  activityInput: ActivityInput;
};


export type ComboMutationAddActivityStakeholderLinkArgs = {
  activityId: Scalars['UUID']['input'];
  stakeholderId: Scalars['UUID']['input'];
};


export type ComboMutationAddConceptArgs = {
  input: ConceptInput;
};


export type ComboMutationAddEvidenceArgs = {
  input: EvidenceInput;
};


export type ComboMutationAddEvidenceLinkArgs = {
  input: EvidenceLinkInput;
};


export type ComboMutationAddFeedbackArgs = {
  payload: FeedbackInput;
};


export type ComboMutationAddFundArgs = {
  input?: InputMaybe<FundInput>;
  portfolioId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ComboMutationAddIroArgs = {
  iro: IroInput;
};


export type ComboMutationAddIroSectionLinkArgs = {
  iroSectionLinkInput: IroSectionLinkInput;
};


export type ComboMutationAddIroStakeholderLinkArgs = {
  iroId: Scalars['UUID']['input'];
  stakeholderId: Scalars['UUID']['input'];
};


export type ComboMutationAddMetricAggregationArgs = {
  input: MetricAggregationInput;
};


export type ComboMutationAddMetricAggregationBatchArgs = {
  input?: InputMaybe<Array<MetricAggregationInput>>;
  inputs: Array<MetricAggregationInput>;
};


export type ComboMutationAddMetricAndAssignmentBatchArgs = {
  assigneeIds: Array<Scalars['UUID']['input']>;
  metric: MetricInput;
};


export type ComboMutationAddMetricAssignmentBatchArgs = {
  inputs: Array<MetricAssignmentInput>;
  portfolioIdOverride?: InputMaybe<Scalars['UUID']['input']>;
};


export type ComboMutationAddMetricMetricLinkArgs = {
  childrenId: Array<Scalars['Int']['input']>;
  parentId: Scalars['Int']['input'];
};


export type ComboMutationAddPortfolioVentureLinkArgs = {
  portfolioId: Scalars['UUID']['input'];
  ventureIds: Array<Scalars['UUID']['input']>;
};


export type ComboMutationAddQuestionnaireArgs = {
  doSendNotification?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  notificationNote?: InputMaybe<Scalars['String']['input']>;
  periodId?: InputMaybe<Scalars['Int']['input']>;
  portfolioId?: InputMaybe<Scalars['String']['input']>;
  referencePeriod?: InputMaybe<ReferencePeriodInput>;
  sectionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  ventureIds: Array<Scalars['UUID']['input']>;
};


export type ComboMutationAddQuestionnaireSectionLinkArgs = {
  questionnaireId: Scalars['Int']['input'];
  sectionId: Scalars['Int']['input'];
};


export type ComboMutationAddReportAnswerArgs = {
  input: ReportAnswerInput;
};


export type ComboMutationAddSectionArgs = {
  input: SectionInput;
};


export type ComboMutationAddSfdrStrategyArgs = {
  input: SfdrStrategyInput;
};


export type ComboMutationAddStakeholderArgs = {
  activityId?: InputMaybe<Scalars['UUID']['input']>;
  iroId?: InputMaybe<Scalars['UUID']['input']>;
  stakeholder: StakeholderInput;
};


export type ComboMutationAddTemplateTextArgs = {
  input: TemplateTextInput;
};


export type ComboMutationAddUserArgs = {
  input: AddUserInput;
};


export type ComboMutationAddValueChainArgs = {
  valueChain: ValueChainInput;
};


export type ComboMutationAddVentureAndUserArgs = {
  input: AddVentureAndUserInput;
};


export type ComboMutationAssignVenturesToGroupArgs = {
  deleteOldVentureIds?: Scalars['Boolean']['input'];
  groupAssignments: Array<GroupAssignmentType>;
  groupId: Scalars['Int']['input'];
  portfolioId?: InputMaybe<Scalars['String']['input']>;
  ventureIds: Array<Scalars['String']['input']>;
};


export type ComboMutationBatchLockImpactsArgs = {
  input: BatchImpactLockInput;
};


export type ComboMutationBatchLockMetricAssignmentValuesArgs = {
  input: BatchMetricValueLockInput;
};


export type ComboMutationBatchLockMetricAssignmentValuesGranularArgs = {
  input: BatchMetricValueGranularLockInput;
};


export type ComboMutationBatchSubmitReviewEventArgs = {
  input: BatchSubmitReviewEventInput;
};


export type ComboMutationChangeHiddenKpiSettingsArgs = {
  hiddenKpis: Array<Scalars['Int']['input']>;
  portfolioId: Scalars['UUID']['input'];
};


export type ComboMutationChangeReportingPeriodTypeArgs = {
  portfolioId: Scalars['UUID']['input'];
  reportingPeriodType: MetricReportingPeriodType;
};


export type ComboMutationCreateDemoPortfolioArgs = {
  input: CreateDemoPortfolioInput;
};


export type ComboMutationCreateImpactArgs = {
  input: ImpactInput;
};


export type ComboMutationCreateImpactGoalArgs = {
  impactGoalId?: InputMaybe<Scalars['Int']['input']>;
  ventureId: Scalars['String']['input'];
};


export type ComboMutationCreateImpactGoalsArgs = {
  ventureIds: Array<Scalars['String']['input']>;
};


export type ComboMutationCreateSourceAssignmentArgs = {
  input: SourceAssignmentInput;
};


export type ComboMutationCreateUserinputConceptLinkWithCustomSelectedConceptArgs = {
  concept: ConceptInput;
  implementationStatus?: InputMaybe<ImplementationStatus>;
  parentConceptId?: InputMaybe<Scalars['Int']['input']>;
  userInputId: Scalars['Int']['input'];
};


export type ComboMutationCreateVentureAccountAndInviteUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  modules?: InputMaybe<Array<Module>>;
  ventureName: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
};


export type ComboMutationDelActivityStakeholderLinkArgs = {
  activityId: Scalars['UUID']['input'];
  stakeholderId: Scalars['UUID']['input'];
};


export type ComboMutationDelEvidenceArgs = {
  id: Scalars['UUID']['input'];
};


export type ComboMutationDelEvidenceLinkArgs = {
  id: Scalars['UUID']['input'];
};


export type ComboMutationDelFundsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type ComboMutationDelIroSectionLinkArgs = {
  iroId: Scalars['UUID']['input'];
  sectionId: Scalars['Int']['input'];
};


export type ComboMutationDelIroStakeholderLinkArgs = {
  iroId: Scalars['UUID']['input'];
  stakeholderId: Scalars['UUID']['input'];
};


export type ComboMutationDelQuestionnaireSectionLinkArgs = {
  questionnaireId: Scalars['Int']['input'];
  sectionId: Scalars['Int']['input'];
};


export type ComboMutationDelSectionArgs = {
  id: Scalars['Int']['input'];
};


export type ComboMutationDelStakeholderArgs = {
  id: Scalars['UUID']['input'];
};


export type ComboMutationDeleteAccountArgs = {
  dryRun?: Scalars['Boolean']['input'];
  id: Scalars['UUID']['input'];
};


export type ComboMutationDeleteActivityArgs = {
  id: Scalars['UUID']['input'];
};


export type ComboMutationDeleteEmissionSourceArgs = {
  id: Scalars['Int']['input'];
};


export type ComboMutationDeleteGroupArgs = {
  groupId: Scalars['Int']['input'];
};


export type ComboMutationDeleteImpactArgs = {
  impactId: Scalars['Int']['input'];
};


export type ComboMutationDeleteImpactSolutionArgs = {
  id: Scalars['Int']['input'];
};


export type ComboMutationDeleteIroArgs = {
  id: Scalars['UUID']['input'];
};


export type ComboMutationDeleteMetricAggregationArgs = {
  metricAggregationId: Scalars['Int']['input'];
};


export type ComboMutationDeleteMetricAggregationBatchArgs = {
  metricAggregationIds: Array<Scalars['Int']['input']>;
};


export type ComboMutationDeleteMetricAssignmentArgs = {
  metricAssignmentId: Scalars['Int']['input'];
};


export type ComboMutationDeletePortfolioVentureLinkArgs = {
  portfolioId: Scalars['UUID']['input'];
  ventureId: Scalars['UUID']['input'];
};


export type ComboMutationDeletePromptTemplateVersionArgs = {
  id: Scalars['Int']['input'];
};


export type ComboMutationDeleteQuestionnaireAndUserInputsArgs = {
  questionnaireIds: Array<Scalars['Int']['input']>;
};


export type ComboMutationDeleteReportingRequestArgs = {
  id: Scalars['UUID']['input'];
};


export type ComboMutationDeleteReviewRequestArgs = {
  id: Scalars['UUID']['input'];
};


export type ComboMutationDeleteSfdrStrategyArgs = {
  id: Scalars['Int']['input'];
};


export type ComboMutationDeleteSourceAssignmentArgs = {
  sourceAssignmentId: Scalars['Int']['input'];
};


export type ComboMutationDeleteTaxonomyArgs = {
  id: Scalars['Int']['input'];
};


export type ComboMutationDeleteTemplateTextArgs = {
  id: Scalars['Int']['input'];
};


export type ComboMutationDeleteUserFeedbackArgs = {
  feedbackId: Scalars['Int']['input'];
};


export type ComboMutationDeleteValueChainArgs = {
  id: Scalars['UUID']['input'];
};


export type ComboMutationExecutePromptArgs = {
  input: ExecutePromptInput;
};


export type ComboMutationInstantiateGhgReductionImpactArgs = {
  ventureId: Scalars['UUID']['input'];
};


export type ComboMutationInviteUserArgs = {
  email: Scalars['String']['input'];
  ventureId: Scalars['UUID']['input'];
};


export type ComboMutationOneTimeNotificationArgs = {
  input: NotificationInput;
};


export type ComboMutationRecalculateComputedKpisInPortfolioArgs = {
  portfolioId: Scalars['UUID']['input'];
};


export type ComboMutationRegenerateModuleTokensArgs = {
  id: Scalars['UUID']['input'];
};


export type ComboMutationRegenerateTeamMemberTokenArgs = {
  id: Scalars['UUID']['input'];
};


export type ComboMutationSetAccountUserRoleArgs = {
  accountId: Scalars['UUID']['input'];
  role: AccountMembershipRole;
  userId: Scalars['UUID']['input'];
};


export type ComboMutationSetAccountUserRolesArgs = {
  accountId: Scalars['UUID']['input'];
  roles: Array<AccountMembershipRole>;
  userId: Scalars['UUID']['input'];
};


export type ComboMutationSetIxAdminArgs = {
  isIxAdmin: Scalars['Boolean']['input'];
  userId: Scalars['UUID']['input'];
};


export type ComboMutationSubmitEuAlignmentQuestionnaireArgs = {
  isEditable: Scalars['Boolean']['input'];
  questionnaireId: Scalars['Int']['input'];
};


export type ComboMutationSubmitQuestionnaireArgs = {
  isEditable: Scalars['Boolean']['input'];
  questionnaireId: Scalars['Int']['input'];
};


export type ComboMutationSubmitReviewEventArgs = {
  input: SubmitReviewEventInput;
};


export type ComboMutationSyncEuTaxonomyActivitiesWithQuestionnaireArgs = {
  ventureId: Scalars['String']['input'];
};


export type ComboMutationSyncVenturesWithSfdrFundSettingsArgs = {
  esgNotificationNote?: InputMaybe<Scalars['String']['input']>;
  fundId: Scalars['Int']['input'];
  portfolioIdOverride?: InputMaybe<Scalars['UUID']['input']>;
  sendEsgNotifications?: Scalars['Boolean']['input'];
};


export type ComboMutationUnlinkSelectedConceptArgs = {
  conceptId: Scalars['Int']['input'];
  userInputId: Scalars['Int']['input'];
};


export type ComboMutationUpdateAccountArgs = {
  input: AccountInput;
  userIdsToAdd?: InputMaybe<Array<Scalars['UUID']['input']>>;
  userIdsToRemove?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type ComboMutationUpdateActivityArgs = {
  activityInput: ActivityInput;
};


export type ComboMutationUpdateActivityStakeholderLinkArgs = {
  activityStakeholderLinkInput: ActivityStakeholderLinkInput;
};


export type ComboMutationUpdateAssetAllocationTargetsArgs = {
  input: FundInput;
};


export type ComboMutationUpdateConceptArgs = {
  input: ConceptInput;
};


export type ComboMutationUpdateEvidenceArgs = {
  input: EvidenceInput;
};


export type ComboMutationUpdateEvidenceLinkArgs = {
  input: EvidenceLinkInput;
};


export type ComboMutationUpdateFundArgs = {
  input: FundInput;
};


export type ComboMutationUpdateImpactArgs = {
  id: Scalars['Int']['input'];
  input: ImpactInput;
};


export type ComboMutationUpdateImpactGoalArgs = {
  input: ImpactGoalInput;
};


export type ComboMutationUpdateIroArgs = {
  iroInput: IroInput;
};


export type ComboMutationUpdateIroSectionLinkArgs = {
  iroSectionLinkInput: IroSectionLinkInput;
};


export type ComboMutationUpdateIroStakeholderLinkArgs = {
  iroStakeholderLinkInput: IroStakeholderLinkInput;
};


export type ComboMutationUpdateMetricAggregationArgs = {
  input: MetricAggregationInput;
};


export type ComboMutationUpdateMetricAssignmentArgs = {
  input: MetricAssignmentInput;
  metricAggregationId?: InputMaybe<Scalars['Int']['input']>;
};


export type ComboMutationUpdatePortfolioVentureLinkArgs = {
  modules: Array<Scalars['String']['input']>;
  portfolioId: Scalars['UUID']['input'];
  ventureId: Scalars['UUID']['input'];
};


export type ComboMutationUpdatePrecontractualReportArgs = {
  input: FundInput;
};


export type ComboMutationUpdateQuestionArgs = {
  input: QuestionInput;
};


export type ComboMutationUpdateQuestionSectionLinkArgs = {
  input: QuestionSectionLinkInput;
};


export type ComboMutationUpdateQuestionnaireArgs = {
  input: QuestionnaireInput;
};


export type ComboMutationUpdateQuestionnaireNavigationArgs = {
  input: QuestionnaireNavigationInput;
};


export type ComboMutationUpdateRealUserArgs = {
  input: UpdateUserInput;
};


export type ComboMutationUpdateReportAnswerArgs = {
  input: ReportAnswerInput;
};


export type ComboMutationUpdateSectionArgs = {
  id: Scalars['Int']['input'];
  input: SectionInput;
};


export type ComboMutationUpdateSelectedConceptArgs = {
  input: UserInputConceptLinkInput;
};


export type ComboMutationUpdateSelectedOptionsArgs = {
  userInputId: Scalars['Int']['input'];
  values: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type ComboMutationUpdateSfdrStrategyArgs = {
  input: SfdrStrategyInput;
};


export type ComboMutationUpdateSourceAssignmentArgs = {
  input: SourceAssignmentInput;
};


export type ComboMutationUpdateStakeholderArgs = {
  stakeholder: StakeholderInput;
};


export type ComboMutationUpdateTemplateTextArgs = {
  input: TemplateTextInput;
};


export type ComboMutationUpdateTextArgs = {
  text?: InputMaybe<Scalars['String']['input']>;
  userInputId: Scalars['Int']['input'];
};


export type ComboMutationUpdateUserFeedbackArgs = {
  input: UserFeedbackInput;
};


export type ComboMutationUpdateUserInputArgs = {
  input: UserInputInput;
};


export type ComboMutationUpdateValueChainArgs = {
  valueChain: ValueChainInput;
};


export type ComboMutationUpdateVentureCommentArgs = {
  comment: Scalars['String']['input'];
  ventureId: Scalars['String']['input'];
};


export type ComboMutationUpsertAccountSectionLinkArgs = {
  input: AccountSectionLinkInput;
};


export type ComboMutationUpsertCategoryArgs = {
  input: CategoryInput;
};


export type ComboMutationUpsertEmissionSourceArgs = {
  input: EmissionSourceInput;
};


export type ComboMutationUpsertEsgComparisonArgs = {
  input: QuestionnaireComparisonInput;
};


export type ComboMutationUpsertGhgSavingPotentialArgs = {
  input: GhgSavingPotentialInput;
};


export type ComboMutationUpsertGroupArgs = {
  input: PortfolioGroupInput;
};


export type ComboMutationUpsertImpactSolutionArgs = {
  input: ImpactSolutionInput;
};


export type ComboMutationUpsertMeasureArgs = {
  input: ConceptInput;
  update?: Scalars['Boolean']['input'];
};


export type ComboMutationUpsertMetricArgs = {
  input: MetricInput;
  update?: Scalars['Boolean']['input'];
};


export type ComboMutationUpsertMetricValuesArgs = {
  inputs: Array<MetricValueInput>;
};


export type ComboMutationUpsertOptionArgs = {
  input: OptionInput;
};


export type ComboMutationUpsertPromptRunArgs = {
  input: PromptRunInput;
};


export type ComboMutationUpsertPromptTemplateArgs = {
  input: PromptTemplateInput;
};


export type ComboMutationUpsertPromptTemplateVersionArgs = {
  input: PromptTemplateVersionInput;
};


export type ComboMutationUpsertReferencePeriodArgs = {
  input: ReferencePeriodInput;
};


export type ComboMutationUpsertReportingRequestArgs = {
  input: UpsertReportingRequestInput;
};


export type ComboMutationUpsertReviewRequestArgs = {
  input: UpsertReviewRequestInput;
};


export type ComboMutationUpsertTaxonomyArgs = {
  input: TaxonomyInput;
};


export type ComboMutationValidateFormulaArgs = {
  expression: Scalars['String']['input'];
};

export type ComboQuery = {
  __typename?: 'ComboQuery';
  basicInfoForCompany: CompanyInfoType;
  canAssignmentBeDeleted: MetricAssignmentDependencyType;
  chatgptTranslate: Array<ChatgptTranslationOutput>;
  checkEmailDomainAccountWarning: EmailDomainAccountWarningType;
  countAccounts: Scalars['Int']['output'];
  countActivities: Scalars['Int']['output'];
  countActivityStakeholderLinks: Scalars['Int']['output'];
  countAuditLogs: Scalars['Int']['output'];
  countCategories: Scalars['Int']['output'];
  countConcepts: Scalars['Int']['output'];
  countEsgQuestionnaireResultsForVentures: Scalars['Int']['output'];
  countEvidenceLinks: Scalars['Int']['output'];
  countEvidences: Scalars['Int']['output'];
  countFeedbacks: Scalars['Int']['output'];
  countFunds: Scalars['Int']['output'];
  countIdemats: Scalars['Int']['output'];
  countIroSectionLinks: Scalars['Int']['output'];
  countIroStakeholderLinks: Scalars['Int']['output'];
  countIros: Scalars['Int']['output'];
  countMetricAggregations: Scalars['Int']['output'];
  countMetricAssignments: Scalars['Int']['output'];
  countMetrics: Scalars['Int']['output'];
  countPortfolioVentureLinks: Scalars['Int']['output'];
  countQuestionnaires: Scalars['Int']['output'];
  countQuestions: Scalars['Int']['output'];
  countReviewEvents: Scalars['Int']['output'];
  countSections: Scalars['Int']['output'];
  countStakeholders: Scalars['Int']['output'];
  countTaxonomies: Scalars['Int']['output'];
  countUsers: Scalars['Int']['output'];
  countValueChains: Scalars['Int']['output'];
  esgQuestionnaireAsTable: Array<QuestionSummaryType>;
  exportByCompany: ExportExcelByCompanyType;
  exportByPortfolio: ExportByPortfolioType;
  exportCompanyTypstEsgPdf: FileExportType;
  exportCompanyTypstPdf: FileExportType;
  exportFundReport: ExportFundReportType;
  exportKfw: ExportKfWType;
  exportNkiCompanyData: FileExportType;
  exportPaiReport: ExportFundReportType;
  exportPrecontractualReport: ExportFundReportType;
  exportReviewCompanyTypstPdfs: ExportReviewCompanyTypstPdfsResultGraphType;
  exportReviewImpactData: FileExportType;
  fundSetupState: FundSetupState;
  getAccount: AccountType;
  getActivity: ActivityType;
  getAggregatedEsgQuestionnaireResult: Array<AggregatedQuestionnaireResultType>;
  getDisclosureSummary: DisclosureSummaryType;
  getEsgComparison?: Maybe<QuestionnaireComparisonType>;
  getEsgMeasureComparison?: Maybe<EsgMeasureComparisonType>;
  getEsgQuestionnaireResultsForVentures: Array<QuestionnaireResultSummaryType>;
  getFund: FundType;
  getFundReport?: Maybe<CalculatedFundReportType>;
  getImpact: ImpactType;
  getImpactGeographiesForVentures: Array<GeographyAggregationType>;
  getImpactGoal: ImpactGoalType;
  getImpactSdgsForVentures: Array<SdgAggregationType>;
  getImpactSummary: ImpactSummaryType;
  getIro: IroType;
  getMetric: MetricType;
  getMetricAggregation: MetricAggregationType;
  getMetricAssignment: MetricAssignmentType;
  getMostRecentQuestionnaireForVentureAndLabel: QuestionnaireType;
  getPaiReport?: Maybe<PaiReportType>;
  getQuestion?: Maybe<QuestionType>;
  getQuestionnaire?: Maybe<QuestionnaireType>;
  getQuestionnairesForVenturesAndLabel: Array<QuestionnaireAssignmentType>;
  getReportingRequest: ReportingRequestGraphType;
  getReviewRequest: ReviewRequestGraphType;
  getSection: SectionType;
  getStakeholder: StakeholderType;
  getStandardReferencePeriods: Array<ReferencePeriodType>;
  getTeamMemberLink: Scalars['String']['output'];
  getUser: UserType;
  getUserById?: Maybe<UserType>;
  getUserFeedback?: Maybe<Array<Maybe<UserFeedbackType>>>;
  getUserInput: UserInputType;
  listAccounts: Array<AccountType>;
  listActivities: Array<ActivityType>;
  listActivityStakeholderLinks: Array<ActivityStakeholderLinkType>;
  listAuditLogs?: Maybe<Array<AuditLogType>>;
  listCategories: Array<CategoryType>;
  listConcepts: Array<ConceptType>;
  listEvidenceLinks?: Maybe<Array<EvidenceLinkType>>;
  listEvidences: Array<EvidenceType>;
  listFeedbacks: Array<FeedbackType>;
  listFunds: Array<FundType>;
  listGeographies: Array<GeographyType>;
  listGroupNamesInPortfolio: Array<Scalars['String']['output']>;
  listIdemats: Array<IdematType>;
  listImpactGoals: Array<ImpactGoalType>;
  listIroSectionLinks: Array<IroSectionLinkType>;
  listIroStakeholderLinks: Array<IroStakeholderLinkType>;
  listIros: Array<IroType>;
  listMetricAggregationCategoryCounts: Array<MetricAggregationCategoryCountType>;
  listMetricAggregationSectionCounts: Array<MetricAggregationSectionCountType>;
  listMetricAggregations: Array<MetricAggregationType>;
  listMetricAssignmentCategoryCounts: Array<MetricAssignmentCategoryCountType>;
  listMetricAssignmentConditionalChildren: Array<MetricAssignmentType>;
  listMetricAssignmentSectionCounts: Array<MetricAssignmentSectionCountType>;
  listMetricAssignments: Array<MetricAssignmentType>;
  listMetrics: Array<MetricType>;
  listOptions: Array<OptionType>;
  listPortfolioGroups: Array<PortfolioGroupType>;
  listPortfolioVentureLinks: Array<PortfolioVentureLinkType>;
  listPromptTemplateVersion: Array<PromptTemplateVersionType>;
  listQuestionnaires: Array<QuestionnaireType>;
  listQuestions: Array<QuestionType>;
  listReferencePeriods: Array<ReferencePeriodType>;
  listReportingRequests: Array<ReportingRequestGraphType>;
  listReviewEvents: Array<ReviewEventGraphType>;
  listReviewRequests: Array<ReviewRequestGraphType>;
  listSections: Array<SectionType>;
  listStakeholders: Array<StakeholderType>;
  listTableModels: Array<FullyQualifiedPath>;
  listTaxonomies: Array<TaxonomyType>;
  listUniqueIdematUnitsAndCategories: IdematFilter;
  listUserInputs: Array<UserInputVentureMappingType>;
  listUserLogEvents: Scalars['JSON']['output'];
  listUsers: Array<UserType>;
  listValueChains: Array<ValueChainType>;
  metricValueAggregation: Array<AggregatedResult>;
  metricValuesForPeriod: Array<MetricValueType>;
  reportingRequestKpiOptions: Array<ReportingRequestKpiOptionGraphType>;
  reportingVenturesMissingEsgModule: Array<Scalars['UUID']['output']>;
  reportingVenturesMissingImpactCarry: Array<Scalars['UUID']['output']>;
  updateAllIroStatuses: Array<IroUpdateType>;
  validateTemplateText?: Maybe<TemplateValidateResponse>;
};


export type ComboQueryBasicInfoForCompanyArgs = {
  ventureId: Scalars['String']['input'];
};


export type ComboQueryCanAssignmentBeDeletedArgs = {
  id: Scalars['Int']['input'];
};


export type ComboQueryChatgptTranslateArgs = {
  input: ChatgptTranslationInput;
  maxAttempts?: Scalars['Int']['input'];
  prompt?: PromptEnum;
};


export type ComboQueryCheckEmailDomainAccountWarningArgs = {
  email: Scalars['String']['input'];
};


export type ComboQueryCountAccountsArgs = {
  filters?: InputMaybe<ListAccountFilter>;
};


export type ComboQueryCountActivitiesArgs = {
  filters?: InputMaybe<ListActivityFilter>;
};


export type ComboQueryCountActivityStakeholderLinksArgs = {
  activityId: Scalars['UUID']['input'];
};


export type ComboQueryCountAuditLogsArgs = {
  createdById?: InputMaybe<Array<Scalars['UUID']['input']>>;
  dataId?: InputMaybe<Scalars['UUID']['input']>;
  excludeSystemUser?: InputMaybe<Scalars['Boolean']['input']>;
  operationType?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  tableName?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type ComboQueryCountCategoriesArgs = {
  input?: InputMaybe<CategoryQueryInput>;
};


export type ComboQueryCountConceptsArgs = {
  createdBy?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  queryInput?: InputMaybe<ConceptQueryInput>;
  taxonomy?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type ComboQueryCountEsgQuestionnaireResultsForVenturesArgs = {
  filters?: InputMaybe<ListPortfolioVentureLinksFilter>;
};


export type ComboQueryCountEvidenceLinksArgs = {
  filters?: InputMaybe<ListEvidenceLinkFilter>;
};


export type ComboQueryCountEvidencesArgs = {
  filters?: InputMaybe<ListEvidenceFilter>;
};


export type ComboQueryCountFundsArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
};


export type ComboQueryCountIdematsArgs = {
  filters?: InputMaybe<IdematSearchInput>;
};


export type ComboQueryCountIroSectionLinksArgs = {
  iroId: Scalars['UUID']['input'];
};


export type ComboQueryCountIroStakeholderLinksArgs = {
  iroId: Scalars['UUID']['input'];
};


export type ComboQueryCountIrosArgs = {
  input?: InputMaybe<IroQueryInput>;
};


export type ComboQueryCountMetricAggregationsArgs = {
  categoryIds?: Array<Scalars['Int']['input']>;
  fundId?: Scalars['Int']['input'];
  groupId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeUncategorized?: Scalars['Boolean']['input'];
  isPaiResultsView?: Scalars['Boolean']['input'];
  keyword?: Scalars['String']['input'];
  metricIds?: Array<Scalars['Int']['input']>;
  sectionIds?: Array<Scalars['Int']['input']>;
};


export type ComboQueryCountMetricAssignmentsArgs = {
  assigneeIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  filters?: InputMaybe<ListMetricAssignmentFilter>;
  ghgSavingPotentialId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  impactSolutionId?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  metricIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  metricNotionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  selfAssigned?: Scalars['Boolean']['input'];
  showImpactTargets?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComboQueryCountMetricsArgs = {
  createdBy?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<MetricQueryInput>;
};


export type ComboQueryCountPortfolioVentureLinksArgs = {
  filters?: InputMaybe<ListPortfolioVentureLinksFilter>;
};


export type ComboQueryCountQuestionnairesArgs = {
  filters?: InputMaybe<ListQuestionnaireFilter>;
};


export type ComboQueryCountQuestionsArgs = {
  filters?: InputMaybe<ListQuestionFilter>;
};


export type ComboQueryCountReviewEventsArgs = {
  filters: ReviewEventFilters;
};


export type ComboQueryCountSectionsArgs = {
  filters?: InputMaybe<SectionFiltersInput>;
};


export type ComboQueryCountStakeholdersArgs = {
  filters?: InputMaybe<ListStakeholderFilter>;
};


export type ComboQueryCountTaxonomiesArgs = {
  input: TaxonomyFilterInput;
};


export type ComboQueryCountUsersArgs = {
  accountId?: InputMaybe<Scalars['UUID']['input']>;
  excludeIxUsers?: Scalars['Boolean']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type ComboQueryCountValueChainsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type ComboQueryEsgQuestionnaireAsTableArgs = {
  id: Scalars['Int']['input'];
};


export type ComboQueryExportByCompanyArgs = {
  input: ExportExcelByCompanyInput;
};


export type ComboQueryExportCompanyTypstEsgPdfArgs = {
  input: ExportCompanyTypstEsgPdfInput;
};


export type ComboQueryExportCompanyTypstPdfArgs = {
  input: ExportCompanyTypstPdfInput;
};


export type ComboQueryExportFundReportArgs = {
  input: ExportFundReportInput;
};


export type ComboQueryExportKfwArgs = {
  input: ExportKfWInput;
};


export type ComboQueryExportNkiCompanyDataArgs = {
  input?: InputMaybe<ExportNkiCompanyDataInput>;
};


export type ComboQueryExportPaiReportArgs = {
  input: ExportPaiReportInput;
};


export type ComboQueryExportPrecontractualReportArgs = {
  input: ExportPrecontractualReportInput;
};


export type ComboQueryExportReviewCompanyTypstPdfsArgs = {
  input: ExportReviewCompanyTypstPdfsInput;
};


export type ComboQueryExportReviewImpactDataArgs = {
  input: ExportReviewImpactDataInput;
};


export type ComboQueryFundSetupStateArgs = {
  id: Scalars['Int']['input'];
};


export type ComboQueryGetAccountArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type ComboQueryGetActivityArgs = {
  id: Scalars['UUID']['input'];
};


export type ComboQueryGetAggregatedEsgQuestionnaireResultArgs = {
  input?: InputMaybe<GetAggregatedQuestionnaireResultFilter>;
};


export type ComboQueryGetDisclosureSummaryArgs = {
  fundId: Scalars['Int']['input'];
  referencePeriod: Scalars['Int']['input'];
  reportType: ReportType;
};


export type ComboQueryGetEsgComparisonArgs = {
  firstQuestionnaireId: Scalars['Int']['input'];
  secondQuestionnaireId: Scalars['Int']['input'];
};


export type ComboQueryGetEsgMeasureComparisonArgs = {
  input: EsgMeasureComparisonInput;
};


export type ComboQueryGetEsgQuestionnaireResultsForVenturesArgs = {
  filters?: InputMaybe<ListPortfolioVentureLinksFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComboQueryGetFundArgs = {
  id: Scalars['Int']['input'];
};


export type ComboQueryGetFundReportArgs = {
  input: GetFundReportInput;
};


export type ComboQueryGetImpactArgs = {
  impactId: Scalars['Int']['input'];
};


export type ComboQueryGetImpactGeographiesForVenturesArgs = {
  showPositive?: InputMaybe<Scalars['Boolean']['input']>;
  ventureIds: Array<Scalars['String']['input']>;
};


export type ComboQueryGetImpactGoalArgs = {
  ventureId?: Scalars['String']['input'];
};


export type ComboQueryGetImpactSdgsForVenturesArgs = {
  showPositive?: InputMaybe<Scalars['Boolean']['input']>;
  ventureIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type ComboQueryGetImpactSummaryArgs = {
  ventureId: Scalars['String']['input'];
};


export type ComboQueryGetIroArgs = {
  id: Scalars['UUID']['input'];
};


export type ComboQueryGetMetricArgs = {
  id: Scalars['Int']['input'];
};


export type ComboQueryGetMetricAggregationArgs = {
  id: Scalars['Int']['input'];
};


export type ComboQueryGetMetricAssignmentArgs = {
  id: Scalars['Int']['input'];
};


export type ComboQueryGetMostRecentQuestionnaireForVentureAndLabelArgs = {
  label: Scalars['String']['input'];
  ventureId: Scalars['String']['input'];
};


export type ComboQueryGetPaiReportArgs = {
  input: GetPaiReportInput;
};


export type ComboQueryGetQuestionArgs = {
  id: Scalars['Int']['input'];
};


export type ComboQueryGetQuestionnaireArgs = {
  id: Scalars['Int']['input'];
};


export type ComboQueryGetQuestionnairesForVenturesAndLabelArgs = {
  label: Scalars['String']['input'];
  ventureIds: Array<Scalars['String']['input']>;
};


export type ComboQueryGetReportingRequestArgs = {
  id: Scalars['UUID']['input'];
};


export type ComboQueryGetReviewRequestArgs = {
  id: Scalars['UUID']['input'];
};


export type ComboQueryGetSectionArgs = {
  id: Scalars['Int']['input'];
};


export type ComboQueryGetStakeholderArgs = {
  id: Scalars['UUID']['input'];
};


export type ComboQueryGetTeamMemberLinkArgs = {
  id: Scalars['UUID']['input'];
  role?: InputMaybe<AccountMembershipRole>;
};


export type ComboQueryGetUserByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type ComboQueryGetUserFeedbackArgs = {
  accountId: Scalars['UUID']['input'];
  conceptId: Scalars['Int']['input'];
  insightId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ComboQueryGetUserInputArgs = {
  id: Scalars['Int']['input'];
};


export type ComboQueryListAccountsArgs = {
  filters?: InputMaybe<ListAccountFilter>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortParam>>;
};


export type ComboQueryListActivitiesArgs = {
  filters?: InputMaybe<ListActivityFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ComboQueryListActivityStakeholderLinksArgs = {
  activityId: Scalars['UUID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ComboQueryListAuditLogsArgs = {
  createdById?: InputMaybe<Array<Scalars['UUID']['input']>>;
  dataId?: InputMaybe<Scalars['UUID']['input']>;
  excludeSystemUser?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  operationType?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  tableName?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type ComboQueryListCategoriesArgs = {
  input?: InputMaybe<CategoryQueryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
};


export type ComboQueryListConceptsArgs = {
  createdBy?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  queryInput?: InputMaybe<ConceptQueryInput>;
  taxonomy?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type ComboQueryListEvidenceLinksArgs = {
  filters?: InputMaybe<ListEvidenceLinkFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ComboQueryListEvidencesArgs = {
  filters?: InputMaybe<ListEvidenceFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ComboQueryListFeedbacksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ComboQueryListFundsArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type ComboQueryListGeographiesArgs = {
  filters?: InputMaybe<ListGeographyFilter>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type ComboQueryListGroupNamesInPortfolioArgs = {
  portfolioId: Scalars['String']['input'];
};


export type ComboQueryListIdematsArgs = {
  input: IdematSearchInput;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortParam>>;
};


export type ComboQueryListImpactGoalsArgs = {
  filters?: InputMaybe<ListImpactGoalFilters>;
};


export type ComboQueryListIroSectionLinksArgs = {
  iroId: Scalars['UUID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ComboQueryListIroStakeholderLinksArgs = {
  iroId: Scalars['UUID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ComboQueryListIrosArgs = {
  input?: InputMaybe<IroQueryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ComboQueryListMetricAggregationCategoryCountsArgs = {
  fundId?: Scalars['Int']['input'];
  groupId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  isPaiResultsView?: Scalars['Boolean']['input'];
  keyword?: Scalars['String']['input'];
  metricIds?: Array<Scalars['Int']['input']>;
};


export type ComboQueryListMetricAggregationSectionCountsArgs = {
  fundId?: Scalars['Int']['input'];
  groupId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  isPaiResultsView?: Scalars['Boolean']['input'];
  keyword?: Scalars['String']['input'];
  metricIds?: Array<Scalars['Int']['input']>;
};


export type ComboQueryListMetricAggregationsArgs = {
  categoryIds?: Array<Scalars['Int']['input']>;
  fundId?: Scalars['Int']['input'];
  groupId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeUncategorized?: Scalars['Boolean']['input'];
  isPaiResultsView?: Scalars['Boolean']['input'];
  keyword?: Scalars['String']['input'];
  limit?: Scalars['Int']['input'];
  metricIds?: Array<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  sectionIds?: Array<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortParam>>;
};


export type ComboQueryListMetricAssignmentCategoryCountsArgs = {
  assigneeIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  filters?: InputMaybe<ListMetricAssignmentFilter>;
  ghgSavingPotentialId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  impactSolutionId?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  metricIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  metricNotionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  selfAssigned?: Scalars['Boolean']['input'];
  showImpactTargets?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComboQueryListMetricAssignmentConditionalChildrenArgs = {
  answer?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
};


export type ComboQueryListMetricAssignmentSectionCountsArgs = {
  assigneeIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  filters?: InputMaybe<ListMetricAssignmentFilter>;
  ghgSavingPotentialId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  impactSolutionId?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  metricIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  metricNotionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  selfAssigned?: Scalars['Boolean']['input'];
  showImpactTargets?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComboQueryListMetricAssignmentsArgs = {
  assigneeIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  filters?: InputMaybe<ListMetricAssignmentFilter>;
  fundIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  ghgSavingPotentialId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  impactSolutionId?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  metricIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  metricNotionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  metricValueFilters?: InputMaybe<ListMetricValuesFilter>;
  offset?: Scalars['Int']['input'];
  selfAssigned?: Scalars['Boolean']['input'];
  showImpactTargets?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Array<SortParam>>;
};


export type ComboQueryListMetricsArgs = {
  createdBy?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<MetricQueryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
};


export type ComboQueryListOptionsArgs = {
  id: Scalars['Int']['input'];
};


export type ComboQueryListPortfolioVentureLinksArgs = {
  filters?: InputMaybe<ListPortfolioVentureLinksFilter>;
  group?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComboQueryListPromptTemplateVersionArgs = {
  filters?: InputMaybe<ListPromptTemplateVersionFilter>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type ComboQueryListQuestionnairesArgs = {
  filters?: InputMaybe<ListQuestionnaireFilter>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type ComboQueryListQuestionsArgs = {
  filters?: InputMaybe<ListQuestionFilter>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type ComboQueryListReferencePeriodsArgs = {
  filters?: InputMaybe<ListReferencePeriodFilters>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type ComboQueryListReviewEventsArgs = {
  filters: ReviewEventFilters;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type ComboQueryListSectionsArgs = {
  filters?: InputMaybe<SectionFiltersInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type ComboQueryListStakeholdersArgs = {
  filters?: InputMaybe<ListStakeholderFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ComboQueryListTableModelsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
  tableNames: Array<Scalars['String']['input']>;
};


export type ComboQueryListTaxonomiesArgs = {
  input: TaxonomyFilterInput;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type ComboQueryListUserInputsArgs = {
  input: Array<UserInputInput>;
};


export type ComboQueryListUserLogEventsArgs = {
  email: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type ComboQueryListUsersArgs = {
  accountId?: InputMaybe<Scalars['UUID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type ComboQueryListValueChainsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type ComboQueryMetricValueAggregationArgs = {
  period: Scalars['String']['input'];
};


export type ComboQueryMetricValuesForPeriodArgs = {
  metricAssignmentId: Scalars['Int']['input'];
  period: Scalars['String']['input'];
};


export type ComboQueryReportingRequestKpiOptionsArgs = {
  ventureIds: Array<Scalars['UUID']['input']>;
};


export type ComboQueryReportingVenturesMissingEsgModuleArgs = {
  ventureIds: Array<Scalars['UUID']['input']>;
};


export type ComboQueryReportingVenturesMissingImpactCarryArgs = {
  ventureIds: Array<Scalars['UUID']['input']>;
};


export type ComboQueryValidateTemplateTextArgs = {
  context?: InputMaybe<TemplateEngineContext>;
  fundId?: InputMaybe<Scalars['Int']['input']>;
  impactId?: InputMaybe<Scalars['Int']['input']>;
  impactSolutionId?: InputMaybe<Scalars['Int']['input']>;
  templateText: Scalars['String']['input'];
};

export type CompanyInfoType = {
  __typename?: 'CompanyInfoType';
  businessModel: Array<Scalars['String']['output']>;
  commercialRegisterNumber?: Maybe<Scalars['String']['output']>;
  companyValuation?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  customerGroup: Array<Scalars['String']['output']>;
  customerGroupOptions?: Maybe<Scalars['String']['output']>;
  employeeHeadcount?: Maybe<Scalars['String']['output']>;
  founders: Array<Scalars['String']['output']>;
  foundingYear?: Maybe<Scalars['String']['output']>;
  fundingStage?: Maybe<Scalars['String']['output']>;
  headquarter?: Maybe<Scalars['String']['output']>;
  incomeStream: Array<Scalars['String']['output']>;
  industries: Array<Scalars['String']['output']>;
  legalEntity?: Maybe<Scalars['String']['output']>;
  pitchLine?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  primaryIndustry?: Maybe<Scalars['String']['output']>;
  products: Array<Scalars['String']['output']>;
  questionnaireId: Scalars['Int']['output'];
  turnover?: Maybe<Scalars['String']['output']>;
  ventureId: Scalars['String']['output'];
  ventureName?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type CompanyUserInviteType = {
  __typename?: 'CompanyUserInviteType';
  email: Scalars['String']['output'];
  sentAt: Scalars['DateTime']['output'];
  sentById?: Maybe<Scalars['UUID']['output']>;
};

export type CompletionRatePeriodDebugType = {
  __typename?: 'CompletionRatePeriodDebugType';
  completedMetrics: Scalars['Int']['output'];
  incompleteMetrics: Scalars['Int']['output'];
  period: Scalars['String']['output'];
  skippedMetrics: Scalars['Int']['output'];
  totalMetrics: Scalars['Int']['output'];
};

export type CompletionRateType = {
  __typename?: 'CompletionRateType';
  annualMetrics: Scalars['Int']['output'];
  assigneeId: Scalars['UUID']['output'];
  completedMetrics: Scalars['Int']['output'];
  completionRate?: Maybe<Scalars['Float']['output']>;
  incompleteMetrics: Scalars['Int']['output'];
  periodDebug: Array<CompletionRatePeriodDebugType>;
  periodsConsidered: Array<Scalars['String']['output']>;
  quarterlyMetrics: Scalars['Int']['output'];
  responseRate?: Maybe<Scalars['Float']['output']>;
  skippedMetrics: Scalars['Int']['output'];
  skippedRate?: Maybe<Scalars['Float']['output']>;
  totalMetrics: Scalars['Int']['output'];
};

export type ConceptInput = {
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  citation?: InputMaybe<Scalars['String']['input']>;
  citationI18n?: InputMaybe<Scalars['JSON']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  currentSubsectionId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionI18n?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  isSubmeasure?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<ConceptKind>;
  label?: InputMaybe<Scalars['String']['input']>;
  labelI18n?: InputMaybe<Scalars['JSON']['input']>;
  materialityExplanation?: InputMaybe<Scalars['String']['input']>;
  materialityExplanationI18n?: InputMaybe<Scalars['JSON']['input']>;
  newSubsectionId?: InputMaybe<Scalars['Int']['input']>;
  scheme?: InputMaybe<RiskManagementScheme>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ConceptStatus>;
  submeasureIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum ConceptKind {
  Company = 'COMPANY',
  Impact = 'IMPACT'
}

export type ConceptLinkType = {
  __typename?: 'ConceptLinkType';
  meta: Scalars['JSON']['output'];
  object: ConceptType;
  predicate: ConceptPredicateType;
  subject: ConceptType;
};

export enum ConceptPredicateType {
  IsParentOf = 'IS_PARENT_OF',
  IsSameAs = 'IS_SAME_AS',
  IsSubmeasureOf = 'IS_SUBMEASURE_OF',
  NegativelyAffects = 'NEGATIVELY_AFFECTS',
  PositivelyAffects = 'POSITIVELY_AFFECTS'
}

export type ConceptQueryInput = {
  isMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  isSubmeasure?: InputMaybe<Scalars['Boolean']['input']>;
  onlyMeasuresAndActions?: InputMaybe<Scalars['Boolean']['input']>;
  onlySubsections?: InputMaybe<Scalars['Boolean']['input']>;
  scheme?: InputMaybe<Array<InputMaybe<RiskManagementScheme>>>;
  status?: InputMaybe<Array<InputMaybe<ConceptStatus>>>;
  submeasureOfConceptsId?: InputMaybe<Array<Scalars['Int']['input']>>;
  taxonomyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
  userInputIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum ConceptStatus {
  Autoverified = 'AUTOVERIFIED',
  Disabled = 'DISABLED',
  Generated = 'GENERATED',
  Proposed = 'PROPOSED',
  Verified = 'VERIFIED'
}

export type ConceptType = {
  __typename?: 'ConceptType';
  additionalData?: Maybe<Scalars['JSON']['output']>;
  citation: Scalars['String']['output'];
  citationI18n: Scalars['JSON']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  descriptionI18n: Scalars['JSON']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  impacts: Array<ImpactType>;
  insights?: Maybe<Scalars['JSON']['output']>;
  isMaterial: Scalars['Boolean']['output'];
  isSubmeasure: Scalars['Boolean']['output'];
  ixId?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<ConceptKind>;
  label: Scalars['String']['output'];
  labelI18n: Scalars['JSON']['output'];
  materialityExplanation: Scalars['String']['output'];
  materialityExplanationI18n: Scalars['JSON']['output'];
  notionId?: Maybe<Scalars['String']['output']>;
  objectLinks: Array<ConceptLinkType>;
  scheme?: Maybe<RiskManagementScheme>;
  sourceUrl: Scalars['String']['output'];
  status: ConceptStatus;
  taxonomy?: Maybe<TaxonomyType>;
};


export type ConceptTypeInsightsArgs = {
  accountId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateDemoPortfolioInput = {
  customerName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  enableEsg?: InputMaybe<Scalars['Boolean']['input']>;
  enableFund?: InputMaybe<Scalars['Boolean']['input']>;
  enableImpact?: InputMaybe<Scalars['Boolean']['input']>;
  fundIncludeKfw?: InputMaybe<Scalars['Boolean']['input']>;
  fundIncludePai?: InputMaybe<Scalars['Boolean']['input']>;
  fundStrategy?: FundStrategy;
  includeGhg?: InputMaybe<Scalars['Boolean']['input']>;
  includeTheoryOfChange?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
};

export type CreateDemoPortfolioType = {
  __typename?: 'CreateDemoPortfolioType';
  portfolioName: Scalars['String']['output'];
};

export type CreateVentureAccountAndInviteUserResult = {
  __typename?: 'CreateVentureAccountAndInviteUserResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  ventureId?: Maybe<Scalars['UUID']['output']>;
};

export type DebugPath = {
  __typename?: 'DebugPath';
  children: Array<DebugPath>;
  metricId: Scalars['Int']['output'];
  result?: Maybe<Scalars['DataFrameType']['output']>;
};

export type DeleteInfoType = {
  __typename?: 'DeleteInfoType';
  isSuccess: Scalars['Boolean']['output'];
  recordId: Scalars['Int']['output'];
};

export type DetailsType = {
  __typename?: 'DetailsType';
  hasRisk: Scalars['Boolean']['output'];
  maxScore: Scalars['Float']['output'];
  questionDetails?: Maybe<Scalars['JSON']['output']>;
  subsectionDetails?: Maybe<Scalars['JSON']['output']>;
};

export type DisclosureSummaryType = {
  __typename?: 'DisclosureSummaryType';
  summary: Scalars['String']['output'];
};

export type EmailDomainAccountWarningType = {
  __typename?: 'EmailDomainAccountWarningType';
  accountNames: Array<Scalars['String']['output']>;
  additionalCount: Scalars['Int']['output'];
  domainMatched: Scalars['Boolean']['output'];
};

export type EmissionSourceInput = {
  baselineAssumption?: InputMaybe<Scalars['String']['input']>;
  baselineConceptName?: InputMaybe<Scalars['String']['input']>;
  baselineConsumption?: InputMaybe<Scalars['Float']['input']>;
  baselineEvidence?: InputMaybe<Scalars['String']['input']>;
  baselineGhgFactor?: InputMaybe<Scalars['Float']['input']>;
  baselineUnitName?: InputMaybe<Scalars['String']['input']>;
  customBaselineConcept?: InputMaybe<Scalars['Boolean']['input']>;
  customSolutionConcept?: InputMaybe<Scalars['Boolean']['input']>;
  ghgSavingPotentialId?: InputMaybe<Scalars['Int']['input']>;
  howSolutionWorks?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  simpleSolutionConsumptionReductionRate?: InputMaybe<Scalars['Float']['input']>;
  simpleSolutionConsumptionReductionRateJustification?: InputMaybe<Scalars['String']['input']>;
  simpleSolutionGhgFactorReductionRate?: InputMaybe<Scalars['Float']['input']>;
  simpleSolutionGhgFactorReductionRateJustification?: InputMaybe<Scalars['String']['input']>;
  solutionAssumption?: InputMaybe<Scalars['String']['input']>;
  solutionConceptName?: InputMaybe<Scalars['String']['input']>;
  solutionConsumption?: InputMaybe<Scalars['Float']['input']>;
  solutionEvidence?: InputMaybe<Scalars['String']['input']>;
  solutionGhgFactor?: InputMaybe<Scalars['Float']['input']>;
  solutionReducesConsumption?: InputMaybe<Scalars['Boolean']['input']>;
  solutionReducesGhgFactor?: InputMaybe<Scalars['Boolean']['input']>;
  solutionUnitName?: InputMaybe<Scalars['String']['input']>;
  sourceOfEmission?: InputMaybe<Scalars['String']['input']>;
  unitName?: InputMaybe<Scalars['String']['input']>;
  ventureId: Scalars['String']['input'];
};

export type EmissionSourceType = {
  __typename?: 'EmissionSourceType';
  baselineAssumption?: Maybe<Scalars['String']['output']>;
  baselineConceptName?: Maybe<Scalars['String']['output']>;
  baselineConsumption?: Maybe<Scalars['Float']['output']>;
  baselineEvidence: Scalars['String']['output'];
  baselineGhgFactor?: Maybe<Scalars['Float']['output']>;
  baselineUnitName?: Maybe<Scalars['String']['output']>;
  customBaselineConcept?: Maybe<Scalars['Boolean']['output']>;
  customSolutionConcept?: Maybe<Scalars['Boolean']['output']>;
  ghgSavingPotential: ImpactSolutionType;
  ghgSavingPotentialId: Scalars['Int']['output'];
  howSolutionWorks?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  metricAssignments: Array<MetricAssignmentType>;
  simpleSolutionConsumptionReductionRate?: Maybe<Scalars['Float']['output']>;
  simpleSolutionConsumptionReductionRateJustification?: Maybe<Scalars['Float']['output']>;
  simpleSolutionGhgFactorReductionRate?: Maybe<Scalars['Float']['output']>;
  simpleSolutionGhgFactorReductionRateJustification?: Maybe<Scalars['Float']['output']>;
  solutionAssumption?: Maybe<Scalars['String']['output']>;
  solutionConceptName?: Maybe<Scalars['String']['output']>;
  solutionConsumption?: Maybe<Scalars['Float']['output']>;
  solutionEvidence: Scalars['String']['output'];
  solutionGhgFactor?: Maybe<Scalars['Float']['output']>;
  solutionReducesConsumption?: Maybe<Scalars['Boolean']['output']>;
  solutionReducesGhgFactor?: Maybe<Scalars['Boolean']['output']>;
  solutionUnitName?: Maybe<Scalars['String']['output']>;
  sourceAssignments: Array<SourceAssignmentType>;
  sourceOfEmission?: Maybe<Scalars['String']['output']>;
  specificReductionPerUnit?: Maybe<Scalars['Float']['output']>;
  unitName?: Maybe<Scalars['String']['output']>;
};

export enum EnumActivityRiskProfile {
  Heightened = 'HEIGHTENED',
  Insignificant = 'INSIGNIFICANT',
  Normal = 'NORMAL',
  Significant = 'SIGNIFICANT'
}

export enum EnumActivityType {
  Downstream = 'DOWNSTREAM',
  Own = 'OWN',
  Upstream = 'UPSTREAM'
}

export enum EnumIroLevelOfImpact {
  Actual = 'ACTUAL',
  Potential = 'POTENTIAL'
}

export enum EnumIroOverrideStatus {
  Material = 'MATERIAL',
  NotMaterial = 'NOT_MATERIAL'
}

export enum EnumIroStatus {
  Assessed = 'ASSESSED',
  FullAssessment = 'FULL_ASSESSMENT',
  Material = 'MATERIAL',
  NotAssessed = 'NOT_ASSESSED',
  NotMaterial = 'NOT_MATERIAL',
  StakeholderEngagement = 'STAKEHOLDER_ENGAGEMENT'
}

export enum EnumIroType {
  Impact = 'IMPACT',
  NegativeImpact = 'NEGATIVE_IMPACT',
  Opportunity = 'OPPORTUNITY',
  PositiveImpact = 'POSITIVE_IMPACT',
  Risk = 'RISK'
}

export enum EnumSectionKind {
  Account = 'ACCOUNT',
  Iro = 'IRO',
  Metric = 'METRIC',
  Question = 'QUESTION'
}

export enum EsCharacteristicStrategy {
  BestInClass = 'BEST_IN_CLASS',
  EsgIntegration = 'ESG_INTEGRATION',
  ExclusionCriteria = 'EXCLUSION_CRITERIA',
  NormBasedScreening = 'NORM_BASED_SCREENING',
  SustainabilityLabel = 'SUSTAINABILITY_LABEL'
}

export enum EsCharacteristicsPromoted {
  Both = 'BOTH',
  OnlyEnvironmental = 'ONLY_ENVIRONMENTAL',
  OnlySocial = 'ONLY_SOCIAL'
}

export type EsgMeasureComparisonInput = {
  firstQuestionnaireId: Scalars['Int']['input'];
  secondQuestionnaireId: Scalars['Int']['input'];
};

export type EsgMeasureComparisonType = {
  __typename?: 'EsgMeasureComparisonType';
  disclosure: Array<MeasureComparisonType>;
  environmental: Array<MeasureComparisonType>;
  governance: Array<MeasureComparisonType>;
  social: Array<MeasureComparisonType>;
};

export enum EuTaxonomyType {
  BiodiversityAndEcosystems = 'BIODIVERSITY_AND_ECOSYSTEMS',
  CircularEconomy = 'CIRCULAR_ECONOMY',
  ClimateChangeAdaptation = 'CLIMATE_CHANGE_ADAPTATION',
  ClimateChangeMitigation = 'CLIMATE_CHANGE_MITIGATION',
  PollutionPrevention = 'POLLUTION_PREVENTION',
  WaterAndMarineResources = 'WATER_AND_MARINE_RESOURCES'
}

export type EvidenceInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type EvidenceLinkInput = {
  accountId?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityIntId?: InputMaybe<Scalars['Int']['input']>;
  entityUuidId?: InputMaybe<Scalars['UUID']['input']>;
  evidenceId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type EvidenceLinkType = {
  __typename?: 'EvidenceLinkType';
  account?: Maybe<AccountType>;
  accountId: Scalars['UUID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  entityIntId?: Maybe<Scalars['Int']['output']>;
  entityUuidId?: Maybe<Scalars['UUID']['output']>;
  evidence?: Maybe<EvidenceType>;
  evidenceId?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  type: Scalars['String']['output'];
};

export type EvidenceType = {
  __typename?: 'EvidenceType';
  comment?: Maybe<Scalars['String']['output']>;
  countEvidenceLinks: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  evidenceLinks: Array<EvidenceLinkType>;
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  internalUrl?: Maybe<Scalars['String']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type ExecutePromptInput = {
  accountId?: InputMaybe<Scalars['UUID']['input']>;
  context?: InputMaybe<TemplateEngineContext>;
  executionStrategy?: AiExecutionStrategy;
  fundId?: InputMaybe<Scalars['Int']['input']>;
  impactId?: InputMaybe<Scalars['Int']['input']>;
  impactSolutionId?: InputMaybe<Scalars['Int']['input']>;
  maxIterations?: InputMaybe<Scalars['Int']['input']>;
  promptTemplateId: Scalars['UUID']['input'];
  questionId?: InputMaybe<Scalars['Int']['input']>;
};

export enum ExpiryPresenceFilter {
  All = 'ALL',
  WithoutExpiry = 'WITHOUT_EXPIRY',
  WithExpiry = 'WITH_EXPIRY'
}

export enum ExpiryStatusFilter {
  Active = 'ACTIVE',
  All = 'ALL',
  Expired = 'EXPIRED',
  ExpiringSoon = 'EXPIRING_SOON'
}

export type ExportByPortfolioType = {
  __typename?: 'ExportByPortfolioType';
  file: Scalars['String']['output'];
  portfolioId: Scalars['String']['output'];
};

export type ExportCompanyTypstEsgPdfInput = {
  questionnaireId: Scalars['Int']['input'];
  ventureId: Scalars['UUID']['input'];
};

export type ExportCompanyTypstPdfInput = {
  questionnaireId?: InputMaybe<Scalars['Int']['input']>;
  sections?: InputMaybe<Array<ReviewCompanyPdfSection>>;
  ventureId: Scalars['UUID']['input'];
};

export type ExportExcelByCompanyInput = {
  doExportEsgQuestions: Scalars['Boolean']['input'];
  doExportEsgScores: Scalars['Boolean']['input'];
  doExportImpactAssessment: Scalars['Boolean']['input'];
  doExportImpactCarry?: Scalars['Boolean']['input'];
  doExportMetrics: Scalars['Boolean']['input'];
  ventureId: Scalars['UUID']['input'];
};

export type ExportExcelByCompanyType = {
  __typename?: 'ExportExcelByCompanyType';
  file: Scalars['String']['output'];
  ventureId: Scalars['String']['output'];
};

export type ExportFundReportInput = {
  fundId: Scalars['Int']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  referencePeriodId?: InputMaybe<Scalars['Int']['input']>;
};

export type ExportFundReportType = {
  __typename?: 'ExportFundReportType';
  file: Scalars['String']['output'];
  fundId: Scalars['Int']['output'];
};

export type ExportKfWInput = {
  exportCompanyIds: Array<Scalars['UUID']['input']>;
  exportFundIds: Array<Scalars['Int']['input']>;
  exportGp?: InputMaybe<Scalars['Boolean']['input']>;
  period: Scalars['String']['input'];
};

export type ExportKfWType = {
  __typename?: 'ExportKfWType';
  files: Array<FileExportType>;
  zipFile?: Maybe<FileExportType>;
};

export type ExportNkiCompanyDataInput = {
  portfolioId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ExportPaiReportInput = {
  fundId: Scalars['Int']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  referencePeriodId?: InputMaybe<Scalars['Int']['input']>;
};

export type ExportPrecontractualReportInput = {
  fundId: Scalars['Int']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  referencePeriodId?: InputMaybe<Scalars['Int']['input']>;
};

export type ExportReviewCompanyTypstPdfsInput = {
  reviewRequestId: Scalars['UUID']['input'];
  sections?: InputMaybe<Array<ReviewCompanyPdfSection>>;
  ventureIds: Array<Scalars['UUID']['input']>;
};

export type ExportReviewCompanyTypstPdfsResultGraphType = {
  __typename?: 'ExportReviewCompanyTypstPdfsResultGraphType';
  items: Array<ReviewCompanyTypstExportItemGraphType>;
  zipFile?: Maybe<FileExportType>;
};

export type ExportReviewImpactDataInput = {
  reviewRequestId: Scalars['UUID']['input'];
  ventureIds: Array<Scalars['UUID']['input']>;
};

export type FeedbackInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  impactId?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type FeedbackType = {
  __typename?: 'FeedbackType';
  accountId?: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  rating?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserType>;
  userId?: Maybe<Scalars['UUID']['output']>;
};

export type FileExportType = {
  __typename?: 'FileExportType';
  base64String: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  format: FileFormat;
};

export enum FileFormat {
  Csv = 'CSV',
  Pdf = 'PDF',
  Xlsx = 'XLSX',
  Zip = 'ZIP'
}

export type FormulaOperator = {
  __typename?: 'FormulaOperator';
  type: FormulaOperatorType;
  value?: Maybe<Scalars['String']['output']>;
  variable?: Maybe<MetricType>;
};

export enum FormulaOperatorType {
  Native = 'NATIVE',
  Operator = 'OPERATOR',
  Variable = 'VARIABLE'
}

export type FormulaValidateResponse = {
  __typename?: 'FormulaValidateResponse';
  error?: Maybe<Scalars['String']['output']>;
  formula: Scalars['JSON']['output'];
  humanReadable: Array<FormulaOperator>;
};

export type FullyQualifiedPath = {
  __typename?: 'FullyQualifiedPath';
  description: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type FundCompletion = {
  __typename?: 'FundCompletion';
  items: Array<FundCompletionItem>;
  value: Scalars['Float']['output'];
};

export type FundCompletionDetail = {
  __typename?: 'FundCompletionDetail';
  applicable: Scalars['Boolean']['output'];
  canonicalKey: Scalars['String']['output'];
  key: Scalars['String']['output'];
  result?: Maybe<Scalars['Float']['output']>;
  why?: Maybe<Scalars['String']['output']>;
};

export type FundCompletionItem = {
  __typename?: 'FundCompletionItem';
  applicable: Scalars['Boolean']['output'];
  canonicalKey: FundCompletionSectionKey;
  details: Array<FundCompletionDetail>;
  key: Scalars['String']['output'];
  result?: Maybe<Scalars['Float']['output']>;
  why?: Maybe<Scalars['String']['output']>;
};

export enum FundCompletionSectionKey {
  BasicInfo = 'BASIC_INFO',
  EntitySustainabilityApproach = 'ENTITY_SUSTAINABILITY_APPROACH',
  EsCharacteristic = 'ES_CHARACTERISTIC',
  Kfw = 'KFW',
  Pai = 'PAI',
  StrategySelection = 'STRATEGY_SELECTION',
  SustainabilityRisk = 'SUSTAINABILITY_RISK',
  SustainableObjectiveForm = 'SUSTAINABLE_OBJECTIVE_FORM',
  SustainableObjectiveFundLevel = 'SUSTAINABLE_OBJECTIVE_FUND_LEVEL',
  SustainableObjectiveSection = 'SUSTAINABLE_OBJECTIVE_SECTION'
}

export type FundInput = {
  assetAllocationTargets?: InputMaybe<AssetAllocationTargetsInput>;
  bindingElementsOfInvestmentStrategy?: InputMaybe<Scalars['String']['input']>;
  companyGovernancePolicy?: InputMaybe<Scalars['String']['input']>;
  considerationOfPaisOnSustainabilityEngagementPolicies?: InputMaybe<Scalars['String']['input']>;
  considerationOfPaisOnSustainabilityInternationalStandards?: InputMaybe<Scalars['String']['input']>;
  entitySustainabilityExtraInfo?: InputMaybe<Scalars['String']['input']>;
  environmentalMetricIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  esCharacteristicsPromoted?: InputMaybe<EsCharacteristicsPromoted>;
  fullReportingLevelVentureIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  fundReport?: InputMaybe<Scalars['JSON']['input']>;
  fundSpecificInfo?: InputMaybe<Scalars['String']['input']>;
  fundStrategy?: InputMaybe<FundStrategy>;
  generalMetricIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  howDidProductConsiderPais?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  investmentPeriodId?: InputMaybe<Scalars['Int']['input']>;
  investmentStrategy?: InputMaybe<Scalars['String']['input']>;
  isConsideringPais?: InputMaybe<IsConsideringPais>;
  isConsideringSustainabilityRisk?: InputMaybe<Scalars['Boolean']['input']>;
  isReportingKfw?: InputMaybe<Scalars['Boolean']['input']>;
  isReportingPais?: InputMaybe<Scalars['Boolean']['input']>;
  legalEntityIdentifier?: InputMaybe<Scalars['String']['input']>;
  likelyImpactsFromSustainabilityRisk?: InputMaybe<Scalars['String']['input']>;
  minimumRateToReduceScope?: InputMaybe<Scalars['String']['input']>;
  minimumReportingLevelVentureIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  notConsideringPaisReason?: InputMaybe<Scalars['String']['input']>;
  paiAggregationGroup?: InputMaybe<TypeAggregationGroup>;
  paiPolicyAdministration?: InputMaybe<Scalars['String']['input']>;
  paiReport?: InputMaybe<Scalars['JSON']['input']>;
  paiSelectionMethodologies?: InputMaybe<Scalars['String']['input']>;
  portfolioId?: InputMaybe<Scalars['String']['input']>;
  precontractualReport?: InputMaybe<UserInputPrecontractualReportInput>;
  reasonNotConsideringSustainabilityRisk?: InputMaybe<Scalars['String']['input']>;
  recommendedReportingLevelVentureIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  reportAnswer?: InputMaybe<ReportAnswerInput>;
  socialMetricIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sustainabilityRiskIntegrationDescription?: InputMaybe<Scalars['String']['input']>;
  ventureIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  volume?: InputMaybe<Scalars['Float']['input']>;
};

export type FundSetupState = {
  __typename?: 'FundSetupState';
  completion: FundCompletion;
  fundId: Scalars['Int']['output'];
  isInSync: Scalars['Boolean']['output'];
  syncState: SyncState;
};

export enum FundStrategy {
  Article_6 = 'ARTICLE_6',
  Article_8 = 'ARTICLE_8',
  Article_8Plus = 'ARTICLE_8_PLUS',
  Article_9 = 'ARTICLE_9',
  OnlyPais = 'ONLY_PAIS'
}

export type FundType = {
  __typename?: 'FundType';
  answers?: Maybe<Array<ReportAnswerType>>;
  assetAllocationTargets: AssetAllocationTargetsType;
  bindingElementsOfInvestmentStrategy?: Maybe<Scalars['String']['output']>;
  companyGovernancePolicy?: Maybe<Scalars['String']['output']>;
  considerationOfPaisOnSustainabilityEngagementPolicies: Scalars['String']['output'];
  considerationOfPaisOnSustainabilityInternationalStandards: Scalars['String']['output'];
  entitySustainabilityExtraInfo?: Maybe<Scalars['String']['output']>;
  entityWebsiteDisclosureAnswers: Array<ReportAnswerType>;
  environmentalMetricIds: Array<Scalars['Int']['output']>;
  environmentalMetrics: Array<MetricType>;
  esCharacteristics: SfdrStrategyType;
  esCharacteristicsPromoted?: Maybe<EsCharacteristicsPromoted>;
  fullReportingLevelVentureIds?: Maybe<Array<Scalars['UUID']['output']>>;
  fundReport?: Maybe<UserInputFundReportType>;
  fundSpecificInfo?: Maybe<Scalars['String']['output']>;
  fundStrategy?: Maybe<FundStrategy>;
  fundWebsiteDisclosureAnswers: Array<ReportAnswerType>;
  generalMetricIds: Array<Scalars['Int']['output']>;
  generalMetrics: Array<MetricType>;
  howDidProductConsiderPais: Scalars['String']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  investmentPeriod?: Maybe<ReferencePeriodType>;
  investmentStrategy?: Maybe<Scalars['String']['output']>;
  isConsideringPais?: Maybe<IsConsideringPais>;
  isConsideringSustainabilityRisk?: Maybe<Scalars['Boolean']['output']>;
  isInSync: Scalars['Boolean']['output'];
  isReportingKfw: Scalars['Boolean']['output'];
  isReportingPais: Scalars['Boolean']['output'];
  legalEntityIdentifier?: Maybe<Scalars['String']['output']>;
  likelyImpactsFromSustainabilityRisk?: Maybe<Scalars['String']['output']>;
  metricAggregationChanges: MetricAggregationChanges;
  minimumRateToReduceScope?: Maybe<Scalars['String']['output']>;
  minimumReportingLevelVentureIds?: Maybe<Array<Scalars['UUID']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  notConsideringPaisReason?: Maybe<Scalars['String']['output']>;
  paiAggregationGroup?: Maybe<TypeAggregationGroup>;
  paiAnswers: Array<ReportAnswerType>;
  paiPolicyAdministration: Scalars['String']['output'];
  paiReport?: Maybe<UserInputPaiReportType>;
  paiSelectionMethodologies: Scalars['String']['output'];
  periodicAnswers: Array<ReportAnswerType>;
  portfolio?: Maybe<AccountType>;
  portfolioId?: Maybe<Scalars['UUID']['output']>;
  precontractualAnswers: Array<ReportAnswerType>;
  precontractualReport?: Maybe<UserInputPrecontractualReportType>;
  reasonNotConsideringSustainabilityRisk?: Maybe<Scalars['String']['output']>;
  recommendedReportingLevelVentureIds?: Maybe<Array<Scalars['UUID']['output']>>;
  setupCompletion: FundCompletion;
  sfdrReportingPeriod?: Maybe<ReferencePeriodType>;
  sfdrStrategies?: Maybe<SfdrStrategyType>;
  socialMetricIds: Array<Scalars['Int']['output']>;
  socialMetrics: Array<MetricType>;
  sustainabilityRiskIntegrationDescription?: Maybe<Scalars['String']['output']>;
  sustainableObjectives: Array<SfdrStrategyType>;
  syncState: SyncState;
  ventureIds?: Maybe<Array<Scalars['UUID']['output']>>;
  ventures?: Maybe<Array<AccountType>>;
  volume?: Maybe<Scalars['Float']['output']>;
};

export type GeographyAggregationType = {
  __typename?: 'GeographyAggregationType';
  geography: GeographyType;
  impacts: Array<ImpactType>;
};

export type GeographyType = {
  __typename?: 'GeographyType';
  children: Array<GeographyType>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isoAlpha2?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  labelI18n: Scalars['JSON']['output'];
  m49?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
};

export type GetAggregatedQuestionnaireResultFilter = {
  questionnaireIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scope?: AggregatedQuestionnaireResultsVentureFilterType;
  ventureIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type GhgSavingPotentialInput = {
  baselineSolutionDescription?: InputMaybe<Scalars['String']['input']>;
  comparativeQuantitiy?: InputMaybe<Scalars['Float']['input']>;
  comparativeUnit?: InputMaybe<Scalars['String']['input']>;
  comparativeUnitConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  describeComparison?: InputMaybe<Scalars['String']['input']>;
  durationOfImpact?: InputMaybe<Scalars['Float']['input']>;
  emissionSourceLimitations?: InputMaybe<Scalars['String']['input']>;
  emissionsConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  growthFactorJustification?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  impactProfileKind?: InputMaybe<ImpactProfileKind>;
  isPreciseEmissionCalculation?: InputMaybe<Scalars['Boolean']['input']>;
  isRecurringImpact?: InputMaybe<Scalars['Boolean']['input']>;
  isScenarioA?: InputMaybe<Scalars['Boolean']['input']>;
  needFulfilled?: InputMaybe<Scalars['String']['input']>;
  preComputedBaselineGhg?: InputMaybe<Scalars['Float']['input']>;
  preComputedSolutionGhg?: InputMaybe<Scalars['Float']['input']>;
  realisticConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  scenarioBComments?: InputMaybe<Scalars['String']['input']>;
  simpleBaselineGhg?: InputMaybe<Scalars['Float']['input']>;
  simpleGhgJustification?: InputMaybe<Scalars['String']['input']>;
  simpleSolutionGhg?: InputMaybe<Scalars['Float']['input']>;
  ventureId?: InputMaybe<Scalars['String']['input']>;
};

export type GhgSavingPotentialType = {
  __typename?: 'GhgSavingPotentialType';
  baselineSolutionDescription?: Maybe<Scalars['String']['output']>;
  comparativeQuantitiy?: Maybe<Scalars['Float']['output']>;
  comparativeUnit?: Maybe<Scalars['String']['output']>;
  comparativeUnitConfirmed?: Maybe<Scalars['Boolean']['output']>;
  describeComparison?: Maybe<Scalars['String']['output']>;
  durationOfImpact?: Maybe<Scalars['Float']['output']>;
  emissionSourceLimitations?: Maybe<Scalars['String']['output']>;
  emissionSources: Array<EmissionSourceType>;
  emissionsConfirmed?: Maybe<Scalars['Boolean']['output']>;
  growthFactorJustification?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  impactProfileKind: ImpactProfileKind;
  isPreciseEmissionCalculation?: Maybe<Scalars['Boolean']['output']>;
  isRecurringImpact?: Maybe<Scalars['Boolean']['output']>;
  isScenarioA?: Maybe<Scalars['Boolean']['output']>;
  metricAssignments: Array<MetricAssignmentType>;
  needFulfilled?: Maybe<Scalars['String']['output']>;
  preComputedBaselineGhg?: Maybe<Scalars['Float']['output']>;
  preComputedSolutionGhg?: Maybe<Scalars['Float']['output']>;
  realisticConfirmation?: Maybe<Scalars['Boolean']['output']>;
  scenarioBComments?: Maybe<Scalars['String']['output']>;
  simpleBaselineGhg?: Maybe<Scalars['Float']['output']>;
  simpleGhgJustification?: Maybe<Scalars['String']['output']>;
  simpleSolutionGhg?: Maybe<Scalars['Float']['output']>;
  specificReductionAsPercentage?: Maybe<Scalars['Float']['output']>;
  specificReductionPerUnit?: Maybe<Scalars['Float']['output']>;
};

export type GroupAssignmentType = {
  groupId: Scalars['Int']['input'];
  ventureIds: Array<Scalars['UUID']['input']>;
};

export type IroInput = {
  activityId?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  finalAssessmentReason?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  irremediability?: InputMaybe<Scalars['Int']['input']>;
  levelOfImpact?: InputMaybe<EnumIroLevelOfImpact>;
  likelihood?: InputMaybe<Scalars['Int']['input']>;
  likelihoodReason?: InputMaybe<Scalars['String']['input']>;
  magnitude?: InputMaybe<Scalars['Int']['input']>;
  magnitudeReason?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overrideReason?: InputMaybe<Scalars['String']['input']>;
  overrideStatus?: InputMaybe<EnumIroOverrideStatus>;
  scale?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<Scalars['Int']['input']>;
  severity?: InputMaybe<Scalars['Int']['input']>;
  severityReason?: InputMaybe<Scalars['String']['input']>;
  stakeholderId?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<EnumIroStatus>;
  type?: InputMaybe<EnumIroType>;
};

export type IroType = {
  __typename?: 'IROType';
  account: AccountType;
  accountId: Scalars['UUID']['output'];
  activity?: Maybe<ActivityType>;
  activityId?: Maybe<Scalars['UUID']['output']>;
  description: Scalars['String']['output'];
  finalAssessmentReason?: Maybe<Scalars['String']['output']>;
  finalSeverity?: Maybe<Scalars['Float']['output']>;
  id: Scalars['UUID']['output'];
  irremediability?: Maybe<Scalars['Int']['output']>;
  levelOfImpact?: Maybe<EnumIroLevelOfImpact>;
  likelihood?: Maybe<Scalars['Int']['output']>;
  likelihoodReason?: Maybe<Scalars['String']['output']>;
  magnitude?: Maybe<Scalars['Int']['output']>;
  magnitudeReason?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  overrideReason?: Maybe<Scalars['String']['output']>;
  overrideStatus?: Maybe<EnumIroOverrideStatus>;
  scale?: Maybe<Scalars['Int']['output']>;
  scope?: Maybe<Scalars['Int']['output']>;
  sectionLinks?: Maybe<Array<IroSectionLinkType>>;
  severity?: Maybe<Scalars['Int']['output']>;
  severityReason?: Maybe<Scalars['String']['output']>;
  stakeholderLinks?: Maybe<Array<IroStakeholderLinkType>>;
  status?: Maybe<EnumIroStatus>;
  type: EnumIroType;
};

export type IdematFilter = {
  __typename?: 'IdematFilter';
  categories: Array<Scalars['String']['output']>;
  units: Array<Scalars['String']['output']>;
};

export type IdematSearchInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  units?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IdematType = {
  __typename?: 'IdematType';
  categoryFull: Scalars['String']['output'];
  ghgFactor: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  idematId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  source: Scalars['String']['output'];
  unit: Scalars['String']['output'];
};

export type ImpactGoalInput = {
  activityUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  doUpdateSubmitDate?: InputMaybe<Scalars['Boolean']['input']>;
  ghgStartingYear?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  isEditable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImpactGoalProgressType = {
  __typename?: 'ImpactGoalProgressType';
  completionRate?: Maybe<Scalars['Float']['output']>;
  endDate?: Maybe<Scalars['Int']['output']>;
  hasTarget: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Int']['output']>;
};

export type ImpactGoalType = {
  __typename?: 'ImpactGoalType';
  activityUrls: Array<Scalars['String']['output']>;
  geographies: Array<GeographyType>;
  ghgStartingYear: Scalars['Int']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  impacts: Array<ImpactType>;
  isEditable: Scalars['Boolean']['output'];
  sdgs: Array<SdgType>;
  submitDate?: Maybe<Scalars['DateTime']['output']>;
  targetProgress: ImpactGoalProgressType;
  ventureId: Scalars['UUID']['output'];
};

export type ImpactInput = {
  carryRemarks?: InputMaybe<Scalars['String']['input']>;
  companyVision?: InputMaybe<Scalars['String']['input']>;
  conceptId?: InputMaybe<Scalars['Int']['input']>;
  doUpdateSubmitDate?: InputMaybe<Scalars['Boolean']['input']>;
  durationYears?: InputMaybe<Scalars['Int']['input']>;
  euTaxonomy?: InputMaybe<EuTaxonomyType>;
  geographies?: InputMaybe<Array<Scalars['Int']['input']>>;
  hasFrozenOutcome?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  impactGoalId?: InputMaybe<Scalars['Int']['input']>;
  initialInvestmentDate?: InputMaybe<Scalars['Date']['input']>;
  inputsActivities?: InputMaybe<Scalars['String']['input']>;
  irisCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
  isEditable?: InputMaybe<Scalars['Boolean']['input']>;
  isPositive?: InputMaybe<Scalars['Boolean']['input']>;
  longTermImpacts?: InputMaybe<Scalars['String']['input']>;
  metricAssignments?: InputMaybe<Array<Scalars['Int']['input']>>;
  problem?: InputMaybe<Scalars['String']['input']>;
  problemStatement?: InputMaybe<Scalars['String']['input']>;
  riskReboundEffects?: InputMaybe<Scalars['String']['input']>;
  sdgTargets?: InputMaybe<Array<Scalars['Int']['input']>>;
  shortTermOutcomes?: InputMaybe<Scalars['String']['input']>;
  solutionsOutput?: InputMaybe<Scalars['String']['input']>;
  stakeholder?: InputMaybe<Scalars['String']['input']>;
  stakeholderCategory?: InputMaybe<StakeholderCategoryType>;
  startingYear?: InputMaybe<Scalars['Int']['input']>;
  targetGroup?: InputMaybe<Scalars['String']['input']>;
  theoryOfChange?: InputMaybe<Scalars['String']['input']>;
};

export enum ImpactProfileKind {
  CircularEconomy = 'CIRCULAR_ECONOMY',
  CustomerEmpowerment = 'CUSTOMER_EMPOWERMENT',
  ExtractionAndManufacturing = 'EXTRACTION_AND_MANUFACTURING',
  Logistics = 'LOGISTICS',
  ProductApplication = 'PRODUCT_APPLICATION'
}

export type ImpactSolutionInput = {
  conceptId?: InputMaybe<Scalars['Int']['input']>;
  ghgSavingPotentialId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  impactId: Scalars['Int']['input'];
  kind?: InputMaybe<ImpactSolutionKind>;
  problemDescription?: InputMaybe<Scalars['String']['input']>;
  solutionDescription?: InputMaybe<Scalars['String']['input']>;
  targetGroup?: InputMaybe<Scalars['String']['input']>;
  useGhgSavingPotentialTool?: InputMaybe<Scalars['Boolean']['input']>;
  ventureId?: InputMaybe<Scalars['String']['input']>;
};

export enum ImpactSolutionKind {
  Hybrid = 'HYBRID',
  Product = 'PRODUCT',
  Service = 'SERVICE'
}

export type ImpactSolutionSummaryType = {
  __typename?: 'ImpactSolutionSummaryType';
  endYear?: Maybe<Scalars['Int']['output']>;
  forecastAssignment?: Maybe<MetricAssignmentType>;
  forecastValues?: Maybe<Array<MetricValueType>>;
  ghgMetricValues?: Maybe<Array<MetricValueType>>;
  impactConcept: Scalars['String']['output'];
  impactSolution: ImpactSolutionType;
  startYear?: Maybe<Scalars['Int']['output']>;
  totalGhgReduction?: Maybe<Scalars['String']['output']>;
};

export type ImpactSolutionType = {
  __typename?: 'ImpactSolutionType';
  concept?: Maybe<ConceptType>;
  conceptId?: Maybe<Scalars['Int']['output']>;
  ghgSavingPotential?: Maybe<GhgSavingPotentialType>;
  ghgSavingPotentialId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  impact: Array<ImpactType>;
  impactId: Scalars['Int']['output'];
  kind?: Maybe<ImpactSolutionKind>;
  problemDescription?: Maybe<Scalars['String']['output']>;
  problemSourceAssignments: Array<SourceAssignmentType>;
  solutionDescription?: Maybe<Scalars['String']['output']>;
  solutionSource: Array<SolutionSourceType>;
  solutionSourceAssignments: Array<SourceAssignmentType>;
  targetGroup?: Maybe<Scalars['String']['output']>;
  useGhgSavingPotentialTool?: Maybe<Scalars['Boolean']['output']>;
};

export type ImpactSummaryType = {
  __typename?: 'ImpactSummaryType';
  averageAnnualReduction?: Maybe<Scalars['Float']['output']>;
  averageTotalGhgReduction?: Maybe<AverageTotalGhgReductionType>;
  economicValue?: Maybe<Scalars['Float']['output']>;
  ghgMetricValues?: Maybe<Array<MetricValueType>>;
  impactSolutionSummaries?: Maybe<Array<ImpactSolutionSummaryType>>;
  totalGhgReduction?: Maybe<Scalars['Float']['output']>;
};

export type ImpactType = {
  __typename?: 'ImpactType';
  carryRemarks?: Maybe<Scalars['String']['output']>;
  companyVision?: Maybe<Scalars['String']['output']>;
  concept?: Maybe<ConceptType>;
  conceptId?: Maybe<Scalars['Int']['output']>;
  durationYears?: Maybe<Scalars['Int']['output']>;
  euTaxonomy?: Maybe<EuTaxonomyType>;
  geographies: Array<GeographyType>;
  hasFrozenOutcome?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  impactGoal?: Maybe<ImpactGoalType>;
  impactSolutions: Array<ImpactSolutionType>;
  initialInvestmentDate?: Maybe<Scalars['Date']['output']>;
  inputsActivities?: Maybe<Scalars['String']['output']>;
  irisCategories: Array<IrisCategoryType>;
  isEditable: Scalars['Boolean']['output'];
  isPositive?: Maybe<Scalars['Boolean']['output']>;
  longTermImpacts?: Maybe<Scalars['String']['output']>;
  metricAssignments: Array<MetricAssignmentType>;
  problem?: Maybe<Scalars['String']['output']>;
  problemStatement?: Maybe<Scalars['String']['output']>;
  riskReboundEffects?: Maybe<Scalars['String']['output']>;
  sdgTargets: Array<SdgTargetType>;
  sdgs: Array<SdgType>;
  shortTermOutcomes?: Maybe<Scalars['String']['output']>;
  solutionsOutput?: Maybe<Scalars['String']['output']>;
  sourceAssignments: Array<SourceAssignmentType>;
  stakeholder?: Maybe<Scalars['String']['output']>;
  stakeholderCategory?: Maybe<StakeholderCategoryType>;
  startingYear?: Maybe<Scalars['Int']['output']>;
  submitDate?: Maybe<Scalars['DateTime']['output']>;
  targetGroup?: Maybe<Scalars['String']['output']>;
  theoryOfChange?: Maybe<Scalars['String']['output']>;
};

export enum ImplementationStatus {
  Doing = 'DOING',
  In_12Months = 'IN_12_MONTHS',
  NotPlanned = 'NOT_PLANNED'
}

export type InviteUserResult = {
  __typename?: 'InviteUserResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type IrisCategoryType = {
  __typename?: 'IrisCategoryType';
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  label: Scalars['String']['output'];
};

export type IroQueryInput = {
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  likelihood?: InputMaybe<Scalars['Int']['input']>;
  magnitude?: InputMaybe<Scalars['Int']['input']>;
  notLinkedToStakeholderIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  stakeholderIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  statuses?: InputMaybe<Array<InputMaybe<EnumIroStatus>>>;
  types?: InputMaybe<Array<EnumIroType>>;
};

export type IroSectionLinkInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  iroId?: InputMaybe<Scalars['UUID']['input']>;
  sectionId?: InputMaybe<Scalars['Int']['input']>;
};

export type IroSectionLinkType = {
  __typename?: 'IroSectionLinkType';
  id: Scalars['UUID']['output'];
  iro: IroType;
  iroId: Scalars['UUID']['output'];
  section: SectionType;
  sectionId: Scalars['Int']['output'];
};

export type IroStakeholderLinkInput = {
  financialMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  howAffected?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  impactMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  iroId?: InputMaybe<Scalars['UUID']['input']>;
  relationToRo?: InputMaybe<Scalars['String']['input']>;
  stakeholderId?: InputMaybe<Scalars['UUID']['input']>;
};

export type IroStakeholderLinkType = {
  __typename?: 'IroStakeholderLinkType';
  financialMaterial: Scalars['Boolean']['output'];
  howAffected: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  impactMaterial: Scalars['Boolean']['output'];
  iro?: Maybe<IroType>;
  iroId?: Maybe<Scalars['UUID']['output']>;
  relationToRo: Scalars['String']['output'];
  stakeholder: StakeholderType;
  stakeholderId: Scalars['UUID']['output'];
};

export type IroUpdateType = {
  __typename?: 'IroUpdateType';
  baseStatus: EnumIroStatus;
  id: Scalars['UUID']['output'];
  newStatus: EnumIroStatus;
};

export enum IsConsideringPais {
  No = 'NO',
  Partially = 'PARTIALLY',
  Yes = 'YES'
}

export type ListAccountFilter = {
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  expiryPresence?: InputMaybe<ExpiryPresenceFilter>;
  expiryStatusFilter?: InputMaybe<ExpiryStatusFilter>;
  fundIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  group?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  module?: InputMaybe<Array<Module>>;
  period?: InputMaybe<Scalars['String']['input']>;
  portfolioId?: InputMaybe<Scalars['UUID']['input']>;
  type?: InputMaybe<Array<AccountCategory>>;
  usageType?: InputMaybe<Array<InputMaybe<UsageType>>>;
  ventureIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  withoutUsers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ListActivityFilter = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  stakeholderIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  valueChainIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type ListEvidenceFilter = {
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type ListEvidenceLinkFilter = {
  accountId?: InputMaybe<Scalars['UUID']['input']>;
  entityIntIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  entityUuidIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ListGeographyFilter = {
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
};

export type ListImpactGoalFilters = {
  isEditable?: InputMaybe<Scalars['Boolean']['input']>;
  ventureIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type ListMetricAssignmentFilter = {
  aggregationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  assigneeIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  beyondFundId?: InputMaybe<Scalars['Int']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  ghgSavingPotentialId?: InputMaybe<Scalars['Int']['input']>;
  hideImpactKpis?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  impactConceptIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  impactIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  impactSolutionId?: InputMaybe<Scalars['Int']['input']>;
  includeUncategorized?: InputMaybe<Scalars['Boolean']['input']>;
  isActualDataEntered?: InputMaybe<Scalars['Boolean']['input']>;
  isComputed?: InputMaybe<Scalars['Boolean']['input']>;
  isDataEntered?: InputMaybe<Scalars['Boolean']['input']>;
  isSkipped?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  metricIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  metricNotionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  reportingPeriodType?: InputMaybe<Array<MetricReportingPeriodType>>;
  sectionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  selfAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  showImpactTargets?: InputMaybe<Scalars['Boolean']['input']>;
  statusPeriods?: InputMaybe<Array<Scalars['String']['input']>>;
  valueType?: InputMaybe<MetricValueKind>;
};

export type ListMetricValuesFilter = {
  periods?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ListPortfolioVentureLinksFilter = {
  group?: InputMaybe<Scalars['String']['input']>;
  hasEsgResult?: InputMaybe<Scalars['Boolean']['input']>;
  hasImpactGoal?: InputMaybe<Scalars['Boolean']['input']>;
  minEnvironmentalScore?: InputMaybe<Scalars['Float']['input']>;
  periodEndTo?: InputMaybe<Scalars['Date']['input']>;
  periodStartFrom?: InputMaybe<Scalars['Date']['input']>;
  portfolioId?: InputMaybe<Scalars['UUID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  ventureIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type ListPromptTemplateVersionFilter = {
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  promptTemplateId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ListQuestionFilter = {
  companyInfoSections?: InputMaybe<Scalars['Boolean']['input']>;
  fundResultsViewSections?: InputMaybe<Scalars['Boolean']['input']>;
  sections?: InputMaybe<Array<Scalars['Int']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ListQuestionnaireFilter = {
  label: Array<Scalars['String']['input']>;
  ventures?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type ListReferencePeriodFilters = {
  hasLabel?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  isAnnual?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  userDefined?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ListStakeholderFilter = {
  activityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  financialMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  impactMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  iroIds?: InputMaybe<Array<Scalars['String']['input']>>;
  notLinkedToActivities?: InputMaybe<Array<Scalars['UUID']['input']>>;
  notLinkedToIros?: InputMaybe<Array<Scalars['UUID']['input']>>;
  search?: Scalars['String']['input'];
};

export type MeasureComparisonType = {
  __typename?: 'MeasureComparisonType';
  category: Scalars['String']['output'];
  measure: Scalars['String']['output'];
  statusFirstPeriod: ImplementationStatus;
  statusSecondPeriod: ImplementationStatus;
};

export type MetricAggregationCategoryCountType = {
  __typename?: 'MetricAggregationCategoryCountType';
  categoryId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
};

export type MetricAggregationChanges = {
  __typename?: 'MetricAggregationChanges';
  toAdd: Array<MetricAggregationType>;
  toDel: Array<MetricAggregationType>;
};

export type MetricAggregationInfo = {
  __typename?: 'MetricAggregationInfo';
  groupId: Scalars['Int']['output'];
  groupType: TypeAggregationGroup;
  metric: MetricType;
  metricId: Scalars['Int']['output'];
  why: Scalars['String']['output'];
};

export type MetricAggregationInput = {
  calculationType?: InputMaybe<MetricCalculationType>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<TypeAggregationGroup>;
  id?: InputMaybe<Scalars['Int']['input']>;
  metricId?: InputMaybe<Scalars['Int']['input']>;
  portfolioId?: InputMaybe<Scalars['UUID']['input']>;
};

export enum MetricAggregationMethod {
  Avg = 'AVG',
  Sum = 'SUM',
  SumOverLen = 'SUM_OVER_LEN'
}

export type MetricAggregationSectionCountType = {
  __typename?: 'MetricAggregationSectionCountType';
  count: Scalars['Int']['output'];
  sectionId?: Maybe<Scalars['Int']['output']>;
};

export type MetricAggregationType = {
  __typename?: 'MetricAggregationType';
  calculationType: MetricCalculationType;
  category?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deprecatedMetricAggregationValues: Array<MetricAggregationValueType>;
  fund?: Maybe<FundType>;
  funds: Array<FundType>;
  groupId?: Maybe<Scalars['Int']['output']>;
  groupType?: Maybe<TypeAggregationGroup>;
  id?: Maybe<Scalars['Int']['output']>;
  indicator: Scalars['String']['output'];
  metric?: Maybe<MetricType>;
  metricAggregationValues: Array<MetricAggregationValueType>;
  metricAggregationValuesPath: DebugPath;
  metricAssignments?: Maybe<Array<MetricAssignmentType>>;
  metricId?: Maybe<Scalars['Int']['output']>;
  paiMetricName?: Maybe<Scalars['String']['output']>;
  paiSort?: Maybe<Scalars['Int']['output']>;
  portfolioId: Scalars['UUID']['output'];
  sfdrStrategies: Array<SfdrStrategyType>;
  sfdrStrategy?: Maybe<SfdrStrategyType>;
};

export type MetricAggregationValueType = {
  __typename?: 'MetricAggregationValueType';
  actual?: Maybe<Scalars['Float']['output']>;
  actualCompleted: Array<AccountType>;
  actualCompletedIds?: Maybe<Array<Scalars['String']['output']>>;
  completionDetails?: Maybe<AggregationCompletionDetailType>;
  metricAggregationId: Scalars['Int']['output'];
  period: Scalars['String']['output'];
  required: Array<AccountType>;
  requiredIds?: Maybe<Array<Scalars['String']['output']>>;
  target?: Maybe<Scalars['Float']['output']>;
  targetCompleted: Array<AccountType>;
  targetCompletedIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type MetricAssignmentAggregationPeriodType = {
  __typename?: 'MetricAssignmentAggregationPeriodType';
  accumulatedActual?: Maybe<Scalars['Float']['output']>;
  accumulatedPerformancePercent?: Maybe<Scalars['Float']['output']>;
  accumulatedTarget?: Maybe<Scalars['Float']['output']>;
  isMostRecentActivePeriod: Scalars['Boolean']['output'];
  period: Scalars['String']['output'];
  rawActual?: Maybe<Scalars['Float']['output']>;
  rawPerformancePercent?: Maybe<Scalars['Float']['output']>;
  rawTarget?: Maybe<Scalars['Float']['output']>;
};

export type MetricAssignmentAggregationSummaryType = {
  __typename?: 'MetricAssignmentAggregationSummaryType';
  actual?: Maybe<Scalars['Float']['output']>;
  performancePercent?: Maybe<Scalars['Float']['output']>;
  target?: Maybe<Scalars['Float']['output']>;
};

export type MetricAssignmentAggregationViewType = {
  __typename?: 'MetricAssignmentAggregationViewType';
  calculationType?: Maybe<Scalars['String']['output']>;
  periodEnd?: Maybe<Scalars['Int']['output']>;
  periodStart?: Maybe<Scalars['Int']['output']>;
  periods: Array<MetricAssignmentAggregationPeriodType>;
  summary: MetricAssignmentAggregationSummaryType;
  unitName?: Maybe<Scalars['String']['output']>;
};

export type MetricAssignmentCategoryCountType = {
  __typename?: 'MetricAssignmentCategoryCountType';
  categoryId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
};

export type MetricAssignmentCompletionType = {
  __typename?: 'MetricAssignmentCompletionType';
  actual?: Maybe<Scalars['Float']['output']>;
  aggregationView?: Maybe<MetricAssignmentAggregationViewType>;
  completionRate?: Maybe<Scalars['Float']['output']>;
  hasTarget: Scalars['Boolean']['output'];
  metricAssignmentId: Scalars['Int']['output'];
  targetParameters?: Maybe<TargetParametersType>;
};

export type MetricAssignmentDependencyType = {
  __typename?: 'MetricAssignmentDependencyType';
  canBeDeleted: Scalars['Boolean']['output'];
  computationalDependentAssignments: Array<MetricAssignmentType>;
  conditionalDependentAssignments: Array<MetricAssignmentType>;
};

export type MetricAssignmentInfo = {
  __typename?: 'MetricAssignmentInfo';
  assignee?: Maybe<AccountType>;
  assigneeId: Scalars['UUID']['output'];
  conceptId?: Maybe<Scalars['Int']['output']>;
  fundId?: Maybe<Scalars['Int']['output']>;
  metric: MetricType;
  metricId: Scalars['Int']['output'];
  why: Scalars['String']['output'];
};

export type MetricAssignmentInput = {
  assigneeId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  conceptId?: InputMaybe<Scalars['Int']['input']>;
  customTargetCalculationType?: InputMaybe<AnnualAggregationMethod>;
  customTargetEndDate?: InputMaybe<Scalars['Int']['input']>;
  customTargetStartDate?: InputMaybe<Scalars['Int']['input']>;
  customTargetValue?: InputMaybe<Scalars['Float']['input']>;
  customTargetWeight?: InputMaybe<Scalars['Float']['input']>;
  emissionSourceId?: InputMaybe<Scalars['Int']['input']>;
  fundId?: InputMaybe<Scalars['Int']['input']>;
  ghgSavingPotentialId?: InputMaybe<Scalars['Int']['input']>;
  goalTarget?: InputMaybe<Scalars['Float']['input']>;
  goalType?: InputMaybe<Scalars['String']['input']>;
  hiddenFromAssignee?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  impactIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  impactSolutionId?: InputMaybe<Scalars['Int']['input']>;
  isFrozen?: InputMaybe<Scalars['Boolean']['input']>;
  metricId?: InputMaybe<Scalars['Int']['input']>;
  reportingPeriodType?: InputMaybe<MetricReportingPeriodType>;
  valueOptions?: InputMaybe<Scalars['JSON']['input']>;
};

export type MetricAssignmentPeriodLockInput = {
  metricAssignmentId: Scalars['Int']['input'];
  periods: Array<Scalars['String']['input']>;
};

export type MetricAssignmentPeriodStatusType = {
  __typename?: 'MetricAssignmentPeriodStatusType';
  isActualDataEntered: Scalars['Boolean']['output'];
  isDataEntered: Scalars['Boolean']['output'];
  isSkipped: Scalars['Boolean']['output'];
  metricAssignmentId: Scalars['Int']['output'];
  period: Scalars['String']['output'];
};

export type MetricAssignmentSectionCountType = {
  __typename?: 'MetricAssignmentSectionCountType';
  count: Scalars['Int']['output'];
  sectionId?: Maybe<Scalars['Int']['output']>;
};

export type MetricAssignmentType = {
  __typename?: 'MetricAssignmentType';
  assignee?: Maybe<AccountType>;
  assigneeId?: Maybe<Scalars['UUID']['output']>;
  children?: Maybe<Array<MetricAssignmentType>>;
  comment?: Maybe<Scalars['String']['output']>;
  completionStatus: MetricAssignmentCompletionType;
  conceptId?: Maybe<Scalars['Int']['output']>;
  customTargetCalculationType: AnnualAggregationMethod;
  customTargetEndDate?: Maybe<Scalars['Int']['output']>;
  customTargetStartDate?: Maybe<Scalars['Int']['output']>;
  customTargetValue?: Maybe<Scalars['Float']['output']>;
  customTargetWeight: Scalars['Float']['output'];
  emissionSourceId?: Maybe<Scalars['Int']['output']>;
  fund?: Maybe<FundType>;
  fundId?: Maybe<Scalars['Int']['output']>;
  ghgSavingPotentialId?: Maybe<Scalars['Int']['output']>;
  goalTarget?: Maybe<Scalars['Float']['output']>;
  goalType?: Maybe<Scalars['String']['output']>;
  hiddenFromAssignee: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  impactSolutionId?: Maybe<Scalars['Int']['output']>;
  impacts: Array<ImpactType>;
  isDataEntered: Scalars['Boolean']['output'];
  isFrozen: Scalars['Boolean']['output'];
  metric?: Maybe<MetricType>;
  metricAggregations: Array<MetricAggregationType>;
  metricId: Scalars['Int']['output'];
  metricNameOverride: Scalars['String']['output'];
  metricValues: Array<MetricValueType>;
  parents?: Maybe<Array<MetricAssignmentType>>;
  periodStatuses?: Maybe<Array<MetricAssignmentPeriodStatusType>>;
  portfolio?: Maybe<AccountType>;
  portfolioId?: Maybe<Scalars['UUID']['output']>;
  reportingPeriodType: MetricReportingPeriodType;
  /** @deprecated Deprecated. Use customTarget* fields on MetricAssignment and completionStatus.targetParameters (computed) instead. */
  targetParameters?: Maybe<TargetParametersType>;
  unitName: Scalars['String']['output'];
  valueOptions?: Maybe<Scalars['JSON']['output']>;
};

export enum MetricCalculationType {
  Avg = 'AVG',
  Predefined = 'PREDEFINED',
  Sum = 'SUM',
  SumOverLen = 'SUM_OVER_LEN'
}

export enum MetricDependencyType {
  Computational = 'COMPUTATIONAL',
  Conditional = 'CONDITIONAL'
}

export type MetricInput = {
  aggregationMethod?: InputMaybe<MetricAggregationMethod>;
  allowCustomOptions?: InputMaybe<Scalars['Boolean']['input']>;
  allowQuarterlyInput?: InputMaybe<Scalars['Boolean']['input']>;
  annualAggregationMethod?: InputMaybe<AnnualAggregationMethod>;
  assignedTo?: InputMaybe<TypeMetricAssignedTo>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Scalars['JSON']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  defaultGoalTarget?: InputMaybe<Scalars['Float']['input']>;
  defaultGoalType?: InputMaybe<Scalars['String']['input']>;
  defaultReportingPeriodType?: InputMaybe<MetricReportingPeriodType>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionI18n?: InputMaybe<Scalars['JSON']['input']>;
  externalData?: InputMaybe<Scalars['JSON']['input']>;
  formula?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isComputed?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameI18n?: InputMaybe<Scalars['JSON']['input']>;
  notionId?: InputMaybe<Scalars['String']['input']>;
  portfolioCanEditMetricValue?: InputMaybe<Scalars['Boolean']['input']>;
  sectionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  taxonomyId?: InputMaybe<Scalars['Int']['input']>;
  tocBaseline?: InputMaybe<Scalars['String']['input']>;
  tocDataCollectionMethod?: InputMaybe<Scalars['String']['input']>;
  tocRelation?: InputMaybe<MetricTheoryOfChangeRelation>;
  unitName?: InputMaybe<Scalars['String']['input']>;
  usageGuidanceI18n?: InputMaybe<Scalars['JSON']['input']>;
  valueOptions?: InputMaybe<Scalars['JSON']['input']>;
  valueType?: InputMaybe<MetricValueKind>;
};

export type MetricQueryInput = {
  allowQuarterlyInput?: InputMaybe<Scalars['Boolean']['input']>;
  assignedTos?: InputMaybe<Array<InputMaybe<TypeMetricAssignedTo>>>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  childIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  defaultReportingPeriodType?: InputMaybe<Array<MetricReportingPeriodType>>;
  dependencyTypes?: InputMaybe<Array<MetricDependencyType>>;
  directOnly?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  isAdminKpi?: InputMaybe<Scalars['Boolean']['input']>;
  isComputed?: InputMaybe<Scalars['Boolean']['input']>;
  parentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  portfolioCanEditMetricValue?: InputMaybe<Scalars['Boolean']['input']>;
  relevantToPortfolioId?: InputMaybe<Scalars['UUID']['input']>;
  sections?: InputMaybe<Array<Scalars['Int']['input']>>;
  sort?: InputMaybe<Array<SortParam>>;
  taxonomies?: InputMaybe<Array<Scalars['Int']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export enum MetricReportingPeriodType {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY'
}

export enum MetricTheoryOfChangeRelation {
  ImpactLongTerm = 'IMPACT_LONG_TERM',
  Outcome = 'OUTCOME',
  SolutionsOutput = 'SOLUTIONS_OUTPUT'
}

export type MetricType = {
  __typename?: 'MetricType';
  aggregationMethod: MetricAggregationMethod;
  allowCustomOptions: Scalars['Boolean']['output'];
  allowQuarterlyInput: Scalars['Boolean']['output'];
  annualAggregationMethod: AnnualAggregationMethod;
  assignedTo?: Maybe<TypeMetricAssignedTo>;
  category?: Maybe<CategoryType>;
  categoryId?: Maybe<Scalars['Int']['output']>;
  childMetrics: Array<MetricType>;
  commaSeparatedSections: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  conditions?: Maybe<Scalars['JSON']['output']>;
  createdBy: Scalars['String']['output'];
  defaultGoalTarget?: Maybe<Scalars['Float']['output']>;
  defaultGoalType?: Maybe<Scalars['String']['output']>;
  defaultReportingPeriodType: MetricReportingPeriodType;
  description: Scalars['String']['output'];
  descriptionI18n: Scalars['JSON']['output'];
  directComputationalChildren: Array<MetricType>;
  directComputationalChildrenIds?: Maybe<Array<Scalars['Int']['output']>>;
  directConditionalChildren: Array<MetricType>;
  editable: Scalars['Boolean']['output'];
  externalData?: Maybe<Scalars['JSON']['output']>;
  formula?: Maybe<Scalars['JSON']['output']>;
  humanReadableDirectFormula: Array<FormulaOperator>;
  id?: Maybe<Scalars['Int']['output']>;
  isComputed: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nameI18n: Scalars['JSON']['output'];
  notionId?: Maybe<Scalars['String']['output']>;
  portfolioCanEditMetricValue: Scalars['Boolean']['output'];
  sections?: Maybe<Array<SectionType>>;
  taxonomy?: Maybe<TaxonomyType>;
  taxonomyId?: Maybe<Scalars['Int']['output']>;
  tocBaseline?: Maybe<Scalars['String']['output']>;
  tocDataCollectionMethod?: Maybe<Scalars['String']['output']>;
  tocRelation?: Maybe<MetricTheoryOfChangeRelation>;
  unitName: Scalars['String']['output'];
  usageGuidance: Scalars['String']['output'];
  usageGuidanceI18n: Scalars['JSON']['output'];
  valueOptions?: Maybe<Scalars['JSON']['output']>;
  valueType: MetricValueKind;
};

export type MetricValueInput = {
  actual?: InputMaybe<Scalars['Float']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  metricAssignmentId?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  period?: InputMaybe<Scalars['String']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  target?: InputMaybe<Scalars['Float']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export enum MetricValueKind {
  Binary = 'BINARY',
  Float = 'FLOAT',
  Int = 'INT',
  Nki = 'NKI',
  Select = 'SELECT',
  SingleSelect = 'SINGLE_SELECT',
  String = 'STRING'
}

export enum MetricValueLockLevel {
  IxAdmin = 'IX_ADMIN',
  Portfolio = 'PORTFOLIO',
  Reviewer = 'REVIEWER'
}

export enum MetricValueLockOperation {
  Freeze = 'FREEZE',
  Unfreeze = 'UNFREEZE'
}

export enum MetricValueLockScope {
  Actual = 'ACTUAL',
  Target = 'TARGET',
  TargetAndActual = 'TARGET_AND_ACTUAL'
}

export type MetricValueType = {
  __typename?: 'MetricValueType';
  actual?: Maybe<Scalars['Float']['output']>;
  actualLocked: Scalars['Boolean']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  editable: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isConditionMet: Scalars['Boolean']['output'];
  lockLevel?: Maybe<MetricValueLockLevel>;
  lockedAt?: Maybe<Scalars['DateTime']['output']>;
  lockedByUserId?: Maybe<Scalars['UUID']['output']>;
  lockedReason?: Maybe<Scalars['String']['output']>;
  metricAssignment?: Maybe<MetricAssignmentType>;
  metricAssignmentId: Scalars['Int']['output'];
  options?: Maybe<Array<Scalars['String']['output']>>;
  percentageAchieved?: Maybe<Scalars['Int']['output']>;
  period: Scalars['String']['output'];
  skipped: Scalars['Boolean']['output'];
  target?: Maybe<Scalars['Float']['output']>;
  targetLocked: Scalars['Boolean']['output'];
  text?: Maybe<Scalars['String']['output']>;
  type: MetricValueKind;
};

export enum Module {
  Annotation = 'ANNOTATION',
  CompanyInfo = 'COMPANY_INFO',
  Csrd = 'CSRD',
  Esg = 'ESG',
  EuTaxonomy = 'EU_TAXONOMY',
  Impact = 'IMPACT',
  ImpactGoal = 'IMPACT_GOAL',
  ImpactScreening = 'IMPACT_SCREENING',
  ImpactStrategy = 'IMPACT_STRATEGY',
  Metrics = 'METRICS',
  Review = 'REVIEW',
  Sfdr = 'SFDR'
}

export type ModuleUpdate = {
  __typename?: 'ModuleUpdate';
  assignee?: Maybe<AccountType>;
  assigneeId: Scalars['UUID']['output'];
  modulesToAdd: Array<Module>;
};

export type NotificationInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  invitePath?: InputMaybe<Scalars['String']['input']>;
  metricId?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  recipient: RecipientEnum;
  recipientEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientId?: InputMaybe<Scalars['String']['input']>;
  reviewEventId?: InputMaybe<Scalars['String']['input']>;
  reviewRequestId?: InputMaybe<Scalars['String']['input']>;
  type: NotificationType;
  ventureId?: InputMaybe<Scalars['String']['input']>;
};

export enum NotificationType {
  CompanyUserInvited = 'COMPANY_USER_INVITED',
  CustomKpiCreated = 'CUSTOM_KPI_CREATED',
  EsgReportReopened = 'ESG_REPORT_REOPENED',
  EsgReportRequested = 'ESG_REPORT_REQUESTED',
  ExistingEsgReportOpened = 'EXISTING_ESG_REPORT_OPENED',
  PortcoSignedUp = 'PORTCO_SIGNED_UP',
  PortcoSubmittedEsg = 'PORTCO_SUBMITTED_ESG',
  ReviewEventSubmitted = 'REVIEW_EVENT_SUBMITTED'
}

export type OptionInput = {
  id: Scalars['Int']['input'];
  ixId?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  labelI18n?: InputMaybe<Scalars['JSON']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  sublabel?: InputMaybe<Scalars['String']['input']>;
  tooltip?: InputMaybe<Scalars['String']['input']>;
};

export type OptionType = {
  __typename?: 'OptionType';
  children: Array<OptionType>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  ixId?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  labelI18n: Scalars['JSON']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  sublabel?: Maybe<Scalars['String']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
};

export type PaiReportType = {
  __typename?: 'PaiReportType';
  considerationOfPaisOnSustainabilityDescription?: Maybe<Scalars['String']['output']>;
  considerationOfPaisOnSustainabilityHistoricalComparison: Scalars['String']['output'];
  fundName: Scalars['String']['output'];
  howDidProductConsiderPais: Scalars['String']['output'];
  legalEntityIdentifier?: Maybe<Scalars['String']['output']>;
  nameOfFinancialMarketParticipant?: Maybe<Scalars['String']['output']>;
  paiExplanationsAndActions: Scalars['JSON']['output'];
  pais: PaisItems;
  subsidiaries: Array<Scalars['String']['output']>;
  summaryOfPais: Scalars['String']['output'];
};

export type PaisItems = {
  __typename?: 'PaisItems';
  additionalEnvironmental: Array<MetricAggregationType>;
  additionalSocial: Array<MetricAggregationType>;
  mandatory: Array<MetricAggregationType>;
};

export type PortfolioGroupInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  label: Scalars['String']['input'];
};

export type PortfolioGroupType = {
  __typename?: 'PortfolioGroupType';
  id?: Maybe<Scalars['Int']['output']>;
  label: Scalars['String']['output'];
  portfolioId: Scalars['UUID']['output'];
};

export type PortfolioVentureLinkType = {
  __typename?: 'PortfolioVentureLinkType';
  comment?: Maybe<Scalars['String']['output']>;
  companyUserInvites: Array<CompanyUserInviteType>;
  esgSummary?: Maybe<QuestionnaireResultSummaryType>;
  groupIds?: Maybe<Array<Scalars['Int']['output']>>;
  groupNames: Array<Scalars['String']['output']>;
  groups?: Maybe<Array<PortfolioGroupType>>;
  id: Scalars['String']['output'];
  impactGoal?: Maybe<ImpactGoalType>;
  modules: Array<Module>;
  portfolio?: Maybe<AccountType>;
  portfolioId: Scalars['UUID']['output'];
  venture?: Maybe<AccountType>;
  ventureId: Scalars['UUID']['output'];
};

export enum PromptEnum {
  KpiTranslationPrompt = 'KPI_TRANSLATION_PROMPT',
  UserInputTranslationPrompt = 'USER_INPUT_TRANSLATION_PROMPT',
  WebsiteDisclosureOverallSummaryPrompt = 'WEBSITE_DISCLOSURE_OVERALL_SUMMARY_PROMPT',
  WebsiteDisclosureSectionSummaryPrompt = 'WEBSITE_DISCLOSURE_SECTION_SUMMARY_PROMPT'
}

export type PromptRunInput = {
  accountId?: InputMaybe<Scalars['UUID']['input']>;
  cacheHit?: InputMaybe<Scalars['Boolean']['input']>;
  context?: InputMaybe<Scalars['String']['input']>;
  dataId?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  executionStrategy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  iterations?: InputMaybe<Scalars['Int']['input']>;
  latencyMs?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  previousFieldValue?: InputMaybe<Scalars['String']['input']>;
  promptAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  promptTemplateId?: InputMaybe<Scalars['UUID']['input']>;
  questionId?: InputMaybe<Scalars['Int']['input']>;
  realUserId?: InputMaybe<Scalars['UUID']['input']>;
  renderedSystem?: InputMaybe<Scalars['String']['input']>;
  renderedUser?: InputMaybe<Scalars['String']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  sanitizedRenderedUser?: InputMaybe<Scalars['String']['input']>;
  sanitizerInfo?: InputMaybe<Scalars['JSON']['input']>;
  scrapedAccountId?: InputMaybe<Scalars['UUID']['input']>;
  status?: PromptRunStatus;
  templateSystem?: InputMaybe<Scalars['String']['input']>;
  templateUser?: InputMaybe<Scalars['String']['input']>;
  tokenUsage?: InputMaybe<Scalars['JSON']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export enum PromptRunStatus {
  Error = 'ERROR',
  InvalidOutput = 'INVALID_OUTPUT',
  Ok = 'OK'
}

export type PromptRunType = {
  __typename?: 'PromptRunType';
  accountId?: Maybe<Scalars['UUID']['output']>;
  cacheHit?: Maybe<Scalars['Boolean']['output']>;
  context?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dataId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  executionStrategy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  iterations?: Maybe<Scalars['Int']['output']>;
  latencyMs?: Maybe<Scalars['Int']['output']>;
  model: Scalars['String']['output'];
  previousFieldValue?: Maybe<Scalars['String']['output']>;
  promptAccepted?: Maybe<Scalars['Boolean']['output']>;
  promptTemplateId: Scalars['UUID']['output'];
  questionId?: Maybe<Scalars['Int']['output']>;
  realUserId?: Maybe<Scalars['UUID']['output']>;
  renderedSystem?: Maybe<Scalars['String']['output']>;
  renderedUser?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  sanitizedRenderedUser?: Maybe<Scalars['String']['output']>;
  sanitizerInfo?: Maybe<Scalars['JSON']['output']>;
  scrapedAccountId?: Maybe<Scalars['UUID']['output']>;
  status: PromptRunStatus;
  templateSystem?: Maybe<Scalars['String']['output']>;
  templateUser?: Maybe<Scalars['String']['output']>;
  tokenUsage?: Maybe<Scalars['JSON']['output']>;
  version: Scalars['Int']['output'];
};

export type PromptTemplateInput = {
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  ixId?: InputMaybe<Scalars['String']['input']>;
  latestVersionId?: InputMaybe<Scalars['UUID']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
  questionId?: InputMaybe<Scalars['Int']['input']>;
};

export type PromptTemplateType = {
  __typename?: 'PromptTemplateType';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  ixId: Scalars['String']['output'];
  latestVersionId?: Maybe<Scalars['UUID']['output']>;
  purpose?: Maybe<Scalars['String']['output']>;
  questionId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PromptTemplateVersionInput = {
  appendCompanyWebsiteScrape?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  inputSchema?: InputMaybe<Scalars['JSON']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outputSchema?: InputMaybe<Scalars['JSON']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  promptTemplateId?: InputMaybe<Scalars['UUID']['input']>;
  systemTemplate?: InputMaybe<Scalars['String']['input']>;
  userTemplate?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type PromptTemplateVersionType = {
  __typename?: 'PromptTemplateVersionType';
  appendCompanyWebsiteScrape?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  inputSchema?: Maybe<Scalars['JSON']['output']>;
  model: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  outputSchema?: Maybe<Scalars['JSON']['output']>;
  params?: Maybe<Scalars['JSON']['output']>;
  promptTemplateId: Scalars['UUID']['output'];
  systemTemplate?: Maybe<Scalars['String']['output']>;
  userTemplate: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type QuestionInput = {
  component?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isActiveByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  isMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  ixId?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  labelI18n?: InputMaybe<Scalars['JSON']['input']>;
  scoringRules?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  sublabel?: InputMaybe<Scalars['String']['input']>;
  sublabelI18n?: InputMaybe<Scalars['JSON']['input']>;
  templateEngineContext?: InputMaybe<TemplateEngineContext>;
  tooltip?: InputMaybe<Scalars['String']['input']>;
  tooltipI18n?: InputMaybe<Scalars['JSON']['input']>;
};

export type QuestionSectionLinkInput = {
  labelI18n?: InputMaybe<Scalars['JSON']['input']>;
  questionId: Scalars['Int']['input'];
  sectionId: Scalars['Int']['input'];
  sort?: InputMaybe<Scalars['Int']['input']>;
  sublabelI18n?: InputMaybe<Scalars['JSON']['input']>;
  tooltipI18n?: InputMaybe<Scalars['JSON']['input']>;
};

export type QuestionSectionLinkType = {
  __typename?: 'QuestionSectionLinkType';
  label?: Maybe<Scalars['String']['output']>;
  labelI18n?: Maybe<Scalars['JSON']['output']>;
  question: QuestionType;
  questionId?: Maybe<Scalars['Int']['output']>;
  section: SectionType;
  sectionId?: Maybe<Scalars['Int']['output']>;
  sort: Scalars['Float']['output'];
  sublabel?: Maybe<Scalars['String']['output']>;
  sublabelI18n?: Maybe<Scalars['JSON']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
  tooltipI18n?: Maybe<Scalars['JSON']['output']>;
};

export type QuestionSectionLinkTypeSectionType = QuestionSectionLinkType | SectionType;

export type QuestionSummaryType = {
  __typename?: 'QuestionSummaryType';
  actionsNeither: Array<Scalars['String']['output']>;
  actionsPlanned: Array<Scalars['String']['output']>;
  actionsTaken: Array<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  disclosureRisks: Array<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  sectionId: Scalars['Int']['output'];
  sectionLabel: Scalars['String']['output'];
  subsectionId: Scalars['Int']['output'];
  subsectionLabel: Scalars['String']['output'];
};

export type QuestionType = {
  __typename?: 'QuestionType';
  component: Scalars['String']['output'];
  concepts: Array<ConceptType>;
  conditionalTemplateTexts: Array<TemplateTextType>;
  copyableOptions: Scalars['JSON']['output'];
  copyableText: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  currentPromptVersion?: Maybe<PromptTemplateVersionType>;
  id?: Maybe<Scalars['Int']['output']>;
  isActiveByDefault: Scalars['Boolean']['output'];
  isCopyable: Scalars['Boolean']['output'];
  isMandatory: Scalars['Boolean']['output'];
  isMultiple?: Maybe<Scalars['Boolean']['output']>;
  ixId?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  labelI18n: Scalars['JSON']['output'];
  options: Array<OptionType>;
  promptTemplate?: Maybe<PromptTemplateType>;
  questionSectionLinks: Array<QuestionSectionLinkType>;
  questions: Array<QuestionType>;
  scoringRules?: Maybe<Scalars['JSON']['output']>;
  sections: Array<SectionType>;
  sort: Scalars['Float']['output'];
  sublabel?: Maybe<Scalars['String']['output']>;
  sublabelI18n: Scalars['JSON']['output'];
  targetEntity?: Maybe<Scalars['String']['output']>;
  templateEngineContext?: Maybe<TemplateEngineContext>;
  templateTexts: Array<TemplateTextType>;
  tooltip?: Maybe<Scalars['String']['output']>;
  tooltipI18n: Scalars['JSON']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value: Scalars['String']['output'];
};


export type QuestionTypeConditionalTemplateTextsArgs = {
  fundId: Scalars['Int']['input'];
};


export type QuestionTypeCopyableOptionsArgs = {
  context?: InputMaybe<TemplateEngineContext>;
  fundId?: InputMaybe<Scalars['Int']['input']>;
  impactSolutionId?: InputMaybe<Scalars['Int']['input']>;
  referencePeriodId?: InputMaybe<Scalars['Int']['input']>;
  sectionId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuestionTypeCopyableTextArgs = {
  context?: InputMaybe<TemplateEngineContext>;
  fundId?: InputMaybe<Scalars['Int']['input']>;
  impactSolutionId?: InputMaybe<Scalars['Int']['input']>;
  referencePeriodId?: InputMaybe<Scalars['Int']['input']>;
  sectionId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuestionTypeValueArgs = {
  fundId?: InputMaybe<Scalars['Int']['input']>;
  questionnaireId?: InputMaybe<Scalars['Int']['input']>;
  referencePeriodId?: InputMaybe<Scalars['Int']['input']>;
  sectionId?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionnaireAssignmentType = {
  __typename?: 'QuestionnaireAssignmentType';
  id?: Maybe<Scalars['Int']['output']>;
  isEditable: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  period?: Maybe<ReferencePeriodType>;
  questionnaireResults: Array<QuestionnaireResultType>;
  results: Array<QuestionnaireResultType>;
  sectionCompletion: Array<SectionCompletionType>;
  sections: Array<SectionType>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userInputs: Array<UserInputType>;
  venture: AccountType;
  ventureId: Scalars['UUID']['output'];
};

export type QuestionnaireComparisonInput = {
  commentE?: InputMaybe<Scalars['String']['input']>;
  commentG?: InputMaybe<Scalars['String']['input']>;
  commentS?: InputMaybe<Scalars['String']['input']>;
  firstQuestionnaireId?: InputMaybe<Scalars['Int']['input']>;
  secondQuestionnaireId?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionnaireComparisonType = {
  __typename?: 'QuestionnaireComparisonType';
  commentE?: Maybe<Scalars['String']['output']>;
  commentG?: Maybe<Scalars['String']['output']>;
  commentS?: Maybe<Scalars['String']['output']>;
  firstQuestionnaireId?: Maybe<Scalars['Int']['output']>;
  secondQuestionnaireId?: Maybe<Scalars['Int']['output']>;
};

export type QuestionnaireInput = {
  doSendNotification?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isEditable?: InputMaybe<Scalars['Boolean']['input']>;
  referencePeriod?: InputMaybe<ReferencePeriodInput>;
};

export type QuestionnaireNavigationInput = {
  currentSection?: InputMaybe<Scalars['Int']['input']>;
  currentSubsection?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionnaireNavigationType = {
  __typename?: 'QuestionnaireNavigationType';
  currentSection?: Maybe<Scalars['Int']['output']>;
  currentSubsection?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type QuestionnaireResultSummaryType = {
  __typename?: 'QuestionnaireResultSummaryType';
  disclosure?: Maybe<Scalars['JSON']['output']>;
  environmental?: Maybe<Scalars['Float']['output']>;
  environmentalDiffToPrevious?: Maybe<Scalars['Float']['output']>;
  governance?: Maybe<Scalars['Float']['output']>;
  governanceDiffToPrevious?: Maybe<Scalars['Float']['output']>;
  isCompleted: Scalars['Boolean']['output'];
  period?: Maybe<ReferencePeriodType>;
  social?: Maybe<Scalars['Float']['output']>;
  socialDiffToPrevious?: Maybe<Scalars['Float']['output']>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  totalDiffToPrevious?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  ventureId: Scalars['String']['output'];
  ventureName: Scalars['String']['output'];
};

export type QuestionnaireResultType = {
  __typename?: 'QuestionnaireResultType';
  details?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  sectionId?: Maybe<Scalars['Int']['output']>;
  sectionLabel: Scalars['String']['output'];
};

export type QuestionnaireTemplateType = {
  __typename?: 'QuestionnaireTemplateType';
  id?: Maybe<Scalars['Int']['output']>;
  label: Scalars['String']['output'];
  sections?: Maybe<Array<SectionType>>;
  ventureId: Scalars['UUID']['output'];
};

export type QuestionnaireType = {
  __typename?: 'QuestionnaireType';
  createdAt: Scalars['DateTime']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  isEditable: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  period?: Maybe<ReferencePeriodType>;
  periodId?: Maybe<Scalars['Int']['output']>;
  questionnaireAssignment?: Maybe<QuestionnaireAssignmentType>;
  questionnaireNavigation?: Maybe<QuestionnaireNavigationType>;
  questionnaireTemplate?: Maybe<QuestionnaireTemplateType>;
  sections: Array<SectionType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userInputs: Array<UserInputType>;
  venture: AccountType;
  ventureId: Scalars['UUID']['output'];
};

export enum RecipientEnum {
  Admin = 'ADMIN',
  Company = 'COMPANY',
  Portfolio = 'PORTFOLIO'
}

export type ReferencePeriodInput = {
  createdBy?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['Date']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['Date']['input'];
  userDefined?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReferencePeriodType = {
  __typename?: 'ReferencePeriodType';
  createdBy?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  userDefined?: Maybe<Scalars['Boolean']['output']>;
};

export type ReportAnswerInput = {
  entityWebsiteDisclosureData?: InputMaybe<UserInputEntityWebsiteDisclosureInput>;
  fundId?: InputMaybe<Scalars['Int']['input']>;
  fundWebsiteDisclosureData?: InputMaybe<UserInputFundWebsiteDisclosureInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  paiReportData?: InputMaybe<UserInputPaiReportInput>;
  periodicReportData?: InputMaybe<UserInputFundReportInput>;
  precontractualReportData?: InputMaybe<UserInputPrecontractualReportInput>;
  referencePeriodId?: InputMaybe<Scalars['Int']['input']>;
  reportType?: InputMaybe<ReportType>;
};

export type ReportAnswerType = {
  __typename?: 'ReportAnswerType';
  fundId: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  referencePeriod: Scalars['Int']['output'];
  referencePeriodId: Scalars['Int']['output'];
  reportData: Scalars['JSON']['output'];
  reportType: ReportType;
  sfdrReportingPeriod?: Maybe<ReferencePeriodType>;
};

export enum ReportType {
  SfdrEntityWebsiteDisclosure = 'SFDR_ENTITY_WEBSITE_DISCLOSURE',
  SfdrFundWebsiteDisclosure = 'SFDR_FUND_WEBSITE_DISCLOSURE',
  SfdrPai = 'SFDR_PAI',
  SfdrPeriodic = 'SFDR_PERIODIC',
  SfdrPrecontractual = 'SFDR_PRECONTRACTUAL'
}

export type ReportingRequestGraphType = {
  __typename?: 'ReportingRequestGraphType';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  description: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['Date']['output']>;
  fundId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  metricIds: Array<Scalars['Int']['output']>;
  metrics: Array<ReportingRequestMetricGraphType>;
  portfolioId: Scalars['UUID']['output'];
  referencePeriod: Scalars['String']['output'];
  requestType: ReportingRequestType;
  title: Scalars['String']['output'];
  ventures: Array<ReportingRequestVentureGraphType>;
};

export type ReportingRequestKpiOptionGraphType = {
  __typename?: 'ReportingRequestKpiOptionGraphType';
  metricId: Scalars['Int']['output'];
  metricName: Scalars['String']['output'];
  ventureIds: Array<Scalars['UUID']['output']>;
};

export type ReportingRequestMetricGraphType = {
  __typename?: 'ReportingRequestMetricGraphType';
  metricId: Scalars['Int']['output'];
};

export enum ReportingRequestType {
  Esg = 'ESG',
  ImpactCarry = 'IMPACT_CARRY',
  Kpi = 'KPI'
}

export type ReportingRequestVentureGraphType = {
  __typename?: 'ReportingRequestVentureGraphType';
  metricIds: Array<Scalars['Int']['output']>;
  questionnaireId?: Maybe<Scalars['Int']['output']>;
  status: ReportingVentureStatus;
  statusSummary: ReportingRequestVentureStatusSummaryGraphType;
  venture: AccountType;
  ventureId: Scalars['UUID']['output'];
};

export type ReportingRequestVentureStatusSummaryGraphType = {
  __typename?: 'ReportingRequestVentureStatusSummaryGraphType';
  completedKpis: Scalars['Int']['output'];
  incompleteKpis: Scalars['Int']['output'];
  skippedKpis: Scalars['Int']['output'];
  totalKpis: Scalars['Int']['output'];
};

export enum ReportingVentureStatus {
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export enum ReviewCompanyPdfSection {
  Carry = 'CARRY',
  CustomImpacts = 'CUSTOM_IMPACTS',
  Ghg = 'GHG',
  Strategy = 'STRATEGY'
}

export type ReviewCompanyTypstExportItemGraphType = {
  __typename?: 'ReviewCompanyTypstExportItemGraphType';
  errorMessage?: Maybe<Scalars['String']['output']>;
  status: ReviewCompanyTypstExportStatus;
  ventureId: Scalars['UUID']['output'];
};

export enum ReviewCompanyTypstExportStatus {
  Error = 'ERROR',
  Success = 'SUCCESS'
}

export type ReviewEventFilters = {
  reviewRequestId: Scalars['UUID']['input'];
  ventureId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ReviewEventGraphType = {
  __typename?: 'ReviewEventGraphType';
  comment: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  eventType: ReviewEventType;
  id: Scalars['UUID']['output'];
  reviewer?: Maybe<UserType>;
  snapshot?: Maybe<Scalars['JSON']['output']>;
  venture: AccountType;
  ventureId: Scalars['UUID']['output'];
};

export enum ReviewEventType {
  Approved = 'APPROVED',
  EditsRequested = 'EDITS_REQUESTED'
}

export type ReviewRequestGraphType = {
  __typename?: 'ReviewRequestGraphType';
  assignedReviewers: Array<UserType>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  portfolioId: Scalars['UUID']['output'];
  reviewType: ReviewType;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  submittedBy?: Maybe<UserType>;
  title: Scalars['String']['output'];
  ventures: Array<ReviewRequestVentureGraphType>;
};

export type ReviewRequestVentureGraphType = {
  __typename?: 'ReviewRequestVentureGraphType';
  latestEvent?: Maybe<ReviewEventGraphType>;
  status: ReviewVentureStatus;
  venture: AccountType;
  ventureId: Scalars['UUID']['output'];
};

export enum ReviewType {
  TheoryOfChange = 'THEORY_OF_CHANGE'
}

export enum ReviewVentureStatus {
  Approved = 'APPROVED',
  AwaitingReview = 'AWAITING_REVIEW',
  EditsRequested = 'EDITS_REQUESTED'
}

export enum RiskManagementScheme {
  Compensation = 'COMPENSATION',
  Implementation = 'IMPLEMENTATION',
  MonitoringEvaluation = 'MONITORING_EVALUATION',
  ReductionSubstitution = 'REDUCTION_SUBSTITUTION'
}

export type SdgAggregationType = {
  __typename?: 'SdgAggregationType';
  impacts: Array<ImpactType>;
  sdgNumber: Scalars['Int']['output'];
};

export type SdgTargetType = {
  __typename?: 'SdgTargetType';
  externalId: Scalars['String']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  label: Scalars['String']['output'];
  sdgId?: Maybe<Scalars['Int']['output']>;
};

export type SdgType = {
  __typename?: 'SdgType';
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  label: Scalars['String']['output'];
  sublabel: Scalars['String']['output'];
};

export type SectionCompletionType = {
  __typename?: 'SectionCompletionType';
  incompleteQuestions: Array<Scalars['String']['output']>;
  isCompleted: Scalars['Boolean']['output'];
  numberIncomplete: Scalars['Int']['output'];
  numberRequired: Scalars['Int']['output'];
  percentageCompleted: Scalars['Float']['output'];
  sectionId: Scalars['Int']['output'];
};

export type SectionFiltersInput = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeHidden?: Scalars['Boolean']['input'];
  iroLink?: InputMaybe<Scalars['Boolean']['input']>;
  linkedToMetrics?: Scalars['Boolean']['input'];
  parentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  parentIsNull?: InputMaybe<Scalars['Boolean']['input']>;
  questionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  taxonomyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  text?: Scalars['String']['input'];
};

export type SectionInput = {
  labelI18n?: InputMaybe<Scalars['JSON']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  sectionKind?: InputMaybe<EnumSectionKind>;
  sublabelI18n?: InputMaybe<Scalars['JSON']['input']>;
  taxonomyId?: InputMaybe<Scalars['Int']['input']>;
};

export type SectionType = {
  __typename?: 'SectionType';
  accountLinks?: Maybe<Array<AccountSectionLinkType>>;
  children: Array<QuestionSectionLinkTypeSectionType>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionI18n: Scalars['JSON']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  iroLinks?: Maybe<Array<IroSectionLinkType>>;
  ixId?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  labelI18n: Scalars['JSON']['output'];
  parent?: Maybe<SectionType>;
  parentId?: Maybe<Scalars['Int']['output']>;
  questionSectionLinks: Array<QuestionSectionLinkType>;
  questions: Array<QuestionType>;
  sectionKind?: Maybe<EnumSectionKind>;
  sections: Array<SectionType>;
  sort: Scalars['Float']['output'];
  sublabel?: Maybe<Scalars['String']['output']>;
  sublabelI18n: Scalars['JSON']['output'];
  taxonomy?: Maybe<TaxonomyType>;
  taxonomyId?: Maybe<Scalars['Int']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
  tooltipI18n: Scalars['JSON']['output'];
};

export type SfdrStrategyInput = {
  actionsTaken?: InputMaybe<Scalars['String']['input']>;
  benchmarkDescription?: InputMaybe<Scalars['String']['input']>;
  bestInClassDescription?: InputMaybe<Scalars['String']['input']>;
  broadMarketIndexComparison?: InputMaybe<Scalars['String']['input']>;
  conceptId?: InputMaybe<Scalars['Int']['input']>;
  dataSourcesConsidered?: InputMaybe<Scalars['String']['input']>;
  doCheckEuTaxonomyAlignment?: InputMaybe<Scalars['Boolean']['input']>;
  dueDiligenceProcessDescription?: InputMaybe<Scalars['String']['input']>;
  engagementPolicyWithSpecificInvestmentStrategy?: InputMaybe<Scalars['String']['input']>;
  entityResponsibleForMonitoringIndicators?: InputMaybe<Scalars['String']['input']>;
  esCharacteristicsDescription?: InputMaybe<Scalars['String']['input']>;
  esStrategy?: InputMaybe<Array<EsCharacteristicStrategy>>;
  esgIntegrationDescription?: InputMaybe<Scalars['String']['input']>;
  euTaxonomyConceptId?: InputMaybe<Scalars['Int']['input']>;
  exclusionCriteriaDescription?: InputMaybe<Scalars['String']['input']>;
  fundId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  indexCalculationMethodology?: InputMaybe<Scalars['String']['input']>;
  investmentAlignedIndexExplanation?: InputMaybe<Scalars['String']['input']>;
  isCo2EmissionGoal?: InputMaybe<Scalars['Boolean']['input']>;
  isConsideringSourcesAndEstimates?: InputMaybe<Scalars['Boolean']['input']>;
  isEnvironmentalGoal?: InputMaybe<Scalars['Boolean']['input']>;
  isIndexDesignated?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<SfdrStrategyKind>;
  metricIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  normBasedScreeningDescription?: InputMaybe<Scalars['String']['input']>;
  shareOfDataSecondHand?: InputMaybe<Scalars['String']['input']>;
  strategyDescription?: InputMaybe<Scalars['String']['input']>;
  sustainabilityIndicatorsMonitoringStrategy?: InputMaybe<Scalars['String']['input']>;
  sustainabilityLabelDescription?: InputMaybe<Scalars['String']['input']>;
  sustainablyAlignedIndexExplanation?: InputMaybe<Scalars['String']['input']>;
  ventureIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum SfdrStrategyKind {
  EsCharacteristic = 'ES_CHARACTERISTIC',
  SustainableObjective = 'SUSTAINABLE_OBJECTIVE'
}

export type SfdrStrategyType = {
  __typename?: 'SfdrStrategyType';
  actionsTaken?: Maybe<Scalars['String']['output']>;
  benchmarkDescription?: Maybe<Scalars['String']['output']>;
  bestInClassDescription?: Maybe<Scalars['String']['output']>;
  broadMarketIndexComparison?: Maybe<Scalars['String']['output']>;
  concept?: Maybe<ConceptType>;
  conceptId?: Maybe<Scalars['Int']['output']>;
  dataSourcesConsidered: Scalars['String']['output'];
  doCheckEuTaxonomyAlignment?: Maybe<Scalars['Boolean']['output']>;
  dueDiligenceProcessDescription: Scalars['String']['output'];
  engagementPolicyWithSpecificInvestmentStrategy: Scalars['String']['output'];
  entityResponsibleForMonitoringIndicators: Scalars['String']['output'];
  esCharacteristicsDescription?: Maybe<Scalars['String']['output']>;
  esStrategy: Array<EsCharacteristicStrategy>;
  esgIntegrationDescription?: Maybe<Scalars['String']['output']>;
  euTaxonomyConcept?: Maybe<ConceptType>;
  euTaxonomyConceptId?: Maybe<Scalars['Int']['output']>;
  exclusionCriteriaDescription?: Maybe<Scalars['String']['output']>;
  fund?: Maybe<FundType>;
  id?: Maybe<Scalars['Int']['output']>;
  indexCalculationMethodology?: Maybe<Scalars['String']['output']>;
  investmentAlignedIndexExplanation?: Maybe<Scalars['String']['output']>;
  isCo2EmissionGoal?: Maybe<Scalars['Boolean']['output']>;
  isConsideringSourcesAndEstimates: Scalars['Boolean']['output'];
  isEnvironmentalGoal: Scalars['Boolean']['output'];
  isIndexDesignated?: Maybe<Scalars['Boolean']['output']>;
  kind: SfdrStrategyKind;
  metricIds: Array<Scalars['Int']['output']>;
  metrics: Array<MetricType>;
  normBasedScreeningDescription?: Maybe<Scalars['String']['output']>;
  shareOfDataSecondHand: Scalars['String']['output'];
  strategyDescription?: Maybe<Scalars['String']['output']>;
  sustainabilityIndicatorsMonitoringStrategy: Scalars['String']['output'];
  sustainabilityLabelDescription?: Maybe<Scalars['String']['output']>;
  sustainablyAlignedIndexExplanation?: Maybe<Scalars['String']['output']>;
  ventureIds?: Maybe<Array<Scalars['UUID']['output']>>;
};

export type SolutionSourceType = {
  __typename?: 'SolutionSourceType';
  comment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  impactSolutionId?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SortParam = {
  field: Scalars['String']['input'];
  sortDesc?: Scalars['Boolean']['input'];
};

export type SourceAssignmentInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  impactId?: InputMaybe<Scalars['Int']['input']>;
  url: Scalars['String']['input'];
};

export type SourceAssignmentType = {
  __typename?: 'SourceAssignmentType';
  comment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  impact: ImpactType;
  url: Scalars['String']['output'];
};

export enum StakeholderCategoryType {
  NaturalEnvironment = 'NATURAL_ENVIRONMENT',
  People = 'PEOPLE',
  PeopleAndNaturalEnvironment = 'PEOPLE_AND_NATURAL_ENVIRONMENT'
}

export type StakeholderInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type StakeholderType = {
  __typename?: 'StakeholderType';
  accountId: Scalars['UUID']['output'];
  activityLinks?: Maybe<Array<ActivityStakeholderLinkType>>;
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  iroLinks?: Maybe<Array<IroStakeholderLinkType>>;
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type SubmitReviewEventInput = {
  comment: Scalars['String']['input'];
  eventType: ReviewEventType;
  reviewRequestId: Scalars['UUID']['input'];
  ventureId: Scalars['UUID']['input'];
};

export type SyncState = {
  __typename?: 'SyncState';
  assignmentsToAdd: Array<MetricAssignmentInfo>;
  esgModule: Scalars['Boolean']['output'];
  esgQuestionnaire: Scalars['Boolean']['output'];
  esgQuestionnairesToAdd: Array<UpdateInfo>;
  euTaxonomyChecks: Scalars['Boolean']['output'];
  fundAggregations: Scalars['Boolean']['output'];
  fundAggregationsToAdd: Array<MetricAggregationInfo>;
  fundAggregationsToDelete: Array<MetricAggregationInfo>;
  fundAssignments: Scalars['Boolean']['output'];
  fundAssignmentsToAdd: Array<MetricAssignmentInfo>;
  kfwAssignments: Scalars['Boolean']['output'];
  moduleUpdates: Array<ModuleUpdate>;
};

export type TargetParametersType = {
  __typename?: 'TargetParametersType';
  calculationType?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  metricAssignmentId?: Maybe<Scalars['Int']['output']>;
  portfolioName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Int']['output']>;
  target?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type TaxonomyFilterInput = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  label?: Scalars['String']['input'];
};

export type TaxonomyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  notionId?: InputMaybe<Scalars['String']['input']>;
  shortLabel?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type TaxonomyType = {
  __typename?: 'TaxonomyType';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  label: Scalars['String']['output'];
  notionId?: Maybe<Scalars['String']['output']>;
  sections: Array<SectionType>;
  shortLabel?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export enum TemplateEngineContext {
  Fund = 'FUND',
  Impact = 'IMPACT',
  ImpactSolution = 'IMPACT_SOLUTION'
}

export type TemplateTextInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  questionId?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
  textI18n?: InputMaybe<Scalars['JSON']['input']>;
};

export type TemplateTextType = {
  __typename?: 'TemplateTextType';
  conds?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  ixId?: Maybe<Scalars['String']['output']>;
  questionId: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  textI18n?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TemplateType = {
  __typename?: 'TemplateType';
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type TemplateValidateResponse = {
  __typename?: 'TemplateValidateResponse';
  error?: Maybe<Scalars['String']['output']>;
  originalText: Scalars['String']['output'];
  processedText?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export enum TypeAggregationGroup {
  AllEnvironmental = 'ALL_ENVIRONMENTAL',
  AllEuTaxonomyAligned = 'ALL_EU_TAXONOMY_ALIGNED',
  AllEuTaxonomyAlignedEnabling = 'ALL_EU_TAXONOMY_ALIGNED_ENABLING',
  AllEuTaxonomyAlignedFossilGas = 'ALL_EU_TAXONOMY_ALIGNED_FOSSIL_GAS',
  AllEuTaxonomyAlignedNoFossilGasNoNuclear = 'ALL_EU_TAXONOMY_ALIGNED_NO_FOSSIL_GAS_NO_NUCLEAR',
  AllEuTaxonomyAlignedNuclear = 'ALL_EU_TAXONOMY_ALIGNED_NUCLEAR',
  AllEuTaxonomyAlignedTransitional = 'ALL_EU_TAXONOMY_ALIGNED_TRANSITIONAL',
  AllSustainable = 'ALL_SUSTAINABLE',
  Fund = 'FUND',
  KfwFullReporting = 'KFW_FULL_REPORTING',
  KfwMinimumReporting = 'KFW_MINIMUM_REPORTING',
  KfwRecommendedReporting = 'KFW_RECOMMENDED_REPORTING',
  PortfolioVentureLink = 'PORTFOLIO_VENTURE_LINK',
  SfdrStrategy = 'SFDR_STRATEGY'
}

export enum TypeMetricAssignedTo {
  Company = 'COMPANY',
  Fund = 'FUND',
  FundCompany = 'FUND_COMPANY',
  FundMgmt = 'FUND_MGMT'
}

export type UpdateInfo = {
  __typename?: 'UpdateInfo';
  assignee?: Maybe<AccountType>;
  assigneeId: Scalars['UUID']['output'];
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertReportingRequestInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  fundId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  metricIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  referencePeriod?: InputMaybe<Scalars['String']['input']>;
  requestType?: InputMaybe<ReportingRequestType>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertReviewRequestInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  reviewType?: ReviewType;
  reviewerUserIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  ventureIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export enum UsageType {
  ActualCustomer = 'ACTUAL_CUSTOMER',
  Internal = 'INTERNAL',
  Other = 'OTHER',
  PendingReview = 'PENDING_REVIEW',
  TrialCustomer = 'TRIAL_CUSTOMER'
}

export type UserFeedbackInput = {
  accountId: Scalars['UUID']['input'];
  additionalComments?: InputMaybe<Scalars['String']['input']>;
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  conceptId: Scalars['Int']['input'];
  feedback: Scalars['String']['input'];
  feedbackType: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  insightId: Scalars['UUID']['input'];
};

export type UserFeedbackType = {
  __typename?: 'UserFeedbackType';
  accountId: Scalars['UUID']['output'];
  additionalComments?: Maybe<Scalars['String']['output']>;
  additionalData?: Maybe<Scalars['JSON']['output']>;
  conceptId: Scalars['Int']['output'];
  feedback: Scalars['String']['output'];
  feedbackType: Scalars['String']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  insightId: Scalars['UUID']['output'];
};

export type UserInputConceptLinkInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  conceptId?: InputMaybe<Scalars['Int']['input']>;
  implementationStatus?: InputMaybe<ImplementationStatus>;
  userInputId?: InputMaybe<Scalars['Int']['input']>;
};

export type UserInputConceptLinkType = {
  __typename?: 'UserInputConceptLinkType';
  comment: Scalars['String']['output'];
  concept: ConceptType;
  conceptId?: Maybe<Scalars['Int']['output']>;
  implementationStatus: ImplementationStatus;
  userInputId?: Maybe<Scalars['Int']['output']>;
};

export type UserInputEntityWebsiteDisclosureInput = {
  entityWdAdverseImpactTransparency?: InputMaybe<Scalars['String']['input']>;
  entityWdIntegrationOfSustainabilityRisk?: InputMaybe<Scalars['String']['input']>;
  entityWdRemunerationPolicies?: InputMaybe<Scalars['String']['input']>;
  entityWdSustainabilityRiskPolicy?: InputMaybe<Scalars['String']['input']>;
};

export type UserInputFundReportInput = {
  accountOnPais?: InputMaybe<Scalars['String']['input']>;
  actionsTakenToMeetEsCharacteristics?: InputMaybe<Scalars['String']['input']>;
  alignmentWithOecdGuidelines?: InputMaybe<Scalars['String']['input']>;
  esCharacteristicsDescription?: InputMaybe<Scalars['String']['input']>;
  fundPerformanceComparedToBroadMarketIndex?: InputMaybe<Scalars['String']['input']>;
  fundPerformanceComparedToReferenceBenchmark?: InputMaybe<Scalars['String']['input']>;
  fundPerformanceOnSustainabilityIndicators?: InputMaybe<Scalars['String']['input']>;
  howDidInvestmentsNotCauseHarm?: InputMaybe<Scalars['String']['input']>;
  investmentsAlignedWithEuTaxonomyComparisonWithPreviousPeriods?: InputMaybe<Scalars['String']['input']>;
  purposeOfOtherOrNotSustainableInvestmentsIncludingSafeguards?: InputMaybe<Scalars['String']['input']>;
  referenceBenchmarkDifferenceToBroadMarket?: InputMaybe<Scalars['String']['input']>;
  shareOfInvestmentsInTransitionalAndEnablingActivities?: InputMaybe<Scalars['String']['input']>;
  shareOfSociallySustainableInvestments?: InputMaybe<Scalars['String']['input']>;
  shareOfSustainableInvestmentsWithEnvironmentalObjectiveNonEuTaxonomyAligned?: InputMaybe<Scalars['String']['input']>;
  sustainabilityIndicatorsPerformanceDescription?: InputMaybe<Scalars['String']['input']>;
  sustainabilityIndicatorsPerformanceDescriptionComparedToPrevious?: InputMaybe<Scalars['String']['input']>;
  sustainabilityRelatedInvestmentAssetAllocation?: InputMaybe<Scalars['String']['input']>;
  sustainabilityRelatedInvestmentEconomicSector?: InputMaybe<Scalars['String']['input']>;
  sustainableInvestmentsMadeByFund?: InputMaybe<Scalars['String']['input']>;
  sustainableInvestmentsWithEnvironmentalObjectiveEuTaxonomyAlignment?: InputMaybe<Scalars['String']['input']>;
};

export type UserInputFundReportType = {
  __typename?: 'UserInputFundReportType';
  accountOnPais?: Maybe<Scalars['String']['output']>;
  actionsTakenToMeetEsCharacteristics?: Maybe<Scalars['String']['output']>;
  alignmentWithOecdGuidelines?: Maybe<Scalars['String']['output']>;
  esCharacteristicsDescription?: Maybe<Scalars['String']['output']>;
  fundPerformanceComparedToBroadMarketIndex?: Maybe<Scalars['String']['output']>;
  fundPerformanceComparedToReferenceBenchmark?: Maybe<Scalars['String']['output']>;
  fundPerformanceOnSustainabilityIndicators?: Maybe<Scalars['String']['output']>;
  howDidInvestmentsNotCauseHarm?: Maybe<Scalars['String']['output']>;
  investmentsAlignedWithEuTaxonomyComparisonWithPreviousPeriods?: Maybe<Scalars['String']['output']>;
  purposeOfOtherOrNotSustainableInvestmentsIncludingSafeguards?: Maybe<Scalars['String']['output']>;
  referenceBenchmarkDifferenceToBroadMarket?: Maybe<Scalars['String']['output']>;
  shareOfInvestmentsInTransitionalAndEnablingActivities?: Maybe<Scalars['String']['output']>;
  shareOfSociallySustainableInvestments?: Maybe<Scalars['String']['output']>;
  shareOfSustainableInvestmentsWithEnvironmentalObjectiveNonEuTaxonomyAligned?: Maybe<Scalars['String']['output']>;
  sustainabilityIndicatorsPerformanceDescription?: Maybe<Scalars['String']['output']>;
  sustainabilityIndicatorsPerformanceDescriptionComparedToPrevious?: Maybe<Scalars['String']['output']>;
  sustainabilityRelatedInvestmentAssetAllocation?: Maybe<Scalars['String']['output']>;
  sustainabilityRelatedInvestmentEconomicSector?: Maybe<Scalars['String']['output']>;
  sustainableInvestmentsMadeByFund?: Maybe<Scalars['String']['output']>;
  sustainableInvestmentsWithEnvironmentalObjectiveEuTaxonomyAlignment?: Maybe<Scalars['String']['output']>;
};

export type UserInputFundWebsiteDisclosureInput = {
  fundWdAttainment?: InputMaybe<Scalars['String']['input']>;
  fundWdDataSourcesAndProcessing?: InputMaybe<Scalars['String']['input']>;
  fundWdDueDiligence?: InputMaybe<Scalars['String']['input']>;
  fundWdEngagementPolicies?: InputMaybe<Scalars['String']['input']>;
  fundWdInvestmentStrategy?: InputMaybe<Scalars['String']['input']>;
  fundWdLimitations?: InputMaybe<Scalars['String']['input']>;
  fundWdMethodologies?: InputMaybe<Scalars['String']['input']>;
  fundWdMonitoringSustainableObjective?: InputMaybe<Scalars['String']['input']>;
  fundWdNoSignificantHarm?: InputMaybe<Scalars['String']['input']>;
  fundWdProportionOfInvestments?: InputMaybe<Scalars['String']['input']>;
  fundWdReferenceBenchmark?: InputMaybe<Scalars['String']['input']>;
  fundWdSummary?: InputMaybe<Scalars['String']['input']>;
  fundWdSustainableInvestmentObjective?: InputMaybe<Scalars['String']['input']>;
  fundWdSustainableObjective?: InputMaybe<Scalars['String']['input']>;
};

export type UserInputInput = {
  geographyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isNotRelevant?: InputMaybe<Scalars['Boolean']['input']>;
  periodId?: InputMaybe<Scalars['Int']['input']>;
  questionId?: InputMaybe<Scalars['Int']['input']>;
  ventureId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UserInputPaiReportInput = {
  considerationOfPaisOnSustainabilityDescription?: InputMaybe<Scalars['String']['input']>;
  considerationOfPaisOnSustainabilityEngagementPolicies?: InputMaybe<Scalars['String']['input']>;
  considerationOfPaisOnSustainabilityHistoricalComparison?: InputMaybe<Scalars['String']['input']>;
  considerationOfPaisOnSustainabilityInternationalStandards?: InputMaybe<Scalars['String']['input']>;
  howDidProductConsiderPais?: InputMaybe<Scalars['String']['input']>;
  principalAdverseImpactsExplanationsAndActions?: InputMaybe<Scalars['JSON']['input']>;
  summaryOfPais?: InputMaybe<Scalars['String']['input']>;
};

export type UserInputPaiReportType = {
  __typename?: 'UserInputPaiReportType';
  considerationOfPaisOnSustainabilityDescription?: Maybe<Scalars['String']['output']>;
  considerationOfPaisOnSustainabilityEngagementPolicies?: Maybe<Scalars['String']['output']>;
  considerationOfPaisOnSustainabilityHistoricalComparison?: Maybe<Scalars['String']['output']>;
  considerationOfPaisOnSustainabilityInternationalStandards?: Maybe<Scalars['String']['output']>;
  howDidProductConsiderPais?: Maybe<Scalars['String']['output']>;
  principalAdverseImpactsExplanationsAndActions: Scalars['JSON']['output'];
  summaryOfPais?: Maybe<Scalars['String']['output']>;
};

export type UserInputPrecontractualReportInput = {
  accountOnPais?: InputMaybe<Scalars['String']['input']>;
  alignmentWithOecdGuidelines?: InputMaybe<Scalars['String']['input']>;
  bindingElementsOfInvestmentStrategy?: InputMaybe<Scalars['String']['input']>;
  broadMarketIndexComparison?: InputMaybe<Scalars['String']['input']>;
  companyGovernancePolicy?: InputMaybe<Scalars['String']['input']>;
  esCharacteristicsDescription?: InputMaybe<Scalars['String']['input']>;
  fossilOrNuclear?: InputMaybe<Scalars['String']['input']>;
  fundSpecificInfo?: InputMaybe<Scalars['String']['input']>;
  howDidInvestmentsNotCauseHarm?: InputMaybe<Scalars['String']['input']>;
  howDidProductConsiderPais?: InputMaybe<Scalars['String']['input']>;
  indexCalculationMethodology?: InputMaybe<Scalars['String']['input']>;
  integrationOfSustainabilityRisk?: InputMaybe<Scalars['String']['input']>;
  investmentAlignedIndexExplanation?: InputMaybe<Scalars['String']['input']>;
  investmentStrategy?: InputMaybe<Scalars['String']['input']>;
  productPerformanceComparison?: InputMaybe<Scalars['String']['input']>;
  purposeOfOtherOrNotSustainableInvestmentsIncludingSafeguards?: InputMaybe<Scalars['String']['input']>;
  shareOfInvestmentsInTransitionalAndEnablingActivities?: InputMaybe<Scalars['String']['input']>;
  shareOfSociallySustainableInvestments?: InputMaybe<Scalars['String']['input']>;
  shareOfSustainableInvestmentsWithEnvironmentalObjectiveNonEuTaxonomyAligned?: InputMaybe<Scalars['String']['input']>;
  shareOfUnalignedSustainableInvestments?: InputMaybe<Scalars['String']['input']>;
  sustainabilityIndicatorsPerformanceDescription?: InputMaybe<Scalars['String']['input']>;
  sustainabilityRelatedInvestmentAssetAllocation?: InputMaybe<Scalars['String']['input']>;
  sustainableInvestmentsMadeByFund?: InputMaybe<Scalars['String']['input']>;
  sustainableInvestmentsWithEnvironmentalObjectiveEuTaxonomyAlignment?: InputMaybe<Scalars['String']['input']>;
  sustainableObjectiveTree?: InputMaybe<Scalars['String']['input']>;
  sustainablyAlignedIndexExplanation?: InputMaybe<Scalars['String']['input']>;
  useOfDerivatives?: InputMaybe<Scalars['String']['input']>;
  wereObjectivesMet?: InputMaybe<Scalars['String']['input']>;
  whyDidProductConsiderPais?: InputMaybe<Scalars['String']['input']>;
};

export type UserInputPrecontractualReportType = {
  __typename?: 'UserInputPrecontractualReportType';
  SustainableInvestmentsWithEnvironmentalObjective?: Maybe<Scalars['String']['output']>;
  accountOnPais?: Maybe<Scalars['String']['output']>;
  alignmentWithOecdGuidelines?: Maybe<Scalars['String']['output']>;
  bindingElementsOfInvestmentStrategy?: Maybe<Scalars['String']['output']>;
  broadMarketIndexComparison?: Maybe<Scalars['String']['output']>;
  companyGovernancePolicy?: Maybe<Scalars['String']['output']>;
  esCharacteristicsDescription?: Maybe<Scalars['String']['output']>;
  fossilOrNuclear?: Maybe<Scalars['String']['output']>;
  fundSpecificInfo?: Maybe<Scalars['String']['output']>;
  howDidInvestmentsNotCauseHarm?: Maybe<Scalars['String']['output']>;
  howDidProductConsiderPais?: Maybe<Scalars['String']['output']>;
  indexCalculationMethodology?: Maybe<Scalars['String']['output']>;
  integrationOfSustainabilityRisk?: Maybe<Scalars['String']['output']>;
  investmentAlignedIndexExplanation?: Maybe<Scalars['String']['output']>;
  investmentStrategy?: Maybe<Scalars['String']['output']>;
  productPerformanceComparison?: Maybe<Scalars['String']['output']>;
  purposeOfOtherOrNotSustainableInvestmentsIncludingSafeguards?: Maybe<Scalars['String']['output']>;
  shareOfInvestmentsInTransitionalAndEnablingActivities?: Maybe<Scalars['String']['output']>;
  shareOfSociallySustainableInvestments?: Maybe<Scalars['String']['output']>;
  shareOfSustainableInvestmentsWithEnvironmentalObjectiveNonEuTaxonomyAligned?: Maybe<Scalars['String']['output']>;
  shareOfUnalignedSustainableInvestments?: Maybe<Scalars['String']['output']>;
  sustainabilityIndicatorsPerformanceDescription?: Maybe<Scalars['String']['output']>;
  sustainabilityRelatedInvestmentAssetAllocation?: Maybe<Scalars['String']['output']>;
  sustainableInvestmentsMadeByFund?: Maybe<Scalars['String']['output']>;
  sustainableInvestmentsWithEnvironmentalObjectiveEuTaxonomyAlignment?: Maybe<Scalars['String']['output']>;
  sustainableObjectiveTree?: Maybe<Scalars['String']['output']>;
  sustainablyAlignedIndexExplanation?: Maybe<Scalars['String']['output']>;
  useOfDerivatives?: Maybe<Scalars['String']['output']>;
  wereObjectivesMet?: Maybe<Scalars['String']['output']>;
  whyDidProductConsiderPais?: Maybe<Scalars['String']['output']>;
};

export type UserInputType = {
  __typename?: 'UserInputType';
  geographyIds?: Maybe<Array<Scalars['Int']['output']>>;
  id?: Maybe<Scalars['Int']['output']>;
  isActive: Scalars['Boolean']['output'];
  isNotRelevant?: Maybe<Scalars['Boolean']['output']>;
  question: QuestionType;
  score?: Maybe<Scalars['JSON']['output']>;
  scoringRule?: Maybe<Scalars['JSON']['output']>;
  selectedConcepts: Array<UserInputConceptLinkType>;
  selectedOptions?: Maybe<Array<OptionType>>;
  text?: Maybe<Scalars['String']['output']>;
};

export type UserInputVentureMappingType = {
  __typename?: 'UserInputVentureMappingType';
  periodId?: Maybe<Scalars['Int']['output']>;
  userInput?: Maybe<UserInputType>;
  ventureId: Scalars['UUID']['output'];
};

export type UserType = {
  __typename?: 'UserType';
  accounts?: Maybe<Array<AccountType>>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isAdmin: Scalars['Boolean']['output'];
  isImpersonated: Scalars['Boolean']['output'];
  isIxAdmin?: Maybe<Scalars['Boolean']['output']>;
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  locale: Scalars['String']['output'];
  membershipRolesForAccount: Array<AccountMembershipRole>;
  realUserIsAdmin: Scalars['Boolean']['output'];
};


export type UserTypeMembershipRolesForAccountArgs = {
  accountId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ValueChainInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
};

export type ValueChainType = {
  __typename?: 'ValueChainType';
  accountId: Scalars['UUID']['output'];
  activities: Array<ActivityType>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

export type GetFundReportInput = {
  id: Scalars['Int']['input'];
  referencePeriodId: Scalars['Int']['input'];
};

export type GetPaiReportInput = {
  id: Scalars['Int']['input'];
  referencePeriodId: Scalars['Int']['input'];
};

export type AccountFragmentForEuTaxonomyFragment = { __typename?: 'AccountType', id: any, bookedModules: Array<Module>, hasNoEligibleBusinessActivities?: boolean | null, areEuTaxonomyActivitiesInSyncWithQuestionnaire: boolean, businessActivities: Array<{ __typename?: 'ConceptType', id?: number | null }>, fundSustainableObjectives: Array<{ __typename?: 'SfdrStrategyType', doCheckEuTaxonomyAlignment?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, createdBy?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, euTaxonomyConcept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, euTaxonomyQuestionnaire?: { __typename?: 'QuestionnaireType', id?: number | null, label: string, questionnaireAssignment?: { __typename?: 'QuestionnaireAssignmentType', id?: number | null, isEditable: boolean, updatedAt?: any | null, period?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null } | null, userInputs: Array<{ __typename?: 'UserInputType', id?: number | null, isActive: boolean, isNotRelevant?: boolean | null, geographyIds?: Array<number> | null, text?: string | null, scoringRule?: any | null, question: { __typename?: 'QuestionType', id?: number | null, label: string, component: string }, selectedOptions?: Array<{ __typename?: 'OptionType', id?: number | null, label?: string | null }> | null, selectedConcepts: Array<{ __typename?: 'UserInputConceptLinkType', implementationStatus: ImplementationStatus, comment: string, userInputId?: number | null, conceptId?: number | null, concept: { __typename?: 'ConceptType', id?: number | null, label: string, scheme?: RiskManagementScheme | null, description: string, isSubmeasure: boolean } }> }>, sectionCompletion: Array<{ __typename?: 'SectionCompletionType', sectionId: number, isCompleted: boolean, percentageCompleted: number, numberRequired: number, numberIncomplete: number, incompleteQuestions: Array<string> }>, questionnaireResults: Array<{ __typename?: 'QuestionnaireResultType', id?: number | null, sectionId?: number | null, sectionLabel: string, score?: number | null, details?: any | null }> } | null, questionnaireTemplate?: { __typename?: 'QuestionnaireTemplateType', sections?: Array<{ __typename?: 'SectionType', label?: string | null, id?: number | null, ixId?: string | null, description?: string | null, questions: Array<{ __typename?: 'QuestionType', id?: number | null, ixId?: string | null, component: string, tooltip?: string | null, isMultiple?: boolean | null, isMandatory: boolean, title: string, subtitle?: string | null, options: Array<{ __typename?: 'OptionType', id?: number | null, ixId?: string | null, label?: string | null, sublabel?: string | null, tooltip?: string | null }> }>, sections: Array<{ __typename?: 'SectionType', label?: string | null, id?: number | null, questions: Array<{ __typename?: 'QuestionType', id?: number | null, ixId?: string | null, component: string, tooltip?: string | null, isMultiple?: boolean | null, isMandatory: boolean, title: string, subtitle?: string | null, options: Array<{ __typename?: 'OptionType', id?: number | null, ixId?: string | null, label?: string | null, sublabel?: string | null, tooltip?: string | null }> }> }> }> | null } | null } | null };

export type AccountLinkFragment = { __typename?: 'AccountSectionLinkType', id: any, accountId: any, sectionId: number, comment: string };

export type BasicMetricAggregationFragment = { __typename?: 'MetricAggregationType', id?: number | null, comment?: string | null, groupId?: number | null, groupType?: TypeAggregationGroup | null, calculationType: MetricCalculationType, paiMetricName?: string | null, indicator: string, category?: string | null, paiSort?: number | null, metricAggregationValues: Array<{ __typename?: 'MetricAggregationValueType', period: string, actual?: number | null, target?: number | null, actualCompleted: Array<{ __typename?: 'AccountType', name?: string | null, id: any }>, required: Array<{ __typename?: 'AccountType', name?: string | null, id: any }> }>, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, fund?: { __typename?: 'FundType', id?: number | null, name?: string | null } | null, sfdrStrategy?: { __typename?: 'SfdrStrategyType', id?: number | null, kind: SfdrStrategyKind, fund?: { __typename?: 'FundType', name?: string | null } | null, concept?: { __typename?: 'ConceptType', label: string } | null } | null };

export type CompleteCompletionStatusFragment = { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null };

export type CompleteConceptFragment = { __typename?: 'ConceptType', id?: number | null, label: string, labelI18n: any, description: string, descriptionI18n: any, isSubmeasure: boolean, additionalData?: any | null, sourceUrl: string, citation: string, citationI18n: any, isMaterial: boolean, materialityExplanation: string, materialityExplanationI18n: any, status: ConceptStatus, scheme?: RiskManagementScheme | null, kind?: ConceptKind | null, ixId?: string | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null }>, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, objectLinks: Array<{ __typename?: 'ConceptLinkType', predicate: ConceptPredicateType, object: { __typename?: 'ConceptType', id?: number | null, label: string } }> };

export type CompleteEmissionSourceFragment = { __typename?: 'EmissionSourceType', id?: number | null, ghgSavingPotentialId: number, sourceOfEmission?: string | null, unitName?: string | null, baselineUnitName?: string | null, solutionUnitName?: string | null, baselineConceptName?: string | null, baselineGhgFactor?: number | null, baselineConsumption?: number | null, baselineAssumption?: string | null, baselineEvidence: string, customBaselineConcept?: boolean | null, solutionReducesConsumption?: boolean | null, solutionReducesGhgFactor?: boolean | null, solutionConceptName?: string | null, solutionGhgFactor?: number | null, solutionConsumption?: number | null, solutionAssumption?: string | null, solutionEvidence: string, customSolutionConcept?: boolean | null, specificReductionPerUnit?: number | null, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> };

export type CompleteGhgSavingPotentialFragment = { __typename?: 'GhgSavingPotentialType', id?: number | null, needFulfilled?: string | null, baselineSolutionDescription?: string | null, comparativeUnit?: string | null, comparativeQuantitiy?: number | null, comparativeUnitConfirmed?: boolean | null, describeComparison?: string | null, isPreciseEmissionCalculation?: boolean | null, simpleBaselineGhg?: number | null, simpleSolutionGhg?: number | null, simpleGhgJustification?: string | null, emissionsConfirmed?: boolean | null, growthFactorJustification?: string | null, isRecurringImpact?: boolean | null, durationOfImpact?: number | null, realisticConfirmation?: boolean | null, impactProfileKind: ImpactProfileKind, isScenarioA?: boolean | null, preComputedBaselineGhg?: number | null, preComputedSolutionGhg?: number | null, scenarioBComments?: string | null, emissionSourceLimitations?: string | null, specificReductionPerUnit?: number | null, specificReductionAsPercentage?: number | null, emissionSources: Array<{ __typename?: 'EmissionSourceType', id?: number | null, ghgSavingPotentialId: number, sourceOfEmission?: string | null, unitName?: string | null, baselineUnitName?: string | null, solutionUnitName?: string | null, baselineConceptName?: string | null, baselineGhgFactor?: number | null, baselineConsumption?: number | null, baselineAssumption?: string | null, baselineEvidence: string, customBaselineConcept?: boolean | null, solutionReducesConsumption?: boolean | null, solutionReducesGhgFactor?: boolean | null, solutionConceptName?: string | null, solutionGhgFactor?: number | null, solutionConsumption?: number | null, solutionAssumption?: string | null, solutionEvidence: string, customSolutionConcept?: boolean | null, specificReductionPerUnit?: number | null, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> }>, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> };

export type CompleteImpactFragment = { __typename?: 'ImpactType', id?: number | null, conceptId?: number | null, stakeholder?: string | null, stakeholderCategory?: StakeholderCategoryType | null, isPositive?: boolean | null, theoryOfChange?: string | null, problem?: string | null, problemStatement?: string | null, companyVision?: string | null, targetGroup?: string | null, inputsActivities?: string | null, solutionsOutput?: string | null, shortTermOutcomes?: string | null, longTermImpacts?: string | null, riskReboundEffects?: string | null, euTaxonomy?: EuTaxonomyType | null, initialInvestmentDate?: any | null, startingYear?: number | null, durationYears?: number | null, carryRemarks?: string | null, isEditable: boolean, submitDate?: any | null, hasFrozenOutcome?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, labelI18n: any, description: string, descriptionI18n: any, isSubmeasure: boolean, additionalData?: any | null, sourceUrl: string, citation: string, citationI18n: any, isMaterial: boolean, materialityExplanation: string, materialityExplanationI18n: any, status: ConceptStatus, scheme?: RiskManagementScheme | null, kind?: ConceptKind | null, ixId?: string | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null }>, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, objectLinks: Array<{ __typename?: 'ConceptLinkType', predicate: ConceptPredicateType, object: { __typename?: 'ConceptType', id?: number | null, label: string } }> } | null, sourceAssignments: Array<{ __typename?: 'SourceAssignmentType', id?: number | null, url: string, comment?: string | null }>, impactSolutions: Array<{ __typename?: 'ImpactSolutionType', id?: number | null, impactId: number, targetGroup?: string | null, problemDescription?: string | null, solutionDescription?: string | null, kind?: ImpactSolutionKind | null, ghgSavingPotentialId?: number | null, useGhgSavingPotentialTool?: boolean | null, solutionSource: Array<{ __typename?: 'SolutionSourceType', id?: number | null, url?: string | null, comment?: string | null }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null, ghgSavingPotential?: { __typename?: 'GhgSavingPotentialType', id?: number | null, needFulfilled?: string | null, baselineSolutionDescription?: string | null, comparativeUnit?: string | null, comparativeQuantitiy?: number | null, comparativeUnitConfirmed?: boolean | null, describeComparison?: string | null, isPreciseEmissionCalculation?: boolean | null, simpleBaselineGhg?: number | null, simpleSolutionGhg?: number | null, simpleGhgJustification?: string | null, emissionsConfirmed?: boolean | null, growthFactorJustification?: string | null, isRecurringImpact?: boolean | null, durationOfImpact?: number | null, realisticConfirmation?: boolean | null, impactProfileKind: ImpactProfileKind, isScenarioA?: boolean | null, preComputedBaselineGhg?: number | null, preComputedSolutionGhg?: number | null, scenarioBComments?: string | null, emissionSourceLimitations?: string | null, specificReductionPerUnit?: number | null, specificReductionAsPercentage?: number | null, emissionSources: Array<{ __typename?: 'EmissionSourceType', id?: number | null, ghgSavingPotentialId: number, sourceOfEmission?: string | null, unitName?: string | null, baselineUnitName?: string | null, solutionUnitName?: string | null, baselineConceptName?: string | null, baselineGhgFactor?: number | null, baselineConsumption?: number | null, baselineAssumption?: string | null, baselineEvidence: string, customBaselineConcept?: boolean | null, solutionReducesConsumption?: boolean | null, solutionReducesGhgFactor?: boolean | null, solutionConceptName?: string | null, solutionGhgFactor?: number | null, solutionConsumption?: number | null, solutionAssumption?: string | null, solutionEvidence: string, customSolutionConcept?: boolean | null, specificReductionPerUnit?: number | null, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> }>, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> } | null }>, sdgs: Array<{ __typename?: 'SdgType', id?: number | null, label: string, sublabel: string }>, sdgTargets: Array<{ __typename?: 'SdgTargetType', id?: number | null, label: string, sdgId?: number | null }>, irisCategories: Array<{ __typename?: 'IrisCategoryType', id?: number | null, label: string }>, geographies: Array<{ __typename?: 'GeographyType', id?: number | null, label: string }>, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, metricNameOverride: string, comment?: string | null, reportingPeriodType: MetricReportingPeriodType, isFrozen: boolean, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> };

export type CompleteImpactGoalFragment = { __typename?: 'ImpactGoalType', id?: number | null, ventureId: any, isEditable: boolean, activityUrls: Array<string>, ghgStartingYear: number, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, conceptId?: number | null, stakeholder?: string | null, stakeholderCategory?: StakeholderCategoryType | null, isPositive?: boolean | null, theoryOfChange?: string | null, problem?: string | null, problemStatement?: string | null, companyVision?: string | null, targetGroup?: string | null, inputsActivities?: string | null, solutionsOutput?: string | null, shortTermOutcomes?: string | null, longTermImpacts?: string | null, riskReboundEffects?: string | null, euTaxonomy?: EuTaxonomyType | null, initialInvestmentDate?: any | null, startingYear?: number | null, durationYears?: number | null, carryRemarks?: string | null, isEditable: boolean, submitDate?: any | null, hasFrozenOutcome?: boolean | null, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, ghgSavingPotentialId?: number | null, metricNameOverride: string, comment?: string | null, reportingPeriodType: MetricReportingPeriodType, isFrozen: boolean, customTargetWeight: number, unitName: string, customTargetCalculationType: AnnualAggregationMethod, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, labelI18n: any, description: string, descriptionI18n: any, isSubmeasure: boolean, additionalData?: any | null, sourceUrl: string, citation: string, citationI18n: any, isMaterial: boolean, materialityExplanation: string, materialityExplanationI18n: any, status: ConceptStatus, scheme?: RiskManagementScheme | null, kind?: ConceptKind | null, ixId?: string | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null }>, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, objectLinks: Array<{ __typename?: 'ConceptLinkType', predicate: ConceptPredicateType, object: { __typename?: 'ConceptType', id?: number | null, label: string } }> } | null, sourceAssignments: Array<{ __typename?: 'SourceAssignmentType', id?: number | null, url: string, comment?: string | null }>, impactSolutions: Array<{ __typename?: 'ImpactSolutionType', id?: number | null, impactId: number, targetGroup?: string | null, problemDescription?: string | null, solutionDescription?: string | null, kind?: ImpactSolutionKind | null, ghgSavingPotentialId?: number | null, useGhgSavingPotentialTool?: boolean | null, solutionSource: Array<{ __typename?: 'SolutionSourceType', id?: number | null, url?: string | null, comment?: string | null }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null, ghgSavingPotential?: { __typename?: 'GhgSavingPotentialType', id?: number | null, needFulfilled?: string | null, baselineSolutionDescription?: string | null, comparativeUnit?: string | null, comparativeQuantitiy?: number | null, comparativeUnitConfirmed?: boolean | null, describeComparison?: string | null, isPreciseEmissionCalculation?: boolean | null, simpleBaselineGhg?: number | null, simpleSolutionGhg?: number | null, simpleGhgJustification?: string | null, emissionsConfirmed?: boolean | null, growthFactorJustification?: string | null, isRecurringImpact?: boolean | null, durationOfImpact?: number | null, realisticConfirmation?: boolean | null, impactProfileKind: ImpactProfileKind, isScenarioA?: boolean | null, preComputedBaselineGhg?: number | null, preComputedSolutionGhg?: number | null, scenarioBComments?: string | null, emissionSourceLimitations?: string | null, specificReductionPerUnit?: number | null, specificReductionAsPercentage?: number | null, emissionSources: Array<{ __typename?: 'EmissionSourceType', id?: number | null, ghgSavingPotentialId: number, sourceOfEmission?: string | null, unitName?: string | null, baselineUnitName?: string | null, solutionUnitName?: string | null, baselineConceptName?: string | null, baselineGhgFactor?: number | null, baselineConsumption?: number | null, baselineAssumption?: string | null, baselineEvidence: string, customBaselineConcept?: boolean | null, solutionReducesConsumption?: boolean | null, solutionReducesGhgFactor?: boolean | null, solutionConceptName?: string | null, solutionGhgFactor?: number | null, solutionConsumption?: number | null, solutionAssumption?: string | null, solutionEvidence: string, customSolutionConcept?: boolean | null, specificReductionPerUnit?: number | null, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> }>, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> } | null }>, sdgs: Array<{ __typename?: 'SdgType', id?: number | null, label: string, sublabel: string }>, sdgTargets: Array<{ __typename?: 'SdgTargetType', id?: number | null, label: string, sdgId?: number | null }>, irisCategories: Array<{ __typename?: 'IrisCategoryType', id?: number | null, label: string }>, geographies: Array<{ __typename?: 'GeographyType', id?: number | null, label: string }> }>, targetProgress: { __typename?: 'ImpactGoalProgressType', id: number, hasTarget: boolean, startDate?: number | null, endDate?: number | null, completionRate?: number | null, message?: string | null } };

export type CompleteImpactSolutionFragment = { __typename?: 'ImpactSolutionType', id?: number | null, impactId: number, targetGroup?: string | null, problemDescription?: string | null, solutionDescription?: string | null, kind?: ImpactSolutionKind | null, ghgSavingPotentialId?: number | null, useGhgSavingPotentialTool?: boolean | null, solutionSource: Array<{ __typename?: 'SolutionSourceType', id?: number | null, url?: string | null, comment?: string | null }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null, ghgSavingPotential?: { __typename?: 'GhgSavingPotentialType', id?: number | null, needFulfilled?: string | null, baselineSolutionDescription?: string | null, comparativeUnit?: string | null, comparativeQuantitiy?: number | null, comparativeUnitConfirmed?: boolean | null, describeComparison?: string | null, isPreciseEmissionCalculation?: boolean | null, simpleBaselineGhg?: number | null, simpleSolutionGhg?: number | null, simpleGhgJustification?: string | null, emissionsConfirmed?: boolean | null, growthFactorJustification?: string | null, isRecurringImpact?: boolean | null, durationOfImpact?: number | null, realisticConfirmation?: boolean | null, impactProfileKind: ImpactProfileKind, isScenarioA?: boolean | null, preComputedBaselineGhg?: number | null, preComputedSolutionGhg?: number | null, scenarioBComments?: string | null, emissionSourceLimitations?: string | null, specificReductionPerUnit?: number | null, specificReductionAsPercentage?: number | null, emissionSources: Array<{ __typename?: 'EmissionSourceType', id?: number | null, ghgSavingPotentialId: number, sourceOfEmission?: string | null, unitName?: string | null, baselineUnitName?: string | null, solutionUnitName?: string | null, baselineConceptName?: string | null, baselineGhgFactor?: number | null, baselineConsumption?: number | null, baselineAssumption?: string | null, baselineEvidence: string, customBaselineConcept?: boolean | null, solutionReducesConsumption?: boolean | null, solutionReducesGhgFactor?: boolean | null, solutionConceptName?: string | null, solutionGhgFactor?: number | null, solutionConsumption?: number | null, solutionAssumption?: string | null, solutionEvidence: string, customSolutionConcept?: boolean | null, specificReductionPerUnit?: number | null, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> }>, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> } | null };

export type CompleteMetricFragment = { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> };

export type CompleteMetricAggregationFragment = { __typename?: 'MetricAggregationType', id?: number | null, comment?: string | null, calculationType: MetricCalculationType, groupId?: number | null, groupType?: TypeAggregationGroup | null, metricAggregationValues: Array<{ __typename?: 'MetricAggregationValueType', period: string, actual?: number | null, target?: number | null }>, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricAssignments?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, metricNameOverride: string, comment?: string | null, isFrozen: boolean, assigneeId?: any | null, goalTarget?: number | null, goalType?: string | null, reportingPeriodType: MetricReportingPeriodType, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null, funds: Array<{ __typename?: 'FundType', id?: number | null, name?: string | null }>, sfdrStrategies: Array<{ __typename?: 'SfdrStrategyType', id?: number | null, kind: SfdrStrategyKind, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }> };

export type CompleteMetricAssignmentFragment = { __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null };

export type CompleteMetricValueFragment = { __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null };

export type CompleteQuestionnaireComparisonFragment = { __typename?: 'QuestionnaireComparisonType', firstQuestionnaireId?: number | null, secondQuestionnaireId?: number | null, commentE?: string | null, commentS?: string | null, commentG?: string | null };

export type CompleteReferencePeriodFragment = { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null };

export type CompleteSolutionSourceFragment = { __typename?: 'SolutionSourceType', id?: number | null, url?: string | null, comment?: string | null, impactSolutionId?: number | null };

export type CompleteTargetParametersFragment = { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null };

export type CompleteTargetProgressFragment = { __typename?: 'ImpactGoalProgressType', id: number, hasTarget: boolean, startDate?: number | null, endDate?: number | null, completionRate?: number | null, message?: string | null };

export type CompleteUserInputFragment = { __typename?: 'UserInputType', id?: number | null, isActive: boolean, isNotRelevant?: boolean | null, geographyIds?: Array<number> | null, text?: string | null, scoringRule?: any | null, question: { __typename?: 'QuestionType', id?: number | null, label: string, component: string }, selectedOptions?: Array<{ __typename?: 'OptionType', id?: number | null, label?: string | null }> | null, selectedConcepts: Array<{ __typename?: 'UserInputConceptLinkType', implementationStatus: ImplementationStatus, comment: string, userInputId?: number | null, conceptId?: number | null, concept: { __typename?: 'ConceptType', id?: number | null, label: string, scheme?: RiskManagementScheme | null, description: string, isSubmeasure: boolean } }> };

export type CompleteUserInputConceptLinkFragment = { __typename?: 'UserInputConceptLinkType', implementationStatus: ImplementationStatus, comment: string, userInputId?: number | null, conceptId?: number | null, concept: { __typename?: 'ConceptType', id?: number | null, label: string, scheme?: RiskManagementScheme | null, description: string, isSubmeasure: boolean } };

export type IroLinkFragment = { __typename?: 'IroSectionLinkType', id: any, iroId: any, sectionId: number, iro: { __typename?: 'IROType', id: any, name: string, type: EnumIroType, description: string, accountId: any, activityId?: any | null, likelihood?: number | null, severity?: number | null, scale?: number | null, scope?: number | null, irremediability?: number | null, status?: EnumIroStatus | null } };

export type QuestionnaireFragmentFragment = { __typename?: 'QuestionnaireAssignmentType', id?: number | null, isEditable: boolean, updatedAt?: any | null, period?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null } | null, userInputs: Array<{ __typename?: 'UserInputType', id?: number | null, isActive: boolean, isNotRelevant?: boolean | null, geographyIds?: Array<number> | null, text?: string | null, scoringRule?: any | null, question: { __typename?: 'QuestionType', id?: number | null, label: string, component: string }, selectedOptions?: Array<{ __typename?: 'OptionType', id?: number | null, label?: string | null }> | null, selectedConcepts: Array<{ __typename?: 'UserInputConceptLinkType', implementationStatus: ImplementationStatus, comment: string, userInputId?: number | null, conceptId?: number | null, concept: { __typename?: 'ConceptType', id?: number | null, label: string, scheme?: RiskManagementScheme | null, description: string, isSubmeasure: boolean } }> }>, sectionCompletion: Array<{ __typename?: 'SectionCompletionType', sectionId: number, isCompleted: boolean, percentageCompleted: number, numberRequired: number, numberIncomplete: number, incompleteQuestions: Array<string> }>, questionnaireResults: Array<{ __typename?: 'QuestionnaireResultType', id?: number | null, sectionId?: number | null, sectionLabel: string, score?: number | null, details?: any | null }> };

export type ShortImpactFragment = { __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null };

export type BasicInfoPortfolioFragment = { __typename?: 'AccountType', id: any, type: AccountCategory, name?: string | null, logo?: string | null, modules?: Array<Module> | null, countries?: Array<string> | null, nace?: Array<string> | null, website?: string | null, nameOfFinancialMarketParticipant: string, legalEntityIdentifier: string, sustainabilityRiskIntegration: string, remunerationPolicies: string, subsidiaries: Array<string>, entityLevelPaiConsideration: string, csrdLikelihoodThreshold?: number | null, csrdMagnitudeThreshold?: number | null, csrdThresholdReason?: string | null, hiddenKpis?: Array<number> | null, csrdNImpactLikelihoodThreshold?: number | null, csrdNImpactSeverityThreshold?: number | null, csrdNImpactThresholdReason?: string | null, csrdPImpactLikelihoodThreshold?: number | null, csrdPImpactScopeThreshold?: number | null, csrdPImpactThresholdReason?: string | null, reportingPeriodType: MetricReportingPeriodType, defaultReferencePeriods: Array<string>, requireImpactSubmission?: boolean | null };

export type CompletePortfolioFragment = { __typename?: 'AccountType', id: any, type: AccountCategory, name?: string | null, logo?: string | null, modules?: Array<Module> | null, countries?: Array<string> | null, nace?: Array<string> | null, website?: string | null, nameOfFinancialMarketParticipant: string, legalEntityIdentifier: string, sustainabilityRiskIntegration: string, remunerationPolicies: string, subsidiaries: Array<string>, entityLevelPaiConsideration: string, csrdLikelihoodThreshold?: number | null, csrdMagnitudeThreshold?: number | null, csrdThresholdReason?: string | null, hiddenKpis?: Array<number> | null, csrdNImpactLikelihoodThreshold?: number | null, csrdNImpactSeverityThreshold?: number | null, csrdNImpactThresholdReason?: string | null, csrdPImpactLikelihoodThreshold?: number | null, csrdPImpactScopeThreshold?: number | null, csrdPImpactThresholdReason?: string | null, reportingPeriodType: MetricReportingPeriodType, defaultReferencePeriods: Array<string>, requireImpactSubmission?: boolean | null, ventureLinks?: Array<{ __typename?: 'PortfolioVentureLinkType', id: string, portfolioId: any, ventureId: any, modules: Array<Module>, groupNames: Array<string>, groupIds?: Array<number> | null, comment?: string | null, venture?: { __typename?: 'AccountType', id: any, name?: string | null, logo?: string | null, website?: string | null } | null, portfolio?: { __typename?: 'AccountType', id: any, name?: string | null, reportingPeriodType: MetricReportingPeriodType } | null }> | null, funds?: Array<{ __typename?: 'FundType', id?: number | null, name?: string | null, volume?: number | null, fundStrategy?: FundStrategy | null, isReportingPais: boolean, isConsideringPais?: IsConsideringPais | null, investmentPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, startDate?: any | null, endDate?: any | null } | null }> | null };

export type CompletePortfolioGroupFragment = { __typename?: 'PortfolioGroupType', id?: number | null, label: string };

export type CompletePortfolioVentureLinkFragment = { __typename?: 'PortfolioVentureLinkType', id: string, portfolioId: any, ventureId: any, modules: Array<Module>, groupNames: Array<string>, groupIds?: Array<number> | null, comment?: string | null, venture?: { __typename?: 'AccountType', id: any, name?: string | null, logo?: string | null, website?: string | null } | null, portfolio?: { __typename?: 'AccountType', id: any, name?: string | null, reportingPeriodType: MetricReportingPeriodType } | null };

export type BasicFundFragment = { __typename?: 'FundType', id?: number | null, name?: string | null, volume?: number | null, ventureIds?: Array<any> | null, fundStrategy?: FundStrategy | null, portfolio?: { __typename?: 'AccountType', id: any, type: AccountCategory, name?: string | null, logo?: string | null, modules?: Array<Module> | null, countries?: Array<string> | null, nace?: Array<string> | null, website?: string | null, nameOfFinancialMarketParticipant: string, legalEntityIdentifier: string, sustainabilityRiskIntegration: string, remunerationPolicies: string, subsidiaries: Array<string>, entityLevelPaiConsideration: string, csrdLikelihoodThreshold?: number | null, csrdMagnitudeThreshold?: number | null, csrdThresholdReason?: string | null, hiddenKpis?: Array<number> | null, csrdNImpactLikelihoodThreshold?: number | null, csrdNImpactSeverityThreshold?: number | null, csrdNImpactThresholdReason?: string | null, csrdPImpactLikelihoodThreshold?: number | null, csrdPImpactScopeThreshold?: number | null, csrdPImpactThresholdReason?: string | null, reportingPeriodType: MetricReportingPeriodType, defaultReferencePeriods: Array<string>, requireImpactSubmission?: boolean | null } | null };

export type CompleteFundFragment = { __typename?: 'FundType', id?: number | null, name?: string | null, legalEntityIdentifier?: string | null, volume?: number | null, fundStrategy?: FundStrategy | null, isReportingPais: boolean, isReportingKfw: boolean, minimumReportingLevelVentureIds?: Array<any> | null, recommendedReportingLevelVentureIds?: Array<any> | null, fullReportingLevelVentureIds?: Array<any> | null, isConsideringPais?: IsConsideringPais | null, notConsideringPaisReason?: string | null, ventureIds?: Array<any> | null, investmentStrategy?: string | null, bindingElementsOfInvestmentStrategy?: string | null, minimumRateToReduceScope?: string | null, companyGovernancePolicy?: string | null, fundSpecificInfo?: string | null, socialMetricIds: Array<number>, environmentalMetricIds: Array<number>, generalMetricIds: Array<number>, paiSelectionMethodologies: string, paiPolicyAdministration: string, considerationOfPaisOnSustainabilityEngagementPolicies: string, considerationOfPaisOnSustainabilityInternationalStandards: string, isConsideringSustainabilityRisk?: boolean | null, sustainabilityRiskIntegrationDescription?: string | null, likelyImpactsFromSustainabilityRisk?: string | null, reasonNotConsideringSustainabilityRisk?: string | null, entitySustainabilityExtraInfo?: string | null, paiAggregationGroup?: TypeAggregationGroup | null, esCharacteristicsPromoted?: EsCharacteristicsPromoted | null, assetAllocationTargets: { __typename?: 'AssetAllocationTargetsType', percentEnvironmental?: number | null, percentEnvironmentalTaxonomyAligned?: number | null, percentEnvironmentalNotTaxonomyAligned?: number | null, percentSocial?: number | null, percentSustainable?: number | null, percentTaxonomyAlignedFossil?: number | null, percentTaxonomyAlignedNuclear?: number | null, percentTaxonomyAlignedEnabling?: number | null, percentTaxonomyAlignedTransitional?: number | null }, socialMetrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, environmentalMetrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, generalMetrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, investmentPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null, sustainableObjectives: Array<{ __typename?: 'SfdrStrategyType', id?: number | null, kind: SfdrStrategyKind, benchmarkDescription?: string | null, actionsTaken?: string | null, metricIds: Array<number>, strategyDescription?: string | null, isEnvironmentalGoal: boolean, isCo2EmissionGoal?: boolean | null, doCheckEuTaxonomyAlignment?: boolean | null, ventureIds?: Array<any> | null, esStrategy: Array<EsCharacteristicStrategy>, esCharacteristicsDescription?: string | null, esgIntegrationDescription?: string | null, exclusionCriteriaDescription?: string | null, bestInClassDescription?: string | null, normBasedScreeningDescription?: string | null, sustainabilityLabelDescription?: string | null, isIndexDesignated?: boolean | null, sustainablyAlignedIndexExplanation?: string | null, investmentAlignedIndexExplanation?: string | null, broadMarketIndexComparison?: string | null, indexCalculationMethodology?: string | null, sustainabilityIndicatorsMonitoringStrategy: string, entityResponsibleForMonitoringIndicators: string, isConsideringSourcesAndEstimates: boolean, dataSourcesConsidered: string, shareOfDataSecondHand: string, dueDiligenceProcessDescription: string, engagementPolicyWithSpecificInvestmentStrategy: string, metrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null, euTaxonomyConcept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null }>, esCharacteristics: { __typename?: 'SfdrStrategyType', id?: number | null, kind: SfdrStrategyKind, benchmarkDescription?: string | null, actionsTaken?: string | null, metricIds: Array<number>, strategyDescription?: string | null, isEnvironmentalGoal: boolean, isCo2EmissionGoal?: boolean | null, doCheckEuTaxonomyAlignment?: boolean | null, ventureIds?: Array<any> | null, esStrategy: Array<EsCharacteristicStrategy>, esCharacteristicsDescription?: string | null, esgIntegrationDescription?: string | null, exclusionCriteriaDescription?: string | null, bestInClassDescription?: string | null, normBasedScreeningDescription?: string | null, sustainabilityLabelDescription?: string | null, isIndexDesignated?: boolean | null, sustainablyAlignedIndexExplanation?: string | null, investmentAlignedIndexExplanation?: string | null, broadMarketIndexComparison?: string | null, indexCalculationMethodology?: string | null, sustainabilityIndicatorsMonitoringStrategy: string, entityResponsibleForMonitoringIndicators: string, isConsideringSourcesAndEstimates: boolean, dataSourcesConsidered: string, shareOfDataSecondHand: string, dueDiligenceProcessDescription: string, engagementPolicyWithSpecificInvestmentStrategy: string, metrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null, euTaxonomyConcept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null }, periodicAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, paiAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, precontractualAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, fundWebsiteDisclosureAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, entityWebsiteDisclosureAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, paiReport?: { __typename?: 'UserInputPaiReportType', considerationOfPaisOnSustainabilityDescription?: string | null, considerationOfPaisOnSustainabilityEngagementPolicies?: string | null, considerationOfPaisOnSustainabilityInternationalStandards?: string | null, considerationOfPaisOnSustainabilityHistoricalComparison?: string | null, howDidProductConsiderPais?: string | null, principalAdverseImpactsExplanationsAndActions: any, summaryOfPais?: string | null } | null, precontractualReport?: { __typename?: 'UserInputPrecontractualReportType', sustainableObjectiveTree?: string | null, wereObjectivesMet?: string | null, esCharacteristicsDescription?: string | null, sustainabilityIndicatorsPerformanceDescription?: string | null, sustainableInvestmentsMadeByFund?: string | null, howDidInvestmentsNotCauseHarm?: string | null, accountOnPais?: string | null, alignmentWithOecdGuidelines?: string | null, investmentStrategy?: string | null, bindingElementsOfInvestmentStrategy?: string | null, companyGovernancePolicy?: string | null, howDidProductConsiderPais?: string | null, sustainabilityRelatedInvestmentAssetAllocation?: string | null, sustainableInvestmentsWithEnvironmentalObjectiveEuTaxonomyAlignment?: string | null, fossilOrNuclear?: string | null, shareOfInvestmentsInTransitionalAndEnablingActivities?: string | null, shareOfSustainableInvestmentsWithEnvironmentalObjectiveNonEuTaxonomyAligned?: string | null, shareOfSociallySustainableInvestments?: string | null, purposeOfOtherOrNotSustainableInvestmentsIncludingSafeguards?: string | null, productPerformanceComparison?: string | null, sustainablyAlignedIndexExplanation?: string | null, investmentAlignedIndexExplanation?: string | null, broadMarketIndexComparison?: string | null, indexCalculationMethodology?: string | null, fundSpecificInfo?: string | null, whyDidProductConsiderPais?: string | null, useOfDerivatives?: string | null } | null };

export type CompleteReportAnswerFragment = { __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null };

export type CompleteSfdrStrategyFragment = { __typename?: 'SfdrStrategyType', id?: number | null, kind: SfdrStrategyKind, benchmarkDescription?: string | null, actionsTaken?: string | null, metricIds: Array<number>, strategyDescription?: string | null, isEnvironmentalGoal: boolean, isCo2EmissionGoal?: boolean | null, doCheckEuTaxonomyAlignment?: boolean | null, ventureIds?: Array<any> | null, esStrategy: Array<EsCharacteristicStrategy>, esCharacteristicsDescription?: string | null, esgIntegrationDescription?: string | null, exclusionCriteriaDescription?: string | null, bestInClassDescription?: string | null, normBasedScreeningDescription?: string | null, sustainabilityLabelDescription?: string | null, isIndexDesignated?: boolean | null, sustainablyAlignedIndexExplanation?: string | null, investmentAlignedIndexExplanation?: string | null, broadMarketIndexComparison?: string | null, indexCalculationMethodology?: string | null, sustainabilityIndicatorsMonitoringStrategy: string, entityResponsibleForMonitoringIndicators: string, isConsideringSourcesAndEstimates: boolean, dataSourcesConsidered: string, shareOfDataSecondHand: string, dueDiligenceProcessDescription: string, engagementPolicyWithSpecificInvestmentStrategy: string, metrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null, euTaxonomyConcept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null };

export type BaseQuestionFragment = { __typename?: 'QuestionType', id?: number | null, ixId?: string | null, component: string, label: string, sublabel?: string | null, tooltip?: string | null, scoringRules?: any | null, isMultiple?: boolean | null, isMandatory: boolean, createdAt: any, updatedAt?: any | null };

export type CompleteQuestionFragment = { __typename?: 'QuestionType', id?: number | null, ixId?: string | null, component: string, tooltip?: string | null, tooltipI18n: any, label: string, labelI18n: any, sublabel?: string | null, sublabelI18n: any, isMultiple?: boolean | null, isMandatory: boolean, scoringRules?: any | null, templateEngineContext?: TemplateEngineContext | null };

export type PromptTemplateFragment = { __typename?: 'PromptTemplateType', id?: any | null, questionId: number, ixId: string, purpose?: string | null, latestVersionId?: any | null, isActive?: boolean | null, createdBy?: string | null };

export type PromptTemplateVersionFragment = { __typename?: 'PromptTemplateVersionType', id?: any | null, promptTemplateId: any, version: number, systemTemplate?: string | null, userTemplate: string, inputSchema?: any | null, outputSchema?: any | null, model: string, params?: any | null, notes?: string | null, createdBy?: string | null, createdAt: any, appendCompanyWebsiteScrape?: boolean | null };

export type AddMetricAndAssignmentBatchMutationVariables = Exact<{
  metric: MetricInput;
  assigneeIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type AddMetricAndAssignmentBatchMutation = { __typename?: 'ComboMutation', addMetricAndAssignmentBatch: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, metricId: number }> };

export type AddMetricAssignmentBatchMutationVariables = Exact<{
  inputs: Array<MetricAssignmentInput> | MetricAssignmentInput;
}>;


export type AddMetricAssignmentBatchMutation = { __typename?: 'ComboMutation', addMetricAssignmentBatch: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, metric?: { __typename?: 'MetricType', id?: number | null } | null }> };

export type AddMetricMetricLinkMutationVariables = Exact<{
  parentId: Scalars['Int']['input'];
  childrenId: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type AddMetricMetricLinkMutation = { __typename?: 'ComboMutation', addMetricMetricLink: boolean };

export type DeleteMetricAggregationMutationVariables = Exact<{
  metricAggregationId: Scalars['Int']['input'];
}>;


export type DeleteMetricAggregationMutation = { __typename: 'ComboMutation', deleteMetricAggregation: boolean };

export type DeleteMetricAssignmentMutationVariables = Exact<{
  metricAssignmentId: Scalars['Int']['input'];
}>;


export type DeleteMetricAssignmentMutation = { __typename: 'ComboMutation', deleteMetricAssignment: boolean };

export type AddIroMutationVariables = Exact<{
  iro: IroInput;
}>;


export type AddIroMutation = { __typename?: 'ComboMutation', addIro: { __typename?: 'IROType', id: any, name: string, type: EnumIroType, description: string, accountId: any, activityId?: any | null, likelihood?: number | null, severity?: number | null, scale?: number | null, scope?: number | null, irremediability?: number | null } };

export type DeleteIroMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteIroMutation = { __typename?: 'ComboMutation', deleteIro: boolean };

export type UpdateIroMutationVariables = Exact<{
  iro: IroInput;
}>;


export type UpdateIroMutation = { __typename?: 'ComboMutation', updateIro: { __typename?: 'IROType', id: any, name: string, type: EnumIroType, description: string, accountId: any, activityId?: any | null, levelOfImpact?: EnumIroLevelOfImpact | null, likelihood?: number | null, likelihoodReason?: string | null, magnitude?: number | null, magnitudeReason?: string | null, finalSeverity?: number | null, severity?: number | null, severityReason?: string | null, scale?: number | null, scope?: number | null, irremediability?: number | null, overrideStatus?: EnumIroOverrideStatus | null, overrideReason?: string | null, finalAssessmentReason?: string | null, status?: EnumIroStatus | null } };

export type OneTimeNotificationMutationVariables = Exact<{
  input: NotificationInput;
}>;


export type OneTimeNotificationMutation = { __typename?: 'ComboMutation', oneTimeNotification: boolean };

export type UpdateKfwReportingMutationVariables = Exact<{
  input: FundInput;
}>;


export type UpdateKfwReportingMutation = { __typename?: 'ComboMutation', updateFund: { __typename?: 'FundType', id?: number | null, minimumReportingLevelVentureIds?: Array<any> | null, recommendedReportingLevelVentureIds?: Array<any> | null, fullReportingLevelVentureIds?: Array<any> | null, isInSync: boolean, syncState: { __typename?: 'SyncState', assignmentsToAdd: Array<{ __typename?: 'MetricAssignmentInfo', metricId: number, fundId?: number | null, conceptId?: number | null, why: string, metric: { __typename?: 'MetricType', name: string } }>, fundAssignmentsToAdd: Array<{ __typename?: 'MetricAssignmentInfo', metricId: number, fundId?: number | null, conceptId?: number | null, why: string, metric: { __typename?: 'MetricType', name: string } }>, fundAggregationsToAdd: Array<{ __typename?: 'MetricAggregationInfo', metricId: number, groupType: TypeAggregationGroup, groupId: number, why: string, metric: { __typename?: 'MetricType', name: string } }>, fundAggregationsToDelete: Array<{ __typename?: 'MetricAggregationInfo', metricId: number, groupType: TypeAggregationGroup, groupId: number, why: string, metric: { __typename?: 'MetricType', name: string } }> } } };

export type UpdateMetricAggregationMutationVariables = Exact<{
  input: MetricAggregationInput;
}>;


export type UpdateMetricAggregationMutation = { __typename?: 'ComboMutation', updateMetricAggregation: { __typename?: 'MetricAggregationType', id?: number | null, comment?: string | null, calculationType: MetricCalculationType, groupId?: number | null, groupType?: TypeAggregationGroup | null, metricAggregationValues: Array<{ __typename?: 'MetricAggregationValueType', period: string, actual?: number | null, target?: number | null }>, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricAssignments?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, metricNameOverride: string, comment?: string | null, isFrozen: boolean, assigneeId?: any | null, goalTarget?: number | null, goalType?: string | null, reportingPeriodType: MetricReportingPeriodType, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null, funds: Array<{ __typename?: 'FundType', id?: number | null, name?: string | null }>, sfdrStrategies: Array<{ __typename?: 'SfdrStrategyType', id?: number | null, kind: SfdrStrategyKind, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }> } };

export type UpdateMetricAssignmentMutationVariables = Exact<{
  input: MetricAssignmentInput;
}>;


export type UpdateMetricAssignmentMutation = { __typename?: 'ComboMutation', updateMetricAssignment: { __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null } };

export type UpsertMetricMutationVariables = Exact<{
  input: MetricInput;
}>;


export type UpsertMetricMutation = { __typename?: 'ComboMutation', upsertMetric: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } };

export type UpsertMetricValuesMutationVariables = Exact<{
  inputs: Array<MetricValueInput> | MetricValueInput;
}>;


export type UpsertMetricValuesMutation = { __typename?: 'ComboMutation', upsertMetricValues: Array<{ __typename?: 'MetricValueType', id: string, period: string, actual?: number | null, target?: number | null, text?: string | null, options?: Array<string> | null, comment?: string | null, metricAssignmentId: number, createdBy?: string | null, targetLocked: boolean, actualLocked: boolean, skipped: boolean }> };

export type UpsertReferencePeriodMutationVariables = Exact<{
  input: ReferencePeriodInput;
}>;


export type UpsertReferencePeriodMutation = { __typename?: 'ComboMutation', upsertReferencePeriod: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } };

export type AddAccountMutationVariables = Exact<{
  account: AccountInput;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type AddAccountMutation = { __typename?: 'ComboMutation', addAccount: { __typename?: 'AccountType', id: any } };

export type AddFundMutationVariables = Exact<{
  input?: InputMaybe<FundInput>;
}>;


export type AddFundMutation = { __typename?: 'ComboMutation', addFund: { __typename?: 'AccountType', id: any, type: AccountCategory, name?: string | null, logo?: string | null, modules?: Array<Module> | null, countries?: Array<string> | null, nace?: Array<string> | null, website?: string | null, nameOfFinancialMarketParticipant: string, legalEntityIdentifier: string, sustainabilityRiskIntegration: string, remunerationPolicies: string, subsidiaries: Array<string>, entityLevelPaiConsideration: string, csrdLikelihoodThreshold?: number | null, csrdMagnitudeThreshold?: number | null, csrdThresholdReason?: string | null, hiddenKpis?: Array<number> | null, csrdNImpactLikelihoodThreshold?: number | null, csrdNImpactSeverityThreshold?: number | null, csrdNImpactThresholdReason?: string | null, csrdPImpactLikelihoodThreshold?: number | null, csrdPImpactScopeThreshold?: number | null, csrdPImpactThresholdReason?: string | null, reportingPeriodType: MetricReportingPeriodType, defaultReferencePeriods: Array<string>, requireImpactSubmission?: boolean | null, ventureLinks?: Array<{ __typename?: 'PortfolioVentureLinkType', id: string, portfolioId: any, ventureId: any, modules: Array<Module>, groupNames: Array<string>, groupIds?: Array<number> | null, comment?: string | null, venture?: { __typename?: 'AccountType', id: any, name?: string | null, logo?: string | null, website?: string | null } | null, portfolio?: { __typename?: 'AccountType', id: any, name?: string | null, reportingPeriodType: MetricReportingPeriodType } | null }> | null, funds?: Array<{ __typename?: 'FundType', id?: number | null, name?: string | null, volume?: number | null, fundStrategy?: FundStrategy | null, isReportingPais: boolean, isConsideringPais?: IsConsideringPais | null, investmentPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, startDate?: any | null, endDate?: any | null } | null }> | null } };

export type AddPortfolioVentureLinkMutationVariables = Exact<{
  portfolioId: Scalars['UUID']['input'];
  ventureIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type AddPortfolioVentureLinkMutation = { __typename?: 'ComboMutation', addPortfolioVentureLink: Array<{ __typename?: 'PortfolioVentureLinkType', ventureId: any }> };

export type AddReportAnswerMutationVariables = Exact<{
  input: ReportAnswerInput;
}>;


export type AddReportAnswerMutation = { __typename?: 'ComboMutation', addReportAnswer: { __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null } };

export type AddSfdrStrategyMutationVariables = Exact<{
  input: SfdrStrategyInput;
}>;


export type AddSfdrStrategyMutation = { __typename?: 'ComboMutation', addSfdrStrategy: { __typename?: 'FundType', id?: number | null, name?: string | null, legalEntityIdentifier?: string | null, volume?: number | null, fundStrategy?: FundStrategy | null, isReportingPais: boolean, isReportingKfw: boolean, minimumReportingLevelVentureIds?: Array<any> | null, recommendedReportingLevelVentureIds?: Array<any> | null, fullReportingLevelVentureIds?: Array<any> | null, isConsideringPais?: IsConsideringPais | null, notConsideringPaisReason?: string | null, ventureIds?: Array<any> | null, investmentStrategy?: string | null, bindingElementsOfInvestmentStrategy?: string | null, minimumRateToReduceScope?: string | null, companyGovernancePolicy?: string | null, fundSpecificInfo?: string | null, socialMetricIds: Array<number>, environmentalMetricIds: Array<number>, generalMetricIds: Array<number>, paiSelectionMethodologies: string, paiPolicyAdministration: string, considerationOfPaisOnSustainabilityEngagementPolicies: string, considerationOfPaisOnSustainabilityInternationalStandards: string, isConsideringSustainabilityRisk?: boolean | null, sustainabilityRiskIntegrationDescription?: string | null, likelyImpactsFromSustainabilityRisk?: string | null, reasonNotConsideringSustainabilityRisk?: string | null, entitySustainabilityExtraInfo?: string | null, paiAggregationGroup?: TypeAggregationGroup | null, esCharacteristicsPromoted?: EsCharacteristicsPromoted | null, assetAllocationTargets: { __typename?: 'AssetAllocationTargetsType', percentEnvironmental?: number | null, percentEnvironmentalTaxonomyAligned?: number | null, percentEnvironmentalNotTaxonomyAligned?: number | null, percentSocial?: number | null, percentSustainable?: number | null, percentTaxonomyAlignedFossil?: number | null, percentTaxonomyAlignedNuclear?: number | null, percentTaxonomyAlignedEnabling?: number | null, percentTaxonomyAlignedTransitional?: number | null }, socialMetrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, environmentalMetrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, generalMetrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, investmentPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null, sustainableObjectives: Array<{ __typename?: 'SfdrStrategyType', id?: number | null, kind: SfdrStrategyKind, benchmarkDescription?: string | null, actionsTaken?: string | null, metricIds: Array<number>, strategyDescription?: string | null, isEnvironmentalGoal: boolean, isCo2EmissionGoal?: boolean | null, doCheckEuTaxonomyAlignment?: boolean | null, ventureIds?: Array<any> | null, esStrategy: Array<EsCharacteristicStrategy>, esCharacteristicsDescription?: string | null, esgIntegrationDescription?: string | null, exclusionCriteriaDescription?: string | null, bestInClassDescription?: string | null, normBasedScreeningDescription?: string | null, sustainabilityLabelDescription?: string | null, isIndexDesignated?: boolean | null, sustainablyAlignedIndexExplanation?: string | null, investmentAlignedIndexExplanation?: string | null, broadMarketIndexComparison?: string | null, indexCalculationMethodology?: string | null, sustainabilityIndicatorsMonitoringStrategy: string, entityResponsibleForMonitoringIndicators: string, isConsideringSourcesAndEstimates: boolean, dataSourcesConsidered: string, shareOfDataSecondHand: string, dueDiligenceProcessDescription: string, engagementPolicyWithSpecificInvestmentStrategy: string, metrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null, euTaxonomyConcept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null }>, esCharacteristics: { __typename?: 'SfdrStrategyType', id?: number | null, kind: SfdrStrategyKind, benchmarkDescription?: string | null, actionsTaken?: string | null, metricIds: Array<number>, strategyDescription?: string | null, isEnvironmentalGoal: boolean, isCo2EmissionGoal?: boolean | null, doCheckEuTaxonomyAlignment?: boolean | null, ventureIds?: Array<any> | null, esStrategy: Array<EsCharacteristicStrategy>, esCharacteristicsDescription?: string | null, esgIntegrationDescription?: string | null, exclusionCriteriaDescription?: string | null, bestInClassDescription?: string | null, normBasedScreeningDescription?: string | null, sustainabilityLabelDescription?: string | null, isIndexDesignated?: boolean | null, sustainablyAlignedIndexExplanation?: string | null, investmentAlignedIndexExplanation?: string | null, broadMarketIndexComparison?: string | null, indexCalculationMethodology?: string | null, sustainabilityIndicatorsMonitoringStrategy: string, entityResponsibleForMonitoringIndicators: string, isConsideringSourcesAndEstimates: boolean, dataSourcesConsidered: string, shareOfDataSecondHand: string, dueDiligenceProcessDescription: string, engagementPolicyWithSpecificInvestmentStrategy: string, metrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null, euTaxonomyConcept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null }, periodicAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, paiAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, precontractualAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, fundWebsiteDisclosureAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, entityWebsiteDisclosureAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, paiReport?: { __typename?: 'UserInputPaiReportType', considerationOfPaisOnSustainabilityDescription?: string | null, considerationOfPaisOnSustainabilityEngagementPolicies?: string | null, considerationOfPaisOnSustainabilityInternationalStandards?: string | null, considerationOfPaisOnSustainabilityHistoricalComparison?: string | null, howDidProductConsiderPais?: string | null, principalAdverseImpactsExplanationsAndActions: any, summaryOfPais?: string | null } | null, precontractualReport?: { __typename?: 'UserInputPrecontractualReportType', sustainableObjectiveTree?: string | null, wereObjectivesMet?: string | null, esCharacteristicsDescription?: string | null, sustainabilityIndicatorsPerformanceDescription?: string | null, sustainableInvestmentsMadeByFund?: string | null, howDidInvestmentsNotCauseHarm?: string | null, accountOnPais?: string | null, alignmentWithOecdGuidelines?: string | null, investmentStrategy?: string | null, bindingElementsOfInvestmentStrategy?: string | null, companyGovernancePolicy?: string | null, howDidProductConsiderPais?: string | null, sustainabilityRelatedInvestmentAssetAllocation?: string | null, sustainableInvestmentsWithEnvironmentalObjectiveEuTaxonomyAlignment?: string | null, fossilOrNuclear?: string | null, shareOfInvestmentsInTransitionalAndEnablingActivities?: string | null, shareOfSustainableInvestmentsWithEnvironmentalObjectiveNonEuTaxonomyAligned?: string | null, shareOfSociallySustainableInvestments?: string | null, purposeOfOtherOrNotSustainableInvestmentsIncludingSafeguards?: string | null, productPerformanceComparison?: string | null, sustainablyAlignedIndexExplanation?: string | null, investmentAlignedIndexExplanation?: string | null, broadMarketIndexComparison?: string | null, indexCalculationMethodology?: string | null, fundSpecificInfo?: string | null, whyDidProductConsiderPais?: string | null, useOfDerivatives?: string | null } | null } };

export type AssignVenturesToGroupMutationVariables = Exact<{
  groupId: Scalars['Int']['input'];
  ventureIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  groupAssignments: Array<GroupAssignmentType> | GroupAssignmentType;
  deleteOldVentureIds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AssignVenturesToGroupMutation = { __typename?: 'ComboMutation', assignVenturesToGroup: Array<{ __typename?: 'PortfolioVentureLinkType', id: string, portfolioId: any, ventureId: any, modules: Array<Module>, groupNames: Array<string>, groupIds?: Array<number> | null, comment?: string | null, venture?: { __typename?: 'AccountType', id: any, name?: string | null, logo?: string | null, website?: string | null } | null, portfolio?: { __typename?: 'AccountType', id: any, name?: string | null, reportingPeriodType: MetricReportingPeriodType } | null }> };

export type ChangeHiddenKpiSettingsMutationVariables = Exact<{
  portfolioId: Scalars['UUID']['input'];
  hiddenKpis: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type ChangeHiddenKpiSettingsMutation = { __typename?: 'ComboMutation', changeHiddenKpiSettings: { __typename?: 'AccountType', id: any, hiddenKpis?: Array<number> | null } };

export type ChangeReportingPeriodTypeMutationVariables = Exact<{
  portfolioId: Scalars['UUID']['input'];
  reportingPeriodType: MetricReportingPeriodType;
}>;


export type ChangeReportingPeriodTypeMutation = { __typename?: 'ComboMutation', changeReportingPeriodType: { __typename?: 'AccountType', id: any, reportingPeriodType: MetricReportingPeriodType } };

export type DeleteAccountMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  dryRun: Scalars['Boolean']['input'];
}>;


export type DeleteAccountMutation = { __typename?: 'ComboMutation', deleteAccount: boolean };

export type DeleteGroupMutationVariables = Exact<{
  groupId: Scalars['Int']['input'];
}>;


export type DeleteGroupMutation = { __typename?: 'ComboMutation', deleteGroup: { __typename?: 'PortfolioGroupType', id?: number | null, label: string } };

export type DeletePortfolioVentureLinkMutationVariables = Exact<{
  portfolioId: Scalars['UUID']['input'];
  ventureId: Scalars['UUID']['input'];
}>;


export type DeletePortfolioVentureLinkMutation = { __typename?: 'ComboMutation', deletePortfolioVentureLink: boolean };

export type DeleteSfdrStrategyMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteSfdrStrategyMutation = { __typename?: 'ComboMutation', deleteSfdrStrategy: { __typename?: 'FundType', id?: number | null, name?: string | null, legalEntityIdentifier?: string | null, volume?: number | null, fundStrategy?: FundStrategy | null, isReportingPais: boolean, isReportingKfw: boolean, minimumReportingLevelVentureIds?: Array<any> | null, recommendedReportingLevelVentureIds?: Array<any> | null, fullReportingLevelVentureIds?: Array<any> | null, isConsideringPais?: IsConsideringPais | null, notConsideringPaisReason?: string | null, ventureIds?: Array<any> | null, investmentStrategy?: string | null, bindingElementsOfInvestmentStrategy?: string | null, minimumRateToReduceScope?: string | null, companyGovernancePolicy?: string | null, fundSpecificInfo?: string | null, socialMetricIds: Array<number>, environmentalMetricIds: Array<number>, generalMetricIds: Array<number>, paiSelectionMethodologies: string, paiPolicyAdministration: string, considerationOfPaisOnSustainabilityEngagementPolicies: string, considerationOfPaisOnSustainabilityInternationalStandards: string, isConsideringSustainabilityRisk?: boolean | null, sustainabilityRiskIntegrationDescription?: string | null, likelyImpactsFromSustainabilityRisk?: string | null, reasonNotConsideringSustainabilityRisk?: string | null, entitySustainabilityExtraInfo?: string | null, paiAggregationGroup?: TypeAggregationGroup | null, esCharacteristicsPromoted?: EsCharacteristicsPromoted | null, assetAllocationTargets: { __typename?: 'AssetAllocationTargetsType', percentEnvironmental?: number | null, percentEnvironmentalTaxonomyAligned?: number | null, percentEnvironmentalNotTaxonomyAligned?: number | null, percentSocial?: number | null, percentSustainable?: number | null, percentTaxonomyAlignedFossil?: number | null, percentTaxonomyAlignedNuclear?: number | null, percentTaxonomyAlignedEnabling?: number | null, percentTaxonomyAlignedTransitional?: number | null }, socialMetrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, environmentalMetrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, generalMetrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, investmentPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null, sustainableObjectives: Array<{ __typename?: 'SfdrStrategyType', id?: number | null, kind: SfdrStrategyKind, benchmarkDescription?: string | null, actionsTaken?: string | null, metricIds: Array<number>, strategyDescription?: string | null, isEnvironmentalGoal: boolean, isCo2EmissionGoal?: boolean | null, doCheckEuTaxonomyAlignment?: boolean | null, ventureIds?: Array<any> | null, esStrategy: Array<EsCharacteristicStrategy>, esCharacteristicsDescription?: string | null, esgIntegrationDescription?: string | null, exclusionCriteriaDescription?: string | null, bestInClassDescription?: string | null, normBasedScreeningDescription?: string | null, sustainabilityLabelDescription?: string | null, isIndexDesignated?: boolean | null, sustainablyAlignedIndexExplanation?: string | null, investmentAlignedIndexExplanation?: string | null, broadMarketIndexComparison?: string | null, indexCalculationMethodology?: string | null, sustainabilityIndicatorsMonitoringStrategy: string, entityResponsibleForMonitoringIndicators: string, isConsideringSourcesAndEstimates: boolean, dataSourcesConsidered: string, shareOfDataSecondHand: string, dueDiligenceProcessDescription: string, engagementPolicyWithSpecificInvestmentStrategy: string, metrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null, euTaxonomyConcept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null }>, esCharacteristics: { __typename?: 'SfdrStrategyType', id?: number | null, kind: SfdrStrategyKind, benchmarkDescription?: string | null, actionsTaken?: string | null, metricIds: Array<number>, strategyDescription?: string | null, isEnvironmentalGoal: boolean, isCo2EmissionGoal?: boolean | null, doCheckEuTaxonomyAlignment?: boolean | null, ventureIds?: Array<any> | null, esStrategy: Array<EsCharacteristicStrategy>, esCharacteristicsDescription?: string | null, esgIntegrationDescription?: string | null, exclusionCriteriaDescription?: string | null, bestInClassDescription?: string | null, normBasedScreeningDescription?: string | null, sustainabilityLabelDescription?: string | null, isIndexDesignated?: boolean | null, sustainablyAlignedIndexExplanation?: string | null, investmentAlignedIndexExplanation?: string | null, broadMarketIndexComparison?: string | null, indexCalculationMethodology?: string | null, sustainabilityIndicatorsMonitoringStrategy: string, entityResponsibleForMonitoringIndicators: string, isConsideringSourcesAndEstimates: boolean, dataSourcesConsidered: string, shareOfDataSecondHand: string, dueDiligenceProcessDescription: string, engagementPolicyWithSpecificInvestmentStrategy: string, metrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null, euTaxonomyConcept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null }, periodicAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, paiAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, precontractualAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, fundWebsiteDisclosureAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, entityWebsiteDisclosureAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, paiReport?: { __typename?: 'UserInputPaiReportType', considerationOfPaisOnSustainabilityDescription?: string | null, considerationOfPaisOnSustainabilityEngagementPolicies?: string | null, considerationOfPaisOnSustainabilityInternationalStandards?: string | null, considerationOfPaisOnSustainabilityHistoricalComparison?: string | null, howDidProductConsiderPais?: string | null, principalAdverseImpactsExplanationsAndActions: any, summaryOfPais?: string | null } | null, precontractualReport?: { __typename?: 'UserInputPrecontractualReportType', sustainableObjectiveTree?: string | null, wereObjectivesMet?: string | null, esCharacteristicsDescription?: string | null, sustainabilityIndicatorsPerformanceDescription?: string | null, sustainableInvestmentsMadeByFund?: string | null, howDidInvestmentsNotCauseHarm?: string | null, accountOnPais?: string | null, alignmentWithOecdGuidelines?: string | null, investmentStrategy?: string | null, bindingElementsOfInvestmentStrategy?: string | null, companyGovernancePolicy?: string | null, howDidProductConsiderPais?: string | null, sustainabilityRelatedInvestmentAssetAllocation?: string | null, sustainableInvestmentsWithEnvironmentalObjectiveEuTaxonomyAlignment?: string | null, fossilOrNuclear?: string | null, shareOfInvestmentsInTransitionalAndEnablingActivities?: string | null, shareOfSustainableInvestmentsWithEnvironmentalObjectiveNonEuTaxonomyAligned?: string | null, shareOfSociallySustainableInvestments?: string | null, purposeOfOtherOrNotSustainableInvestmentsIncludingSafeguards?: string | null, productPerformanceComparison?: string | null, sustainablyAlignedIndexExplanation?: string | null, investmentAlignedIndexExplanation?: string | null, broadMarketIndexComparison?: string | null, indexCalculationMethodology?: string | null, fundSpecificInfo?: string | null, whyDidProductConsiderPais?: string | null, useOfDerivatives?: string | null } | null } };

export type GeneratePortfolioTeamMemberSignupLinksCsvMutationVariables = Exact<{ [key: string]: never; }>;


export type GeneratePortfolioTeamMemberSignupLinksCsvMutation = { __typename?: 'ComboMutation', generatePortfolioTeamMemberSignupLinksCsv: string };

export type RegenerateModuleTokensMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type RegenerateModuleTokensMutation = { __typename?: 'ComboMutation', regenerateModuleTokens: { __typename?: 'AccountType', id: any, esgToken?: string | null, metricsToken?: string | null, impactGoalToken?: string | null } };

export type RegenerateTeamMemberTokenMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type RegenerateTeamMemberTokenMutation = { __typename?: 'ComboMutation', regenerateTeamMemberToken: string };

export type SetAccountUserRolesMutationVariables = Exact<{
  accountId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
  roles: Array<AccountMembershipRole> | AccountMembershipRole;
}>;


export type SetAccountUserRolesMutation = { __typename?: 'ComboMutation', setAccountUserRoles: Array<{ __typename?: 'AccountUserMembershipType', role: AccountMembershipRole, user: { __typename?: 'UserType', id: any, email: string } }> };

export type SubmitEuAlignmentQuestionnaireMutationVariables = Exact<{
  questionnaireId: Scalars['Int']['input'];
  isEditable: Scalars['Boolean']['input'];
}>;


export type SubmitEuAlignmentQuestionnaireMutation = { __typename?: 'ComboMutation', submitEuAlignmentQuestionnaire: { __typename?: 'AccountType', id: any, bookedModules: Array<Module>, hasNoEligibleBusinessActivities?: boolean | null, areEuTaxonomyActivitiesInSyncWithQuestionnaire: boolean, businessActivities: Array<{ __typename?: 'ConceptType', id?: number | null }>, fundSustainableObjectives: Array<{ __typename?: 'SfdrStrategyType', doCheckEuTaxonomyAlignment?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, createdBy?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, euTaxonomyConcept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, euTaxonomyQuestionnaire?: { __typename?: 'QuestionnaireType', id?: number | null, label: string, questionnaireAssignment?: { __typename?: 'QuestionnaireAssignmentType', id?: number | null, isEditable: boolean, updatedAt?: any | null, period?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null } | null, userInputs: Array<{ __typename?: 'UserInputType', id?: number | null, isActive: boolean, isNotRelevant?: boolean | null, geographyIds?: Array<number> | null, text?: string | null, scoringRule?: any | null, question: { __typename?: 'QuestionType', id?: number | null, label: string, component: string }, selectedOptions?: Array<{ __typename?: 'OptionType', id?: number | null, label?: string | null }> | null, selectedConcepts: Array<{ __typename?: 'UserInputConceptLinkType', implementationStatus: ImplementationStatus, comment: string, userInputId?: number | null, conceptId?: number | null, concept: { __typename?: 'ConceptType', id?: number | null, label: string, scheme?: RiskManagementScheme | null, description: string, isSubmeasure: boolean } }> }>, sectionCompletion: Array<{ __typename?: 'SectionCompletionType', sectionId: number, isCompleted: boolean, percentageCompleted: number, numberRequired: number, numberIncomplete: number, incompleteQuestions: Array<string> }>, questionnaireResults: Array<{ __typename?: 'QuestionnaireResultType', id?: number | null, sectionId?: number | null, sectionLabel: string, score?: number | null, details?: any | null }> } | null, questionnaireTemplate?: { __typename?: 'QuestionnaireTemplateType', sections?: Array<{ __typename?: 'SectionType', label?: string | null, id?: number | null, ixId?: string | null, description?: string | null, questions: Array<{ __typename?: 'QuestionType', id?: number | null, ixId?: string | null, component: string, tooltip?: string | null, isMultiple?: boolean | null, isMandatory: boolean, title: string, subtitle?: string | null, options: Array<{ __typename?: 'OptionType', id?: number | null, ixId?: string | null, label?: string | null, sublabel?: string | null, tooltip?: string | null }> }>, sections: Array<{ __typename?: 'SectionType', label?: string | null, id?: number | null, questions: Array<{ __typename?: 'QuestionType', id?: number | null, ixId?: string | null, component: string, tooltip?: string | null, isMultiple?: boolean | null, isMandatory: boolean, title: string, subtitle?: string | null, options: Array<{ __typename?: 'OptionType', id?: number | null, ixId?: string | null, label?: string | null, sublabel?: string | null, tooltip?: string | null }> }> }> }> | null } | null } | null } };

export type SyncEuTaxonomyActivitiesWithQuestionnaireMutationVariables = Exact<{
  ventureId: Scalars['String']['input'];
}>;


export type SyncEuTaxonomyActivitiesWithQuestionnaireMutation = { __typename?: 'ComboMutation', syncEuTaxonomyActivitiesWithQuestionnaire: { __typename?: 'AccountType', id: any, bookedModules: Array<Module>, hasNoEligibleBusinessActivities?: boolean | null, areEuTaxonomyActivitiesInSyncWithQuestionnaire: boolean, businessActivities: Array<{ __typename?: 'ConceptType', id?: number | null }>, fundSustainableObjectives: Array<{ __typename?: 'SfdrStrategyType', doCheckEuTaxonomyAlignment?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, createdBy?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, euTaxonomyConcept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, euTaxonomyQuestionnaire?: { __typename?: 'QuestionnaireType', id?: number | null, label: string, questionnaireAssignment?: { __typename?: 'QuestionnaireAssignmentType', id?: number | null, isEditable: boolean, updatedAt?: any | null, period?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null } | null, userInputs: Array<{ __typename?: 'UserInputType', id?: number | null, isActive: boolean, isNotRelevant?: boolean | null, geographyIds?: Array<number> | null, text?: string | null, scoringRule?: any | null, question: { __typename?: 'QuestionType', id?: number | null, label: string, component: string }, selectedOptions?: Array<{ __typename?: 'OptionType', id?: number | null, label?: string | null }> | null, selectedConcepts: Array<{ __typename?: 'UserInputConceptLinkType', implementationStatus: ImplementationStatus, comment: string, userInputId?: number | null, conceptId?: number | null, concept: { __typename?: 'ConceptType', id?: number | null, label: string, scheme?: RiskManagementScheme | null, description: string, isSubmeasure: boolean } }> }>, sectionCompletion: Array<{ __typename?: 'SectionCompletionType', sectionId: number, isCompleted: boolean, percentageCompleted: number, numberRequired: number, numberIncomplete: number, incompleteQuestions: Array<string> }>, questionnaireResults: Array<{ __typename?: 'QuestionnaireResultType', id?: number | null, sectionId?: number | null, sectionLabel: string, score?: number | null, details?: any | null }> } | null, questionnaireTemplate?: { __typename?: 'QuestionnaireTemplateType', sections?: Array<{ __typename?: 'SectionType', label?: string | null, id?: number | null, ixId?: string | null, description?: string | null, questions: Array<{ __typename?: 'QuestionType', id?: number | null, ixId?: string | null, component: string, tooltip?: string | null, isMultiple?: boolean | null, isMandatory: boolean, title: string, subtitle?: string | null, options: Array<{ __typename?: 'OptionType', id?: number | null, ixId?: string | null, label?: string | null, sublabel?: string | null, tooltip?: string | null }> }>, sections: Array<{ __typename?: 'SectionType', label?: string | null, id?: number | null, questions: Array<{ __typename?: 'QuestionType', id?: number | null, ixId?: string | null, component: string, tooltip?: string | null, isMultiple?: boolean | null, isMandatory: boolean, title: string, subtitle?: string | null, options: Array<{ __typename?: 'OptionType', id?: number | null, ixId?: string | null, label?: string | null, sublabel?: string | null, tooltip?: string | null }> }> }> }> | null } | null } | null } };

export type SyncVenturesWithSfdrFundSettingsMutationVariables = Exact<{
  fundId: Scalars['Int']['input'];
  sendEsgNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  esgNotificationNote?: InputMaybe<Scalars['String']['input']>;
}>;


export type SyncVenturesWithSfdrFundSettingsMutation = { __typename?: 'ComboMutation', syncVenturesWithSfdrFundSettings: { __typename?: 'FundType', id?: number | null, name?: string | null, legalEntityIdentifier?: string | null, volume?: number | null, fundStrategy?: FundStrategy | null, isReportingPais: boolean, isReportingKfw: boolean, minimumReportingLevelVentureIds?: Array<any> | null, recommendedReportingLevelVentureIds?: Array<any> | null, fullReportingLevelVentureIds?: Array<any> | null, isConsideringPais?: IsConsideringPais | null, notConsideringPaisReason?: string | null, ventureIds?: Array<any> | null, investmentStrategy?: string | null, bindingElementsOfInvestmentStrategy?: string | null, minimumRateToReduceScope?: string | null, companyGovernancePolicy?: string | null, fundSpecificInfo?: string | null, socialMetricIds: Array<number>, environmentalMetricIds: Array<number>, generalMetricIds: Array<number>, paiSelectionMethodologies: string, paiPolicyAdministration: string, considerationOfPaisOnSustainabilityEngagementPolicies: string, considerationOfPaisOnSustainabilityInternationalStandards: string, isConsideringSustainabilityRisk?: boolean | null, sustainabilityRiskIntegrationDescription?: string | null, likelyImpactsFromSustainabilityRisk?: string | null, reasonNotConsideringSustainabilityRisk?: string | null, entitySustainabilityExtraInfo?: string | null, paiAggregationGroup?: TypeAggregationGroup | null, esCharacteristicsPromoted?: EsCharacteristicsPromoted | null, assetAllocationTargets: { __typename?: 'AssetAllocationTargetsType', percentEnvironmental?: number | null, percentEnvironmentalTaxonomyAligned?: number | null, percentEnvironmentalNotTaxonomyAligned?: number | null, percentSocial?: number | null, percentSustainable?: number | null, percentTaxonomyAlignedFossil?: number | null, percentTaxonomyAlignedNuclear?: number | null, percentTaxonomyAlignedEnabling?: number | null, percentTaxonomyAlignedTransitional?: number | null }, socialMetrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, environmentalMetrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, generalMetrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, investmentPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null, sustainableObjectives: Array<{ __typename?: 'SfdrStrategyType', id?: number | null, kind: SfdrStrategyKind, benchmarkDescription?: string | null, actionsTaken?: string | null, metricIds: Array<number>, strategyDescription?: string | null, isEnvironmentalGoal: boolean, isCo2EmissionGoal?: boolean | null, doCheckEuTaxonomyAlignment?: boolean | null, ventureIds?: Array<any> | null, esStrategy: Array<EsCharacteristicStrategy>, esCharacteristicsDescription?: string | null, esgIntegrationDescription?: string | null, exclusionCriteriaDescription?: string | null, bestInClassDescription?: string | null, normBasedScreeningDescription?: string | null, sustainabilityLabelDescription?: string | null, isIndexDesignated?: boolean | null, sustainablyAlignedIndexExplanation?: string | null, investmentAlignedIndexExplanation?: string | null, broadMarketIndexComparison?: string | null, indexCalculationMethodology?: string | null, sustainabilityIndicatorsMonitoringStrategy: string, entityResponsibleForMonitoringIndicators: string, isConsideringSourcesAndEstimates: boolean, dataSourcesConsidered: string, shareOfDataSecondHand: string, dueDiligenceProcessDescription: string, engagementPolicyWithSpecificInvestmentStrategy: string, metrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null, euTaxonomyConcept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null }>, esCharacteristics: { __typename?: 'SfdrStrategyType', id?: number | null, kind: SfdrStrategyKind, benchmarkDescription?: string | null, actionsTaken?: string | null, metricIds: Array<number>, strategyDescription?: string | null, isEnvironmentalGoal: boolean, isCo2EmissionGoal?: boolean | null, doCheckEuTaxonomyAlignment?: boolean | null, ventureIds?: Array<any> | null, esStrategy: Array<EsCharacteristicStrategy>, esCharacteristicsDescription?: string | null, esgIntegrationDescription?: string | null, exclusionCriteriaDescription?: string | null, bestInClassDescription?: string | null, normBasedScreeningDescription?: string | null, sustainabilityLabelDescription?: string | null, isIndexDesignated?: boolean | null, sustainablyAlignedIndexExplanation?: string | null, investmentAlignedIndexExplanation?: string | null, broadMarketIndexComparison?: string | null, indexCalculationMethodology?: string | null, sustainabilityIndicatorsMonitoringStrategy: string, entityResponsibleForMonitoringIndicators: string, isConsideringSourcesAndEstimates: boolean, dataSourcesConsidered: string, shareOfDataSecondHand: string, dueDiligenceProcessDescription: string, engagementPolicyWithSpecificInvestmentStrategy: string, metrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null, euTaxonomyConcept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null }, periodicAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, paiAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, precontractualAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, fundWebsiteDisclosureAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, entityWebsiteDisclosureAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, paiReport?: { __typename?: 'UserInputPaiReportType', considerationOfPaisOnSustainabilityDescription?: string | null, considerationOfPaisOnSustainabilityEngagementPolicies?: string | null, considerationOfPaisOnSustainabilityInternationalStandards?: string | null, considerationOfPaisOnSustainabilityHistoricalComparison?: string | null, howDidProductConsiderPais?: string | null, principalAdverseImpactsExplanationsAndActions: any, summaryOfPais?: string | null } | null, precontractualReport?: { __typename?: 'UserInputPrecontractualReportType', sustainableObjectiveTree?: string | null, wereObjectivesMet?: string | null, esCharacteristicsDescription?: string | null, sustainabilityIndicatorsPerformanceDescription?: string | null, sustainableInvestmentsMadeByFund?: string | null, howDidInvestmentsNotCauseHarm?: string | null, accountOnPais?: string | null, alignmentWithOecdGuidelines?: string | null, investmentStrategy?: string | null, bindingElementsOfInvestmentStrategy?: string | null, companyGovernancePolicy?: string | null, howDidProductConsiderPais?: string | null, sustainabilityRelatedInvestmentAssetAllocation?: string | null, sustainableInvestmentsWithEnvironmentalObjectiveEuTaxonomyAlignment?: string | null, fossilOrNuclear?: string | null, shareOfInvestmentsInTransitionalAndEnablingActivities?: string | null, shareOfSustainableInvestmentsWithEnvironmentalObjectiveNonEuTaxonomyAligned?: string | null, shareOfSociallySustainableInvestments?: string | null, purposeOfOtherOrNotSustainableInvestmentsIncludingSafeguards?: string | null, productPerformanceComparison?: string | null, sustainablyAlignedIndexExplanation?: string | null, investmentAlignedIndexExplanation?: string | null, broadMarketIndexComparison?: string | null, indexCalculationMethodology?: string | null, fundSpecificInfo?: string | null, whyDidProductConsiderPais?: string | null, useOfDerivatives?: string | null } | null } };

export type UpdateAccountMutationVariables = Exact<{
  input: AccountInput;
  userIdsToAdd?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  userIdsToRemove?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;


export type UpdateAccountMutation = { __typename?: 'ComboMutation', updateAccount: { __typename?: 'AccountType', csrdRequirement?: any | null, showCsrdIntro: boolean, id: any, bookedModules: Array<Module>, hasNoEligibleBusinessActivities?: boolean | null, areEuTaxonomyActivitiesInSyncWithQuestionnaire: boolean, type: AccountCategory, name?: string | null, logo?: string | null, modules?: Array<Module> | null, countries?: Array<string> | null, nace?: Array<string> | null, website?: string | null, nameOfFinancialMarketParticipant: string, legalEntityIdentifier: string, sustainabilityRiskIntegration: string, remunerationPolicies: string, subsidiaries: Array<string>, entityLevelPaiConsideration: string, csrdLikelihoodThreshold?: number | null, csrdMagnitudeThreshold?: number | null, csrdThresholdReason?: string | null, hiddenKpis?: Array<number> | null, csrdNImpactLikelihoodThreshold?: number | null, csrdNImpactSeverityThreshold?: number | null, csrdNImpactThresholdReason?: string | null, csrdPImpactLikelihoodThreshold?: number | null, csrdPImpactScopeThreshold?: number | null, csrdPImpactThresholdReason?: string | null, reportingPeriodType: MetricReportingPeriodType, defaultReferencePeriods: Array<string>, requireImpactSubmission?: boolean | null, users?: Array<{ __typename?: 'UserType', id: any, email: string }> | null, ventureLinks?: Array<{ __typename?: 'PortfolioVentureLinkType', id: string, portfolioId: any, ventureId: any, modules: Array<Module>, groupNames: Array<string>, groupIds?: Array<number> | null, comment?: string | null, venture?: { __typename?: 'AccountType', id: any, name?: string | null, logo?: string | null, website?: string | null } | null, portfolio?: { __typename?: 'AccountType', id: any, name?: string | null, reportingPeriodType: MetricReportingPeriodType } | null }> | null, funds?: Array<{ __typename?: 'FundType', id?: number | null, name?: string | null, volume?: number | null, fundStrategy?: FundStrategy | null, isReportingPais: boolean, isConsideringPais?: IsConsideringPais | null, investmentPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, startDate?: any | null, endDate?: any | null } | null }> | null, businessActivities: Array<{ __typename?: 'ConceptType', id?: number | null }>, fundSustainableObjectives: Array<{ __typename?: 'SfdrStrategyType', doCheckEuTaxonomyAlignment?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, createdBy?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, euTaxonomyConcept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, euTaxonomyQuestionnaire?: { __typename?: 'QuestionnaireType', id?: number | null, label: string, questionnaireAssignment?: { __typename?: 'QuestionnaireAssignmentType', id?: number | null, isEditable: boolean, updatedAt?: any | null, period?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null } | null, userInputs: Array<{ __typename?: 'UserInputType', id?: number | null, isActive: boolean, isNotRelevant?: boolean | null, geographyIds?: Array<number> | null, text?: string | null, scoringRule?: any | null, question: { __typename?: 'QuestionType', id?: number | null, label: string, component: string }, selectedOptions?: Array<{ __typename?: 'OptionType', id?: number | null, label?: string | null }> | null, selectedConcepts: Array<{ __typename?: 'UserInputConceptLinkType', implementationStatus: ImplementationStatus, comment: string, userInputId?: number | null, conceptId?: number | null, concept: { __typename?: 'ConceptType', id?: number | null, label: string, scheme?: RiskManagementScheme | null, description: string, isSubmeasure: boolean } }> }>, sectionCompletion: Array<{ __typename?: 'SectionCompletionType', sectionId: number, isCompleted: boolean, percentageCompleted: number, numberRequired: number, numberIncomplete: number, incompleteQuestions: Array<string> }>, questionnaireResults: Array<{ __typename?: 'QuestionnaireResultType', id?: number | null, sectionId?: number | null, sectionLabel: string, score?: number | null, details?: any | null }> } | null, questionnaireTemplate?: { __typename?: 'QuestionnaireTemplateType', sections?: Array<{ __typename?: 'SectionType', label?: string | null, id?: number | null, ixId?: string | null, description?: string | null, questions: Array<{ __typename?: 'QuestionType', id?: number | null, ixId?: string | null, component: string, tooltip?: string | null, isMultiple?: boolean | null, isMandatory: boolean, title: string, subtitle?: string | null, options: Array<{ __typename?: 'OptionType', id?: number | null, ixId?: string | null, label?: string | null, sublabel?: string | null, tooltip?: string | null }> }>, sections: Array<{ __typename?: 'SectionType', label?: string | null, id?: number | null, questions: Array<{ __typename?: 'QuestionType', id?: number | null, ixId?: string | null, component: string, tooltip?: string | null, isMultiple?: boolean | null, isMandatory: boolean, title: string, subtitle?: string | null, options: Array<{ __typename?: 'OptionType', id?: number | null, ixId?: string | null, label?: string | null, sublabel?: string | null, tooltip?: string | null }> }> }> }> | null } | null } | null } };

export type UpdateAccountFundSetupMutationVariables = Exact<{
  input: AccountInput;
}>;


export type UpdateAccountFundSetupMutation = { __typename?: 'ComboMutation', updateAccount: { __typename?: 'AccountType', id: any, nameOfFinancialMarketParticipant: string, legalEntityIdentifier: string, sustainabilityRiskIntegration: string, remunerationPolicies: string, subsidiaries: Array<string>, entityLevelPaiConsideration: string, hiddenKpis?: Array<number> | null } };

export type UpdateAssetAllocationTargetsMutationVariables = Exact<{
  input: FundInput;
}>;


export type UpdateAssetAllocationTargetsMutation = { __typename?: 'ComboMutation', updateAssetAllocationTargets: { __typename?: 'FundType', id?: number | null, assetAllocationTargets: { __typename?: 'AssetAllocationTargetsType', percentEnvironmental?: number | null, percentEnvironmentalTaxonomyAligned?: number | null, percentEnvironmentalNotTaxonomyAligned?: number | null, percentSocial?: number | null, percentSustainable?: number | null, percentTaxonomyAlignedFossil?: number | null, percentTaxonomyAlignedNuclear?: number | null, percentTaxonomyAlignedEnabling?: number | null, percentTaxonomyAlignedTransitional?: number | null } } };

export type UpdateFundMutationVariables = Exact<{
  input: FundInput;
}>;


export type UpdateFundMutation = { __typename?: 'ComboMutation', updateFund: { __typename?: 'FundType', id?: number | null, name?: string | null, legalEntityIdentifier?: string | null, volume?: number | null, fundStrategy?: FundStrategy | null, isReportingPais: boolean, isReportingKfw: boolean, minimumReportingLevelVentureIds?: Array<any> | null, recommendedReportingLevelVentureIds?: Array<any> | null, fullReportingLevelVentureIds?: Array<any> | null, isConsideringPais?: IsConsideringPais | null, notConsideringPaisReason?: string | null, ventureIds?: Array<any> | null, investmentStrategy?: string | null, bindingElementsOfInvestmentStrategy?: string | null, minimumRateToReduceScope?: string | null, companyGovernancePolicy?: string | null, fundSpecificInfo?: string | null, socialMetricIds: Array<number>, environmentalMetricIds: Array<number>, generalMetricIds: Array<number>, paiSelectionMethodologies: string, paiPolicyAdministration: string, considerationOfPaisOnSustainabilityEngagementPolicies: string, considerationOfPaisOnSustainabilityInternationalStandards: string, isConsideringSustainabilityRisk?: boolean | null, sustainabilityRiskIntegrationDescription?: string | null, likelyImpactsFromSustainabilityRisk?: string | null, reasonNotConsideringSustainabilityRisk?: string | null, entitySustainabilityExtraInfo?: string | null, paiAggregationGroup?: TypeAggregationGroup | null, esCharacteristicsPromoted?: EsCharacteristicsPromoted | null, assetAllocationTargets: { __typename?: 'AssetAllocationTargetsType', percentEnvironmental?: number | null, percentEnvironmentalTaxonomyAligned?: number | null, percentEnvironmentalNotTaxonomyAligned?: number | null, percentSocial?: number | null, percentSustainable?: number | null, percentTaxonomyAlignedFossil?: number | null, percentTaxonomyAlignedNuclear?: number | null, percentTaxonomyAlignedEnabling?: number | null, percentTaxonomyAlignedTransitional?: number | null }, socialMetrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, environmentalMetrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, generalMetrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, investmentPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null, sustainableObjectives: Array<{ __typename?: 'SfdrStrategyType', id?: number | null, kind: SfdrStrategyKind, benchmarkDescription?: string | null, actionsTaken?: string | null, metricIds: Array<number>, strategyDescription?: string | null, isEnvironmentalGoal: boolean, isCo2EmissionGoal?: boolean | null, doCheckEuTaxonomyAlignment?: boolean | null, ventureIds?: Array<any> | null, esStrategy: Array<EsCharacteristicStrategy>, esCharacteristicsDescription?: string | null, esgIntegrationDescription?: string | null, exclusionCriteriaDescription?: string | null, bestInClassDescription?: string | null, normBasedScreeningDescription?: string | null, sustainabilityLabelDescription?: string | null, isIndexDesignated?: boolean | null, sustainablyAlignedIndexExplanation?: string | null, investmentAlignedIndexExplanation?: string | null, broadMarketIndexComparison?: string | null, indexCalculationMethodology?: string | null, sustainabilityIndicatorsMonitoringStrategy: string, entityResponsibleForMonitoringIndicators: string, isConsideringSourcesAndEstimates: boolean, dataSourcesConsidered: string, shareOfDataSecondHand: string, dueDiligenceProcessDescription: string, engagementPolicyWithSpecificInvestmentStrategy: string, metrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null, euTaxonomyConcept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null }>, esCharacteristics: { __typename?: 'SfdrStrategyType', id?: number | null, kind: SfdrStrategyKind, benchmarkDescription?: string | null, actionsTaken?: string | null, metricIds: Array<number>, strategyDescription?: string | null, isEnvironmentalGoal: boolean, isCo2EmissionGoal?: boolean | null, doCheckEuTaxonomyAlignment?: boolean | null, ventureIds?: Array<any> | null, esStrategy: Array<EsCharacteristicStrategy>, esCharacteristicsDescription?: string | null, esgIntegrationDescription?: string | null, exclusionCriteriaDescription?: string | null, bestInClassDescription?: string | null, normBasedScreeningDescription?: string | null, sustainabilityLabelDescription?: string | null, isIndexDesignated?: boolean | null, sustainablyAlignedIndexExplanation?: string | null, investmentAlignedIndexExplanation?: string | null, broadMarketIndexComparison?: string | null, indexCalculationMethodology?: string | null, sustainabilityIndicatorsMonitoringStrategy: string, entityResponsibleForMonitoringIndicators: string, isConsideringSourcesAndEstimates: boolean, dataSourcesConsidered: string, shareOfDataSecondHand: string, dueDiligenceProcessDescription: string, engagementPolicyWithSpecificInvestmentStrategy: string, metrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null, euTaxonomyConcept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null }, periodicAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, paiAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, precontractualAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, fundWebsiteDisclosureAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, entityWebsiteDisclosureAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, paiReport?: { __typename?: 'UserInputPaiReportType', considerationOfPaisOnSustainabilityDescription?: string | null, considerationOfPaisOnSustainabilityEngagementPolicies?: string | null, considerationOfPaisOnSustainabilityInternationalStandards?: string | null, considerationOfPaisOnSustainabilityHistoricalComparison?: string | null, howDidProductConsiderPais?: string | null, principalAdverseImpactsExplanationsAndActions: any, summaryOfPais?: string | null } | null, precontractualReport?: { __typename?: 'UserInputPrecontractualReportType', sustainableObjectiveTree?: string | null, wereObjectivesMet?: string | null, esCharacteristicsDescription?: string | null, sustainabilityIndicatorsPerformanceDescription?: string | null, sustainableInvestmentsMadeByFund?: string | null, howDidInvestmentsNotCauseHarm?: string | null, accountOnPais?: string | null, alignmentWithOecdGuidelines?: string | null, investmentStrategy?: string | null, bindingElementsOfInvestmentStrategy?: string | null, companyGovernancePolicy?: string | null, howDidProductConsiderPais?: string | null, sustainabilityRelatedInvestmentAssetAllocation?: string | null, sustainableInvestmentsWithEnvironmentalObjectiveEuTaxonomyAlignment?: string | null, fossilOrNuclear?: string | null, shareOfInvestmentsInTransitionalAndEnablingActivities?: string | null, shareOfSustainableInvestmentsWithEnvironmentalObjectiveNonEuTaxonomyAligned?: string | null, shareOfSociallySustainableInvestments?: string | null, purposeOfOtherOrNotSustainableInvestmentsIncludingSafeguards?: string | null, productPerformanceComparison?: string | null, sustainablyAlignedIndexExplanation?: string | null, investmentAlignedIndexExplanation?: string | null, broadMarketIndexComparison?: string | null, indexCalculationMethodology?: string | null, fundSpecificInfo?: string | null, whyDidProductConsiderPais?: string | null, useOfDerivatives?: string | null } | null } };

export type UpdatePortfolioVentureLinkMutationVariables = Exact<{
  portfolioId: Scalars['UUID']['input'];
  ventureId: Scalars['UUID']['input'];
  modules: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdatePortfolioVentureLinkMutation = { __typename?: 'ComboMutation', updatePortfolioVentureLink: { __typename?: 'PortfolioVentureLinkType', portfolioId: any, ventureId: any, modules: Array<Module> } };

export type UpdatePrecontractualReportMutationVariables = Exact<{
  input: FundInput;
}>;


export type UpdatePrecontractualReportMutation = { __typename?: 'ComboMutation', updatePrecontractualReport: { __typename?: 'FundType', id?: number | null, name?: string | null, legalEntityIdentifier?: string | null, volume?: number | null, fundStrategy?: FundStrategy | null, isReportingPais: boolean, isReportingKfw: boolean, minimumReportingLevelVentureIds?: Array<any> | null, recommendedReportingLevelVentureIds?: Array<any> | null, fullReportingLevelVentureIds?: Array<any> | null, isConsideringPais?: IsConsideringPais | null, notConsideringPaisReason?: string | null, ventureIds?: Array<any> | null, investmentStrategy?: string | null, bindingElementsOfInvestmentStrategy?: string | null, minimumRateToReduceScope?: string | null, companyGovernancePolicy?: string | null, fundSpecificInfo?: string | null, socialMetricIds: Array<number>, environmentalMetricIds: Array<number>, generalMetricIds: Array<number>, paiSelectionMethodologies: string, paiPolicyAdministration: string, considerationOfPaisOnSustainabilityEngagementPolicies: string, considerationOfPaisOnSustainabilityInternationalStandards: string, isConsideringSustainabilityRisk?: boolean | null, sustainabilityRiskIntegrationDescription?: string | null, likelyImpactsFromSustainabilityRisk?: string | null, reasonNotConsideringSustainabilityRisk?: string | null, entitySustainabilityExtraInfo?: string | null, paiAggregationGroup?: TypeAggregationGroup | null, esCharacteristicsPromoted?: EsCharacteristicsPromoted | null, assetAllocationTargets: { __typename?: 'AssetAllocationTargetsType', percentEnvironmental?: number | null, percentEnvironmentalTaxonomyAligned?: number | null, percentEnvironmentalNotTaxonomyAligned?: number | null, percentSocial?: number | null, percentSustainable?: number | null, percentTaxonomyAlignedFossil?: number | null, percentTaxonomyAlignedNuclear?: number | null, percentTaxonomyAlignedEnabling?: number | null, percentTaxonomyAlignedTransitional?: number | null }, socialMetrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, environmentalMetrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, generalMetrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, investmentPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null, sustainableObjectives: Array<{ __typename?: 'SfdrStrategyType', id?: number | null, kind: SfdrStrategyKind, benchmarkDescription?: string | null, actionsTaken?: string | null, metricIds: Array<number>, strategyDescription?: string | null, isEnvironmentalGoal: boolean, isCo2EmissionGoal?: boolean | null, doCheckEuTaxonomyAlignment?: boolean | null, ventureIds?: Array<any> | null, esStrategy: Array<EsCharacteristicStrategy>, esCharacteristicsDescription?: string | null, esgIntegrationDescription?: string | null, exclusionCriteriaDescription?: string | null, bestInClassDescription?: string | null, normBasedScreeningDescription?: string | null, sustainabilityLabelDescription?: string | null, isIndexDesignated?: boolean | null, sustainablyAlignedIndexExplanation?: string | null, investmentAlignedIndexExplanation?: string | null, broadMarketIndexComparison?: string | null, indexCalculationMethodology?: string | null, sustainabilityIndicatorsMonitoringStrategy: string, entityResponsibleForMonitoringIndicators: string, isConsideringSourcesAndEstimates: boolean, dataSourcesConsidered: string, shareOfDataSecondHand: string, dueDiligenceProcessDescription: string, engagementPolicyWithSpecificInvestmentStrategy: string, metrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null, euTaxonomyConcept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null }>, esCharacteristics: { __typename?: 'SfdrStrategyType', id?: number | null, kind: SfdrStrategyKind, benchmarkDescription?: string | null, actionsTaken?: string | null, metricIds: Array<number>, strategyDescription?: string | null, isEnvironmentalGoal: boolean, isCo2EmissionGoal?: boolean | null, doCheckEuTaxonomyAlignment?: boolean | null, ventureIds?: Array<any> | null, esStrategy: Array<EsCharacteristicStrategy>, esCharacteristicsDescription?: string | null, esgIntegrationDescription?: string | null, exclusionCriteriaDescription?: string | null, bestInClassDescription?: string | null, normBasedScreeningDescription?: string | null, sustainabilityLabelDescription?: string | null, isIndexDesignated?: boolean | null, sustainablyAlignedIndexExplanation?: string | null, investmentAlignedIndexExplanation?: string | null, broadMarketIndexComparison?: string | null, indexCalculationMethodology?: string | null, sustainabilityIndicatorsMonitoringStrategy: string, entityResponsibleForMonitoringIndicators: string, isConsideringSourcesAndEstimates: boolean, dataSourcesConsidered: string, shareOfDataSecondHand: string, dueDiligenceProcessDescription: string, engagementPolicyWithSpecificInvestmentStrategy: string, metrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null, euTaxonomyConcept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null }, periodicAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, paiAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, precontractualAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, fundWebsiteDisclosureAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, entityWebsiteDisclosureAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, paiReport?: { __typename?: 'UserInputPaiReportType', considerationOfPaisOnSustainabilityDescription?: string | null, considerationOfPaisOnSustainabilityEngagementPolicies?: string | null, considerationOfPaisOnSustainabilityInternationalStandards?: string | null, considerationOfPaisOnSustainabilityHistoricalComparison?: string | null, howDidProductConsiderPais?: string | null, principalAdverseImpactsExplanationsAndActions: any, summaryOfPais?: string | null } | null, precontractualReport?: { __typename?: 'UserInputPrecontractualReportType', sustainableObjectiveTree?: string | null, wereObjectivesMet?: string | null, esCharacteristicsDescription?: string | null, sustainabilityIndicatorsPerformanceDescription?: string | null, sustainableInvestmentsMadeByFund?: string | null, howDidInvestmentsNotCauseHarm?: string | null, accountOnPais?: string | null, alignmentWithOecdGuidelines?: string | null, investmentStrategy?: string | null, bindingElementsOfInvestmentStrategy?: string | null, companyGovernancePolicy?: string | null, howDidProductConsiderPais?: string | null, sustainabilityRelatedInvestmentAssetAllocation?: string | null, sustainableInvestmentsWithEnvironmentalObjectiveEuTaxonomyAlignment?: string | null, fossilOrNuclear?: string | null, shareOfInvestmentsInTransitionalAndEnablingActivities?: string | null, shareOfSustainableInvestmentsWithEnvironmentalObjectiveNonEuTaxonomyAligned?: string | null, shareOfSociallySustainableInvestments?: string | null, purposeOfOtherOrNotSustainableInvestmentsIncludingSafeguards?: string | null, productPerformanceComparison?: string | null, sustainablyAlignedIndexExplanation?: string | null, investmentAlignedIndexExplanation?: string | null, broadMarketIndexComparison?: string | null, indexCalculationMethodology?: string | null, fundSpecificInfo?: string | null, whyDidProductConsiderPais?: string | null, useOfDerivatives?: string | null } | null } };

export type UpdateReportAnswerMutationVariables = Exact<{
  input: ReportAnswerInput;
}>;


export type UpdateReportAnswerMutation = { __typename?: 'ComboMutation', updateReportAnswer: { __typename?: 'ReportAnswerType', id: any, fundId: number, referencePeriodId: number, reportType: ReportType } };

export type UpdateSfdrStrategyMutationVariables = Exact<{
  input: SfdrStrategyInput;
}>;


export type UpdateSfdrStrategyMutation = { __typename?: 'ComboMutation', updateSfdrStrategy: { __typename?: 'FundType', id?: number | null, name?: string | null, legalEntityIdentifier?: string | null, volume?: number | null, fundStrategy?: FundStrategy | null, isReportingPais: boolean, isReportingKfw: boolean, minimumReportingLevelVentureIds?: Array<any> | null, recommendedReportingLevelVentureIds?: Array<any> | null, fullReportingLevelVentureIds?: Array<any> | null, isConsideringPais?: IsConsideringPais | null, notConsideringPaisReason?: string | null, ventureIds?: Array<any> | null, investmentStrategy?: string | null, bindingElementsOfInvestmentStrategy?: string | null, minimumRateToReduceScope?: string | null, companyGovernancePolicy?: string | null, fundSpecificInfo?: string | null, socialMetricIds: Array<number>, environmentalMetricIds: Array<number>, generalMetricIds: Array<number>, paiSelectionMethodologies: string, paiPolicyAdministration: string, considerationOfPaisOnSustainabilityEngagementPolicies: string, considerationOfPaisOnSustainabilityInternationalStandards: string, isConsideringSustainabilityRisk?: boolean | null, sustainabilityRiskIntegrationDescription?: string | null, likelyImpactsFromSustainabilityRisk?: string | null, reasonNotConsideringSustainabilityRisk?: string | null, entitySustainabilityExtraInfo?: string | null, paiAggregationGroup?: TypeAggregationGroup | null, esCharacteristicsPromoted?: EsCharacteristicsPromoted | null, assetAllocationTargets: { __typename?: 'AssetAllocationTargetsType', percentEnvironmental?: number | null, percentEnvironmentalTaxonomyAligned?: number | null, percentEnvironmentalNotTaxonomyAligned?: number | null, percentSocial?: number | null, percentSustainable?: number | null, percentTaxonomyAlignedFossil?: number | null, percentTaxonomyAlignedNuclear?: number | null, percentTaxonomyAlignedEnabling?: number | null, percentTaxonomyAlignedTransitional?: number | null }, socialMetrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, environmentalMetrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, generalMetrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, investmentPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null, sustainableObjectives: Array<{ __typename?: 'SfdrStrategyType', id?: number | null, kind: SfdrStrategyKind, benchmarkDescription?: string | null, actionsTaken?: string | null, metricIds: Array<number>, strategyDescription?: string | null, isEnvironmentalGoal: boolean, isCo2EmissionGoal?: boolean | null, doCheckEuTaxonomyAlignment?: boolean | null, ventureIds?: Array<any> | null, esStrategy: Array<EsCharacteristicStrategy>, esCharacteristicsDescription?: string | null, esgIntegrationDescription?: string | null, exclusionCriteriaDescription?: string | null, bestInClassDescription?: string | null, normBasedScreeningDescription?: string | null, sustainabilityLabelDescription?: string | null, isIndexDesignated?: boolean | null, sustainablyAlignedIndexExplanation?: string | null, investmentAlignedIndexExplanation?: string | null, broadMarketIndexComparison?: string | null, indexCalculationMethodology?: string | null, sustainabilityIndicatorsMonitoringStrategy: string, entityResponsibleForMonitoringIndicators: string, isConsideringSourcesAndEstimates: boolean, dataSourcesConsidered: string, shareOfDataSecondHand: string, dueDiligenceProcessDescription: string, engagementPolicyWithSpecificInvestmentStrategy: string, metrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null, euTaxonomyConcept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null }>, esCharacteristics: { __typename?: 'SfdrStrategyType', id?: number | null, kind: SfdrStrategyKind, benchmarkDescription?: string | null, actionsTaken?: string | null, metricIds: Array<number>, strategyDescription?: string | null, isEnvironmentalGoal: boolean, isCo2EmissionGoal?: boolean | null, doCheckEuTaxonomyAlignment?: boolean | null, ventureIds?: Array<any> | null, esStrategy: Array<EsCharacteristicStrategy>, esCharacteristicsDescription?: string | null, esgIntegrationDescription?: string | null, exclusionCriteriaDescription?: string | null, bestInClassDescription?: string | null, normBasedScreeningDescription?: string | null, sustainabilityLabelDescription?: string | null, isIndexDesignated?: boolean | null, sustainablyAlignedIndexExplanation?: string | null, investmentAlignedIndexExplanation?: string | null, broadMarketIndexComparison?: string | null, indexCalculationMethodology?: string | null, sustainabilityIndicatorsMonitoringStrategy: string, entityResponsibleForMonitoringIndicators: string, isConsideringSourcesAndEstimates: boolean, dataSourcesConsidered: string, shareOfDataSecondHand: string, dueDiligenceProcessDescription: string, engagementPolicyWithSpecificInvestmentStrategy: string, metrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null, euTaxonomyConcept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null }, periodicAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, paiAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, precontractualAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, fundWebsiteDisclosureAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, entityWebsiteDisclosureAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, paiReport?: { __typename?: 'UserInputPaiReportType', considerationOfPaisOnSustainabilityDescription?: string | null, considerationOfPaisOnSustainabilityEngagementPolicies?: string | null, considerationOfPaisOnSustainabilityInternationalStandards?: string | null, considerationOfPaisOnSustainabilityHistoricalComparison?: string | null, howDidProductConsiderPais?: string | null, principalAdverseImpactsExplanationsAndActions: any, summaryOfPais?: string | null } | null, precontractualReport?: { __typename?: 'UserInputPrecontractualReportType', sustainableObjectiveTree?: string | null, wereObjectivesMet?: string | null, esCharacteristicsDescription?: string | null, sustainabilityIndicatorsPerformanceDescription?: string | null, sustainableInvestmentsMadeByFund?: string | null, howDidInvestmentsNotCauseHarm?: string | null, accountOnPais?: string | null, alignmentWithOecdGuidelines?: string | null, investmentStrategy?: string | null, bindingElementsOfInvestmentStrategy?: string | null, companyGovernancePolicy?: string | null, howDidProductConsiderPais?: string | null, sustainabilityRelatedInvestmentAssetAllocation?: string | null, sustainableInvestmentsWithEnvironmentalObjectiveEuTaxonomyAlignment?: string | null, fossilOrNuclear?: string | null, shareOfInvestmentsInTransitionalAndEnablingActivities?: string | null, shareOfSustainableInvestmentsWithEnvironmentalObjectiveNonEuTaxonomyAligned?: string | null, shareOfSociallySustainableInvestments?: string | null, purposeOfOtherOrNotSustainableInvestmentsIncludingSafeguards?: string | null, productPerformanceComparison?: string | null, sustainablyAlignedIndexExplanation?: string | null, investmentAlignedIndexExplanation?: string | null, broadMarketIndexComparison?: string | null, indexCalculationMethodology?: string | null, fundSpecificInfo?: string | null, whyDidProductConsiderPais?: string | null, useOfDerivatives?: string | null } | null } };

export type UpdateVentureCommentMutationVariables = Exact<{
  ventureId: Scalars['String']['input'];
  comment: Scalars['String']['input'];
}>;


export type UpdateVentureCommentMutation = { __typename?: 'ComboMutation', updateVentureComment: { __typename?: 'PortfolioVentureLinkType', id: string, portfolioId: any, ventureId: any, comment?: string | null } };

export type UpsertGroupMutationVariables = Exact<{
  input: PortfolioGroupInput;
}>;


export type UpsertGroupMutation = { __typename?: 'ComboMutation', upsertGroup: { __typename?: 'PortfolioGroupType', id?: number | null, label: string } };

export type UpsertAccountSectionLinkMutationVariables = Exact<{
  input: AccountSectionLinkInput;
}>;


export type UpsertAccountSectionLinkMutation = { __typename?: 'ComboMutation', upsertAccountSectionLink: { __typename?: 'AccountSectionLinkType', id: any, accountId: any, sectionId: number, comment: string } };

export type AddActivityStakeholderLinkMutationVariables = Exact<{
  stakeholderId: Scalars['UUID']['input'];
  activityId: Scalars['UUID']['input'];
}>;


export type AddActivityStakeholderLinkMutation = { __typename?: 'ComboMutation', addActivityStakeholderLink: { __typename?: 'ActivityStakeholderLinkType', stakeholderId: any, activityId: any } };

export type UpdateActivityStakeholderLinkMutationVariables = Exact<{
  input: ActivityStakeholderLinkInput;
}>;


export type UpdateActivityStakeholderLinkMutation = { __typename?: 'ComboMutation', updateActivityStakeholderLink: { __typename?: 'ActivityStakeholderLinkType', id: any, impactMaterial: boolean, financialMaterial: boolean } };

export type AddActivityMutationVariables = Exact<{
  activityInput: ActivityInput;
}>;


export type AddActivityMutation = { __typename?: 'ComboMutation', addActivity: { __typename?: 'ActivityType', id: any, name: string, description: string, industry: string, geographyId?: number | null, location: string, type: EnumActivityType, riskProfile: EnumActivityRiskProfile, valueChainId: any } };

export type DeleteActivityMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteActivityMutation = { __typename?: 'ComboMutation', deleteActivity: boolean };

export type UpdateActivityMutationVariables = Exact<{
  activityInput: ActivityInput;
}>;


export type UpdateActivityMutation = { __typename?: 'ComboMutation', updateActivity: { __typename?: 'ActivityType', id: any, name: string, description: string, industry: string, location: string, type: EnumActivityType, riskProfile: EnumActivityRiskProfile, geographyId?: number | null, valueChainId: any } };

export type ExecutePromptMutationVariables = Exact<{
  input: ExecutePromptInput;
}>;


export type ExecutePromptMutation = { __typename?: 'ComboMutation', executePrompt: { __typename?: 'PromptRunType', id?: any | null, response?: string | null, tokenUsage?: any | null, latencyMs?: number | null, cacheHit?: boolean | null, promptTemplateId: any, version: number, model: string, renderedSystem?: string | null, renderedUser?: string | null, sanitizedRenderedUser?: string | null, createdAt: any, promptAccepted?: boolean | null, sanitizerInfo?: any | null } };

export type UpsertPromptRunMutationVariables = Exact<{
  input: PromptRunInput;
}>;


export type UpsertPromptRunMutation = { __typename?: 'ComboMutation', upsertPromptRun: { __typename?: 'PromptRunType', id?: any | null } };

export type UpdateCategoryMutationVariables = Exact<{
  input: CategoryInput;
}>;


export type UpdateCategoryMutation = { __typename?: 'ComboMutation', upsertCategory: { __typename?: 'CategoryType', id?: number | null, label: string, labelI18n: any, createdAt: any, parentId?: number | null, parent?: { __typename?: 'CategoryType', id?: number | null, label: string } | null } };

export type AddConceptMutationVariables = Exact<{
  input: ConceptInput;
}>;


export type AddConceptMutation = { __typename?: 'ComboMutation', addConcept: { __typename?: 'ConceptType', id?: number | null, label: string, labelI18n: any, description: string, descriptionI18n: any, isSubmeasure: boolean, additionalData?: any | null, sourceUrl: string, citation: string, citationI18n: any, isMaterial: boolean, materialityExplanation: string, materialityExplanationI18n: any, status: ConceptStatus, scheme?: RiskManagementScheme | null, kind?: ConceptKind | null, ixId?: string | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null }>, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, objectLinks: Array<{ __typename?: 'ConceptLinkType', predicate: ConceptPredicateType, object: { __typename?: 'ConceptType', id?: number | null, label: string } }> } };

export type UpsertMeasureMutationVariables = Exact<{
  input: ConceptInput;
}>;


export type UpsertMeasureMutation = { __typename?: 'ComboMutation', upsertMeasure: { __typename?: 'ConceptType', id?: number | null, label: string, labelI18n: any, description: string, descriptionI18n: any, isSubmeasure: boolean, additionalData?: any | null, sourceUrl: string, citation: string, citationI18n: any, isMaterial: boolean, materialityExplanation: string, materialityExplanationI18n: any, status: ConceptStatus, scheme?: RiskManagementScheme | null, kind?: ConceptKind | null, ixId?: string | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null }>, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, objectLinks: Array<{ __typename?: 'ConceptLinkType', predicate: ConceptPredicateType, object: { __typename?: 'ConceptType', id?: number | null, label: string } }> } };

export type CreateDemoPortfolioMutationVariables = Exact<{
  input: CreateDemoPortfolioInput;
}>;


export type CreateDemoPortfolioMutation = { __typename?: 'ComboMutation', createDemoPortfolio: { __typename?: 'CreateDemoPortfolioType', portfolioName: string } };

export type AddEvidenceMutationVariables = Exact<{
  input: EvidenceInput;
}>;


export type AddEvidenceMutation = { __typename?: 'ComboMutation', addEvidence: { __typename?: 'EvidenceType', id: any, websiteUrl?: string | null, description?: string | null, comment?: string | null } };

export type AddEvidenceLinkMutationVariables = Exact<{
  input: EvidenceLinkInput;
}>;


export type AddEvidenceLinkMutation = { __typename?: 'ComboMutation', addEvidenceLink: { __typename?: 'EvidenceLinkType', id: any, accountId: any, type: string, evidenceId?: any | null, entityUuidId?: any | null, entityIntId?: number | null, description?: string | null } };

export type DelEvidenceMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DelEvidenceMutation = { __typename?: 'ComboMutation', delEvidence: boolean };

export type DelEvidenceLinkMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DelEvidenceLinkMutation = { __typename?: 'ComboMutation', delEvidenceLink: boolean };

export type UpdateEvidenceMutationVariables = Exact<{
  input: EvidenceInput;
}>;


export type UpdateEvidenceMutation = { __typename?: 'ComboMutation', updateEvidence: { __typename?: 'EvidenceType', id: any, websiteUrl?: string | null, comment?: string | null, description?: string | null } };

export type UpdateEvidenceLinkMutationVariables = Exact<{
  input: EvidenceLinkInput;
}>;


export type UpdateEvidenceLinkMutation = { __typename?: 'ComboMutation', updateEvidenceLink: { __typename?: 'EvidenceLinkType', id: any, accountId: any, type: string, evidenceId?: any | null, entityUuidId?: any | null, entityIntId?: number | null, description?: string | null } };

export type BatchLockImpactsMutationVariables = Exact<{
  input: BatchImpactLockInput;
}>;


export type BatchLockImpactsMutation = { __typename?: 'ComboMutation', batchLockImpacts: Array<{ __typename?: 'ImpactType', id?: number | null, isEditable: boolean, submitDate?: any | null }> };

export type CreateImpactMutationVariables = Exact<{
  input: ImpactInput;
}>;


export type CreateImpactMutation = { __typename?: 'ComboMutation', createImpact: { __typename?: 'ImpactType', id?: number | null, conceptId?: number | null, stakeholder?: string | null, stakeholderCategory?: StakeholderCategoryType | null, isPositive?: boolean | null, theoryOfChange?: string | null, problem?: string | null, problemStatement?: string | null, companyVision?: string | null, targetGroup?: string | null, inputsActivities?: string | null, solutionsOutput?: string | null, shortTermOutcomes?: string | null, longTermImpacts?: string | null, riskReboundEffects?: string | null, euTaxonomy?: EuTaxonomyType | null, initialInvestmentDate?: any | null, startingYear?: number | null, durationYears?: number | null, carryRemarks?: string | null, isEditable: boolean, submitDate?: any | null, hasFrozenOutcome?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, labelI18n: any, description: string, descriptionI18n: any, isSubmeasure: boolean, additionalData?: any | null, sourceUrl: string, citation: string, citationI18n: any, isMaterial: boolean, materialityExplanation: string, materialityExplanationI18n: any, status: ConceptStatus, scheme?: RiskManagementScheme | null, kind?: ConceptKind | null, ixId?: string | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null }>, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, objectLinks: Array<{ __typename?: 'ConceptLinkType', predicate: ConceptPredicateType, object: { __typename?: 'ConceptType', id?: number | null, label: string } }> } | null, sourceAssignments: Array<{ __typename?: 'SourceAssignmentType', id?: number | null, url: string, comment?: string | null }>, impactSolutions: Array<{ __typename?: 'ImpactSolutionType', id?: number | null, impactId: number, targetGroup?: string | null, problemDescription?: string | null, solutionDescription?: string | null, kind?: ImpactSolutionKind | null, ghgSavingPotentialId?: number | null, useGhgSavingPotentialTool?: boolean | null, solutionSource: Array<{ __typename?: 'SolutionSourceType', id?: number | null, url?: string | null, comment?: string | null }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null, ghgSavingPotential?: { __typename?: 'GhgSavingPotentialType', id?: number | null, needFulfilled?: string | null, baselineSolutionDescription?: string | null, comparativeUnit?: string | null, comparativeQuantitiy?: number | null, comparativeUnitConfirmed?: boolean | null, describeComparison?: string | null, isPreciseEmissionCalculation?: boolean | null, simpleBaselineGhg?: number | null, simpleSolutionGhg?: number | null, simpleGhgJustification?: string | null, emissionsConfirmed?: boolean | null, growthFactorJustification?: string | null, isRecurringImpact?: boolean | null, durationOfImpact?: number | null, realisticConfirmation?: boolean | null, impactProfileKind: ImpactProfileKind, isScenarioA?: boolean | null, preComputedBaselineGhg?: number | null, preComputedSolutionGhg?: number | null, scenarioBComments?: string | null, emissionSourceLimitations?: string | null, specificReductionPerUnit?: number | null, specificReductionAsPercentage?: number | null, emissionSources: Array<{ __typename?: 'EmissionSourceType', id?: number | null, ghgSavingPotentialId: number, sourceOfEmission?: string | null, unitName?: string | null, baselineUnitName?: string | null, solutionUnitName?: string | null, baselineConceptName?: string | null, baselineGhgFactor?: number | null, baselineConsumption?: number | null, baselineAssumption?: string | null, baselineEvidence: string, customBaselineConcept?: boolean | null, solutionReducesConsumption?: boolean | null, solutionReducesGhgFactor?: boolean | null, solutionConceptName?: string | null, solutionGhgFactor?: number | null, solutionConsumption?: number | null, solutionAssumption?: string | null, solutionEvidence: string, customSolutionConcept?: boolean | null, specificReductionPerUnit?: number | null, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> }>, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> } | null }>, sdgs: Array<{ __typename?: 'SdgType', id?: number | null, label: string, sublabel: string }>, sdgTargets: Array<{ __typename?: 'SdgTargetType', id?: number | null, label: string, sdgId?: number | null }>, irisCategories: Array<{ __typename?: 'IrisCategoryType', id?: number | null, label: string }>, geographies: Array<{ __typename?: 'GeographyType', id?: number | null, label: string }>, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, metricNameOverride: string, comment?: string | null, reportingPeriodType: MetricReportingPeriodType, isFrozen: boolean, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> } };

export type CreateImpactGoalsMutationVariables = Exact<{
  ventureIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CreateImpactGoalsMutation = { __typename?: 'ComboMutation', createImpactGoals: Array<{ __typename?: 'ImpactGoalType', id?: number | null, ventureId: any, isEditable: boolean, activityUrls: Array<string>, ghgStartingYear: number, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, conceptId?: number | null, stakeholder?: string | null, stakeholderCategory?: StakeholderCategoryType | null, isPositive?: boolean | null, theoryOfChange?: string | null, problem?: string | null, problemStatement?: string | null, companyVision?: string | null, targetGroup?: string | null, inputsActivities?: string | null, solutionsOutput?: string | null, shortTermOutcomes?: string | null, longTermImpacts?: string | null, riskReboundEffects?: string | null, euTaxonomy?: EuTaxonomyType | null, initialInvestmentDate?: any | null, startingYear?: number | null, durationYears?: number | null, carryRemarks?: string | null, isEditable: boolean, submitDate?: any | null, hasFrozenOutcome?: boolean | null, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, ghgSavingPotentialId?: number | null, metricNameOverride: string, comment?: string | null, reportingPeriodType: MetricReportingPeriodType, isFrozen: boolean, customTargetWeight: number, unitName: string, customTargetCalculationType: AnnualAggregationMethod, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, labelI18n: any, description: string, descriptionI18n: any, isSubmeasure: boolean, additionalData?: any | null, sourceUrl: string, citation: string, citationI18n: any, isMaterial: boolean, materialityExplanation: string, materialityExplanationI18n: any, status: ConceptStatus, scheme?: RiskManagementScheme | null, kind?: ConceptKind | null, ixId?: string | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null }>, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, objectLinks: Array<{ __typename?: 'ConceptLinkType', predicate: ConceptPredicateType, object: { __typename?: 'ConceptType', id?: number | null, label: string } }> } | null, sourceAssignments: Array<{ __typename?: 'SourceAssignmentType', id?: number | null, url: string, comment?: string | null }>, impactSolutions: Array<{ __typename?: 'ImpactSolutionType', id?: number | null, impactId: number, targetGroup?: string | null, problemDescription?: string | null, solutionDescription?: string | null, kind?: ImpactSolutionKind | null, ghgSavingPotentialId?: number | null, useGhgSavingPotentialTool?: boolean | null, solutionSource: Array<{ __typename?: 'SolutionSourceType', id?: number | null, url?: string | null, comment?: string | null }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null, ghgSavingPotential?: { __typename?: 'GhgSavingPotentialType', id?: number | null, needFulfilled?: string | null, baselineSolutionDescription?: string | null, comparativeUnit?: string | null, comparativeQuantitiy?: number | null, comparativeUnitConfirmed?: boolean | null, describeComparison?: string | null, isPreciseEmissionCalculation?: boolean | null, simpleBaselineGhg?: number | null, simpleSolutionGhg?: number | null, simpleGhgJustification?: string | null, emissionsConfirmed?: boolean | null, growthFactorJustification?: string | null, isRecurringImpact?: boolean | null, durationOfImpact?: number | null, realisticConfirmation?: boolean | null, impactProfileKind: ImpactProfileKind, isScenarioA?: boolean | null, preComputedBaselineGhg?: number | null, preComputedSolutionGhg?: number | null, scenarioBComments?: string | null, emissionSourceLimitations?: string | null, specificReductionPerUnit?: number | null, specificReductionAsPercentage?: number | null, emissionSources: Array<{ __typename?: 'EmissionSourceType', id?: number | null, ghgSavingPotentialId: number, sourceOfEmission?: string | null, unitName?: string | null, baselineUnitName?: string | null, solutionUnitName?: string | null, baselineConceptName?: string | null, baselineGhgFactor?: number | null, baselineConsumption?: number | null, baselineAssumption?: string | null, baselineEvidence: string, customBaselineConcept?: boolean | null, solutionReducesConsumption?: boolean | null, solutionReducesGhgFactor?: boolean | null, solutionConceptName?: string | null, solutionGhgFactor?: number | null, solutionConsumption?: number | null, solutionAssumption?: string | null, solutionEvidence: string, customSolutionConcept?: boolean | null, specificReductionPerUnit?: number | null, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> }>, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> } | null }>, sdgs: Array<{ __typename?: 'SdgType', id?: number | null, label: string, sublabel: string }>, sdgTargets: Array<{ __typename?: 'SdgTargetType', id?: number | null, label: string, sdgId?: number | null }>, irisCategories: Array<{ __typename?: 'IrisCategoryType', id?: number | null, label: string }>, geographies: Array<{ __typename?: 'GeographyType', id?: number | null, label: string }> }>, targetProgress: { __typename?: 'ImpactGoalProgressType', id: number, hasTarget: boolean, startDate?: number | null, endDate?: number | null, completionRate?: number | null, message?: string | null } }> };

export type DeleteEmissionSourceMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteEmissionSourceMutation = { __typename?: 'ComboMutation', deleteEmissionSource: { __typename?: 'GhgSavingPotentialType', id?: number | null, needFulfilled?: string | null, baselineSolutionDescription?: string | null, comparativeUnit?: string | null, comparativeQuantitiy?: number | null, comparativeUnitConfirmed?: boolean | null, describeComparison?: string | null, isPreciseEmissionCalculation?: boolean | null, simpleBaselineGhg?: number | null, simpleSolutionGhg?: number | null, simpleGhgJustification?: string | null, emissionsConfirmed?: boolean | null, growthFactorJustification?: string | null, isRecurringImpact?: boolean | null, durationOfImpact?: number | null, realisticConfirmation?: boolean | null, impactProfileKind: ImpactProfileKind, isScenarioA?: boolean | null, preComputedBaselineGhg?: number | null, preComputedSolutionGhg?: number | null, scenarioBComments?: string | null, emissionSourceLimitations?: string | null, specificReductionPerUnit?: number | null, specificReductionAsPercentage?: number | null, emissionSources: Array<{ __typename?: 'EmissionSourceType', id?: number | null, ghgSavingPotentialId: number, sourceOfEmission?: string | null, unitName?: string | null, baselineUnitName?: string | null, solutionUnitName?: string | null, baselineConceptName?: string | null, baselineGhgFactor?: number | null, baselineConsumption?: number | null, baselineAssumption?: string | null, baselineEvidence: string, customBaselineConcept?: boolean | null, solutionReducesConsumption?: boolean | null, solutionReducesGhgFactor?: boolean | null, solutionConceptName?: string | null, solutionGhgFactor?: number | null, solutionConsumption?: number | null, solutionAssumption?: string | null, solutionEvidence: string, customSolutionConcept?: boolean | null, specificReductionPerUnit?: number | null, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> }>, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> } };

export type DeleteImpactMutationVariables = Exact<{
  impactId: Scalars['Int']['input'];
}>;


export type DeleteImpactMutation = { __typename?: 'ComboMutation', deleteImpact: { __typename?: 'DeleteInfoType', isSuccess: boolean, recordId: number } };

export type DeleteImpactSolutionMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteImpactSolutionMutation = { __typename?: 'ComboMutation', deleteImpactSolution: { __typename?: 'DeleteInfoType', isSuccess: boolean, recordId: number } };

export type InstantiateGhgReductionImpactMutationVariables = Exact<{
  ventureId: Scalars['UUID']['input'];
}>;


export type InstantiateGhgReductionImpactMutation = { __typename?: 'ComboMutation', instantiateGhgReductionImpact: { __typename?: 'ImpactGoalType', id?: number | null, ventureId: any, isEditable: boolean, activityUrls: Array<string>, ghgStartingYear: number, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, conceptId?: number | null, stakeholder?: string | null, stakeholderCategory?: StakeholderCategoryType | null, isPositive?: boolean | null, theoryOfChange?: string | null, problem?: string | null, problemStatement?: string | null, companyVision?: string | null, targetGroup?: string | null, inputsActivities?: string | null, solutionsOutput?: string | null, shortTermOutcomes?: string | null, longTermImpacts?: string | null, riskReboundEffects?: string | null, euTaxonomy?: EuTaxonomyType | null, initialInvestmentDate?: any | null, startingYear?: number | null, durationYears?: number | null, carryRemarks?: string | null, isEditable: boolean, submitDate?: any | null, hasFrozenOutcome?: boolean | null, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, ghgSavingPotentialId?: number | null, metricNameOverride: string, comment?: string | null, reportingPeriodType: MetricReportingPeriodType, isFrozen: boolean, customTargetWeight: number, unitName: string, customTargetCalculationType: AnnualAggregationMethod, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, labelI18n: any, description: string, descriptionI18n: any, isSubmeasure: boolean, additionalData?: any | null, sourceUrl: string, citation: string, citationI18n: any, isMaterial: boolean, materialityExplanation: string, materialityExplanationI18n: any, status: ConceptStatus, scheme?: RiskManagementScheme | null, kind?: ConceptKind | null, ixId?: string | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null }>, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, objectLinks: Array<{ __typename?: 'ConceptLinkType', predicate: ConceptPredicateType, object: { __typename?: 'ConceptType', id?: number | null, label: string } }> } | null, sourceAssignments: Array<{ __typename?: 'SourceAssignmentType', id?: number | null, url: string, comment?: string | null }>, impactSolutions: Array<{ __typename?: 'ImpactSolutionType', id?: number | null, impactId: number, targetGroup?: string | null, problemDescription?: string | null, solutionDescription?: string | null, kind?: ImpactSolutionKind | null, ghgSavingPotentialId?: number | null, useGhgSavingPotentialTool?: boolean | null, solutionSource: Array<{ __typename?: 'SolutionSourceType', id?: number | null, url?: string | null, comment?: string | null }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null, ghgSavingPotential?: { __typename?: 'GhgSavingPotentialType', id?: number | null, needFulfilled?: string | null, baselineSolutionDescription?: string | null, comparativeUnit?: string | null, comparativeQuantitiy?: number | null, comparativeUnitConfirmed?: boolean | null, describeComparison?: string | null, isPreciseEmissionCalculation?: boolean | null, simpleBaselineGhg?: number | null, simpleSolutionGhg?: number | null, simpleGhgJustification?: string | null, emissionsConfirmed?: boolean | null, growthFactorJustification?: string | null, isRecurringImpact?: boolean | null, durationOfImpact?: number | null, realisticConfirmation?: boolean | null, impactProfileKind: ImpactProfileKind, isScenarioA?: boolean | null, preComputedBaselineGhg?: number | null, preComputedSolutionGhg?: number | null, scenarioBComments?: string | null, emissionSourceLimitations?: string | null, specificReductionPerUnit?: number | null, specificReductionAsPercentage?: number | null, emissionSources: Array<{ __typename?: 'EmissionSourceType', id?: number | null, ghgSavingPotentialId: number, sourceOfEmission?: string | null, unitName?: string | null, baselineUnitName?: string | null, solutionUnitName?: string | null, baselineConceptName?: string | null, baselineGhgFactor?: number | null, baselineConsumption?: number | null, baselineAssumption?: string | null, baselineEvidence: string, customBaselineConcept?: boolean | null, solutionReducesConsumption?: boolean | null, solutionReducesGhgFactor?: boolean | null, solutionConceptName?: string | null, solutionGhgFactor?: number | null, solutionConsumption?: number | null, solutionAssumption?: string | null, solutionEvidence: string, customSolutionConcept?: boolean | null, specificReductionPerUnit?: number | null, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> }>, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> } | null }>, sdgs: Array<{ __typename?: 'SdgType', id?: number | null, label: string, sublabel: string }>, sdgTargets: Array<{ __typename?: 'SdgTargetType', id?: number | null, label: string, sdgId?: number | null }>, irisCategories: Array<{ __typename?: 'IrisCategoryType', id?: number | null, label: string }>, geographies: Array<{ __typename?: 'GeographyType', id?: number | null, label: string }> }>, targetProgress: { __typename?: 'ImpactGoalProgressType', id: number, hasTarget: boolean, startDate?: number | null, endDate?: number | null, completionRate?: number | null, message?: string | null } } };

export type UpdateImpactMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: ImpactInput;
}>;


export type UpdateImpactMutation = { __typename?: 'ComboMutation', updateImpact: { __typename?: 'ImpactType', id?: number | null, conceptId?: number | null, stakeholder?: string | null, stakeholderCategory?: StakeholderCategoryType | null, isPositive?: boolean | null, theoryOfChange?: string | null, problem?: string | null, problemStatement?: string | null, companyVision?: string | null, targetGroup?: string | null, inputsActivities?: string | null, solutionsOutput?: string | null, shortTermOutcomes?: string | null, longTermImpacts?: string | null, riskReboundEffects?: string | null, euTaxonomy?: EuTaxonomyType | null, initialInvestmentDate?: any | null, startingYear?: number | null, durationYears?: number | null, carryRemarks?: string | null, isEditable: boolean, submitDate?: any | null, hasFrozenOutcome?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, labelI18n: any, description: string, descriptionI18n: any, isSubmeasure: boolean, additionalData?: any | null, sourceUrl: string, citation: string, citationI18n: any, isMaterial: boolean, materialityExplanation: string, materialityExplanationI18n: any, status: ConceptStatus, scheme?: RiskManagementScheme | null, kind?: ConceptKind | null, ixId?: string | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null }>, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, objectLinks: Array<{ __typename?: 'ConceptLinkType', predicate: ConceptPredicateType, object: { __typename?: 'ConceptType', id?: number | null, label: string } }> } | null, sourceAssignments: Array<{ __typename?: 'SourceAssignmentType', id?: number | null, url: string, comment?: string | null }>, impactSolutions: Array<{ __typename?: 'ImpactSolutionType', id?: number | null, impactId: number, targetGroup?: string | null, problemDescription?: string | null, solutionDescription?: string | null, kind?: ImpactSolutionKind | null, ghgSavingPotentialId?: number | null, useGhgSavingPotentialTool?: boolean | null, solutionSource: Array<{ __typename?: 'SolutionSourceType', id?: number | null, url?: string | null, comment?: string | null }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null, ghgSavingPotential?: { __typename?: 'GhgSavingPotentialType', id?: number | null, needFulfilled?: string | null, baselineSolutionDescription?: string | null, comparativeUnit?: string | null, comparativeQuantitiy?: number | null, comparativeUnitConfirmed?: boolean | null, describeComparison?: string | null, isPreciseEmissionCalculation?: boolean | null, simpleBaselineGhg?: number | null, simpleSolutionGhg?: number | null, simpleGhgJustification?: string | null, emissionsConfirmed?: boolean | null, growthFactorJustification?: string | null, isRecurringImpact?: boolean | null, durationOfImpact?: number | null, realisticConfirmation?: boolean | null, impactProfileKind: ImpactProfileKind, isScenarioA?: boolean | null, preComputedBaselineGhg?: number | null, preComputedSolutionGhg?: number | null, scenarioBComments?: string | null, emissionSourceLimitations?: string | null, specificReductionPerUnit?: number | null, specificReductionAsPercentage?: number | null, emissionSources: Array<{ __typename?: 'EmissionSourceType', id?: number | null, ghgSavingPotentialId: number, sourceOfEmission?: string | null, unitName?: string | null, baselineUnitName?: string | null, solutionUnitName?: string | null, baselineConceptName?: string | null, baselineGhgFactor?: number | null, baselineConsumption?: number | null, baselineAssumption?: string | null, baselineEvidence: string, customBaselineConcept?: boolean | null, solutionReducesConsumption?: boolean | null, solutionReducesGhgFactor?: boolean | null, solutionConceptName?: string | null, solutionGhgFactor?: number | null, solutionConsumption?: number | null, solutionAssumption?: string | null, solutionEvidence: string, customSolutionConcept?: boolean | null, specificReductionPerUnit?: number | null, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> }>, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> } | null }>, sdgs: Array<{ __typename?: 'SdgType', id?: number | null, label: string, sublabel: string }>, sdgTargets: Array<{ __typename?: 'SdgTargetType', id?: number | null, label: string, sdgId?: number | null }>, irisCategories: Array<{ __typename?: 'IrisCategoryType', id?: number | null, label: string }>, geographies: Array<{ __typename?: 'GeographyType', id?: number | null, label: string }>, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, metricNameOverride: string, comment?: string | null, reportingPeriodType: MetricReportingPeriodType, isFrozen: boolean, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> } };

export type UpdateImpactGoalMutationVariables = Exact<{
  input: ImpactGoalInput;
}>;


export type UpdateImpactGoalMutation = { __typename?: 'ComboMutation', updateImpactGoal: { __typename?: 'ImpactGoalType', id?: number | null, ventureId: any, isEditable: boolean, activityUrls: Array<string>, ghgStartingYear: number, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, conceptId?: number | null, stakeholder?: string | null, stakeholderCategory?: StakeholderCategoryType | null, isPositive?: boolean | null, theoryOfChange?: string | null, problem?: string | null, problemStatement?: string | null, companyVision?: string | null, targetGroup?: string | null, inputsActivities?: string | null, solutionsOutput?: string | null, shortTermOutcomes?: string | null, longTermImpacts?: string | null, riskReboundEffects?: string | null, euTaxonomy?: EuTaxonomyType | null, initialInvestmentDate?: any | null, startingYear?: number | null, durationYears?: number | null, carryRemarks?: string | null, isEditable: boolean, submitDate?: any | null, hasFrozenOutcome?: boolean | null, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, ghgSavingPotentialId?: number | null, metricNameOverride: string, comment?: string | null, reportingPeriodType: MetricReportingPeriodType, isFrozen: boolean, customTargetWeight: number, unitName: string, customTargetCalculationType: AnnualAggregationMethod, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, labelI18n: any, description: string, descriptionI18n: any, isSubmeasure: boolean, additionalData?: any | null, sourceUrl: string, citation: string, citationI18n: any, isMaterial: boolean, materialityExplanation: string, materialityExplanationI18n: any, status: ConceptStatus, scheme?: RiskManagementScheme | null, kind?: ConceptKind | null, ixId?: string | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null }>, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, objectLinks: Array<{ __typename?: 'ConceptLinkType', predicate: ConceptPredicateType, object: { __typename?: 'ConceptType', id?: number | null, label: string } }> } | null, sourceAssignments: Array<{ __typename?: 'SourceAssignmentType', id?: number | null, url: string, comment?: string | null }>, impactSolutions: Array<{ __typename?: 'ImpactSolutionType', id?: number | null, impactId: number, targetGroup?: string | null, problemDescription?: string | null, solutionDescription?: string | null, kind?: ImpactSolutionKind | null, ghgSavingPotentialId?: number | null, useGhgSavingPotentialTool?: boolean | null, solutionSource: Array<{ __typename?: 'SolutionSourceType', id?: number | null, url?: string | null, comment?: string | null }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null, ghgSavingPotential?: { __typename?: 'GhgSavingPotentialType', id?: number | null, needFulfilled?: string | null, baselineSolutionDescription?: string | null, comparativeUnit?: string | null, comparativeQuantitiy?: number | null, comparativeUnitConfirmed?: boolean | null, describeComparison?: string | null, isPreciseEmissionCalculation?: boolean | null, simpleBaselineGhg?: number | null, simpleSolutionGhg?: number | null, simpleGhgJustification?: string | null, emissionsConfirmed?: boolean | null, growthFactorJustification?: string | null, isRecurringImpact?: boolean | null, durationOfImpact?: number | null, realisticConfirmation?: boolean | null, impactProfileKind: ImpactProfileKind, isScenarioA?: boolean | null, preComputedBaselineGhg?: number | null, preComputedSolutionGhg?: number | null, scenarioBComments?: string | null, emissionSourceLimitations?: string | null, specificReductionPerUnit?: number | null, specificReductionAsPercentage?: number | null, emissionSources: Array<{ __typename?: 'EmissionSourceType', id?: number | null, ghgSavingPotentialId: number, sourceOfEmission?: string | null, unitName?: string | null, baselineUnitName?: string | null, solutionUnitName?: string | null, baselineConceptName?: string | null, baselineGhgFactor?: number | null, baselineConsumption?: number | null, baselineAssumption?: string | null, baselineEvidence: string, customBaselineConcept?: boolean | null, solutionReducesConsumption?: boolean | null, solutionReducesGhgFactor?: boolean | null, solutionConceptName?: string | null, solutionGhgFactor?: number | null, solutionConsumption?: number | null, solutionAssumption?: string | null, solutionEvidence: string, customSolutionConcept?: boolean | null, specificReductionPerUnit?: number | null, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> }>, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> } | null }>, sdgs: Array<{ __typename?: 'SdgType', id?: number | null, label: string, sublabel: string }>, sdgTargets: Array<{ __typename?: 'SdgTargetType', id?: number | null, label: string, sdgId?: number | null }>, irisCategories: Array<{ __typename?: 'IrisCategoryType', id?: number | null, label: string }>, geographies: Array<{ __typename?: 'GeographyType', id?: number | null, label: string }> }>, targetProgress: { __typename?: 'ImpactGoalProgressType', id: number, hasTarget: boolean, startDate?: number | null, endDate?: number | null, completionRate?: number | null, message?: string | null } } };

export type UpdateImpactLeanMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: ImpactInput;
}>;


export type UpdateImpactLeanMutation = { __typename?: 'ComboMutation', updateImpact: { __typename?: 'ImpactType', id?: number | null, euTaxonomy?: EuTaxonomyType | null, sdgTargets: Array<{ __typename?: 'SdgTargetType', id?: number | null, label: string, sdgId?: number | null }>, irisCategories: Array<{ __typename?: 'IrisCategoryType', id?: number | null, label: string }> } };

export type UpsertEmissionSourceMutationVariables = Exact<{
  input: EmissionSourceInput;
}>;


export type UpsertEmissionSourceMutation = { __typename?: 'ComboMutation', upsertEmissionSource?: { __typename?: 'GhgSavingPotentialType', id?: number | null, needFulfilled?: string | null, baselineSolutionDescription?: string | null, comparativeUnit?: string | null, comparativeQuantitiy?: number | null, comparativeUnitConfirmed?: boolean | null, describeComparison?: string | null, isPreciseEmissionCalculation?: boolean | null, simpleBaselineGhg?: number | null, simpleSolutionGhg?: number | null, simpleGhgJustification?: string | null, emissionsConfirmed?: boolean | null, growthFactorJustification?: string | null, isRecurringImpact?: boolean | null, durationOfImpact?: number | null, realisticConfirmation?: boolean | null, impactProfileKind: ImpactProfileKind, isScenarioA?: boolean | null, preComputedBaselineGhg?: number | null, preComputedSolutionGhg?: number | null, scenarioBComments?: string | null, emissionSourceLimitations?: string | null, specificReductionPerUnit?: number | null, specificReductionAsPercentage?: number | null, emissionSources: Array<{ __typename?: 'EmissionSourceType', id?: number | null, ghgSavingPotentialId: number, sourceOfEmission?: string | null, unitName?: string | null, baselineUnitName?: string | null, solutionUnitName?: string | null, baselineConceptName?: string | null, baselineGhgFactor?: number | null, baselineConsumption?: number | null, baselineAssumption?: string | null, baselineEvidence: string, customBaselineConcept?: boolean | null, solutionReducesConsumption?: boolean | null, solutionReducesGhgFactor?: boolean | null, solutionConceptName?: string | null, solutionGhgFactor?: number | null, solutionConsumption?: number | null, solutionAssumption?: string | null, solutionEvidence: string, customSolutionConcept?: boolean | null, specificReductionPerUnit?: number | null, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> }>, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> } | null };

export type UpsertGhgSavingPotentialMutationVariables = Exact<{
  input: GhgSavingPotentialInput;
}>;


export type UpsertGhgSavingPotentialMutation = { __typename?: 'ComboMutation', upsertGhgSavingPotential: { __typename?: 'GhgSavingPotentialType', id?: number | null, needFulfilled?: string | null, baselineSolutionDescription?: string | null, comparativeUnit?: string | null, comparativeQuantitiy?: number | null, comparativeUnitConfirmed?: boolean | null, describeComparison?: string | null, isPreciseEmissionCalculation?: boolean | null, simpleBaselineGhg?: number | null, simpleSolutionGhg?: number | null, simpleGhgJustification?: string | null, emissionsConfirmed?: boolean | null, growthFactorJustification?: string | null, isRecurringImpact?: boolean | null, durationOfImpact?: number | null, realisticConfirmation?: boolean | null, impactProfileKind: ImpactProfileKind, isScenarioA?: boolean | null, preComputedBaselineGhg?: number | null, preComputedSolutionGhg?: number | null, scenarioBComments?: string | null, emissionSourceLimitations?: string | null, specificReductionPerUnit?: number | null, specificReductionAsPercentage?: number | null, emissionSources: Array<{ __typename?: 'EmissionSourceType', id?: number | null, ghgSavingPotentialId: number, sourceOfEmission?: string | null, unitName?: string | null, baselineUnitName?: string | null, solutionUnitName?: string | null, baselineConceptName?: string | null, baselineGhgFactor?: number | null, baselineConsumption?: number | null, baselineAssumption?: string | null, baselineEvidence: string, customBaselineConcept?: boolean | null, solutionReducesConsumption?: boolean | null, solutionReducesGhgFactor?: boolean | null, solutionConceptName?: string | null, solutionGhgFactor?: number | null, solutionConsumption?: number | null, solutionAssumption?: string | null, solutionEvidence: string, customSolutionConcept?: boolean | null, specificReductionPerUnit?: number | null, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> }>, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> } };

export type UpsertImpactSolutionMutationVariables = Exact<{
  input: ImpactSolutionInput;
}>;


export type UpsertImpactSolutionMutation = { __typename?: 'ComboMutation', upsertImpactSolution: { __typename?: 'ImpactSolutionType', id?: number | null, impactId: number, targetGroup?: string | null, problemDescription?: string | null, solutionDescription?: string | null, kind?: ImpactSolutionKind | null, ghgSavingPotentialId?: number | null, useGhgSavingPotentialTool?: boolean | null, solutionSource: Array<{ __typename?: 'SolutionSourceType', id?: number | null, url?: string | null, comment?: string | null }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null, ghgSavingPotential?: { __typename?: 'GhgSavingPotentialType', id?: number | null, needFulfilled?: string | null, baselineSolutionDescription?: string | null, comparativeUnit?: string | null, comparativeQuantitiy?: number | null, comparativeUnitConfirmed?: boolean | null, describeComparison?: string | null, isPreciseEmissionCalculation?: boolean | null, simpleBaselineGhg?: number | null, simpleSolutionGhg?: number | null, simpleGhgJustification?: string | null, emissionsConfirmed?: boolean | null, growthFactorJustification?: string | null, isRecurringImpact?: boolean | null, durationOfImpact?: number | null, realisticConfirmation?: boolean | null, impactProfileKind: ImpactProfileKind, isScenarioA?: boolean | null, preComputedBaselineGhg?: number | null, preComputedSolutionGhg?: number | null, scenarioBComments?: string | null, emissionSourceLimitations?: string | null, specificReductionPerUnit?: number | null, specificReductionAsPercentage?: number | null, emissionSources: Array<{ __typename?: 'EmissionSourceType', id?: number | null, ghgSavingPotentialId: number, sourceOfEmission?: string | null, unitName?: string | null, baselineUnitName?: string | null, solutionUnitName?: string | null, baselineConceptName?: string | null, baselineGhgFactor?: number | null, baselineConsumption?: number | null, baselineAssumption?: string | null, baselineEvidence: string, customBaselineConcept?: boolean | null, solutionReducesConsumption?: boolean | null, solutionReducesGhgFactor?: boolean | null, solutionConceptName?: string | null, solutionGhgFactor?: number | null, solutionConsumption?: number | null, solutionAssumption?: string | null, solutionEvidence: string, customSolutionConcept?: boolean | null, specificReductionPerUnit?: number | null, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> }>, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> } | null } };

export type AddIroSectionLinkMutationVariables = Exact<{
  input: IroSectionLinkInput;
}>;


export type AddIroSectionLinkMutation = { __typename?: 'ComboMutation', addIroSectionLink: { __typename?: 'IroSectionLinkType', id: any } };

export type DelIroSectionLinkMutationVariables = Exact<{
  iroId: Scalars['UUID']['input'];
  sectionId: Scalars['Int']['input'];
}>;


export type DelIroSectionLinkMutation = { __typename?: 'ComboMutation', delIroSectionLink: boolean };

export type UpdateIroSectionLinkMutationVariables = Exact<{
  input: IroSectionLinkInput;
}>;


export type UpdateIroSectionLinkMutation = { __typename?: 'ComboMutation', updateIroSectionLink: { __typename?: 'IroSectionLinkType', id: any } };

export type AddIroStakeholderLinkMutationVariables = Exact<{
  stakeholderId: Scalars['UUID']['input'];
  iroId: Scalars['UUID']['input'];
}>;


export type AddIroStakeholderLinkMutation = { __typename?: 'ComboMutation', addIroStakeholderLink: { __typename?: 'IroStakeholderLinkType', stakeholderId: any, iroId?: any | null } };

export type UpdateIroStakeholderLinkMutationVariables = Exact<{
  input: IroStakeholderLinkInput;
}>;


export type UpdateIroStakeholderLinkMutation = { __typename?: 'ComboMutation', updateIroStakeholderLink: { __typename?: 'IroStakeholderLinkType', id: any, impactMaterial: boolean, financialMaterial: boolean, howAffected: string, relationToRo: string } };

export type AddMetricAggregationMutationVariables = Exact<{
  input: MetricAggregationInput;
}>;


export type AddMetricAggregationMutation = { __typename?: 'ComboMutation', addMetricAggregation: { __typename?: 'MetricAggregationType', id?: number | null, comment?: string | null, calculationType: MetricCalculationType, groupId?: number | null, groupType?: TypeAggregationGroup | null, metricAggregationValues: Array<{ __typename?: 'MetricAggregationValueType', period: string, actual?: number | null, target?: number | null }>, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricAssignments?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, metricNameOverride: string, comment?: string | null, isFrozen: boolean, assigneeId?: any | null, goalTarget?: number | null, goalType?: string | null, reportingPeriodType: MetricReportingPeriodType, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null, funds: Array<{ __typename?: 'FundType', id?: number | null, name?: string | null }>, sfdrStrategies: Array<{ __typename?: 'SfdrStrategyType', id?: number | null, kind: SfdrStrategyKind, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }> } };

export type AddMetricAggregationBatchMutationVariables = Exact<{
  inputs: Array<MetricAggregationInput> | MetricAggregationInput;
}>;


export type AddMetricAggregationBatchMutation = { __typename?: 'ComboMutation', addMetricAggregationBatch: Array<{ __typename?: 'MetricAggregationType', id?: number | null }> };

export type BatchLockMetricAssignmentValuesMutationVariables = Exact<{
  input: BatchMetricValueLockInput;
}>;


export type BatchLockMetricAssignmentValuesMutation = { __typename?: 'ComboMutation', batchLockMetricAssignmentValues: Array<{ __typename?: 'MetricAssignmentType', id?: number | null }> };

export type BatchLockMetricAssignmentValuesGranularMutationVariables = Exact<{
  input: BatchMetricValueGranularLockInput;
}>;


export type BatchLockMetricAssignmentValuesGranularMutation = { __typename?: 'ComboMutation', batchLockMetricAssignmentValuesGranular: { __typename?: 'BatchMetricValueGranularLockResult', updatedMetricAssignmentIds: Array<number>, errors: Array<{ __typename?: 'BatchMetricValueLockError', metricAssignmentId: number, message: string }> } };

export type RecalculateComputedKpisInPortfolioMutationVariables = Exact<{
  portfolioId: Scalars['UUID']['input'];
}>;


export type RecalculateComputedKpisInPortfolioMutation = { __typename?: 'ComboMutation', recalculateComputedKpisInPortfolio: string };

export type AddQuestionnaireMutationVariables = Exact<{
  ventureIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  sectionIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  periodId?: InputMaybe<Scalars['Int']['input']>;
  referencePeriod?: InputMaybe<ReferencePeriodInput>;
  doSendNotification?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AddQuestionnaireMutation = { __typename?: 'ComboMutation', addQuestionnaire: Array<{ __typename?: 'QuestionnaireType', updatedAt?: any | null, id?: number | null, ventureId: any, label: string, isEditable: boolean }> };

export type AddTemplateTextMutationVariables = Exact<{
  input: TemplateTextInput;
}>;


export type AddTemplateTextMutation = { __typename?: 'ComboMutation', addTemplateText: { __typename?: 'TemplateTextType', id: number, text: string, conds?: any | null, questionId: number, ixId?: string | null } };

export type CreateUserinputConceptLinkWithCustomSelectedConceptMutationVariables = Exact<{
  userInputId: Scalars['Int']['input'];
  concept: ConceptInput;
  implementationStatus?: InputMaybe<ImplementationStatus>;
  parentConceptId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateUserinputConceptLinkWithCustomSelectedConceptMutation = { __typename?: 'ComboMutation', createUserinputConceptLinkWithCustomSelectedConcept: { __typename?: 'UserInputConceptLinkType', implementationStatus: ImplementationStatus, comment: string, userInputId?: number | null, conceptId?: number | null, concept: { __typename?: 'ConceptType', id?: number | null, label: string, scheme?: RiskManagementScheme | null, description: string, isSubmeasure: boolean } } };

export type DeletePromptTemplateVersionMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeletePromptTemplateVersionMutation = { __typename?: 'ComboMutation', deletePromptTemplateVersion: boolean };

export type DeleteQuestionnaireAndUserInputsMutationVariables = Exact<{
  questionnaireIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type DeleteQuestionnaireAndUserInputsMutation = { __typename?: 'ComboMutation', deleteQuestionnaireAndUserInputs: boolean };

export type DeleteTemplateTextMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteTemplateTextMutation = { __typename?: 'ComboMutation', deleteTemplateText: boolean };

export type SubmitQuestionnaireMutationVariables = Exact<{
  questionnaireId: Scalars['Int']['input'];
  isEditable: Scalars['Boolean']['input'];
}>;


export type SubmitQuestionnaireMutation = { __typename?: 'ComboMutation', submitQuestionnaire: { __typename?: 'QuestionnaireAssignmentType', id?: number | null, isEditable: boolean, updatedAt?: any | null, period?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null } | null, userInputs: Array<{ __typename?: 'UserInputType', id?: number | null, isActive: boolean, isNotRelevant?: boolean | null, geographyIds?: Array<number> | null, text?: string | null, scoringRule?: any | null, question: { __typename?: 'QuestionType', id?: number | null, label: string, component: string }, selectedOptions?: Array<{ __typename?: 'OptionType', id?: number | null, label?: string | null }> | null, selectedConcepts: Array<{ __typename?: 'UserInputConceptLinkType', implementationStatus: ImplementationStatus, comment: string, userInputId?: number | null, conceptId?: number | null, concept: { __typename?: 'ConceptType', id?: number | null, label: string, scheme?: RiskManagementScheme | null, description: string, isSubmeasure: boolean } }> }>, sectionCompletion: Array<{ __typename?: 'SectionCompletionType', sectionId: number, isCompleted: boolean, percentageCompleted: number, numberRequired: number, numberIncomplete: number, incompleteQuestions: Array<string> }>, questionnaireResults: Array<{ __typename?: 'QuestionnaireResultType', id?: number | null, sectionId?: number | null, sectionLabel: string, score?: number | null, details?: any | null }> } };

export type UnlinkSelectedConceptMutationVariables = Exact<{
  userInputId: Scalars['Int']['input'];
  conceptId: Scalars['Int']['input'];
}>;


export type UnlinkSelectedConceptMutation = { __typename?: 'ComboMutation', unlinkSelectedConcept: { __typename?: 'UserInputType', id?: number | null, isActive: boolean, isNotRelevant?: boolean | null, geographyIds?: Array<number> | null, text?: string | null, scoringRule?: any | null, question: { __typename?: 'QuestionType', id?: number | null, label: string, component: string }, selectedOptions?: Array<{ __typename?: 'OptionType', id?: number | null, label?: string | null }> | null, selectedConcepts: Array<{ __typename?: 'UserInputConceptLinkType', implementationStatus: ImplementationStatus, comment: string, userInputId?: number | null, conceptId?: number | null, concept: { __typename?: 'ConceptType', id?: number | null, label: string, scheme?: RiskManagementScheme | null, description: string, isSubmeasure: boolean } }> } };

export type UpdateQuestionnaireMutationVariables = Exact<{
  input: QuestionnaireInput;
}>;


export type UpdateQuestionnaireMutation = { __typename?: 'ComboMutation', updateQuestionnaire: { __typename?: 'QuestionnaireType', id?: number | null, isEditable: boolean } };

export type UpdateConceptMutationVariables = Exact<{
  input: ConceptInput;
}>;


export type UpdateConceptMutation = { __typename?: 'ComboMutation', updateConcept: { __typename?: 'ConceptType', id?: number | null, label: string, labelI18n: any, description: string, descriptionI18n: any, isSubmeasure: boolean, additionalData?: any | null, sourceUrl: string, citation: string, citationI18n: any, isMaterial: boolean, materialityExplanation: string, materialityExplanationI18n: any, status: ConceptStatus, scheme?: RiskManagementScheme | null, kind?: ConceptKind | null, ixId?: string | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null }>, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, objectLinks: Array<{ __typename?: 'ConceptLinkType', predicate: ConceptPredicateType, object: { __typename?: 'ConceptType', id?: number | null, label: string } }> } };

export type UpdateQuestionMutationVariables = Exact<{
  input: QuestionInput;
}>;


export type UpdateQuestionMutation = { __typename?: 'ComboMutation', updateQuestion: { __typename?: 'QuestionType', id?: number | null, ixId?: string | null, component: string, tooltip?: string | null, tooltipI18n: any, label: string, labelI18n: any, sublabel?: string | null, sublabelI18n: any, isMultiple?: boolean | null, isMandatory: boolean, scoringRules?: any | null, templateEngineContext?: TemplateEngineContext | null } };

export type UpdateQuestionSectionLinkMutationVariables = Exact<{
  input: QuestionSectionLinkInput;
}>;


export type UpdateQuestionSectionLinkMutation = { __typename?: 'ComboMutation', updateQuestionSectionLink: { __typename?: 'QuestionSectionLinkType', sort: number, labelI18n?: any | null, sublabelI18n?: any | null, tooltipI18n?: any | null } };

export type UpdateQuestionnaireNavigationMutationVariables = Exact<{
  input: QuestionnaireNavigationInput;
}>;


export type UpdateQuestionnaireNavigationMutation = { __typename?: 'ComboMutation', updateQuestionnaireNavigation: { __typename?: 'QuestionnaireNavigationType', id?: number | null, currentSection?: number | null, currentSubsection?: number | null } };

export type UpdateSelectedConceptMutationVariables = Exact<{
  input: UserInputConceptLinkInput;
}>;


export type UpdateSelectedConceptMutation = { __typename?: 'ComboMutation', updateSelectedConcept: { __typename?: 'UserInputType', id?: number | null, isActive: boolean, isNotRelevant?: boolean | null, geographyIds?: Array<number> | null, text?: string | null, scoringRule?: any | null, question: { __typename?: 'QuestionType', id?: number | null, label: string, component: string }, selectedOptions?: Array<{ __typename?: 'OptionType', id?: number | null, label?: string | null }> | null, selectedConcepts: Array<{ __typename?: 'UserInputConceptLinkType', implementationStatus: ImplementationStatus, comment: string, userInputId?: number | null, conceptId?: number | null, concept: { __typename?: 'ConceptType', id?: number | null, label: string, scheme?: RiskManagementScheme | null, description: string, isSubmeasure: boolean } }> } };

export type UpdateSelectedOptionsMutationVariables = Exact<{
  userInputId: Scalars['Int']['input'];
  values: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateSelectedOptionsMutation = { __typename?: 'ComboMutation', updateSelectedOptions: { __typename?: 'QuestionnaireAssignmentType', id?: number | null, isEditable: boolean, updatedAt?: any | null, period?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null } | null, userInputs: Array<{ __typename?: 'UserInputType', id?: number | null, isActive: boolean, isNotRelevant?: boolean | null, geographyIds?: Array<number> | null, text?: string | null, scoringRule?: any | null, question: { __typename?: 'QuestionType', id?: number | null, label: string, component: string }, selectedOptions?: Array<{ __typename?: 'OptionType', id?: number | null, label?: string | null }> | null, selectedConcepts: Array<{ __typename?: 'UserInputConceptLinkType', implementationStatus: ImplementationStatus, comment: string, userInputId?: number | null, conceptId?: number | null, concept: { __typename?: 'ConceptType', id?: number | null, label: string, scheme?: RiskManagementScheme | null, description: string, isSubmeasure: boolean } }> }>, sectionCompletion: Array<{ __typename?: 'SectionCompletionType', sectionId: number, isCompleted: boolean, percentageCompleted: number, numberRequired: number, numberIncomplete: number, incompleteQuestions: Array<string> }>, questionnaireResults: Array<{ __typename?: 'QuestionnaireResultType', id?: number | null, sectionId?: number | null, sectionLabel: string, score?: number | null, details?: any | null }> } };

export type UpdateTemplateTextMutationVariables = Exact<{
  input: TemplateTextInput;
}>;


export type UpdateTemplateTextMutation = { __typename?: 'ComboMutation', updateTemplateText: { __typename?: 'TemplateTextType', id: number, text: string, conds?: any | null, questionId: number, ixId?: string | null } };

export type UpdateTextMutationVariables = Exact<{
  userInputId: Scalars['Int']['input'];
  text: Scalars['String']['input'];
}>;


export type UpdateTextMutation = { __typename?: 'ComboMutation', updateText: { __typename?: 'QuestionnaireAssignmentType', id?: number | null, userInputs: Array<{ __typename?: 'UserInputType', id?: number | null }> } };

export type UpdateUserInputMutationVariables = Exact<{
  input: UserInputInput;
}>;


export type UpdateUserInputMutation = { __typename?: 'ComboMutation', updateUserInput: { __typename?: 'QuestionnaireAssignmentType', id?: number | null, isEditable: boolean, updatedAt?: any | null, period?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null } | null, userInputs: Array<{ __typename?: 'UserInputType', id?: number | null, isActive: boolean, isNotRelevant?: boolean | null, geographyIds?: Array<number> | null, text?: string | null, scoringRule?: any | null, question: { __typename?: 'QuestionType', id?: number | null, label: string, component: string }, selectedOptions?: Array<{ __typename?: 'OptionType', id?: number | null, label?: string | null }> | null, selectedConcepts: Array<{ __typename?: 'UserInputConceptLinkType', implementationStatus: ImplementationStatus, comment: string, userInputId?: number | null, conceptId?: number | null, concept: { __typename?: 'ConceptType', id?: number | null, label: string, scheme?: RiskManagementScheme | null, description: string, isSubmeasure: boolean } }> }>, sectionCompletion: Array<{ __typename?: 'SectionCompletionType', sectionId: number, isCompleted: boolean, percentageCompleted: number, numberRequired: number, numberIncomplete: number, incompleteQuestions: Array<string> }>, questionnaireResults: Array<{ __typename?: 'QuestionnaireResultType', id?: number | null, sectionId?: number | null, sectionLabel: string, score?: number | null, details?: any | null }> } };

export type UpsertEsgComparisonMutationVariables = Exact<{
  input: QuestionnaireComparisonInput;
}>;


export type UpsertEsgComparisonMutation = { __typename?: 'ComboMutation', upsertEsgComparison: { __typename?: 'QuestionnaireComparisonType', firstQuestionnaireId?: number | null, secondQuestionnaireId?: number | null, commentE?: string | null, commentS?: string | null, commentG?: string | null } };

export type UpsertOptionMutationVariables = Exact<{
  input: OptionInput;
}>;


export type UpsertOptionMutation = { __typename?: 'ComboMutation', upsertOption: { __typename?: 'OptionType', id?: number | null, labelI18n: any, label?: string | null, sublabel?: string | null, tooltip?: string | null, ixId?: string | null } };

export type UpsertPromptTemplateMutationVariables = Exact<{
  input: PromptTemplateInput;
}>;


export type UpsertPromptTemplateMutation = { __typename?: 'ComboMutation', upsertPromptTemplate: { __typename?: 'PromptTemplateType', id?: any | null, questionId: number, ixId: string, purpose?: string | null, latestVersionId?: any | null, isActive?: boolean | null, createdBy?: string | null } };

export type UpsertPromptTemplateVersionMutationVariables = Exact<{
  input: PromptTemplateVersionInput;
}>;


export type UpsertPromptTemplateVersionMutation = { __typename?: 'ComboMutation', upsertPromptTemplateVersion: { __typename?: 'PromptTemplateVersionType', id?: any | null, promptTemplateId: any, version: number, systemTemplate?: string | null, userTemplate: string, inputSchema?: any | null, outputSchema?: any | null, model: string, params?: any | null, notes?: string | null, createdBy?: string | null, createdAt: any, appendCompanyWebsiteScrape?: boolean | null } };

export type DeleteReportingRequestMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteReportingRequestMutation = { __typename?: 'ComboMutation', deleteReportingRequest: boolean };

export type UpsertReportingRequestMutationVariables = Exact<{
  input: UpsertReportingRequestInput;
}>;


export type UpsertReportingRequestMutation = { __typename?: 'ComboMutation', upsertReportingRequest: { __typename?: 'ReportingRequestGraphType', id: any, fundId?: number | null, requestType: ReportingRequestType, title: string, description: string, referencePeriod: string, dueDate?: any | null, ventures: Array<{ __typename?: 'ReportingRequestVentureGraphType', ventureId: any, status: ReportingVentureStatus, metricIds: Array<number> }> } };

export type BatchSubmitReviewEventMutationVariables = Exact<{
  input: BatchSubmitReviewEventInput;
}>;


export type BatchSubmitReviewEventMutation = { __typename?: 'ComboMutation', batchSubmitReviewEvent: { __typename?: 'BatchSubmitReviewEventResultGraphType', successCount: number, failureCount: number, results: Array<{ __typename?: 'BatchSubmitReviewEventItemGraphType', ventureId: any, ok: boolean, error?: string | null, event?: { __typename?: 'ReviewEventGraphType', id: any, eventType: ReviewEventType, comment: string, createdAt: any } | null }> } };

export type DeleteReviewRequestMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteReviewRequestMutation = { __typename?: 'ComboMutation', deleteReviewRequest: boolean };

export type SubmitReviewEventMutationVariables = Exact<{
  input: SubmitReviewEventInput;
}>;


export type SubmitReviewEventMutation = { __typename?: 'ComboMutation', submitReviewEvent: { __typename?: 'ReviewEventGraphType', id: any, eventType: ReviewEventType, comment: string, createdAt: any, snapshot?: any | null } };

export type UpsertReviewRequestMutationVariables = Exact<{
  input: UpsertReviewRequestInput;
}>;


export type UpsertReviewRequestMutation = { __typename?: 'ComboMutation', upsertReviewRequest: { __typename?: 'ReviewRequestGraphType', id: any, title: string, description: string, assignedReviewers: Array<{ __typename?: 'UserType', id: any, email: string }>, ventures: Array<{ __typename?: 'ReviewRequestVentureGraphType', ventureId: any, status: ReviewVentureStatus }> } };

export type DelSectionMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DelSectionMutation = { __typename?: 'ComboMutation', delSection: boolean };

export type UpdateSectionMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: SectionInput;
}>;


export type UpdateSectionMutation = { __typename?: 'ComboMutation', updateSection: { __typename?: 'SectionType', id?: number | null, label?: string | null, labelI18n: any, sort: number, parentId?: number | null, taxonomyId?: number | null, sectionKind?: EnumSectionKind | null, parent?: { __typename?: 'SectionType', id?: number | null, label?: string | null } | null, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null } };

export type AddStakeholderMutationVariables = Exact<{
  stakeholder: StakeholderInput;
  activityId?: InputMaybe<Scalars['UUID']['input']>;
  iroId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type AddStakeholderMutation = { __typename?: 'ComboMutation', addStakeholder: { __typename?: 'StakeholderType', id: any, name: string, type: string, description: string } };

export type DelStakeholderMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DelStakeholderMutation = { __typename?: 'ComboMutation', delStakeholder: boolean };

export type DelIroStakeholderLinkMutationVariables = Exact<{
  iroId: Scalars['UUID']['input'];
  stakeholderId: Scalars['UUID']['input'];
}>;


export type DelIroStakeholderLinkMutation = { __typename?: 'ComboMutation', delIroStakeholderLink: boolean };

export type DelActivityStakeholderLinkMutationVariables = Exact<{
  activityId: Scalars['UUID']['input'];
  stakeholderId: Scalars['UUID']['input'];
}>;


export type DelActivityStakeholderLinkMutation = { __typename?: 'ComboMutation', delActivityStakeholderLink: boolean };

export type UpdateStakeholderMutationVariables = Exact<{
  stakeholder: StakeholderInput;
}>;


export type UpdateStakeholderMutation = { __typename?: 'ComboMutation', updateStakeholder: { __typename?: 'StakeholderType', id: any, name: string, type: string, description: string } };

export type DeleteTaxonomyMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteTaxonomyMutation = { __typename?: 'ComboMutation', deleteTaxonomy: boolean };

export type UpsertTaxonomyMutationVariables = Exact<{
  input: TaxonomyInput;
}>;


export type UpsertTaxonomyMutation = { __typename?: 'ComboMutation', upsertTaxonomy: { __typename?: 'TaxonomyType', id?: number | null, label: string, shortLabel?: string | null, description?: string | null, version?: string | null, notionId?: string | null, sections: Array<{ __typename?: 'SectionType', id?: number | null, label?: string | null }> } };

export type UpdateUserFeedbackMutationVariables = Exact<{
  feedbackInput: UserFeedbackInput;
}>;


export type UpdateUserFeedbackMutation = { __typename?: 'ComboMutation', updateUserFeedback?: { __typename?: 'UserFeedbackType', id?: number | null, accountId: any, conceptId: number, insightId: any, feedbackType: string, additionalComments?: string | null, additionalData?: any | null } | null };

export type AcceptCompanyInviteMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type AcceptCompanyInviteMutation = { __typename?: 'ComboMutation', acceptCompanyInvite: { __typename?: 'AcceptCompanyInviteResult', success: boolean, message: string, accountId?: any | null } };

export type AddFeedbackMutationVariables = Exact<{
  payload: FeedbackInput;
}>;


export type AddFeedbackMutation = { __typename?: 'ComboMutation', addFeedback: boolean };

export type AddUserMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  accountId: Scalars['String']['input'];
  token: Scalars['String']['input'];
  hasAcceptedPortfolioSharing?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AddUserMutation = { __typename?: 'ComboMutation', addUser: { __typename?: 'UserType', firstName?: string | null, lastName?: string | null, email: string } };

export type AddVentureAndUserMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  ventureName: Scalars['String']['input'];
  impactGoalToken?: InputMaybe<Scalars['String']['input']>;
  impactStrategy?: InputMaybe<Scalars['Boolean']['input']>;
  hasAcceptedPortfolioSharing?: InputMaybe<Scalars['Boolean']['input']>;
  esgToken?: InputMaybe<Scalars['String']['input']>;
  metricsToken?: InputMaybe<Scalars['String']['input']>;
  companyInfo?: InputMaybe<Scalars['Boolean']['input']>;
  accountId: Scalars['String']['input'];
  logo?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddVentureAndUserMutation = { __typename?: 'ComboMutation', addVentureAndUser: { __typename?: 'UserType', firstName?: string | null, lastName?: string | null, email: string } };

export type CreateVentureAccountAndInviteUserMutationVariables = Exact<{
  ventureName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  modules?: InputMaybe<Array<Module> | Module>;
}>;


export type CreateVentureAccountAndInviteUserMutation = { __typename?: 'ComboMutation', createVentureAccountAndInviteUser: { __typename?: 'CreateVentureAccountAndInviteUserResult', success: boolean, message: string, ventureId?: any | null } };

export type InviteUserMutationVariables = Exact<{
  ventureId: Scalars['UUID']['input'];
  email: Scalars['String']['input'];
}>;


export type InviteUserMutation = { __typename?: 'ComboMutation', inviteUser: { __typename?: 'InviteUserResult', success: boolean, message: string } };

export type SetIxAdminMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  isIxAdmin: Scalars['Boolean']['input'];
}>;


export type SetIxAdminMutation = { __typename?: 'ComboMutation', setIxAdmin: { __typename?: 'UserType', id: any, isIxAdmin?: boolean | null, isAdmin: boolean } };

export type UpdateRealUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateRealUserMutation = { __typename?: 'ComboMutation', updateRealUser: { __typename?: 'UserType', id: any, firstName?: string | null, lastName?: string | null, email: string, locale: string } };

export type AddValueChainMutationVariables = Exact<{
  valueChain: ValueChainInput;
}>;


export type AddValueChainMutation = { __typename?: 'ComboMutation', addValueChain: { __typename?: 'ValueChainType', id: any, name: string } };

export type DeleteValueChainMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteValueChainMutation = { __typename?: 'ComboMutation', deleteValueChain: boolean };

export type ListValueChainsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListValueChainsQuery = { __typename?: 'ComboQuery', listValueChains: Array<{ __typename?: 'ValueChainType', id: any, name: string, activities: Array<{ __typename?: 'ActivityType', id: any, name: string, type: EnumActivityType, geographyId?: number | null, location: string, sortOrder: number, riskProfile: EnumActivityRiskProfile, IROs: Array<{ __typename?: 'IROType', id: any, type: EnumIroType, name: string }> }> }> };

export type UpdateValueChainMutationVariables = Exact<{
  valueChain: ValueChainInput;
}>;


export type UpdateValueChainMutation = { __typename?: 'ComboMutation', updateValueChain: { __typename?: 'ValueChainType', id: any, name: string } };

export type AddQuestionnaireSectionLinkMutationVariables = Exact<{
  questionnaireId: Scalars['Int']['input'];
  sectionId: Scalars['Int']['input'];
}>;


export type AddQuestionnaireSectionLinkMutation = { __typename?: 'ComboMutation', addQuestionnaireSectionLink: boolean };

export type AddSectionMutationVariables = Exact<{
  input: SectionInput;
}>;


export type AddSectionMutation = { __typename?: 'ComboMutation', addSection: { __typename?: 'SectionType', label?: string | null, description?: string | null, id?: number | null, externalId?: string | null, ixId?: string | null, sort: number, labelI18n: any, descriptionI18n: any, taxonomyId?: number | null } };

export type DelQuestionnaireSectionLinkMutationVariables = Exact<{
  questionnaireId: Scalars['Int']['input'];
  sectionId: Scalars['Int']['input'];
}>;


export type DelQuestionnaireSectionLinkMutation = { __typename?: 'ComboMutation', delQuestionnaireSectionLink: boolean };

export type GetDisclosureSummaryQueryVariables = Exact<{
  fundId: Scalars['Int']['input'];
  reportType: ReportType;
  referencePeriod: Scalars['Int']['input'];
}>;


export type GetDisclosureSummaryQuery = { __typename?: 'ComboQuery', getDisclosureSummary: { __typename?: 'DisclosureSummaryType', summary: string } };

export type GetMetricAggregationQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetMetricAggregationQuery = { __typename?: 'ComboQuery', getMetricAggregation: { __typename?: 'MetricAggregationType', id?: number | null, comment?: string | null, calculationType: MetricCalculationType, groupId?: number | null, groupType?: TypeAggregationGroup | null, metricAggregationValues: Array<{ __typename?: 'MetricAggregationValueType', period: string, actual?: number | null, target?: number | null }>, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricAssignments?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, metricNameOverride: string, comment?: string | null, isFrozen: boolean, assigneeId?: any | null, goalTarget?: number | null, goalType?: string | null, reportingPeriodType: MetricReportingPeriodType, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null, funds: Array<{ __typename?: 'FundType', id?: number | null, name?: string | null }>, sfdrStrategies: Array<{ __typename?: 'SfdrStrategyType', id?: number | null, kind: SfdrStrategyKind, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }> } };

export type GetSectionQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetSectionQuery = { __typename?: 'ComboQuery', getSection: { __typename?: 'SectionType', id?: number | null, label?: string | null, labelI18n: any, sublabelI18n: any, sort: number, parentId?: number | null, taxonomyId?: number | null, sectionKind?: EnumSectionKind | null, parent?: { __typename?: 'SectionType', id?: number | null, label?: string | null } | null, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, sections: Array<{ __typename?: 'SectionType', id?: number | null, label?: string | null, labelI18n: any, sort: number, taxonomyId?: number | null, parentId?: number | null, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, questions: Array<{ __typename?: 'QuestionType', id?: number | null, label: string, sublabel?: string | null, tooltip?: string | null, scoringRules?: any | null, isMultiple?: boolean | null, isMandatory: boolean, createdAt: any, updatedAt?: any | null }>, sections: Array<{ __typename?: 'SectionType', id?: number | null, label?: string | null, labelI18n: any, sort: number, taxonomyId?: number | null, parentId?: number | null, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, sections: Array<{ __typename?: 'SectionType', id?: number | null, label?: string | null, labelI18n: any, sort: number, taxonomyId?: number | null, parentId?: number | null, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, sections: Array<{ __typename?: 'SectionType', id?: number | null, label?: string | null, labelI18n: any, sort: number, taxonomyId?: number | null, parentId?: number | null, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, sections: Array<{ __typename?: 'SectionType', id?: number | null, label?: string | null, labelI18n: any, sort: number, taxonomyId?: number | null, parentId?: number | null, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null }> }> }> }> }> } };

export type GetTeamMemberLinkQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  role?: InputMaybe<AccountMembershipRole>;
}>;


export type GetTeamMemberLinkQuery = { __typename?: 'ComboQuery', getTeamMemberLink: string };

export type ListIroSectionLinksQueryVariables = Exact<{
  iroId: Scalars['UUID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListIroSectionLinksQuery = { __typename?: 'ComboQuery', countIroSectionLinks: number, listIroSectionLinks: Array<{ __typename?: 'IroSectionLinkType', id: any, iroId: any, sectionId: number, iro: { __typename?: 'IROType', id: any, name: string }, section: { __typename?: 'SectionType', id?: number | null, label?: string | null } }> };

export type ListIroStakeholderLinksQueryVariables = Exact<{
  iroId: Scalars['UUID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListIroStakeholderLinksQuery = { __typename?: 'ComboQuery', countIroStakeholderLinks: number, listIroStakeholderLinks: Array<{ __typename?: 'IroStakeholderLinkType', id: any, iroId?: any | null, stakeholderId: any, impactMaterial: boolean, financialMaterial: boolean, howAffected: string, relationToRo: string, iro?: { __typename?: 'IROType', id: any, name: string } | null, stakeholder: { __typename?: 'StakeholderType', id: any, name: string, type: string, description: string } }> };

export type GetIroQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetIroQuery = { __typename?: 'ComboQuery', getIro: { __typename?: 'IROType', id: any, name: string, type: EnumIroType, description: string, accountId: any, activityId?: any | null, levelOfImpact?: EnumIroLevelOfImpact | null, likelihood?: number | null, likelihoodReason?: string | null, finalSeverity?: number | null, severity?: number | null, severityReason?: string | null, scale?: number | null, scope?: number | null, irremediability?: number | null, finalAssessmentReason?: string | null, overrideStatus?: EnumIroOverrideStatus | null, overrideReason?: string | null, status?: EnumIroStatus | null, magnitude?: number | null, magnitudeReason?: string | null, activity?: { __typename?: 'ActivityType', valueChainId: any, name: string, geographyId?: number | null } | null } };

export type ListIrosQueryVariables = Exact<{
  input?: InputMaybe<IroQueryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListIrosQuery = { __typename?: 'ComboQuery', countIros: number, listIros: Array<{ __typename?: 'IROType', id: any, name: string, type: EnumIroType, description: string, accountId: any, activityId?: any | null, likelihood?: number | null, magnitude?: number | null, severity?: number | null, finalSeverity?: number | null, scale?: number | null, scope?: number | null, irremediability?: number | null, levelOfImpact?: EnumIroLevelOfImpact | null, status?: EnumIroStatus | null, overrideStatus?: EnumIroOverrideStatus | null, activity?: { __typename?: 'ActivityType', id: any, name: string, type: EnumActivityType, geographyId?: number | null } | null, stakeholderLinks?: Array<{ __typename?: 'IroStakeholderLinkType', stakeholder: { __typename?: 'StakeholderType', id: any, name: string, type: string } }> | null, sectionLinks?: Array<{ __typename?: 'IroSectionLinkType', section: { __typename?: 'SectionType', id?: number | null, label?: string | null, parent?: { __typename?: 'SectionType', id?: number | null, label?: string | null, parent?: { __typename?: 'SectionType', id?: number | null, label?: string | null } | null } | null } }> | null }> };

export type UpdateAllIroStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type UpdateAllIroStatusesQuery = { __typename?: 'ComboQuery', updateAllIroStatuses: Array<{ __typename?: 'IroUpdateType', id: any, baseStatus: EnumIroStatus, newStatus: EnumIroStatus }> };

export type ListAuditLogsQueryVariables = Exact<{
  tableName?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  operationType?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  createdById?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  dataId?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  excludeSystemUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ListAuditLogsQuery = { __typename?: 'ComboQuery', countAuditLogs: number, listAuditLogs?: Array<{ __typename?: 'AuditLogType', id: any, tableName?: string | null, operationType?: string | null, dataId: any, originalData?: any | null, newData?: any | null, createdAt?: any | null, context: any, createdBy?: { __typename?: 'UserType', email: string, firstName?: string | null, lastName?: string | null, isAdmin: boolean } | null }> | null };

export type ListEsrsSectionsQueryVariables = Exact<{
  filters?: InputMaybe<SectionFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListEsrsSectionsQuery = { __typename?: 'ComboQuery', countSections: number, listSections: Array<{ __typename?: 'SectionType', id?: number | null, label?: string | null, labelI18n: any, sort: number, taxonomyId?: number | null, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, sections: Array<{ __typename?: 'SectionType', id?: number | null, label?: string | null, labelI18n: any, sort: number, taxonomyId?: number | null, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, sections: Array<{ __typename?: 'SectionType', id?: number | null, label?: string | null, labelI18n: any, sort: number, taxonomyId?: number | null, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, sections: Array<{ __typename?: 'SectionType', id?: number | null, label?: string | null, labelI18n: any, sort: number, taxonomyId?: number | null, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, sections: Array<{ __typename?: 'SectionType', id?: number | null, label?: string | null, labelI18n: any, sort: number, taxonomyId?: number | null, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, sections: Array<{ __typename?: 'SectionType', id?: number | null, label?: string | null, labelI18n: any, sort: number, taxonomyId?: number | null, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, iroLinks?: Array<{ __typename?: 'IroSectionLinkType', id: any, iroId: any, sectionId: number, iro: { __typename?: 'IROType', id: any, name: string, type: EnumIroType, description: string, accountId: any, activityId?: any | null, likelihood?: number | null, severity?: number | null, scale?: number | null, scope?: number | null, irremediability?: number | null, status?: EnumIroStatus | null } }> | null, accountLinks?: Array<{ __typename?: 'AccountSectionLinkType', id: any, accountId: any, sectionId: number, comment: string }> | null }> }> }>, iroLinks?: Array<{ __typename?: 'IroSectionLinkType', id: any, iroId: any, sectionId: number, iro: { __typename?: 'IROType', id: any, name: string, type: EnumIroType, description: string, accountId: any, activityId?: any | null, likelihood?: number | null, severity?: number | null, scale?: number | null, scope?: number | null, irremediability?: number | null, status?: EnumIroStatus | null } }> | null, accountLinks?: Array<{ __typename?: 'AccountSectionLinkType', id: any, accountId: any, sectionId: number, comment: string }> | null }>, iroLinks?: Array<{ __typename?: 'IroSectionLinkType', id: any, iroId: any, sectionId: number, iro: { __typename?: 'IROType', id: any, name: string, type: EnumIroType, description: string, accountId: any, activityId?: any | null, likelihood?: number | null, severity?: number | null, scale?: number | null, scope?: number | null, irremediability?: number | null, status?: EnumIroStatus | null } }> | null, accountLinks?: Array<{ __typename?: 'AccountSectionLinkType', id: any, accountId: any, sectionId: number, comment: string }> | null }> }> };

export type ListMetricAggregationsQueryVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  metricIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  includeUncategorized?: InputMaybe<Scalars['Boolean']['input']>;
  sectionIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortParam> | SortParam>;
  fundId?: InputMaybe<Scalars['Int']['input']>;
  isPaiResultsView?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ListMetricAggregationsQuery = { __typename?: 'ComboQuery', countMetricAggregations: number, listMetricAggregations: Array<{ __typename?: 'MetricAggregationType', id?: number | null, comment?: string | null, groupId?: number | null, groupType?: TypeAggregationGroup | null, calculationType: MetricCalculationType, paiMetricName?: string | null, indicator: string, category?: string | null, paiSort?: number | null, metricAggregationValues: Array<{ __typename?: 'MetricAggregationValueType', period: string, actual?: number | null, target?: number | null, actualCompleted: Array<{ __typename?: 'AccountType', name?: string | null, id: any }>, required: Array<{ __typename?: 'AccountType', name?: string | null, id: any }> }>, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, fund?: { __typename?: 'FundType', id?: number | null, name?: string | null } | null, sfdrStrategy?: { __typename?: 'SfdrStrategyType', id?: number | null, kind: SfdrStrategyKind, fund?: { __typename?: 'FundType', name?: string | null } | null, concept?: { __typename?: 'ConceptType', label: string } | null } | null }>, listMetricAggregationCategoryCounts: Array<{ __typename?: 'MetricAggregationCategoryCountType', categoryId?: number | null, count: number }>, listMetricAggregationSectionCounts: Array<{ __typename?: 'MetricAggregationSectionCountType', sectionId?: number | null, count: number }> };

export type ListMetricsQueryVariables = Exact<{
  input: MetricQueryInput;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListMetricsQuery = { __typename?: 'ComboQuery', countMetrics: number, listMetrics: Array<{ __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> }> };

export type ListSectionsQueryVariables = Exact<{
  filters?: InputMaybe<SectionFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListSectionsQuery = { __typename?: 'ComboQuery', countSections: number, listSections: Array<{ __typename?: 'SectionType', id?: number | null, label?: string | null, labelI18n: any, sort: number, parentId?: number | null, taxonomyId?: number | null, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, sections: Array<{ __typename?: 'SectionType', id?: number | null, label?: string | null, labelI18n: any, sort: number, taxonomyId?: number | null, parentId?: number | null, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, sections: Array<{ __typename?: 'SectionType', id?: number | null, label?: string | null, labelI18n: any, sort: number, taxonomyId?: number | null, parentId?: number | null, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, sections: Array<{ __typename?: 'SectionType', id?: number | null, label?: string | null, labelI18n: any, sort: number, taxonomyId?: number | null, parentId?: number | null, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, sections: Array<{ __typename?: 'SectionType', id?: number | null, label?: string | null, labelI18n: any, sort: number, taxonomyId?: number | null, parentId?: number | null, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, sections: Array<{ __typename?: 'SectionType', id?: number | null, label?: string | null, labelI18n: any, sort: number, taxonomyId?: number | null, parentId?: number | null, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null }> }> }> }> }>, iroLinks?: Array<{ __typename?: 'IroSectionLinkType', id: any, iroId: any, sectionId: number, iro: { __typename?: 'IROType', id: any, name: string, type: EnumIroType, description: string, accountId: any, activityId?: any | null, likelihood?: number | null, severity?: number | null, scale?: number | null, scope?: number | null, irremediability?: number | null, status?: EnumIroStatus | null } }> | null }> };

export type ListSubmittedMetricsQueryVariables = Exact<{
  fundId?: InputMaybe<Scalars['Int']['input']>;
  metricIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListSubmittedMetricsQuery = { __typename?: 'ComboQuery', listMetricAggregations: Array<{ __typename?: 'MetricAggregationType', id?: number | null, metric?: { __typename?: 'MetricType', id?: number | null } | null }> };

export type ListTableModelsQueryVariables = Exact<{
  tableNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
  query: Scalars['String']['input'];
}>;


export type ListTableModelsQuery = { __typename?: 'ComboQuery', listTableModels: Array<{ __typename?: 'FullyQualifiedPath', path: string, description: string }> };

export type ListTaxonomiesQueryVariables = Exact<{
  input: TaxonomyFilterInput;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListTaxonomiesQuery = { __typename?: 'ComboQuery', countTaxonomies: number, listTaxonomies: Array<{ __typename?: 'TaxonomyType', label: string, shortLabel?: string | null, id?: number | null }> };

export type GetAccountQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAccountQuery = { __typename?: 'ComboQuery', getAccount: { __typename?: 'AccountType', id: any, logo?: string | null, website?: string | null, type: AccountCategory, expiryDate?: any | null, expiryStatus: AccountExpiryStatus, movedToUrls?: Array<string> | null, isSuspended: boolean, esgActionsActive: boolean, name?: string | null, metricsToken?: string | null, esgToken?: string | null, impactGoalToken?: string | null, modules?: Array<Module> | null, membershipRoles: Array<AccountMembershipRole>, bookedModules: Array<Module>, hasKfw: boolean, legalEntityIdentifier: string, nace?: Array<string> | null, countries?: Array<string> | null, hiddenKpis?: Array<number> | null, nameOfFinancialMarketParticipant: string, remunerationPolicies: string, sustainabilityRiskIntegration: string, entityLevelPaiConsideration: string, reportingPeriodType: MetricReportingPeriodType, subsidiaries: Array<string>, csrdRequirement?: any | null, csrdLikelihoodThreshold?: number | null, csrdMagnitudeThreshold?: number | null, csrdThresholdReason?: string | null, csrdNImpactLikelihoodThreshold?: number | null, csrdNImpactSeverityThreshold?: number | null, csrdNImpactThresholdReason?: string | null, csrdPImpactLikelihoodThreshold?: number | null, csrdPImpactScopeThreshold?: number | null, csrdPImpactThresholdReason?: string | null, defaultReferencePeriods: Array<string>, requireImpactSubmission?: boolean | null, usersCount: number, ventureLinks?: Array<{ __typename?: 'PortfolioVentureLinkType', id: string, portfolioId: any, ventureId: any, modules: Array<Module>, comment?: string | null, groupNames: Array<string>, groupIds?: Array<number> | null, venture?: { __typename?: 'AccountType', id: any, name?: string | null, logo?: string | null, website?: string | null } | null }> | null, portfolioLinks?: Array<{ __typename?: 'PortfolioVentureLinkType', modules: Array<Module>, portfolioId: any, ventureId: any, comment?: string | null, portfolio?: { __typename?: 'AccountType', id: any, name?: string | null, logo?: string | null, website?: string | null, reportingPeriodType: MetricReportingPeriodType, defaultReferencePeriods: Array<string>, requireImpactSubmission?: boolean | null } | null }> | null } };

export type GetAccountWithDetailQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAccountWithDetailQuery = { __typename?: 'ComboQuery', getAccount: { __typename?: 'AccountType', id: any, logo?: string | null, website?: string | null, type: AccountCategory, esgActionsActive: boolean, name?: string | null, metricsToken?: string | null, esgToken?: string | null, impactGoalToken?: string | null, modules?: Array<Module> | null, bookedModules: Array<Module>, hasKfw: boolean, nace?: Array<string> | null, countries?: Array<string> | null, csrdRequirement?: any | null, ventureLinks?: Array<{ __typename?: 'PortfolioVentureLinkType', id: string, portfolioId: any, ventureId: any, modules: Array<Module>, comment?: string | null, venture?: { __typename?: 'AccountType', id: any, name?: string | null, logo?: string | null, website?: string | null } | null }> | null, portfolioLinks?: Array<{ __typename?: 'PortfolioVentureLinkType', modules: Array<Module>, portfolioId: any, ventureId: any, comment?: string | null, portfolio?: { __typename?: 'AccountType', id: any, name?: string | null, logo?: string | null, website?: string | null } | null }> | null, metricAssignments?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, metric?: { __typename?: 'MetricType', name: string } | null }> | null, companyInfo?: { __typename?: 'QuestionnaireType', userInputs: Array<{ __typename?: 'UserInputType', text?: string | null, question: { __typename?: 'QuestionType', label: string }, selectedOptions?: Array<{ __typename?: 'OptionType', label?: string | null }> | null }> } | null } };

export type GetAccountWithEuTaxonomyDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAccountWithEuTaxonomyDataQuery = { __typename?: 'ComboQuery', getAccount: { __typename?: 'AccountType', id: any, bookedModules: Array<Module>, hasNoEligibleBusinessActivities?: boolean | null, areEuTaxonomyActivitiesInSyncWithQuestionnaire: boolean, businessActivities: Array<{ __typename?: 'ConceptType', id?: number | null }>, fundSustainableObjectives: Array<{ __typename?: 'SfdrStrategyType', doCheckEuTaxonomyAlignment?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, createdBy?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, euTaxonomyConcept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, euTaxonomyQuestionnaire?: { __typename?: 'QuestionnaireType', id?: number | null, label: string, questionnaireAssignment?: { __typename?: 'QuestionnaireAssignmentType', id?: number | null, isEditable: boolean, updatedAt?: any | null, period?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null } | null, userInputs: Array<{ __typename?: 'UserInputType', id?: number | null, isActive: boolean, isNotRelevant?: boolean | null, geographyIds?: Array<number> | null, text?: string | null, scoringRule?: any | null, question: { __typename?: 'QuestionType', id?: number | null, label: string, component: string }, selectedOptions?: Array<{ __typename?: 'OptionType', id?: number | null, label?: string | null }> | null, selectedConcepts: Array<{ __typename?: 'UserInputConceptLinkType', implementationStatus: ImplementationStatus, comment: string, userInputId?: number | null, conceptId?: number | null, concept: { __typename?: 'ConceptType', id?: number | null, label: string, scheme?: RiskManagementScheme | null, description: string, isSubmeasure: boolean } }> }>, sectionCompletion: Array<{ __typename?: 'SectionCompletionType', sectionId: number, isCompleted: boolean, percentageCompleted: number, numberRequired: number, numberIncomplete: number, incompleteQuestions: Array<string> }>, questionnaireResults: Array<{ __typename?: 'QuestionnaireResultType', id?: number | null, sectionId?: number | null, sectionLabel: string, score?: number | null, details?: any | null }> } | null, questionnaireTemplate?: { __typename?: 'QuestionnaireTemplateType', sections?: Array<{ __typename?: 'SectionType', label?: string | null, id?: number | null, ixId?: string | null, description?: string | null, questions: Array<{ __typename?: 'QuestionType', id?: number | null, ixId?: string | null, component: string, tooltip?: string | null, isMultiple?: boolean | null, isMandatory: boolean, title: string, subtitle?: string | null, options: Array<{ __typename?: 'OptionType', id?: number | null, ixId?: string | null, label?: string | null, sublabel?: string | null, tooltip?: string | null }> }>, sections: Array<{ __typename?: 'SectionType', label?: string | null, id?: number | null, questions: Array<{ __typename?: 'QuestionType', id?: number | null, ixId?: string | null, component: string, tooltip?: string | null, isMultiple?: boolean | null, isMandatory: boolean, title: string, subtitle?: string | null, options: Array<{ __typename?: 'OptionType', id?: number | null, ixId?: string | null, label?: string | null, sublabel?: string | null, tooltip?: string | null }> }> }> }> | null } | null } | null } };

export type GetFundIsInSyncQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetFundIsInSyncQuery = { __typename?: 'ComboQuery', getFund: { __typename?: 'FundType', id?: number | null, isInSync: boolean, syncState: { __typename?: 'SyncState', esgQuestionnaire: boolean, esgModule: boolean, fundAggregations: boolean, fundAssignments: boolean, euTaxonomyChecks: boolean, kfwAssignments: boolean, fundAggregationsToAdd: Array<{ __typename?: 'MetricAggregationInfo', metricId: number, groupType: TypeAggregationGroup, groupId: number, why: string, metric: { __typename?: 'MetricType', name: string } }>, fundAggregationsToDelete: Array<{ __typename?: 'MetricAggregationInfo', metricId: number, groupType: TypeAggregationGroup, groupId: number, why: string, metric: { __typename?: 'MetricType', name: string } }>, assignmentsToAdd: Array<{ __typename?: 'MetricAssignmentInfo', metricId: number, assigneeId: any, fundId?: number | null, why: string, metric: { __typename?: 'MetricType', name: string }, assignee?: { __typename?: 'AccountType', name?: string | null } | null }>, moduleUpdates: Array<{ __typename?: 'ModuleUpdate', modulesToAdd: Array<Module>, assignee?: { __typename?: 'AccountType', id: any, name?: string | null } | null }>, esgQuestionnairesToAdd: Array<{ __typename?: 'UpdateInfo', assignee?: { __typename?: 'AccountType', id: any, name?: string | null } | null }> } } };

export type GetFundReportQueryVariables = Exact<{
  input: GetFundReportInput;
}>;


export type GetFundReportQuery = { __typename?: 'ComboQuery', getFundReport?: { __typename?: 'CalculatedFundReportType', nameOfFinancialMarketParticipant?: string | null, legalEntityIdentifier?: string | null, fundName?: string | null, isArticle9: boolean, isArticle8: boolean, isArticle8Plus: boolean, isArticle8PlusWithAlignedEnvironmentalInvestments?: boolean | null, isArticle8PlusWithNonAlignedEnvironmentalInvestments?: boolean | null, isArticle8PlusWithSocialObjective?: boolean | null, hasSustainableInvestmentObjective?: boolean | null, hasEnvironmentalInvestments?: boolean | null, percentSustainableInvestmentsWithEnvironmentalObjective?: string | null, hasAlignedEnvironmentalInvestments?: boolean | null, hasNonAlignedEnvironmentalInvestments?: boolean | null, hasFossilOrNuclearActivities?: boolean | null, hasFossilActivities?: boolean | null, hasNuclearActivities?: boolean | null, hasNoFossilNorNuclearActivities?: boolean | null, hasSocialObjective?: boolean | null, percentSustainableInvestmentsWithSocialObjective?: string | null, percentSustainableInvestmentsWhilePromotingEsCharacteristics?: string | null, esCharacteristicsDescription?: string | null, sustainabilityIndicatorsPerformanceDescriptionComparedToPrevious?: string | null, sustainabilityRelatedInvestmentEconomicSector?: string | null, sustainabilityRelatedInvestmentAssetAllocation?: string | null, sustainabilityRelatedInvestmentAssetAllocationPrecontractual?: string | null, investments?: any | null, sustainableInvestmentsMadeByFund?: string | null, sustainableInvestmentsMadeByFundPrecontractual?: string | null, sustainabilityIndicatorsPerformanceDescription?: string | null, sustainabilityIndicatorsDescriptionPrecontractual?: string | null, howDidInvestmentsNotCauseHarm?: string | null, alignmentWithOecdGuidelines?: string | null, investmentsCategorizationChartData?: any | null, investmentsCategorizationChartDataPrecontractual?: any | null, accountOnPais?: string | null, sustainableInvestmentsWithEnvironmentalObjectiveEuTaxonomyAlignment?: string | null, sustainableInvestmentsWithEnvironmentalObjectiveEuTaxonomyAlignmentPrecontractual?: string | null, shareOfSustainableInvestmentsWithEnvironmentalObjectiveNonEuTaxonomyAligned?: string | null, shareOfSustainableInvestmentsWithEnvironmentalObjectiveNonEuTaxonomyAlignedPrecontractual?: string | null, shareOfSociallySustainableInvestments?: string | null, shareOfSociallySustainableInvestmentsPrecontractual?: string | null, shareOfInvestmentsInTransitionalAndEnablingActivities?: string | null, shareOfInvestmentsInTransitionalAndEnablingActivitiesPrecontractual?: string | null, investmentStrategy?: string | null, bindingElementsOfInvestmentStrategy?: string | null, minimumRateToReduceScope?: string | null, companyGovernancePolicy?: string | null, isIndexDesignated?: boolean | null, sustainablyAlignedIndexExplanation?: string | null, investmentAlignedIndexExplanation?: string | null, broadMarketIndexComparison?: string | null, indexCalculationMethodology?: string | null, fundSpecificInfo?: string | null, investmentsAlignedWithEuTaxonomyComparisonWithPreviousPeriods?: string | null, purposeOfOtherOrNotSustainableInvestmentsIncludingSafeguards?: string | null, purposeOfOtherOrNotSustainableInvestmentsIncludingSafeguardsPrecontractual?: string | null, fundPerformanceComparedToReferenceBenchmark?: string | null, actionsTakenToMeetEsCharacteristics?: string | null, percentageOfInvestmentsAlignedWithEuTaxonomy?: any | null, isConsideringPais?: IsConsideringPais | null, isConsideringTaxonomy?: boolean | null, whyDidProductConsiderPais?: string | null, useOfDerivatives?: string | null, referenceBenchmarkDifferenceToBroadMarketOptions?: Array<{ __typename?: 'TemplateType', title: string, text: string }> | null, fundPerformanceOnSustainabilityIndicatorsOptions?: Array<{ __typename?: 'TemplateType', title: string, text: string }> | null, fundPerformanceComparedToReferenceBenchmarkOptions?: Array<{ __typename?: 'TemplateType', text: string, title: string }> | null, fundPerformanceComparedToBroadMarketIndexOptions?: Array<{ __typename?: 'TemplateType', text: string, title: string }> | null } | null };

export type GetPaiReportQueryVariables = Exact<{
  input: GetPaiReportInput;
}>;


export type GetPaiReportQuery = { __typename?: 'ComboQuery', getPaiReport?: { __typename?: 'PaiReportType', nameOfFinancialMarketParticipant?: string | null, legalEntityIdentifier?: string | null, fundName: string, considerationOfPaisOnSustainabilityDescription?: string | null, subsidiaries: Array<string>, paiExplanationsAndActions: any, considerationOfPaisOnSustainabilityHistoricalComparison: string, howDidProductConsiderPais: string, summaryOfPais: string } | null };

export type GetCsrdIntroQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCsrdIntroQuery = { __typename?: 'ComboQuery', getAccount: { __typename?: 'AccountType', id: any, showCsrdIntro: boolean } };

export type ListAccountsQueryVariables = Exact<{
  filters?: InputMaybe<ListAccountFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortParam> | SortParam>;
}>;


export type ListAccountsQuery = { __typename?: 'ComboQuery', countAccounts: number, listAccounts: Array<{ __typename?: 'AccountType', id: any, name?: string | null, type: AccountCategory, usageType?: UsageType | null, bookedModules: Array<Module>, esgActionsActive: boolean, modules?: Array<Module> | null, createdAt?: any | null, expiryDate?: any | null, expiryStatus: AccountExpiryStatus, isSuspended: boolean, logo?: string | null, metricAssignmentsCount: number, usersCount: number, users?: Array<{ __typename?: 'UserType', id: any, email: string }> | null, accountMemberships: Array<{ __typename?: 'AccountUserMembershipType', role: AccountMembershipRole, user: { __typename?: 'UserType', id: any, email: string } }>, portfolioLinks?: Array<{ __typename?: 'PortfolioVentureLinkType', ventureId: any, portfolioId: any, groupIds?: Array<number> | null, groupNames: Array<string>, companyUserInvites: Array<{ __typename?: 'CompanyUserInviteType', email: string, sentAt: any, sentById?: any | null }> }> | null, completionRates: { __typename?: 'CompletionRateType', assigneeId: any, completionRate?: number | null, skippedRate?: number | null, responseRate?: number | null, totalMetrics: number, completedMetrics: number, skippedMetrics: number, incompleteMetrics: number, quarterlyMetrics: number, annualMetrics: number, periodsConsidered: Array<string>, periodDebug: Array<{ __typename?: 'CompletionRatePeriodDebugType', period: string, totalMetrics: number, completedMetrics: number, skippedMetrics: number, incompleteMetrics: number }> } }> };

export type ListBasicAccountsQueryVariables = Exact<{
  filters?: InputMaybe<ListAccountFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortParam> | SortParam>;
}>;


export type ListBasicAccountsQuery = { __typename?: 'ComboQuery', countAccounts: number, listAccounts: Array<{ __typename?: 'AccountType', id: any, name?: string | null, type: AccountCategory, usageType?: UsageType | null, bookedModules: Array<Module>, esgActionsActive: boolean, modules?: Array<Module> | null, createdAt?: any | null, logo?: string | null }> };

export type ListEsgPortfolioVentureLinksQueryVariables = Exact<{
  filters?: InputMaybe<ListPortfolioVentureLinksFilter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ListEsgPortfolioVentureLinksQuery = { __typename?: 'ComboQuery', countPortfolioVentureLinks: number, listPortfolioVentureLinks: Array<{ __typename?: 'PortfolioVentureLinkType', id: string, portfolioId: any, ventureId: any, modules: Array<Module>, groupNames: Array<string>, groupIds?: Array<number> | null, comment?: string | null, esgSummary?: { __typename?: 'QuestionnaireResultSummaryType', ventureId: string, isCompleted: boolean, updatedAt?: any | null, submittedAt?: any | null, total?: number | null, totalDiffToPrevious?: number | null, environmental?: number | null, environmentalDiffToPrevious?: number | null, social?: number | null, socialDiffToPrevious?: number | null, governance?: number | null, governanceDiffToPrevious?: number | null, disclosure?: any | null, period?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null } | null } | null, venture?: { __typename?: 'AccountType', id: any, name?: string | null, logo?: string | null, website?: string | null } | null, portfolio?: { __typename?: 'AccountType', id: any, name?: string | null, reportingPeriodType: MetricReportingPeriodType } | null }> };

export type ListGroupNamesInPortfolioQueryVariables = Exact<{
  portfolioId: Scalars['String']['input'];
}>;


export type ListGroupNamesInPortfolioQuery = { __typename?: 'ComboQuery', listGroupNamesInPortfolio: Array<string> };

export type ListPortfolioGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListPortfolioGroupsQuery = { __typename?: 'ComboQuery', listPortfolioGroups: Array<{ __typename?: 'PortfolioGroupType', id?: number | null, label: string }> };

export type ListPortfolioVentureLinksQueryVariables = Exact<{
  filters?: InputMaybe<ListPortfolioVentureLinksFilter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ListPortfolioVentureLinksQuery = { __typename?: 'ComboQuery', countPortfolioVentureLinks: number, listPortfolioVentureLinks: Array<{ __typename?: 'PortfolioVentureLinkType', id: string, portfolioId: any, ventureId: any, modules: Array<Module>, groupNames: Array<string>, groupIds?: Array<number> | null, comment?: string | null, impactGoal?: { __typename?: 'ImpactGoalType', id?: number | null, ventureId: any, isEditable: boolean, submitDate?: any | null, targetProgress: { __typename?: 'ImpactGoalProgressType', id: number, hasTarget: boolean, startDate?: number | null, endDate?: number | null, completionRate?: number | null, message?: string | null }, sdgs: Array<{ __typename?: 'SdgType', id?: number | null, label: string }>, geographies: Array<{ __typename?: 'GeographyType', id?: number | null, label: string }>, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, stakeholderCategory?: StakeholderCategoryType | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, reportingPeriodType: MetricReportingPeriodType }> }> } | null, venture?: { __typename?: 'AccountType', id: any, name?: string | null, logo?: string | null, website?: string | null } | null, portfolio?: { __typename?: 'AccountType', id: any, name?: string | null, reportingPeriodType: MetricReportingPeriodType } | null }> };

export type ListPortfolioVentureLinksForReviewQueryVariables = Exact<{
  portfolioId: Scalars['UUID']['input'];
}>;


export type ListPortfolioVentureLinksForReviewQuery = { __typename?: 'ComboQuery', listPortfolioVentureLinks: Array<{ __typename?: 'PortfolioVentureLinkType', ventureId: any, venture?: { __typename?: 'AccountType', id: any, name?: string | null } | null }> };

export type ListActivityStakeholderLinksQueryVariables = Exact<{
  activityId: Scalars['UUID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListActivityStakeholderLinksQuery = { __typename?: 'ComboQuery', countActivityStakeholderLinks: number, listActivityStakeholderLinks: Array<{ __typename?: 'ActivityStakeholderLinkType', id: any, activityId: any, stakeholderId: any, impactMaterial: boolean, financialMaterial: boolean, stakeholder: { __typename?: 'StakeholderType', name: string, type: string } }> };

export type GetActivityQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetActivityQuery = { __typename?: 'ComboQuery', getActivity: { __typename?: 'ActivityType', id: any, name: string, description: string, riskProfile: EnumActivityRiskProfile, industry: string, location: string, geographyId?: number | null, type: EnumActivityType } };

export type ListActivitiesQueryVariables = Exact<{
  filters?: InputMaybe<ListActivityFilter>;
}>;


export type ListActivitiesQuery = { __typename?: 'ComboQuery', countActivities: number, listActivities: Array<{ __typename?: 'ActivityType', id: any, name: string, description: string, riskProfile: EnumActivityRiskProfile, industry: string, location: string, geographyId?: number | null, type: EnumActivityType }> };

export type ListCategoriesQueryVariables = Exact<{
  input?: InputMaybe<CategoryQueryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListCategoriesQuery = { __typename?: 'ComboQuery', countCategories: number, listCategories: Array<{ __typename?: 'CategoryType', label: string, id?: number | null, labelI18n: any, createdAt: any, parentId?: number | null, parent?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, subcategories?: Array<{ __typename?: 'CategoryType', label: string, id?: number | null, labelI18n: any, createdAt: any }> | null }> };

export type GetUserInputQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetUserInputQuery = { __typename?: 'ComboQuery', getUserInput: { __typename?: 'UserInputType', id?: number | null, isActive: boolean, isNotRelevant?: boolean | null, geographyIds?: Array<number> | null, text?: string | null, scoringRule?: any | null, question: { __typename?: 'QuestionType', id?: number | null, label: string, component: string }, selectedOptions?: Array<{ __typename?: 'OptionType', id?: number | null, label?: string | null }> | null, selectedConcepts: Array<{ __typename?: 'UserInputConceptLinkType', implementationStatus: ImplementationStatus, comment: string, userInputId?: number | null, conceptId?: number | null, concept: { __typename?: 'ConceptType', id?: number | null, label: string, scheme?: RiskManagementScheme | null, description: string, isSubmeasure: boolean } }> } };

export type ListConceptsQueryVariables = Exact<{
  queryInput?: InputMaybe<ConceptQueryInput>;
  taxonomy?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  accountId?: InputMaybe<Scalars['UUID']['input']>;
  withUserFeedback?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ListConceptsQuery = { __typename?: 'ComboQuery', countConcepts: number, listConcepts: Array<{ __typename?: 'ConceptType', insights?: any | null, id?: number | null, label: string, labelI18n: any, description: string, descriptionI18n: any, isSubmeasure: boolean, additionalData?: any | null, sourceUrl: string, citation: string, citationI18n: any, isMaterial: boolean, materialityExplanation: string, materialityExplanationI18n: any, status: ConceptStatus, scheme?: RiskManagementScheme | null, kind?: ConceptKind | null, ixId?: string | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null }>, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, objectLinks: Array<{ __typename?: 'ConceptLinkType', predicate: ConceptPredicateType, object: { __typename?: 'ConceptType', id?: number | null, label: string } }> }> };

export type ListEvidenceLinksQueryVariables = Exact<{
  filters?: InputMaybe<ListEvidenceLinkFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListEvidenceLinksQuery = { __typename?: 'ComboQuery', countEvidenceLinks: number, listEvidenceLinks?: Array<{ __typename?: 'EvidenceLinkType', id: any, type: string, evidenceId?: any | null, accountId: any, entityUuidId?: any | null, entityIntId?: number | null, description?: string | null, account?: { __typename?: 'AccountType', id: any, name?: string | null, type: AccountCategory } | null, evidence?: { __typename?: 'EvidenceType', id: any, websiteUrl?: string | null, description?: string | null, comment?: string | null, internalUrl?: string | null, filename?: string | null } | null }> | null };

export type ListEvidencesQueryVariables = Exact<{
  filters?: InputMaybe<ListEvidenceFilter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListEvidencesQuery = { __typename?: 'ComboQuery', countEvidences: number, listEvidences: Array<{ __typename?: 'EvidenceType', id: any, websiteUrl?: string | null, internalUrl?: string | null, filename?: string | null, description?: string | null, comment?: string | null, countEvidenceLinks: number }> };

export type ExportByCompanyQueryVariables = Exact<{
  input: ExportExcelByCompanyInput;
}>;


export type ExportByCompanyQuery = { __typename?: 'ComboQuery', exportByCompany: { __typename?: 'ExportExcelByCompanyType', ventureId: string, file: string } };

export type ExportByPortfolioQueryVariables = Exact<{ [key: string]: never; }>;


export type ExportByPortfolioQuery = { __typename?: 'ComboQuery', exportByPortfolio: { __typename?: 'ExportByPortfolioType', portfolioId: string, file: string } };

export type ExportCompanyTypstPdfQueryVariables = Exact<{
  input: ExportCompanyTypstPdfInput;
}>;


export type ExportCompanyTypstPdfQuery = { __typename?: 'ComboQuery', exportCompanyTypstPdf: { __typename?: 'FileExportType', fileName: string, format: FileFormat, base64String: string } };

export type ExportFundReportQueryVariables = Exact<{
  input: ExportFundReportInput;
}>;


export type ExportFundReportQuery = { __typename?: 'ComboQuery', exportFundReport: { __typename?: 'ExportFundReportType', fundId: number, file: string } };

export type ExportKfwQueryVariables = Exact<{
  input: ExportKfWInput;
}>;


export type ExportKfwQuery = { __typename?: 'ComboQuery', exportKfw: { __typename?: 'ExportKfWType', zipFile?: { __typename?: 'FileExportType', fileName: string, base64String: string, format: FileFormat } | null, files: Array<{ __typename?: 'FileExportType', fileName: string, base64String: string, format: FileFormat }> } };

export type ExportNkiCompanyDataQueryVariables = Exact<{
  input?: InputMaybe<ExportNkiCompanyDataInput>;
}>;


export type ExportNkiCompanyDataQuery = { __typename?: 'ComboQuery', exportNkiCompanyData: { __typename?: 'FileExportType', fileName: string, format: FileFormat, base64String: string } };

export type ExportPaiReportQueryVariables = Exact<{
  input: ExportPaiReportInput;
}>;


export type ExportPaiReportQuery = { __typename?: 'ComboQuery', exportPaiReport: { __typename?: 'ExportFundReportType', fundId: number, file: string } };

export type ExportPrecontractualReportQueryVariables = Exact<{
  input: ExportPrecontractualReportInput;
}>;


export type ExportPrecontractualReportQuery = { __typename?: 'ComboQuery', exportPrecontractualReport: { __typename?: 'ExportFundReportType', fundId: number, file: string } };

export type ListFeedbacksQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListFeedbacksQuery = { __typename?: 'ComboQuery', countFeedbacks: number, listFeedbacks: Array<{ __typename?: 'FeedbackType', id: any, accountId?: any | null, userId?: any | null, title?: string | null, description?: string | null, rating?: number | null, url?: string | null, createdAt: any, user?: { __typename?: 'UserType', email: string } | null }> };

export type GetFundQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetFundQuery = { __typename?: 'ComboQuery', getFund: { __typename?: 'FundType', id?: number | null, name?: string | null, legalEntityIdentifier?: string | null, volume?: number | null, fundStrategy?: FundStrategy | null, isReportingPais: boolean, isReportingKfw: boolean, minimumReportingLevelVentureIds?: Array<any> | null, recommendedReportingLevelVentureIds?: Array<any> | null, fullReportingLevelVentureIds?: Array<any> | null, isConsideringPais?: IsConsideringPais | null, notConsideringPaisReason?: string | null, ventureIds?: Array<any> | null, investmentStrategy?: string | null, bindingElementsOfInvestmentStrategy?: string | null, minimumRateToReduceScope?: string | null, companyGovernancePolicy?: string | null, fundSpecificInfo?: string | null, socialMetricIds: Array<number>, environmentalMetricIds: Array<number>, generalMetricIds: Array<number>, paiSelectionMethodologies: string, paiPolicyAdministration: string, considerationOfPaisOnSustainabilityEngagementPolicies: string, considerationOfPaisOnSustainabilityInternationalStandards: string, isConsideringSustainabilityRisk?: boolean | null, sustainabilityRiskIntegrationDescription?: string | null, likelyImpactsFromSustainabilityRisk?: string | null, reasonNotConsideringSustainabilityRisk?: string | null, entitySustainabilityExtraInfo?: string | null, paiAggregationGroup?: TypeAggregationGroup | null, esCharacteristicsPromoted?: EsCharacteristicsPromoted | null, portfolio?: { __typename?: 'AccountType', id: any, type: AccountCategory, name?: string | null, logo?: string | null, modules?: Array<Module> | null, countries?: Array<string> | null, nace?: Array<string> | null, website?: string | null, nameOfFinancialMarketParticipant: string, legalEntityIdentifier: string, sustainabilityRiskIntegration: string, remunerationPolicies: string, subsidiaries: Array<string>, entityLevelPaiConsideration: string, csrdLikelihoodThreshold?: number | null, csrdMagnitudeThreshold?: number | null, csrdThresholdReason?: string | null, hiddenKpis?: Array<number> | null, csrdNImpactLikelihoodThreshold?: number | null, csrdNImpactSeverityThreshold?: number | null, csrdNImpactThresholdReason?: string | null, csrdPImpactLikelihoodThreshold?: number | null, csrdPImpactScopeThreshold?: number | null, csrdPImpactThresholdReason?: string | null, reportingPeriodType: MetricReportingPeriodType, defaultReferencePeriods: Array<string>, requireImpactSubmission?: boolean | null, ventureLinks?: Array<{ __typename?: 'PortfolioVentureLinkType', ventureId: any, modules: Array<Module> }> | null } | null, assetAllocationTargets: { __typename?: 'AssetAllocationTargetsType', percentEnvironmental?: number | null, percentEnvironmentalTaxonomyAligned?: number | null, percentEnvironmentalNotTaxonomyAligned?: number | null, percentSocial?: number | null, percentSustainable?: number | null, percentTaxonomyAlignedFossil?: number | null, percentTaxonomyAlignedNuclear?: number | null, percentTaxonomyAlignedEnabling?: number | null, percentTaxonomyAlignedTransitional?: number | null }, socialMetrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, environmentalMetrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, generalMetrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, investmentPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null, sustainableObjectives: Array<{ __typename?: 'SfdrStrategyType', id?: number | null, kind: SfdrStrategyKind, benchmarkDescription?: string | null, actionsTaken?: string | null, metricIds: Array<number>, strategyDescription?: string | null, isEnvironmentalGoal: boolean, isCo2EmissionGoal?: boolean | null, doCheckEuTaxonomyAlignment?: boolean | null, ventureIds?: Array<any> | null, esStrategy: Array<EsCharacteristicStrategy>, esCharacteristicsDescription?: string | null, esgIntegrationDescription?: string | null, exclusionCriteriaDescription?: string | null, bestInClassDescription?: string | null, normBasedScreeningDescription?: string | null, sustainabilityLabelDescription?: string | null, isIndexDesignated?: boolean | null, sustainablyAlignedIndexExplanation?: string | null, investmentAlignedIndexExplanation?: string | null, broadMarketIndexComparison?: string | null, indexCalculationMethodology?: string | null, sustainabilityIndicatorsMonitoringStrategy: string, entityResponsibleForMonitoringIndicators: string, isConsideringSourcesAndEstimates: boolean, dataSourcesConsidered: string, shareOfDataSecondHand: string, dueDiligenceProcessDescription: string, engagementPolicyWithSpecificInvestmentStrategy: string, metrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null, euTaxonomyConcept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null }>, esCharacteristics: { __typename?: 'SfdrStrategyType', id?: number | null, kind: SfdrStrategyKind, benchmarkDescription?: string | null, actionsTaken?: string | null, metricIds: Array<number>, strategyDescription?: string | null, isEnvironmentalGoal: boolean, isCo2EmissionGoal?: boolean | null, doCheckEuTaxonomyAlignment?: boolean | null, ventureIds?: Array<any> | null, esStrategy: Array<EsCharacteristicStrategy>, esCharacteristicsDescription?: string | null, esgIntegrationDescription?: string | null, exclusionCriteriaDescription?: string | null, bestInClassDescription?: string | null, normBasedScreeningDescription?: string | null, sustainabilityLabelDescription?: string | null, isIndexDesignated?: boolean | null, sustainablyAlignedIndexExplanation?: string | null, investmentAlignedIndexExplanation?: string | null, broadMarketIndexComparison?: string | null, indexCalculationMethodology?: string | null, sustainabilityIndicatorsMonitoringStrategy: string, entityResponsibleForMonitoringIndicators: string, isConsideringSourcesAndEstimates: boolean, dataSourcesConsidered: string, shareOfDataSecondHand: string, dueDiligenceProcessDescription: string, engagementPolicyWithSpecificInvestmentStrategy: string, metrics: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null, euTaxonomyConcept?: { __typename?: 'ConceptType', id?: number | null, label: string, ixId?: string | null } | null }, periodicAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, paiAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, precontractualAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, fundWebsiteDisclosureAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, entityWebsiteDisclosureAnswers: Array<{ __typename?: 'ReportAnswerType', id: any, fundId: number, reportType: ReportType, referencePeriodId: number, reportData: any, sfdrReportingPeriod?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null } | null }>, paiReport?: { __typename?: 'UserInputPaiReportType', considerationOfPaisOnSustainabilityDescription?: string | null, considerationOfPaisOnSustainabilityEngagementPolicies?: string | null, considerationOfPaisOnSustainabilityInternationalStandards?: string | null, considerationOfPaisOnSustainabilityHistoricalComparison?: string | null, howDidProductConsiderPais?: string | null, principalAdverseImpactsExplanationsAndActions: any, summaryOfPais?: string | null } | null, precontractualReport?: { __typename?: 'UserInputPrecontractualReportType', sustainableObjectiveTree?: string | null, wereObjectivesMet?: string | null, esCharacteristicsDescription?: string | null, sustainabilityIndicatorsPerformanceDescription?: string | null, sustainableInvestmentsMadeByFund?: string | null, howDidInvestmentsNotCauseHarm?: string | null, accountOnPais?: string | null, alignmentWithOecdGuidelines?: string | null, investmentStrategy?: string | null, bindingElementsOfInvestmentStrategy?: string | null, companyGovernancePolicy?: string | null, howDidProductConsiderPais?: string | null, sustainabilityRelatedInvestmentAssetAllocation?: string | null, sustainableInvestmentsWithEnvironmentalObjectiveEuTaxonomyAlignment?: string | null, fossilOrNuclear?: string | null, shareOfInvestmentsInTransitionalAndEnablingActivities?: string | null, shareOfSustainableInvestmentsWithEnvironmentalObjectiveNonEuTaxonomyAligned?: string | null, shareOfSociallySustainableInvestments?: string | null, purposeOfOtherOrNotSustainableInvestmentsIncludingSafeguards?: string | null, productPerformanceComparison?: string | null, sustainablyAlignedIndexExplanation?: string | null, investmentAlignedIndexExplanation?: string | null, broadMarketIndexComparison?: string | null, indexCalculationMethodology?: string | null, fundSpecificInfo?: string | null, whyDidProductConsiderPais?: string | null, useOfDerivatives?: string | null } | null } };

export type GetFundSetupStateQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetFundSetupStateQuery = { __typename?: 'ComboQuery', fundSetupState: { __typename?: 'FundSetupState', fundId: number, isInSync: boolean, completion: { __typename?: 'FundCompletion', value: number, items: Array<{ __typename?: 'FundCompletionItem', key: string, canonicalKey: FundCompletionSectionKey, result?: number | null, applicable: boolean, why?: string | null, details: Array<{ __typename?: 'FundCompletionDetail', key: string, canonicalKey: string, result?: number | null, applicable: boolean, why?: string | null }> }> }, syncState: { __typename?: 'SyncState', esgQuestionnaire: boolean, esgModule: boolean, fundAggregations: boolean, fundAssignments: boolean, euTaxonomyChecks: boolean, kfwAssignments: boolean, fundAggregationsToAdd: Array<{ __typename?: 'MetricAggregationInfo', metricId: number, groupType: TypeAggregationGroup, groupId: number, why: string, metric: { __typename?: 'MetricType', name: string } }>, fundAggregationsToDelete: Array<{ __typename?: 'MetricAggregationInfo', metricId: number, groupType: TypeAggregationGroup, groupId: number, why: string, metric: { __typename?: 'MetricType', name: string } }>, assignmentsToAdd: Array<{ __typename?: 'MetricAssignmentInfo', metricId: number, assigneeId: any, fundId?: number | null, why: string, metric: { __typename?: 'MetricType', name: string }, assignee?: { __typename?: 'AccountType', name?: string | null } | null }>, moduleUpdates: Array<{ __typename?: 'ModuleUpdate', modulesToAdd: Array<Module>, assignee?: { __typename?: 'AccountType', id: any, name?: string | null } | null }>, esgQuestionnairesToAdd: Array<{ __typename?: 'UpdateInfo', assignee?: { __typename?: 'AccountType', id: any, name?: string | null } | null }> } } };

export type ListFundsQueryVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListFundsQuery = { __typename?: 'ComboQuery', countFunds: number, listFunds: Array<{ __typename?: 'FundType', id?: number | null, name?: string | null, volume?: number | null, ventureIds?: Array<any> | null, fundStrategy?: FundStrategy | null, isReportingPais: boolean, legalEntityIdentifier?: string | null, isReportingKfw: boolean, ventures?: Array<{ __typename?: 'AccountType', id: any, name?: string | null }> | null, sustainableObjectives: Array<{ __typename?: 'SfdrStrategyType', id?: number | null, isEnvironmentalGoal: boolean, doCheckEuTaxonomyAlignment?: boolean | null, euTaxonomyConceptId?: number | null, euTaxonomyConcept?: { __typename?: 'ConceptType', id?: number | null } | null }>, esCharacteristics: { __typename?: 'SfdrStrategyType', id?: number | null }, portfolio?: { __typename?: 'AccountType', name?: string | null } | null }> };

export type DelFundsMutationVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type DelFundsMutation = { __typename?: 'ComboMutation', delFunds: boolean };

export type ListFlatGeographiesQueryVariables = Exact<{
  filters?: InputMaybe<ListGeographyFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListFlatGeographiesQuery = { __typename?: 'ComboQuery', listGeographies: Array<{ __typename?: 'GeographyType', id?: number | null, label: string, isoAlpha2?: string | null, parentId?: number | null, children: Array<{ __typename?: 'GeographyType', id?: number | null }> }> };

export type ListNestedGeographiesQueryVariables = Exact<{
  filters?: InputMaybe<ListGeographyFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListNestedGeographiesQuery = { __typename?: 'ComboQuery', listGeographies: Array<{ __typename?: 'GeographyType', id?: number | null, label: string, isoAlpha2?: string | null, parentId?: number | null, children: Array<{ __typename?: 'GeographyType', id?: number | null, label: string, isoAlpha2?: string | null, parentId?: number | null, children: Array<{ __typename?: 'GeographyType', id?: number | null, label: string, isoAlpha2?: string | null, parentId?: number | null, children: Array<{ __typename?: 'GeographyType', id?: number | null, label: string, isoAlpha2?: string | null, parentId?: number | null }> }> }> }> };

export type GetMetricQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetMetricQuery = { __typename?: 'ComboQuery', getMetric: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } };

export type QuestionFragment = { __typename?: 'QuestionSectionLinkType', sort: number, label?: string | null, sublabel?: string | null, tooltip?: string | null, question: { __typename?: 'QuestionType', id?: number | null, sort: number, label: string, sublabel?: string | null, tooltip?: string | null, component: string, ixId?: string | null, targetEntity?: string | null, isMandatory: boolean, isActiveByDefault: boolean, isMultiple?: boolean | null, createdAt: any, updatedAt?: any | null, value: string, copyableText: string, copyableOptions: any, isCopyable: boolean, options: Array<{ __typename?: 'OptionType', id?: number | null, ixId?: string | null, label?: string | null }>, templateTexts: Array<{ __typename?: 'TemplateTextType', text: string }>, promptTemplate?: { __typename?: 'PromptTemplateType', id?: any | null, isActive?: boolean | null } | null } };

export type SectionFragment = { __typename?: 'SectionType', id?: number | null, ixId?: string | null, label?: string | null, labelI18n: any, sublabel?: string | null, tooltip?: string | null, sort: number, children: Array<{ __typename?: 'QuestionSectionLinkType', sort: number, label?: string | null, sublabel?: string | null, tooltip?: string | null, question: { __typename?: 'QuestionType', id?: number | null, sort: number, label: string, sublabel?: string | null, tooltip?: string | null, component: string, ixId?: string | null, targetEntity?: string | null, isMandatory: boolean, isActiveByDefault: boolean, isMultiple?: boolean | null, createdAt: any, updatedAt?: any | null, value: string, copyableText: string, copyableOptions: any, isCopyable: boolean, options: Array<{ __typename?: 'OptionType', id?: number | null, ixId?: string | null, label?: string | null }>, templateTexts: Array<{ __typename?: 'TemplateTextType', text: string }>, promptTemplate?: { __typename?: 'PromptTemplateType', id?: any | null, isActive?: boolean | null } | null } } | { __typename?: 'SectionType', id?: number | null, ixId?: string | null, label?: string | null, labelI18n: any, sublabel?: string | null, tooltip?: string | null, sort: number, children: Array<{ __typename?: 'QuestionSectionLinkType', sort: number, label?: string | null, sublabel?: string | null, tooltip?: string | null, question: { __typename?: 'QuestionType', id?: number | null, sort: number, label: string, sublabel?: string | null, tooltip?: string | null, component: string, ixId?: string | null, targetEntity?: string | null, isMandatory: boolean, isActiveByDefault: boolean, isMultiple?: boolean | null, createdAt: any, updatedAt?: any | null, value: string, copyableText: string, copyableOptions: any, isCopyable: boolean, options: Array<{ __typename?: 'OptionType', id?: number | null, ixId?: string | null, label?: string | null }>, templateTexts: Array<{ __typename?: 'TemplateTextType', text: string }>, promptTemplate?: { __typename?: 'PromptTemplateType', id?: any | null, isActive?: boolean | null } | null } } | { __typename?: 'SectionType' }> }> };

export type GetSectionWithQuestionsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  fundId?: InputMaybe<Scalars['Int']['input']>;
  referencePeriodId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSectionWithQuestionsQuery = { __typename?: 'ComboQuery', getSection: { __typename?: 'SectionType', label?: string | null, children: Array<{ __typename?: 'QuestionSectionLinkType', sort: number, label?: string | null, sublabel?: string | null, tooltip?: string | null, question: { __typename?: 'QuestionType', id?: number | null, sort: number, label: string, sublabel?: string | null, tooltip?: string | null, component: string, ixId?: string | null, targetEntity?: string | null, isMandatory: boolean, isActiveByDefault: boolean, isMultiple?: boolean | null, createdAt: any, updatedAt?: any | null, value: string, copyableText: string, copyableOptions: any, isCopyable: boolean, options: Array<{ __typename?: 'OptionType', id?: number | null, ixId?: string | null, label?: string | null }>, templateTexts: Array<{ __typename?: 'TemplateTextType', text: string }>, promptTemplate?: { __typename?: 'PromptTemplateType', id?: any | null, isActive?: boolean | null } | null } } | { __typename?: 'SectionType', id?: number | null, ixId?: string | null, label?: string | null, labelI18n: any, sublabel?: string | null, tooltip?: string | null, sort: number, children: Array<{ __typename?: 'QuestionSectionLinkType', sort: number, label?: string | null, sublabel?: string | null, tooltip?: string | null, question: { __typename?: 'QuestionType', id?: number | null, sort: number, label: string, sublabel?: string | null, tooltip?: string | null, component: string, ixId?: string | null, targetEntity?: string | null, isMandatory: boolean, isActiveByDefault: boolean, isMultiple?: boolean | null, createdAt: any, updatedAt?: any | null, value: string, copyableText: string, copyableOptions: any, isCopyable: boolean, options: Array<{ __typename?: 'OptionType', id?: number | null, ixId?: string | null, label?: string | null }>, templateTexts: Array<{ __typename?: 'TemplateTextType', text: string }>, promptTemplate?: { __typename?: 'PromptTemplateType', id?: any | null, isActive?: boolean | null } | null } } | { __typename?: 'SectionType', id?: number | null, ixId?: string | null, label?: string | null, labelI18n: any, sublabel?: string | null, tooltip?: string | null, sort: number, children: Array<{ __typename?: 'QuestionSectionLinkType', sort: number, label?: string | null, sublabel?: string | null, tooltip?: string | null, question: { __typename?: 'QuestionType', id?: number | null, sort: number, label: string, sublabel?: string | null, tooltip?: string | null, component: string, ixId?: string | null, targetEntity?: string | null, isMandatory: boolean, isActiveByDefault: boolean, isMultiple?: boolean | null, createdAt: any, updatedAt?: any | null, value: string, copyableText: string, copyableOptions: any, isCopyable: boolean, options: Array<{ __typename?: 'OptionType', id?: number | null, ixId?: string | null, label?: string | null }>, templateTexts: Array<{ __typename?: 'TemplateTextType', text: string }>, promptTemplate?: { __typename?: 'PromptTemplateType', id?: any | null, isActive?: boolean | null } | null } } | { __typename?: 'SectionType' }> }> }> } };

export type ListUniqueIdematUnitsAndCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListUniqueIdematUnitsAndCategoriesQuery = { __typename?: 'ComboQuery', listUniqueIdematUnitsAndCategories: { __typename?: 'IdematFilter', units: Array<string>, categories: Array<string> } };

export type GetImpactQueryVariables = Exact<{
  impactId: Scalars['Int']['input'];
}>;


export type GetImpactQuery = { __typename?: 'ComboQuery', getImpact: { __typename?: 'ImpactType', id?: number | null, conceptId?: number | null, stakeholder?: string | null, stakeholderCategory?: StakeholderCategoryType | null, isPositive?: boolean | null, theoryOfChange?: string | null, problem?: string | null, problemStatement?: string | null, companyVision?: string | null, targetGroup?: string | null, inputsActivities?: string | null, solutionsOutput?: string | null, shortTermOutcomes?: string | null, longTermImpacts?: string | null, riskReboundEffects?: string | null, euTaxonomy?: EuTaxonomyType | null, initialInvestmentDate?: any | null, startingYear?: number | null, durationYears?: number | null, carryRemarks?: string | null, isEditable: boolean, submitDate?: any | null, hasFrozenOutcome?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, labelI18n: any, description: string, descriptionI18n: any, isSubmeasure: boolean, additionalData?: any | null, sourceUrl: string, citation: string, citationI18n: any, isMaterial: boolean, materialityExplanation: string, materialityExplanationI18n: any, status: ConceptStatus, scheme?: RiskManagementScheme | null, kind?: ConceptKind | null, ixId?: string | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null }>, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, objectLinks: Array<{ __typename?: 'ConceptLinkType', predicate: ConceptPredicateType, object: { __typename?: 'ConceptType', id?: number | null, label: string } }> } | null, sourceAssignments: Array<{ __typename?: 'SourceAssignmentType', id?: number | null, url: string, comment?: string | null }>, impactSolutions: Array<{ __typename?: 'ImpactSolutionType', id?: number | null, impactId: number, targetGroup?: string | null, problemDescription?: string | null, solutionDescription?: string | null, kind?: ImpactSolutionKind | null, ghgSavingPotentialId?: number | null, useGhgSavingPotentialTool?: boolean | null, solutionSource: Array<{ __typename?: 'SolutionSourceType', id?: number | null, url?: string | null, comment?: string | null }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null, ghgSavingPotential?: { __typename?: 'GhgSavingPotentialType', id?: number | null, needFulfilled?: string | null, baselineSolutionDescription?: string | null, comparativeUnit?: string | null, comparativeQuantitiy?: number | null, comparativeUnitConfirmed?: boolean | null, describeComparison?: string | null, isPreciseEmissionCalculation?: boolean | null, simpleBaselineGhg?: number | null, simpleSolutionGhg?: number | null, simpleGhgJustification?: string | null, emissionsConfirmed?: boolean | null, growthFactorJustification?: string | null, isRecurringImpact?: boolean | null, durationOfImpact?: number | null, realisticConfirmation?: boolean | null, impactProfileKind: ImpactProfileKind, isScenarioA?: boolean | null, preComputedBaselineGhg?: number | null, preComputedSolutionGhg?: number | null, scenarioBComments?: string | null, emissionSourceLimitations?: string | null, specificReductionPerUnit?: number | null, specificReductionAsPercentage?: number | null, emissionSources: Array<{ __typename?: 'EmissionSourceType', id?: number | null, ghgSavingPotentialId: number, sourceOfEmission?: string | null, unitName?: string | null, baselineUnitName?: string | null, solutionUnitName?: string | null, baselineConceptName?: string | null, baselineGhgFactor?: number | null, baselineConsumption?: number | null, baselineAssumption?: string | null, baselineEvidence: string, customBaselineConcept?: boolean | null, solutionReducesConsumption?: boolean | null, solutionReducesGhgFactor?: boolean | null, solutionConceptName?: string | null, solutionGhgFactor?: number | null, solutionConsumption?: number | null, solutionAssumption?: string | null, solutionEvidence: string, customSolutionConcept?: boolean | null, specificReductionPerUnit?: number | null, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> }>, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> } | null }>, sdgs: Array<{ __typename?: 'SdgType', id?: number | null, label: string, sublabel: string }>, sdgTargets: Array<{ __typename?: 'SdgTargetType', id?: number | null, label: string, sdgId?: number | null }>, irisCategories: Array<{ __typename?: 'IrisCategoryType', id?: number | null, label: string }>, geographies: Array<{ __typename?: 'GeographyType', id?: number | null, label: string }>, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, metricNameOverride: string, comment?: string | null, reportingPeriodType: MetricReportingPeriodType, isFrozen: boolean, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> } };

export type GetImpactGeographiesForVenturesQueryVariables = Exact<{
  ventureIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetImpactGeographiesForVenturesQuery = { __typename?: 'ComboQuery', getImpactGeographiesForVentures: Array<{ __typename?: 'GeographyAggregationType', geography: { __typename?: 'GeographyType', id?: number | null, label: string, externalId?: string | null }, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null, geographies: Array<{ __typename?: 'GeographyType', id?: number | null, label: string }>, impactGoal?: { __typename?: 'ImpactGoalType', id?: number | null, ventureId: any } | null }> }> };

export type GetImpactGoalQueryVariables = Exact<{
  ventureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetImpactGoalQuery = { __typename?: 'ComboQuery', getImpactGoal: { __typename?: 'ImpactGoalType', id?: number | null, ventureId: any, isEditable: boolean, activityUrls: Array<string>, ghgStartingYear: number, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, conceptId?: number | null, stakeholder?: string | null, stakeholderCategory?: StakeholderCategoryType | null, isPositive?: boolean | null, theoryOfChange?: string | null, problem?: string | null, problemStatement?: string | null, companyVision?: string | null, targetGroup?: string | null, inputsActivities?: string | null, solutionsOutput?: string | null, shortTermOutcomes?: string | null, longTermImpacts?: string | null, riskReboundEffects?: string | null, euTaxonomy?: EuTaxonomyType | null, initialInvestmentDate?: any | null, startingYear?: number | null, durationYears?: number | null, carryRemarks?: string | null, isEditable: boolean, submitDate?: any | null, hasFrozenOutcome?: boolean | null, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, ghgSavingPotentialId?: number | null, metricNameOverride: string, comment?: string | null, reportingPeriodType: MetricReportingPeriodType, isFrozen: boolean, customTargetWeight: number, unitName: string, customTargetCalculationType: AnnualAggregationMethod, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, labelI18n: any, description: string, descriptionI18n: any, isSubmeasure: boolean, additionalData?: any | null, sourceUrl: string, citation: string, citationI18n: any, isMaterial: boolean, materialityExplanation: string, materialityExplanationI18n: any, status: ConceptStatus, scheme?: RiskManagementScheme | null, kind?: ConceptKind | null, ixId?: string | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null }>, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, objectLinks: Array<{ __typename?: 'ConceptLinkType', predicate: ConceptPredicateType, object: { __typename?: 'ConceptType', id?: number | null, label: string } }> } | null, sourceAssignments: Array<{ __typename?: 'SourceAssignmentType', id?: number | null, url: string, comment?: string | null }>, impactSolutions: Array<{ __typename?: 'ImpactSolutionType', id?: number | null, impactId: number, targetGroup?: string | null, problemDescription?: string | null, solutionDescription?: string | null, kind?: ImpactSolutionKind | null, ghgSavingPotentialId?: number | null, useGhgSavingPotentialTool?: boolean | null, solutionSource: Array<{ __typename?: 'SolutionSourceType', id?: number | null, url?: string | null, comment?: string | null }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null, ghgSavingPotential?: { __typename?: 'GhgSavingPotentialType', id?: number | null, needFulfilled?: string | null, baselineSolutionDescription?: string | null, comparativeUnit?: string | null, comparativeQuantitiy?: number | null, comparativeUnitConfirmed?: boolean | null, describeComparison?: string | null, isPreciseEmissionCalculation?: boolean | null, simpleBaselineGhg?: number | null, simpleSolutionGhg?: number | null, simpleGhgJustification?: string | null, emissionsConfirmed?: boolean | null, growthFactorJustification?: string | null, isRecurringImpact?: boolean | null, durationOfImpact?: number | null, realisticConfirmation?: boolean | null, impactProfileKind: ImpactProfileKind, isScenarioA?: boolean | null, preComputedBaselineGhg?: number | null, preComputedSolutionGhg?: number | null, scenarioBComments?: string | null, emissionSourceLimitations?: string | null, specificReductionPerUnit?: number | null, specificReductionAsPercentage?: number | null, emissionSources: Array<{ __typename?: 'EmissionSourceType', id?: number | null, ghgSavingPotentialId: number, sourceOfEmission?: string | null, unitName?: string | null, baselineUnitName?: string | null, solutionUnitName?: string | null, baselineConceptName?: string | null, baselineGhgFactor?: number | null, baselineConsumption?: number | null, baselineAssumption?: string | null, baselineEvidence: string, customBaselineConcept?: boolean | null, solutionReducesConsumption?: boolean | null, solutionReducesGhgFactor?: boolean | null, solutionConceptName?: string | null, solutionGhgFactor?: number | null, solutionConsumption?: number | null, solutionAssumption?: string | null, solutionEvidence: string, customSolutionConcept?: boolean | null, specificReductionPerUnit?: number | null, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> }>, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> } | null }>, sdgs: Array<{ __typename?: 'SdgType', id?: number | null, label: string, sublabel: string }>, sdgTargets: Array<{ __typename?: 'SdgTargetType', id?: number | null, label: string, sdgId?: number | null }>, irisCategories: Array<{ __typename?: 'IrisCategoryType', id?: number | null, label: string }>, geographies: Array<{ __typename?: 'GeographyType', id?: number | null, label: string }> }>, targetProgress: { __typename?: 'ImpactGoalProgressType', id: number, hasTarget: boolean, startDate?: number | null, endDate?: number | null, completionRate?: number | null, message?: string | null } } };

export type GetImpactGoalLockStatesQueryVariables = Exact<{
  ventureId: Scalars['String']['input'];
}>;


export type GetImpactGoalLockStatesQuery = { __typename?: 'ComboQuery', getImpactGoal: { __typename?: 'ImpactGoalType', id?: number | null, ventureId: any, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, isEditable: boolean, submitDate?: any | null, concept?: { __typename?: 'ConceptType', label: string } | null }> } };

export type GetImpactSdgsForVenturesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetImpactSdgsForVenturesQuery = { __typename?: 'ComboQuery', getImpactSdgsForVentures: Array<{ __typename?: 'SdgAggregationType', sdgNumber: number, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null, impactGoal?: { __typename?: 'ImpactGoalType', id?: number | null, ventureId: any } | null }> }> };

export type GetImpactSummaryQueryVariables = Exact<{
  ventureId: Scalars['String']['input'];
}>;


export type GetImpactSummaryQuery = { __typename?: 'ComboQuery', getImpactSummary: { __typename?: 'ImpactSummaryType', totalGhgReduction?: number | null, averageAnnualReduction?: number | null, economicValue?: number | null, averageTotalGhgReduction?: { __typename?: 'AverageTotalGhgReductionType', center: number, lowerBound: number, upperBound: number } | null, ghgMetricValues?: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> | null, impactSolutionSummaries?: Array<{ __typename?: 'ImpactSolutionSummaryType', totalGhgReduction?: string | null, startYear?: number | null, endYear?: number | null, impactConcept: string, impactSolution: { __typename?: 'ImpactSolutionType', id?: number | null, kind?: ImpactSolutionKind | null, targetGroup?: string | null, solutionDescription?: string | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null, ghgSavingPotential?: { __typename?: 'GhgSavingPotentialType', id?: number | null, needFulfilled?: string | null, baselineSolutionDescription?: string | null, comparativeUnit?: string | null, comparativeQuantitiy?: number | null, comparativeUnitConfirmed?: boolean | null, describeComparison?: string | null, isPreciseEmissionCalculation?: boolean | null, simpleBaselineGhg?: number | null, simpleSolutionGhg?: number | null, simpleGhgJustification?: string | null, emissionsConfirmed?: boolean | null, growthFactorJustification?: string | null, isRecurringImpact?: boolean | null, durationOfImpact?: number | null, realisticConfirmation?: boolean | null, impactProfileKind: ImpactProfileKind, isScenarioA?: boolean | null, preComputedBaselineGhg?: number | null, preComputedSolutionGhg?: number | null, scenarioBComments?: string | null, emissionSourceLimitations?: string | null, specificReductionPerUnit?: number | null, specificReductionAsPercentage?: number | null, emissionSources: Array<{ __typename?: 'EmissionSourceType', id?: number | null, ghgSavingPotentialId: number, sourceOfEmission?: string | null, unitName?: string | null, baselineUnitName?: string | null, solutionUnitName?: string | null, baselineConceptName?: string | null, baselineGhgFactor?: number | null, baselineConsumption?: number | null, baselineAssumption?: string | null, baselineEvidence: string, customBaselineConcept?: boolean | null, solutionReducesConsumption?: boolean | null, solutionReducesGhgFactor?: boolean | null, solutionConceptName?: string | null, solutionGhgFactor?: number | null, solutionConsumption?: number | null, solutionAssumption?: string | null, solutionEvidence: string, customSolutionConcept?: boolean | null, specificReductionPerUnit?: number | null, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> }>, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> } | null }, ghgMetricValues?: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> | null, forecastAssignment?: { __typename?: 'MetricAssignmentType', id?: number | null, metricNameOverride: string, unitName: string, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null } } | null, forecastValues?: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> | null }> | null } };

export type ListImpactGoalsQueryVariables = Exact<{
  filters?: InputMaybe<ListImpactGoalFilters>;
}>;


export type ListImpactGoalsQuery = { __typename?: 'ComboQuery', listImpactGoals: Array<{ __typename?: 'ImpactGoalType', id?: number | null, ventureId: any, isEditable: boolean, activityUrls: Array<string>, ghgStartingYear: number, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, conceptId?: number | null, stakeholder?: string | null, stakeholderCategory?: StakeholderCategoryType | null, isPositive?: boolean | null, theoryOfChange?: string | null, problem?: string | null, problemStatement?: string | null, companyVision?: string | null, targetGroup?: string | null, inputsActivities?: string | null, solutionsOutput?: string | null, shortTermOutcomes?: string | null, longTermImpacts?: string | null, riskReboundEffects?: string | null, euTaxonomy?: EuTaxonomyType | null, initialInvestmentDate?: any | null, startingYear?: number | null, durationYears?: number | null, carryRemarks?: string | null, isEditable: boolean, submitDate?: any | null, hasFrozenOutcome?: boolean | null, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, ghgSavingPotentialId?: number | null, metricNameOverride: string, comment?: string | null, reportingPeriodType: MetricReportingPeriodType, isFrozen: boolean, customTargetWeight: number, unitName: string, customTargetCalculationType: AnnualAggregationMethod, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string, labelI18n: any, description: string, descriptionI18n: any, isSubmeasure: boolean, additionalData?: any | null, sourceUrl: string, citation: string, citationI18n: any, isMaterial: boolean, materialityExplanation: string, materialityExplanationI18n: any, status: ConceptStatus, scheme?: RiskManagementScheme | null, kind?: ConceptKind | null, ixId?: string | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null }>, taxonomy?: { __typename?: 'TaxonomyType', id?: number | null, label: string } | null, objectLinks: Array<{ __typename?: 'ConceptLinkType', predicate: ConceptPredicateType, object: { __typename?: 'ConceptType', id?: number | null, label: string } }> } | null, sourceAssignments: Array<{ __typename?: 'SourceAssignmentType', id?: number | null, url: string, comment?: string | null }>, impactSolutions: Array<{ __typename?: 'ImpactSolutionType', id?: number | null, impactId: number, targetGroup?: string | null, problemDescription?: string | null, solutionDescription?: string | null, kind?: ImpactSolutionKind | null, ghgSavingPotentialId?: number | null, useGhgSavingPotentialTool?: boolean | null, solutionSource: Array<{ __typename?: 'SolutionSourceType', id?: number | null, url?: string | null, comment?: string | null }>, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null, ghgSavingPotential?: { __typename?: 'GhgSavingPotentialType', id?: number | null, needFulfilled?: string | null, baselineSolutionDescription?: string | null, comparativeUnit?: string | null, comparativeQuantitiy?: number | null, comparativeUnitConfirmed?: boolean | null, describeComparison?: string | null, isPreciseEmissionCalculation?: boolean | null, simpleBaselineGhg?: number | null, simpleSolutionGhg?: number | null, simpleGhgJustification?: string | null, emissionsConfirmed?: boolean | null, growthFactorJustification?: string | null, isRecurringImpact?: boolean | null, durationOfImpact?: number | null, realisticConfirmation?: boolean | null, impactProfileKind: ImpactProfileKind, isScenarioA?: boolean | null, preComputedBaselineGhg?: number | null, preComputedSolutionGhg?: number | null, scenarioBComments?: string | null, emissionSourceLimitations?: string | null, specificReductionPerUnit?: number | null, specificReductionAsPercentage?: number | null, emissionSources: Array<{ __typename?: 'EmissionSourceType', id?: number | null, ghgSavingPotentialId: number, sourceOfEmission?: string | null, unitName?: string | null, baselineUnitName?: string | null, solutionUnitName?: string | null, baselineConceptName?: string | null, baselineGhgFactor?: number | null, baselineConsumption?: number | null, baselineAssumption?: string | null, baselineEvidence: string, customBaselineConcept?: boolean | null, solutionReducesConsumption?: boolean | null, solutionReducesGhgFactor?: boolean | null, solutionConceptName?: string | null, solutionGhgFactor?: number | null, solutionConsumption?: number | null, solutionAssumption?: string | null, solutionEvidence: string, customSolutionConcept?: boolean | null, specificReductionPerUnit?: number | null, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> }>, metricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> } | null }>, sdgs: Array<{ __typename?: 'SdgType', id?: number | null, label: string, sublabel: string }>, sdgTargets: Array<{ __typename?: 'SdgTargetType', id?: number | null, label: string, sdgId?: number | null }>, irisCategories: Array<{ __typename?: 'IrisCategoryType', id?: number | null, label: string }>, geographies: Array<{ __typename?: 'GeographyType', id?: number | null, label: string }> }>, targetProgress: { __typename?: 'ImpactGoalProgressType', id: number, hasTarget: boolean, startDate?: number | null, endDate?: number | null, completionRate?: number | null, message?: string | null } }> };

export type ListIdematsQueryVariables = Exact<{
  input: IdematSearchInput;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<IdematSearchInput>;
  sort?: InputMaybe<Array<SortParam> | SortParam>;
}>;


export type ListIdematsQuery = { __typename?: 'ComboQuery', countIdemats: number, listIdemats: Array<{ __typename?: 'IdematType', id: number, idematId: string, name: string, categoryFull: string, ghgFactor: string, unit: string, notes: string, source: string }> };

export type ListMetricAssignmentConditionalChildrenQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  answer?: InputMaybe<Scalars['Float']['input']>;
}>;


export type ListMetricAssignmentConditionalChildrenQuery = { __typename?: 'ComboQuery', listMetricAssignmentConditionalChildren: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, metric?: { __typename?: 'MetricType', id?: number | null, name: string } | null }> };

export type CanAssignmentBeDeletedQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type CanAssignmentBeDeletedQuery = { __typename?: 'ComboQuery', canAssignmentBeDeleted: { __typename?: 'MetricAssignmentDependencyType', canBeDeleted: boolean, computationalDependentAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }>, conditionalDependentAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }> } };

export type GetMetricAssignmentQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetMetricAssignmentQuery = { __typename?: 'ComboQuery', getMetricAssignment: { __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null } };

export type ListMetricAssignmentsQueryVariables = Exact<{
  filters?: InputMaybe<ListMetricAssignmentFilter>;
  assigneeIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  metricIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  metricNotionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  ghgSavingPotentialId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  selfAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  showImpactTargets?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortParam> | SortParam>;
}>;


export type ListMetricAssignmentsQuery = { __typename?: 'ComboQuery', countMetricAssignments: number, listMetricAssignments: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, isDataEntered: boolean, customTargetStartDate?: number | null, customTargetEndDate?: number | null, customTargetCalculationType: AnnualAggregationMethod, customTargetWeight: number, unitName: string, impactSolutionId?: number | null, ghgSavingPotentialId?: number | null, emissionSourceId?: number | null, assignee?: { __typename?: 'AccountType', name?: string | null, logo?: string | null } | null, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, impacts: Array<{ __typename?: 'ImpactType', id?: number | null, stakeholder?: string | null, isPositive?: boolean | null, concept?: { __typename?: 'ConceptType', id?: number | null, label: string } | null }>, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }>, periodStatuses?: Array<{ __typename?: 'MetricAssignmentPeriodStatusType', period: string, isDataEntered: boolean, isActualDataEntered: boolean, isSkipped: boolean }> | null, completionStatus: { __typename?: 'MetricAssignmentCompletionType', hasTarget: boolean, metricAssignmentId: number, actual?: number | null, completionRate?: number | null, _id: number, targetParameters?: { __typename?: 'TargetParametersType', startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null, _id?: number | null } | null, aggregationView?: { __typename?: 'MetricAssignmentAggregationViewType', calculationType?: string | null, periodStart?: number | null, periodEnd?: number | null, unitName?: string | null, summary: { __typename?: 'MetricAssignmentAggregationSummaryType', actual?: number | null, target?: number | null, performancePercent?: number | null }, periods: Array<{ __typename?: 'MetricAssignmentAggregationPeriodType', period: string, rawActual?: number | null, rawTarget?: number | null, rawPerformancePercent?: number | null, accumulatedActual?: number | null, accumulatedTarget?: number | null, accumulatedPerformancePercent?: number | null, isMostRecentActivePeriod: boolean }> } | null }, targetParameters?: { __typename?: 'TargetParametersType', id?: number | null, startDate?: number | null, endDate?: number | null, target?: number | null, calculationType?: string | null, weight?: number | null, metricAssignmentId?: number | null, createdBy?: string | null, portfolioName?: string | null } | null, fund?: { __typename?: 'FundType', name?: string | null } | null, children?: Array<{ __typename?: 'MetricAssignmentType', id?: number | null, assigneeId?: any | null, comment?: string | null, isFrozen: boolean, goalType?: string | null, goalTarget?: number | null, reportingPeriodType: MetricReportingPeriodType, valueOptions?: any | null, metricNameOverride: string, metric?: { __typename: 'MetricType', id?: number | null, assignedTo?: TypeMetricAssignedTo | null, name: string, nameI18n: any, description: string, descriptionI18n: any, defaultGoalType?: string | null, defaultGoalTarget?: number | null, editable: boolean, unitName: string, isComputed: boolean, createdBy: string, defaultReportingPeriodType: MetricReportingPeriodType, allowQuarterlyInput: boolean, allowCustomOptions: boolean, annualAggregationMethod: AnnualAggregationMethod, valueType: MetricValueKind, valueOptions?: any | null, externalData?: any | null, usageGuidanceI18n: any, usageGuidance: string, conditions?: any | null, formula?: any | null, comment?: string | null, aggregationMethod: MetricAggregationMethod, portfolioCanEditMetricValue: boolean, categoryId?: number | null, commaSeparatedSections: string, notionId?: string | null, tocRelation?: MetricTheoryOfChangeRelation | null, tocDataCollectionMethod?: string | null, tocBaseline?: string | null, category?: { __typename?: 'CategoryType', id?: number | null, label: string } | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, description?: string | null, label?: string | null, taxonomy?: { __typename?: 'TaxonomyType', label: string } | null }> | null, directConditionalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, directComputationalChildren: Array<{ __typename?: 'MetricType', id?: number | null, name: string }>, humanReadableDirectFormula: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', id?: number | null, name: string, isComputed: boolean } | null }> } | null, metricValues: Array<{ __typename?: 'MetricValueType', id: string, editable: boolean, metricAssignmentId: number, period: string, target?: number | null, actual?: number | null, percentageAchieved?: number | null, comment?: string | null, options?: Array<string> | null, text?: string | null, targetLocked: boolean, actualLocked: boolean, lockLevel?: MetricValueLockLevel | null, lockedReason?: string | null, skipped: boolean, lockedByUserId?: any | null }> }> | null }>, listMetricAssignmentCategoryCounts: Array<{ __typename?: 'MetricAssignmentCategoryCountType', categoryId?: number | null, count: number }>, listMetricAssignmentSectionCounts: Array<{ __typename?: 'MetricAssignmentSectionCountType', sectionId?: number | null, count: number }> };

export type MetricValueAggregationQueryVariables = Exact<{
  period: Scalars['String']['input'];
}>;


export type MetricValueAggregationQuery = { __typename?: 'ComboQuery', metricValueAggregation: Array<{ __typename?: 'AggregatedResult', id: string, name: string, unitName?: string | null, defaultGoalType?: string | null, actualAvg?: number | null, targetAvg?: number | null, actualSum?: number | null, targetSum?: number | null, distinctVentureCnt?: number | null, withValueVentureCnt?: number | null, calculationType: MetricCalculationType }> };

export type GetQuestionQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetQuestionQuery = { __typename?: 'ComboQuery', getQuestion?: { __typename?: 'QuestionType', id?: number | null, sort: number, label: string, labelI18n: any, sublabel?: string | null, sublabelI18n: any, tooltip?: string | null, tooltipI18n: any, component: string, ixId?: string | null, isMandatory: boolean, isActiveByDefault: boolean, scoringRules?: any | null, isMultiple?: boolean | null, createdAt: any, updatedAt?: any | null, templateEngineContext?: TemplateEngineContext | null, targetEntity?: string | null, options: Array<{ __typename?: 'OptionType', id?: number | null, labelI18n: any, label?: string | null, sublabel?: string | null, tooltip?: string | null, ixId?: string | null }>, templateTexts: Array<{ __typename?: 'TemplateTextType', id: number, text: string, conds?: any | null }>, promptTemplate?: { __typename?: 'PromptTemplateType', id?: any | null, questionId: number, ixId: string, purpose?: string | null, latestVersionId?: any | null, isActive?: boolean | null, createdBy?: string | null } | null, currentPromptVersion?: { __typename?: 'PromptTemplateVersionType', id?: any | null, promptTemplateId: any, version: number, systemTemplate?: string | null, userTemplate: string, inputSchema?: any | null, outputSchema?: any | null, model: string, params?: any | null, notes?: string | null, createdBy?: string | null, createdAt: any, appendCompanyWebsiteScrape?: boolean | null } | null, questionSectionLinks: Array<{ __typename?: 'QuestionSectionLinkType', questionId?: number | null, sectionId?: number | null, labelI18n?: any | null, label?: string | null, sublabelI18n?: any | null, sublabel?: string | null, tooltipI18n?: any | null, tooltip?: string | null, section: { __typename?: 'SectionType', id?: number | null, label?: string | null, parent?: { __typename?: 'SectionType', id?: number | null, label?: string | null, parent?: { __typename?: 'SectionType', id?: number | null, label?: string | null } | null } | null } }> } | null };

export type ListQuestionsQueryVariables = Exact<{
  filters?: InputMaybe<ListQuestionFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListQuestionsQuery = { __typename?: 'ComboQuery', countQuestions: number, listQuestions: Array<{ __typename?: 'QuestionType', id?: number | null, sort: number, label: string, sublabel?: string | null, tooltip?: string | null, component: string, ixId?: string | null, isMandatory: boolean, isActiveByDefault: boolean, scoringRules?: any | null, isMultiple?: boolean | null, createdAt: any, updatedAt?: any | null, targetEntity?: string | null, templateTexts: Array<{ __typename?: 'TemplateTextType', id: number, text: string, conds?: any | null }>, promptTemplate?: { __typename?: 'PromptTemplateType', id?: any | null, questionId: number, ixId: string, purpose?: string | null, latestVersionId?: any | null, isActive?: boolean | null, createdBy?: string | null } | null, currentPromptVersion?: { __typename?: 'PromptTemplateVersionType', id?: any | null, promptTemplateId: any, version: number, systemTemplate?: string | null, userTemplate: string, inputSchema?: any | null, outputSchema?: any | null, model: string, params?: any | null, notes?: string | null, createdBy?: string | null, createdAt: any, appendCompanyWebsiteScrape?: boolean | null } | null }> };

export type BasicInfoForCompanyQueryVariables = Exact<{
  ventureId: Scalars['String']['input'];
}>;


export type BasicInfoForCompanyQuery = { __typename?: 'ComboQuery', basicInfoForCompany: { __typename?: 'CompanyInfoType', ventureName?: string | null, website?: string | null, questionnaireId: number, ventureId: string, pitchLine?: string | null, legalEntity?: string | null, founders: Array<string>, headquarter?: string | null, country?: string | null, foundingYear?: string | null, employeeHeadcount?: string | null, turnover?: string | null, fundingStage?: string | null, businessModel: Array<string>, incomeStream: Array<string>, products: Array<string>, industries: Array<string>, primaryIndustry?: string | null, customerGroup: Array<string>, customerGroupOptions?: string | null, commercialRegisterNumber?: string | null, postcode?: string | null, companyValuation?: string | null, id: string } };

export type EsgQuestionnaireAsTableQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type EsgQuestionnaireAsTableQuery = { __typename?: 'ComboQuery', esgQuestionnaireAsTable: Array<{ __typename?: 'QuestionSummaryType', sectionId: number, sectionLabel: string, subsectionId: number, subsectionLabel: string, label: string, actionsTaken: Array<string>, actionsPlanned: Array<string>, actionsNeither: Array<string>, disclosureRisks: Array<string>, comment?: string | null }> };

export type GetAggregatedEsgQuestionnaireResultQueryVariables = Exact<{
  input?: InputMaybe<GetAggregatedQuestionnaireResultFilter>;
}>;


export type GetAggregatedEsgQuestionnaireResultQuery = { __typename?: 'ComboQuery', getAggregatedEsgQuestionnaireResult: Array<{ __typename?: 'AggregatedQuestionnaireResultType', sectionLabel: string, score: number, details?: { __typename?: 'DetailsType', hasRisk: boolean, maxScore: number, questionDetails?: any | null, subsectionDetails?: any | null } | null }> };

export type GetEsgComparisonQueryVariables = Exact<{
  firstQuestionnaireId: Scalars['Int']['input'];
  secondQuestionnaireId: Scalars['Int']['input'];
}>;


export type GetEsgComparisonQuery = { __typename?: 'ComboQuery', getEsgComparison?: { __typename?: 'QuestionnaireComparisonType', firstQuestionnaireId?: number | null, secondQuestionnaireId?: number | null, commentE?: string | null, commentS?: string | null, commentG?: string | null } | null };

export type GetEsgMeasureComparisonQueryVariables = Exact<{
  input: EsgMeasureComparisonInput;
}>;


export type GetEsgMeasureComparisonQuery = { __typename?: 'ComboQuery', getEsgMeasureComparison?: { __typename?: 'EsgMeasureComparisonType', environmental: Array<{ __typename?: 'MeasureComparisonType', category: string, measure: string, statusFirstPeriod: ImplementationStatus, statusSecondPeriod: ImplementationStatus }>, social: Array<{ __typename?: 'MeasureComparisonType', category: string, measure: string, statusFirstPeriod: ImplementationStatus, statusSecondPeriod: ImplementationStatus }>, governance: Array<{ __typename?: 'MeasureComparisonType', category: string, measure: string, statusFirstPeriod: ImplementationStatus, statusSecondPeriod: ImplementationStatus }>, disclosure: Array<{ __typename?: 'MeasureComparisonType', category: string, measure: string, statusFirstPeriod: ImplementationStatus, statusSecondPeriod: ImplementationStatus }> } | null };

export type GetEsgQuestionnaireResultsForVenturesQueryVariables = Exact<{
  filters?: InputMaybe<ListPortfolioVentureLinksFilter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetEsgQuestionnaireResultsForVenturesQuery = { __typename?: 'ComboQuery', countEsgQuestionnaireResultsForVentures: number, getEsgQuestionnaireResultsForVentures: Array<{ __typename?: 'QuestionnaireResultSummaryType', ventureId: string, isCompleted: boolean, updatedAt?: any | null, total?: number | null, totalDiffToPrevious?: number | null, environmental?: number | null, environmentalDiffToPrevious?: number | null, social?: number | null, socialDiffToPrevious?: number | null, governance?: number | null, governanceDiffToPrevious?: number | null, disclosure?: any | null, _id: string }> };

export type GetMostRecentQuestionnaireForVentureAndLabelQueryVariables = Exact<{
  ventureId: Scalars['String']['input'];
  label: Scalars['String']['input'];
}>;


export type GetMostRecentQuestionnaireForVentureAndLabelQuery = { __typename?: 'ComboQuery', getMostRecentQuestionnaireForVentureAndLabel: { __typename?: 'QuestionnaireType', questionnaireAssignment?: { __typename?: 'QuestionnaireAssignmentType', id?: number | null, isEditable: boolean, updatedAt?: any | null, period?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null } | null, userInputs: Array<{ __typename?: 'UserInputType', id?: number | null, isActive: boolean, isNotRelevant?: boolean | null, geographyIds?: Array<number> | null, text?: string | null, scoringRule?: any | null, question: { __typename?: 'QuestionType', id?: number | null, label: string, component: string }, selectedOptions?: Array<{ __typename?: 'OptionType', id?: number | null, label?: string | null }> | null, selectedConcepts: Array<{ __typename?: 'UserInputConceptLinkType', implementationStatus: ImplementationStatus, comment: string, userInputId?: number | null, conceptId?: number | null, concept: { __typename?: 'ConceptType', id?: number | null, label: string, scheme?: RiskManagementScheme | null, description: string, isSubmeasure: boolean } }> }>, sectionCompletion: Array<{ __typename?: 'SectionCompletionType', sectionId: number, isCompleted: boolean, percentageCompleted: number, numberRequired: number, numberIncomplete: number, incompleteQuestions: Array<string> }>, questionnaireResults: Array<{ __typename?: 'QuestionnaireResultType', id?: number | null, sectionId?: number | null, sectionLabel: string, score?: number | null, details?: any | null }> } | null, questionnaireTemplate?: { __typename?: 'QuestionnaireTemplateType', id?: number | null, ventureId: any, sections?: Array<{ __typename?: 'SectionType', id?: number | null, ixId?: string | null, label?: string | null, sections: Array<{ __typename?: 'SectionType', id?: number | null, ixId?: string | null, label?: string | null, description?: string | null, questions: Array<{ __typename?: 'QuestionType', id?: number | null, ixId?: string | null, component: string, tooltip?: string | null, isMultiple?: boolean | null, isMandatory: boolean, title: string, subtitle?: string | null, options: Array<{ __typename?: 'OptionType', id?: number | null, ixId?: string | null, label?: string | null, sublabel?: string | null, tooltip?: string | null }>, concepts: Array<{ __typename?: 'ConceptType', id?: number | null, ixId?: string | null, label: string, scheme?: RiskManagementScheme | null, description: string }>, questions: Array<{ __typename?: 'QuestionType', id?: number | null, ixId?: string | null, component: string, tooltip?: string | null, isMultiple?: boolean | null, isMandatory: boolean, title: string, subtitle?: string | null, options: Array<{ __typename?: 'OptionType', id?: number | null, ixId?: string | null, label?: string | null, sublabel?: string | null, tooltip?: string | null }> }> }> }>, questions: Array<{ __typename?: 'QuestionType', id?: number | null, ixId?: string | null, component: string, tooltip?: string | null, isMultiple?: boolean | null, isMandatory: boolean, title: string, subtitle?: string | null, options: Array<{ __typename?: 'OptionType', id?: number | null, ixId?: string | null, label?: string | null, sublabel?: string | null, tooltip?: string | null }> }> }> | null } | null, questionnaireNavigation?: { __typename?: 'QuestionnaireNavigationType', id?: number | null, currentSection?: number | null, currentSubsection?: number | null } | null } };

export type GetQuestionnaireQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetQuestionnaireQuery = { __typename?: 'ComboQuery', getQuestionnaire?: { __typename?: 'QuestionnaireType', questionnaireAssignment?: { __typename?: 'QuestionnaireAssignmentType', id?: number | null, isEditable: boolean, updatedAt?: any | null, period?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null } | null, userInputs: Array<{ __typename?: 'UserInputType', id?: number | null, isActive: boolean, isNotRelevant?: boolean | null, geographyIds?: Array<number> | null, text?: string | null, scoringRule?: any | null, question: { __typename?: 'QuestionType', id?: number | null, label: string, component: string }, selectedOptions?: Array<{ __typename?: 'OptionType', id?: number | null, label?: string | null }> | null, selectedConcepts: Array<{ __typename?: 'UserInputConceptLinkType', implementationStatus: ImplementationStatus, comment: string, userInputId?: number | null, conceptId?: number | null, concept: { __typename?: 'ConceptType', id?: number | null, label: string, scheme?: RiskManagementScheme | null, description: string, isSubmeasure: boolean } }> }>, sectionCompletion: Array<{ __typename?: 'SectionCompletionType', sectionId: number, isCompleted: boolean, percentageCompleted: number, numberRequired: number, numberIncomplete: number, incompleteQuestions: Array<string> }>, questionnaireResults: Array<{ __typename?: 'QuestionnaireResultType', id?: number | null, sectionId?: number | null, sectionLabel: string, score?: number | null, details?: any | null }> } | null, questionnaireTemplate?: { __typename?: 'QuestionnaireTemplateType', id?: number | null, ventureId: any, sections?: Array<{ __typename?: 'SectionType', id?: number | null, ixId?: string | null, label?: string | null, sections: Array<{ __typename?: 'SectionType', id?: number | null, ixId?: string | null, label?: string | null, description?: string | null, questions: Array<{ __typename?: 'QuestionType', id?: number | null, ixId?: string | null, component: string, tooltip?: string | null, isMultiple?: boolean | null, isMandatory: boolean, title: string, subtitle?: string | null, options: Array<{ __typename?: 'OptionType', id?: number | null, ixId?: string | null, label?: string | null, labelI18n: any, sublabel?: string | null, tooltip?: string | null }>, concepts: Array<{ __typename?: 'ConceptType', id?: number | null, ixId?: string | null, label: string, labelI18n: any, scheme?: RiskManagementScheme | null, description: string, isSubmeasure: boolean, additionalData?: any | null, sourceUrl: string, citation: string, isMaterial: boolean, materialityExplanation: string, status: ConceptStatus }>, questions: Array<{ __typename?: 'QuestionType', id?: number | null, ixId?: string | null, component: string, tooltip?: string | null, isMultiple?: boolean | null, isMandatory: boolean, title: string, subtitle?: string | null, options: Array<{ __typename?: 'OptionType', id?: number | null, ixId?: string | null, label?: string | null, sublabel?: string | null, tooltip?: string | null }> }> }> }>, questions: Array<{ __typename?: 'QuestionType', id?: number | null, ixId?: string | null, component: string, tooltip?: string | null, isMultiple?: boolean | null, isMandatory: boolean, title: string, subtitle?: string | null, options: Array<{ __typename?: 'OptionType', id?: number | null, ixId?: string | null, label?: string | null, sublabel?: string | null, tooltip?: string | null }> }> }> | null } | null, questionnaireNavigation?: { __typename?: 'QuestionnaireNavigationType', id?: number | null, currentSection?: number | null, currentSubsection?: number | null } | null } | null };

export type GetQuestionnaireForComparisonQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetQuestionnaireForComparisonQuery = { __typename?: 'ComboQuery', getQuestionnaire?: { __typename?: 'QuestionnaireType', questionnaireAssignment?: { __typename?: 'QuestionnaireAssignmentType', id?: number | null, updatedAt?: any | null, period?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null } | null, questionnaireResults: Array<{ __typename?: 'QuestionnaireResultType', id?: number | null, sectionId?: number | null, sectionLabel: string, score?: number | null, details?: any | null }>, userInputs: Array<{ __typename?: 'UserInputType', id?: number | null, isActive: boolean, isNotRelevant?: boolean | null, geographyIds?: Array<number> | null, text?: string | null, scoringRule?: any | null, question: { __typename?: 'QuestionType', id?: number | null, label: string, component: string }, selectedOptions?: Array<{ __typename?: 'OptionType', id?: number | null, label?: string | null }> | null, selectedConcepts: Array<{ __typename?: 'UserInputConceptLinkType', implementationStatus: ImplementationStatus, comment: string, userInputId?: number | null, conceptId?: number | null, concept: { __typename?: 'ConceptType', id?: number | null, label: string, scheme?: RiskManagementScheme | null, description: string, isSubmeasure: boolean } }> }> } | null, questionnaireTemplate?: { __typename?: 'QuestionnaireTemplateType', id?: number | null, sections?: Array<{ __typename?: 'SectionType', id?: number | null, ixId?: string | null, label?: string | null, sections: Array<{ __typename?: 'SectionType', id?: number | null, ixId?: string | null, label?: string | null }> }> | null } | null } | null };

export type GetQuestionnaireV2QueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetQuestionnaireV2Query = { __typename?: 'ComboQuery', getQuestionnaire?: { __typename?: 'QuestionnaireType', id?: number | null, ventureId: any, sections: Array<{ __typename?: 'SectionType', id?: number | null, label?: string | null, labelI18n: any, sections: Array<{ __typename?: 'SectionType', id?: number | null, label?: string | null, labelI18n: any, description?: string | null, questions: Array<{ __typename?: 'QuestionType', id?: number | null, ixId?: string | null, component: string, tooltip?: string | null, isMultiple?: boolean | null, isMandatory: boolean, title: string, subtitle?: string | null, options: Array<{ __typename?: 'OptionType', id?: number | null, ixId?: string | null, label?: string | null, sublabel?: string | null, tooltip?: string | null }>, concepts: Array<{ __typename?: 'ConceptType', id?: number | null, ixId?: string | null, label: string, labelI18n: any, scheme?: RiskManagementScheme | null, description: string }>, questions: Array<{ __typename?: 'QuestionType', id?: number | null, ixId?: string | null, component: string, tooltip?: string | null, isMultiple?: boolean | null, isMandatory: boolean, title: string, subtitle?: string | null, options: Array<{ __typename?: 'OptionType', id?: number | null, ixId?: string | null, label?: string | null, sublabel?: string | null, tooltip?: string | null }> }> }> }>, questions: Array<{ __typename?: 'QuestionType', id?: number | null, ixId?: string | null, component: string, tooltip?: string | null, isMultiple?: boolean | null, isMandatory: boolean, title: string, subtitle?: string | null, options: Array<{ __typename?: 'OptionType', id?: number | null, ixId?: string | null, label?: string | null, sublabel?: string | null, tooltip?: string | null }> }> }> } | null };

export type GetQuestionnairesForVenturesAndLabelQueryVariables = Exact<{
  ventureIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  label: Scalars['String']['input'];
}>;


export type GetQuestionnairesForVenturesAndLabelQuery = { __typename?: 'ComboQuery', getQuestionnairesForVenturesAndLabel: Array<{ __typename?: 'QuestionnaireAssignmentType', id?: number | null, isEditable: boolean, updatedAt?: any | null, sections: Array<{ __typename?: 'SectionType', id?: number | null, label?: string | null }>, period?: { __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null } | null, venture: { __typename?: 'AccountType', id: any, name?: string | null } }> };

export type OptionFieldsFragment = { __typename?: 'OptionType', id?: number | null, externalId?: string | null, label?: string | null, sublabel?: string | null, tooltip?: string | null, ixId?: string | null };

export type ListOptionsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ListOptionsQuery = { __typename?: 'ComboQuery', listOptions: Array<{ __typename?: 'OptionType', id?: number | null, externalId?: string | null, label?: string | null, sublabel?: string | null, tooltip?: string | null, ixId?: string | null, children: Array<{ __typename?: 'OptionType', id?: number | null, externalId?: string | null, label?: string | null, sublabel?: string | null, tooltip?: string | null, ixId?: string | null, children: Array<{ __typename?: 'OptionType', id?: number | null, externalId?: string | null, label?: string | null, sublabel?: string | null, tooltip?: string | null, ixId?: string | null, children: Array<{ __typename?: 'OptionType', id?: number | null, externalId?: string | null, label?: string | null, sublabel?: string | null, tooltip?: string | null, ixId?: string | null, children: Array<{ __typename?: 'OptionType', id?: number | null, externalId?: string | null, label?: string | null, sublabel?: string | null, tooltip?: string | null, ixId?: string | null }> }> }> }> }> };

export type ListPromptTemplateVersionQueryVariables = Exact<{
  filters?: InputMaybe<ListPromptTemplateVersionFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListPromptTemplateVersionQuery = { __typename?: 'ComboQuery', listPromptTemplateVersion: Array<{ __typename?: 'PromptTemplateVersionType', id?: any | null, promptTemplateId: any, version: number, systemTemplate?: string | null, userTemplate: string, inputSchema?: any | null, outputSchema?: any | null, model: string, params?: any | null, notes?: string | null, createdBy?: string | null, createdAt: any, appendCompanyWebsiteScrape?: boolean | null }> };

export type ListQuestionnairesQueryVariables = Exact<{
  filters?: InputMaybe<ListQuestionnaireFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListQuestionnairesQuery = { __typename?: 'ComboQuery', countQuestionnaires: number, listQuestionnaires: Array<{ __typename?: 'QuestionnaireType', id?: number | null, ventureId: any, createdAt: any, updatedAt?: any | null, venture: { __typename?: 'AccountType', name?: string | null }, sections: Array<{ __typename?: 'SectionType', id?: number | null, label?: string | null }>, period?: { __typename?: 'ReferencePeriodType', startDate?: any | null, endDate?: any | null, id?: number | null, label?: string | null, createdBy?: string | null, userDefined?: boolean | null } | null }> };

export type ListReferencePeriodsQueryVariables = Exact<{
  filters?: InputMaybe<ListReferencePeriodFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListReferencePeriodsQuery = { __typename?: 'ComboQuery', listReferencePeriods: Array<{ __typename?: 'ReferencePeriodType', id?: number | null, label?: string | null, startDate?: any | null, endDate?: any | null, userDefined?: boolean | null, createdBy?: string | null }> };

export type GetReportingRequestQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetReportingRequestQuery = { __typename?: 'ComboQuery', getReportingRequest: { __typename?: 'ReportingRequestGraphType', id: any, title: string, description: string, referencePeriod: string, dueDate?: any | null, requestType: ReportingRequestType, portfolioId: any, createdAt: any, metricIds: Array<number>, ventures: Array<{ __typename?: 'ReportingRequestVentureGraphType', ventureId: any, status: ReportingVentureStatus, metricIds: Array<number>, questionnaireId?: number | null, statusSummary: { __typename?: 'ReportingRequestVentureStatusSummaryGraphType', totalKpis: number, completedKpis: number, skippedKpis: number, incompleteKpis: number }, venture: { __typename?: 'AccountType', id: any, name?: string | null, logo?: string | null } }> } };

export type ListReportingRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListReportingRequestsQuery = { __typename?: 'ComboQuery', listReportingRequests: Array<{ __typename?: 'ReportingRequestGraphType', id: any, title: string, description: string, referencePeriod: string, dueDate?: any | null, requestType: ReportingRequestType, portfolioId: any, fundId?: number | null, createdAt: any, metricIds: Array<number>, ventures: Array<{ __typename?: 'ReportingRequestVentureGraphType', ventureId: any, status: ReportingVentureStatus, metricIds: Array<number>, questionnaireId?: number | null, statusSummary: { __typename?: 'ReportingRequestVentureStatusSummaryGraphType', totalKpis: number, completedKpis: number, skippedKpis: number, incompleteKpis: number }, venture: { __typename?: 'AccountType', id: any, name?: string | null } }> }> };

export type ReportingRequestKpiOptionsQueryVariables = Exact<{
  ventureIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type ReportingRequestKpiOptionsQuery = { __typename?: 'ComboQuery', reportingRequestKpiOptions: Array<{ __typename?: 'ReportingRequestKpiOptionGraphType', metricId: number, metricName: string, ventureIds: Array<any> }> };

export type ReportingVenturesMissingEsgModuleQueryVariables = Exact<{
  ventureIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type ReportingVenturesMissingEsgModuleQuery = { __typename?: 'ComboQuery', reportingVenturesMissingEsgModule: Array<any> };

export type ReportingVenturesMissingImpactCarryQueryVariables = Exact<{
  ventureIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type ReportingVenturesMissingImpactCarryQuery = { __typename?: 'ComboQuery', reportingVenturesMissingImpactCarry: Array<any> };

export type ExportReviewCompanyTypstPdfsQueryVariables = Exact<{
  input: ExportReviewCompanyTypstPdfsInput;
}>;


export type ExportReviewCompanyTypstPdfsQuery = { __typename?: 'ComboQuery', exportReviewCompanyTypstPdfs: { __typename?: 'ExportReviewCompanyTypstPdfsResultGraphType', zipFile?: { __typename?: 'FileExportType', fileName: string, format: FileFormat, base64String: string } | null, items: Array<{ __typename?: 'ReviewCompanyTypstExportItemGraphType', ventureId: any, status: ReviewCompanyTypstExportStatus, errorMessage?: string | null }> } };

export type ExportReviewImpactDataQueryVariables = Exact<{
  input: ExportReviewImpactDataInput;
}>;


export type ExportReviewImpactDataQuery = { __typename?: 'ComboQuery', exportReviewImpactData: { __typename?: 'FileExportType', fileName: string, format: FileFormat, base64String: string } };

export type GetReviewRequestQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetReviewRequestQuery = { __typename?: 'ComboQuery', getReviewRequest: { __typename?: 'ReviewRequestGraphType', id: any, title: string, description: string, reviewType: ReviewType, createdAt: any, createdBy?: { __typename?: 'UserType', email: string, firstName?: string | null, lastName?: string | null } | null, assignedReviewers: Array<{ __typename?: 'UserType', id: any, email: string }>, ventures: Array<{ __typename?: 'ReviewRequestVentureGraphType', ventureId: any, status: ReviewVentureStatus, venture: { __typename?: 'AccountType', id: any, name?: string | null, logo?: string | null }, latestEvent?: { __typename?: 'ReviewEventGraphType', id: any, eventType: ReviewEventType, comment: string, createdAt: any, snapshot?: any | null, reviewer?: { __typename?: 'UserType', email: string } | null } | null }> } };

export type ListReviewEventsQueryVariables = Exact<{
  filters: ReviewEventFilters;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListReviewEventsQuery = { __typename?: 'ComboQuery', countReviewEvents: number, listReviewEvents: Array<{ __typename?: 'ReviewEventGraphType', id: any, eventType: ReviewEventType, comment: string, createdAt: any, ventureId: any, reviewer?: { __typename?: 'UserType', email: string } | null, venture: { __typename?: 'AccountType', id: any, name?: string | null } }> };

export type ListReviewRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListReviewRequestsQuery = { __typename?: 'ComboQuery', listReviewRequests: Array<{ __typename?: 'ReviewRequestGraphType', id: any, title: string, description: string, reviewType: ReviewType, createdAt: any, createdBy?: { __typename?: 'UserType', email: string } | null, assignedReviewers: Array<{ __typename?: 'UserType', id: any, email: string }>, ventures: Array<{ __typename?: 'ReviewRequestVentureGraphType', ventureId: any, status: ReviewVentureStatus, venture: { __typename?: 'AccountType', id: any, name?: string | null } }> }> };

export type GetStakeholderQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetStakeholderQuery = { __typename?: 'ComboQuery', getStakeholder: { __typename?: 'StakeholderType', id: any, name: string, type: string, description: string, activityLinks?: Array<{ __typename?: 'ActivityStakeholderLinkType', id: any, activityId: any, stakeholderId: any, impactMaterial: boolean, financialMaterial: boolean, activity: { __typename?: 'ActivityType', id: any, name: string, geographyId?: number | null } }> | null, iroLinks?: Array<{ __typename?: 'IroStakeholderLinkType', id: any, iroId?: any | null, stakeholderId: any, impactMaterial: boolean, financialMaterial: boolean, iro?: { __typename?: 'IROType', id: any, name: string } | null }> | null } };

export type ListStakeholdersQueryVariables = Exact<{
  filters?: InputMaybe<ListStakeholderFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListStakeholdersQuery = { __typename?: 'ComboQuery', countStakeholders: number, listStakeholders: Array<{ __typename?: 'StakeholderType', id: any, name: string, type: string, description: string, activityLinks?: Array<{ __typename?: 'ActivityStakeholderLinkType', id: any, activityId: any, stakeholderId: any, impactMaterial: boolean, financialMaterial: boolean, activity: { __typename?: 'ActivityType', id: any, name: string, type: EnumActivityType, geographyId?: number | null } }> | null, iroLinks?: Array<{ __typename?: 'IroStakeholderLinkType', id: any, iroId?: any | null, stakeholderId: any, impactMaterial: boolean, financialMaterial: boolean, iro?: { __typename?: 'IROType', id: any, name: string, levelOfImpact?: EnumIroLevelOfImpact | null, type: EnumIroType, overrideStatus?: EnumIroOverrideStatus | null, status?: EnumIroStatus | null } | null }> | null }> };

export type ChatgptTranslateQueryVariables = Exact<{
  input: ChatgptTranslationInput;
  prompt?: InputMaybe<PromptEnum>;
}>;


export type ChatgptTranslateQuery = { __typename?: 'ComboQuery', chatgptTranslate: Array<{ __typename?: 'ChatgptTranslationOutput', inputText: string, sourceLanguage?: string | null, translatedText: string, targetLanguage: string }> };

export type ListUserInputsQueryVariables = Exact<{
  input: Array<UserInputInput> | UserInputInput;
}>;


export type ListUserInputsQuery = { __typename?: 'ComboQuery', listUserInputs: Array<{ __typename?: 'UserInputVentureMappingType', ventureId: any, periodId?: number | null, userInput?: { __typename?: 'UserInputType', id?: number | null, text?: string | null, geographyIds?: Array<number> | null, selectedOptions?: Array<{ __typename?: 'OptionType', id?: number | null, label?: string | null }> | null } | null }> };

export type CheckEmailDomainAccountWarningQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type CheckEmailDomainAccountWarningQuery = { __typename?: 'ComboQuery', checkEmailDomainAccountWarning: { __typename?: 'EmailDomainAccountWarningType', domainMatched: boolean, accountNames: Array<string>, additionalCount: number } };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'ComboQuery', getUser: { __typename?: 'UserType', id: any, isAdmin: boolean, realUserIsAdmin: boolean, isImpersonated: boolean, locale: string, email: string, firstName?: string | null, lastName?: string | null, accounts?: Array<{ __typename?: 'AccountType', id: any, name?: string | null, type: AccountCategory, movedToUrls?: Array<string> | null }> | null } };

export type GetUserByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetUserByIdQuery = { __typename?: 'ComboQuery', getUserById?: { __typename?: 'UserType', id: any, firstName?: string | null, lastName?: string | null } | null };

export type ListUsersQueryVariables = Exact<{
  accountId?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListUsersQuery = { __typename?: 'ComboQuery', countUsers: number, listUsers: Array<{ __typename?: 'UserType', id: any, locale: string, firstName?: string | null, lastName?: string | null, email: string, lastLogin?: any | null, isIxAdmin?: boolean | null, membershipRolesForAccount: Array<AccountMembershipRole>, accounts?: Array<{ __typename?: 'AccountType', id: any, name?: string | null }> | null }> };

export type ListUserLogEventsQueryVariables = Exact<{
  email: Scalars['String']['input'];
  perPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListUserLogEventsQuery = { __typename?: 'ComboQuery', listUserLogEvents: any };

export type ValidateFormulaMutationVariables = Exact<{
  expression: Scalars['String']['input'];
}>;


export type ValidateFormulaMutation = { __typename?: 'ComboMutation', validateFormula?: { __typename?: 'FormulaValidateResponse', formula: any, error?: string | null, humanReadable: Array<{ __typename?: 'FormulaOperator', type: FormulaOperatorType, value?: string | null, variable?: { __typename?: 'MetricType', name: string, id?: number | null } | null }> } | null };

export type ValidateTemplateTextQueryVariables = Exact<{
  templateText: Scalars['String']['input'];
  fundId?: InputMaybe<Scalars['Int']['input']>;
  context?: InputMaybe<TemplateEngineContext>;
  impactSolutionId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ValidateTemplateTextQuery = { __typename?: 'ComboQuery', validateTemplateText?: { __typename?: 'TemplateValidateResponse', valid: boolean, originalText: string, processedText?: string | null, error?: string | null } | null };

export const CompleteUserInputConceptLinkFragmentDoc = gql`
    fragment CompleteUserInputConceptLink on UserInputConceptLinkType {
  implementationStatus
  comment
  userInputId
  conceptId
  concept {
    id
    label
    scheme
    description
    isSubmeasure
  }
}
    `;
export const CompleteUserInputFragmentDoc = gql`
    fragment CompleteUserInput on UserInputType {
  id
  isActive
  isNotRelevant
  geographyIds
  question {
    id
    label
    component
  }
  selectedOptions {
    id
    label
  }
  selectedConcepts {
    ...CompleteUserInputConceptLink
  }
  text
  scoringRule
}
    ${CompleteUserInputConceptLinkFragmentDoc}`;
export const QuestionnaireFragmentFragmentDoc = gql`
    fragment QuestionnaireFragment on QuestionnaireAssignmentType {
  id
  isEditable
  updatedAt
  period {
    id
    label
  }
  userInputs {
    ...CompleteUserInput
  }
  sectionCompletion {
    sectionId
    isCompleted
    percentageCompleted
    numberRequired
    numberIncomplete
    incompleteQuestions
  }
  questionnaireResults {
    id
    sectionId
    sectionLabel
    score
    details
  }
}
    ${CompleteUserInputFragmentDoc}`;
export const AccountFragmentForEuTaxonomyFragmentDoc = gql`
    fragment AccountFragmentForEuTaxonomy on AccountType {
  id
  businessActivities {
    id
  }
  bookedModules
  hasNoEligibleBusinessActivities
  areEuTaxonomyActivitiesInSyncWithQuestionnaire
  fundSustainableObjectives {
    doCheckEuTaxonomyAlignment
    concept {
      id
      label
      createdBy
    }
    fund {
      name
    }
    euTaxonomyConcept {
      id
      label
    }
  }
  euTaxonomyQuestionnaire {
    id
    label
    questionnaireAssignment {
      ...QuestionnaireFragment
    }
    questionnaireTemplate {
      sections {
        label
        id
        ixId
        description
        questions {
          id
          ixId
          component
          tooltip
          title: label
          subtitle: sublabel
          isMultiple
          isMandatory
          options {
            id
            ixId
            label
            sublabel
            tooltip
          }
        }
        sections {
          label
          id
          questions {
            id
            ixId
            component
            tooltip
            title: label
            subtitle: sublabel
            isMultiple
            isMandatory
            options {
              id
              ixId
              label
              sublabel
              tooltip
            }
          }
        }
      }
    }
  }
}
    ${QuestionnaireFragmentFragmentDoc}`;
export const AccountLinkFragmentDoc = gql`
    fragment AccountLink on AccountSectionLinkType {
  id
  accountId
  sectionId
  comment
}
    `;
export const CompleteMetricFragmentDoc = gql`
    fragment CompleteMetric on MetricType {
  __typename
  id
  assignedTo
  name
  nameI18n
  description
  descriptionI18n
  defaultGoalType
  defaultGoalTarget
  editable
  unitName
  isComputed
  createdBy
  defaultReportingPeriodType
  allowQuarterlyInput
  allowCustomOptions
  annualAggregationMethod
  valueType
  valueOptions
  externalData
  usageGuidanceI18n
  usageGuidance
  conditions
  formula
  comment
  aggregationMethod
  portfolioCanEditMetricValue
  categoryId
  category {
    id
    label
  }
  taxonomy {
    label
  }
  commaSeparatedSections
  notionId
  tocRelation
  tocDataCollectionMethod
  tocBaseline
  sections {
    id
    description
    label
    taxonomy {
      label
    }
  }
  directConditionalChildren {
    id
    name
  }
  directComputationalChildren {
    id
    name
  }
  humanReadableDirectFormula {
    type
    value
    variable {
      id
      name
      isComputed
    }
  }
}
    `;
export const BasicMetricAggregationFragmentDoc = gql`
    fragment BasicMetricAggregation on MetricAggregationType {
  id
  comment
  groupId
  groupType
  calculationType
  paiMetricName
  indicator
  category
  paiSort
  metricAggregationValues {
    period
    actual
    target
    actualCompleted {
      name
      id
    }
    required {
      name
      id
    }
  }
  metric {
    ...CompleteMetric
  }
  fund {
    id
    name
  }
  sfdrStrategy {
    id
    kind
    fund {
      name
    }
    concept {
      label
    }
  }
}
    ${CompleteMetricFragmentDoc}`;
export const CompleteConceptFragmentDoc = gql`
    fragment CompleteConcept on ConceptType {
  id
  label
  labelI18n
  description
  descriptionI18n
  isSubmeasure
  additionalData
  sourceUrl
  citation
  citationI18n
  isMaterial
  materialityExplanation
  materialityExplanationI18n
  status
  scheme
  kind
  ixId
  impacts {
    id
  }
  taxonomy {
    id
    label
  }
  objectLinks {
    object {
      id
      label
    }
    predicate
  }
}
    `;
export const ShortImpactFragmentDoc = gql`
    fragment ShortImpact on ImpactType {
  id
  concept {
    id
    label
  }
  stakeholder
  isPositive
}
    `;
export const CompleteMetricValueFragmentDoc = gql`
    fragment CompleteMetricValue on MetricValueType {
  id
  editable
  metricAssignmentId
  period
  target
  actual
  percentageAchieved
  comment
  options
  text
  targetLocked
  actualLocked
  lockLevel
  lockedReason
  skipped
  lockedByUserId
}
    `;
export const CompleteCompletionStatusFragmentDoc = gql`
    fragment CompleteCompletionStatus on MetricAssignmentCompletionType {
  _id: metricAssignmentId
  hasTarget
  metricAssignmentId
  actual
  completionRate
  targetParameters {
    _id: metricAssignmentId
    startDate
    endDate
    target
    calculationType
    weight
    metricAssignmentId
    createdBy
    portfolioName
  }
  aggregationView {
    calculationType
    periodStart
    periodEnd
    unitName
    summary {
      actual
      target
      performancePercent
    }
    periods {
      period
      rawActual
      rawTarget
      rawPerformancePercent
      accumulatedActual
      accumulatedTarget
      accumulatedPerformancePercent
      isMostRecentActivePeriod
    }
  }
}
    `;
export const CompleteTargetParametersFragmentDoc = gql`
    fragment CompleteTargetParameters on TargetParametersType {
  id
  startDate
  endDate
  target
  calculationType
  weight
  metricAssignmentId
  createdBy
  portfolioName
}
    `;
export const CompleteMetricAssignmentFragmentDoc = gql`
    fragment CompleteMetricAssignment on MetricAssignmentType {
  id
  assigneeId
  comment
  isFrozen
  goalType
  goalTarget
  reportingPeriodType
  valueOptions
  metricNameOverride
  isDataEntered
  customTargetStartDate
  customTargetEndDate
  customTargetCalculationType
  customTargetWeight
  assignee {
    name
    logo
  }
  unitName
  metric {
    ...CompleteMetric
  }
  impacts {
    ...ShortImpact
  }
  metricValues {
    ...CompleteMetricValue
  }
  periodStatuses {
    period
    isDataEntered
    isActualDataEntered
    isSkipped
  }
  completionStatus {
    ...CompleteCompletionStatus
  }
  targetParameters {
    ...CompleteTargetParameters
  }
  impactSolutionId
  ghgSavingPotentialId
  emissionSourceId
  fund {
    name
  }
  children {
    id
    assigneeId
    comment
    isFrozen
    goalType
    goalTarget
    reportingPeriodType
    valueOptions
    metricNameOverride
    metric {
      ...CompleteMetric
    }
    metricValues {
      ...CompleteMetricValue
    }
  }
}
    ${CompleteMetricFragmentDoc}
${ShortImpactFragmentDoc}
${CompleteMetricValueFragmentDoc}
${CompleteCompletionStatusFragmentDoc}
${CompleteTargetParametersFragmentDoc}`;
export const CompleteEmissionSourceFragmentDoc = gql`
    fragment CompleteEmissionSource on EmissionSourceType {
  id
  ghgSavingPotentialId
  sourceOfEmission
  unitName
  baselineUnitName
  solutionUnitName
  baselineConceptName
  baselineGhgFactor
  baselineConsumption
  baselineAssumption
  baselineEvidence
  customBaselineConcept
  solutionReducesConsumption
  solutionReducesGhgFactor
  solutionConceptName
  solutionGhgFactor
  solutionConsumption
  solutionAssumption
  solutionEvidence
  customSolutionConcept
  specificReductionPerUnit
  metricAssignments {
    ...CompleteMetricAssignment
  }
}
    ${CompleteMetricAssignmentFragmentDoc}`;
export const CompleteGhgSavingPotentialFragmentDoc = gql`
    fragment CompleteGhgSavingPotential on GhgSavingPotentialType {
  id
  needFulfilled
  baselineSolutionDescription
  comparativeUnit
  comparativeQuantitiy
  comparativeUnitConfirmed
  describeComparison
  isPreciseEmissionCalculation
  simpleBaselineGhg
  simpleSolutionGhg
  simpleGhgJustification
  emissionsConfirmed
  growthFactorJustification
  isRecurringImpact
  durationOfImpact
  realisticConfirmation
  impactProfileKind
  isScenarioA
  preComputedBaselineGhg
  preComputedSolutionGhg
  scenarioBComments
  emissionSourceLimitations
  emissionSources {
    ...CompleteEmissionSource
  }
  specificReductionPerUnit
  specificReductionAsPercentage
  metricAssignments {
    ...CompleteMetricAssignment
  }
}
    ${CompleteEmissionSourceFragmentDoc}
${CompleteMetricAssignmentFragmentDoc}`;
export const CompleteImpactSolutionFragmentDoc = gql`
    fragment CompleteImpactSolution on ImpactSolutionType {
  id
  impactId
  targetGroup
  problemDescription
  solutionDescription
  solutionSource {
    id
    url
    comment
  }
  concept {
    id
    label
  }
  kind
  ghgSavingPotentialId
  useGhgSavingPotentialTool
  ghgSavingPotential {
    ...CompleteGhgSavingPotential
  }
}
    ${CompleteGhgSavingPotentialFragmentDoc}`;
export const CompleteImpactFragmentDoc = gql`
    fragment CompleteImpact on ImpactType {
  id
  conceptId
  concept {
    ...CompleteConcept
  }
  stakeholder
  stakeholderCategory
  isPositive
  theoryOfChange
  problem
  problemStatement
  companyVision
  targetGroup
  inputsActivities
  solutionsOutput
  shortTermOutcomes
  longTermImpacts
  riskReboundEffects
  euTaxonomy
  initialInvestmentDate
  startingYear
  durationYears
  carryRemarks
  isEditable
  submitDate
  sourceAssignments {
    id
    url
    comment
  }
  impactSolutions {
    ...CompleteImpactSolution
  }
  sdgs {
    id
    label
    sublabel
  }
  sdgTargets {
    id
    label
    sdgId
  }
  irisCategories {
    id
    label
  }
  geographies {
    id
    label
  }
  metricAssignments {
    id
    metricNameOverride
    comment
    reportingPeriodType
    isFrozen
    customTargetCalculationType
    customTargetWeight
    unitName
    metric {
      ...CompleteMetric
    }
    completionStatus {
      ...CompleteCompletionStatus
    }
    metricValues {
      ...CompleteMetricValue
    }
  }
  hasFrozenOutcome
}
    ${CompleteConceptFragmentDoc}
${CompleteImpactSolutionFragmentDoc}
${CompleteMetricFragmentDoc}
${CompleteCompletionStatusFragmentDoc}
${CompleteMetricValueFragmentDoc}`;
export const CompleteTargetProgressFragmentDoc = gql`
    fragment CompleteTargetProgress on ImpactGoalProgressType {
  id
  hasTarget
  startDate
  endDate
  completionRate
  message
}
    `;
export const CompleteImpactGoalFragmentDoc = gql`
    fragment CompleteImpactGoal on ImpactGoalType {
  id
  ventureId
  isEditable
  activityUrls
  ghgStartingYear
  impacts {
    ...CompleteImpact
    metricAssignments {
      id
      ghgSavingPotentialId
      metricNameOverride
      comment
      reportingPeriodType
      isFrozen
      customTargetWeight
      unitName
      metric {
        ...CompleteMetric
      }
      completionStatus {
        ...CompleteCompletionStatus
      }
      metricValues {
        ...CompleteMetricValue
      }
    }
  }
  targetProgress {
    ...CompleteTargetProgress
  }
}
    ${CompleteImpactFragmentDoc}
${CompleteMetricFragmentDoc}
${CompleteCompletionStatusFragmentDoc}
${CompleteMetricValueFragmentDoc}
${CompleteTargetProgressFragmentDoc}`;
export const CompleteMetricAggregationFragmentDoc = gql`
    fragment CompleteMetricAggregation on MetricAggregationType {
  id
  comment
  metricAggregationValues {
    period
    actual
    target
  }
  calculationType
  metric {
    ...CompleteMetric
  }
  metricAssignments {
    id
    metricNameOverride
    comment
    isFrozen
    assigneeId
    goalTarget
    goalType
    reportingPeriodType
    metric {
      ...CompleteMetric
    }
    metricValues {
      ...CompleteMetricValue
    }
  }
  groupId
  groupType
  funds {
    id
    name
  }
  sfdrStrategies {
    id
    kind
    concept {
      id
      label
    }
  }
}
    ${CompleteMetricFragmentDoc}
${CompleteMetricValueFragmentDoc}`;
export const CompleteQuestionnaireComparisonFragmentDoc = gql`
    fragment CompleteQuestionnaireComparison on QuestionnaireComparisonType {
  firstQuestionnaireId
  secondQuestionnaireId
  commentE
  commentS
  commentG
}
    `;
export const CompleteSolutionSourceFragmentDoc = gql`
    fragment CompleteSolutionSource on SolutionSourceType {
  id
  url
  comment
  impactSolutionId
}
    `;
export const IroLinkFragmentDoc = gql`
    fragment IroLink on IroSectionLinkType {
  id
  iroId
  sectionId
  iro {
    id
    name
    type
    description
    accountId
    activityId
    likelihood
    severity
    scale
    scope
    irremediability
    status
  }
}
    `;
export const BasicInfoPortfolioFragmentDoc = gql`
    fragment BasicInfoPortfolio on AccountType {
  id
  type
  name
  logo
  modules
  countries
  nace
  website
  nameOfFinancialMarketParticipant
  legalEntityIdentifier
  sustainabilityRiskIntegration
  remunerationPolicies
  subsidiaries
  nameOfFinancialMarketParticipant
  entityLevelPaiConsideration
  csrdLikelihoodThreshold
  csrdMagnitudeThreshold
  csrdThresholdReason
  hiddenKpis
  csrdNImpactLikelihoodThreshold
  csrdNImpactSeverityThreshold
  csrdNImpactThresholdReason
  csrdPImpactLikelihoodThreshold
  csrdPImpactScopeThreshold
  csrdPImpactThresholdReason
  reportingPeriodType
  defaultReferencePeriods
  requireImpactSubmission
}
    `;
export const CompletePortfolioVentureLinkFragmentDoc = gql`
    fragment CompletePortfolioVentureLink on PortfolioVentureLinkType {
  id
  portfolioId
  ventureId
  modules
  groupNames
  groupIds
  comment
  venture {
    id
    name
    logo
    website
  }
  portfolio {
    id
    name
    reportingPeriodType
  }
}
    `;
export const CompletePortfolioFragmentDoc = gql`
    fragment CompletePortfolio on AccountType {
  ...BasicInfoPortfolio
  ventureLinks {
    ...CompletePortfolioVentureLink
  }
  funds {
    id
    name
    volume
    fundStrategy
    isReportingPais
    isConsideringPais
    investmentPeriod {
      id
      startDate
      endDate
    }
  }
}
    ${BasicInfoPortfolioFragmentDoc}
${CompletePortfolioVentureLinkFragmentDoc}`;
export const CompletePortfolioGroupFragmentDoc = gql`
    fragment CompletePortfolioGroup on PortfolioGroupType {
  id
  label
}
    `;
export const BasicFundFragmentDoc = gql`
    fragment BasicFund on FundType {
  id
  name
  volume
  ventureIds
  fundStrategy
  portfolio {
    ...BasicInfoPortfolio
  }
}
    ${BasicInfoPortfolioFragmentDoc}`;
export const CompleteReferencePeriodFragmentDoc = gql`
    fragment CompleteReferencePeriod on ReferencePeriodType {
  id
  label
  startDate
  endDate
  userDefined
  createdBy
}
    `;
export const CompleteSfdrStrategyFragmentDoc = gql`
    fragment CompleteSfdrStrategy on SfdrStrategyType {
  id
  kind
  benchmarkDescription
  actionsTaken
  metricIds
  metrics {
    id
    name
  }
  concept {
    id
    label
    ixId
  }
  euTaxonomyConcept {
    id
    label
    ixId
  }
  strategyDescription
  isEnvironmentalGoal
  isCo2EmissionGoal
  doCheckEuTaxonomyAlignment
  ventureIds
  esStrategy
  esCharacteristicsDescription
  esgIntegrationDescription
  exclusionCriteriaDescription
  bestInClassDescription
  normBasedScreeningDescription
  sustainabilityLabelDescription
  isIndexDesignated
  sustainablyAlignedIndexExplanation
  investmentAlignedIndexExplanation
  broadMarketIndexComparison
  indexCalculationMethodology
  sustainabilityIndicatorsMonitoringStrategy
  entityResponsibleForMonitoringIndicators
  isConsideringSourcesAndEstimates
  dataSourcesConsidered
  shareOfDataSecondHand
  dueDiligenceProcessDescription
  engagementPolicyWithSpecificInvestmentStrategy
}
    `;
export const CompleteReportAnswerFragmentDoc = gql`
    fragment CompleteReportAnswer on ReportAnswerType {
  id
  fundId
  reportType
  referencePeriodId
  sfdrReportingPeriod {
    ...CompleteReferencePeriod
  }
  reportData
}
    ${CompleteReferencePeriodFragmentDoc}`;
export const CompleteFundFragmentDoc = gql`
    fragment CompleteFund on FundType {
  id
  name
  legalEntityIdentifier
  volume
  fundStrategy
  isReportingPais
  isReportingKfw
  minimumReportingLevelVentureIds
  recommendedReportingLevelVentureIds
  fullReportingLevelVentureIds
  isConsideringPais
  notConsideringPaisReason
  ventureIds
  investmentStrategy
  bindingElementsOfInvestmentStrategy
  minimumRateToReduceScope
  companyGovernancePolicy
  assetAllocationTargets {
    percentEnvironmental
    percentEnvironmentalTaxonomyAligned
    percentEnvironmentalNotTaxonomyAligned
    percentSocial
    percentSustainable
    percentTaxonomyAlignedFossil
    percentTaxonomyAlignedNuclear
    percentTaxonomyAlignedEnabling
    percentTaxonomyAlignedTransitional
  }
  fundSpecificInfo
  socialMetrics {
    id
    name
  }
  environmentalMetrics {
    id
    name
  }
  socialMetricIds
  environmentalMetricIds
  generalMetricIds
  generalMetrics {
    id
    name
  }
  paiSelectionMethodologies
  paiPolicyAdministration
  considerationOfPaisOnSustainabilityEngagementPolicies
  considerationOfPaisOnSustainabilityInternationalStandards
  isConsideringSustainabilityRisk
  sustainabilityRiskIntegrationDescription
  likelyImpactsFromSustainabilityRisk
  reasonNotConsideringSustainabilityRisk
  entitySustainabilityExtraInfo
  paiAggregationGroup
  esCharacteristicsPromoted
  investmentPeriod {
    ...CompleteReferencePeriod
  }
  sfdrReportingPeriod {
    ...CompleteReferencePeriod
  }
  sustainableObjectives {
    ...CompleteSfdrStrategy
  }
  esCharacteristics {
    ...CompleteSfdrStrategy
  }
  periodicAnswers {
    ...CompleteReportAnswer
  }
  paiAnswers {
    ...CompleteReportAnswer
  }
  precontractualAnswers {
    ...CompleteReportAnswer
  }
  fundWebsiteDisclosureAnswers {
    ...CompleteReportAnswer
  }
  entityWebsiteDisclosureAnswers {
    ...CompleteReportAnswer
  }
  paiReport {
    considerationOfPaisOnSustainabilityDescription
    considerationOfPaisOnSustainabilityEngagementPolicies
    considerationOfPaisOnSustainabilityInternationalStandards
    considerationOfPaisOnSustainabilityHistoricalComparison
    howDidProductConsiderPais
    principalAdverseImpactsExplanationsAndActions
    summaryOfPais
  }
  precontractualReport {
    sustainableObjectiveTree
    wereObjectivesMet
    esCharacteristicsDescription
    sustainabilityIndicatorsPerformanceDescription
    sustainableInvestmentsMadeByFund
    howDidInvestmentsNotCauseHarm
    accountOnPais
    alignmentWithOecdGuidelines
    investmentStrategy
    bindingElementsOfInvestmentStrategy
    companyGovernancePolicy
    howDidProductConsiderPais
    sustainabilityRelatedInvestmentAssetAllocation
    sustainableInvestmentsWithEnvironmentalObjectiveEuTaxonomyAlignment
    fossilOrNuclear
    shareOfInvestmentsInTransitionalAndEnablingActivities
    shareOfSustainableInvestmentsWithEnvironmentalObjectiveNonEuTaxonomyAligned
    shareOfSociallySustainableInvestments
    purposeOfOtherOrNotSustainableInvestmentsIncludingSafeguards
    productPerformanceComparison
    sustainablyAlignedIndexExplanation
    investmentAlignedIndexExplanation
    broadMarketIndexComparison
    indexCalculationMethodology
    fundSpecificInfo
    whyDidProductConsiderPais
    useOfDerivatives
  }
}
    ${CompleteReferencePeriodFragmentDoc}
${CompleteSfdrStrategyFragmentDoc}
${CompleteReportAnswerFragmentDoc}`;
export const BaseQuestionFragmentDoc = gql`
    fragment BaseQuestion on QuestionType {
  id
  ixId
  component
  label
  sublabel
  tooltip
  scoringRules
  isMultiple
  isMandatory
  createdAt
  updatedAt
}
    `;
export const CompleteQuestionFragmentDoc = gql`
    fragment CompleteQuestion on QuestionType {
  id
  ixId
  component
  tooltip
  tooltipI18n
  label
  labelI18n
  sublabel
  sublabelI18n
  isMultiple
  isMandatory
  scoringRules
  templateEngineContext
}
    `;
export const PromptTemplateFragmentDoc = gql`
    fragment PromptTemplate on PromptTemplateType {
  id
  questionId
  ixId
  purpose
  latestVersionId
  isActive
  createdBy
}
    `;
export const PromptTemplateVersionFragmentDoc = gql`
    fragment PromptTemplateVersion on PromptTemplateVersionType {
  id
  promptTemplateId
  version
  systemTemplate
  userTemplate
  inputSchema
  outputSchema
  model
  params
  notes
  createdBy
  createdAt
  appendCompanyWebsiteScrape
}
    `;
export const QuestionFragmentDoc = gql`
    fragment question on QuestionSectionLinkType {
  sort
  label
  sublabel
  tooltip
  question {
    id
    sort
    label
    sublabel
    tooltip
    component
    ixId
    targetEntity
    isMandatory
    options {
      id
      ixId
      label
    }
    isActiveByDefault
    isMultiple
    createdAt
    updatedAt
    templateTexts {
      text
    }
    promptTemplate {
      id
      isActive
    }
    value(fundId: $fundId, referencePeriodId: $referencePeriodId, sectionId: $id)
    copyableText(
      fundId: $fundId
      referencePeriodId: $referencePeriodId
      sectionId: $id
    )
    copyableOptions(
      fundId: $fundId
      referencePeriodId: $referencePeriodId
      sectionId: $id
    )
    isCopyable
  }
}
    `;
export const SectionFragmentDoc = gql`
    fragment section on SectionType {
  id
  ixId
  label
  labelI18n
  sublabel
  tooltip
  sort
  children {
    ... on SectionType {
      id
      ixId
      label
      labelI18n
      sublabel
      tooltip
      sort
      children {
        ... on QuestionSectionLinkType {
          ...question
        }
      }
    }
    ... on QuestionSectionLinkType {
      ...question
    }
  }
}
    ${QuestionFragmentDoc}`;
export const OptionFieldsFragmentDoc = gql`
    fragment optionFields on OptionType {
  id
  externalId
  label
  sublabel
  tooltip
  ixId
}
    `;
export const AddMetricAndAssignmentBatchDocument = gql`
    mutation addMetricAndAssignmentBatch($metric: MetricInput!, $assigneeIds: [UUID!]!) {
  addMetricAndAssignmentBatch(metric: $metric, assigneeIds: $assigneeIds) {
    id
    metricId
  }
}
    `;

/**
 * __useAddMetricAndAssignmentBatchMutation__
 *
 * To run a mutation, you first call `useAddMetricAndAssignmentBatchMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddMetricAndAssignmentBatchMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddMetricAndAssignmentBatchMutation({
 *   variables: {
 *     metric: // value for 'metric'
 *     assigneeIds: // value for 'assigneeIds'
 *   },
 * });
 */
export function useAddMetricAndAssignmentBatchMutation(options: VueApolloComposable.UseMutationOptions<AddMetricAndAssignmentBatchMutation, AddMetricAndAssignmentBatchMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddMetricAndAssignmentBatchMutation, AddMetricAndAssignmentBatchMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddMetricAndAssignmentBatchMutation, AddMetricAndAssignmentBatchMutationVariables>(AddMetricAndAssignmentBatchDocument, options);
}
export type AddMetricAndAssignmentBatchMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddMetricAndAssignmentBatchMutation, AddMetricAndAssignmentBatchMutationVariables>;
export const AddMetricAssignmentBatchDocument = gql`
    mutation addMetricAssignmentBatch($inputs: [MetricAssignmentInput!]!) {
  addMetricAssignmentBatch(inputs: $inputs) {
    id
    metric {
      id
    }
  }
}
    `;

/**
 * __useAddMetricAssignmentBatchMutation__
 *
 * To run a mutation, you first call `useAddMetricAssignmentBatchMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddMetricAssignmentBatchMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddMetricAssignmentBatchMutation({
 *   variables: {
 *     inputs: // value for 'inputs'
 *   },
 * });
 */
export function useAddMetricAssignmentBatchMutation(options: VueApolloComposable.UseMutationOptions<AddMetricAssignmentBatchMutation, AddMetricAssignmentBatchMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddMetricAssignmentBatchMutation, AddMetricAssignmentBatchMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddMetricAssignmentBatchMutation, AddMetricAssignmentBatchMutationVariables>(AddMetricAssignmentBatchDocument, options);
}
export type AddMetricAssignmentBatchMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddMetricAssignmentBatchMutation, AddMetricAssignmentBatchMutationVariables>;
export const AddMetricMetricLinkDocument = gql`
    mutation AddMetricMetricLink($parentId: Int!, $childrenId: [Int!]!) {
  addMetricMetricLink(parentId: $parentId, childrenId: $childrenId)
}
    `;

/**
 * __useAddMetricMetricLinkMutation__
 *
 * To run a mutation, you first call `useAddMetricMetricLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddMetricMetricLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddMetricMetricLinkMutation({
 *   variables: {
 *     parentId: // value for 'parentId'
 *     childrenId: // value for 'childrenId'
 *   },
 * });
 */
export function useAddMetricMetricLinkMutation(options: VueApolloComposable.UseMutationOptions<AddMetricMetricLinkMutation, AddMetricMetricLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddMetricMetricLinkMutation, AddMetricMetricLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddMetricMetricLinkMutation, AddMetricMetricLinkMutationVariables>(AddMetricMetricLinkDocument, options);
}
export type AddMetricMetricLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddMetricMetricLinkMutation, AddMetricMetricLinkMutationVariables>;
export const DeleteMetricAggregationDocument = gql`
    mutation DeleteMetricAggregation($metricAggregationId: Int!) {
  __typename
  deleteMetricAggregation(metricAggregationId: $metricAggregationId)
}
    `;

/**
 * __useDeleteMetricAggregationMutation__
 *
 * To run a mutation, you first call `useDeleteMetricAggregationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMetricAggregationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteMetricAggregationMutation({
 *   variables: {
 *     metricAggregationId: // value for 'metricAggregationId'
 *   },
 * });
 */
export function useDeleteMetricAggregationMutation(options: VueApolloComposable.UseMutationOptions<DeleteMetricAggregationMutation, DeleteMetricAggregationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteMetricAggregationMutation, DeleteMetricAggregationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteMetricAggregationMutation, DeleteMetricAggregationMutationVariables>(DeleteMetricAggregationDocument, options);
}
export type DeleteMetricAggregationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteMetricAggregationMutation, DeleteMetricAggregationMutationVariables>;
export const DeleteMetricAssignmentDocument = gql`
    mutation DeleteMetricAssignment($metricAssignmentId: Int!) {
  __typename
  deleteMetricAssignment(metricAssignmentId: $metricAssignmentId)
}
    `;

/**
 * __useDeleteMetricAssignmentMutation__
 *
 * To run a mutation, you first call `useDeleteMetricAssignmentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMetricAssignmentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteMetricAssignmentMutation({
 *   variables: {
 *     metricAssignmentId: // value for 'metricAssignmentId'
 *   },
 * });
 */
export function useDeleteMetricAssignmentMutation(options: VueApolloComposable.UseMutationOptions<DeleteMetricAssignmentMutation, DeleteMetricAssignmentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteMetricAssignmentMutation, DeleteMetricAssignmentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteMetricAssignmentMutation, DeleteMetricAssignmentMutationVariables>(DeleteMetricAssignmentDocument, options);
}
export type DeleteMetricAssignmentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteMetricAssignmentMutation, DeleteMetricAssignmentMutationVariables>;
export const AddIroDocument = gql`
    mutation AddIro($iro: IROInput!) {
  addIro(iro: $iro) {
    id
    name
    type
    description
    accountId
    activityId
    likelihood
    severity
    scale
    scope
    irremediability
  }
}
    `;

/**
 * __useAddIroMutation__
 *
 * To run a mutation, you first call `useAddIroMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddIroMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddIroMutation({
 *   variables: {
 *     iro: // value for 'iro'
 *   },
 * });
 */
export function useAddIroMutation(options: VueApolloComposable.UseMutationOptions<AddIroMutation, AddIroMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddIroMutation, AddIroMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddIroMutation, AddIroMutationVariables>(AddIroDocument, options);
}
export type AddIroMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddIroMutation, AddIroMutationVariables>;
export const DeleteIroDocument = gql`
    mutation DeleteIRO($id: UUID!) {
  deleteIro(id: $id)
}
    `;

/**
 * __useDeleteIroMutation__
 *
 * To run a mutation, you first call `useDeleteIroMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIroMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteIroMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIroMutation(options: VueApolloComposable.UseMutationOptions<DeleteIroMutation, DeleteIroMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteIroMutation, DeleteIroMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteIroMutation, DeleteIroMutationVariables>(DeleteIroDocument, options);
}
export type DeleteIroMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteIroMutation, DeleteIroMutationVariables>;
export const UpdateIroDocument = gql`
    mutation UpdateIRO($iro: IROInput!) {
  updateIro(iroInput: $iro) {
    id
    name
    type
    description
    accountId
    activityId
    levelOfImpact
    likelihood
    likelihoodReason
    magnitude
    magnitudeReason
    finalSeverity
    severity
    severityReason
    scale
    scope
    irremediability
    overrideStatus
    overrideReason
    finalAssessmentReason
    status
  }
}
    `;

/**
 * __useUpdateIroMutation__
 *
 * To run a mutation, you first call `useUpdateIroMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIroMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateIroMutation({
 *   variables: {
 *     iro: // value for 'iro'
 *   },
 * });
 */
export function useUpdateIroMutation(options: VueApolloComposable.UseMutationOptions<UpdateIroMutation, UpdateIroMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateIroMutation, UpdateIroMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateIroMutation, UpdateIroMutationVariables>(UpdateIroDocument, options);
}
export type UpdateIroMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateIroMutation, UpdateIroMutationVariables>;
export const OneTimeNotificationDocument = gql`
    mutation oneTimeNotification($input: NotificationInput!) {
  oneTimeNotification(input: $input)
}
    `;

/**
 * __useOneTimeNotificationMutation__
 *
 * To run a mutation, you first call `useOneTimeNotificationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useOneTimeNotificationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useOneTimeNotificationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useOneTimeNotificationMutation(options: VueApolloComposable.UseMutationOptions<OneTimeNotificationMutation, OneTimeNotificationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<OneTimeNotificationMutation, OneTimeNotificationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<OneTimeNotificationMutation, OneTimeNotificationMutationVariables>(OneTimeNotificationDocument, options);
}
export type OneTimeNotificationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<OneTimeNotificationMutation, OneTimeNotificationMutationVariables>;
export const UpdateKfwReportingDocument = gql`
    mutation updateKfwReporting($input: FundInput!) {
  updateFund(input: $input) {
    id
    minimumReportingLevelVentureIds
    recommendedReportingLevelVentureIds
    fullReportingLevelVentureIds
    syncState {
      assignmentsToAdd {
        metricId
        fundId
        conceptId
        why
        metric {
          name
        }
      }
      fundAssignmentsToAdd {
        metricId
        fundId
        conceptId
        why
        metric {
          name
        }
      }
      fundAggregationsToAdd {
        metricId
        groupType
        groupId
        why
        metric {
          name
        }
      }
      fundAggregationsToDelete {
        metricId
        groupType
        groupId
        why
        metric {
          name
        }
      }
    }
    isInSync
  }
}
    `;

/**
 * __useUpdateKfwReportingMutation__
 *
 * To run a mutation, you first call `useUpdateKfwReportingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKfwReportingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateKfwReportingMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKfwReportingMutation(options: VueApolloComposable.UseMutationOptions<UpdateKfwReportingMutation, UpdateKfwReportingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateKfwReportingMutation, UpdateKfwReportingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateKfwReportingMutation, UpdateKfwReportingMutationVariables>(UpdateKfwReportingDocument, options);
}
export type UpdateKfwReportingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateKfwReportingMutation, UpdateKfwReportingMutationVariables>;
export const UpdateMetricAggregationDocument = gql`
    mutation UpdateMetricAggregation($input: MetricAggregationInput!) {
  updateMetricAggregation(input: $input) {
    ...CompleteMetricAggregation
  }
}
    ${CompleteMetricAggregationFragmentDoc}`;

/**
 * __useUpdateMetricAggregationMutation__
 *
 * To run a mutation, you first call `useUpdateMetricAggregationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMetricAggregationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateMetricAggregationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMetricAggregationMutation(options: VueApolloComposable.UseMutationOptions<UpdateMetricAggregationMutation, UpdateMetricAggregationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateMetricAggregationMutation, UpdateMetricAggregationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateMetricAggregationMutation, UpdateMetricAggregationMutationVariables>(UpdateMetricAggregationDocument, options);
}
export type UpdateMetricAggregationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateMetricAggregationMutation, UpdateMetricAggregationMutationVariables>;
export const UpdateMetricAssignmentDocument = gql`
    mutation updateMetricAssignment($input: MetricAssignmentInput!) {
  updateMetricAssignment(input: $input) {
    ...CompleteMetricAssignment
  }
}
    ${CompleteMetricAssignmentFragmentDoc}`;

/**
 * __useUpdateMetricAssignmentMutation__
 *
 * To run a mutation, you first call `useUpdateMetricAssignmentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMetricAssignmentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateMetricAssignmentMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMetricAssignmentMutation(options: VueApolloComposable.UseMutationOptions<UpdateMetricAssignmentMutation, UpdateMetricAssignmentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateMetricAssignmentMutation, UpdateMetricAssignmentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateMetricAssignmentMutation, UpdateMetricAssignmentMutationVariables>(UpdateMetricAssignmentDocument, options);
}
export type UpdateMetricAssignmentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateMetricAssignmentMutation, UpdateMetricAssignmentMutationVariables>;
export const UpsertMetricDocument = gql`
    mutation upsertMetric($input: MetricInput!) {
  upsertMetric(input: $input) {
    ...CompleteMetric
  }
}
    ${CompleteMetricFragmentDoc}`;

/**
 * __useUpsertMetricMutation__
 *
 * To run a mutation, you first call `useUpsertMetricMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMetricMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertMetricMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpsertMetricMutation(options: VueApolloComposable.UseMutationOptions<UpsertMetricMutation, UpsertMetricMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertMetricMutation, UpsertMetricMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertMetricMutation, UpsertMetricMutationVariables>(UpsertMetricDocument, options);
}
export type UpsertMetricMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertMetricMutation, UpsertMetricMutationVariables>;
export const UpsertMetricValuesDocument = gql`
    mutation UpsertMetricValues($inputs: [MetricValueInput!]!) {
  upsertMetricValues(inputs: $inputs) {
    id
    period
    actual
    target
    text
    options
    comment
    metricAssignmentId
    createdBy
    targetLocked
    actualLocked
    skipped
  }
}
    `;

/**
 * __useUpsertMetricValuesMutation__
 *
 * To run a mutation, you first call `useUpsertMetricValuesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMetricValuesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertMetricValuesMutation({
 *   variables: {
 *     inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpsertMetricValuesMutation(options: VueApolloComposable.UseMutationOptions<UpsertMetricValuesMutation, UpsertMetricValuesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertMetricValuesMutation, UpsertMetricValuesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertMetricValuesMutation, UpsertMetricValuesMutationVariables>(UpsertMetricValuesDocument, options);
}
export type UpsertMetricValuesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertMetricValuesMutation, UpsertMetricValuesMutationVariables>;
export const UpsertReferencePeriodDocument = gql`
    mutation upsertReferencePeriod($input: ReferencePeriodInput!) {
  upsertReferencePeriod(input: $input) {
    ...CompleteReferencePeriod
  }
}
    ${CompleteReferencePeriodFragmentDoc}`;

/**
 * __useUpsertReferencePeriodMutation__
 *
 * To run a mutation, you first call `useUpsertReferencePeriodMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertReferencePeriodMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertReferencePeriodMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpsertReferencePeriodMutation(options: VueApolloComposable.UseMutationOptions<UpsertReferencePeriodMutation, UpsertReferencePeriodMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertReferencePeriodMutation, UpsertReferencePeriodMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertReferencePeriodMutation, UpsertReferencePeriodMutationVariables>(UpsertReferencePeriodDocument, options);
}
export type UpsertReferencePeriodMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertReferencePeriodMutation, UpsertReferencePeriodMutationVariables>;
export const AddAccountDocument = gql`
    mutation AddAccount($account: AccountInput!, $email: String!, $password: String!) {
  addAccount(account: $account, email: $email, password: $password) {
    id
  }
}
    `;

/**
 * __useAddAccountMutation__
 *
 * To run a mutation, you first call `useAddAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddAccountMutation({
 *   variables: {
 *     account: // value for 'account'
 *     email: // value for 'email'
 *     password: // value for 'password'
 *   },
 * });
 */
export function useAddAccountMutation(options: VueApolloComposable.UseMutationOptions<AddAccountMutation, AddAccountMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddAccountMutation, AddAccountMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddAccountMutation, AddAccountMutationVariables>(AddAccountDocument, options);
}
export type AddAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddAccountMutation, AddAccountMutationVariables>;
export const AddFundDocument = gql`
    mutation addFund($input: FundInput) {
  addFund(input: $input) {
    ...CompletePortfolio
  }
}
    ${CompletePortfolioFragmentDoc}`;

/**
 * __useAddFundMutation__
 *
 * To run a mutation, you first call `useAddFundMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddFundMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddFundMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddFundMutation(options: VueApolloComposable.UseMutationOptions<AddFundMutation, AddFundMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddFundMutation, AddFundMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddFundMutation, AddFundMutationVariables>(AddFundDocument, options);
}
export type AddFundMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddFundMutation, AddFundMutationVariables>;
export const AddPortfolioVentureLinkDocument = gql`
    mutation addPortfolioVentureLink($portfolioId: UUID!, $ventureIds: [UUID!]!) {
  addPortfolioVentureLink(portfolioId: $portfolioId, ventureIds: $ventureIds) {
    ventureId
  }
}
    `;

/**
 * __useAddPortfolioVentureLinkMutation__
 *
 * To run a mutation, you first call `useAddPortfolioVentureLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddPortfolioVentureLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddPortfolioVentureLinkMutation({
 *   variables: {
 *     portfolioId: // value for 'portfolioId'
 *     ventureIds: // value for 'ventureIds'
 *   },
 * });
 */
export function useAddPortfolioVentureLinkMutation(options: VueApolloComposable.UseMutationOptions<AddPortfolioVentureLinkMutation, AddPortfolioVentureLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddPortfolioVentureLinkMutation, AddPortfolioVentureLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddPortfolioVentureLinkMutation, AddPortfolioVentureLinkMutationVariables>(AddPortfolioVentureLinkDocument, options);
}
export type AddPortfolioVentureLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddPortfolioVentureLinkMutation, AddPortfolioVentureLinkMutationVariables>;
export const AddReportAnswerDocument = gql`
    mutation AddReportAnswer($input: ReportAnswerInput!) {
  addReportAnswer(input: $input) {
    ...CompleteReportAnswer
  }
}
    ${CompleteReportAnswerFragmentDoc}`;

/**
 * __useAddReportAnswerMutation__
 *
 * To run a mutation, you first call `useAddReportAnswerMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddReportAnswerMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddReportAnswerMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddReportAnswerMutation(options: VueApolloComposable.UseMutationOptions<AddReportAnswerMutation, AddReportAnswerMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddReportAnswerMutation, AddReportAnswerMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddReportAnswerMutation, AddReportAnswerMutationVariables>(AddReportAnswerDocument, options);
}
export type AddReportAnswerMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddReportAnswerMutation, AddReportAnswerMutationVariables>;
export const AddSfdrStrategyDocument = gql`
    mutation addSfdrStrategy($input: SfdrStrategyInput!) {
  addSfdrStrategy(input: $input) {
    ...CompleteFund
  }
}
    ${CompleteFundFragmentDoc}`;

/**
 * __useAddSfdrStrategyMutation__
 *
 * To run a mutation, you first call `useAddSfdrStrategyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddSfdrStrategyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddSfdrStrategyMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddSfdrStrategyMutation(options: VueApolloComposable.UseMutationOptions<AddSfdrStrategyMutation, AddSfdrStrategyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddSfdrStrategyMutation, AddSfdrStrategyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddSfdrStrategyMutation, AddSfdrStrategyMutationVariables>(AddSfdrStrategyDocument, options);
}
export type AddSfdrStrategyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddSfdrStrategyMutation, AddSfdrStrategyMutationVariables>;
export const AssignVenturesToGroupDocument = gql`
    mutation assignVenturesToGroup($groupId: Int!, $ventureIds: [String!]!, $groupAssignments: [GroupAssignmentType!]!, $deleteOldVentureIds: Boolean) {
  assignVenturesToGroup(
    groupId: $groupId
    ventureIds: $ventureIds
    groupAssignments: $groupAssignments
    deleteOldVentureIds: $deleteOldVentureIds
  ) {
    ...CompletePortfolioVentureLink
  }
}
    ${CompletePortfolioVentureLinkFragmentDoc}`;

/**
 * __useAssignVenturesToGroupMutation__
 *
 * To run a mutation, you first call `useAssignVenturesToGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAssignVenturesToGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAssignVenturesToGroupMutation({
 *   variables: {
 *     groupId: // value for 'groupId'
 *     ventureIds: // value for 'ventureIds'
 *     groupAssignments: // value for 'groupAssignments'
 *     deleteOldVentureIds: // value for 'deleteOldVentureIds'
 *   },
 * });
 */
export function useAssignVenturesToGroupMutation(options: VueApolloComposable.UseMutationOptions<AssignVenturesToGroupMutation, AssignVenturesToGroupMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AssignVenturesToGroupMutation, AssignVenturesToGroupMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AssignVenturesToGroupMutation, AssignVenturesToGroupMutationVariables>(AssignVenturesToGroupDocument, options);
}
export type AssignVenturesToGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AssignVenturesToGroupMutation, AssignVenturesToGroupMutationVariables>;
export const ChangeHiddenKpiSettingsDocument = gql`
    mutation changeHiddenKpiSettings($portfolioId: UUID!, $hiddenKpis: [Int!]!) {
  changeHiddenKpiSettings(portfolioId: $portfolioId, hiddenKpis: $hiddenKpis) {
    id
    hiddenKpis
  }
}
    `;

/**
 * __useChangeHiddenKpiSettingsMutation__
 *
 * To run a mutation, you first call `useChangeHiddenKpiSettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useChangeHiddenKpiSettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useChangeHiddenKpiSettingsMutation({
 *   variables: {
 *     portfolioId: // value for 'portfolioId'
 *     hiddenKpis: // value for 'hiddenKpis'
 *   },
 * });
 */
export function useChangeHiddenKpiSettingsMutation(options: VueApolloComposable.UseMutationOptions<ChangeHiddenKpiSettingsMutation, ChangeHiddenKpiSettingsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ChangeHiddenKpiSettingsMutation, ChangeHiddenKpiSettingsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ChangeHiddenKpiSettingsMutation, ChangeHiddenKpiSettingsMutationVariables>(ChangeHiddenKpiSettingsDocument, options);
}
export type ChangeHiddenKpiSettingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ChangeHiddenKpiSettingsMutation, ChangeHiddenKpiSettingsMutationVariables>;
export const ChangeReportingPeriodTypeDocument = gql`
    mutation changeReportingPeriodType($portfolioId: UUID!, $reportingPeriodType: MetricReportingPeriodType!) {
  changeReportingPeriodType(
    portfolioId: $portfolioId
    reportingPeriodType: $reportingPeriodType
  ) {
    id
    reportingPeriodType
  }
}
    `;

/**
 * __useChangeReportingPeriodTypeMutation__
 *
 * To run a mutation, you first call `useChangeReportingPeriodTypeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useChangeReportingPeriodTypeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useChangeReportingPeriodTypeMutation({
 *   variables: {
 *     portfolioId: // value for 'portfolioId'
 *     reportingPeriodType: // value for 'reportingPeriodType'
 *   },
 * });
 */
export function useChangeReportingPeriodTypeMutation(options: VueApolloComposable.UseMutationOptions<ChangeReportingPeriodTypeMutation, ChangeReportingPeriodTypeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ChangeReportingPeriodTypeMutation, ChangeReportingPeriodTypeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ChangeReportingPeriodTypeMutation, ChangeReportingPeriodTypeMutationVariables>(ChangeReportingPeriodTypeDocument, options);
}
export type ChangeReportingPeriodTypeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ChangeReportingPeriodTypeMutation, ChangeReportingPeriodTypeMutationVariables>;
export const DeleteAccountDocument = gql`
    mutation deleteAccount($id: UUID!, $dryRun: Boolean!) {
  deleteAccount(id: $id, dryRun: $dryRun)
}
    `;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAccountMutation({
 *   variables: {
 *     id: // value for 'id'
 *     dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useDeleteAccountMutation(options: VueApolloComposable.UseMutationOptions<DeleteAccountMutation, DeleteAccountMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteAccountMutation, DeleteAccountMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument, options);
}
export type DeleteAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteAccountMutation, DeleteAccountMutationVariables>;
export const DeleteGroupDocument = gql`
    mutation deleteGroup($groupId: Int!) {
  deleteGroup(groupId: $groupId) {
    ...CompletePortfolioGroup
  }
}
    ${CompletePortfolioGroupFragmentDoc}`;

/**
 * __useDeleteGroupMutation__
 *
 * To run a mutation, you first call `useDeleteGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteGroupMutation({
 *   variables: {
 *     groupId: // value for 'groupId'
 *   },
 * });
 */
export function useDeleteGroupMutation(options: VueApolloComposable.UseMutationOptions<DeleteGroupMutation, DeleteGroupMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteGroupMutation, DeleteGroupMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteGroupMutation, DeleteGroupMutationVariables>(DeleteGroupDocument, options);
}
export type DeleteGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteGroupMutation, DeleteGroupMutationVariables>;
export const DeletePortfolioVentureLinkDocument = gql`
    mutation deletePortfolioVentureLink($portfolioId: UUID!, $ventureId: UUID!) {
  deletePortfolioVentureLink(portfolioId: $portfolioId, ventureId: $ventureId)
}
    `;

/**
 * __useDeletePortfolioVentureLinkMutation__
 *
 * To run a mutation, you first call `useDeletePortfolioVentureLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeletePortfolioVentureLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeletePortfolioVentureLinkMutation({
 *   variables: {
 *     portfolioId: // value for 'portfolioId'
 *     ventureId: // value for 'ventureId'
 *   },
 * });
 */
export function useDeletePortfolioVentureLinkMutation(options: VueApolloComposable.UseMutationOptions<DeletePortfolioVentureLinkMutation, DeletePortfolioVentureLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeletePortfolioVentureLinkMutation, DeletePortfolioVentureLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeletePortfolioVentureLinkMutation, DeletePortfolioVentureLinkMutationVariables>(DeletePortfolioVentureLinkDocument, options);
}
export type DeletePortfolioVentureLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeletePortfolioVentureLinkMutation, DeletePortfolioVentureLinkMutationVariables>;
export const DeleteSfdrStrategyDocument = gql`
    mutation deleteSfdrStrategy($id: Int!) {
  deleteSfdrStrategy(id: $id) {
    ...CompleteFund
  }
}
    ${CompleteFundFragmentDoc}`;

/**
 * __useDeleteSfdrStrategyMutation__
 *
 * To run a mutation, you first call `useDeleteSfdrStrategyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSfdrStrategyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteSfdrStrategyMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSfdrStrategyMutation(options: VueApolloComposable.UseMutationOptions<DeleteSfdrStrategyMutation, DeleteSfdrStrategyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteSfdrStrategyMutation, DeleteSfdrStrategyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteSfdrStrategyMutation, DeleteSfdrStrategyMutationVariables>(DeleteSfdrStrategyDocument, options);
}
export type DeleteSfdrStrategyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteSfdrStrategyMutation, DeleteSfdrStrategyMutationVariables>;
export const GeneratePortfolioTeamMemberSignupLinksCsvDocument = gql`
    mutation generatePortfolioTeamMemberSignupLinksCsv {
  generatePortfolioTeamMemberSignupLinksCsv
}
    `;

/**
 * __useGeneratePortfolioTeamMemberSignupLinksCsvMutation__
 *
 * To run a mutation, you first call `useGeneratePortfolioTeamMemberSignupLinksCsvMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePortfolioTeamMemberSignupLinksCsvMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGeneratePortfolioTeamMemberSignupLinksCsvMutation();
 */
export function useGeneratePortfolioTeamMemberSignupLinksCsvMutation(options: VueApolloComposable.UseMutationOptions<GeneratePortfolioTeamMemberSignupLinksCsvMutation, GeneratePortfolioTeamMemberSignupLinksCsvMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<GeneratePortfolioTeamMemberSignupLinksCsvMutation, GeneratePortfolioTeamMemberSignupLinksCsvMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<GeneratePortfolioTeamMemberSignupLinksCsvMutation, GeneratePortfolioTeamMemberSignupLinksCsvMutationVariables>(GeneratePortfolioTeamMemberSignupLinksCsvDocument, options);
}
export type GeneratePortfolioTeamMemberSignupLinksCsvMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<GeneratePortfolioTeamMemberSignupLinksCsvMutation, GeneratePortfolioTeamMemberSignupLinksCsvMutationVariables>;
export const RegenerateModuleTokensDocument = gql`
    mutation regenerateModuleTokens($id: UUID!) {
  regenerateModuleTokens(id: $id) {
    id
    esgToken
    metricsToken
    impactGoalToken
  }
}
    `;

/**
 * __useRegenerateModuleTokensMutation__
 *
 * To run a mutation, you first call `useRegenerateModuleTokensMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateModuleTokensMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRegenerateModuleTokensMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useRegenerateModuleTokensMutation(options: VueApolloComposable.UseMutationOptions<RegenerateModuleTokensMutation, RegenerateModuleTokensMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RegenerateModuleTokensMutation, RegenerateModuleTokensMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RegenerateModuleTokensMutation, RegenerateModuleTokensMutationVariables>(RegenerateModuleTokensDocument, options);
}
export type RegenerateModuleTokensMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RegenerateModuleTokensMutation, RegenerateModuleTokensMutationVariables>;
export const RegenerateTeamMemberTokenDocument = gql`
    mutation regenerateTeamMemberToken($id: UUID!) {
  regenerateTeamMemberToken(id: $id)
}
    `;

/**
 * __useRegenerateTeamMemberTokenMutation__
 *
 * To run a mutation, you first call `useRegenerateTeamMemberTokenMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateTeamMemberTokenMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRegenerateTeamMemberTokenMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useRegenerateTeamMemberTokenMutation(options: VueApolloComposable.UseMutationOptions<RegenerateTeamMemberTokenMutation, RegenerateTeamMemberTokenMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RegenerateTeamMemberTokenMutation, RegenerateTeamMemberTokenMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RegenerateTeamMemberTokenMutation, RegenerateTeamMemberTokenMutationVariables>(RegenerateTeamMemberTokenDocument, options);
}
export type RegenerateTeamMemberTokenMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RegenerateTeamMemberTokenMutation, RegenerateTeamMemberTokenMutationVariables>;
export const SetAccountUserRolesDocument = gql`
    mutation setAccountUserRoles($accountId: UUID!, $userId: UUID!, $roles: [AccountMembershipRole!]!) {
  setAccountUserRoles(accountId: $accountId, userId: $userId, roles: $roles) {
    role
    user {
      id
      email
    }
  }
}
    `;

/**
 * __useSetAccountUserRolesMutation__
 *
 * To run a mutation, you first call `useSetAccountUserRolesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetAccountUserRolesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetAccountUserRolesMutation({
 *   variables: {
 *     accountId: // value for 'accountId'
 *     userId: // value for 'userId'
 *     roles: // value for 'roles'
 *   },
 * });
 */
export function useSetAccountUserRolesMutation(options: VueApolloComposable.UseMutationOptions<SetAccountUserRolesMutation, SetAccountUserRolesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetAccountUserRolesMutation, SetAccountUserRolesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SetAccountUserRolesMutation, SetAccountUserRolesMutationVariables>(SetAccountUserRolesDocument, options);
}
export type SetAccountUserRolesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetAccountUserRolesMutation, SetAccountUserRolesMutationVariables>;
export const SubmitEuAlignmentQuestionnaireDocument = gql`
    mutation submitEuAlignmentQuestionnaire($questionnaireId: Int!, $isEditable: Boolean!) {
  submitEuAlignmentQuestionnaire(
    questionnaireId: $questionnaireId
    isEditable: $isEditable
  ) {
    ...AccountFragmentForEuTaxonomy
  }
}
    ${AccountFragmentForEuTaxonomyFragmentDoc}`;

/**
 * __useSubmitEuAlignmentQuestionnaireMutation__
 *
 * To run a mutation, you first call `useSubmitEuAlignmentQuestionnaireMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSubmitEuAlignmentQuestionnaireMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSubmitEuAlignmentQuestionnaireMutation({
 *   variables: {
 *     questionnaireId: // value for 'questionnaireId'
 *     isEditable: // value for 'isEditable'
 *   },
 * });
 */
export function useSubmitEuAlignmentQuestionnaireMutation(options: VueApolloComposable.UseMutationOptions<SubmitEuAlignmentQuestionnaireMutation, SubmitEuAlignmentQuestionnaireMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SubmitEuAlignmentQuestionnaireMutation, SubmitEuAlignmentQuestionnaireMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SubmitEuAlignmentQuestionnaireMutation, SubmitEuAlignmentQuestionnaireMutationVariables>(SubmitEuAlignmentQuestionnaireDocument, options);
}
export type SubmitEuAlignmentQuestionnaireMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SubmitEuAlignmentQuestionnaireMutation, SubmitEuAlignmentQuestionnaireMutationVariables>;
export const SyncEuTaxonomyActivitiesWithQuestionnaireDocument = gql`
    mutation syncEuTaxonomyActivitiesWithQuestionnaire($ventureId: String!) {
  syncEuTaxonomyActivitiesWithQuestionnaire(ventureId: $ventureId) {
    ...AccountFragmentForEuTaxonomy
  }
}
    ${AccountFragmentForEuTaxonomyFragmentDoc}`;

/**
 * __useSyncEuTaxonomyActivitiesWithQuestionnaireMutation__
 *
 * To run a mutation, you first call `useSyncEuTaxonomyActivitiesWithQuestionnaireMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSyncEuTaxonomyActivitiesWithQuestionnaireMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSyncEuTaxonomyActivitiesWithQuestionnaireMutation({
 *   variables: {
 *     ventureId: // value for 'ventureId'
 *   },
 * });
 */
export function useSyncEuTaxonomyActivitiesWithQuestionnaireMutation(options: VueApolloComposable.UseMutationOptions<SyncEuTaxonomyActivitiesWithQuestionnaireMutation, SyncEuTaxonomyActivitiesWithQuestionnaireMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SyncEuTaxonomyActivitiesWithQuestionnaireMutation, SyncEuTaxonomyActivitiesWithQuestionnaireMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SyncEuTaxonomyActivitiesWithQuestionnaireMutation, SyncEuTaxonomyActivitiesWithQuestionnaireMutationVariables>(SyncEuTaxonomyActivitiesWithQuestionnaireDocument, options);
}
export type SyncEuTaxonomyActivitiesWithQuestionnaireMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SyncEuTaxonomyActivitiesWithQuestionnaireMutation, SyncEuTaxonomyActivitiesWithQuestionnaireMutationVariables>;
export const SyncVenturesWithSfdrFundSettingsDocument = gql`
    mutation syncVenturesWithSfdrFundSettings($fundId: Int!, $sendEsgNotifications: Boolean, $esgNotificationNote: String) {
  syncVenturesWithSfdrFundSettings(
    fundId: $fundId
    sendEsgNotifications: $sendEsgNotifications
    esgNotificationNote: $esgNotificationNote
  ) {
    ...CompleteFund
  }
}
    ${CompleteFundFragmentDoc}`;

/**
 * __useSyncVenturesWithSfdrFundSettingsMutation__
 *
 * To run a mutation, you first call `useSyncVenturesWithSfdrFundSettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSyncVenturesWithSfdrFundSettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSyncVenturesWithSfdrFundSettingsMutation({
 *   variables: {
 *     fundId: // value for 'fundId'
 *     sendEsgNotifications: // value for 'sendEsgNotifications'
 *     esgNotificationNote: // value for 'esgNotificationNote'
 *   },
 * });
 */
export function useSyncVenturesWithSfdrFundSettingsMutation(options: VueApolloComposable.UseMutationOptions<SyncVenturesWithSfdrFundSettingsMutation, SyncVenturesWithSfdrFundSettingsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SyncVenturesWithSfdrFundSettingsMutation, SyncVenturesWithSfdrFundSettingsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SyncVenturesWithSfdrFundSettingsMutation, SyncVenturesWithSfdrFundSettingsMutationVariables>(SyncVenturesWithSfdrFundSettingsDocument, options);
}
export type SyncVenturesWithSfdrFundSettingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SyncVenturesWithSfdrFundSettingsMutation, SyncVenturesWithSfdrFundSettingsMutationVariables>;
export const UpdateAccountDocument = gql`
    mutation updateAccount($input: AccountInput!, $userIdsToAdd: [UUID!], $userIdsToRemove: [UUID!]) {
  updateAccount(
    input: $input
    userIdsToAdd: $userIdsToAdd
    userIdsToRemove: $userIdsToRemove
  ) {
    ...CompletePortfolio
    users {
      id
      email
    }
    csrdRequirement
    showCsrdIntro
    ...AccountFragmentForEuTaxonomy
  }
}
    ${CompletePortfolioFragmentDoc}
${AccountFragmentForEuTaxonomyFragmentDoc}`;

/**
 * __useUpdateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAccountMutation({
 *   variables: {
 *     input: // value for 'input'
 *     userIdsToAdd: // value for 'userIdsToAdd'
 *     userIdsToRemove: // value for 'userIdsToRemove'
 *   },
 * });
 */
export function useUpdateAccountMutation(options: VueApolloComposable.UseMutationOptions<UpdateAccountMutation, UpdateAccountMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateAccountMutation, UpdateAccountMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateAccountMutation, UpdateAccountMutationVariables>(UpdateAccountDocument, options);
}
export type UpdateAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const UpdateAccountFundSetupDocument = gql`
    mutation updateAccountFundSetup($input: AccountInput!) {
  updateAccount(input: $input) {
    id
    nameOfFinancialMarketParticipant
    legalEntityIdentifier
    sustainabilityRiskIntegration
    remunerationPolicies
    subsidiaries
    entityLevelPaiConsideration
    hiddenKpis
  }
}
    `;

/**
 * __useUpdateAccountFundSetupMutation__
 *
 * To run a mutation, you first call `useUpdateAccountFundSetupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountFundSetupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAccountFundSetupMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountFundSetupMutation(options: VueApolloComposable.UseMutationOptions<UpdateAccountFundSetupMutation, UpdateAccountFundSetupMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateAccountFundSetupMutation, UpdateAccountFundSetupMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateAccountFundSetupMutation, UpdateAccountFundSetupMutationVariables>(UpdateAccountFundSetupDocument, options);
}
export type UpdateAccountFundSetupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateAccountFundSetupMutation, UpdateAccountFundSetupMutationVariables>;
export const UpdateAssetAllocationTargetsDocument = gql`
    mutation updateAssetAllocationTargets($input: FundInput!) {
  updateAssetAllocationTargets(input: $input) {
    id
    assetAllocationTargets {
      percentEnvironmental
      percentEnvironmentalTaxonomyAligned
      percentEnvironmentalNotTaxonomyAligned
      percentSocial
      percentSustainable
      percentTaxonomyAlignedFossil
      percentTaxonomyAlignedNuclear
      percentTaxonomyAlignedEnabling
      percentTaxonomyAlignedTransitional
    }
  }
}
    `;

/**
 * __useUpdateAssetAllocationTargetsMutation__
 *
 * To run a mutation, you first call `useUpdateAssetAllocationTargetsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssetAllocationTargetsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAssetAllocationTargetsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAssetAllocationTargetsMutation(options: VueApolloComposable.UseMutationOptions<UpdateAssetAllocationTargetsMutation, UpdateAssetAllocationTargetsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateAssetAllocationTargetsMutation, UpdateAssetAllocationTargetsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateAssetAllocationTargetsMutation, UpdateAssetAllocationTargetsMutationVariables>(UpdateAssetAllocationTargetsDocument, options);
}
export type UpdateAssetAllocationTargetsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateAssetAllocationTargetsMutation, UpdateAssetAllocationTargetsMutationVariables>;
export const UpdateFundDocument = gql`
    mutation updateFund($input: FundInput!) {
  updateFund(input: $input) {
    ...CompleteFund
  }
}
    ${CompleteFundFragmentDoc}`;

/**
 * __useUpdateFundMutation__
 *
 * To run a mutation, you first call `useUpdateFundMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFundMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateFundMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFundMutation(options: VueApolloComposable.UseMutationOptions<UpdateFundMutation, UpdateFundMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateFundMutation, UpdateFundMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateFundMutation, UpdateFundMutationVariables>(UpdateFundDocument, options);
}
export type UpdateFundMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateFundMutation, UpdateFundMutationVariables>;
export const UpdatePortfolioVentureLinkDocument = gql`
    mutation updatePortfolioVentureLink($portfolioId: UUID!, $ventureId: UUID!, $modules: [String!]!) {
  updatePortfolioVentureLink(
    portfolioId: $portfolioId
    ventureId: $ventureId
    modules: $modules
  ) {
    portfolioId
    ventureId
    modules
  }
}
    `;

/**
 * __useUpdatePortfolioVentureLinkMutation__
 *
 * To run a mutation, you first call `useUpdatePortfolioVentureLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortfolioVentureLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePortfolioVentureLinkMutation({
 *   variables: {
 *     portfolioId: // value for 'portfolioId'
 *     ventureId: // value for 'ventureId'
 *     modules: // value for 'modules'
 *   },
 * });
 */
export function useUpdatePortfolioVentureLinkMutation(options: VueApolloComposable.UseMutationOptions<UpdatePortfolioVentureLinkMutation, UpdatePortfolioVentureLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdatePortfolioVentureLinkMutation, UpdatePortfolioVentureLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdatePortfolioVentureLinkMutation, UpdatePortfolioVentureLinkMutationVariables>(UpdatePortfolioVentureLinkDocument, options);
}
export type UpdatePortfolioVentureLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdatePortfolioVentureLinkMutation, UpdatePortfolioVentureLinkMutationVariables>;
export const UpdatePrecontractualReportDocument = gql`
    mutation updatePrecontractualReport($input: FundInput!) {
  updatePrecontractualReport(input: $input) {
    ...CompleteFund
  }
}
    ${CompleteFundFragmentDoc}`;

/**
 * __useUpdatePrecontractualReportMutation__
 *
 * To run a mutation, you first call `useUpdatePrecontractualReportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePrecontractualReportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePrecontractualReportMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePrecontractualReportMutation(options: VueApolloComposable.UseMutationOptions<UpdatePrecontractualReportMutation, UpdatePrecontractualReportMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdatePrecontractualReportMutation, UpdatePrecontractualReportMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdatePrecontractualReportMutation, UpdatePrecontractualReportMutationVariables>(UpdatePrecontractualReportDocument, options);
}
export type UpdatePrecontractualReportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdatePrecontractualReportMutation, UpdatePrecontractualReportMutationVariables>;
export const UpdateReportAnswerDocument = gql`
    mutation updateReportAnswer($input: ReportAnswerInput!) {
  updateReportAnswer(input: $input) {
    id
    fundId
    referencePeriodId
    reportType
  }
}
    `;

/**
 * __useUpdateReportAnswerMutation__
 *
 * To run a mutation, you first call `useUpdateReportAnswerMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportAnswerMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateReportAnswerMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportAnswerMutation(options: VueApolloComposable.UseMutationOptions<UpdateReportAnswerMutation, UpdateReportAnswerMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateReportAnswerMutation, UpdateReportAnswerMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateReportAnswerMutation, UpdateReportAnswerMutationVariables>(UpdateReportAnswerDocument, options);
}
export type UpdateReportAnswerMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateReportAnswerMutation, UpdateReportAnswerMutationVariables>;
export const UpdateSfdrStrategyDocument = gql`
    mutation updateSfdrStrategy($input: SfdrStrategyInput!) {
  updateSfdrStrategy(input: $input) {
    ...CompleteFund
  }
}
    ${CompleteFundFragmentDoc}`;

/**
 * __useUpdateSfdrStrategyMutation__
 *
 * To run a mutation, you first call `useUpdateSfdrStrategyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSfdrStrategyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSfdrStrategyMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSfdrStrategyMutation(options: VueApolloComposable.UseMutationOptions<UpdateSfdrStrategyMutation, UpdateSfdrStrategyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateSfdrStrategyMutation, UpdateSfdrStrategyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateSfdrStrategyMutation, UpdateSfdrStrategyMutationVariables>(UpdateSfdrStrategyDocument, options);
}
export type UpdateSfdrStrategyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateSfdrStrategyMutation, UpdateSfdrStrategyMutationVariables>;
export const UpdateVentureCommentDocument = gql`
    mutation updateVentureComment($ventureId: String!, $comment: String!) {
  updateVentureComment(ventureId: $ventureId, comment: $comment) {
    id
    portfolioId
    ventureId
    comment
  }
}
    `;

/**
 * __useUpdateVentureCommentMutation__
 *
 * To run a mutation, you first call `useUpdateVentureCommentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVentureCommentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateVentureCommentMutation({
 *   variables: {
 *     ventureId: // value for 'ventureId'
 *     comment: // value for 'comment'
 *   },
 * });
 */
export function useUpdateVentureCommentMutation(options: VueApolloComposable.UseMutationOptions<UpdateVentureCommentMutation, UpdateVentureCommentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateVentureCommentMutation, UpdateVentureCommentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateVentureCommentMutation, UpdateVentureCommentMutationVariables>(UpdateVentureCommentDocument, options);
}
export type UpdateVentureCommentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateVentureCommentMutation, UpdateVentureCommentMutationVariables>;
export const UpsertGroupDocument = gql`
    mutation upsertGroup($input: PortfolioGroupInput!) {
  upsertGroup(input: $input) {
    ...CompletePortfolioGroup
  }
}
    ${CompletePortfolioGroupFragmentDoc}`;

/**
 * __useUpsertGroupMutation__
 *
 * To run a mutation, you first call `useUpsertGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertGroupMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpsertGroupMutation(options: VueApolloComposable.UseMutationOptions<UpsertGroupMutation, UpsertGroupMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertGroupMutation, UpsertGroupMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertGroupMutation, UpsertGroupMutationVariables>(UpsertGroupDocument, options);
}
export type UpsertGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertGroupMutation, UpsertGroupMutationVariables>;
export const UpsertAccountSectionLinkDocument = gql`
    mutation upsertAccountSectionLink($input: AccountSectionLinkInput!) {
  upsertAccountSectionLink(input: $input) {
    ...AccountLink
  }
}
    ${AccountLinkFragmentDoc}`;

/**
 * __useUpsertAccountSectionLinkMutation__
 *
 * To run a mutation, you first call `useUpsertAccountSectionLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAccountSectionLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertAccountSectionLinkMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpsertAccountSectionLinkMutation(options: VueApolloComposable.UseMutationOptions<UpsertAccountSectionLinkMutation, UpsertAccountSectionLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertAccountSectionLinkMutation, UpsertAccountSectionLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertAccountSectionLinkMutation, UpsertAccountSectionLinkMutationVariables>(UpsertAccountSectionLinkDocument, options);
}
export type UpsertAccountSectionLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertAccountSectionLinkMutation, UpsertAccountSectionLinkMutationVariables>;
export const AddActivityStakeholderLinkDocument = gql`
    mutation addActivityStakeholderLink($stakeholderId: UUID!, $activityId: UUID!) {
  addActivityStakeholderLink(
    stakeholderId: $stakeholderId
    activityId: $activityId
  ) {
    stakeholderId
    activityId
  }
}
    `;

/**
 * __useAddActivityStakeholderLinkMutation__
 *
 * To run a mutation, you first call `useAddActivityStakeholderLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddActivityStakeholderLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddActivityStakeholderLinkMutation({
 *   variables: {
 *     stakeholderId: // value for 'stakeholderId'
 *     activityId: // value for 'activityId'
 *   },
 * });
 */
export function useAddActivityStakeholderLinkMutation(options: VueApolloComposable.UseMutationOptions<AddActivityStakeholderLinkMutation, AddActivityStakeholderLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddActivityStakeholderLinkMutation, AddActivityStakeholderLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddActivityStakeholderLinkMutation, AddActivityStakeholderLinkMutationVariables>(AddActivityStakeholderLinkDocument, options);
}
export type AddActivityStakeholderLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddActivityStakeholderLinkMutation, AddActivityStakeholderLinkMutationVariables>;
export const UpdateActivityStakeholderLinkDocument = gql`
    mutation updateActivityStakeholderLink($input: ActivityStakeholderLinkInput!) {
  updateActivityStakeholderLink(activityStakeholderLinkInput: $input) {
    id
    impactMaterial
    financialMaterial
  }
}
    `;

/**
 * __useUpdateActivityStakeholderLinkMutation__
 *
 * To run a mutation, you first call `useUpdateActivityStakeholderLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActivityStakeholderLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateActivityStakeholderLinkMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateActivityStakeholderLinkMutation(options: VueApolloComposable.UseMutationOptions<UpdateActivityStakeholderLinkMutation, UpdateActivityStakeholderLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateActivityStakeholderLinkMutation, UpdateActivityStakeholderLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateActivityStakeholderLinkMutation, UpdateActivityStakeholderLinkMutationVariables>(UpdateActivityStakeholderLinkDocument, options);
}
export type UpdateActivityStakeholderLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateActivityStakeholderLinkMutation, UpdateActivityStakeholderLinkMutationVariables>;
export const AddActivityDocument = gql`
    mutation AddActivity($activityInput: ActivityInput!) {
  addActivity(activityInput: $activityInput) {
    id
    name
    description
    industry
    geographyId
    location
    type
    riskProfile
    valueChainId
  }
}
    `;

/**
 * __useAddActivityMutation__
 *
 * To run a mutation, you first call `useAddActivityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddActivityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddActivityMutation({
 *   variables: {
 *     activityInput: // value for 'activityInput'
 *   },
 * });
 */
export function useAddActivityMutation(options: VueApolloComposable.UseMutationOptions<AddActivityMutation, AddActivityMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddActivityMutation, AddActivityMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddActivityMutation, AddActivityMutationVariables>(AddActivityDocument, options);
}
export type AddActivityMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddActivityMutation, AddActivityMutationVariables>;
export const DeleteActivityDocument = gql`
    mutation deleteActivity($id: UUID!) {
  deleteActivity(id: $id)
}
    `;

/**
 * __useDeleteActivityMutation__
 *
 * To run a mutation, you first call `useDeleteActivityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteActivityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteActivityMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteActivityMutation(options: VueApolloComposable.UseMutationOptions<DeleteActivityMutation, DeleteActivityMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteActivityMutation, DeleteActivityMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteActivityMutation, DeleteActivityMutationVariables>(DeleteActivityDocument, options);
}
export type DeleteActivityMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteActivityMutation, DeleteActivityMutationVariables>;
export const UpdateActivityDocument = gql`
    mutation UpdateActivity($activityInput: ActivityInput!) {
  updateActivity(activityInput: $activityInput) {
    id
    name
    description
    industry
    location
    type
    riskProfile
    geographyId
    valueChainId
  }
}
    `;

/**
 * __useUpdateActivityMutation__
 *
 * To run a mutation, you first call `useUpdateActivityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActivityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateActivityMutation({
 *   variables: {
 *     activityInput: // value for 'activityInput'
 *   },
 * });
 */
export function useUpdateActivityMutation(options: VueApolloComposable.UseMutationOptions<UpdateActivityMutation, UpdateActivityMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateActivityMutation, UpdateActivityMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateActivityMutation, UpdateActivityMutationVariables>(UpdateActivityDocument, options);
}
export type UpdateActivityMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateActivityMutation, UpdateActivityMutationVariables>;
export const ExecutePromptDocument = gql`
    mutation executePrompt($input: ExecutePromptInput!) {
  executePrompt(input: $input) {
    id
    response
    tokenUsage
    latencyMs
    cacheHit
    promptTemplateId
    version
    model
    renderedSystem
    renderedUser
    sanitizedRenderedUser
    createdAt
    promptAccepted
    sanitizerInfo
  }
}
    `;

/**
 * __useExecutePromptMutation__
 *
 * To run a mutation, you first call `useExecutePromptMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useExecutePromptMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useExecutePromptMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useExecutePromptMutation(options: VueApolloComposable.UseMutationOptions<ExecutePromptMutation, ExecutePromptMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ExecutePromptMutation, ExecutePromptMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ExecutePromptMutation, ExecutePromptMutationVariables>(ExecutePromptDocument, options);
}
export type ExecutePromptMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ExecutePromptMutation, ExecutePromptMutationVariables>;
export const UpsertPromptRunDocument = gql`
    mutation upsertPromptRun($input: PromptRunInput!) {
  upsertPromptRun(input: $input) {
    id
  }
}
    `;

/**
 * __useUpsertPromptRunMutation__
 *
 * To run a mutation, you first call `useUpsertPromptRunMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPromptRunMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertPromptRunMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPromptRunMutation(options: VueApolloComposable.UseMutationOptions<UpsertPromptRunMutation, UpsertPromptRunMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertPromptRunMutation, UpsertPromptRunMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertPromptRunMutation, UpsertPromptRunMutationVariables>(UpsertPromptRunDocument, options);
}
export type UpsertPromptRunMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertPromptRunMutation, UpsertPromptRunMutationVariables>;
export const UpdateCategoryDocument = gql`
    mutation UpdateCategory($input: CategoryInput!) {
  upsertCategory(input: $input) {
    id
    label
    labelI18n
    createdAt
    parentId
    parent {
      id
      label
    }
  }
}
    `;

/**
 * __useUpdateCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCategoryMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCategoryMutation(options: VueApolloComposable.UseMutationOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateCategoryMutation, UpdateCategoryMutationVariables>(UpdateCategoryDocument, options);
}
export type UpdateCategoryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateCategoryMutation, UpdateCategoryMutationVariables>;
export const AddConceptDocument = gql`
    mutation addConcept($input: ConceptInput!) {
  addConcept(input: $input) {
    ...CompleteConcept
  }
}
    ${CompleteConceptFragmentDoc}`;

/**
 * __useAddConceptMutation__
 *
 * To run a mutation, you first call `useAddConceptMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddConceptMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddConceptMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddConceptMutation(options: VueApolloComposable.UseMutationOptions<AddConceptMutation, AddConceptMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddConceptMutation, AddConceptMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddConceptMutation, AddConceptMutationVariables>(AddConceptDocument, options);
}
export type AddConceptMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddConceptMutation, AddConceptMutationVariables>;
export const UpsertMeasureDocument = gql`
    mutation upsertMeasure($input: ConceptInput!) {
  upsertMeasure(input: $input) {
    ...CompleteConcept
  }
}
    ${CompleteConceptFragmentDoc}`;

/**
 * __useUpsertMeasureMutation__
 *
 * To run a mutation, you first call `useUpsertMeasureMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMeasureMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertMeasureMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpsertMeasureMutation(options: VueApolloComposable.UseMutationOptions<UpsertMeasureMutation, UpsertMeasureMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertMeasureMutation, UpsertMeasureMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertMeasureMutation, UpsertMeasureMutationVariables>(UpsertMeasureDocument, options);
}
export type UpsertMeasureMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertMeasureMutation, UpsertMeasureMutationVariables>;
export const CreateDemoPortfolioDocument = gql`
    mutation CreateDemoPortfolio($input: CreateDemoPortfolioInput!) {
  createDemoPortfolio(input: $input) {
    portfolioName
  }
}
    `;

/**
 * __useCreateDemoPortfolioMutation__
 *
 * To run a mutation, you first call `useCreateDemoPortfolioMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateDemoPortfolioMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateDemoPortfolioMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateDemoPortfolioMutation(options: VueApolloComposable.UseMutationOptions<CreateDemoPortfolioMutation, CreateDemoPortfolioMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateDemoPortfolioMutation, CreateDemoPortfolioMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateDemoPortfolioMutation, CreateDemoPortfolioMutationVariables>(CreateDemoPortfolioDocument, options);
}
export type CreateDemoPortfolioMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateDemoPortfolioMutation, CreateDemoPortfolioMutationVariables>;
export const AddEvidenceDocument = gql`
    mutation AddEvidence($input: EvidenceInput!) {
  addEvidence(input: $input) {
    id
    websiteUrl
    description
    comment
  }
}
    `;

/**
 * __useAddEvidenceMutation__
 *
 * To run a mutation, you first call `useAddEvidenceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddEvidenceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddEvidenceMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddEvidenceMutation(options: VueApolloComposable.UseMutationOptions<AddEvidenceMutation, AddEvidenceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddEvidenceMutation, AddEvidenceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddEvidenceMutation, AddEvidenceMutationVariables>(AddEvidenceDocument, options);
}
export type AddEvidenceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddEvidenceMutation, AddEvidenceMutationVariables>;
export const AddEvidenceLinkDocument = gql`
    mutation AddEvidenceLink($input: EvidenceLinkInput!) {
  addEvidenceLink(input: $input) {
    id
    accountId
    type
    evidenceId
    entityUuidId
    entityIntId
    description
  }
}
    `;

/**
 * __useAddEvidenceLinkMutation__
 *
 * To run a mutation, you first call `useAddEvidenceLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddEvidenceLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddEvidenceLinkMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddEvidenceLinkMutation(options: VueApolloComposable.UseMutationOptions<AddEvidenceLinkMutation, AddEvidenceLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddEvidenceLinkMutation, AddEvidenceLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddEvidenceLinkMutation, AddEvidenceLinkMutationVariables>(AddEvidenceLinkDocument, options);
}
export type AddEvidenceLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddEvidenceLinkMutation, AddEvidenceLinkMutationVariables>;
export const DelEvidenceDocument = gql`
    mutation DelEvidence($id: UUID!) {
  delEvidence(id: $id)
}
    `;

/**
 * __useDelEvidenceMutation__
 *
 * To run a mutation, you first call `useDelEvidenceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDelEvidenceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDelEvidenceMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDelEvidenceMutation(options: VueApolloComposable.UseMutationOptions<DelEvidenceMutation, DelEvidenceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DelEvidenceMutation, DelEvidenceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DelEvidenceMutation, DelEvidenceMutationVariables>(DelEvidenceDocument, options);
}
export type DelEvidenceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DelEvidenceMutation, DelEvidenceMutationVariables>;
export const DelEvidenceLinkDocument = gql`
    mutation DelEvidenceLink($id: UUID!) {
  delEvidenceLink(id: $id)
}
    `;

/**
 * __useDelEvidenceLinkMutation__
 *
 * To run a mutation, you first call `useDelEvidenceLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDelEvidenceLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDelEvidenceLinkMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDelEvidenceLinkMutation(options: VueApolloComposable.UseMutationOptions<DelEvidenceLinkMutation, DelEvidenceLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DelEvidenceLinkMutation, DelEvidenceLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DelEvidenceLinkMutation, DelEvidenceLinkMutationVariables>(DelEvidenceLinkDocument, options);
}
export type DelEvidenceLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DelEvidenceLinkMutation, DelEvidenceLinkMutationVariables>;
export const UpdateEvidenceDocument = gql`
    mutation UpdateEvidence($input: EvidenceInput!) {
  updateEvidence(input: $input) {
    id
    websiteUrl
    comment
    description
  }
}
    `;

/**
 * __useUpdateEvidenceMutation__
 *
 * To run a mutation, you first call `useUpdateEvidenceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEvidenceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateEvidenceMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEvidenceMutation(options: VueApolloComposable.UseMutationOptions<UpdateEvidenceMutation, UpdateEvidenceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateEvidenceMutation, UpdateEvidenceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateEvidenceMutation, UpdateEvidenceMutationVariables>(UpdateEvidenceDocument, options);
}
export type UpdateEvidenceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateEvidenceMutation, UpdateEvidenceMutationVariables>;
export const UpdateEvidenceLinkDocument = gql`
    mutation UpdateEvidenceLink($input: EvidenceLinkInput!) {
  updateEvidenceLink(input: $input) {
    id
    accountId
    type
    evidenceId
    entityUuidId
    entityIntId
    description
  }
}
    `;

/**
 * __useUpdateEvidenceLinkMutation__
 *
 * To run a mutation, you first call `useUpdateEvidenceLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEvidenceLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateEvidenceLinkMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEvidenceLinkMutation(options: VueApolloComposable.UseMutationOptions<UpdateEvidenceLinkMutation, UpdateEvidenceLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateEvidenceLinkMutation, UpdateEvidenceLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateEvidenceLinkMutation, UpdateEvidenceLinkMutationVariables>(UpdateEvidenceLinkDocument, options);
}
export type UpdateEvidenceLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateEvidenceLinkMutation, UpdateEvidenceLinkMutationVariables>;
export const BatchLockImpactsDocument = gql`
    mutation BatchLockImpacts($input: BatchImpactLockInput!) {
  batchLockImpacts(input: $input) {
    id
    isEditable
    submitDate
  }
}
    `;

/**
 * __useBatchLockImpactsMutation__
 *
 * To run a mutation, you first call `useBatchLockImpactsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBatchLockImpactsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBatchLockImpactsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useBatchLockImpactsMutation(options: VueApolloComposable.UseMutationOptions<BatchLockImpactsMutation, BatchLockImpactsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<BatchLockImpactsMutation, BatchLockImpactsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<BatchLockImpactsMutation, BatchLockImpactsMutationVariables>(BatchLockImpactsDocument, options);
}
export type BatchLockImpactsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<BatchLockImpactsMutation, BatchLockImpactsMutationVariables>;
export const CreateImpactDocument = gql`
    mutation createImpact($input: ImpactInput!) {
  createImpact(input: $input) {
    ...CompleteImpact
  }
}
    ${CompleteImpactFragmentDoc}`;

/**
 * __useCreateImpactMutation__
 *
 * To run a mutation, you first call `useCreateImpactMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateImpactMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateImpactMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateImpactMutation(options: VueApolloComposable.UseMutationOptions<CreateImpactMutation, CreateImpactMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateImpactMutation, CreateImpactMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateImpactMutation, CreateImpactMutationVariables>(CreateImpactDocument, options);
}
export type CreateImpactMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateImpactMutation, CreateImpactMutationVariables>;
export const CreateImpactGoalsDocument = gql`
    mutation createImpactGoals($ventureIds: [String!]!) {
  createImpactGoals(ventureIds: $ventureIds) {
    ...CompleteImpactGoal
  }
}
    ${CompleteImpactGoalFragmentDoc}`;

/**
 * __useCreateImpactGoalsMutation__
 *
 * To run a mutation, you first call `useCreateImpactGoalsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateImpactGoalsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateImpactGoalsMutation({
 *   variables: {
 *     ventureIds: // value for 'ventureIds'
 *   },
 * });
 */
export function useCreateImpactGoalsMutation(options: VueApolloComposable.UseMutationOptions<CreateImpactGoalsMutation, CreateImpactGoalsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateImpactGoalsMutation, CreateImpactGoalsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateImpactGoalsMutation, CreateImpactGoalsMutationVariables>(CreateImpactGoalsDocument, options);
}
export type CreateImpactGoalsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateImpactGoalsMutation, CreateImpactGoalsMutationVariables>;
export const DeleteEmissionSourceDocument = gql`
    mutation deleteEmissionSource($id: Int!) {
  deleteEmissionSource(id: $id) {
    ...CompleteGhgSavingPotential
  }
}
    ${CompleteGhgSavingPotentialFragmentDoc}`;

/**
 * __useDeleteEmissionSourceMutation__
 *
 * To run a mutation, you first call `useDeleteEmissionSourceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmissionSourceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteEmissionSourceMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEmissionSourceMutation(options: VueApolloComposable.UseMutationOptions<DeleteEmissionSourceMutation, DeleteEmissionSourceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteEmissionSourceMutation, DeleteEmissionSourceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteEmissionSourceMutation, DeleteEmissionSourceMutationVariables>(DeleteEmissionSourceDocument, options);
}
export type DeleteEmissionSourceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteEmissionSourceMutation, DeleteEmissionSourceMutationVariables>;
export const DeleteImpactDocument = gql`
    mutation deleteImpact($impactId: Int!) {
  deleteImpact(impactId: $impactId) {
    isSuccess
    recordId
  }
}
    `;

/**
 * __useDeleteImpactMutation__
 *
 * To run a mutation, you first call `useDeleteImpactMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteImpactMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteImpactMutation({
 *   variables: {
 *     impactId: // value for 'impactId'
 *   },
 * });
 */
export function useDeleteImpactMutation(options: VueApolloComposable.UseMutationOptions<DeleteImpactMutation, DeleteImpactMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteImpactMutation, DeleteImpactMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteImpactMutation, DeleteImpactMutationVariables>(DeleteImpactDocument, options);
}
export type DeleteImpactMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteImpactMutation, DeleteImpactMutationVariables>;
export const DeleteImpactSolutionDocument = gql`
    mutation deleteImpactSolution($id: Int!) {
  deleteImpactSolution(id: $id) {
    isSuccess
    recordId
  }
}
    `;

/**
 * __useDeleteImpactSolutionMutation__
 *
 * To run a mutation, you first call `useDeleteImpactSolutionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteImpactSolutionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteImpactSolutionMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteImpactSolutionMutation(options: VueApolloComposable.UseMutationOptions<DeleteImpactSolutionMutation, DeleteImpactSolutionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteImpactSolutionMutation, DeleteImpactSolutionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteImpactSolutionMutation, DeleteImpactSolutionMutationVariables>(DeleteImpactSolutionDocument, options);
}
export type DeleteImpactSolutionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteImpactSolutionMutation, DeleteImpactSolutionMutationVariables>;
export const InstantiateGhgReductionImpactDocument = gql`
    mutation instantiateGhgReductionImpact($ventureId: UUID!) {
  instantiateGhgReductionImpact(ventureId: $ventureId) {
    ...CompleteImpactGoal
  }
}
    ${CompleteImpactGoalFragmentDoc}`;

/**
 * __useInstantiateGhgReductionImpactMutation__
 *
 * To run a mutation, you first call `useInstantiateGhgReductionImpactMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInstantiateGhgReductionImpactMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInstantiateGhgReductionImpactMutation({
 *   variables: {
 *     ventureId: // value for 'ventureId'
 *   },
 * });
 */
export function useInstantiateGhgReductionImpactMutation(options: VueApolloComposable.UseMutationOptions<InstantiateGhgReductionImpactMutation, InstantiateGhgReductionImpactMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<InstantiateGhgReductionImpactMutation, InstantiateGhgReductionImpactMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<InstantiateGhgReductionImpactMutation, InstantiateGhgReductionImpactMutationVariables>(InstantiateGhgReductionImpactDocument, options);
}
export type InstantiateGhgReductionImpactMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<InstantiateGhgReductionImpactMutation, InstantiateGhgReductionImpactMutationVariables>;
export const UpdateImpactDocument = gql`
    mutation updateImpact($id: Int!, $input: ImpactInput!) {
  updateImpact(id: $id, input: $input) {
    ...CompleteImpact
  }
}
    ${CompleteImpactFragmentDoc}`;

/**
 * __useUpdateImpactMutation__
 *
 * To run a mutation, you first call `useUpdateImpactMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImpactMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateImpactMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateImpactMutation(options: VueApolloComposable.UseMutationOptions<UpdateImpactMutation, UpdateImpactMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateImpactMutation, UpdateImpactMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateImpactMutation, UpdateImpactMutationVariables>(UpdateImpactDocument, options);
}
export type UpdateImpactMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateImpactMutation, UpdateImpactMutationVariables>;
export const UpdateImpactGoalDocument = gql`
    mutation updateImpactGoal($input: ImpactGoalInput!) {
  updateImpactGoal(input: $input) {
    ...CompleteImpactGoal
  }
}
    ${CompleteImpactGoalFragmentDoc}`;

/**
 * __useUpdateImpactGoalMutation__
 *
 * To run a mutation, you first call `useUpdateImpactGoalMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImpactGoalMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateImpactGoalMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateImpactGoalMutation(options: VueApolloComposable.UseMutationOptions<UpdateImpactGoalMutation, UpdateImpactGoalMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateImpactGoalMutation, UpdateImpactGoalMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateImpactGoalMutation, UpdateImpactGoalMutationVariables>(UpdateImpactGoalDocument, options);
}
export type UpdateImpactGoalMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateImpactGoalMutation, UpdateImpactGoalMutationVariables>;
export const UpdateImpactLeanDocument = gql`
    mutation updateImpactLean($id: Int!, $input: ImpactInput!) {
  updateImpact(id: $id, input: $input) {
    id
    euTaxonomy
    sdgTargets {
      id
      label
      sdgId
    }
    irisCategories {
      id
      label
    }
  }
}
    `;

/**
 * __useUpdateImpactLeanMutation__
 *
 * To run a mutation, you first call `useUpdateImpactLeanMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImpactLeanMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateImpactLeanMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateImpactLeanMutation(options: VueApolloComposable.UseMutationOptions<UpdateImpactLeanMutation, UpdateImpactLeanMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateImpactLeanMutation, UpdateImpactLeanMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateImpactLeanMutation, UpdateImpactLeanMutationVariables>(UpdateImpactLeanDocument, options);
}
export type UpdateImpactLeanMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateImpactLeanMutation, UpdateImpactLeanMutationVariables>;
export const UpsertEmissionSourceDocument = gql`
    mutation upsertEmissionSource($input: EmissionSourceInput!) {
  upsertEmissionSource(input: $input) {
    ...CompleteGhgSavingPotential
  }
}
    ${CompleteGhgSavingPotentialFragmentDoc}`;

/**
 * __useUpsertEmissionSourceMutation__
 *
 * To run a mutation, you first call `useUpsertEmissionSourceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertEmissionSourceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertEmissionSourceMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpsertEmissionSourceMutation(options: VueApolloComposable.UseMutationOptions<UpsertEmissionSourceMutation, UpsertEmissionSourceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertEmissionSourceMutation, UpsertEmissionSourceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertEmissionSourceMutation, UpsertEmissionSourceMutationVariables>(UpsertEmissionSourceDocument, options);
}
export type UpsertEmissionSourceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertEmissionSourceMutation, UpsertEmissionSourceMutationVariables>;
export const UpsertGhgSavingPotentialDocument = gql`
    mutation upsertGhgSavingPotential($input: GhgSavingPotentialInput!) {
  upsertGhgSavingPotential(input: $input) {
    ...CompleteGhgSavingPotential
  }
}
    ${CompleteGhgSavingPotentialFragmentDoc}`;

/**
 * __useUpsertGhgSavingPotentialMutation__
 *
 * To run a mutation, you first call `useUpsertGhgSavingPotentialMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertGhgSavingPotentialMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertGhgSavingPotentialMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpsertGhgSavingPotentialMutation(options: VueApolloComposable.UseMutationOptions<UpsertGhgSavingPotentialMutation, UpsertGhgSavingPotentialMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertGhgSavingPotentialMutation, UpsertGhgSavingPotentialMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertGhgSavingPotentialMutation, UpsertGhgSavingPotentialMutationVariables>(UpsertGhgSavingPotentialDocument, options);
}
export type UpsertGhgSavingPotentialMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertGhgSavingPotentialMutation, UpsertGhgSavingPotentialMutationVariables>;
export const UpsertImpactSolutionDocument = gql`
    mutation upsertImpactSolution($input: ImpactSolutionInput!) {
  upsertImpactSolution(input: $input) {
    ...CompleteImpactSolution
  }
}
    ${CompleteImpactSolutionFragmentDoc}`;

/**
 * __useUpsertImpactSolutionMutation__
 *
 * To run a mutation, you first call `useUpsertImpactSolutionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertImpactSolutionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertImpactSolutionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpsertImpactSolutionMutation(options: VueApolloComposable.UseMutationOptions<UpsertImpactSolutionMutation, UpsertImpactSolutionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertImpactSolutionMutation, UpsertImpactSolutionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertImpactSolutionMutation, UpsertImpactSolutionMutationVariables>(UpsertImpactSolutionDocument, options);
}
export type UpsertImpactSolutionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertImpactSolutionMutation, UpsertImpactSolutionMutationVariables>;
export const AddIroSectionLinkDocument = gql`
    mutation addIroSectionLink($input: IroSectionLinkInput!) {
  addIroSectionLink(iroSectionLinkInput: $input) {
    id
  }
}
    `;

/**
 * __useAddIroSectionLinkMutation__
 *
 * To run a mutation, you first call `useAddIroSectionLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddIroSectionLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddIroSectionLinkMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddIroSectionLinkMutation(options: VueApolloComposable.UseMutationOptions<AddIroSectionLinkMutation, AddIroSectionLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddIroSectionLinkMutation, AddIroSectionLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddIroSectionLinkMutation, AddIroSectionLinkMutationVariables>(AddIroSectionLinkDocument, options);
}
export type AddIroSectionLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddIroSectionLinkMutation, AddIroSectionLinkMutationVariables>;
export const DelIroSectionLinkDocument = gql`
    mutation delIroSectionLink($iroId: UUID!, $sectionId: Int!) {
  delIroSectionLink(iroId: $iroId, sectionId: $sectionId)
}
    `;

/**
 * __useDelIroSectionLinkMutation__
 *
 * To run a mutation, you first call `useDelIroSectionLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDelIroSectionLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDelIroSectionLinkMutation({
 *   variables: {
 *     iroId: // value for 'iroId'
 *     sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function useDelIroSectionLinkMutation(options: VueApolloComposable.UseMutationOptions<DelIroSectionLinkMutation, DelIroSectionLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DelIroSectionLinkMutation, DelIroSectionLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DelIroSectionLinkMutation, DelIroSectionLinkMutationVariables>(DelIroSectionLinkDocument, options);
}
export type DelIroSectionLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DelIroSectionLinkMutation, DelIroSectionLinkMutationVariables>;
export const UpdateIroSectionLinkDocument = gql`
    mutation updateIroSectionLink($input: IroSectionLinkInput!) {
  updateIroSectionLink(iroSectionLinkInput: $input) {
    id
  }
}
    `;

/**
 * __useUpdateIroSectionLinkMutation__
 *
 * To run a mutation, you first call `useUpdateIroSectionLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIroSectionLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateIroSectionLinkMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIroSectionLinkMutation(options: VueApolloComposable.UseMutationOptions<UpdateIroSectionLinkMutation, UpdateIroSectionLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateIroSectionLinkMutation, UpdateIroSectionLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateIroSectionLinkMutation, UpdateIroSectionLinkMutationVariables>(UpdateIroSectionLinkDocument, options);
}
export type UpdateIroSectionLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateIroSectionLinkMutation, UpdateIroSectionLinkMutationVariables>;
export const AddIroStakeholderLinkDocument = gql`
    mutation addIroStakeholderLink($stakeholderId: UUID!, $iroId: UUID!) {
  addIroStakeholderLink(stakeholderId: $stakeholderId, iroId: $iroId) {
    stakeholderId
    iroId
  }
}
    `;

/**
 * __useAddIroStakeholderLinkMutation__
 *
 * To run a mutation, you first call `useAddIroStakeholderLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddIroStakeholderLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddIroStakeholderLinkMutation({
 *   variables: {
 *     stakeholderId: // value for 'stakeholderId'
 *     iroId: // value for 'iroId'
 *   },
 * });
 */
export function useAddIroStakeholderLinkMutation(options: VueApolloComposable.UseMutationOptions<AddIroStakeholderLinkMutation, AddIroStakeholderLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddIroStakeholderLinkMutation, AddIroStakeholderLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddIroStakeholderLinkMutation, AddIroStakeholderLinkMutationVariables>(AddIroStakeholderLinkDocument, options);
}
export type AddIroStakeholderLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddIroStakeholderLinkMutation, AddIroStakeholderLinkMutationVariables>;
export const UpdateIroStakeholderLinkDocument = gql`
    mutation updateIroStakeholderLink($input: IroStakeholderLinkInput!) {
  updateIroStakeholderLink(iroStakeholderLinkInput: $input) {
    id
    impactMaterial
    financialMaterial
    howAffected
    relationToRo
  }
}
    `;

/**
 * __useUpdateIroStakeholderLinkMutation__
 *
 * To run a mutation, you first call `useUpdateIroStakeholderLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIroStakeholderLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateIroStakeholderLinkMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIroStakeholderLinkMutation(options: VueApolloComposable.UseMutationOptions<UpdateIroStakeholderLinkMutation, UpdateIroStakeholderLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateIroStakeholderLinkMutation, UpdateIroStakeholderLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateIroStakeholderLinkMutation, UpdateIroStakeholderLinkMutationVariables>(UpdateIroStakeholderLinkDocument, options);
}
export type UpdateIroStakeholderLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateIroStakeholderLinkMutation, UpdateIroStakeholderLinkMutationVariables>;
export const AddMetricAggregationDocument = gql`
    mutation addMetricAggregation($input: MetricAggregationInput!) {
  addMetricAggregation(input: $input) {
    ...CompleteMetricAggregation
  }
}
    ${CompleteMetricAggregationFragmentDoc}`;

/**
 * __useAddMetricAggregationMutation__
 *
 * To run a mutation, you first call `useAddMetricAggregationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddMetricAggregationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddMetricAggregationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddMetricAggregationMutation(options: VueApolloComposable.UseMutationOptions<AddMetricAggregationMutation, AddMetricAggregationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddMetricAggregationMutation, AddMetricAggregationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddMetricAggregationMutation, AddMetricAggregationMutationVariables>(AddMetricAggregationDocument, options);
}
export type AddMetricAggregationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddMetricAggregationMutation, AddMetricAggregationMutationVariables>;
export const AddMetricAggregationBatchDocument = gql`
    mutation addMetricAggregationBatch($inputs: [MetricAggregationInput!]!) {
  addMetricAggregationBatch(inputs: $inputs) {
    id
  }
}
    `;

/**
 * __useAddMetricAggregationBatchMutation__
 *
 * To run a mutation, you first call `useAddMetricAggregationBatchMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddMetricAggregationBatchMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddMetricAggregationBatchMutation({
 *   variables: {
 *     inputs: // value for 'inputs'
 *   },
 * });
 */
export function useAddMetricAggregationBatchMutation(options: VueApolloComposable.UseMutationOptions<AddMetricAggregationBatchMutation, AddMetricAggregationBatchMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddMetricAggregationBatchMutation, AddMetricAggregationBatchMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddMetricAggregationBatchMutation, AddMetricAggregationBatchMutationVariables>(AddMetricAggregationBatchDocument, options);
}
export type AddMetricAggregationBatchMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddMetricAggregationBatchMutation, AddMetricAggregationBatchMutationVariables>;
export const BatchLockMetricAssignmentValuesDocument = gql`
    mutation BatchLockMetricAssignmentValues($input: BatchMetricValueLockInput!) {
  batchLockMetricAssignmentValues(input: $input) {
    id
  }
}
    `;

/**
 * __useBatchLockMetricAssignmentValuesMutation__
 *
 * To run a mutation, you first call `useBatchLockMetricAssignmentValuesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBatchLockMetricAssignmentValuesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBatchLockMetricAssignmentValuesMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useBatchLockMetricAssignmentValuesMutation(options: VueApolloComposable.UseMutationOptions<BatchLockMetricAssignmentValuesMutation, BatchLockMetricAssignmentValuesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<BatchLockMetricAssignmentValuesMutation, BatchLockMetricAssignmentValuesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<BatchLockMetricAssignmentValuesMutation, BatchLockMetricAssignmentValuesMutationVariables>(BatchLockMetricAssignmentValuesDocument, options);
}
export type BatchLockMetricAssignmentValuesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<BatchLockMetricAssignmentValuesMutation, BatchLockMetricAssignmentValuesMutationVariables>;
export const BatchLockMetricAssignmentValuesGranularDocument = gql`
    mutation BatchLockMetricAssignmentValuesGranular($input: BatchMetricValueGranularLockInput!) {
  batchLockMetricAssignmentValuesGranular(input: $input) {
    updatedMetricAssignmentIds
    errors {
      metricAssignmentId
      message
    }
  }
}
    `;

/**
 * __useBatchLockMetricAssignmentValuesGranularMutation__
 *
 * To run a mutation, you first call `useBatchLockMetricAssignmentValuesGranularMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBatchLockMetricAssignmentValuesGranularMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBatchLockMetricAssignmentValuesGranularMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useBatchLockMetricAssignmentValuesGranularMutation(options: VueApolloComposable.UseMutationOptions<BatchLockMetricAssignmentValuesGranularMutation, BatchLockMetricAssignmentValuesGranularMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<BatchLockMetricAssignmentValuesGranularMutation, BatchLockMetricAssignmentValuesGranularMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<BatchLockMetricAssignmentValuesGranularMutation, BatchLockMetricAssignmentValuesGranularMutationVariables>(BatchLockMetricAssignmentValuesGranularDocument, options);
}
export type BatchLockMetricAssignmentValuesGranularMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<BatchLockMetricAssignmentValuesGranularMutation, BatchLockMetricAssignmentValuesGranularMutationVariables>;
export const RecalculateComputedKpisInPortfolioDocument = gql`
    mutation recalculateComputedKpisInPortfolio($portfolioId: UUID!) {
  recalculateComputedKpisInPortfolio(portfolioId: $portfolioId)
}
    `;

/**
 * __useRecalculateComputedKpisInPortfolioMutation__
 *
 * To run a mutation, you first call `useRecalculateComputedKpisInPortfolioMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRecalculateComputedKpisInPortfolioMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRecalculateComputedKpisInPortfolioMutation({
 *   variables: {
 *     portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function useRecalculateComputedKpisInPortfolioMutation(options: VueApolloComposable.UseMutationOptions<RecalculateComputedKpisInPortfolioMutation, RecalculateComputedKpisInPortfolioMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RecalculateComputedKpisInPortfolioMutation, RecalculateComputedKpisInPortfolioMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RecalculateComputedKpisInPortfolioMutation, RecalculateComputedKpisInPortfolioMutationVariables>(RecalculateComputedKpisInPortfolioDocument, options);
}
export type RecalculateComputedKpisInPortfolioMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RecalculateComputedKpisInPortfolioMutation, RecalculateComputedKpisInPortfolioMutationVariables>;
export const AddQuestionnaireDocument = gql`
    mutation addQuestionnaire($ventureIds: [UUID!]!, $label: String, $sectionIds: [Int!], $periodId: Int, $referencePeriod: ReferencePeriodInput, $doSendNotification: Boolean) {
  addQuestionnaire(
    ventureIds: $ventureIds
    label: $label
    sectionIds: $sectionIds
    periodId: $periodId
    referencePeriod: $referencePeriod
    doSendNotification: $doSendNotification
  ) {
    updatedAt
    id
    ventureId
    label
    isEditable
  }
}
    `;

/**
 * __useAddQuestionnaireMutation__
 *
 * To run a mutation, you first call `useAddQuestionnaireMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddQuestionnaireMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddQuestionnaireMutation({
 *   variables: {
 *     ventureIds: // value for 'ventureIds'
 *     label: // value for 'label'
 *     sectionIds: // value for 'sectionIds'
 *     periodId: // value for 'periodId'
 *     referencePeriod: // value for 'referencePeriod'
 *     doSendNotification: // value for 'doSendNotification'
 *   },
 * });
 */
export function useAddQuestionnaireMutation(options: VueApolloComposable.UseMutationOptions<AddQuestionnaireMutation, AddQuestionnaireMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddQuestionnaireMutation, AddQuestionnaireMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddQuestionnaireMutation, AddQuestionnaireMutationVariables>(AddQuestionnaireDocument, options);
}
export type AddQuestionnaireMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddQuestionnaireMutation, AddQuestionnaireMutationVariables>;
export const AddTemplateTextDocument = gql`
    mutation addTemplateText($input: TemplateTextInput!) {
  addTemplateText(input: $input) {
    id
    text
    conds
    questionId
    ixId
  }
}
    `;

/**
 * __useAddTemplateTextMutation__
 *
 * To run a mutation, you first call `useAddTemplateTextMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddTemplateTextMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddTemplateTextMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddTemplateTextMutation(options: VueApolloComposable.UseMutationOptions<AddTemplateTextMutation, AddTemplateTextMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddTemplateTextMutation, AddTemplateTextMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddTemplateTextMutation, AddTemplateTextMutationVariables>(AddTemplateTextDocument, options);
}
export type AddTemplateTextMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddTemplateTextMutation, AddTemplateTextMutationVariables>;
export const CreateUserinputConceptLinkWithCustomSelectedConceptDocument = gql`
    mutation createUserinputConceptLinkWithCustomSelectedConcept($userInputId: Int!, $concept: ConceptInput!, $implementationStatus: ImplementationStatus, $parentConceptId: Int) {
  createUserinputConceptLinkWithCustomSelectedConcept(
    userInputId: $userInputId
    concept: $concept
    implementationStatus: $implementationStatus
    parentConceptId: $parentConceptId
  ) {
    ...CompleteUserInputConceptLink
  }
}
    ${CompleteUserInputConceptLinkFragmentDoc}`;

/**
 * __useCreateUserinputConceptLinkWithCustomSelectedConceptMutation__
 *
 * To run a mutation, you first call `useCreateUserinputConceptLinkWithCustomSelectedConceptMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserinputConceptLinkWithCustomSelectedConceptMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateUserinputConceptLinkWithCustomSelectedConceptMutation({
 *   variables: {
 *     userInputId: // value for 'userInputId'
 *     concept: // value for 'concept'
 *     implementationStatus: // value for 'implementationStatus'
 *     parentConceptId: // value for 'parentConceptId'
 *   },
 * });
 */
export function useCreateUserinputConceptLinkWithCustomSelectedConceptMutation(options: VueApolloComposable.UseMutationOptions<CreateUserinputConceptLinkWithCustomSelectedConceptMutation, CreateUserinputConceptLinkWithCustomSelectedConceptMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateUserinputConceptLinkWithCustomSelectedConceptMutation, CreateUserinputConceptLinkWithCustomSelectedConceptMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateUserinputConceptLinkWithCustomSelectedConceptMutation, CreateUserinputConceptLinkWithCustomSelectedConceptMutationVariables>(CreateUserinputConceptLinkWithCustomSelectedConceptDocument, options);
}
export type CreateUserinputConceptLinkWithCustomSelectedConceptMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateUserinputConceptLinkWithCustomSelectedConceptMutation, CreateUserinputConceptLinkWithCustomSelectedConceptMutationVariables>;
export const DeletePromptTemplateVersionDocument = gql`
    mutation deletePromptTemplateVersion($id: Int!) {
  deletePromptTemplateVersion(id: $id)
}
    `;

/**
 * __useDeletePromptTemplateVersionMutation__
 *
 * To run a mutation, you first call `useDeletePromptTemplateVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeletePromptTemplateVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeletePromptTemplateVersionMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeletePromptTemplateVersionMutation(options: VueApolloComposable.UseMutationOptions<DeletePromptTemplateVersionMutation, DeletePromptTemplateVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeletePromptTemplateVersionMutation, DeletePromptTemplateVersionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeletePromptTemplateVersionMutation, DeletePromptTemplateVersionMutationVariables>(DeletePromptTemplateVersionDocument, options);
}
export type DeletePromptTemplateVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeletePromptTemplateVersionMutation, DeletePromptTemplateVersionMutationVariables>;
export const DeleteQuestionnaireAndUserInputsDocument = gql`
    mutation deleteQuestionnaireAndUserInputs($questionnaireIds: [Int!]!) {
  deleteQuestionnaireAndUserInputs(questionnaireIds: $questionnaireIds)
}
    `;

/**
 * __useDeleteQuestionnaireAndUserInputsMutation__
 *
 * To run a mutation, you first call `useDeleteQuestionnaireAndUserInputsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuestionnaireAndUserInputsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteQuestionnaireAndUserInputsMutation({
 *   variables: {
 *     questionnaireIds: // value for 'questionnaireIds'
 *   },
 * });
 */
export function useDeleteQuestionnaireAndUserInputsMutation(options: VueApolloComposable.UseMutationOptions<DeleteQuestionnaireAndUserInputsMutation, DeleteQuestionnaireAndUserInputsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteQuestionnaireAndUserInputsMutation, DeleteQuestionnaireAndUserInputsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteQuestionnaireAndUserInputsMutation, DeleteQuestionnaireAndUserInputsMutationVariables>(DeleteQuestionnaireAndUserInputsDocument, options);
}
export type DeleteQuestionnaireAndUserInputsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteQuestionnaireAndUserInputsMutation, DeleteQuestionnaireAndUserInputsMutationVariables>;
export const DeleteTemplateTextDocument = gql`
    mutation deleteTemplateText($id: Int!) {
  deleteTemplateText(id: $id)
}
    `;

/**
 * __useDeleteTemplateTextMutation__
 *
 * To run a mutation, you first call `useDeleteTemplateTextMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplateTextMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteTemplateTextMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTemplateTextMutation(options: VueApolloComposable.UseMutationOptions<DeleteTemplateTextMutation, DeleteTemplateTextMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteTemplateTextMutation, DeleteTemplateTextMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteTemplateTextMutation, DeleteTemplateTextMutationVariables>(DeleteTemplateTextDocument, options);
}
export type DeleteTemplateTextMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteTemplateTextMutation, DeleteTemplateTextMutationVariables>;
export const SubmitQuestionnaireDocument = gql`
    mutation submitQuestionnaire($questionnaireId: Int!, $isEditable: Boolean!) {
  submitQuestionnaire(questionnaireId: $questionnaireId, isEditable: $isEditable) {
    ...QuestionnaireFragment
  }
}
    ${QuestionnaireFragmentFragmentDoc}`;

/**
 * __useSubmitQuestionnaireMutation__
 *
 * To run a mutation, you first call `useSubmitQuestionnaireMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSubmitQuestionnaireMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSubmitQuestionnaireMutation({
 *   variables: {
 *     questionnaireId: // value for 'questionnaireId'
 *     isEditable: // value for 'isEditable'
 *   },
 * });
 */
export function useSubmitQuestionnaireMutation(options: VueApolloComposable.UseMutationOptions<SubmitQuestionnaireMutation, SubmitQuestionnaireMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SubmitQuestionnaireMutation, SubmitQuestionnaireMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SubmitQuestionnaireMutation, SubmitQuestionnaireMutationVariables>(SubmitQuestionnaireDocument, options);
}
export type SubmitQuestionnaireMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SubmitQuestionnaireMutation, SubmitQuestionnaireMutationVariables>;
export const UnlinkSelectedConceptDocument = gql`
    mutation unlinkSelectedConcept($userInputId: Int!, $conceptId: Int!) {
  unlinkSelectedConcept(userInputId: $userInputId, conceptId: $conceptId) {
    ...CompleteUserInput
  }
}
    ${CompleteUserInputFragmentDoc}`;

/**
 * __useUnlinkSelectedConceptMutation__
 *
 * To run a mutation, you first call `useUnlinkSelectedConceptMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkSelectedConceptMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUnlinkSelectedConceptMutation({
 *   variables: {
 *     userInputId: // value for 'userInputId'
 *     conceptId: // value for 'conceptId'
 *   },
 * });
 */
export function useUnlinkSelectedConceptMutation(options: VueApolloComposable.UseMutationOptions<UnlinkSelectedConceptMutation, UnlinkSelectedConceptMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UnlinkSelectedConceptMutation, UnlinkSelectedConceptMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UnlinkSelectedConceptMutation, UnlinkSelectedConceptMutationVariables>(UnlinkSelectedConceptDocument, options);
}
export type UnlinkSelectedConceptMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UnlinkSelectedConceptMutation, UnlinkSelectedConceptMutationVariables>;
export const UpdateQuestionnaireDocument = gql`
    mutation updateQuestionnaire($input: QuestionnaireInput!) {
  updateQuestionnaire(input: $input) {
    id
    isEditable
  }
}
    `;

/**
 * __useUpdateQuestionnaireMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionnaireMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionnaireMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateQuestionnaireMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuestionnaireMutation(options: VueApolloComposable.UseMutationOptions<UpdateQuestionnaireMutation, UpdateQuestionnaireMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateQuestionnaireMutation, UpdateQuestionnaireMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateQuestionnaireMutation, UpdateQuestionnaireMutationVariables>(UpdateQuestionnaireDocument, options);
}
export type UpdateQuestionnaireMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateQuestionnaireMutation, UpdateQuestionnaireMutationVariables>;
export const UpdateConceptDocument = gql`
    mutation updateConcept($input: ConceptInput!) {
  updateConcept(input: $input) {
    ...CompleteConcept
  }
}
    ${CompleteConceptFragmentDoc}`;

/**
 * __useUpdateConceptMutation__
 *
 * To run a mutation, you first call `useUpdateConceptMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConceptMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateConceptMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateConceptMutation(options: VueApolloComposable.UseMutationOptions<UpdateConceptMutation, UpdateConceptMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateConceptMutation, UpdateConceptMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateConceptMutation, UpdateConceptMutationVariables>(UpdateConceptDocument, options);
}
export type UpdateConceptMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateConceptMutation, UpdateConceptMutationVariables>;
export const UpdateQuestionDocument = gql`
    mutation updateQuestion($input: QuestionInput!) {
  updateQuestion(input: $input) {
    ...CompleteQuestion
  }
}
    ${CompleteQuestionFragmentDoc}`;

/**
 * __useUpdateQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateQuestionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuestionMutation(options: VueApolloComposable.UseMutationOptions<UpdateQuestionMutation, UpdateQuestionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateQuestionMutation, UpdateQuestionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateQuestionMutation, UpdateQuestionMutationVariables>(UpdateQuestionDocument, options);
}
export type UpdateQuestionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateQuestionMutation, UpdateQuestionMutationVariables>;
export const UpdateQuestionSectionLinkDocument = gql`
    mutation updateQuestionSectionLink($input: QuestionSectionLinkInput!) {
  updateQuestionSectionLink(input: $input) {
    sort
    labelI18n
    sublabelI18n
    tooltipI18n
  }
}
    `;

/**
 * __useUpdateQuestionSectionLinkMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionSectionLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionSectionLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateQuestionSectionLinkMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuestionSectionLinkMutation(options: VueApolloComposable.UseMutationOptions<UpdateQuestionSectionLinkMutation, UpdateQuestionSectionLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateQuestionSectionLinkMutation, UpdateQuestionSectionLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateQuestionSectionLinkMutation, UpdateQuestionSectionLinkMutationVariables>(UpdateQuestionSectionLinkDocument, options);
}
export type UpdateQuestionSectionLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateQuestionSectionLinkMutation, UpdateQuestionSectionLinkMutationVariables>;
export const UpdateQuestionnaireNavigationDocument = gql`
    mutation updateQuestionnaireNavigation($input: QuestionnaireNavigationInput!) {
  updateQuestionnaireNavigation(input: $input) {
    id
    currentSection
    currentSubsection
  }
}
    `;

/**
 * __useUpdateQuestionnaireNavigationMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionnaireNavigationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionnaireNavigationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateQuestionnaireNavigationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuestionnaireNavigationMutation(options: VueApolloComposable.UseMutationOptions<UpdateQuestionnaireNavigationMutation, UpdateQuestionnaireNavigationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateQuestionnaireNavigationMutation, UpdateQuestionnaireNavigationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateQuestionnaireNavigationMutation, UpdateQuestionnaireNavigationMutationVariables>(UpdateQuestionnaireNavigationDocument, options);
}
export type UpdateQuestionnaireNavigationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateQuestionnaireNavigationMutation, UpdateQuestionnaireNavigationMutationVariables>;
export const UpdateSelectedConceptDocument = gql`
    mutation updateSelectedConcept($input: UserInputConceptLinkInput!) {
  updateSelectedConcept(input: $input) {
    ...CompleteUserInput
  }
}
    ${CompleteUserInputFragmentDoc}`;

/**
 * __useUpdateSelectedConceptMutation__
 *
 * To run a mutation, you first call `useUpdateSelectedConceptMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSelectedConceptMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSelectedConceptMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSelectedConceptMutation(options: VueApolloComposable.UseMutationOptions<UpdateSelectedConceptMutation, UpdateSelectedConceptMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateSelectedConceptMutation, UpdateSelectedConceptMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateSelectedConceptMutation, UpdateSelectedConceptMutationVariables>(UpdateSelectedConceptDocument, options);
}
export type UpdateSelectedConceptMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateSelectedConceptMutation, UpdateSelectedConceptMutationVariables>;
export const UpdateSelectedOptionsDocument = gql`
    mutation updateSelectedOptions($userInputId: Int!, $values: [Int]!) {
  updateSelectedOptions(userInputId: $userInputId, values: $values) {
    ...QuestionnaireFragment
  }
}
    ${QuestionnaireFragmentFragmentDoc}`;

/**
 * __useUpdateSelectedOptionsMutation__
 *
 * To run a mutation, you first call `useUpdateSelectedOptionsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSelectedOptionsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSelectedOptionsMutation({
 *   variables: {
 *     userInputId: // value for 'userInputId'
 *     values: // value for 'values'
 *   },
 * });
 */
export function useUpdateSelectedOptionsMutation(options: VueApolloComposable.UseMutationOptions<UpdateSelectedOptionsMutation, UpdateSelectedOptionsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateSelectedOptionsMutation, UpdateSelectedOptionsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateSelectedOptionsMutation, UpdateSelectedOptionsMutationVariables>(UpdateSelectedOptionsDocument, options);
}
export type UpdateSelectedOptionsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateSelectedOptionsMutation, UpdateSelectedOptionsMutationVariables>;
export const UpdateTemplateTextDocument = gql`
    mutation updateTemplateText($input: TemplateTextInput!) {
  updateTemplateText(input: $input) {
    id
    text
    conds
    questionId
    ixId
  }
}
    `;

/**
 * __useUpdateTemplateTextMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateTextMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateTextMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTemplateTextMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTemplateTextMutation(options: VueApolloComposable.UseMutationOptions<UpdateTemplateTextMutation, UpdateTemplateTextMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateTemplateTextMutation, UpdateTemplateTextMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateTemplateTextMutation, UpdateTemplateTextMutationVariables>(UpdateTemplateTextDocument, options);
}
export type UpdateTemplateTextMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateTemplateTextMutation, UpdateTemplateTextMutationVariables>;
export const UpdateTextDocument = gql`
    mutation updateText($userInputId: Int!, $text: String!) {
  updateText(userInputId: $userInputId, text: $text) {
    id
    userInputs {
      id
    }
  }
}
    `;

/**
 * __useUpdateTextMutation__
 *
 * To run a mutation, you first call `useUpdateTextMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTextMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTextMutation({
 *   variables: {
 *     userInputId: // value for 'userInputId'
 *     text: // value for 'text'
 *   },
 * });
 */
export function useUpdateTextMutation(options: VueApolloComposable.UseMutationOptions<UpdateTextMutation, UpdateTextMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateTextMutation, UpdateTextMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateTextMutation, UpdateTextMutationVariables>(UpdateTextDocument, options);
}
export type UpdateTextMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateTextMutation, UpdateTextMutationVariables>;
export const UpdateUserInputDocument = gql`
    mutation updateUserInput($input: UserInputInput!) {
  updateUserInput(input: $input) {
    ...QuestionnaireFragment
  }
}
    ${QuestionnaireFragmentFragmentDoc}`;

/**
 * __useUpdateUserInputMutation__
 *
 * To run a mutation, you first call `useUpdateUserInputMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserInputMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserInputMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserInputMutation(options: VueApolloComposable.UseMutationOptions<UpdateUserInputMutation, UpdateUserInputMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateUserInputMutation, UpdateUserInputMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateUserInputMutation, UpdateUserInputMutationVariables>(UpdateUserInputDocument, options);
}
export type UpdateUserInputMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateUserInputMutation, UpdateUserInputMutationVariables>;
export const UpsertEsgComparisonDocument = gql`
    mutation upsertEsgComparison($input: QuestionnaireComparisonInput!) {
  upsertEsgComparison(input: $input) {
    ...CompleteQuestionnaireComparison
  }
}
    ${CompleteQuestionnaireComparisonFragmentDoc}`;

/**
 * __useUpsertEsgComparisonMutation__
 *
 * To run a mutation, you first call `useUpsertEsgComparisonMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertEsgComparisonMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertEsgComparisonMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpsertEsgComparisonMutation(options: VueApolloComposable.UseMutationOptions<UpsertEsgComparisonMutation, UpsertEsgComparisonMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertEsgComparisonMutation, UpsertEsgComparisonMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertEsgComparisonMutation, UpsertEsgComparisonMutationVariables>(UpsertEsgComparisonDocument, options);
}
export type UpsertEsgComparisonMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertEsgComparisonMutation, UpsertEsgComparisonMutationVariables>;
export const UpsertOptionDocument = gql`
    mutation upsertOption($input: OptionInput!) {
  upsertOption(input: $input) {
    id
    labelI18n
    label
    sublabel
    tooltip
    ixId
  }
}
    `;

/**
 * __useUpsertOptionMutation__
 *
 * To run a mutation, you first call `useUpsertOptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertOptionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpsertOptionMutation(options: VueApolloComposable.UseMutationOptions<UpsertOptionMutation, UpsertOptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertOptionMutation, UpsertOptionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertOptionMutation, UpsertOptionMutationVariables>(UpsertOptionDocument, options);
}
export type UpsertOptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertOptionMutation, UpsertOptionMutationVariables>;
export const UpsertPromptTemplateDocument = gql`
    mutation upsertPromptTemplate($input: PromptTemplateInput!) {
  upsertPromptTemplate(input: $input) {
    ...PromptTemplate
  }
}
    ${PromptTemplateFragmentDoc}`;

/**
 * __useUpsertPromptTemplateMutation__
 *
 * To run a mutation, you first call `useUpsertPromptTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPromptTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertPromptTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPromptTemplateMutation(options: VueApolloComposable.UseMutationOptions<UpsertPromptTemplateMutation, UpsertPromptTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertPromptTemplateMutation, UpsertPromptTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertPromptTemplateMutation, UpsertPromptTemplateMutationVariables>(UpsertPromptTemplateDocument, options);
}
export type UpsertPromptTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertPromptTemplateMutation, UpsertPromptTemplateMutationVariables>;
export const UpsertPromptTemplateVersionDocument = gql`
    mutation upsertPromptTemplateVersion($input: PromptTemplateVersionInput!) {
  upsertPromptTemplateVersion(input: $input) {
    ...PromptTemplateVersion
  }
}
    ${PromptTemplateVersionFragmentDoc}`;

/**
 * __useUpsertPromptTemplateVersionMutation__
 *
 * To run a mutation, you first call `useUpsertPromptTemplateVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPromptTemplateVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertPromptTemplateVersionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPromptTemplateVersionMutation(options: VueApolloComposable.UseMutationOptions<UpsertPromptTemplateVersionMutation, UpsertPromptTemplateVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertPromptTemplateVersionMutation, UpsertPromptTemplateVersionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertPromptTemplateVersionMutation, UpsertPromptTemplateVersionMutationVariables>(UpsertPromptTemplateVersionDocument, options);
}
export type UpsertPromptTemplateVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertPromptTemplateVersionMutation, UpsertPromptTemplateVersionMutationVariables>;
export const DeleteReportingRequestDocument = gql`
    mutation deleteReportingRequest($id: UUID!) {
  deleteReportingRequest(id: $id)
}
    `;

/**
 * __useDeleteReportingRequestMutation__
 *
 * To run a mutation, you first call `useDeleteReportingRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportingRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteReportingRequestMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReportingRequestMutation(options: VueApolloComposable.UseMutationOptions<DeleteReportingRequestMutation, DeleteReportingRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteReportingRequestMutation, DeleteReportingRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteReportingRequestMutation, DeleteReportingRequestMutationVariables>(DeleteReportingRequestDocument, options);
}
export type DeleteReportingRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteReportingRequestMutation, DeleteReportingRequestMutationVariables>;
export const UpsertReportingRequestDocument = gql`
    mutation upsertReportingRequest($input: UpsertReportingRequestInput!) {
  upsertReportingRequest(input: $input) {
    id
    fundId
    requestType
    title
    description
    referencePeriod
    dueDate
    ventures {
      ventureId
      status
      metricIds
    }
  }
}
    `;

/**
 * __useUpsertReportingRequestMutation__
 *
 * To run a mutation, you first call `useUpsertReportingRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertReportingRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertReportingRequestMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpsertReportingRequestMutation(options: VueApolloComposable.UseMutationOptions<UpsertReportingRequestMutation, UpsertReportingRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertReportingRequestMutation, UpsertReportingRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertReportingRequestMutation, UpsertReportingRequestMutationVariables>(UpsertReportingRequestDocument, options);
}
export type UpsertReportingRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertReportingRequestMutation, UpsertReportingRequestMutationVariables>;
export const BatchSubmitReviewEventDocument = gql`
    mutation batchSubmitReviewEvent($input: BatchSubmitReviewEventInput!) {
  batchSubmitReviewEvent(input: $input) {
    successCount
    failureCount
    results {
      ventureId
      ok
      error
      event {
        id
        eventType
        comment
        createdAt
      }
    }
  }
}
    `;

/**
 * __useBatchSubmitReviewEventMutation__
 *
 * To run a mutation, you first call `useBatchSubmitReviewEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBatchSubmitReviewEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBatchSubmitReviewEventMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useBatchSubmitReviewEventMutation(options: VueApolloComposable.UseMutationOptions<BatchSubmitReviewEventMutation, BatchSubmitReviewEventMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<BatchSubmitReviewEventMutation, BatchSubmitReviewEventMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<BatchSubmitReviewEventMutation, BatchSubmitReviewEventMutationVariables>(BatchSubmitReviewEventDocument, options);
}
export type BatchSubmitReviewEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<BatchSubmitReviewEventMutation, BatchSubmitReviewEventMutationVariables>;
export const DeleteReviewRequestDocument = gql`
    mutation deleteReviewRequest($id: UUID!) {
  deleteReviewRequest(id: $id)
}
    `;

/**
 * __useDeleteReviewRequestMutation__
 *
 * To run a mutation, you first call `useDeleteReviewRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReviewRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteReviewRequestMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReviewRequestMutation(options: VueApolloComposable.UseMutationOptions<DeleteReviewRequestMutation, DeleteReviewRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteReviewRequestMutation, DeleteReviewRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteReviewRequestMutation, DeleteReviewRequestMutationVariables>(DeleteReviewRequestDocument, options);
}
export type DeleteReviewRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteReviewRequestMutation, DeleteReviewRequestMutationVariables>;
export const SubmitReviewEventDocument = gql`
    mutation submitReviewEvent($input: SubmitReviewEventInput!) {
  submitReviewEvent(input: $input) {
    id
    eventType
    comment
    createdAt
    snapshot
  }
}
    `;

/**
 * __useSubmitReviewEventMutation__
 *
 * To run a mutation, you first call `useSubmitReviewEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSubmitReviewEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSubmitReviewEventMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSubmitReviewEventMutation(options: VueApolloComposable.UseMutationOptions<SubmitReviewEventMutation, SubmitReviewEventMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SubmitReviewEventMutation, SubmitReviewEventMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SubmitReviewEventMutation, SubmitReviewEventMutationVariables>(SubmitReviewEventDocument, options);
}
export type SubmitReviewEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SubmitReviewEventMutation, SubmitReviewEventMutationVariables>;
export const UpsertReviewRequestDocument = gql`
    mutation upsertReviewRequest($input: UpsertReviewRequestInput!) {
  upsertReviewRequest(input: $input) {
    id
    title
    description
    assignedReviewers {
      id
      email
    }
    ventures {
      ventureId
      status
    }
  }
}
    `;

/**
 * __useUpsertReviewRequestMutation__
 *
 * To run a mutation, you first call `useUpsertReviewRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertReviewRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertReviewRequestMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpsertReviewRequestMutation(options: VueApolloComposable.UseMutationOptions<UpsertReviewRequestMutation, UpsertReviewRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertReviewRequestMutation, UpsertReviewRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertReviewRequestMutation, UpsertReviewRequestMutationVariables>(UpsertReviewRequestDocument, options);
}
export type UpsertReviewRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertReviewRequestMutation, UpsertReviewRequestMutationVariables>;
export const DelSectionDocument = gql`
    mutation DelSection($id: Int!) {
  delSection(id: $id)
}
    `;

/**
 * __useDelSectionMutation__
 *
 * To run a mutation, you first call `useDelSectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDelSectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDelSectionMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDelSectionMutation(options: VueApolloComposable.UseMutationOptions<DelSectionMutation, DelSectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DelSectionMutation, DelSectionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DelSectionMutation, DelSectionMutationVariables>(DelSectionDocument, options);
}
export type DelSectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DelSectionMutation, DelSectionMutationVariables>;
export const UpdateSectionDocument = gql`
    mutation UpdateSection($id: Int!, $input: SectionInput!) {
  updateSection(id: $id, input: $input) {
    id
    label
    labelI18n
    sort
    parentId
    parent {
      id
      label
    }
    taxonomyId
    taxonomy {
      id
      label
    }
    sectionKind
  }
}
    `;

/**
 * __useUpdateSectionMutation__
 *
 * To run a mutation, you first call `useUpdateSectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSectionMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSectionMutation(options: VueApolloComposable.UseMutationOptions<UpdateSectionMutation, UpdateSectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateSectionMutation, UpdateSectionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateSectionMutation, UpdateSectionMutationVariables>(UpdateSectionDocument, options);
}
export type UpdateSectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateSectionMutation, UpdateSectionMutationVariables>;
export const AddStakeholderDocument = gql`
    mutation AddStakeholder($stakeholder: StakeholderInput!, $activityId: UUID, $iroId: UUID) {
  addStakeholder(
    stakeholder: $stakeholder
    activityId: $activityId
    iroId: $iroId
  ) {
    id
    name
    type
    description
  }
}
    `;

/**
 * __useAddStakeholderMutation__
 *
 * To run a mutation, you first call `useAddStakeholderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddStakeholderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddStakeholderMutation({
 *   variables: {
 *     stakeholder: // value for 'stakeholder'
 *     activityId: // value for 'activityId'
 *     iroId: // value for 'iroId'
 *   },
 * });
 */
export function useAddStakeholderMutation(options: VueApolloComposable.UseMutationOptions<AddStakeholderMutation, AddStakeholderMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddStakeholderMutation, AddStakeholderMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddStakeholderMutation, AddStakeholderMutationVariables>(AddStakeholderDocument, options);
}
export type AddStakeholderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddStakeholderMutation, AddStakeholderMutationVariables>;
export const DelStakeholderDocument = gql`
    mutation delStakeholder($id: UUID!) {
  delStakeholder(id: $id)
}
    `;

/**
 * __useDelStakeholderMutation__
 *
 * To run a mutation, you first call `useDelStakeholderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDelStakeholderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDelStakeholderMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDelStakeholderMutation(options: VueApolloComposable.UseMutationOptions<DelStakeholderMutation, DelStakeholderMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DelStakeholderMutation, DelStakeholderMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DelStakeholderMutation, DelStakeholderMutationVariables>(DelStakeholderDocument, options);
}
export type DelStakeholderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DelStakeholderMutation, DelStakeholderMutationVariables>;
export const DelIroStakeholderLinkDocument = gql`
    mutation delIroStakeholderLink($iroId: UUID!, $stakeholderId: UUID!) {
  delIroStakeholderLink(iroId: $iroId, stakeholderId: $stakeholderId)
}
    `;

/**
 * __useDelIroStakeholderLinkMutation__
 *
 * To run a mutation, you first call `useDelIroStakeholderLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDelIroStakeholderLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDelIroStakeholderLinkMutation({
 *   variables: {
 *     iroId: // value for 'iroId'
 *     stakeholderId: // value for 'stakeholderId'
 *   },
 * });
 */
export function useDelIroStakeholderLinkMutation(options: VueApolloComposable.UseMutationOptions<DelIroStakeholderLinkMutation, DelIroStakeholderLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DelIroStakeholderLinkMutation, DelIroStakeholderLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DelIroStakeholderLinkMutation, DelIroStakeholderLinkMutationVariables>(DelIroStakeholderLinkDocument, options);
}
export type DelIroStakeholderLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DelIroStakeholderLinkMutation, DelIroStakeholderLinkMutationVariables>;
export const DelActivityStakeholderLinkDocument = gql`
    mutation delActivityStakeholderLink($activityId: UUID!, $stakeholderId: UUID!) {
  delActivityStakeholderLink(
    activityId: $activityId
    stakeholderId: $stakeholderId
  )
}
    `;

/**
 * __useDelActivityStakeholderLinkMutation__
 *
 * To run a mutation, you first call `useDelActivityStakeholderLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDelActivityStakeholderLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDelActivityStakeholderLinkMutation({
 *   variables: {
 *     activityId: // value for 'activityId'
 *     stakeholderId: // value for 'stakeholderId'
 *   },
 * });
 */
export function useDelActivityStakeholderLinkMutation(options: VueApolloComposable.UseMutationOptions<DelActivityStakeholderLinkMutation, DelActivityStakeholderLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DelActivityStakeholderLinkMutation, DelActivityStakeholderLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DelActivityStakeholderLinkMutation, DelActivityStakeholderLinkMutationVariables>(DelActivityStakeholderLinkDocument, options);
}
export type DelActivityStakeholderLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DelActivityStakeholderLinkMutation, DelActivityStakeholderLinkMutationVariables>;
export const UpdateStakeholderDocument = gql`
    mutation UpdateStakeholder($stakeholder: StakeholderInput!) {
  updateStakeholder(stakeholder: $stakeholder) {
    id
    name
    type
    description
  }
}
    `;

/**
 * __useUpdateStakeholderMutation__
 *
 * To run a mutation, you first call `useUpdateStakeholderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStakeholderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateStakeholderMutation({
 *   variables: {
 *     stakeholder: // value for 'stakeholder'
 *   },
 * });
 */
export function useUpdateStakeholderMutation(options: VueApolloComposable.UseMutationOptions<UpdateStakeholderMutation, UpdateStakeholderMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateStakeholderMutation, UpdateStakeholderMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateStakeholderMutation, UpdateStakeholderMutationVariables>(UpdateStakeholderDocument, options);
}
export type UpdateStakeholderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateStakeholderMutation, UpdateStakeholderMutationVariables>;
export const DeleteTaxonomyDocument = gql`
    mutation deleteTaxonomy($id: Int!) {
  deleteTaxonomy(id: $id)
}
    `;

/**
 * __useDeleteTaxonomyMutation__
 *
 * To run a mutation, you first call `useDeleteTaxonomyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaxonomyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteTaxonomyMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTaxonomyMutation(options: VueApolloComposable.UseMutationOptions<DeleteTaxonomyMutation, DeleteTaxonomyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteTaxonomyMutation, DeleteTaxonomyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteTaxonomyMutation, DeleteTaxonomyMutationVariables>(DeleteTaxonomyDocument, options);
}
export type DeleteTaxonomyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteTaxonomyMutation, DeleteTaxonomyMutationVariables>;
export const UpsertTaxonomyDocument = gql`
    mutation upsertTaxonomy($input: TaxonomyInput!) {
  upsertTaxonomy(input: $input) {
    id
    label
    shortLabel
    description
    version
    notionId
    sections {
      id
      label
    }
  }
}
    `;

/**
 * __useUpsertTaxonomyMutation__
 *
 * To run a mutation, you first call `useUpsertTaxonomyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTaxonomyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertTaxonomyMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpsertTaxonomyMutation(options: VueApolloComposable.UseMutationOptions<UpsertTaxonomyMutation, UpsertTaxonomyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertTaxonomyMutation, UpsertTaxonomyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertTaxonomyMutation, UpsertTaxonomyMutationVariables>(UpsertTaxonomyDocument, options);
}
export type UpsertTaxonomyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertTaxonomyMutation, UpsertTaxonomyMutationVariables>;
export const UpdateUserFeedbackDocument = gql`
    mutation UpdateUserFeedback($feedbackInput: UserFeedbackInput!) {
  updateUserFeedback(input: $feedbackInput) {
    id
    accountId
    conceptId
    insightId
    feedbackType
    additionalComments
    additionalData
  }
}
    `;

/**
 * __useUpdateUserFeedbackMutation__
 *
 * To run a mutation, you first call `useUpdateUserFeedbackMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserFeedbackMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserFeedbackMutation({
 *   variables: {
 *     feedbackInput: // value for 'feedbackInput'
 *   },
 * });
 */
export function useUpdateUserFeedbackMutation(options: VueApolloComposable.UseMutationOptions<UpdateUserFeedbackMutation, UpdateUserFeedbackMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateUserFeedbackMutation, UpdateUserFeedbackMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateUserFeedbackMutation, UpdateUserFeedbackMutationVariables>(UpdateUserFeedbackDocument, options);
}
export type UpdateUserFeedbackMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateUserFeedbackMutation, UpdateUserFeedbackMutationVariables>;
export const AcceptCompanyInviteDocument = gql`
    mutation acceptCompanyInvite($token: String!) {
  acceptCompanyInvite(token: $token) {
    success
    message
    accountId
  }
}
    `;

/**
 * __useAcceptCompanyInviteMutation__
 *
 * To run a mutation, you first call `useAcceptCompanyInviteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAcceptCompanyInviteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAcceptCompanyInviteMutation({
 *   variables: {
 *     token: // value for 'token'
 *   },
 * });
 */
export function useAcceptCompanyInviteMutation(options: VueApolloComposable.UseMutationOptions<AcceptCompanyInviteMutation, AcceptCompanyInviteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AcceptCompanyInviteMutation, AcceptCompanyInviteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AcceptCompanyInviteMutation, AcceptCompanyInviteMutationVariables>(AcceptCompanyInviteDocument, options);
}
export type AcceptCompanyInviteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AcceptCompanyInviteMutation, AcceptCompanyInviteMutationVariables>;
export const AddFeedbackDocument = gql`
    mutation AddFeedback($payload: FeedbackInput!) {
  addFeedback(payload: $payload)
}
    `;

/**
 * __useAddFeedbackMutation__
 *
 * To run a mutation, you first call `useAddFeedbackMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddFeedbackMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddFeedbackMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useAddFeedbackMutation(options: VueApolloComposable.UseMutationOptions<AddFeedbackMutation, AddFeedbackMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddFeedbackMutation, AddFeedbackMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddFeedbackMutation, AddFeedbackMutationVariables>(AddFeedbackDocument, options);
}
export type AddFeedbackMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddFeedbackMutation, AddFeedbackMutationVariables>;
export const AddUserDocument = gql`
    mutation AddUser($firstName: String!, $lastName: String!, $email: String!, $password: String!, $accountId: String!, $token: String!, $hasAcceptedPortfolioSharing: Boolean) {
  addUser(
    input: {firstName: $firstName, lastName: $lastName, email: $email, password: $password, accountId: $accountId, token: $token, hasAcceptedPortfolioSharing: $hasAcceptedPortfolioSharing}
  ) {
    firstName
    lastName
    email
  }
}
    `;

/**
 * __useAddUserMutation__
 *
 * To run a mutation, you first call `useAddUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddUserMutation({
 *   variables: {
 *     firstName: // value for 'firstName'
 *     lastName: // value for 'lastName'
 *     email: // value for 'email'
 *     password: // value for 'password'
 *     accountId: // value for 'accountId'
 *     token: // value for 'token'
 *     hasAcceptedPortfolioSharing: // value for 'hasAcceptedPortfolioSharing'
 *   },
 * });
 */
export function useAddUserMutation(options: VueApolloComposable.UseMutationOptions<AddUserMutation, AddUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddUserMutation, AddUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddUserMutation, AddUserMutationVariables>(AddUserDocument, options);
}
export type AddUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddUserMutation, AddUserMutationVariables>;
export const AddVentureAndUserDocument = gql`
    mutation AddVentureAndUser($firstName: String!, $lastName: String, $email: String!, $password: String!, $ventureName: String!, $impactGoalToken: String, $impactStrategy: Boolean, $hasAcceptedPortfolioSharing: Boolean, $esgToken: String, $metricsToken: String, $companyInfo: Boolean, $accountId: String!, $logo: String, $website: String) {
  addVentureAndUser(
    input: {firstName: $firstName, lastName: $lastName, email: $email, password: $password, ventureName: $ventureName, impactGoalToken: $impactGoalToken, impactStrategy: $impactStrategy, hasAcceptedPortfolioSharing: $hasAcceptedPortfolioSharing, esgToken: $esgToken, metricsToken: $metricsToken, companyInfo: $companyInfo, accountId: $accountId, logo: $logo, website: $website}
  ) {
    firstName
    lastName
    email
  }
}
    `;

/**
 * __useAddVentureAndUserMutation__
 *
 * To run a mutation, you first call `useAddVentureAndUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddVentureAndUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddVentureAndUserMutation({
 *   variables: {
 *     firstName: // value for 'firstName'
 *     lastName: // value for 'lastName'
 *     email: // value for 'email'
 *     password: // value for 'password'
 *     ventureName: // value for 'ventureName'
 *     impactGoalToken: // value for 'impactGoalToken'
 *     impactStrategy: // value for 'impactStrategy'
 *     hasAcceptedPortfolioSharing: // value for 'hasAcceptedPortfolioSharing'
 *     esgToken: // value for 'esgToken'
 *     metricsToken: // value for 'metricsToken'
 *     companyInfo: // value for 'companyInfo'
 *     accountId: // value for 'accountId'
 *     logo: // value for 'logo'
 *     website: // value for 'website'
 *   },
 * });
 */
export function useAddVentureAndUserMutation(options: VueApolloComposable.UseMutationOptions<AddVentureAndUserMutation, AddVentureAndUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddVentureAndUserMutation, AddVentureAndUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddVentureAndUserMutation, AddVentureAndUserMutationVariables>(AddVentureAndUserDocument, options);
}
export type AddVentureAndUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddVentureAndUserMutation, AddVentureAndUserMutationVariables>;
export const CreateVentureAccountAndInviteUserDocument = gql`
    mutation createVentureAccountAndInviteUser($ventureName: String!, $email: String, $logo: String, $website: String, $modules: [Module!]) {
  createVentureAccountAndInviteUser(
    email: $email
    ventureName: $ventureName
    logo: $logo
    website: $website
    modules: $modules
  ) {
    success
    message
    ventureId
  }
}
    `;

/**
 * __useCreateVentureAccountAndInviteUserMutation__
 *
 * To run a mutation, you first call `useCreateVentureAccountAndInviteUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateVentureAccountAndInviteUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateVentureAccountAndInviteUserMutation({
 *   variables: {
 *     ventureName: // value for 'ventureName'
 *     email: // value for 'email'
 *     logo: // value for 'logo'
 *     website: // value for 'website'
 *     modules: // value for 'modules'
 *   },
 * });
 */
export function useCreateVentureAccountAndInviteUserMutation(options: VueApolloComposable.UseMutationOptions<CreateVentureAccountAndInviteUserMutation, CreateVentureAccountAndInviteUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateVentureAccountAndInviteUserMutation, CreateVentureAccountAndInviteUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateVentureAccountAndInviteUserMutation, CreateVentureAccountAndInviteUserMutationVariables>(CreateVentureAccountAndInviteUserDocument, options);
}
export type CreateVentureAccountAndInviteUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateVentureAccountAndInviteUserMutation, CreateVentureAccountAndInviteUserMutationVariables>;
export const InviteUserDocument = gql`
    mutation InviteUser($ventureId: UUID!, $email: String!) {
  inviteUser(ventureId: $ventureId, email: $email) {
    success
    message
  }
}
    `;

/**
 * __useInviteUserMutation__
 *
 * To run a mutation, you first call `useInviteUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInviteUserMutation({
 *   variables: {
 *     ventureId: // value for 'ventureId'
 *     email: // value for 'email'
 *   },
 * });
 */
export function useInviteUserMutation(options: VueApolloComposable.UseMutationOptions<InviteUserMutation, InviteUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<InviteUserMutation, InviteUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument, options);
}
export type InviteUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<InviteUserMutation, InviteUserMutationVariables>;
export const SetIxAdminDocument = gql`
    mutation SetIxAdmin($userId: UUID!, $isIxAdmin: Boolean!) {
  setIxAdmin(userId: $userId, isIxAdmin: $isIxAdmin) {
    id
    isIxAdmin
    isAdmin
  }
}
    `;

/**
 * __useSetIxAdminMutation__
 *
 * To run a mutation, you first call `useSetIxAdminMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetIxAdminMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetIxAdminMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     isIxAdmin: // value for 'isIxAdmin'
 *   },
 * });
 */
export function useSetIxAdminMutation(options: VueApolloComposable.UseMutationOptions<SetIxAdminMutation, SetIxAdminMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetIxAdminMutation, SetIxAdminMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SetIxAdminMutation, SetIxAdminMutationVariables>(SetIxAdminDocument, options);
}
export type SetIxAdminMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetIxAdminMutation, SetIxAdminMutationVariables>;
export const UpdateRealUserDocument = gql`
    mutation UpdateRealUser($input: UpdateUserInput!) {
  updateRealUser(input: $input) {
    id
    firstName
    lastName
    email
    locale
  }
}
    `;

/**
 * __useUpdateRealUserMutation__
 *
 * To run a mutation, you first call `useUpdateRealUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRealUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateRealUserMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRealUserMutation(options: VueApolloComposable.UseMutationOptions<UpdateRealUserMutation, UpdateRealUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateRealUserMutation, UpdateRealUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateRealUserMutation, UpdateRealUserMutationVariables>(UpdateRealUserDocument, options);
}
export type UpdateRealUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateRealUserMutation, UpdateRealUserMutationVariables>;
export const AddValueChainDocument = gql`
    mutation AddValueChain($valueChain: ValueChainInput!) {
  addValueChain(valueChain: $valueChain) {
    id
    name
  }
}
    `;

/**
 * __useAddValueChainMutation__
 *
 * To run a mutation, you first call `useAddValueChainMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddValueChainMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddValueChainMutation({
 *   variables: {
 *     valueChain: // value for 'valueChain'
 *   },
 * });
 */
export function useAddValueChainMutation(options: VueApolloComposable.UseMutationOptions<AddValueChainMutation, AddValueChainMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddValueChainMutation, AddValueChainMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddValueChainMutation, AddValueChainMutationVariables>(AddValueChainDocument, options);
}
export type AddValueChainMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddValueChainMutation, AddValueChainMutationVariables>;
export const DeleteValueChainDocument = gql`
    mutation DeleteValueChain($id: UUID!) {
  deleteValueChain(id: $id)
}
    `;

/**
 * __useDeleteValueChainMutation__
 *
 * To run a mutation, you first call `useDeleteValueChainMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteValueChainMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteValueChainMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteValueChainMutation(options: VueApolloComposable.UseMutationOptions<DeleteValueChainMutation, DeleteValueChainMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteValueChainMutation, DeleteValueChainMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteValueChainMutation, DeleteValueChainMutationVariables>(DeleteValueChainDocument, options);
}
export type DeleteValueChainMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteValueChainMutation, DeleteValueChainMutationVariables>;
export const ListValueChainsDocument = gql`
    query ListValueChains($search: String, $limit: Int, $offset: Int) {
  listValueChains(search: $search, limit: $limit, offset: $offset) {
    id
    name
    activities {
      id
      name
      type
      geographyId
      location
      sortOrder
      riskProfile
      IROs {
        id
        type
        name
      }
    }
  }
}
    `;

/**
 * __useListValueChainsQuery__
 *
 * To run a query within a Vue component, call `useListValueChainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListValueChainsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListValueChainsQuery({
 *   search: // value for 'search'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 * });
 */
export function useListValueChainsQuery(variables: ListValueChainsQueryVariables | VueCompositionApi.Ref<ListValueChainsQueryVariables> | ReactiveFunction<ListValueChainsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListValueChainsQuery, ListValueChainsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListValueChainsQuery, ListValueChainsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListValueChainsQuery, ListValueChainsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListValueChainsQuery, ListValueChainsQueryVariables>(ListValueChainsDocument, variables, options);
}
export function useListValueChainsLazyQuery(variables: ListValueChainsQueryVariables | VueCompositionApi.Ref<ListValueChainsQueryVariables> | ReactiveFunction<ListValueChainsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListValueChainsQuery, ListValueChainsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListValueChainsQuery, ListValueChainsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListValueChainsQuery, ListValueChainsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListValueChainsQuery, ListValueChainsQueryVariables>(ListValueChainsDocument, variables, options);
}
export type ListValueChainsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListValueChainsQuery, ListValueChainsQueryVariables>;
export const UpdateValueChainDocument = gql`
    mutation UpdateValueChain($valueChain: ValueChainInput!) {
  updateValueChain(valueChain: $valueChain) {
    id
    name
  }
}
    `;

/**
 * __useUpdateValueChainMutation__
 *
 * To run a mutation, you first call `useUpdateValueChainMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateValueChainMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateValueChainMutation({
 *   variables: {
 *     valueChain: // value for 'valueChain'
 *   },
 * });
 */
export function useUpdateValueChainMutation(options: VueApolloComposable.UseMutationOptions<UpdateValueChainMutation, UpdateValueChainMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateValueChainMutation, UpdateValueChainMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateValueChainMutation, UpdateValueChainMutationVariables>(UpdateValueChainDocument, options);
}
export type UpdateValueChainMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateValueChainMutation, UpdateValueChainMutationVariables>;
export const AddQuestionnaireSectionLinkDocument = gql`
    mutation AddQuestionnaireSectionLink($questionnaireId: Int!, $sectionId: Int!) {
  addQuestionnaireSectionLink(
    questionnaireId: $questionnaireId
    sectionId: $sectionId
  )
}
    `;

/**
 * __useAddQuestionnaireSectionLinkMutation__
 *
 * To run a mutation, you first call `useAddQuestionnaireSectionLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddQuestionnaireSectionLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddQuestionnaireSectionLinkMutation({
 *   variables: {
 *     questionnaireId: // value for 'questionnaireId'
 *     sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function useAddQuestionnaireSectionLinkMutation(options: VueApolloComposable.UseMutationOptions<AddQuestionnaireSectionLinkMutation, AddQuestionnaireSectionLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddQuestionnaireSectionLinkMutation, AddQuestionnaireSectionLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddQuestionnaireSectionLinkMutation, AddQuestionnaireSectionLinkMutationVariables>(AddQuestionnaireSectionLinkDocument, options);
}
export type AddQuestionnaireSectionLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddQuestionnaireSectionLinkMutation, AddQuestionnaireSectionLinkMutationVariables>;
export const AddSectionDocument = gql`
    mutation AddSection($input: SectionInput!) {
  addSection(input: $input) {
    label
    description
    id
    externalId
    ixId
    sort
    labelI18n
    descriptionI18n
    taxonomyId
  }
}
    `;

/**
 * __useAddSectionMutation__
 *
 * To run a mutation, you first call `useAddSectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddSectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddSectionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddSectionMutation(options: VueApolloComposable.UseMutationOptions<AddSectionMutation, AddSectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddSectionMutation, AddSectionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddSectionMutation, AddSectionMutationVariables>(AddSectionDocument, options);
}
export type AddSectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddSectionMutation, AddSectionMutationVariables>;
export const DelQuestionnaireSectionLinkDocument = gql`
    mutation DelQuestionnaireSectionLink($questionnaireId: Int!, $sectionId: Int!) {
  delQuestionnaireSectionLink(
    questionnaireId: $questionnaireId
    sectionId: $sectionId
  )
}
    `;

/**
 * __useDelQuestionnaireSectionLinkMutation__
 *
 * To run a mutation, you first call `useDelQuestionnaireSectionLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDelQuestionnaireSectionLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDelQuestionnaireSectionLinkMutation({
 *   variables: {
 *     questionnaireId: // value for 'questionnaireId'
 *     sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function useDelQuestionnaireSectionLinkMutation(options: VueApolloComposable.UseMutationOptions<DelQuestionnaireSectionLinkMutation, DelQuestionnaireSectionLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DelQuestionnaireSectionLinkMutation, DelQuestionnaireSectionLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DelQuestionnaireSectionLinkMutation, DelQuestionnaireSectionLinkMutationVariables>(DelQuestionnaireSectionLinkDocument, options);
}
export type DelQuestionnaireSectionLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DelQuestionnaireSectionLinkMutation, DelQuestionnaireSectionLinkMutationVariables>;
export const GetDisclosureSummaryDocument = gql`
    query getDisclosureSummary($fundId: Int!, $reportType: ReportType!, $referencePeriod: Int!) {
  getDisclosureSummary(
    fundId: $fundId
    reportType: $reportType
    referencePeriod: $referencePeriod
  ) {
    summary
  }
}
    `;

/**
 * __useGetDisclosureSummaryQuery__
 *
 * To run a query within a Vue component, call `useGetDisclosureSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisclosureSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDisclosureSummaryQuery({
 *   fundId: // value for 'fundId'
 *   reportType: // value for 'reportType'
 *   referencePeriod: // value for 'referencePeriod'
 * });
 */
export function useGetDisclosureSummaryQuery(variables: GetDisclosureSummaryQueryVariables | VueCompositionApi.Ref<GetDisclosureSummaryQueryVariables> | ReactiveFunction<GetDisclosureSummaryQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetDisclosureSummaryQuery, GetDisclosureSummaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetDisclosureSummaryQuery, GetDisclosureSummaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetDisclosureSummaryQuery, GetDisclosureSummaryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetDisclosureSummaryQuery, GetDisclosureSummaryQueryVariables>(GetDisclosureSummaryDocument, variables, options);
}
export function useGetDisclosureSummaryLazyQuery(variables: GetDisclosureSummaryQueryVariables | VueCompositionApi.Ref<GetDisclosureSummaryQueryVariables> | ReactiveFunction<GetDisclosureSummaryQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetDisclosureSummaryQuery, GetDisclosureSummaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetDisclosureSummaryQuery, GetDisclosureSummaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetDisclosureSummaryQuery, GetDisclosureSummaryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetDisclosureSummaryQuery, GetDisclosureSummaryQueryVariables>(GetDisclosureSummaryDocument, variables, options);
}
export type GetDisclosureSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetDisclosureSummaryQuery, GetDisclosureSummaryQueryVariables>;
export const GetMetricAggregationDocument = gql`
    query getMetricAggregation($id: Int!) {
  getMetricAggregation(id: $id) {
    ...CompleteMetricAggregation
  }
}
    ${CompleteMetricAggregationFragmentDoc}`;

/**
 * __useGetMetricAggregationQuery__
 *
 * To run a query within a Vue component, call `useGetMetricAggregationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricAggregationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMetricAggregationQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetMetricAggregationQuery(variables: GetMetricAggregationQueryVariables | VueCompositionApi.Ref<GetMetricAggregationQueryVariables> | ReactiveFunction<GetMetricAggregationQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMetricAggregationQuery, GetMetricAggregationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMetricAggregationQuery, GetMetricAggregationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMetricAggregationQuery, GetMetricAggregationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMetricAggregationQuery, GetMetricAggregationQueryVariables>(GetMetricAggregationDocument, variables, options);
}
export function useGetMetricAggregationLazyQuery(variables: GetMetricAggregationQueryVariables | VueCompositionApi.Ref<GetMetricAggregationQueryVariables> | ReactiveFunction<GetMetricAggregationQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMetricAggregationQuery, GetMetricAggregationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMetricAggregationQuery, GetMetricAggregationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMetricAggregationQuery, GetMetricAggregationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMetricAggregationQuery, GetMetricAggregationQueryVariables>(GetMetricAggregationDocument, variables, options);
}
export type GetMetricAggregationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMetricAggregationQuery, GetMetricAggregationQueryVariables>;
export const GetSectionDocument = gql`
    query GetSection($id: Int!) {
  getSection(id: $id) {
    id
    label
    labelI18n
    sublabelI18n
    sort
    parentId
    parent {
      id
      label
    }
    taxonomyId
    taxonomy {
      id
      label
    }
    sectionKind
    sections {
      id
      label
      labelI18n
      sort
      taxonomyId
      parentId
      taxonomy {
        id
        label
      }
      questions {
        id
        label
        sublabel
        tooltip
        scoringRules
        isMultiple
        isMandatory
        createdAt
        updatedAt
      }
      sections {
        id
        label
        labelI18n
        sort
        taxonomyId
        parentId
        taxonomy {
          id
          label
        }
        sections {
          id
          label
          labelI18n
          sort
          taxonomyId
          parentId
          taxonomy {
            id
            label
          }
          sections {
            id
            label
            labelI18n
            sort
            taxonomyId
            parentId
            taxonomy {
              id
              label
            }
            sections {
              id
              label
              labelI18n
              sort
              taxonomyId
              parentId
              taxonomy {
                id
                label
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSectionQuery__
 *
 * To run a query within a Vue component, call `useGetSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSectionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSectionQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetSectionQuery(variables: GetSectionQueryVariables | VueCompositionApi.Ref<GetSectionQueryVariables> | ReactiveFunction<GetSectionQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetSectionQuery, GetSectionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSectionQuery, GetSectionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSectionQuery, GetSectionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetSectionQuery, GetSectionQueryVariables>(GetSectionDocument, variables, options);
}
export function useGetSectionLazyQuery(variables: GetSectionQueryVariables | VueCompositionApi.Ref<GetSectionQueryVariables> | ReactiveFunction<GetSectionQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetSectionQuery, GetSectionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSectionQuery, GetSectionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSectionQuery, GetSectionQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetSectionQuery, GetSectionQueryVariables>(GetSectionDocument, variables, options);
}
export type GetSectionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetSectionQuery, GetSectionQueryVariables>;
export const GetTeamMemberLinkDocument = gql`
    query getTeamMemberLink($id: UUID!, $role: AccountMembershipRole) {
  getTeamMemberLink(id: $id, role: $role)
}
    `;

/**
 * __useGetTeamMemberLinkQuery__
 *
 * To run a query within a Vue component, call `useGetTeamMemberLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamMemberLinkQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTeamMemberLinkQuery({
 *   id: // value for 'id'
 *   role: // value for 'role'
 * });
 */
export function useGetTeamMemberLinkQuery(variables: GetTeamMemberLinkQueryVariables | VueCompositionApi.Ref<GetTeamMemberLinkQueryVariables> | ReactiveFunction<GetTeamMemberLinkQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTeamMemberLinkQuery, GetTeamMemberLinkQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTeamMemberLinkQuery, GetTeamMemberLinkQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTeamMemberLinkQuery, GetTeamMemberLinkQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTeamMemberLinkQuery, GetTeamMemberLinkQueryVariables>(GetTeamMemberLinkDocument, variables, options);
}
export function useGetTeamMemberLinkLazyQuery(variables: GetTeamMemberLinkQueryVariables | VueCompositionApi.Ref<GetTeamMemberLinkQueryVariables> | ReactiveFunction<GetTeamMemberLinkQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTeamMemberLinkQuery, GetTeamMemberLinkQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTeamMemberLinkQuery, GetTeamMemberLinkQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTeamMemberLinkQuery, GetTeamMemberLinkQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTeamMemberLinkQuery, GetTeamMemberLinkQueryVariables>(GetTeamMemberLinkDocument, variables, options);
}
export type GetTeamMemberLinkQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTeamMemberLinkQuery, GetTeamMemberLinkQueryVariables>;
export const ListIroSectionLinksDocument = gql`
    query ListIroSectionLinks($iroId: UUID!, $limit: Int, $offset: Int) {
  listIroSectionLinks(iroId: $iroId, limit: $limit, offset: $offset) {
    id
    iroId
    iro {
      id
      name
    }
    sectionId
    section {
      id
      label
    }
  }
  countIroSectionLinks(iroId: $iroId)
}
    `;

/**
 * __useListIroSectionLinksQuery__
 *
 * To run a query within a Vue component, call `useListIroSectionLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListIroSectionLinksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListIroSectionLinksQuery({
 *   iroId: // value for 'iroId'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 * });
 */
export function useListIroSectionLinksQuery(variables: ListIroSectionLinksQueryVariables | VueCompositionApi.Ref<ListIroSectionLinksQueryVariables> | ReactiveFunction<ListIroSectionLinksQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListIroSectionLinksQuery, ListIroSectionLinksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListIroSectionLinksQuery, ListIroSectionLinksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListIroSectionLinksQuery, ListIroSectionLinksQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListIroSectionLinksQuery, ListIroSectionLinksQueryVariables>(ListIroSectionLinksDocument, variables, options);
}
export function useListIroSectionLinksLazyQuery(variables: ListIroSectionLinksQueryVariables | VueCompositionApi.Ref<ListIroSectionLinksQueryVariables> | ReactiveFunction<ListIroSectionLinksQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListIroSectionLinksQuery, ListIroSectionLinksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListIroSectionLinksQuery, ListIroSectionLinksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListIroSectionLinksQuery, ListIroSectionLinksQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListIroSectionLinksQuery, ListIroSectionLinksQueryVariables>(ListIroSectionLinksDocument, variables, options);
}
export type ListIroSectionLinksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListIroSectionLinksQuery, ListIroSectionLinksQueryVariables>;
export const ListIroStakeholderLinksDocument = gql`
    query ListIroStakeholderLinks($iroId: UUID!, $limit: Int, $offset: Int) {
  listIroStakeholderLinks(iroId: $iroId, limit: $limit, offset: $offset) {
    id
    iroId
    iro {
      id
      name
    }
    stakeholderId
    stakeholder {
      id
      name
      type
      description
    }
    impactMaterial
    financialMaterial
    howAffected
    relationToRo
  }
  countIroStakeholderLinks(iroId: $iroId)
}
    `;

/**
 * __useListIroStakeholderLinksQuery__
 *
 * To run a query within a Vue component, call `useListIroStakeholderLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListIroStakeholderLinksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListIroStakeholderLinksQuery({
 *   iroId: // value for 'iroId'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 * });
 */
export function useListIroStakeholderLinksQuery(variables: ListIroStakeholderLinksQueryVariables | VueCompositionApi.Ref<ListIroStakeholderLinksQueryVariables> | ReactiveFunction<ListIroStakeholderLinksQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListIroStakeholderLinksQuery, ListIroStakeholderLinksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListIroStakeholderLinksQuery, ListIroStakeholderLinksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListIroStakeholderLinksQuery, ListIroStakeholderLinksQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListIroStakeholderLinksQuery, ListIroStakeholderLinksQueryVariables>(ListIroStakeholderLinksDocument, variables, options);
}
export function useListIroStakeholderLinksLazyQuery(variables: ListIroStakeholderLinksQueryVariables | VueCompositionApi.Ref<ListIroStakeholderLinksQueryVariables> | ReactiveFunction<ListIroStakeholderLinksQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListIroStakeholderLinksQuery, ListIroStakeholderLinksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListIroStakeholderLinksQuery, ListIroStakeholderLinksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListIroStakeholderLinksQuery, ListIroStakeholderLinksQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListIroStakeholderLinksQuery, ListIroStakeholderLinksQueryVariables>(ListIroStakeholderLinksDocument, variables, options);
}
export type ListIroStakeholderLinksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListIroStakeholderLinksQuery, ListIroStakeholderLinksQueryVariables>;
export const GetIroDocument = gql`
    query getIro($id: UUID!) {
  getIro(id: $id) {
    id
    name
    type
    description
    accountId
    activityId
    activity {
      valueChainId
      name
      geographyId
    }
    levelOfImpact
    likelihood
    likelihoodReason
    finalSeverity
    severity
    severityReason
    scale
    scope
    irremediability
    finalAssessmentReason
    overrideStatus
    overrideReason
    status
    magnitude
    magnitudeReason
  }
}
    `;

/**
 * __useGetIroQuery__
 *
 * To run a query within a Vue component, call `useGetIroQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIroQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetIroQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetIroQuery(variables: GetIroQueryVariables | VueCompositionApi.Ref<GetIroQueryVariables> | ReactiveFunction<GetIroQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetIroQuery, GetIroQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetIroQuery, GetIroQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetIroQuery, GetIroQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetIroQuery, GetIroQueryVariables>(GetIroDocument, variables, options);
}
export function useGetIroLazyQuery(variables: GetIroQueryVariables | VueCompositionApi.Ref<GetIroQueryVariables> | ReactiveFunction<GetIroQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetIroQuery, GetIroQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetIroQuery, GetIroQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetIroQuery, GetIroQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetIroQuery, GetIroQueryVariables>(GetIroDocument, variables, options);
}
export type GetIroQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetIroQuery, GetIroQueryVariables>;
export const ListIrosDocument = gql`
    query ListIros($input: IroQueryInput, $limit: Int, $offset: Int) {
  listIros(input: $input, limit: $limit, offset: $offset) {
    id
    name
    type
    activity {
      id
      name
      type
      geographyId
    }
    type
    description
    accountId
    activityId
    likelihood
    magnitude
    severity
    finalSeverity
    scale
    scope
    irremediability
    levelOfImpact
    status
    overrideStatus
    stakeholderLinks {
      stakeholder {
        id
        name
        type
      }
    }
    sectionLinks {
      section {
        id
        label
        parent {
          id
          label
          parent {
            id
            label
          }
        }
      }
    }
  }
  countIros(input: $input)
}
    `;

/**
 * __useListIrosQuery__
 *
 * To run a query within a Vue component, call `useListIrosQuery` and pass it any options that fit your needs.
 * When your component renders, `useListIrosQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListIrosQuery({
 *   input: // value for 'input'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 * });
 */
export function useListIrosQuery(variables: ListIrosQueryVariables | VueCompositionApi.Ref<ListIrosQueryVariables> | ReactiveFunction<ListIrosQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListIrosQuery, ListIrosQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListIrosQuery, ListIrosQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListIrosQuery, ListIrosQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListIrosQuery, ListIrosQueryVariables>(ListIrosDocument, variables, options);
}
export function useListIrosLazyQuery(variables: ListIrosQueryVariables | VueCompositionApi.Ref<ListIrosQueryVariables> | ReactiveFunction<ListIrosQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListIrosQuery, ListIrosQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListIrosQuery, ListIrosQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListIrosQuery, ListIrosQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListIrosQuery, ListIrosQueryVariables>(ListIrosDocument, variables, options);
}
export type ListIrosQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListIrosQuery, ListIrosQueryVariables>;
export const UpdateAllIroStatusesDocument = gql`
    query updateAllIroStatuses {
  updateAllIroStatuses {
    id
    baseStatus
    newStatus
  }
}
    `;

/**
 * __useUpdateAllIroStatusesQuery__
 *
 * To run a query within a Vue component, call `useUpdateAllIroStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllIroStatusesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUpdateAllIroStatusesQuery();
 */
export function useUpdateAllIroStatusesQuery(options: VueApolloComposable.UseQueryOptions<UpdateAllIroStatusesQuery, UpdateAllIroStatusesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UpdateAllIroStatusesQuery, UpdateAllIroStatusesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UpdateAllIroStatusesQuery, UpdateAllIroStatusesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UpdateAllIroStatusesQuery, UpdateAllIroStatusesQueryVariables>(UpdateAllIroStatusesDocument, {}, options);
}
export function useUpdateAllIroStatusesLazyQuery(options: VueApolloComposable.UseQueryOptions<UpdateAllIroStatusesQuery, UpdateAllIroStatusesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UpdateAllIroStatusesQuery, UpdateAllIroStatusesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UpdateAllIroStatusesQuery, UpdateAllIroStatusesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UpdateAllIroStatusesQuery, UpdateAllIroStatusesQueryVariables>(UpdateAllIroStatusesDocument, {}, options);
}
export type UpdateAllIroStatusesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UpdateAllIroStatusesQuery, UpdateAllIroStatusesQueryVariables>;
export const ListAuditLogsDocument = gql`
    query listAuditLogs($tableName: [String!], $operationType: [String!], $createdById: [UUID!], $dataId: UUID, $offset: Int, $limit: Int, $excludeSystemUser: Boolean) {
  listAuditLogs(
    tableName: $tableName
    operationType: $operationType
    createdById: $createdById
    dataId: $dataId
    offset: $offset
    limit: $limit
    excludeSystemUser: $excludeSystemUser
  ) {
    id
    tableName
    operationType
    dataId
    originalData
    newData
    createdAt
    context
    createdBy {
      email
      firstName
      lastName
      isAdmin
    }
  }
  countAuditLogs(
    tableName: $tableName
    dataId: $dataId
    operationType: $operationType
    createdById: $createdById
  )
}
    `;

/**
 * __useListAuditLogsQuery__
 *
 * To run a query within a Vue component, call `useListAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAuditLogsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListAuditLogsQuery({
 *   tableName: // value for 'tableName'
 *   operationType: // value for 'operationType'
 *   createdById: // value for 'createdById'
 *   dataId: // value for 'dataId'
 *   offset: // value for 'offset'
 *   limit: // value for 'limit'
 *   excludeSystemUser: // value for 'excludeSystemUser'
 * });
 */
export function useListAuditLogsQuery(variables: ListAuditLogsQueryVariables | VueCompositionApi.Ref<ListAuditLogsQueryVariables> | ReactiveFunction<ListAuditLogsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListAuditLogsQuery, ListAuditLogsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListAuditLogsQuery, ListAuditLogsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListAuditLogsQuery, ListAuditLogsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListAuditLogsQuery, ListAuditLogsQueryVariables>(ListAuditLogsDocument, variables, options);
}
export function useListAuditLogsLazyQuery(variables: ListAuditLogsQueryVariables | VueCompositionApi.Ref<ListAuditLogsQueryVariables> | ReactiveFunction<ListAuditLogsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListAuditLogsQuery, ListAuditLogsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListAuditLogsQuery, ListAuditLogsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListAuditLogsQuery, ListAuditLogsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListAuditLogsQuery, ListAuditLogsQueryVariables>(ListAuditLogsDocument, variables, options);
}
export type ListAuditLogsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListAuditLogsQuery, ListAuditLogsQueryVariables>;
export const ListEsrsSectionsDocument = gql`
    query ListEsrsSections($filters: SectionFiltersInput, $limit: Int, $offset: Int) {
  listSections(filters: $filters, limit: $limit, offset: $offset) {
    id
    label
    labelI18n
    sort
    taxonomyId
    taxonomy {
      id
      label
    }
    sections {
      id
      label
      labelI18n
      sort
      taxonomyId
      taxonomy {
        id
        label
      }
      sections {
        id
        label
        labelI18n
        sort
        taxonomyId
        taxonomy {
          id
          label
        }
        sections {
          id
          label
          labelI18n
          sort
          taxonomyId
          taxonomy {
            id
            label
          }
          sections {
            id
            label
            labelI18n
            sort
            taxonomyId
            taxonomy {
              id
              label
            }
            sections {
              id
              label
              labelI18n
              sort
              taxonomyId
              taxonomy {
                id
                label
              }
              iroLinks {
                ...IroLink
              }
              accountLinks {
                ...AccountLink
              }
            }
          }
        }
        iroLinks {
          ...IroLink
        }
        accountLinks {
          ...AccountLink
        }
      }
      iroLinks {
        ...IroLink
      }
      accountLinks {
        ...AccountLink
      }
    }
  }
  countSections(filters: $filters)
}
    ${IroLinkFragmentDoc}
${AccountLinkFragmentDoc}`;

/**
 * __useListEsrsSectionsQuery__
 *
 * To run a query within a Vue component, call `useListEsrsSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEsrsSectionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListEsrsSectionsQuery({
 *   filters: // value for 'filters'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 * });
 */
export function useListEsrsSectionsQuery(variables: ListEsrsSectionsQueryVariables | VueCompositionApi.Ref<ListEsrsSectionsQueryVariables> | ReactiveFunction<ListEsrsSectionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListEsrsSectionsQuery, ListEsrsSectionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListEsrsSectionsQuery, ListEsrsSectionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListEsrsSectionsQuery, ListEsrsSectionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListEsrsSectionsQuery, ListEsrsSectionsQueryVariables>(ListEsrsSectionsDocument, variables, options);
}
export function useListEsrsSectionsLazyQuery(variables: ListEsrsSectionsQueryVariables | VueCompositionApi.Ref<ListEsrsSectionsQueryVariables> | ReactiveFunction<ListEsrsSectionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListEsrsSectionsQuery, ListEsrsSectionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListEsrsSectionsQuery, ListEsrsSectionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListEsrsSectionsQuery, ListEsrsSectionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListEsrsSectionsQuery, ListEsrsSectionsQueryVariables>(ListEsrsSectionsDocument, variables, options);
}
export type ListEsrsSectionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListEsrsSectionsQuery, ListEsrsSectionsQueryVariables>;
export const ListMetricAggregationsDocument = gql`
    query listMetricAggregations($keyword: String, $ids: [Int!], $metricIds: [Int!], $categoryIds: [Int!], $includeUncategorized: Boolean, $sectionIds: [Int!], $offset: Int, $limit: Int, $sort: [SortParam!], $fundId: Int, $isPaiResultsView: Boolean) {
  listMetricAggregations(
    keyword: $keyword
    ids: $ids
    metricIds: $metricIds
    categoryIds: $categoryIds
    includeUncategorized: $includeUncategorized
    sectionIds: $sectionIds
    offset: $offset
    limit: $limit
    sort: $sort
    fundId: $fundId
    isPaiResultsView: $isPaiResultsView
  ) {
    ...BasicMetricAggregation
  }
  countMetricAggregations(
    keyword: $keyword
    ids: $ids
    metricIds: $metricIds
    categoryIds: $categoryIds
    includeUncategorized: $includeUncategorized
    sectionIds: $sectionIds
    fundId: $fundId
    isPaiResultsView: $isPaiResultsView
  )
  listMetricAggregationCategoryCounts(
    keyword: $keyword
    ids: $ids
    metricIds: $metricIds
    fundId: $fundId
    isPaiResultsView: $isPaiResultsView
  ) {
    categoryId
    count
  }
  listMetricAggregationSectionCounts(
    keyword: $keyword
    ids: $ids
    metricIds: $metricIds
    fundId: $fundId
    isPaiResultsView: $isPaiResultsView
  ) {
    sectionId
    count
  }
}
    ${BasicMetricAggregationFragmentDoc}`;

/**
 * __useListMetricAggregationsQuery__
 *
 * To run a query within a Vue component, call `useListMetricAggregationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMetricAggregationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListMetricAggregationsQuery({
 *   keyword: // value for 'keyword'
 *   ids: // value for 'ids'
 *   metricIds: // value for 'metricIds'
 *   categoryIds: // value for 'categoryIds'
 *   includeUncategorized: // value for 'includeUncategorized'
 *   sectionIds: // value for 'sectionIds'
 *   offset: // value for 'offset'
 *   limit: // value for 'limit'
 *   sort: // value for 'sort'
 *   fundId: // value for 'fundId'
 *   isPaiResultsView: // value for 'isPaiResultsView'
 * });
 */
export function useListMetricAggregationsQuery(variables: ListMetricAggregationsQueryVariables | VueCompositionApi.Ref<ListMetricAggregationsQueryVariables> | ReactiveFunction<ListMetricAggregationsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListMetricAggregationsQuery, ListMetricAggregationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListMetricAggregationsQuery, ListMetricAggregationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListMetricAggregationsQuery, ListMetricAggregationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListMetricAggregationsQuery, ListMetricAggregationsQueryVariables>(ListMetricAggregationsDocument, variables, options);
}
export function useListMetricAggregationsLazyQuery(variables: ListMetricAggregationsQueryVariables | VueCompositionApi.Ref<ListMetricAggregationsQueryVariables> | ReactiveFunction<ListMetricAggregationsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListMetricAggregationsQuery, ListMetricAggregationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListMetricAggregationsQuery, ListMetricAggregationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListMetricAggregationsQuery, ListMetricAggregationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListMetricAggregationsQuery, ListMetricAggregationsQueryVariables>(ListMetricAggregationsDocument, variables, options);
}
export type ListMetricAggregationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListMetricAggregationsQuery, ListMetricAggregationsQueryVariables>;
export const ListMetricsDocument = gql`
    query listMetrics($input: MetricQueryInput!, $offset: Int, $limit: Int) {
  listMetrics(input: $input, offset: $offset, limit: $limit) {
    ...CompleteMetric
  }
  countMetrics(input: $input)
}
    ${CompleteMetricFragmentDoc}`;

/**
 * __useListMetricsQuery__
 *
 * To run a query within a Vue component, call `useListMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMetricsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListMetricsQuery({
 *   input: // value for 'input'
 *   offset: // value for 'offset'
 *   limit: // value for 'limit'
 * });
 */
export function useListMetricsQuery(variables: ListMetricsQueryVariables | VueCompositionApi.Ref<ListMetricsQueryVariables> | ReactiveFunction<ListMetricsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListMetricsQuery, ListMetricsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListMetricsQuery, ListMetricsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListMetricsQuery, ListMetricsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListMetricsQuery, ListMetricsQueryVariables>(ListMetricsDocument, variables, options);
}
export function useListMetricsLazyQuery(variables: ListMetricsQueryVariables | VueCompositionApi.Ref<ListMetricsQueryVariables> | ReactiveFunction<ListMetricsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListMetricsQuery, ListMetricsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListMetricsQuery, ListMetricsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListMetricsQuery, ListMetricsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListMetricsQuery, ListMetricsQueryVariables>(ListMetricsDocument, variables, options);
}
export type ListMetricsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListMetricsQuery, ListMetricsQueryVariables>;
export const ListSectionsDocument = gql`
    query ListSections($filters: SectionFiltersInput, $limit: Int, $offset: Int) {
  listSections(filters: $filters, limit: $limit, offset: $offset) {
    id
    label
    labelI18n
    sort
    parentId
    taxonomyId
    taxonomy {
      id
      label
    }
    sections {
      id
      label
      labelI18n
      sort
      taxonomyId
      parentId
      taxonomy {
        id
        label
      }
      sections {
        id
        label
        labelI18n
        sort
        taxonomyId
        parentId
        taxonomy {
          id
          label
        }
        sections {
          id
          label
          labelI18n
          sort
          taxonomyId
          parentId
          taxonomy {
            id
            label
          }
          sections {
            id
            label
            labelI18n
            sort
            taxonomyId
            parentId
            taxonomy {
              id
              label
            }
            sections {
              id
              label
              labelI18n
              sort
              taxonomyId
              parentId
              taxonomy {
                id
                label
              }
            }
          }
        }
      }
    }
    iroLinks {
      ...IroLink
    }
  }
  countSections(filters: $filters)
}
    ${IroLinkFragmentDoc}`;

/**
 * __useListSectionsQuery__
 *
 * To run a query within a Vue component, call `useListSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSectionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListSectionsQuery({
 *   filters: // value for 'filters'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 * });
 */
export function useListSectionsQuery(variables: ListSectionsQueryVariables | VueCompositionApi.Ref<ListSectionsQueryVariables> | ReactiveFunction<ListSectionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListSectionsQuery, ListSectionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListSectionsQuery, ListSectionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListSectionsQuery, ListSectionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListSectionsQuery, ListSectionsQueryVariables>(ListSectionsDocument, variables, options);
}
export function useListSectionsLazyQuery(variables: ListSectionsQueryVariables | VueCompositionApi.Ref<ListSectionsQueryVariables> | ReactiveFunction<ListSectionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListSectionsQuery, ListSectionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListSectionsQuery, ListSectionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListSectionsQuery, ListSectionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListSectionsQuery, ListSectionsQueryVariables>(ListSectionsDocument, variables, options);
}
export type ListSectionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListSectionsQuery, ListSectionsQueryVariables>;
export const ListSubmittedMetricsDocument = gql`
    query listSubmittedMetrics($fundId: Int, $metricIds: [Int!], $limit: Int, $offset: Int) {
  listMetricAggregations(
    fundId: $fundId
    metricIds: $metricIds
    limit: $limit
    offset: $offset
  ) {
    id
    metric {
      id
    }
  }
}
    `;

/**
 * __useListSubmittedMetricsQuery__
 *
 * To run a query within a Vue component, call `useListSubmittedMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSubmittedMetricsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListSubmittedMetricsQuery({
 *   fundId: // value for 'fundId'
 *   metricIds: // value for 'metricIds'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 * });
 */
export function useListSubmittedMetricsQuery(variables: ListSubmittedMetricsQueryVariables | VueCompositionApi.Ref<ListSubmittedMetricsQueryVariables> | ReactiveFunction<ListSubmittedMetricsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListSubmittedMetricsQuery, ListSubmittedMetricsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListSubmittedMetricsQuery, ListSubmittedMetricsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListSubmittedMetricsQuery, ListSubmittedMetricsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListSubmittedMetricsQuery, ListSubmittedMetricsQueryVariables>(ListSubmittedMetricsDocument, variables, options);
}
export function useListSubmittedMetricsLazyQuery(variables: ListSubmittedMetricsQueryVariables | VueCompositionApi.Ref<ListSubmittedMetricsQueryVariables> | ReactiveFunction<ListSubmittedMetricsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListSubmittedMetricsQuery, ListSubmittedMetricsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListSubmittedMetricsQuery, ListSubmittedMetricsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListSubmittedMetricsQuery, ListSubmittedMetricsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListSubmittedMetricsQuery, ListSubmittedMetricsQueryVariables>(ListSubmittedMetricsDocument, variables, options);
}
export type ListSubmittedMetricsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListSubmittedMetricsQuery, ListSubmittedMetricsQueryVariables>;
export const ListTableModelsDocument = gql`
    query ListTableModels($tableNames: [String!]!, $query: String!) {
  listTableModels(tableNames: $tableNames, query: $query) {
    path
    description
  }
}
    `;

/**
 * __useListTableModelsQuery__
 *
 * To run a query within a Vue component, call `useListTableModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTableModelsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListTableModelsQuery({
 *   tableNames: // value for 'tableNames'
 *   query: // value for 'query'
 * });
 */
export function useListTableModelsQuery(variables: ListTableModelsQueryVariables | VueCompositionApi.Ref<ListTableModelsQueryVariables> | ReactiveFunction<ListTableModelsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListTableModelsQuery, ListTableModelsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListTableModelsQuery, ListTableModelsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListTableModelsQuery, ListTableModelsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListTableModelsQuery, ListTableModelsQueryVariables>(ListTableModelsDocument, variables, options);
}
export function useListTableModelsLazyQuery(variables: ListTableModelsQueryVariables | VueCompositionApi.Ref<ListTableModelsQueryVariables> | ReactiveFunction<ListTableModelsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListTableModelsQuery, ListTableModelsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListTableModelsQuery, ListTableModelsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListTableModelsQuery, ListTableModelsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListTableModelsQuery, ListTableModelsQueryVariables>(ListTableModelsDocument, variables, options);
}
export type ListTableModelsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListTableModelsQuery, ListTableModelsQueryVariables>;
export const ListTaxonomiesDocument = gql`
    query ListTaxonomies($input: TaxonomyFilterInput!, $offset: Int, $limit: Int) {
  listTaxonomies(input: $input, offset: $offset, limit: $limit) {
    label
    shortLabel
    id
  }
  countTaxonomies(input: $input)
}
    `;

/**
 * __useListTaxonomiesQuery__
 *
 * To run a query within a Vue component, call `useListTaxonomiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTaxonomiesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListTaxonomiesQuery({
 *   input: // value for 'input'
 *   offset: // value for 'offset'
 *   limit: // value for 'limit'
 * });
 */
export function useListTaxonomiesQuery(variables: ListTaxonomiesQueryVariables | VueCompositionApi.Ref<ListTaxonomiesQueryVariables> | ReactiveFunction<ListTaxonomiesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListTaxonomiesQuery, ListTaxonomiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListTaxonomiesQuery, ListTaxonomiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListTaxonomiesQuery, ListTaxonomiesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListTaxonomiesQuery, ListTaxonomiesQueryVariables>(ListTaxonomiesDocument, variables, options);
}
export function useListTaxonomiesLazyQuery(variables: ListTaxonomiesQueryVariables | VueCompositionApi.Ref<ListTaxonomiesQueryVariables> | ReactiveFunction<ListTaxonomiesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListTaxonomiesQuery, ListTaxonomiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListTaxonomiesQuery, ListTaxonomiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListTaxonomiesQuery, ListTaxonomiesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListTaxonomiesQuery, ListTaxonomiesQueryVariables>(ListTaxonomiesDocument, variables, options);
}
export type ListTaxonomiesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListTaxonomiesQuery, ListTaxonomiesQueryVariables>;
export const GetAccountDocument = gql`
    query getAccount($id: String) {
  getAccount(id: $id) {
    id
    logo
    website
    type
    expiryDate
    expiryStatus
    movedToUrls
    isSuspended
    esgActionsActive
    name
    metricsToken
    esgToken
    impactGoalToken
    modules
    membershipRoles
    bookedModules
    hasKfw
    legalEntityIdentifier
    nace
    countries
    hiddenKpis
    nameOfFinancialMarketParticipant
    remunerationPolicies
    sustainabilityRiskIntegration
    entityLevelPaiConsideration
    reportingPeriodType
    subsidiaries
    csrdRequirement
    csrdLikelihoodThreshold
    csrdMagnitudeThreshold
    csrdThresholdReason
    csrdNImpactLikelihoodThreshold
    csrdNImpactSeverityThreshold
    csrdNImpactThresholdReason
    csrdPImpactLikelihoodThreshold
    csrdPImpactScopeThreshold
    csrdPImpactThresholdReason
    ventureLinks {
      id
      portfolioId
      ventureId
      modules
      comment
      groupNames
      groupIds
      venture {
        id
        name
        logo
        website
      }
    }
    portfolioLinks {
      modules
      portfolioId
      ventureId
      comment
      portfolio {
        id
        name
        logo
        website
        reportingPeriodType
        defaultReferencePeriods
        requireImpactSubmission
      }
    }
    defaultReferencePeriods
    requireImpactSubmission
    usersCount
  }
}
    `;

/**
 * __useGetAccountQuery__
 *
 * To run a query within a Vue component, call `useGetAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAccountQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetAccountQuery(variables: GetAccountQueryVariables | VueCompositionApi.Ref<GetAccountQueryVariables> | ReactiveFunction<GetAccountQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetAccountQuery, GetAccountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAccountQuery, GetAccountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAccountQuery, GetAccountQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, variables, options);
}
export function useGetAccountLazyQuery(variables: GetAccountQueryVariables | VueCompositionApi.Ref<GetAccountQueryVariables> | ReactiveFunction<GetAccountQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetAccountQuery, GetAccountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAccountQuery, GetAccountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAccountQuery, GetAccountQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, variables, options);
}
export type GetAccountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAccountQuery, GetAccountQueryVariables>;
export const GetAccountWithDetailDocument = gql`
    query getAccountWithDetail($id: String) {
  getAccount(id: $id) {
    id
    logo
    website
    type
    esgActionsActive
    name
    metricsToken
    esgToken
    impactGoalToken
    modules
    bookedModules
    hasKfw
    nace
    countries
    csrdRequirement
    ventureLinks {
      id
      portfolioId
      ventureId
      modules
      comment
      venture {
        id
        name
        logo
        website
      }
    }
    portfolioLinks {
      modules
      portfolioId
      ventureId
      comment
      portfolio {
        id
        name
        logo
        website
      }
    }
    metricAssignments {
      id
      metric {
        name
      }
    }
    companyInfo {
      userInputs {
        question {
          label
        }
        text
        selectedOptions {
          label
        }
      }
    }
  }
}
    `;

/**
 * __useGetAccountWithDetailQuery__
 *
 * To run a query within a Vue component, call `useGetAccountWithDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountWithDetailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAccountWithDetailQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetAccountWithDetailQuery(variables: GetAccountWithDetailQueryVariables | VueCompositionApi.Ref<GetAccountWithDetailQueryVariables> | ReactiveFunction<GetAccountWithDetailQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetAccountWithDetailQuery, GetAccountWithDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAccountWithDetailQuery, GetAccountWithDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAccountWithDetailQuery, GetAccountWithDetailQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAccountWithDetailQuery, GetAccountWithDetailQueryVariables>(GetAccountWithDetailDocument, variables, options);
}
export function useGetAccountWithDetailLazyQuery(variables: GetAccountWithDetailQueryVariables | VueCompositionApi.Ref<GetAccountWithDetailQueryVariables> | ReactiveFunction<GetAccountWithDetailQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetAccountWithDetailQuery, GetAccountWithDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAccountWithDetailQuery, GetAccountWithDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAccountWithDetailQuery, GetAccountWithDetailQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAccountWithDetailQuery, GetAccountWithDetailQueryVariables>(GetAccountWithDetailDocument, variables, options);
}
export type GetAccountWithDetailQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAccountWithDetailQuery, GetAccountWithDetailQueryVariables>;
export const GetAccountWithEuTaxonomyDataDocument = gql`
    query GetAccountWithEuTaxonomyData($id: String) {
  getAccount(id: $id) {
    id
    ...AccountFragmentForEuTaxonomy
  }
}
    ${AccountFragmentForEuTaxonomyFragmentDoc}`;

/**
 * __useGetAccountWithEuTaxonomyDataQuery__
 *
 * To run a query within a Vue component, call `useGetAccountWithEuTaxonomyDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountWithEuTaxonomyDataQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAccountWithEuTaxonomyDataQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetAccountWithEuTaxonomyDataQuery(variables: GetAccountWithEuTaxonomyDataQueryVariables | VueCompositionApi.Ref<GetAccountWithEuTaxonomyDataQueryVariables> | ReactiveFunction<GetAccountWithEuTaxonomyDataQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetAccountWithEuTaxonomyDataQuery, GetAccountWithEuTaxonomyDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAccountWithEuTaxonomyDataQuery, GetAccountWithEuTaxonomyDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAccountWithEuTaxonomyDataQuery, GetAccountWithEuTaxonomyDataQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAccountWithEuTaxonomyDataQuery, GetAccountWithEuTaxonomyDataQueryVariables>(GetAccountWithEuTaxonomyDataDocument, variables, options);
}
export function useGetAccountWithEuTaxonomyDataLazyQuery(variables: GetAccountWithEuTaxonomyDataQueryVariables | VueCompositionApi.Ref<GetAccountWithEuTaxonomyDataQueryVariables> | ReactiveFunction<GetAccountWithEuTaxonomyDataQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetAccountWithEuTaxonomyDataQuery, GetAccountWithEuTaxonomyDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAccountWithEuTaxonomyDataQuery, GetAccountWithEuTaxonomyDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAccountWithEuTaxonomyDataQuery, GetAccountWithEuTaxonomyDataQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAccountWithEuTaxonomyDataQuery, GetAccountWithEuTaxonomyDataQueryVariables>(GetAccountWithEuTaxonomyDataDocument, variables, options);
}
export type GetAccountWithEuTaxonomyDataQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAccountWithEuTaxonomyDataQuery, GetAccountWithEuTaxonomyDataQueryVariables>;
export const GetFundIsInSyncDocument = gql`
    query getFundIsInSync($id: Int!) {
  getFund(id: $id) {
    id
    isInSync
    syncState {
      esgQuestionnaire
      esgModule
      fundAggregations
      fundAssignments
      euTaxonomyChecks
      kfwAssignments
      fundAggregationsToAdd {
        metricId
        groupType
        groupId
        metric {
          name
        }
        why
      }
      fundAggregationsToDelete {
        metricId
        groupType
        groupId
        metric {
          name
        }
        why
      }
      assignmentsToAdd {
        metricId
        assigneeId
        fundId
        metric {
          name
        }
        assignee {
          name
        }
        why
      }
      moduleUpdates {
        assignee {
          id
          name
        }
        modulesToAdd
      }
      esgQuestionnairesToAdd {
        assignee {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetFundIsInSyncQuery__
 *
 * To run a query within a Vue component, call `useGetFundIsInSyncQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundIsInSyncQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetFundIsInSyncQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetFundIsInSyncQuery(variables: GetFundIsInSyncQueryVariables | VueCompositionApi.Ref<GetFundIsInSyncQueryVariables> | ReactiveFunction<GetFundIsInSyncQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetFundIsInSyncQuery, GetFundIsInSyncQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetFundIsInSyncQuery, GetFundIsInSyncQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetFundIsInSyncQuery, GetFundIsInSyncQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetFundIsInSyncQuery, GetFundIsInSyncQueryVariables>(GetFundIsInSyncDocument, variables, options);
}
export function useGetFundIsInSyncLazyQuery(variables: GetFundIsInSyncQueryVariables | VueCompositionApi.Ref<GetFundIsInSyncQueryVariables> | ReactiveFunction<GetFundIsInSyncQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetFundIsInSyncQuery, GetFundIsInSyncQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetFundIsInSyncQuery, GetFundIsInSyncQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetFundIsInSyncQuery, GetFundIsInSyncQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetFundIsInSyncQuery, GetFundIsInSyncQueryVariables>(GetFundIsInSyncDocument, variables, options);
}
export type GetFundIsInSyncQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetFundIsInSyncQuery, GetFundIsInSyncQueryVariables>;
export const GetFundReportDocument = gql`
    query getFundReport($input: getFundReportInput!) {
  getFundReport(input: $input) {
    nameOfFinancialMarketParticipant
    legalEntityIdentifier
    fundName
    isArticle9
    isArticle8
    isArticle8Plus
    isArticle8PlusWithAlignedEnvironmentalInvestments
    isArticle8PlusWithNonAlignedEnvironmentalInvestments
    isArticle8PlusWithSocialObjective
    hasSustainableInvestmentObjective
    hasEnvironmentalInvestments
    percentSustainableInvestmentsWithEnvironmentalObjective
    hasAlignedEnvironmentalInvestments
    hasNonAlignedEnvironmentalInvestments
    hasFossilOrNuclearActivities
    hasFossilActivities
    hasNuclearActivities
    hasNoFossilNorNuclearActivities
    hasSocialObjective
    percentSustainableInvestmentsWithSocialObjective
    percentSustainableInvestmentsWhilePromotingEsCharacteristics
    esCharacteristicsDescription
    sustainabilityIndicatorsPerformanceDescriptionComparedToPrevious
    sustainabilityRelatedInvestmentEconomicSector
    sustainabilityRelatedInvestmentAssetAllocation
    sustainabilityRelatedInvestmentAssetAllocationPrecontractual
    investments
    sustainableInvestmentsMadeByFund
    sustainableInvestmentsMadeByFundPrecontractual
    sustainabilityIndicatorsPerformanceDescription
    sustainabilityIndicatorsDescriptionPrecontractual
    howDidInvestmentsNotCauseHarm
    alignmentWithOecdGuidelines
    investmentsCategorizationChartData
    investmentsCategorizationChartDataPrecontractual
    accountOnPais
    sustainableInvestmentsWithEnvironmentalObjectiveEuTaxonomyAlignment
    sustainableInvestmentsWithEnvironmentalObjectiveEuTaxonomyAlignmentPrecontractual
    shareOfSustainableInvestmentsWithEnvironmentalObjectiveNonEuTaxonomyAligned
    shareOfSustainableInvestmentsWithEnvironmentalObjectiveNonEuTaxonomyAlignedPrecontractual
    shareOfSociallySustainableInvestments
    shareOfSociallySustainableInvestmentsPrecontractual
    shareOfInvestmentsInTransitionalAndEnablingActivities
    shareOfInvestmentsInTransitionalAndEnablingActivitiesPrecontractual
    investmentStrategy
    bindingElementsOfInvestmentStrategy
    minimumRateToReduceScope
    companyGovernancePolicy
    isIndexDesignated
    sustainablyAlignedIndexExplanation
    investmentAlignedIndexExplanation
    broadMarketIndexComparison
    indexCalculationMethodology
    fundSpecificInfo
    referenceBenchmarkDifferenceToBroadMarketOptions {
      title
      text
    }
    investmentsAlignedWithEuTaxonomyComparisonWithPreviousPeriods
    purposeOfOtherOrNotSustainableInvestmentsIncludingSafeguards
    purposeOfOtherOrNotSustainableInvestmentsIncludingSafeguardsPrecontractual
    fundPerformanceOnSustainabilityIndicatorsOptions {
      title
      text
    }
    fundPerformanceComparedToReferenceBenchmark
    fundPerformanceComparedToReferenceBenchmarkOptions {
      text
      title
    }
    fundPerformanceComparedToBroadMarketIndexOptions {
      text
      title
    }
    actionsTakenToMeetEsCharacteristics
    percentageOfInvestmentsAlignedWithEuTaxonomy
    isConsideringPais
    isConsideringTaxonomy
    whyDidProductConsiderPais
    useOfDerivatives
  }
}
    `;

/**
 * __useGetFundReportQuery__
 *
 * To run a query within a Vue component, call `useGetFundReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundReportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetFundReportQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetFundReportQuery(variables: GetFundReportQueryVariables | VueCompositionApi.Ref<GetFundReportQueryVariables> | ReactiveFunction<GetFundReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetFundReportQuery, GetFundReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetFundReportQuery, GetFundReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetFundReportQuery, GetFundReportQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetFundReportQuery, GetFundReportQueryVariables>(GetFundReportDocument, variables, options);
}
export function useGetFundReportLazyQuery(variables: GetFundReportQueryVariables | VueCompositionApi.Ref<GetFundReportQueryVariables> | ReactiveFunction<GetFundReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetFundReportQuery, GetFundReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetFundReportQuery, GetFundReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetFundReportQuery, GetFundReportQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetFundReportQuery, GetFundReportQueryVariables>(GetFundReportDocument, variables, options);
}
export type GetFundReportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetFundReportQuery, GetFundReportQueryVariables>;
export const GetPaiReportDocument = gql`
    query getPaiReport($input: getPaiReportInput!) {
  getPaiReport(input: $input) {
    nameOfFinancialMarketParticipant
    legalEntityIdentifier
    fundName
    considerationOfPaisOnSustainabilityDescription
    subsidiaries
    paiExplanationsAndActions
    considerationOfPaisOnSustainabilityHistoricalComparison
    howDidProductConsiderPais
    summaryOfPais
  }
}
    `;

/**
 * __useGetPaiReportQuery__
 *
 * To run a query within a Vue component, call `useGetPaiReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaiReportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPaiReportQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetPaiReportQuery(variables: GetPaiReportQueryVariables | VueCompositionApi.Ref<GetPaiReportQueryVariables> | ReactiveFunction<GetPaiReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPaiReportQuery, GetPaiReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPaiReportQuery, GetPaiReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPaiReportQuery, GetPaiReportQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPaiReportQuery, GetPaiReportQueryVariables>(GetPaiReportDocument, variables, options);
}
export function useGetPaiReportLazyQuery(variables: GetPaiReportQueryVariables | VueCompositionApi.Ref<GetPaiReportQueryVariables> | ReactiveFunction<GetPaiReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPaiReportQuery, GetPaiReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPaiReportQuery, GetPaiReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPaiReportQuery, GetPaiReportQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPaiReportQuery, GetPaiReportQueryVariables>(GetPaiReportDocument, variables, options);
}
export type GetPaiReportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPaiReportQuery, GetPaiReportQueryVariables>;
export const GetCsrdIntroDocument = gql`
    query getCsrdIntro($id: String) {
  getAccount(id: $id) {
    id
    showCsrdIntro
  }
}
    `;

/**
 * __useGetCsrdIntroQuery__
 *
 * To run a query within a Vue component, call `useGetCsrdIntroQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCsrdIntroQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCsrdIntroQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetCsrdIntroQuery(variables: GetCsrdIntroQueryVariables | VueCompositionApi.Ref<GetCsrdIntroQueryVariables> | ReactiveFunction<GetCsrdIntroQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetCsrdIntroQuery, GetCsrdIntroQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCsrdIntroQuery, GetCsrdIntroQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCsrdIntroQuery, GetCsrdIntroQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCsrdIntroQuery, GetCsrdIntroQueryVariables>(GetCsrdIntroDocument, variables, options);
}
export function useGetCsrdIntroLazyQuery(variables: GetCsrdIntroQueryVariables | VueCompositionApi.Ref<GetCsrdIntroQueryVariables> | ReactiveFunction<GetCsrdIntroQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetCsrdIntroQuery, GetCsrdIntroQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCsrdIntroQuery, GetCsrdIntroQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCsrdIntroQuery, GetCsrdIntroQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetCsrdIntroQuery, GetCsrdIntroQueryVariables>(GetCsrdIntroDocument, variables, options);
}
export type GetCsrdIntroQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCsrdIntroQuery, GetCsrdIntroQueryVariables>;
export const ListAccountsDocument = gql`
    query listAccounts($filters: ListAccountFilter, $limit: Int, $offset: Int, $sort: [SortParam!]) {
  listAccounts(filters: $filters, limit: $limit, offset: $offset, sort: $sort) {
    id
    name
    type
    usageType
    bookedModules
    esgActionsActive
    modules
    createdAt
    expiryDate
    expiryStatus
    isSuspended
    logo
    users {
      id
      email
    }
    accountMemberships {
      role
      user {
        id
        email
      }
    }
    portfolioLinks {
      ventureId
      portfolioId
      groupIds
      groupNames
      companyUserInvites {
        email
        sentAt
        sentById
      }
    }
    completionRates {
      assigneeId
      completionRate
      skippedRate
      responseRate
      totalMetrics
      completedMetrics
      skippedMetrics
      incompleteMetrics
      quarterlyMetrics
      annualMetrics
      periodsConsidered
      periodDebug {
        period
        totalMetrics
        completedMetrics
        skippedMetrics
        incompleteMetrics
      }
    }
    metricAssignmentsCount
    usersCount
  }
  countAccounts(filters: $filters)
}
    `;

/**
 * __useListAccountsQuery__
 *
 * To run a query within a Vue component, call `useListAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAccountsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListAccountsQuery({
 *   filters: // value for 'filters'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 *   sort: // value for 'sort'
 * });
 */
export function useListAccountsQuery(variables: ListAccountsQueryVariables | VueCompositionApi.Ref<ListAccountsQueryVariables> | ReactiveFunction<ListAccountsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListAccountsQuery, ListAccountsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListAccountsQuery, ListAccountsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListAccountsQuery, ListAccountsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListAccountsQuery, ListAccountsQueryVariables>(ListAccountsDocument, variables, options);
}
export function useListAccountsLazyQuery(variables: ListAccountsQueryVariables | VueCompositionApi.Ref<ListAccountsQueryVariables> | ReactiveFunction<ListAccountsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListAccountsQuery, ListAccountsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListAccountsQuery, ListAccountsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListAccountsQuery, ListAccountsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListAccountsQuery, ListAccountsQueryVariables>(ListAccountsDocument, variables, options);
}
export type ListAccountsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListAccountsQuery, ListAccountsQueryVariables>;
export const ListBasicAccountsDocument = gql`
    query listBasicAccounts($filters: ListAccountFilter, $limit: Int, $offset: Int, $sort: [SortParam!]) {
  listAccounts(filters: $filters, limit: $limit, offset: $offset, sort: $sort) {
    id
    name
    type
    usageType
    bookedModules
    esgActionsActive
    modules
    createdAt
    logo
  }
  countAccounts(filters: $filters)
}
    `;

/**
 * __useListBasicAccountsQuery__
 *
 * To run a query within a Vue component, call `useListBasicAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListBasicAccountsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListBasicAccountsQuery({
 *   filters: // value for 'filters'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 *   sort: // value for 'sort'
 * });
 */
export function useListBasicAccountsQuery(variables: ListBasicAccountsQueryVariables | VueCompositionApi.Ref<ListBasicAccountsQueryVariables> | ReactiveFunction<ListBasicAccountsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListBasicAccountsQuery, ListBasicAccountsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListBasicAccountsQuery, ListBasicAccountsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListBasicAccountsQuery, ListBasicAccountsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListBasicAccountsQuery, ListBasicAccountsQueryVariables>(ListBasicAccountsDocument, variables, options);
}
export function useListBasicAccountsLazyQuery(variables: ListBasicAccountsQueryVariables | VueCompositionApi.Ref<ListBasicAccountsQueryVariables> | ReactiveFunction<ListBasicAccountsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListBasicAccountsQuery, ListBasicAccountsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListBasicAccountsQuery, ListBasicAccountsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListBasicAccountsQuery, ListBasicAccountsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListBasicAccountsQuery, ListBasicAccountsQueryVariables>(ListBasicAccountsDocument, variables, options);
}
export type ListBasicAccountsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListBasicAccountsQuery, ListBasicAccountsQueryVariables>;
export const ListEsgPortfolioVentureLinksDocument = gql`
    query listEsgPortfolioVentureLinks($filters: ListPortfolioVentureLinksFilter, $offset: Int, $limit: Int, $sortBy: String, $sortDesc: Boolean) {
  listPortfolioVentureLinks(
    filters: $filters
    offset: $offset
    limit: $limit
    sortBy: $sortBy
    sortDesc: $sortDesc
  ) {
    ...CompletePortfolioVentureLink
    esgSummary {
      ventureId
      isCompleted
      updatedAt
      submittedAt
      period {
        id
        label
        startDate
        endDate
        userDefined
      }
      total
      totalDiffToPrevious
      environmental
      environmentalDiffToPrevious
      social
      socialDiffToPrevious
      governance
      governanceDiffToPrevious
      disclosure
    }
  }
  countPortfolioVentureLinks(filters: $filters)
}
    ${CompletePortfolioVentureLinkFragmentDoc}`;

/**
 * __useListEsgPortfolioVentureLinksQuery__
 *
 * To run a query within a Vue component, call `useListEsgPortfolioVentureLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEsgPortfolioVentureLinksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListEsgPortfolioVentureLinksQuery({
 *   filters: // value for 'filters'
 *   offset: // value for 'offset'
 *   limit: // value for 'limit'
 *   sortBy: // value for 'sortBy'
 *   sortDesc: // value for 'sortDesc'
 * });
 */
export function useListEsgPortfolioVentureLinksQuery(variables: ListEsgPortfolioVentureLinksQueryVariables | VueCompositionApi.Ref<ListEsgPortfolioVentureLinksQueryVariables> | ReactiveFunction<ListEsgPortfolioVentureLinksQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListEsgPortfolioVentureLinksQuery, ListEsgPortfolioVentureLinksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListEsgPortfolioVentureLinksQuery, ListEsgPortfolioVentureLinksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListEsgPortfolioVentureLinksQuery, ListEsgPortfolioVentureLinksQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListEsgPortfolioVentureLinksQuery, ListEsgPortfolioVentureLinksQueryVariables>(ListEsgPortfolioVentureLinksDocument, variables, options);
}
export function useListEsgPortfolioVentureLinksLazyQuery(variables: ListEsgPortfolioVentureLinksQueryVariables | VueCompositionApi.Ref<ListEsgPortfolioVentureLinksQueryVariables> | ReactiveFunction<ListEsgPortfolioVentureLinksQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListEsgPortfolioVentureLinksQuery, ListEsgPortfolioVentureLinksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListEsgPortfolioVentureLinksQuery, ListEsgPortfolioVentureLinksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListEsgPortfolioVentureLinksQuery, ListEsgPortfolioVentureLinksQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListEsgPortfolioVentureLinksQuery, ListEsgPortfolioVentureLinksQueryVariables>(ListEsgPortfolioVentureLinksDocument, variables, options);
}
export type ListEsgPortfolioVentureLinksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListEsgPortfolioVentureLinksQuery, ListEsgPortfolioVentureLinksQueryVariables>;
export const ListGroupNamesInPortfolioDocument = gql`
    query listGroupNamesInPortfolio($portfolioId: String!) {
  listGroupNamesInPortfolio(portfolioId: $portfolioId)
}
    `;

/**
 * __useListGroupNamesInPortfolioQuery__
 *
 * To run a query within a Vue component, call `useListGroupNamesInPortfolioQuery` and pass it any options that fit your needs.
 * When your component renders, `useListGroupNamesInPortfolioQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListGroupNamesInPortfolioQuery({
 *   portfolioId: // value for 'portfolioId'
 * });
 */
export function useListGroupNamesInPortfolioQuery(variables: ListGroupNamesInPortfolioQueryVariables | VueCompositionApi.Ref<ListGroupNamesInPortfolioQueryVariables> | ReactiveFunction<ListGroupNamesInPortfolioQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListGroupNamesInPortfolioQuery, ListGroupNamesInPortfolioQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListGroupNamesInPortfolioQuery, ListGroupNamesInPortfolioQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListGroupNamesInPortfolioQuery, ListGroupNamesInPortfolioQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListGroupNamesInPortfolioQuery, ListGroupNamesInPortfolioQueryVariables>(ListGroupNamesInPortfolioDocument, variables, options);
}
export function useListGroupNamesInPortfolioLazyQuery(variables: ListGroupNamesInPortfolioQueryVariables | VueCompositionApi.Ref<ListGroupNamesInPortfolioQueryVariables> | ReactiveFunction<ListGroupNamesInPortfolioQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListGroupNamesInPortfolioQuery, ListGroupNamesInPortfolioQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListGroupNamesInPortfolioQuery, ListGroupNamesInPortfolioQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListGroupNamesInPortfolioQuery, ListGroupNamesInPortfolioQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListGroupNamesInPortfolioQuery, ListGroupNamesInPortfolioQueryVariables>(ListGroupNamesInPortfolioDocument, variables, options);
}
export type ListGroupNamesInPortfolioQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListGroupNamesInPortfolioQuery, ListGroupNamesInPortfolioQueryVariables>;
export const ListPortfolioGroupsDocument = gql`
    query listPortfolioGroups {
  listPortfolioGroups {
    ...CompletePortfolioGroup
  }
}
    ${CompletePortfolioGroupFragmentDoc}`;

/**
 * __useListPortfolioGroupsQuery__
 *
 * To run a query within a Vue component, call `useListPortfolioGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPortfolioGroupsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListPortfolioGroupsQuery();
 */
export function useListPortfolioGroupsQuery(options: VueApolloComposable.UseQueryOptions<ListPortfolioGroupsQuery, ListPortfolioGroupsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListPortfolioGroupsQuery, ListPortfolioGroupsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListPortfolioGroupsQuery, ListPortfolioGroupsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListPortfolioGroupsQuery, ListPortfolioGroupsQueryVariables>(ListPortfolioGroupsDocument, {}, options);
}
export function useListPortfolioGroupsLazyQuery(options: VueApolloComposable.UseQueryOptions<ListPortfolioGroupsQuery, ListPortfolioGroupsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListPortfolioGroupsQuery, ListPortfolioGroupsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListPortfolioGroupsQuery, ListPortfolioGroupsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListPortfolioGroupsQuery, ListPortfolioGroupsQueryVariables>(ListPortfolioGroupsDocument, {}, options);
}
export type ListPortfolioGroupsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListPortfolioGroupsQuery, ListPortfolioGroupsQueryVariables>;
export const ListPortfolioVentureLinksDocument = gql`
    query listPortfolioVentureLinks($filters: ListPortfolioVentureLinksFilter, $offset: Int, $limit: Int, $sortBy: String, $sortDesc: Boolean) {
  listPortfolioVentureLinks(
    filters: $filters
    offset: $offset
    limit: $limit
    sortBy: $sortBy
    sortDesc: $sortDesc
  ) {
    ...CompletePortfolioVentureLink
    impactGoal {
      id
      ventureId
      isEditable
      submitDate
      targetProgress {
        ...CompleteTargetProgress
      }
      sdgs {
        id
        label
      }
      geographies {
        id
        label
      }
      impacts {
        id
        concept {
          id
          label
        }
        stakeholder
        stakeholderCategory
        isPositive
        metricAssignments {
          id
          reportingPeriodType
        }
      }
    }
  }
  countPortfolioVentureLinks(filters: $filters)
}
    ${CompletePortfolioVentureLinkFragmentDoc}
${CompleteTargetProgressFragmentDoc}`;

/**
 * __useListPortfolioVentureLinksQuery__
 *
 * To run a query within a Vue component, call `useListPortfolioVentureLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPortfolioVentureLinksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListPortfolioVentureLinksQuery({
 *   filters: // value for 'filters'
 *   offset: // value for 'offset'
 *   limit: // value for 'limit'
 *   sortBy: // value for 'sortBy'
 *   sortDesc: // value for 'sortDesc'
 * });
 */
export function useListPortfolioVentureLinksQuery(variables: ListPortfolioVentureLinksQueryVariables | VueCompositionApi.Ref<ListPortfolioVentureLinksQueryVariables> | ReactiveFunction<ListPortfolioVentureLinksQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListPortfolioVentureLinksQuery, ListPortfolioVentureLinksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListPortfolioVentureLinksQuery, ListPortfolioVentureLinksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListPortfolioVentureLinksQuery, ListPortfolioVentureLinksQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListPortfolioVentureLinksQuery, ListPortfolioVentureLinksQueryVariables>(ListPortfolioVentureLinksDocument, variables, options);
}
export function useListPortfolioVentureLinksLazyQuery(variables: ListPortfolioVentureLinksQueryVariables | VueCompositionApi.Ref<ListPortfolioVentureLinksQueryVariables> | ReactiveFunction<ListPortfolioVentureLinksQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListPortfolioVentureLinksQuery, ListPortfolioVentureLinksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListPortfolioVentureLinksQuery, ListPortfolioVentureLinksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListPortfolioVentureLinksQuery, ListPortfolioVentureLinksQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListPortfolioVentureLinksQuery, ListPortfolioVentureLinksQueryVariables>(ListPortfolioVentureLinksDocument, variables, options);
}
export type ListPortfolioVentureLinksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListPortfolioVentureLinksQuery, ListPortfolioVentureLinksQueryVariables>;
export const ListPortfolioVentureLinksForReviewDocument = gql`
    query listPortfolioVentureLinksForReview($portfolioId: UUID!) {
  listPortfolioVentureLinks(
    filters: {portfolioId: $portfolioId}
    limit: -1
    offset: 0
  ) {
    ventureId
    venture {
      id
      name
    }
  }
}
    `;

/**
 * __useListPortfolioVentureLinksForReviewQuery__
 *
 * To run a query within a Vue component, call `useListPortfolioVentureLinksForReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPortfolioVentureLinksForReviewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListPortfolioVentureLinksForReviewQuery({
 *   portfolioId: // value for 'portfolioId'
 * });
 */
export function useListPortfolioVentureLinksForReviewQuery(variables: ListPortfolioVentureLinksForReviewQueryVariables | VueCompositionApi.Ref<ListPortfolioVentureLinksForReviewQueryVariables> | ReactiveFunction<ListPortfolioVentureLinksForReviewQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListPortfolioVentureLinksForReviewQuery, ListPortfolioVentureLinksForReviewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListPortfolioVentureLinksForReviewQuery, ListPortfolioVentureLinksForReviewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListPortfolioVentureLinksForReviewQuery, ListPortfolioVentureLinksForReviewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListPortfolioVentureLinksForReviewQuery, ListPortfolioVentureLinksForReviewQueryVariables>(ListPortfolioVentureLinksForReviewDocument, variables, options);
}
export function useListPortfolioVentureLinksForReviewLazyQuery(variables: ListPortfolioVentureLinksForReviewQueryVariables | VueCompositionApi.Ref<ListPortfolioVentureLinksForReviewQueryVariables> | ReactiveFunction<ListPortfolioVentureLinksForReviewQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListPortfolioVentureLinksForReviewQuery, ListPortfolioVentureLinksForReviewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListPortfolioVentureLinksForReviewQuery, ListPortfolioVentureLinksForReviewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListPortfolioVentureLinksForReviewQuery, ListPortfolioVentureLinksForReviewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListPortfolioVentureLinksForReviewQuery, ListPortfolioVentureLinksForReviewQueryVariables>(ListPortfolioVentureLinksForReviewDocument, variables, options);
}
export type ListPortfolioVentureLinksForReviewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListPortfolioVentureLinksForReviewQuery, ListPortfolioVentureLinksForReviewQueryVariables>;
export const ListActivityStakeholderLinksDocument = gql`
    query ListActivityStakeholderLinks($activityId: UUID!, $limit: Int, $offset: Int) {
  listActivityStakeholderLinks(
    activityId: $activityId
    limit: $limit
    offset: $offset
  ) {
    id
    activityId
    stakeholderId
    stakeholder {
      name
      type
    }
    impactMaterial
    financialMaterial
  }
  countActivityStakeholderLinks(activityId: $activityId)
}
    `;

/**
 * __useListActivityStakeholderLinksQuery__
 *
 * To run a query within a Vue component, call `useListActivityStakeholderLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActivityStakeholderLinksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListActivityStakeholderLinksQuery({
 *   activityId: // value for 'activityId'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 * });
 */
export function useListActivityStakeholderLinksQuery(variables: ListActivityStakeholderLinksQueryVariables | VueCompositionApi.Ref<ListActivityStakeholderLinksQueryVariables> | ReactiveFunction<ListActivityStakeholderLinksQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListActivityStakeholderLinksQuery, ListActivityStakeholderLinksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListActivityStakeholderLinksQuery, ListActivityStakeholderLinksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListActivityStakeholderLinksQuery, ListActivityStakeholderLinksQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListActivityStakeholderLinksQuery, ListActivityStakeholderLinksQueryVariables>(ListActivityStakeholderLinksDocument, variables, options);
}
export function useListActivityStakeholderLinksLazyQuery(variables: ListActivityStakeholderLinksQueryVariables | VueCompositionApi.Ref<ListActivityStakeholderLinksQueryVariables> | ReactiveFunction<ListActivityStakeholderLinksQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListActivityStakeholderLinksQuery, ListActivityStakeholderLinksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListActivityStakeholderLinksQuery, ListActivityStakeholderLinksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListActivityStakeholderLinksQuery, ListActivityStakeholderLinksQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListActivityStakeholderLinksQuery, ListActivityStakeholderLinksQueryVariables>(ListActivityStakeholderLinksDocument, variables, options);
}
export type ListActivityStakeholderLinksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListActivityStakeholderLinksQuery, ListActivityStakeholderLinksQueryVariables>;
export const GetActivityDocument = gql`
    query GetActivity($id: UUID!) {
  getActivity(id: $id) {
    id
    name
    description
    riskProfile
    industry
    location
    geographyId
    type
  }
}
    `;

/**
 * __useGetActivityQuery__
 *
 * To run a query within a Vue component, call `useGetActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetActivityQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetActivityQuery(variables: GetActivityQueryVariables | VueCompositionApi.Ref<GetActivityQueryVariables> | ReactiveFunction<GetActivityQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetActivityQuery, GetActivityQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetActivityQuery, GetActivityQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetActivityQuery, GetActivityQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetActivityQuery, GetActivityQueryVariables>(GetActivityDocument, variables, options);
}
export function useGetActivityLazyQuery(variables: GetActivityQueryVariables | VueCompositionApi.Ref<GetActivityQueryVariables> | ReactiveFunction<GetActivityQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetActivityQuery, GetActivityQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetActivityQuery, GetActivityQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetActivityQuery, GetActivityQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetActivityQuery, GetActivityQueryVariables>(GetActivityDocument, variables, options);
}
export type GetActivityQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetActivityQuery, GetActivityQueryVariables>;
export const ListActivitiesDocument = gql`
    query ListActivities($filters: ListActivityFilter) {
  listActivities(filters: $filters) {
    id
    name
    description
    riskProfile
    industry
    location
    geographyId
    type
  }
  countActivities(filters: $filters)
}
    `;

/**
 * __useListActivitiesQuery__
 *
 * To run a query within a Vue component, call `useListActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActivitiesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListActivitiesQuery({
 *   filters: // value for 'filters'
 * });
 */
export function useListActivitiesQuery(variables: ListActivitiesQueryVariables | VueCompositionApi.Ref<ListActivitiesQueryVariables> | ReactiveFunction<ListActivitiesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListActivitiesQuery, ListActivitiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListActivitiesQuery, ListActivitiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListActivitiesQuery, ListActivitiesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListActivitiesQuery, ListActivitiesQueryVariables>(ListActivitiesDocument, variables, options);
}
export function useListActivitiesLazyQuery(variables: ListActivitiesQueryVariables | VueCompositionApi.Ref<ListActivitiesQueryVariables> | ReactiveFunction<ListActivitiesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListActivitiesQuery, ListActivitiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListActivitiesQuery, ListActivitiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListActivitiesQuery, ListActivitiesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListActivitiesQuery, ListActivitiesQueryVariables>(ListActivitiesDocument, variables, options);
}
export type ListActivitiesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListActivitiesQuery, ListActivitiesQueryVariables>;
export const ListCategoriesDocument = gql`
    query listCategories($input: CategoryQueryInput, $limit: Int, $offset: Int) {
  listCategories(input: $input, limit: $limit, offset: $offset) {
    label
    id
    labelI18n
    createdAt
    parentId
    parent {
      id
      label
    }
    subcategories {
      label
      id
      labelI18n
      createdAt
    }
  }
  countCategories(input: $input)
}
    `;

/**
 * __useListCategoriesQuery__
 *
 * To run a query within a Vue component, call `useListCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCategoriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListCategoriesQuery({
 *   input: // value for 'input'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 * });
 */
export function useListCategoriesQuery(variables: ListCategoriesQueryVariables | VueCompositionApi.Ref<ListCategoriesQueryVariables> | ReactiveFunction<ListCategoriesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListCategoriesQuery, ListCategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListCategoriesQuery, ListCategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListCategoriesQuery, ListCategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListCategoriesQuery, ListCategoriesQueryVariables>(ListCategoriesDocument, variables, options);
}
export function useListCategoriesLazyQuery(variables: ListCategoriesQueryVariables | VueCompositionApi.Ref<ListCategoriesQueryVariables> | ReactiveFunction<ListCategoriesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListCategoriesQuery, ListCategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListCategoriesQuery, ListCategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListCategoriesQuery, ListCategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListCategoriesQuery, ListCategoriesQueryVariables>(ListCategoriesDocument, variables, options);
}
export type ListCategoriesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListCategoriesQuery, ListCategoriesQueryVariables>;
export const GetUserInputDocument = gql`
    query getUserInput($id: Int!) {
  getUserInput(id: $id) {
    ...CompleteUserInput
  }
}
    ${CompleteUserInputFragmentDoc}`;

/**
 * __useGetUserInputQuery__
 *
 * To run a query within a Vue component, call `useGetUserInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInputQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUserInputQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetUserInputQuery(variables: GetUserInputQueryVariables | VueCompositionApi.Ref<GetUserInputQueryVariables> | ReactiveFunction<GetUserInputQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetUserInputQuery, GetUserInputQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserInputQuery, GetUserInputQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserInputQuery, GetUserInputQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetUserInputQuery, GetUserInputQueryVariables>(GetUserInputDocument, variables, options);
}
export function useGetUserInputLazyQuery(variables: GetUserInputQueryVariables | VueCompositionApi.Ref<GetUserInputQueryVariables> | ReactiveFunction<GetUserInputQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetUserInputQuery, GetUserInputQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserInputQuery, GetUserInputQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserInputQuery, GetUserInputQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetUserInputQuery, GetUserInputQueryVariables>(GetUserInputDocument, variables, options);
}
export type GetUserInputQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetUserInputQuery, GetUserInputQueryVariables>;
export const ListConceptsDocument = gql`
    query listConcepts($queryInput: ConceptQueryInput, $taxonomy: String, $kind: String, $label: String, $offset: Int!, $limit: Int!, $accountId: UUID, $withUserFeedback: Boolean = false) {
  listConcepts(
    queryInput: $queryInput
    taxonomy: $taxonomy
    kind: $kind
    label: $label
    offset: $offset
    limit: $limit
  ) {
    ...CompleteConcept
    insights(accountId: $accountId) @include(if: $withUserFeedback)
  }
  countConcepts(queryInput: $queryInput, taxonomy: $taxonomy, kind: $kind)
}
    ${CompleteConceptFragmentDoc}`;

/**
 * __useListConceptsQuery__
 *
 * To run a query within a Vue component, call `useListConceptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListConceptsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListConceptsQuery({
 *   queryInput: // value for 'queryInput'
 *   taxonomy: // value for 'taxonomy'
 *   kind: // value for 'kind'
 *   label: // value for 'label'
 *   offset: // value for 'offset'
 *   limit: // value for 'limit'
 *   accountId: // value for 'accountId'
 *   withUserFeedback: // value for 'withUserFeedback'
 * });
 */
export function useListConceptsQuery(variables: ListConceptsQueryVariables | VueCompositionApi.Ref<ListConceptsQueryVariables> | ReactiveFunction<ListConceptsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListConceptsQuery, ListConceptsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListConceptsQuery, ListConceptsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListConceptsQuery, ListConceptsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListConceptsQuery, ListConceptsQueryVariables>(ListConceptsDocument, variables, options);
}
export function useListConceptsLazyQuery(variables: ListConceptsQueryVariables | VueCompositionApi.Ref<ListConceptsQueryVariables> | ReactiveFunction<ListConceptsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListConceptsQuery, ListConceptsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListConceptsQuery, ListConceptsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListConceptsQuery, ListConceptsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListConceptsQuery, ListConceptsQueryVariables>(ListConceptsDocument, variables, options);
}
export type ListConceptsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListConceptsQuery, ListConceptsQueryVariables>;
export const ListEvidenceLinksDocument = gql`
    query listEvidenceLinks($filters: ListEvidenceLinkFilter, $limit: Int, $offset: Int) {
  listEvidenceLinks(filters: $filters, offset: $offset, limit: $limit) {
    id
    type
    evidenceId
    accountId
    account {
      id
      name
      type
    }
    evidence {
      id
      websiteUrl
      description
      comment
      internalUrl
      filename
    }
    entityUuidId
    entityIntId
    description
  }
  countEvidenceLinks(filters: $filters)
}
    `;

/**
 * __useListEvidenceLinksQuery__
 *
 * To run a query within a Vue component, call `useListEvidenceLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEvidenceLinksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListEvidenceLinksQuery({
 *   filters: // value for 'filters'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 * });
 */
export function useListEvidenceLinksQuery(variables: ListEvidenceLinksQueryVariables | VueCompositionApi.Ref<ListEvidenceLinksQueryVariables> | ReactiveFunction<ListEvidenceLinksQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListEvidenceLinksQuery, ListEvidenceLinksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListEvidenceLinksQuery, ListEvidenceLinksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListEvidenceLinksQuery, ListEvidenceLinksQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListEvidenceLinksQuery, ListEvidenceLinksQueryVariables>(ListEvidenceLinksDocument, variables, options);
}
export function useListEvidenceLinksLazyQuery(variables: ListEvidenceLinksQueryVariables | VueCompositionApi.Ref<ListEvidenceLinksQueryVariables> | ReactiveFunction<ListEvidenceLinksQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListEvidenceLinksQuery, ListEvidenceLinksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListEvidenceLinksQuery, ListEvidenceLinksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListEvidenceLinksQuery, ListEvidenceLinksQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListEvidenceLinksQuery, ListEvidenceLinksQueryVariables>(ListEvidenceLinksDocument, variables, options);
}
export type ListEvidenceLinksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListEvidenceLinksQuery, ListEvidenceLinksQueryVariables>;
export const ListEvidencesDocument = gql`
    query listEvidences($filters: ListEvidenceFilter, $offset: Int, $limit: Int) {
  listEvidences(filters: $filters, offset: $offset, limit: $limit) {
    id
    websiteUrl
    internalUrl
    filename
    description
    comment
    countEvidenceLinks
  }
  countEvidences(filters: $filters)
}
    `;

/**
 * __useListEvidencesQuery__
 *
 * To run a query within a Vue component, call `useListEvidencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEvidencesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListEvidencesQuery({
 *   filters: // value for 'filters'
 *   offset: // value for 'offset'
 *   limit: // value for 'limit'
 * });
 */
export function useListEvidencesQuery(variables: ListEvidencesQueryVariables | VueCompositionApi.Ref<ListEvidencesQueryVariables> | ReactiveFunction<ListEvidencesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListEvidencesQuery, ListEvidencesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListEvidencesQuery, ListEvidencesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListEvidencesQuery, ListEvidencesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListEvidencesQuery, ListEvidencesQueryVariables>(ListEvidencesDocument, variables, options);
}
export function useListEvidencesLazyQuery(variables: ListEvidencesQueryVariables | VueCompositionApi.Ref<ListEvidencesQueryVariables> | ReactiveFunction<ListEvidencesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListEvidencesQuery, ListEvidencesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListEvidencesQuery, ListEvidencesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListEvidencesQuery, ListEvidencesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListEvidencesQuery, ListEvidencesQueryVariables>(ListEvidencesDocument, variables, options);
}
export type ListEvidencesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListEvidencesQuery, ListEvidencesQueryVariables>;
export const ExportByCompanyDocument = gql`
    query exportByCompany($input: ExportExcelByCompanyInput!) {
  exportByCompany(input: $input) {
    ventureId
    file
  }
}
    `;

/**
 * __useExportByCompanyQuery__
 *
 * To run a query within a Vue component, call `useExportByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportByCompanyQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExportByCompanyQuery({
 *   input: // value for 'input'
 * });
 */
export function useExportByCompanyQuery(variables: ExportByCompanyQueryVariables | VueCompositionApi.Ref<ExportByCompanyQueryVariables> | ReactiveFunction<ExportByCompanyQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExportByCompanyQuery, ExportByCompanyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportByCompanyQuery, ExportByCompanyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportByCompanyQuery, ExportByCompanyQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ExportByCompanyQuery, ExportByCompanyQueryVariables>(ExportByCompanyDocument, variables, options);
}
export function useExportByCompanyLazyQuery(variables: ExportByCompanyQueryVariables | VueCompositionApi.Ref<ExportByCompanyQueryVariables> | ReactiveFunction<ExportByCompanyQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExportByCompanyQuery, ExportByCompanyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportByCompanyQuery, ExportByCompanyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportByCompanyQuery, ExportByCompanyQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ExportByCompanyQuery, ExportByCompanyQueryVariables>(ExportByCompanyDocument, variables, options);
}
export type ExportByCompanyQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ExportByCompanyQuery, ExportByCompanyQueryVariables>;
export const ExportByPortfolioDocument = gql`
    query exportByPortfolio {
  exportByPortfolio {
    portfolioId
    file
  }
}
    `;

/**
 * __useExportByPortfolioQuery__
 *
 * To run a query within a Vue component, call `useExportByPortfolioQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportByPortfolioQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExportByPortfolioQuery();
 */
export function useExportByPortfolioQuery(options: VueApolloComposable.UseQueryOptions<ExportByPortfolioQuery, ExportByPortfolioQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportByPortfolioQuery, ExportByPortfolioQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportByPortfolioQuery, ExportByPortfolioQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ExportByPortfolioQuery, ExportByPortfolioQueryVariables>(ExportByPortfolioDocument, {}, options);
}
export function useExportByPortfolioLazyQuery(options: VueApolloComposable.UseQueryOptions<ExportByPortfolioQuery, ExportByPortfolioQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportByPortfolioQuery, ExportByPortfolioQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportByPortfolioQuery, ExportByPortfolioQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ExportByPortfolioQuery, ExportByPortfolioQueryVariables>(ExportByPortfolioDocument, {}, options);
}
export type ExportByPortfolioQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ExportByPortfolioQuery, ExportByPortfolioQueryVariables>;
export const ExportCompanyTypstPdfDocument = gql`
    query exportCompanyTypstPdf($input: ExportCompanyTypstPdfInput!) {
  exportCompanyTypstPdf(input: $input) {
    fileName
    format
    base64String
  }
}
    `;

/**
 * __useExportCompanyTypstPdfQuery__
 *
 * To run a query within a Vue component, call `useExportCompanyTypstPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportCompanyTypstPdfQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExportCompanyTypstPdfQuery({
 *   input: // value for 'input'
 * });
 */
export function useExportCompanyTypstPdfQuery(variables: ExportCompanyTypstPdfQueryVariables | VueCompositionApi.Ref<ExportCompanyTypstPdfQueryVariables> | ReactiveFunction<ExportCompanyTypstPdfQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExportCompanyTypstPdfQuery, ExportCompanyTypstPdfQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportCompanyTypstPdfQuery, ExportCompanyTypstPdfQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportCompanyTypstPdfQuery, ExportCompanyTypstPdfQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ExportCompanyTypstPdfQuery, ExportCompanyTypstPdfQueryVariables>(ExportCompanyTypstPdfDocument, variables, options);
}
export function useExportCompanyTypstPdfLazyQuery(variables: ExportCompanyTypstPdfQueryVariables | VueCompositionApi.Ref<ExportCompanyTypstPdfQueryVariables> | ReactiveFunction<ExportCompanyTypstPdfQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExportCompanyTypstPdfQuery, ExportCompanyTypstPdfQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportCompanyTypstPdfQuery, ExportCompanyTypstPdfQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportCompanyTypstPdfQuery, ExportCompanyTypstPdfQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ExportCompanyTypstPdfQuery, ExportCompanyTypstPdfQueryVariables>(ExportCompanyTypstPdfDocument, variables, options);
}
export type ExportCompanyTypstPdfQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ExportCompanyTypstPdfQuery, ExportCompanyTypstPdfQueryVariables>;
export const ExportFundReportDocument = gql`
    query exportFundReport($input: ExportFundReportInput!) {
  exportFundReport(input: $input) {
    fundId
    file
  }
}
    `;

/**
 * __useExportFundReportQuery__
 *
 * To run a query within a Vue component, call `useExportFundReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportFundReportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExportFundReportQuery({
 *   input: // value for 'input'
 * });
 */
export function useExportFundReportQuery(variables: ExportFundReportQueryVariables | VueCompositionApi.Ref<ExportFundReportQueryVariables> | ReactiveFunction<ExportFundReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExportFundReportQuery, ExportFundReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportFundReportQuery, ExportFundReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportFundReportQuery, ExportFundReportQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ExportFundReportQuery, ExportFundReportQueryVariables>(ExportFundReportDocument, variables, options);
}
export function useExportFundReportLazyQuery(variables: ExportFundReportQueryVariables | VueCompositionApi.Ref<ExportFundReportQueryVariables> | ReactiveFunction<ExportFundReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExportFundReportQuery, ExportFundReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportFundReportQuery, ExportFundReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportFundReportQuery, ExportFundReportQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ExportFundReportQuery, ExportFundReportQueryVariables>(ExportFundReportDocument, variables, options);
}
export type ExportFundReportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ExportFundReportQuery, ExportFundReportQueryVariables>;
export const ExportKfwDocument = gql`
    query exportKfw($input: ExportKfWInput!) {
  exportKfw(input: $input) {
    zipFile {
      fileName
      base64String
      format
    }
    files {
      fileName
      base64String
      format
    }
  }
}
    `;

/**
 * __useExportKfwQuery__
 *
 * To run a query within a Vue component, call `useExportKfwQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportKfwQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExportKfwQuery({
 *   input: // value for 'input'
 * });
 */
export function useExportKfwQuery(variables: ExportKfwQueryVariables | VueCompositionApi.Ref<ExportKfwQueryVariables> | ReactiveFunction<ExportKfwQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExportKfwQuery, ExportKfwQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportKfwQuery, ExportKfwQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportKfwQuery, ExportKfwQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ExportKfwQuery, ExportKfwQueryVariables>(ExportKfwDocument, variables, options);
}
export function useExportKfwLazyQuery(variables: ExportKfwQueryVariables | VueCompositionApi.Ref<ExportKfwQueryVariables> | ReactiveFunction<ExportKfwQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExportKfwQuery, ExportKfwQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportKfwQuery, ExportKfwQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportKfwQuery, ExportKfwQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ExportKfwQuery, ExportKfwQueryVariables>(ExportKfwDocument, variables, options);
}
export type ExportKfwQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ExportKfwQuery, ExportKfwQueryVariables>;
export const ExportNkiCompanyDataDocument = gql`
    query exportNkiCompanyData($input: ExportNkiCompanyDataInput) {
  exportNkiCompanyData(input: $input) {
    fileName
    format
    base64String
  }
}
    `;

/**
 * __useExportNkiCompanyDataQuery__
 *
 * To run a query within a Vue component, call `useExportNkiCompanyDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportNkiCompanyDataQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExportNkiCompanyDataQuery({
 *   input: // value for 'input'
 * });
 */
export function useExportNkiCompanyDataQuery(variables: ExportNkiCompanyDataQueryVariables | VueCompositionApi.Ref<ExportNkiCompanyDataQueryVariables> | ReactiveFunction<ExportNkiCompanyDataQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ExportNkiCompanyDataQuery, ExportNkiCompanyDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportNkiCompanyDataQuery, ExportNkiCompanyDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportNkiCompanyDataQuery, ExportNkiCompanyDataQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ExportNkiCompanyDataQuery, ExportNkiCompanyDataQueryVariables>(ExportNkiCompanyDataDocument, variables, options);
}
export function useExportNkiCompanyDataLazyQuery(variables: ExportNkiCompanyDataQueryVariables | VueCompositionApi.Ref<ExportNkiCompanyDataQueryVariables> | ReactiveFunction<ExportNkiCompanyDataQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ExportNkiCompanyDataQuery, ExportNkiCompanyDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportNkiCompanyDataQuery, ExportNkiCompanyDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportNkiCompanyDataQuery, ExportNkiCompanyDataQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ExportNkiCompanyDataQuery, ExportNkiCompanyDataQueryVariables>(ExportNkiCompanyDataDocument, variables, options);
}
export type ExportNkiCompanyDataQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ExportNkiCompanyDataQuery, ExportNkiCompanyDataQueryVariables>;
export const ExportPaiReportDocument = gql`
    query exportPaiReport($input: ExportPaiReportInput!) {
  exportPaiReport(input: $input) {
    fundId
    file
  }
}
    `;

/**
 * __useExportPaiReportQuery__
 *
 * To run a query within a Vue component, call `useExportPaiReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportPaiReportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExportPaiReportQuery({
 *   input: // value for 'input'
 * });
 */
export function useExportPaiReportQuery(variables: ExportPaiReportQueryVariables | VueCompositionApi.Ref<ExportPaiReportQueryVariables> | ReactiveFunction<ExportPaiReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExportPaiReportQuery, ExportPaiReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportPaiReportQuery, ExportPaiReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportPaiReportQuery, ExportPaiReportQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ExportPaiReportQuery, ExportPaiReportQueryVariables>(ExportPaiReportDocument, variables, options);
}
export function useExportPaiReportLazyQuery(variables: ExportPaiReportQueryVariables | VueCompositionApi.Ref<ExportPaiReportQueryVariables> | ReactiveFunction<ExportPaiReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExportPaiReportQuery, ExportPaiReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportPaiReportQuery, ExportPaiReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportPaiReportQuery, ExportPaiReportQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ExportPaiReportQuery, ExportPaiReportQueryVariables>(ExportPaiReportDocument, variables, options);
}
export type ExportPaiReportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ExportPaiReportQuery, ExportPaiReportQueryVariables>;
export const ExportPrecontractualReportDocument = gql`
    query exportPrecontractualReport($input: ExportPrecontractualReportInput!) {
  exportPrecontractualReport(input: $input) {
    fundId
    file
  }
}
    `;

/**
 * __useExportPrecontractualReportQuery__
 *
 * To run a query within a Vue component, call `useExportPrecontractualReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportPrecontractualReportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExportPrecontractualReportQuery({
 *   input: // value for 'input'
 * });
 */
export function useExportPrecontractualReportQuery(variables: ExportPrecontractualReportQueryVariables | VueCompositionApi.Ref<ExportPrecontractualReportQueryVariables> | ReactiveFunction<ExportPrecontractualReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExportPrecontractualReportQuery, ExportPrecontractualReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportPrecontractualReportQuery, ExportPrecontractualReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportPrecontractualReportQuery, ExportPrecontractualReportQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ExportPrecontractualReportQuery, ExportPrecontractualReportQueryVariables>(ExportPrecontractualReportDocument, variables, options);
}
export function useExportPrecontractualReportLazyQuery(variables: ExportPrecontractualReportQueryVariables | VueCompositionApi.Ref<ExportPrecontractualReportQueryVariables> | ReactiveFunction<ExportPrecontractualReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExportPrecontractualReportQuery, ExportPrecontractualReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportPrecontractualReportQuery, ExportPrecontractualReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportPrecontractualReportQuery, ExportPrecontractualReportQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ExportPrecontractualReportQuery, ExportPrecontractualReportQueryVariables>(ExportPrecontractualReportDocument, variables, options);
}
export type ExportPrecontractualReportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ExportPrecontractualReportQuery, ExportPrecontractualReportQueryVariables>;
export const ListFeedbacksDocument = gql`
    query ListFeedbacks($limit: Int, $offset: Int) {
  listFeedbacks(limit: $limit, offset: $offset) {
    id
    accountId
    userId
    user {
      email
    }
    title
    description
    rating
    url
    createdAt
  }
  countFeedbacks
}
    `;

/**
 * __useListFeedbacksQuery__
 *
 * To run a query within a Vue component, call `useListFeedbacksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFeedbacksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListFeedbacksQuery({
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 * });
 */
export function useListFeedbacksQuery(variables: ListFeedbacksQueryVariables | VueCompositionApi.Ref<ListFeedbacksQueryVariables> | ReactiveFunction<ListFeedbacksQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListFeedbacksQuery, ListFeedbacksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListFeedbacksQuery, ListFeedbacksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListFeedbacksQuery, ListFeedbacksQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListFeedbacksQuery, ListFeedbacksQueryVariables>(ListFeedbacksDocument, variables, options);
}
export function useListFeedbacksLazyQuery(variables: ListFeedbacksQueryVariables | VueCompositionApi.Ref<ListFeedbacksQueryVariables> | ReactiveFunction<ListFeedbacksQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListFeedbacksQuery, ListFeedbacksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListFeedbacksQuery, ListFeedbacksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListFeedbacksQuery, ListFeedbacksQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListFeedbacksQuery, ListFeedbacksQueryVariables>(ListFeedbacksDocument, variables, options);
}
export type ListFeedbacksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListFeedbacksQuery, ListFeedbacksQueryVariables>;
export const GetFundDocument = gql`
    query getFund($id: Int!) {
  getFund(id: $id) {
    ...CompleteFund
    portfolio {
      ...BasicInfoPortfolio
      ventureLinks {
        ventureId
        modules
      }
    }
  }
}
    ${CompleteFundFragmentDoc}
${BasicInfoPortfolioFragmentDoc}`;

/**
 * __useGetFundQuery__
 *
 * To run a query within a Vue component, call `useGetFundQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetFundQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetFundQuery(variables: GetFundQueryVariables | VueCompositionApi.Ref<GetFundQueryVariables> | ReactiveFunction<GetFundQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetFundQuery, GetFundQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetFundQuery, GetFundQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetFundQuery, GetFundQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetFundQuery, GetFundQueryVariables>(GetFundDocument, variables, options);
}
export function useGetFundLazyQuery(variables: GetFundQueryVariables | VueCompositionApi.Ref<GetFundQueryVariables> | ReactiveFunction<GetFundQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetFundQuery, GetFundQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetFundQuery, GetFundQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetFundQuery, GetFundQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetFundQuery, GetFundQueryVariables>(GetFundDocument, variables, options);
}
export type GetFundQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetFundQuery, GetFundQueryVariables>;
export const GetFundSetupStateDocument = gql`
    query getFundSetupState($id: Int!) {
  fundSetupState(id: $id) {
    fundId
    isInSync
    completion {
      value
      items {
        key
        canonicalKey
        result
        applicable
        why
        details {
          key
          canonicalKey
          result
          applicable
          why
        }
      }
    }
    syncState {
      esgQuestionnaire
      esgModule
      fundAggregations
      fundAssignments
      euTaxonomyChecks
      kfwAssignments
      fundAggregationsToAdd {
        metricId
        groupType
        groupId
        metric {
          name
        }
        why
      }
      fundAggregationsToDelete {
        metricId
        groupType
        groupId
        metric {
          name
        }
        why
      }
      assignmentsToAdd {
        metricId
        assigneeId
        fundId
        metric {
          name
        }
        assignee {
          name
        }
        why
      }
      moduleUpdates {
        assignee {
          id
          name
        }
        modulesToAdd
      }
      esgQuestionnairesToAdd {
        assignee {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetFundSetupStateQuery__
 *
 * To run a query within a Vue component, call `useGetFundSetupStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundSetupStateQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetFundSetupStateQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetFundSetupStateQuery(variables: GetFundSetupStateQueryVariables | VueCompositionApi.Ref<GetFundSetupStateQueryVariables> | ReactiveFunction<GetFundSetupStateQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetFundSetupStateQuery, GetFundSetupStateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetFundSetupStateQuery, GetFundSetupStateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetFundSetupStateQuery, GetFundSetupStateQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetFundSetupStateQuery, GetFundSetupStateQueryVariables>(GetFundSetupStateDocument, variables, options);
}
export function useGetFundSetupStateLazyQuery(variables: GetFundSetupStateQueryVariables | VueCompositionApi.Ref<GetFundSetupStateQueryVariables> | ReactiveFunction<GetFundSetupStateQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetFundSetupStateQuery, GetFundSetupStateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetFundSetupStateQuery, GetFundSetupStateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetFundSetupStateQuery, GetFundSetupStateQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetFundSetupStateQuery, GetFundSetupStateQueryVariables>(GetFundSetupStateDocument, variables, options);
}
export type GetFundSetupStateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetFundSetupStateQuery, GetFundSetupStateQueryVariables>;
export const ListFundsDocument = gql`
    query listFunds($keyword: String, $offset: Int, $limit: Int) {
  listFunds(keyword: $keyword, offset: $offset, limit: $limit) {
    id
    name
    volume
    ventureIds
    ventures {
      id
      name
    }
    fundStrategy
    isReportingPais
    legalEntityIdentifier
    isReportingKfw
    sustainableObjectives {
      id
      isEnvironmentalGoal
      doCheckEuTaxonomyAlignment
      euTaxonomyConceptId
      euTaxonomyConcept {
        id
      }
    }
    esCharacteristics {
      id
    }
    portfolio {
      name
    }
  }
  countFunds
}
    `;

/**
 * __useListFundsQuery__
 *
 * To run a query within a Vue component, call `useListFundsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFundsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListFundsQuery({
 *   keyword: // value for 'keyword'
 *   offset: // value for 'offset'
 *   limit: // value for 'limit'
 * });
 */
export function useListFundsQuery(variables: ListFundsQueryVariables | VueCompositionApi.Ref<ListFundsQueryVariables> | ReactiveFunction<ListFundsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListFundsQuery, ListFundsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListFundsQuery, ListFundsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListFundsQuery, ListFundsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListFundsQuery, ListFundsQueryVariables>(ListFundsDocument, variables, options);
}
export function useListFundsLazyQuery(variables: ListFundsQueryVariables | VueCompositionApi.Ref<ListFundsQueryVariables> | ReactiveFunction<ListFundsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListFundsQuery, ListFundsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListFundsQuery, ListFundsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListFundsQuery, ListFundsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListFundsQuery, ListFundsQueryVariables>(ListFundsDocument, variables, options);
}
export type ListFundsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListFundsQuery, ListFundsQueryVariables>;
export const DelFundsDocument = gql`
    mutation delFunds($ids: [Int!]!) {
  delFunds(ids: $ids)
}
    `;

/**
 * __useDelFundsMutation__
 *
 * To run a mutation, you first call `useDelFundsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDelFundsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDelFundsMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useDelFundsMutation(options: VueApolloComposable.UseMutationOptions<DelFundsMutation, DelFundsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DelFundsMutation, DelFundsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DelFundsMutation, DelFundsMutationVariables>(DelFundsDocument, options);
}
export type DelFundsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DelFundsMutation, DelFundsMutationVariables>;
export const ListFlatGeographiesDocument = gql`
    query ListFlatGeographies($filters: ListGeographyFilter, $limit: Int, $offset: Int) {
  listGeographies(filters: $filters, limit: $limit, offset: $offset) {
    id
    label
    isoAlpha2
    parentId
    children {
      id
    }
  }
}
    `;

/**
 * __useListFlatGeographiesQuery__
 *
 * To run a query within a Vue component, call `useListFlatGeographiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFlatGeographiesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListFlatGeographiesQuery({
 *   filters: // value for 'filters'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 * });
 */
export function useListFlatGeographiesQuery(variables: ListFlatGeographiesQueryVariables | VueCompositionApi.Ref<ListFlatGeographiesQueryVariables> | ReactiveFunction<ListFlatGeographiesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListFlatGeographiesQuery, ListFlatGeographiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListFlatGeographiesQuery, ListFlatGeographiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListFlatGeographiesQuery, ListFlatGeographiesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListFlatGeographiesQuery, ListFlatGeographiesQueryVariables>(ListFlatGeographiesDocument, variables, options);
}
export function useListFlatGeographiesLazyQuery(variables: ListFlatGeographiesQueryVariables | VueCompositionApi.Ref<ListFlatGeographiesQueryVariables> | ReactiveFunction<ListFlatGeographiesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListFlatGeographiesQuery, ListFlatGeographiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListFlatGeographiesQuery, ListFlatGeographiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListFlatGeographiesQuery, ListFlatGeographiesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListFlatGeographiesQuery, ListFlatGeographiesQueryVariables>(ListFlatGeographiesDocument, variables, options);
}
export type ListFlatGeographiesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListFlatGeographiesQuery, ListFlatGeographiesQueryVariables>;
export const ListNestedGeographiesDocument = gql`
    query ListNestedGeographies($filters: ListGeographyFilter, $limit: Int, $offset: Int) {
  listGeographies(filters: $filters, limit: $limit, offset: $offset) {
    id
    label
    isoAlpha2
    parentId
    children {
      id
      label
      isoAlpha2
      parentId
      children {
        id
        label
        isoAlpha2
        parentId
        children {
          id
          label
          isoAlpha2
          parentId
        }
      }
    }
  }
}
    `;

/**
 * __useListNestedGeographiesQuery__
 *
 * To run a query within a Vue component, call `useListNestedGeographiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListNestedGeographiesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListNestedGeographiesQuery({
 *   filters: // value for 'filters'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 * });
 */
export function useListNestedGeographiesQuery(variables: ListNestedGeographiesQueryVariables | VueCompositionApi.Ref<ListNestedGeographiesQueryVariables> | ReactiveFunction<ListNestedGeographiesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListNestedGeographiesQuery, ListNestedGeographiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListNestedGeographiesQuery, ListNestedGeographiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListNestedGeographiesQuery, ListNestedGeographiesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListNestedGeographiesQuery, ListNestedGeographiesQueryVariables>(ListNestedGeographiesDocument, variables, options);
}
export function useListNestedGeographiesLazyQuery(variables: ListNestedGeographiesQueryVariables | VueCompositionApi.Ref<ListNestedGeographiesQueryVariables> | ReactiveFunction<ListNestedGeographiesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListNestedGeographiesQuery, ListNestedGeographiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListNestedGeographiesQuery, ListNestedGeographiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListNestedGeographiesQuery, ListNestedGeographiesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListNestedGeographiesQuery, ListNestedGeographiesQueryVariables>(ListNestedGeographiesDocument, variables, options);
}
export type ListNestedGeographiesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListNestedGeographiesQuery, ListNestedGeographiesQueryVariables>;
export const GetMetricDocument = gql`
    query getMetric($id: Int!) {
  getMetric(id: $id) {
    ...CompleteMetric
  }
}
    ${CompleteMetricFragmentDoc}`;

/**
 * __useGetMetricQuery__
 *
 * To run a query within a Vue component, call `useGetMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMetricQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetMetricQuery(variables: GetMetricQueryVariables | VueCompositionApi.Ref<GetMetricQueryVariables> | ReactiveFunction<GetMetricQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMetricQuery, GetMetricQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMetricQuery, GetMetricQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMetricQuery, GetMetricQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMetricQuery, GetMetricQueryVariables>(GetMetricDocument, variables, options);
}
export function useGetMetricLazyQuery(variables: GetMetricQueryVariables | VueCompositionApi.Ref<GetMetricQueryVariables> | ReactiveFunction<GetMetricQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMetricQuery, GetMetricQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMetricQuery, GetMetricQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMetricQuery, GetMetricQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMetricQuery, GetMetricQueryVariables>(GetMetricDocument, variables, options);
}
export type GetMetricQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMetricQuery, GetMetricQueryVariables>;
export const GetSectionWithQuestionsDocument = gql`
    query getSectionWithQuestions($id: Int!, $fundId: Int, $referencePeriodId: Int) {
  getSection(id: $id) {
    label
    children {
      ... on SectionType {
        ...section
      }
      ... on QuestionSectionLinkType {
        ...question
      }
    }
  }
}
    ${SectionFragmentDoc}
${QuestionFragmentDoc}`;

/**
 * __useGetSectionWithQuestionsQuery__
 *
 * To run a query within a Vue component, call `useGetSectionWithQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSectionWithQuestionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSectionWithQuestionsQuery({
 *   id: // value for 'id'
 *   fundId: // value for 'fundId'
 *   referencePeriodId: // value for 'referencePeriodId'
 * });
 */
export function useGetSectionWithQuestionsQuery(variables: GetSectionWithQuestionsQueryVariables | VueCompositionApi.Ref<GetSectionWithQuestionsQueryVariables> | ReactiveFunction<GetSectionWithQuestionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetSectionWithQuestionsQuery, GetSectionWithQuestionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSectionWithQuestionsQuery, GetSectionWithQuestionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSectionWithQuestionsQuery, GetSectionWithQuestionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetSectionWithQuestionsQuery, GetSectionWithQuestionsQueryVariables>(GetSectionWithQuestionsDocument, variables, options);
}
export function useGetSectionWithQuestionsLazyQuery(variables: GetSectionWithQuestionsQueryVariables | VueCompositionApi.Ref<GetSectionWithQuestionsQueryVariables> | ReactiveFunction<GetSectionWithQuestionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetSectionWithQuestionsQuery, GetSectionWithQuestionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSectionWithQuestionsQuery, GetSectionWithQuestionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSectionWithQuestionsQuery, GetSectionWithQuestionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetSectionWithQuestionsQuery, GetSectionWithQuestionsQueryVariables>(GetSectionWithQuestionsDocument, variables, options);
}
export type GetSectionWithQuestionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetSectionWithQuestionsQuery, GetSectionWithQuestionsQueryVariables>;
export const ListUniqueIdematUnitsAndCategoriesDocument = gql`
    query listUniqueIdematUnitsAndCategories {
  listUniqueIdematUnitsAndCategories {
    units
    categories
  }
}
    `;

/**
 * __useListUniqueIdematUnitsAndCategoriesQuery__
 *
 * To run a query within a Vue component, call `useListUniqueIdematUnitsAndCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUniqueIdematUnitsAndCategoriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListUniqueIdematUnitsAndCategoriesQuery();
 */
export function useListUniqueIdematUnitsAndCategoriesQuery(options: VueApolloComposable.UseQueryOptions<ListUniqueIdematUnitsAndCategoriesQuery, ListUniqueIdematUnitsAndCategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListUniqueIdematUnitsAndCategoriesQuery, ListUniqueIdematUnitsAndCategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListUniqueIdematUnitsAndCategoriesQuery, ListUniqueIdematUnitsAndCategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListUniqueIdematUnitsAndCategoriesQuery, ListUniqueIdematUnitsAndCategoriesQueryVariables>(ListUniqueIdematUnitsAndCategoriesDocument, {}, options);
}
export function useListUniqueIdematUnitsAndCategoriesLazyQuery(options: VueApolloComposable.UseQueryOptions<ListUniqueIdematUnitsAndCategoriesQuery, ListUniqueIdematUnitsAndCategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListUniqueIdematUnitsAndCategoriesQuery, ListUniqueIdematUnitsAndCategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListUniqueIdematUnitsAndCategoriesQuery, ListUniqueIdematUnitsAndCategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListUniqueIdematUnitsAndCategoriesQuery, ListUniqueIdematUnitsAndCategoriesQueryVariables>(ListUniqueIdematUnitsAndCategoriesDocument, {}, options);
}
export type ListUniqueIdematUnitsAndCategoriesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListUniqueIdematUnitsAndCategoriesQuery, ListUniqueIdematUnitsAndCategoriesQueryVariables>;
export const GetImpactDocument = gql`
    query getImpact($impactId: Int!) {
  getImpact(impactId: $impactId) {
    ...CompleteImpact
  }
}
    ${CompleteImpactFragmentDoc}`;

/**
 * __useGetImpactQuery__
 *
 * To run a query within a Vue component, call `useGetImpactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImpactQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetImpactQuery({
 *   impactId: // value for 'impactId'
 * });
 */
export function useGetImpactQuery(variables: GetImpactQueryVariables | VueCompositionApi.Ref<GetImpactQueryVariables> | ReactiveFunction<GetImpactQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetImpactQuery, GetImpactQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetImpactQuery, GetImpactQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetImpactQuery, GetImpactQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetImpactQuery, GetImpactQueryVariables>(GetImpactDocument, variables, options);
}
export function useGetImpactLazyQuery(variables: GetImpactQueryVariables | VueCompositionApi.Ref<GetImpactQueryVariables> | ReactiveFunction<GetImpactQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetImpactQuery, GetImpactQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetImpactQuery, GetImpactQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetImpactQuery, GetImpactQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetImpactQuery, GetImpactQueryVariables>(GetImpactDocument, variables, options);
}
export type GetImpactQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetImpactQuery, GetImpactQueryVariables>;
export const GetImpactGeographiesForVenturesDocument = gql`
    query getImpactGeographiesForVentures($ventureIds: [String!]!) {
  getImpactGeographiesForVentures(ventureIds: $ventureIds) {
    geography {
      id
      label
      externalId
    }
    impacts {
      id
      concept {
        id
        label
      }
      stakeholder
      geographies {
        id
        label
      }
      impactGoal {
        id
        ventureId
      }
    }
  }
}
    `;

/**
 * __useGetImpactGeographiesForVenturesQuery__
 *
 * To run a query within a Vue component, call `useGetImpactGeographiesForVenturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImpactGeographiesForVenturesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetImpactGeographiesForVenturesQuery({
 *   ventureIds: // value for 'ventureIds'
 * });
 */
export function useGetImpactGeographiesForVenturesQuery(variables: GetImpactGeographiesForVenturesQueryVariables | VueCompositionApi.Ref<GetImpactGeographiesForVenturesQueryVariables> | ReactiveFunction<GetImpactGeographiesForVenturesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetImpactGeographiesForVenturesQuery, GetImpactGeographiesForVenturesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetImpactGeographiesForVenturesQuery, GetImpactGeographiesForVenturesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetImpactGeographiesForVenturesQuery, GetImpactGeographiesForVenturesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetImpactGeographiesForVenturesQuery, GetImpactGeographiesForVenturesQueryVariables>(GetImpactGeographiesForVenturesDocument, variables, options);
}
export function useGetImpactGeographiesForVenturesLazyQuery(variables: GetImpactGeographiesForVenturesQueryVariables | VueCompositionApi.Ref<GetImpactGeographiesForVenturesQueryVariables> | ReactiveFunction<GetImpactGeographiesForVenturesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetImpactGeographiesForVenturesQuery, GetImpactGeographiesForVenturesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetImpactGeographiesForVenturesQuery, GetImpactGeographiesForVenturesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetImpactGeographiesForVenturesQuery, GetImpactGeographiesForVenturesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetImpactGeographiesForVenturesQuery, GetImpactGeographiesForVenturesQueryVariables>(GetImpactGeographiesForVenturesDocument, variables, options);
}
export type GetImpactGeographiesForVenturesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetImpactGeographiesForVenturesQuery, GetImpactGeographiesForVenturesQueryVariables>;
export const GetImpactGoalDocument = gql`
    query getImpactGoal($ventureId: String) {
  getImpactGoal(ventureId: $ventureId) {
    ...CompleteImpactGoal
  }
}
    ${CompleteImpactGoalFragmentDoc}`;

/**
 * __useGetImpactGoalQuery__
 *
 * To run a query within a Vue component, call `useGetImpactGoalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImpactGoalQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetImpactGoalQuery({
 *   ventureId: // value for 'ventureId'
 * });
 */
export function useGetImpactGoalQuery(variables: GetImpactGoalQueryVariables | VueCompositionApi.Ref<GetImpactGoalQueryVariables> | ReactiveFunction<GetImpactGoalQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetImpactGoalQuery, GetImpactGoalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetImpactGoalQuery, GetImpactGoalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetImpactGoalQuery, GetImpactGoalQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetImpactGoalQuery, GetImpactGoalQueryVariables>(GetImpactGoalDocument, variables, options);
}
export function useGetImpactGoalLazyQuery(variables: GetImpactGoalQueryVariables | VueCompositionApi.Ref<GetImpactGoalQueryVariables> | ReactiveFunction<GetImpactGoalQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetImpactGoalQuery, GetImpactGoalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetImpactGoalQuery, GetImpactGoalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetImpactGoalQuery, GetImpactGoalQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetImpactGoalQuery, GetImpactGoalQueryVariables>(GetImpactGoalDocument, variables, options);
}
export type GetImpactGoalQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetImpactGoalQuery, GetImpactGoalQueryVariables>;
export const GetImpactGoalLockStatesDocument = gql`
    query GetImpactGoalLockStates($ventureId: String!) {
  getImpactGoal(ventureId: $ventureId) {
    id
    ventureId
    impacts {
      id
      isEditable
      submitDate
      concept {
        label
      }
    }
  }
}
    `;

/**
 * __useGetImpactGoalLockStatesQuery__
 *
 * To run a query within a Vue component, call `useGetImpactGoalLockStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImpactGoalLockStatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetImpactGoalLockStatesQuery({
 *   ventureId: // value for 'ventureId'
 * });
 */
export function useGetImpactGoalLockStatesQuery(variables: GetImpactGoalLockStatesQueryVariables | VueCompositionApi.Ref<GetImpactGoalLockStatesQueryVariables> | ReactiveFunction<GetImpactGoalLockStatesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetImpactGoalLockStatesQuery, GetImpactGoalLockStatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetImpactGoalLockStatesQuery, GetImpactGoalLockStatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetImpactGoalLockStatesQuery, GetImpactGoalLockStatesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetImpactGoalLockStatesQuery, GetImpactGoalLockStatesQueryVariables>(GetImpactGoalLockStatesDocument, variables, options);
}
export function useGetImpactGoalLockStatesLazyQuery(variables: GetImpactGoalLockStatesQueryVariables | VueCompositionApi.Ref<GetImpactGoalLockStatesQueryVariables> | ReactiveFunction<GetImpactGoalLockStatesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetImpactGoalLockStatesQuery, GetImpactGoalLockStatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetImpactGoalLockStatesQuery, GetImpactGoalLockStatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetImpactGoalLockStatesQuery, GetImpactGoalLockStatesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetImpactGoalLockStatesQuery, GetImpactGoalLockStatesQueryVariables>(GetImpactGoalLockStatesDocument, variables, options);
}
export type GetImpactGoalLockStatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetImpactGoalLockStatesQuery, GetImpactGoalLockStatesQueryVariables>;
export const GetImpactSdgsForVenturesDocument = gql`
    query getImpactSdgsForVentures {
  getImpactSdgsForVentures {
    sdgNumber
    impacts {
      id
      concept {
        id
        label
      }
      stakeholder
      impactGoal {
        id
        ventureId
      }
    }
  }
}
    `;

/**
 * __useGetImpactSdgsForVenturesQuery__
 *
 * To run a query within a Vue component, call `useGetImpactSdgsForVenturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImpactSdgsForVenturesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetImpactSdgsForVenturesQuery();
 */
export function useGetImpactSdgsForVenturesQuery(options: VueApolloComposable.UseQueryOptions<GetImpactSdgsForVenturesQuery, GetImpactSdgsForVenturesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetImpactSdgsForVenturesQuery, GetImpactSdgsForVenturesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetImpactSdgsForVenturesQuery, GetImpactSdgsForVenturesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetImpactSdgsForVenturesQuery, GetImpactSdgsForVenturesQueryVariables>(GetImpactSdgsForVenturesDocument, {}, options);
}
export function useGetImpactSdgsForVenturesLazyQuery(options: VueApolloComposable.UseQueryOptions<GetImpactSdgsForVenturesQuery, GetImpactSdgsForVenturesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetImpactSdgsForVenturesQuery, GetImpactSdgsForVenturesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetImpactSdgsForVenturesQuery, GetImpactSdgsForVenturesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetImpactSdgsForVenturesQuery, GetImpactSdgsForVenturesQueryVariables>(GetImpactSdgsForVenturesDocument, {}, options);
}
export type GetImpactSdgsForVenturesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetImpactSdgsForVenturesQuery, GetImpactSdgsForVenturesQueryVariables>;
export const GetImpactSummaryDocument = gql`
    query getImpactSummary($ventureId: String!) {
  getImpactSummary(ventureId: $ventureId) {
    totalGhgReduction
    averageTotalGhgReduction {
      center
      lowerBound
      upperBound
    }
    averageAnnualReduction
    economicValue
    ghgMetricValues {
      ...CompleteMetricValue
    }
    impactSolutionSummaries {
      totalGhgReduction
      startYear
      endYear
      impactConcept
      impactSolution {
        id
        kind
        targetGroup
        solutionDescription
        concept {
          id
          label
        }
        ghgSavingPotential {
          ...CompleteGhgSavingPotential
        }
      }
      ghgMetricValues {
        ...CompleteMetricValue
      }
      forecastAssignment {
        id
        metricNameOverride
        completionStatus {
          ...CompleteCompletionStatus
        }
        unitName
      }
      forecastValues {
        ...CompleteMetricValue
      }
    }
  }
}
    ${CompleteMetricValueFragmentDoc}
${CompleteGhgSavingPotentialFragmentDoc}
${CompleteCompletionStatusFragmentDoc}`;

/**
 * __useGetImpactSummaryQuery__
 *
 * To run a query within a Vue component, call `useGetImpactSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImpactSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetImpactSummaryQuery({
 *   ventureId: // value for 'ventureId'
 * });
 */
export function useGetImpactSummaryQuery(variables: GetImpactSummaryQueryVariables | VueCompositionApi.Ref<GetImpactSummaryQueryVariables> | ReactiveFunction<GetImpactSummaryQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetImpactSummaryQuery, GetImpactSummaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetImpactSummaryQuery, GetImpactSummaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetImpactSummaryQuery, GetImpactSummaryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetImpactSummaryQuery, GetImpactSummaryQueryVariables>(GetImpactSummaryDocument, variables, options);
}
export function useGetImpactSummaryLazyQuery(variables: GetImpactSummaryQueryVariables | VueCompositionApi.Ref<GetImpactSummaryQueryVariables> | ReactiveFunction<GetImpactSummaryQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetImpactSummaryQuery, GetImpactSummaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetImpactSummaryQuery, GetImpactSummaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetImpactSummaryQuery, GetImpactSummaryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetImpactSummaryQuery, GetImpactSummaryQueryVariables>(GetImpactSummaryDocument, variables, options);
}
export type GetImpactSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetImpactSummaryQuery, GetImpactSummaryQueryVariables>;
export const ListImpactGoalsDocument = gql`
    query listImpactGoals($filters: ListImpactGoalFilters) {
  listImpactGoals(filters: $filters) {
    ...CompleteImpactGoal
  }
}
    ${CompleteImpactGoalFragmentDoc}`;

/**
 * __useListImpactGoalsQuery__
 *
 * To run a query within a Vue component, call `useListImpactGoalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListImpactGoalsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListImpactGoalsQuery({
 *   filters: // value for 'filters'
 * });
 */
export function useListImpactGoalsQuery(variables: ListImpactGoalsQueryVariables | VueCompositionApi.Ref<ListImpactGoalsQueryVariables> | ReactiveFunction<ListImpactGoalsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListImpactGoalsQuery, ListImpactGoalsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListImpactGoalsQuery, ListImpactGoalsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListImpactGoalsQuery, ListImpactGoalsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListImpactGoalsQuery, ListImpactGoalsQueryVariables>(ListImpactGoalsDocument, variables, options);
}
export function useListImpactGoalsLazyQuery(variables: ListImpactGoalsQueryVariables | VueCompositionApi.Ref<ListImpactGoalsQueryVariables> | ReactiveFunction<ListImpactGoalsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListImpactGoalsQuery, ListImpactGoalsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListImpactGoalsQuery, ListImpactGoalsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListImpactGoalsQuery, ListImpactGoalsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListImpactGoalsQuery, ListImpactGoalsQueryVariables>(ListImpactGoalsDocument, variables, options);
}
export type ListImpactGoalsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListImpactGoalsQuery, ListImpactGoalsQueryVariables>;
export const ListIdematsDocument = gql`
    query listIdemats($input: IdematSearchInput!, $offset: Int, $limit: Int, $filters: IdematSearchInput, $sort: [SortParam!]) {
  listIdemats(input: $input, offset: $offset, limit: $limit, sort: $sort) {
    id
    idematId
    name
    categoryFull
    ghgFactor
    unit
    notes
    source
  }
  countIdemats(filters: $filters)
}
    `;

/**
 * __useListIdematsQuery__
 *
 * To run a query within a Vue component, call `useListIdematsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListIdematsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListIdematsQuery({
 *   input: // value for 'input'
 *   offset: // value for 'offset'
 *   limit: // value for 'limit'
 *   filters: // value for 'filters'
 *   sort: // value for 'sort'
 * });
 */
export function useListIdematsQuery(variables: ListIdematsQueryVariables | VueCompositionApi.Ref<ListIdematsQueryVariables> | ReactiveFunction<ListIdematsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListIdematsQuery, ListIdematsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListIdematsQuery, ListIdematsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListIdematsQuery, ListIdematsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListIdematsQuery, ListIdematsQueryVariables>(ListIdematsDocument, variables, options);
}
export function useListIdematsLazyQuery(variables: ListIdematsQueryVariables | VueCompositionApi.Ref<ListIdematsQueryVariables> | ReactiveFunction<ListIdematsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListIdematsQuery, ListIdematsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListIdematsQuery, ListIdematsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListIdematsQuery, ListIdematsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListIdematsQuery, ListIdematsQueryVariables>(ListIdematsDocument, variables, options);
}
export type ListIdematsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListIdematsQuery, ListIdematsQueryVariables>;
export const ListMetricAssignmentConditionalChildrenDocument = gql`
    query ListMetricAssignmentConditionalChildren($id: Int!, $answer: Float) {
  listMetricAssignmentConditionalChildren(id: $id, answer: $answer) {
    id
    metric {
      id
      name
    }
  }
}
    `;

/**
 * __useListMetricAssignmentConditionalChildrenQuery__
 *
 * To run a query within a Vue component, call `useListMetricAssignmentConditionalChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMetricAssignmentConditionalChildrenQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListMetricAssignmentConditionalChildrenQuery({
 *   id: // value for 'id'
 *   answer: // value for 'answer'
 * });
 */
export function useListMetricAssignmentConditionalChildrenQuery(variables: ListMetricAssignmentConditionalChildrenQueryVariables | VueCompositionApi.Ref<ListMetricAssignmentConditionalChildrenQueryVariables> | ReactiveFunction<ListMetricAssignmentConditionalChildrenQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListMetricAssignmentConditionalChildrenQuery, ListMetricAssignmentConditionalChildrenQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListMetricAssignmentConditionalChildrenQuery, ListMetricAssignmentConditionalChildrenQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListMetricAssignmentConditionalChildrenQuery, ListMetricAssignmentConditionalChildrenQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListMetricAssignmentConditionalChildrenQuery, ListMetricAssignmentConditionalChildrenQueryVariables>(ListMetricAssignmentConditionalChildrenDocument, variables, options);
}
export function useListMetricAssignmentConditionalChildrenLazyQuery(variables: ListMetricAssignmentConditionalChildrenQueryVariables | VueCompositionApi.Ref<ListMetricAssignmentConditionalChildrenQueryVariables> | ReactiveFunction<ListMetricAssignmentConditionalChildrenQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListMetricAssignmentConditionalChildrenQuery, ListMetricAssignmentConditionalChildrenQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListMetricAssignmentConditionalChildrenQuery, ListMetricAssignmentConditionalChildrenQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListMetricAssignmentConditionalChildrenQuery, ListMetricAssignmentConditionalChildrenQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListMetricAssignmentConditionalChildrenQuery, ListMetricAssignmentConditionalChildrenQueryVariables>(ListMetricAssignmentConditionalChildrenDocument, variables, options);
}
export type ListMetricAssignmentConditionalChildrenQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListMetricAssignmentConditionalChildrenQuery, ListMetricAssignmentConditionalChildrenQueryVariables>;
export const CanAssignmentBeDeletedDocument = gql`
    query canAssignmentBeDeleted($id: Int!) {
  canAssignmentBeDeleted(id: $id) {
    computationalDependentAssignments {
      ...CompleteMetricAssignment
    }
    conditionalDependentAssignments {
      ...CompleteMetricAssignment
    }
    canBeDeleted
  }
}
    ${CompleteMetricAssignmentFragmentDoc}`;

/**
 * __useCanAssignmentBeDeletedQuery__
 *
 * To run a query within a Vue component, call `useCanAssignmentBeDeletedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanAssignmentBeDeletedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCanAssignmentBeDeletedQuery({
 *   id: // value for 'id'
 * });
 */
export function useCanAssignmentBeDeletedQuery(variables: CanAssignmentBeDeletedQueryVariables | VueCompositionApi.Ref<CanAssignmentBeDeletedQueryVariables> | ReactiveFunction<CanAssignmentBeDeletedQueryVariables>, options: VueApolloComposable.UseQueryOptions<CanAssignmentBeDeletedQuery, CanAssignmentBeDeletedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CanAssignmentBeDeletedQuery, CanAssignmentBeDeletedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CanAssignmentBeDeletedQuery, CanAssignmentBeDeletedQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CanAssignmentBeDeletedQuery, CanAssignmentBeDeletedQueryVariables>(CanAssignmentBeDeletedDocument, variables, options);
}
export function useCanAssignmentBeDeletedLazyQuery(variables: CanAssignmentBeDeletedQueryVariables | VueCompositionApi.Ref<CanAssignmentBeDeletedQueryVariables> | ReactiveFunction<CanAssignmentBeDeletedQueryVariables>, options: VueApolloComposable.UseQueryOptions<CanAssignmentBeDeletedQuery, CanAssignmentBeDeletedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CanAssignmentBeDeletedQuery, CanAssignmentBeDeletedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CanAssignmentBeDeletedQuery, CanAssignmentBeDeletedQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CanAssignmentBeDeletedQuery, CanAssignmentBeDeletedQueryVariables>(CanAssignmentBeDeletedDocument, variables, options);
}
export type CanAssignmentBeDeletedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CanAssignmentBeDeletedQuery, CanAssignmentBeDeletedQueryVariables>;
export const GetMetricAssignmentDocument = gql`
    query getMetricAssignment($id: Int!) {
  getMetricAssignment(id: $id) {
    ...CompleteMetricAssignment
  }
}
    ${CompleteMetricAssignmentFragmentDoc}`;

/**
 * __useGetMetricAssignmentQuery__
 *
 * To run a query within a Vue component, call `useGetMetricAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricAssignmentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMetricAssignmentQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetMetricAssignmentQuery(variables: GetMetricAssignmentQueryVariables | VueCompositionApi.Ref<GetMetricAssignmentQueryVariables> | ReactiveFunction<GetMetricAssignmentQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMetricAssignmentQuery, GetMetricAssignmentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMetricAssignmentQuery, GetMetricAssignmentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMetricAssignmentQuery, GetMetricAssignmentQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMetricAssignmentQuery, GetMetricAssignmentQueryVariables>(GetMetricAssignmentDocument, variables, options);
}
export function useGetMetricAssignmentLazyQuery(variables: GetMetricAssignmentQueryVariables | VueCompositionApi.Ref<GetMetricAssignmentQueryVariables> | ReactiveFunction<GetMetricAssignmentQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMetricAssignmentQuery, GetMetricAssignmentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMetricAssignmentQuery, GetMetricAssignmentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMetricAssignmentQuery, GetMetricAssignmentQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMetricAssignmentQuery, GetMetricAssignmentQueryVariables>(GetMetricAssignmentDocument, variables, options);
}
export type GetMetricAssignmentQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMetricAssignmentQuery, GetMetricAssignmentQueryVariables>;
export const ListMetricAssignmentsDocument = gql`
    query listMetricAssignments($filters: ListMetricAssignmentFilter, $assigneeIds: [UUID!], $metricIds: [Int!], $metricNotionIds: [String!], $ghgSavingPotentialId: Int, $ids: [Int!], $selfAssigned: Boolean, $keyword: String, $showImpactTargets: Boolean, $limit: Int, $offset: Int, $sort: [SortParam!]) {
  listMetricAssignments(
    filters: $filters
    assigneeIds: $assigneeIds
    metricIds: $metricIds
    metricNotionIds: $metricNotionIds
    ghgSavingPotentialId: $ghgSavingPotentialId
    ids: $ids
    selfAssigned: $selfAssigned
    keyword: $keyword
    showImpactTargets: $showImpactTargets
    limit: $limit
    offset: $offset
    sort: $sort
  ) {
    ...CompleteMetricAssignment
  }
  countMetricAssignments(
    filters: $filters
    assigneeIds: $assigneeIds
    metricIds: $metricIds
    metricNotionIds: $metricNotionIds
    ghgSavingPotentialId: $ghgSavingPotentialId
    ids: $ids
    selfAssigned: $selfAssigned
    keyword: $keyword
    showImpactTargets: $showImpactTargets
  )
  listMetricAssignmentCategoryCounts(
    filters: $filters
    assigneeIds: $assigneeIds
    metricIds: $metricIds
    metricNotionIds: $metricNotionIds
    ghgSavingPotentialId: $ghgSavingPotentialId
    ids: $ids
    selfAssigned: $selfAssigned
    keyword: $keyword
    showImpactTargets: $showImpactTargets
  ) {
    categoryId
    count
  }
  listMetricAssignmentSectionCounts(
    filters: $filters
    assigneeIds: $assigneeIds
    metricIds: $metricIds
    metricNotionIds: $metricNotionIds
    ghgSavingPotentialId: $ghgSavingPotentialId
    ids: $ids
    selfAssigned: $selfAssigned
    keyword: $keyword
    showImpactTargets: $showImpactTargets
  ) {
    sectionId
    count
  }
}
    ${CompleteMetricAssignmentFragmentDoc}`;

/**
 * __useListMetricAssignmentsQuery__
 *
 * To run a query within a Vue component, call `useListMetricAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMetricAssignmentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListMetricAssignmentsQuery({
 *   filters: // value for 'filters'
 *   assigneeIds: // value for 'assigneeIds'
 *   metricIds: // value for 'metricIds'
 *   metricNotionIds: // value for 'metricNotionIds'
 *   ghgSavingPotentialId: // value for 'ghgSavingPotentialId'
 *   ids: // value for 'ids'
 *   selfAssigned: // value for 'selfAssigned'
 *   keyword: // value for 'keyword'
 *   showImpactTargets: // value for 'showImpactTargets'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 *   sort: // value for 'sort'
 * });
 */
export function useListMetricAssignmentsQuery(variables: ListMetricAssignmentsQueryVariables | VueCompositionApi.Ref<ListMetricAssignmentsQueryVariables> | ReactiveFunction<ListMetricAssignmentsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListMetricAssignmentsQuery, ListMetricAssignmentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListMetricAssignmentsQuery, ListMetricAssignmentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListMetricAssignmentsQuery, ListMetricAssignmentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListMetricAssignmentsQuery, ListMetricAssignmentsQueryVariables>(ListMetricAssignmentsDocument, variables, options);
}
export function useListMetricAssignmentsLazyQuery(variables: ListMetricAssignmentsQueryVariables | VueCompositionApi.Ref<ListMetricAssignmentsQueryVariables> | ReactiveFunction<ListMetricAssignmentsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListMetricAssignmentsQuery, ListMetricAssignmentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListMetricAssignmentsQuery, ListMetricAssignmentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListMetricAssignmentsQuery, ListMetricAssignmentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListMetricAssignmentsQuery, ListMetricAssignmentsQueryVariables>(ListMetricAssignmentsDocument, variables, options);
}
export type ListMetricAssignmentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListMetricAssignmentsQuery, ListMetricAssignmentsQueryVariables>;
export const MetricValueAggregationDocument = gql`
    query metricValueAggregation($period: String!) {
  metricValueAggregation(period: $period) {
    id
    name
    unitName
    defaultGoalType
    actualAvg
    targetAvg
    actualSum
    targetSum
    distinctVentureCnt
    withValueVentureCnt
    calculationType
  }
}
    `;

/**
 * __useMetricValueAggregationQuery__
 *
 * To run a query within a Vue component, call `useMetricValueAggregationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricValueAggregationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMetricValueAggregationQuery({
 *   period: // value for 'period'
 * });
 */
export function useMetricValueAggregationQuery(variables: MetricValueAggregationQueryVariables | VueCompositionApi.Ref<MetricValueAggregationQueryVariables> | ReactiveFunction<MetricValueAggregationQueryVariables>, options: VueApolloComposable.UseQueryOptions<MetricValueAggregationQuery, MetricValueAggregationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MetricValueAggregationQuery, MetricValueAggregationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MetricValueAggregationQuery, MetricValueAggregationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MetricValueAggregationQuery, MetricValueAggregationQueryVariables>(MetricValueAggregationDocument, variables, options);
}
export function useMetricValueAggregationLazyQuery(variables: MetricValueAggregationQueryVariables | VueCompositionApi.Ref<MetricValueAggregationQueryVariables> | ReactiveFunction<MetricValueAggregationQueryVariables>, options: VueApolloComposable.UseQueryOptions<MetricValueAggregationQuery, MetricValueAggregationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MetricValueAggregationQuery, MetricValueAggregationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MetricValueAggregationQuery, MetricValueAggregationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MetricValueAggregationQuery, MetricValueAggregationQueryVariables>(MetricValueAggregationDocument, variables, options);
}
export type MetricValueAggregationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MetricValueAggregationQuery, MetricValueAggregationQueryVariables>;
export const GetQuestionDocument = gql`
    query GetQuestion($id: Int!) {
  getQuestion(id: $id) {
    id
    sort
    label
    labelI18n
    sublabel
    sublabelI18n
    tooltip
    tooltipI18n
    component
    ixId
    isMandatory
    isActiveByDefault
    scoringRules
    isMultiple
    createdAt
    updatedAt
    templateEngineContext
    targetEntity
    options {
      id
      labelI18n
      label
      sublabel
      tooltip
      ixId
    }
    templateTexts {
      id
      text
      conds
    }
    promptTemplate {
      ...PromptTemplate
    }
    currentPromptVersion {
      ...PromptTemplateVersion
    }
    questionSectionLinks {
      section {
        id
        label
        parent {
          id
          label
          parent {
            id
            label
          }
        }
      }
      questionId
      sectionId
      labelI18n
      label
      sublabelI18n
      sublabel
      tooltipI18n
      tooltip
    }
  }
}
    ${PromptTemplateFragmentDoc}
${PromptTemplateVersionFragmentDoc}`;

/**
 * __useGetQuestionQuery__
 *
 * To run a query within a Vue component, call `useGetQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetQuestionQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetQuestionQuery(variables: GetQuestionQueryVariables | VueCompositionApi.Ref<GetQuestionQueryVariables> | ReactiveFunction<GetQuestionQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetQuestionQuery, GetQuestionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetQuestionQuery, GetQuestionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetQuestionQuery, GetQuestionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetQuestionQuery, GetQuestionQueryVariables>(GetQuestionDocument, variables, options);
}
export function useGetQuestionLazyQuery(variables: GetQuestionQueryVariables | VueCompositionApi.Ref<GetQuestionQueryVariables> | ReactiveFunction<GetQuestionQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetQuestionQuery, GetQuestionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetQuestionQuery, GetQuestionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetQuestionQuery, GetQuestionQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetQuestionQuery, GetQuestionQueryVariables>(GetQuestionDocument, variables, options);
}
export type GetQuestionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetQuestionQuery, GetQuestionQueryVariables>;
export const ListQuestionsDocument = gql`
    query ListQuestions($filters: ListQuestionFilter, $limit: Int, $offset: Int) {
  listQuestions(filters: $filters, limit: $limit, offset: $offset) {
    id
    sort
    label
    sublabel
    tooltip
    component
    ixId
    isMandatory
    isActiveByDefault
    scoringRules
    isMultiple
    createdAt
    updatedAt
    targetEntity
    templateTexts {
      id
      text
      conds
    }
    promptTemplate {
      ...PromptTemplate
    }
    currentPromptVersion {
      ...PromptTemplateVersion
    }
  }
  countQuestions(filters: $filters)
}
    ${PromptTemplateFragmentDoc}
${PromptTemplateVersionFragmentDoc}`;

/**
 * __useListQuestionsQuery__
 *
 * To run a query within a Vue component, call `useListQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListQuestionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListQuestionsQuery({
 *   filters: // value for 'filters'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 * });
 */
export function useListQuestionsQuery(variables: ListQuestionsQueryVariables | VueCompositionApi.Ref<ListQuestionsQueryVariables> | ReactiveFunction<ListQuestionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListQuestionsQuery, ListQuestionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListQuestionsQuery, ListQuestionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListQuestionsQuery, ListQuestionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListQuestionsQuery, ListQuestionsQueryVariables>(ListQuestionsDocument, variables, options);
}
export function useListQuestionsLazyQuery(variables: ListQuestionsQueryVariables | VueCompositionApi.Ref<ListQuestionsQueryVariables> | ReactiveFunction<ListQuestionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListQuestionsQuery, ListQuestionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListQuestionsQuery, ListQuestionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListQuestionsQuery, ListQuestionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListQuestionsQuery, ListQuestionsQueryVariables>(ListQuestionsDocument, variables, options);
}
export type ListQuestionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListQuestionsQuery, ListQuestionsQueryVariables>;
export const BasicInfoForCompanyDocument = gql`
    query basicInfoForCompany($ventureId: String!) {
  basicInfoForCompany(ventureId: $ventureId) {
    id: ventureId
    ventureName
    website
    questionnaireId
    ventureId
    pitchLine
    legalEntity
    founders
    headquarter
    country
    foundingYear
    employeeHeadcount
    turnover
    fundingStage
    businessModel
    incomeStream
    products
    industries
    primaryIndustry
    customerGroup
    customerGroupOptions
    commercialRegisterNumber
    postcode
    companyValuation
  }
}
    `;

/**
 * __useBasicInfoForCompanyQuery__
 *
 * To run a query within a Vue component, call `useBasicInfoForCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useBasicInfoForCompanyQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBasicInfoForCompanyQuery({
 *   ventureId: // value for 'ventureId'
 * });
 */
export function useBasicInfoForCompanyQuery(variables: BasicInfoForCompanyQueryVariables | VueCompositionApi.Ref<BasicInfoForCompanyQueryVariables> | ReactiveFunction<BasicInfoForCompanyQueryVariables>, options: VueApolloComposable.UseQueryOptions<BasicInfoForCompanyQuery, BasicInfoForCompanyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BasicInfoForCompanyQuery, BasicInfoForCompanyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BasicInfoForCompanyQuery, BasicInfoForCompanyQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BasicInfoForCompanyQuery, BasicInfoForCompanyQueryVariables>(BasicInfoForCompanyDocument, variables, options);
}
export function useBasicInfoForCompanyLazyQuery(variables: BasicInfoForCompanyQueryVariables | VueCompositionApi.Ref<BasicInfoForCompanyQueryVariables> | ReactiveFunction<BasicInfoForCompanyQueryVariables>, options: VueApolloComposable.UseQueryOptions<BasicInfoForCompanyQuery, BasicInfoForCompanyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BasicInfoForCompanyQuery, BasicInfoForCompanyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BasicInfoForCompanyQuery, BasicInfoForCompanyQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BasicInfoForCompanyQuery, BasicInfoForCompanyQueryVariables>(BasicInfoForCompanyDocument, variables, options);
}
export type BasicInfoForCompanyQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BasicInfoForCompanyQuery, BasicInfoForCompanyQueryVariables>;
export const EsgQuestionnaireAsTableDocument = gql`
    query esgQuestionnaireAsTable($id: Int!) {
  esgQuestionnaireAsTable(id: $id) {
    sectionId
    sectionLabel
    subsectionId
    subsectionLabel
    label
    actionsTaken
    actionsPlanned
    actionsNeither
    disclosureRisks
    comment
  }
}
    `;

/**
 * __useEsgQuestionnaireAsTableQuery__
 *
 * To run a query within a Vue component, call `useEsgQuestionnaireAsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsgQuestionnaireAsTableQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEsgQuestionnaireAsTableQuery({
 *   id: // value for 'id'
 * });
 */
export function useEsgQuestionnaireAsTableQuery(variables: EsgQuestionnaireAsTableQueryVariables | VueCompositionApi.Ref<EsgQuestionnaireAsTableQueryVariables> | ReactiveFunction<EsgQuestionnaireAsTableQueryVariables>, options: VueApolloComposable.UseQueryOptions<EsgQuestionnaireAsTableQuery, EsgQuestionnaireAsTableQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EsgQuestionnaireAsTableQuery, EsgQuestionnaireAsTableQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EsgQuestionnaireAsTableQuery, EsgQuestionnaireAsTableQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<EsgQuestionnaireAsTableQuery, EsgQuestionnaireAsTableQueryVariables>(EsgQuestionnaireAsTableDocument, variables, options);
}
export function useEsgQuestionnaireAsTableLazyQuery(variables: EsgQuestionnaireAsTableQueryVariables | VueCompositionApi.Ref<EsgQuestionnaireAsTableQueryVariables> | ReactiveFunction<EsgQuestionnaireAsTableQueryVariables>, options: VueApolloComposable.UseQueryOptions<EsgQuestionnaireAsTableQuery, EsgQuestionnaireAsTableQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EsgQuestionnaireAsTableQuery, EsgQuestionnaireAsTableQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EsgQuestionnaireAsTableQuery, EsgQuestionnaireAsTableQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<EsgQuestionnaireAsTableQuery, EsgQuestionnaireAsTableQueryVariables>(EsgQuestionnaireAsTableDocument, variables, options);
}
export type EsgQuestionnaireAsTableQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<EsgQuestionnaireAsTableQuery, EsgQuestionnaireAsTableQueryVariables>;
export const GetAggregatedEsgQuestionnaireResultDocument = gql`
    query getAggregatedEsgQuestionnaireResult($input: GetAggregatedQuestionnaireResultFilter) {
  getAggregatedEsgQuestionnaireResult(input: $input) {
    sectionLabel
    score
    details {
      hasRisk
      maxScore
      questionDetails
      subsectionDetails
    }
  }
}
    `;

/**
 * __useGetAggregatedEsgQuestionnaireResultQuery__
 *
 * To run a query within a Vue component, call `useGetAggregatedEsgQuestionnaireResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAggregatedEsgQuestionnaireResultQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAggregatedEsgQuestionnaireResultQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetAggregatedEsgQuestionnaireResultQuery(variables: GetAggregatedEsgQuestionnaireResultQueryVariables | VueCompositionApi.Ref<GetAggregatedEsgQuestionnaireResultQueryVariables> | ReactiveFunction<GetAggregatedEsgQuestionnaireResultQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetAggregatedEsgQuestionnaireResultQuery, GetAggregatedEsgQuestionnaireResultQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAggregatedEsgQuestionnaireResultQuery, GetAggregatedEsgQuestionnaireResultQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAggregatedEsgQuestionnaireResultQuery, GetAggregatedEsgQuestionnaireResultQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAggregatedEsgQuestionnaireResultQuery, GetAggregatedEsgQuestionnaireResultQueryVariables>(GetAggregatedEsgQuestionnaireResultDocument, variables, options);
}
export function useGetAggregatedEsgQuestionnaireResultLazyQuery(variables: GetAggregatedEsgQuestionnaireResultQueryVariables | VueCompositionApi.Ref<GetAggregatedEsgQuestionnaireResultQueryVariables> | ReactiveFunction<GetAggregatedEsgQuestionnaireResultQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetAggregatedEsgQuestionnaireResultQuery, GetAggregatedEsgQuestionnaireResultQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAggregatedEsgQuestionnaireResultQuery, GetAggregatedEsgQuestionnaireResultQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAggregatedEsgQuestionnaireResultQuery, GetAggregatedEsgQuestionnaireResultQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAggregatedEsgQuestionnaireResultQuery, GetAggregatedEsgQuestionnaireResultQueryVariables>(GetAggregatedEsgQuestionnaireResultDocument, variables, options);
}
export type GetAggregatedEsgQuestionnaireResultQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAggregatedEsgQuestionnaireResultQuery, GetAggregatedEsgQuestionnaireResultQueryVariables>;
export const GetEsgComparisonDocument = gql`
    query getEsgComparison($firstQuestionnaireId: Int!, $secondQuestionnaireId: Int!) {
  getEsgComparison(
    firstQuestionnaireId: $firstQuestionnaireId
    secondQuestionnaireId: $secondQuestionnaireId
  ) {
    ...CompleteQuestionnaireComparison
  }
}
    ${CompleteQuestionnaireComparisonFragmentDoc}`;

/**
 * __useGetEsgComparisonQuery__
 *
 * To run a query within a Vue component, call `useGetEsgComparisonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEsgComparisonQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEsgComparisonQuery({
 *   firstQuestionnaireId: // value for 'firstQuestionnaireId'
 *   secondQuestionnaireId: // value for 'secondQuestionnaireId'
 * });
 */
export function useGetEsgComparisonQuery(variables: GetEsgComparisonQueryVariables | VueCompositionApi.Ref<GetEsgComparisonQueryVariables> | ReactiveFunction<GetEsgComparisonQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEsgComparisonQuery, GetEsgComparisonQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEsgComparisonQuery, GetEsgComparisonQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEsgComparisonQuery, GetEsgComparisonQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetEsgComparisonQuery, GetEsgComparisonQueryVariables>(GetEsgComparisonDocument, variables, options);
}
export function useGetEsgComparisonLazyQuery(variables: GetEsgComparisonQueryVariables | VueCompositionApi.Ref<GetEsgComparisonQueryVariables> | ReactiveFunction<GetEsgComparisonQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEsgComparisonQuery, GetEsgComparisonQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEsgComparisonQuery, GetEsgComparisonQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEsgComparisonQuery, GetEsgComparisonQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetEsgComparisonQuery, GetEsgComparisonQueryVariables>(GetEsgComparisonDocument, variables, options);
}
export type GetEsgComparisonQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetEsgComparisonQuery, GetEsgComparisonQueryVariables>;
export const GetEsgMeasureComparisonDocument = gql`
    query getEsgMeasureComparison($input: EsgMeasureComparisonInput!) {
  getEsgMeasureComparison(input: $input) {
    environmental {
      category
      measure
      statusFirstPeriod
      statusSecondPeriod
    }
    social {
      category
      measure
      statusFirstPeriod
      statusSecondPeriod
    }
    governance {
      category
      measure
      statusFirstPeriod
      statusSecondPeriod
    }
    disclosure {
      category
      measure
      statusFirstPeriod
      statusSecondPeriod
    }
  }
}
    `;

/**
 * __useGetEsgMeasureComparisonQuery__
 *
 * To run a query within a Vue component, call `useGetEsgMeasureComparisonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEsgMeasureComparisonQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEsgMeasureComparisonQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetEsgMeasureComparisonQuery(variables: GetEsgMeasureComparisonQueryVariables | VueCompositionApi.Ref<GetEsgMeasureComparisonQueryVariables> | ReactiveFunction<GetEsgMeasureComparisonQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEsgMeasureComparisonQuery, GetEsgMeasureComparisonQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEsgMeasureComparisonQuery, GetEsgMeasureComparisonQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEsgMeasureComparisonQuery, GetEsgMeasureComparisonQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetEsgMeasureComparisonQuery, GetEsgMeasureComparisonQueryVariables>(GetEsgMeasureComparisonDocument, variables, options);
}
export function useGetEsgMeasureComparisonLazyQuery(variables: GetEsgMeasureComparisonQueryVariables | VueCompositionApi.Ref<GetEsgMeasureComparisonQueryVariables> | ReactiveFunction<GetEsgMeasureComparisonQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEsgMeasureComparisonQuery, GetEsgMeasureComparisonQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEsgMeasureComparisonQuery, GetEsgMeasureComparisonQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEsgMeasureComparisonQuery, GetEsgMeasureComparisonQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetEsgMeasureComparisonQuery, GetEsgMeasureComparisonQueryVariables>(GetEsgMeasureComparisonDocument, variables, options);
}
export type GetEsgMeasureComparisonQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetEsgMeasureComparisonQuery, GetEsgMeasureComparisonQueryVariables>;
export const GetEsgQuestionnaireResultsForVenturesDocument = gql`
    query getEsgQuestionnaireResultsForVentures($filters: ListPortfolioVentureLinksFilter, $offset: Int, $limit: Int, $sortBy: String, $sortDesc: Boolean) {
  getEsgQuestionnaireResultsForVentures(
    filters: $filters
    offset: $offset
    limit: $limit
    sortBy: $sortBy
    sortDesc: $sortDesc
  ) {
    _id: ventureId
    ventureId
    isCompleted
    updatedAt
    total
    totalDiffToPrevious
    environmental
    environmentalDiffToPrevious
    social
    socialDiffToPrevious
    governance
    governanceDiffToPrevious
    disclosure
  }
  countEsgQuestionnaireResultsForVentures(filters: $filters)
}
    `;

/**
 * __useGetEsgQuestionnaireResultsForVenturesQuery__
 *
 * To run a query within a Vue component, call `useGetEsgQuestionnaireResultsForVenturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEsgQuestionnaireResultsForVenturesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEsgQuestionnaireResultsForVenturesQuery({
 *   filters: // value for 'filters'
 *   offset: // value for 'offset'
 *   limit: // value for 'limit'
 *   sortBy: // value for 'sortBy'
 *   sortDesc: // value for 'sortDesc'
 * });
 */
export function useGetEsgQuestionnaireResultsForVenturesQuery(variables: GetEsgQuestionnaireResultsForVenturesQueryVariables | VueCompositionApi.Ref<GetEsgQuestionnaireResultsForVenturesQueryVariables> | ReactiveFunction<GetEsgQuestionnaireResultsForVenturesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetEsgQuestionnaireResultsForVenturesQuery, GetEsgQuestionnaireResultsForVenturesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEsgQuestionnaireResultsForVenturesQuery, GetEsgQuestionnaireResultsForVenturesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEsgQuestionnaireResultsForVenturesQuery, GetEsgQuestionnaireResultsForVenturesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetEsgQuestionnaireResultsForVenturesQuery, GetEsgQuestionnaireResultsForVenturesQueryVariables>(GetEsgQuestionnaireResultsForVenturesDocument, variables, options);
}
export function useGetEsgQuestionnaireResultsForVenturesLazyQuery(variables: GetEsgQuestionnaireResultsForVenturesQueryVariables | VueCompositionApi.Ref<GetEsgQuestionnaireResultsForVenturesQueryVariables> | ReactiveFunction<GetEsgQuestionnaireResultsForVenturesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetEsgQuestionnaireResultsForVenturesQuery, GetEsgQuestionnaireResultsForVenturesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEsgQuestionnaireResultsForVenturesQuery, GetEsgQuestionnaireResultsForVenturesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEsgQuestionnaireResultsForVenturesQuery, GetEsgQuestionnaireResultsForVenturesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetEsgQuestionnaireResultsForVenturesQuery, GetEsgQuestionnaireResultsForVenturesQueryVariables>(GetEsgQuestionnaireResultsForVenturesDocument, variables, options);
}
export type GetEsgQuestionnaireResultsForVenturesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetEsgQuestionnaireResultsForVenturesQuery, GetEsgQuestionnaireResultsForVenturesQueryVariables>;
export const GetMostRecentQuestionnaireForVentureAndLabelDocument = gql`
    query getMostRecentQuestionnaireForVentureAndLabel($ventureId: String!, $label: String!) {
  getMostRecentQuestionnaireForVentureAndLabel(
    ventureId: $ventureId
    label: $label
  ) {
    questionnaireAssignment {
      ...QuestionnaireFragment
    }
    questionnaireTemplate {
      id
      ventureId
      sections {
        id
        ixId
        label
        sections {
          id
          ixId
          label
          description
          questions {
            id
            ixId
            component
            tooltip
            title: label
            subtitle: sublabel
            isMultiple
            isMandatory
            options {
              id
              ixId
              label
              sublabel
              tooltip
            }
            concepts {
              id
              ixId
              label
              scheme
              description
            }
            questions {
              id
              ixId
              component
              tooltip
              title: label
              subtitle: sublabel
              isMultiple
              isMandatory
              options {
                id
                ixId
                label
                sublabel
                tooltip
              }
            }
          }
        }
        questions {
          id
          ixId
          component
          tooltip
          title: label
          subtitle: sublabel
          isMultiple
          isMandatory
          options {
            id
            ixId
            label
            sublabel
            tooltip
          }
        }
      }
    }
    questionnaireNavigation {
      id
      currentSection
      currentSubsection
    }
  }
}
    ${QuestionnaireFragmentFragmentDoc}`;

/**
 * __useGetMostRecentQuestionnaireForVentureAndLabelQuery__
 *
 * To run a query within a Vue component, call `useGetMostRecentQuestionnaireForVentureAndLabelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMostRecentQuestionnaireForVentureAndLabelQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMostRecentQuestionnaireForVentureAndLabelQuery({
 *   ventureId: // value for 'ventureId'
 *   label: // value for 'label'
 * });
 */
export function useGetMostRecentQuestionnaireForVentureAndLabelQuery(variables: GetMostRecentQuestionnaireForVentureAndLabelQueryVariables | VueCompositionApi.Ref<GetMostRecentQuestionnaireForVentureAndLabelQueryVariables> | ReactiveFunction<GetMostRecentQuestionnaireForVentureAndLabelQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMostRecentQuestionnaireForVentureAndLabelQuery, GetMostRecentQuestionnaireForVentureAndLabelQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMostRecentQuestionnaireForVentureAndLabelQuery, GetMostRecentQuestionnaireForVentureAndLabelQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMostRecentQuestionnaireForVentureAndLabelQuery, GetMostRecentQuestionnaireForVentureAndLabelQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMostRecentQuestionnaireForVentureAndLabelQuery, GetMostRecentQuestionnaireForVentureAndLabelQueryVariables>(GetMostRecentQuestionnaireForVentureAndLabelDocument, variables, options);
}
export function useGetMostRecentQuestionnaireForVentureAndLabelLazyQuery(variables: GetMostRecentQuestionnaireForVentureAndLabelQueryVariables | VueCompositionApi.Ref<GetMostRecentQuestionnaireForVentureAndLabelQueryVariables> | ReactiveFunction<GetMostRecentQuestionnaireForVentureAndLabelQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMostRecentQuestionnaireForVentureAndLabelQuery, GetMostRecentQuestionnaireForVentureAndLabelQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMostRecentQuestionnaireForVentureAndLabelQuery, GetMostRecentQuestionnaireForVentureAndLabelQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMostRecentQuestionnaireForVentureAndLabelQuery, GetMostRecentQuestionnaireForVentureAndLabelQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMostRecentQuestionnaireForVentureAndLabelQuery, GetMostRecentQuestionnaireForVentureAndLabelQueryVariables>(GetMostRecentQuestionnaireForVentureAndLabelDocument, variables, options);
}
export type GetMostRecentQuestionnaireForVentureAndLabelQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMostRecentQuestionnaireForVentureAndLabelQuery, GetMostRecentQuestionnaireForVentureAndLabelQueryVariables>;
export const GetQuestionnaireDocument = gql`
    query getQuestionnaire($id: Int!) {
  getQuestionnaire(id: $id) {
    questionnaireAssignment {
      ...QuestionnaireFragment
    }
    questionnaireTemplate {
      id
      ventureId
      sections {
        id
        ixId
        label
        sections {
          id
          ixId
          label
          description
          questions {
            id
            ixId
            component
            tooltip
            title: label
            subtitle: sublabel
            isMultiple
            isMandatory
            options {
              id
              ixId
              label
              labelI18n
              sublabel
              tooltip
            }
            concepts {
              id
              ixId
              label
              labelI18n
              scheme
              description
              isSubmeasure
              additionalData
              sourceUrl
              citation
              isMaterial
              materialityExplanation
              status
            }
            questions {
              id
              ixId
              component
              tooltip
              title: label
              subtitle: sublabel
              isMultiple
              isMandatory
              options {
                id
                ixId
                label
                sublabel
                tooltip
              }
            }
          }
        }
        questions {
          id
          ixId
          component
          tooltip
          title: label
          subtitle: sublabel
          isMultiple
          isMandatory
          options {
            id
            ixId
            label
            sublabel
            tooltip
          }
        }
      }
    }
    questionnaireNavigation {
      id
      currentSection
      currentSubsection
    }
  }
}
    ${QuestionnaireFragmentFragmentDoc}`;

/**
 * __useGetQuestionnaireQuery__
 *
 * To run a query within a Vue component, call `useGetQuestionnaireQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionnaireQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetQuestionnaireQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetQuestionnaireQuery(variables: GetQuestionnaireQueryVariables | VueCompositionApi.Ref<GetQuestionnaireQueryVariables> | ReactiveFunction<GetQuestionnaireQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetQuestionnaireQuery, GetQuestionnaireQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetQuestionnaireQuery, GetQuestionnaireQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetQuestionnaireQuery, GetQuestionnaireQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetQuestionnaireQuery, GetQuestionnaireQueryVariables>(GetQuestionnaireDocument, variables, options);
}
export function useGetQuestionnaireLazyQuery(variables: GetQuestionnaireQueryVariables | VueCompositionApi.Ref<GetQuestionnaireQueryVariables> | ReactiveFunction<GetQuestionnaireQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetQuestionnaireQuery, GetQuestionnaireQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetQuestionnaireQuery, GetQuestionnaireQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetQuestionnaireQuery, GetQuestionnaireQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetQuestionnaireQuery, GetQuestionnaireQueryVariables>(GetQuestionnaireDocument, variables, options);
}
export type GetQuestionnaireQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetQuestionnaireQuery, GetQuestionnaireQueryVariables>;
export const GetQuestionnaireForComparisonDocument = gql`
    query getQuestionnaireForComparison($id: Int!) {
  getQuestionnaire(id: $id) {
    questionnaireAssignment {
      id
      updatedAt
      period {
        id
        label
      }
      questionnaireResults {
        id
        sectionId
        sectionLabel
        score
        details
      }
      userInputs {
        ...CompleteUserInput
      }
    }
    questionnaireTemplate {
      id
      sections {
        id
        ixId
        label
        sections {
          id
          ixId
          label
        }
      }
    }
  }
}
    ${CompleteUserInputFragmentDoc}`;

/**
 * __useGetQuestionnaireForComparisonQuery__
 *
 * To run a query within a Vue component, call `useGetQuestionnaireForComparisonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionnaireForComparisonQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetQuestionnaireForComparisonQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetQuestionnaireForComparisonQuery(variables: GetQuestionnaireForComparisonQueryVariables | VueCompositionApi.Ref<GetQuestionnaireForComparisonQueryVariables> | ReactiveFunction<GetQuestionnaireForComparisonQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetQuestionnaireForComparisonQuery, GetQuestionnaireForComparisonQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetQuestionnaireForComparisonQuery, GetQuestionnaireForComparisonQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetQuestionnaireForComparisonQuery, GetQuestionnaireForComparisonQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetQuestionnaireForComparisonQuery, GetQuestionnaireForComparisonQueryVariables>(GetQuestionnaireForComparisonDocument, variables, options);
}
export function useGetQuestionnaireForComparisonLazyQuery(variables: GetQuestionnaireForComparisonQueryVariables | VueCompositionApi.Ref<GetQuestionnaireForComparisonQueryVariables> | ReactiveFunction<GetQuestionnaireForComparisonQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetQuestionnaireForComparisonQuery, GetQuestionnaireForComparisonQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetQuestionnaireForComparisonQuery, GetQuestionnaireForComparisonQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetQuestionnaireForComparisonQuery, GetQuestionnaireForComparisonQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetQuestionnaireForComparisonQuery, GetQuestionnaireForComparisonQueryVariables>(GetQuestionnaireForComparisonDocument, variables, options);
}
export type GetQuestionnaireForComparisonQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetQuestionnaireForComparisonQuery, GetQuestionnaireForComparisonQueryVariables>;
export const GetQuestionnaireV2Document = gql`
    query getQuestionnaireV2($id: Int!) {
  getQuestionnaire(id: $id) {
    id
    ventureId
    sections {
      id
      label
      labelI18n
      sections {
        id
        label
        labelI18n
        description
        questions {
          id
          ixId
          component
          tooltip
          title: label
          subtitle: sublabel
          isMultiple
          isMandatory
          options {
            id
            ixId
            label
            sublabel
            tooltip
          }
          concepts {
            id
            ixId
            label
            labelI18n
            scheme
            description
          }
          questions {
            id
            ixId
            component
            tooltip
            title: label
            subtitle: sublabel
            isMultiple
            isMandatory
            options {
              id
              ixId
              label
              sublabel
              tooltip
            }
          }
        }
      }
      questions {
        id
        ixId
        component
        tooltip
        title: label
        subtitle: sublabel
        isMultiple
        isMandatory
        options {
          id
          ixId
          label
          sublabel
          tooltip
        }
      }
    }
  }
}
    `;

/**
 * __useGetQuestionnaireV2Query__
 *
 * To run a query within a Vue component, call `useGetQuestionnaireV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionnaireV2Query` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetQuestionnaireV2Query({
 *   id: // value for 'id'
 * });
 */
export function useGetQuestionnaireV2Query(variables: GetQuestionnaireV2QueryVariables | VueCompositionApi.Ref<GetQuestionnaireV2QueryVariables> | ReactiveFunction<GetQuestionnaireV2QueryVariables>, options: VueApolloComposable.UseQueryOptions<GetQuestionnaireV2Query, GetQuestionnaireV2QueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetQuestionnaireV2Query, GetQuestionnaireV2QueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetQuestionnaireV2Query, GetQuestionnaireV2QueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetQuestionnaireV2Query, GetQuestionnaireV2QueryVariables>(GetQuestionnaireV2Document, variables, options);
}
export function useGetQuestionnaireV2LazyQuery(variables: GetQuestionnaireV2QueryVariables | VueCompositionApi.Ref<GetQuestionnaireV2QueryVariables> | ReactiveFunction<GetQuestionnaireV2QueryVariables>, options: VueApolloComposable.UseQueryOptions<GetQuestionnaireV2Query, GetQuestionnaireV2QueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetQuestionnaireV2Query, GetQuestionnaireV2QueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetQuestionnaireV2Query, GetQuestionnaireV2QueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetQuestionnaireV2Query, GetQuestionnaireV2QueryVariables>(GetQuestionnaireV2Document, variables, options);
}
export type GetQuestionnaireV2QueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetQuestionnaireV2Query, GetQuestionnaireV2QueryVariables>;
export const GetQuestionnairesForVenturesAndLabelDocument = gql`
    query getQuestionnairesForVenturesAndLabel($ventureIds: [String!]!, $label: String!) {
  getQuestionnairesForVenturesAndLabel(ventureIds: $ventureIds, label: $label) {
    id
    isEditable
    sections {
      id
      label
    }
    period {
      id
      label
      startDate
      endDate
      userDefined
    }
    updatedAt
    venture {
      id
      name
    }
  }
}
    `;

/**
 * __useGetQuestionnairesForVenturesAndLabelQuery__
 *
 * To run a query within a Vue component, call `useGetQuestionnairesForVenturesAndLabelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionnairesForVenturesAndLabelQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetQuestionnairesForVenturesAndLabelQuery({
 *   ventureIds: // value for 'ventureIds'
 *   label: // value for 'label'
 * });
 */
export function useGetQuestionnairesForVenturesAndLabelQuery(variables: GetQuestionnairesForVenturesAndLabelQueryVariables | VueCompositionApi.Ref<GetQuestionnairesForVenturesAndLabelQueryVariables> | ReactiveFunction<GetQuestionnairesForVenturesAndLabelQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetQuestionnairesForVenturesAndLabelQuery, GetQuestionnairesForVenturesAndLabelQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetQuestionnairesForVenturesAndLabelQuery, GetQuestionnairesForVenturesAndLabelQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetQuestionnairesForVenturesAndLabelQuery, GetQuestionnairesForVenturesAndLabelQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetQuestionnairesForVenturesAndLabelQuery, GetQuestionnairesForVenturesAndLabelQueryVariables>(GetQuestionnairesForVenturesAndLabelDocument, variables, options);
}
export function useGetQuestionnairesForVenturesAndLabelLazyQuery(variables: GetQuestionnairesForVenturesAndLabelQueryVariables | VueCompositionApi.Ref<GetQuestionnairesForVenturesAndLabelQueryVariables> | ReactiveFunction<GetQuestionnairesForVenturesAndLabelQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetQuestionnairesForVenturesAndLabelQuery, GetQuestionnairesForVenturesAndLabelQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetQuestionnairesForVenturesAndLabelQuery, GetQuestionnairesForVenturesAndLabelQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetQuestionnairesForVenturesAndLabelQuery, GetQuestionnairesForVenturesAndLabelQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetQuestionnairesForVenturesAndLabelQuery, GetQuestionnairesForVenturesAndLabelQueryVariables>(GetQuestionnairesForVenturesAndLabelDocument, variables, options);
}
export type GetQuestionnairesForVenturesAndLabelQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetQuestionnairesForVenturesAndLabelQuery, GetQuestionnairesForVenturesAndLabelQueryVariables>;
export const ListOptionsDocument = gql`
    query listOptions($id: Int!) {
  listOptions(id: $id) {
    ...optionFields
    children {
      ...optionFields
      children {
        ...optionFields
        children {
          ...optionFields
          children {
            ...optionFields
          }
        }
      }
    }
  }
}
    ${OptionFieldsFragmentDoc}`;

/**
 * __useListOptionsQuery__
 *
 * To run a query within a Vue component, call `useListOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListOptionsQuery({
 *   id: // value for 'id'
 * });
 */
export function useListOptionsQuery(variables: ListOptionsQueryVariables | VueCompositionApi.Ref<ListOptionsQueryVariables> | ReactiveFunction<ListOptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListOptionsQuery, ListOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListOptionsQuery, ListOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListOptionsQuery, ListOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListOptionsQuery, ListOptionsQueryVariables>(ListOptionsDocument, variables, options);
}
export function useListOptionsLazyQuery(variables: ListOptionsQueryVariables | VueCompositionApi.Ref<ListOptionsQueryVariables> | ReactiveFunction<ListOptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListOptionsQuery, ListOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListOptionsQuery, ListOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListOptionsQuery, ListOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListOptionsQuery, ListOptionsQueryVariables>(ListOptionsDocument, variables, options);
}
export type ListOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListOptionsQuery, ListOptionsQueryVariables>;
export const ListPromptTemplateVersionDocument = gql`
    query ListPromptTemplateVersion($filters: ListPromptTemplateVersionFilter, $limit: Int, $offset: Int) {
  listPromptTemplateVersion(filters: $filters, limit: $limit, offset: $offset) {
    ...PromptTemplateVersion
  }
}
    ${PromptTemplateVersionFragmentDoc}`;

/**
 * __useListPromptTemplateVersionQuery__
 *
 * To run a query within a Vue component, call `useListPromptTemplateVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPromptTemplateVersionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListPromptTemplateVersionQuery({
 *   filters: // value for 'filters'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 * });
 */
export function useListPromptTemplateVersionQuery(variables: ListPromptTemplateVersionQueryVariables | VueCompositionApi.Ref<ListPromptTemplateVersionQueryVariables> | ReactiveFunction<ListPromptTemplateVersionQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListPromptTemplateVersionQuery, ListPromptTemplateVersionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListPromptTemplateVersionQuery, ListPromptTemplateVersionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListPromptTemplateVersionQuery, ListPromptTemplateVersionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListPromptTemplateVersionQuery, ListPromptTemplateVersionQueryVariables>(ListPromptTemplateVersionDocument, variables, options);
}
export function useListPromptTemplateVersionLazyQuery(variables: ListPromptTemplateVersionQueryVariables | VueCompositionApi.Ref<ListPromptTemplateVersionQueryVariables> | ReactiveFunction<ListPromptTemplateVersionQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListPromptTemplateVersionQuery, ListPromptTemplateVersionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListPromptTemplateVersionQuery, ListPromptTemplateVersionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListPromptTemplateVersionQuery, ListPromptTemplateVersionQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListPromptTemplateVersionQuery, ListPromptTemplateVersionQueryVariables>(ListPromptTemplateVersionDocument, variables, options);
}
export type ListPromptTemplateVersionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListPromptTemplateVersionQuery, ListPromptTemplateVersionQueryVariables>;
export const ListQuestionnairesDocument = gql`
    query listQuestionnaires($filters: ListQuestionnaireFilter, $limit: Int, $offset: Int) {
  listQuestionnaires(filters: $filters, limit: $limit, offset: $offset) {
    id
    ventureId
    venture {
      name
    }
    sections {
      id
      label
    }
    period {
      startDate
      endDate
      id
      label
      createdBy
      userDefined
    }
    createdAt
    updatedAt
  }
  countQuestionnaires(filters: $filters)
}
    `;

/**
 * __useListQuestionnairesQuery__
 *
 * To run a query within a Vue component, call `useListQuestionnairesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListQuestionnairesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListQuestionnairesQuery({
 *   filters: // value for 'filters'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 * });
 */
export function useListQuestionnairesQuery(variables: ListQuestionnairesQueryVariables | VueCompositionApi.Ref<ListQuestionnairesQueryVariables> | ReactiveFunction<ListQuestionnairesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListQuestionnairesQuery, ListQuestionnairesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListQuestionnairesQuery, ListQuestionnairesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListQuestionnairesQuery, ListQuestionnairesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListQuestionnairesQuery, ListQuestionnairesQueryVariables>(ListQuestionnairesDocument, variables, options);
}
export function useListQuestionnairesLazyQuery(variables: ListQuestionnairesQueryVariables | VueCompositionApi.Ref<ListQuestionnairesQueryVariables> | ReactiveFunction<ListQuestionnairesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListQuestionnairesQuery, ListQuestionnairesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListQuestionnairesQuery, ListQuestionnairesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListQuestionnairesQuery, ListQuestionnairesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListQuestionnairesQuery, ListQuestionnairesQueryVariables>(ListQuestionnairesDocument, variables, options);
}
export type ListQuestionnairesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListQuestionnairesQuery, ListQuestionnairesQueryVariables>;
export const ListReferencePeriodsDocument = gql`
    query listReferencePeriods($filters: ListReferencePeriodFilters, $limit: Int, $offset: Int, $sort: String) {
  listReferencePeriods(
    filters: $filters
    limit: $limit
    offset: $offset
    sort: $sort
  ) {
    id
    label
    startDate
    endDate
    userDefined
    createdBy
  }
}
    `;

/**
 * __useListReferencePeriodsQuery__
 *
 * To run a query within a Vue component, call `useListReferencePeriodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListReferencePeriodsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListReferencePeriodsQuery({
 *   filters: // value for 'filters'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 *   sort: // value for 'sort'
 * });
 */
export function useListReferencePeriodsQuery(variables: ListReferencePeriodsQueryVariables | VueCompositionApi.Ref<ListReferencePeriodsQueryVariables> | ReactiveFunction<ListReferencePeriodsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListReferencePeriodsQuery, ListReferencePeriodsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListReferencePeriodsQuery, ListReferencePeriodsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListReferencePeriodsQuery, ListReferencePeriodsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListReferencePeriodsQuery, ListReferencePeriodsQueryVariables>(ListReferencePeriodsDocument, variables, options);
}
export function useListReferencePeriodsLazyQuery(variables: ListReferencePeriodsQueryVariables | VueCompositionApi.Ref<ListReferencePeriodsQueryVariables> | ReactiveFunction<ListReferencePeriodsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListReferencePeriodsQuery, ListReferencePeriodsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListReferencePeriodsQuery, ListReferencePeriodsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListReferencePeriodsQuery, ListReferencePeriodsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListReferencePeriodsQuery, ListReferencePeriodsQueryVariables>(ListReferencePeriodsDocument, variables, options);
}
export type ListReferencePeriodsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListReferencePeriodsQuery, ListReferencePeriodsQueryVariables>;
export const GetReportingRequestDocument = gql`
    query getReportingRequest($id: UUID!) {
  getReportingRequest(id: $id) {
    id
    title
    description
    referencePeriod
    dueDate
    requestType
    portfolioId
    createdAt
    metricIds
    ventures {
      ventureId
      status
      metricIds
      statusSummary {
        totalKpis
        completedKpis
        skippedKpis
        incompleteKpis
      }
      questionnaireId
      venture {
        id
        name
        logo
      }
    }
  }
}
    `;

/**
 * __useGetReportingRequestQuery__
 *
 * To run a query within a Vue component, call `useGetReportingRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportingRequestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetReportingRequestQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetReportingRequestQuery(variables: GetReportingRequestQueryVariables | VueCompositionApi.Ref<GetReportingRequestQueryVariables> | ReactiveFunction<GetReportingRequestQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetReportingRequestQuery, GetReportingRequestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetReportingRequestQuery, GetReportingRequestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetReportingRequestQuery, GetReportingRequestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetReportingRequestQuery, GetReportingRequestQueryVariables>(GetReportingRequestDocument, variables, options);
}
export function useGetReportingRequestLazyQuery(variables: GetReportingRequestQueryVariables | VueCompositionApi.Ref<GetReportingRequestQueryVariables> | ReactiveFunction<GetReportingRequestQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetReportingRequestQuery, GetReportingRequestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetReportingRequestQuery, GetReportingRequestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetReportingRequestQuery, GetReportingRequestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetReportingRequestQuery, GetReportingRequestQueryVariables>(GetReportingRequestDocument, variables, options);
}
export type GetReportingRequestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetReportingRequestQuery, GetReportingRequestQueryVariables>;
export const ListReportingRequestsDocument = gql`
    query listReportingRequests {
  listReportingRequests {
    id
    title
    description
    referencePeriod
    dueDate
    requestType
    portfolioId
    fundId
    createdAt
    metricIds
    ventures {
      ventureId
      status
      metricIds
      statusSummary {
        totalKpis
        completedKpis
        skippedKpis
        incompleteKpis
      }
      questionnaireId
      venture {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useListReportingRequestsQuery__
 *
 * To run a query within a Vue component, call `useListReportingRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListReportingRequestsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListReportingRequestsQuery();
 */
export function useListReportingRequestsQuery(options: VueApolloComposable.UseQueryOptions<ListReportingRequestsQuery, ListReportingRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListReportingRequestsQuery, ListReportingRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListReportingRequestsQuery, ListReportingRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListReportingRequestsQuery, ListReportingRequestsQueryVariables>(ListReportingRequestsDocument, {}, options);
}
export function useListReportingRequestsLazyQuery(options: VueApolloComposable.UseQueryOptions<ListReportingRequestsQuery, ListReportingRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListReportingRequestsQuery, ListReportingRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListReportingRequestsQuery, ListReportingRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListReportingRequestsQuery, ListReportingRequestsQueryVariables>(ListReportingRequestsDocument, {}, options);
}
export type ListReportingRequestsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListReportingRequestsQuery, ListReportingRequestsQueryVariables>;
export const ReportingRequestKpiOptionsDocument = gql`
    query reportingRequestKpiOptions($ventureIds: [UUID!]!) {
  reportingRequestKpiOptions(ventureIds: $ventureIds) {
    metricId
    metricName
    ventureIds
  }
}
    `;

/**
 * __useReportingRequestKpiOptionsQuery__
 *
 * To run a query within a Vue component, call `useReportingRequestKpiOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingRequestKpiOptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReportingRequestKpiOptionsQuery({
 *   ventureIds: // value for 'ventureIds'
 * });
 */
export function useReportingRequestKpiOptionsQuery(variables: ReportingRequestKpiOptionsQueryVariables | VueCompositionApi.Ref<ReportingRequestKpiOptionsQueryVariables> | ReactiveFunction<ReportingRequestKpiOptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ReportingRequestKpiOptionsQuery, ReportingRequestKpiOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReportingRequestKpiOptionsQuery, ReportingRequestKpiOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReportingRequestKpiOptionsQuery, ReportingRequestKpiOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ReportingRequestKpiOptionsQuery, ReportingRequestKpiOptionsQueryVariables>(ReportingRequestKpiOptionsDocument, variables, options);
}
export function useReportingRequestKpiOptionsLazyQuery(variables: ReportingRequestKpiOptionsQueryVariables | VueCompositionApi.Ref<ReportingRequestKpiOptionsQueryVariables> | ReactiveFunction<ReportingRequestKpiOptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ReportingRequestKpiOptionsQuery, ReportingRequestKpiOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReportingRequestKpiOptionsQuery, ReportingRequestKpiOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReportingRequestKpiOptionsQuery, ReportingRequestKpiOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ReportingRequestKpiOptionsQuery, ReportingRequestKpiOptionsQueryVariables>(ReportingRequestKpiOptionsDocument, variables, options);
}
export type ReportingRequestKpiOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ReportingRequestKpiOptionsQuery, ReportingRequestKpiOptionsQueryVariables>;
export const ReportingVenturesMissingEsgModuleDocument = gql`
    query reportingVenturesMissingEsgModule($ventureIds: [UUID!]!) {
  reportingVenturesMissingEsgModule(ventureIds: $ventureIds)
}
    `;

/**
 * __useReportingVenturesMissingEsgModuleQuery__
 *
 * To run a query within a Vue component, call `useReportingVenturesMissingEsgModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingVenturesMissingEsgModuleQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReportingVenturesMissingEsgModuleQuery({
 *   ventureIds: // value for 'ventureIds'
 * });
 */
export function useReportingVenturesMissingEsgModuleQuery(variables: ReportingVenturesMissingEsgModuleQueryVariables | VueCompositionApi.Ref<ReportingVenturesMissingEsgModuleQueryVariables> | ReactiveFunction<ReportingVenturesMissingEsgModuleQueryVariables>, options: VueApolloComposable.UseQueryOptions<ReportingVenturesMissingEsgModuleQuery, ReportingVenturesMissingEsgModuleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReportingVenturesMissingEsgModuleQuery, ReportingVenturesMissingEsgModuleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReportingVenturesMissingEsgModuleQuery, ReportingVenturesMissingEsgModuleQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ReportingVenturesMissingEsgModuleQuery, ReportingVenturesMissingEsgModuleQueryVariables>(ReportingVenturesMissingEsgModuleDocument, variables, options);
}
export function useReportingVenturesMissingEsgModuleLazyQuery(variables: ReportingVenturesMissingEsgModuleQueryVariables | VueCompositionApi.Ref<ReportingVenturesMissingEsgModuleQueryVariables> | ReactiveFunction<ReportingVenturesMissingEsgModuleQueryVariables>, options: VueApolloComposable.UseQueryOptions<ReportingVenturesMissingEsgModuleQuery, ReportingVenturesMissingEsgModuleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReportingVenturesMissingEsgModuleQuery, ReportingVenturesMissingEsgModuleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReportingVenturesMissingEsgModuleQuery, ReportingVenturesMissingEsgModuleQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ReportingVenturesMissingEsgModuleQuery, ReportingVenturesMissingEsgModuleQueryVariables>(ReportingVenturesMissingEsgModuleDocument, variables, options);
}
export type ReportingVenturesMissingEsgModuleQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ReportingVenturesMissingEsgModuleQuery, ReportingVenturesMissingEsgModuleQueryVariables>;
export const ReportingVenturesMissingImpactCarryDocument = gql`
    query reportingVenturesMissingImpactCarry($ventureIds: [UUID!]!) {
  reportingVenturesMissingImpactCarry(ventureIds: $ventureIds)
}
    `;

/**
 * __useReportingVenturesMissingImpactCarryQuery__
 *
 * To run a query within a Vue component, call `useReportingVenturesMissingImpactCarryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingVenturesMissingImpactCarryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReportingVenturesMissingImpactCarryQuery({
 *   ventureIds: // value for 'ventureIds'
 * });
 */
export function useReportingVenturesMissingImpactCarryQuery(variables: ReportingVenturesMissingImpactCarryQueryVariables | VueCompositionApi.Ref<ReportingVenturesMissingImpactCarryQueryVariables> | ReactiveFunction<ReportingVenturesMissingImpactCarryQueryVariables>, options: VueApolloComposable.UseQueryOptions<ReportingVenturesMissingImpactCarryQuery, ReportingVenturesMissingImpactCarryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReportingVenturesMissingImpactCarryQuery, ReportingVenturesMissingImpactCarryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReportingVenturesMissingImpactCarryQuery, ReportingVenturesMissingImpactCarryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ReportingVenturesMissingImpactCarryQuery, ReportingVenturesMissingImpactCarryQueryVariables>(ReportingVenturesMissingImpactCarryDocument, variables, options);
}
export function useReportingVenturesMissingImpactCarryLazyQuery(variables: ReportingVenturesMissingImpactCarryQueryVariables | VueCompositionApi.Ref<ReportingVenturesMissingImpactCarryQueryVariables> | ReactiveFunction<ReportingVenturesMissingImpactCarryQueryVariables>, options: VueApolloComposable.UseQueryOptions<ReportingVenturesMissingImpactCarryQuery, ReportingVenturesMissingImpactCarryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReportingVenturesMissingImpactCarryQuery, ReportingVenturesMissingImpactCarryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReportingVenturesMissingImpactCarryQuery, ReportingVenturesMissingImpactCarryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ReportingVenturesMissingImpactCarryQuery, ReportingVenturesMissingImpactCarryQueryVariables>(ReportingVenturesMissingImpactCarryDocument, variables, options);
}
export type ReportingVenturesMissingImpactCarryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ReportingVenturesMissingImpactCarryQuery, ReportingVenturesMissingImpactCarryQueryVariables>;
export const ExportReviewCompanyTypstPdfsDocument = gql`
    query exportReviewCompanyTypstPdfs($input: ExportReviewCompanyTypstPdfsInput!) {
  exportReviewCompanyTypstPdfs(input: $input) {
    zipFile {
      fileName
      format
      base64String
    }
    items {
      ventureId
      status
      errorMessage
    }
  }
}
    `;

/**
 * __useExportReviewCompanyTypstPdfsQuery__
 *
 * To run a query within a Vue component, call `useExportReviewCompanyTypstPdfsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportReviewCompanyTypstPdfsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExportReviewCompanyTypstPdfsQuery({
 *   input: // value for 'input'
 * });
 */
export function useExportReviewCompanyTypstPdfsQuery(variables: ExportReviewCompanyTypstPdfsQueryVariables | VueCompositionApi.Ref<ExportReviewCompanyTypstPdfsQueryVariables> | ReactiveFunction<ExportReviewCompanyTypstPdfsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExportReviewCompanyTypstPdfsQuery, ExportReviewCompanyTypstPdfsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportReviewCompanyTypstPdfsQuery, ExportReviewCompanyTypstPdfsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportReviewCompanyTypstPdfsQuery, ExportReviewCompanyTypstPdfsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ExportReviewCompanyTypstPdfsQuery, ExportReviewCompanyTypstPdfsQueryVariables>(ExportReviewCompanyTypstPdfsDocument, variables, options);
}
export function useExportReviewCompanyTypstPdfsLazyQuery(variables: ExportReviewCompanyTypstPdfsQueryVariables | VueCompositionApi.Ref<ExportReviewCompanyTypstPdfsQueryVariables> | ReactiveFunction<ExportReviewCompanyTypstPdfsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExportReviewCompanyTypstPdfsQuery, ExportReviewCompanyTypstPdfsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportReviewCompanyTypstPdfsQuery, ExportReviewCompanyTypstPdfsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportReviewCompanyTypstPdfsQuery, ExportReviewCompanyTypstPdfsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ExportReviewCompanyTypstPdfsQuery, ExportReviewCompanyTypstPdfsQueryVariables>(ExportReviewCompanyTypstPdfsDocument, variables, options);
}
export type ExportReviewCompanyTypstPdfsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ExportReviewCompanyTypstPdfsQuery, ExportReviewCompanyTypstPdfsQueryVariables>;
export const ExportReviewImpactDataDocument = gql`
    query exportReviewImpactData($input: ExportReviewImpactDataInput!) {
  exportReviewImpactData(input: $input) {
    fileName
    format
    base64String
  }
}
    `;

/**
 * __useExportReviewImpactDataQuery__
 *
 * To run a query within a Vue component, call `useExportReviewImpactDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportReviewImpactDataQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExportReviewImpactDataQuery({
 *   input: // value for 'input'
 * });
 */
export function useExportReviewImpactDataQuery(variables: ExportReviewImpactDataQueryVariables | VueCompositionApi.Ref<ExportReviewImpactDataQueryVariables> | ReactiveFunction<ExportReviewImpactDataQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExportReviewImpactDataQuery, ExportReviewImpactDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportReviewImpactDataQuery, ExportReviewImpactDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportReviewImpactDataQuery, ExportReviewImpactDataQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ExportReviewImpactDataQuery, ExportReviewImpactDataQueryVariables>(ExportReviewImpactDataDocument, variables, options);
}
export function useExportReviewImpactDataLazyQuery(variables: ExportReviewImpactDataQueryVariables | VueCompositionApi.Ref<ExportReviewImpactDataQueryVariables> | ReactiveFunction<ExportReviewImpactDataQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExportReviewImpactDataQuery, ExportReviewImpactDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportReviewImpactDataQuery, ExportReviewImpactDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportReviewImpactDataQuery, ExportReviewImpactDataQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ExportReviewImpactDataQuery, ExportReviewImpactDataQueryVariables>(ExportReviewImpactDataDocument, variables, options);
}
export type ExportReviewImpactDataQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ExportReviewImpactDataQuery, ExportReviewImpactDataQueryVariables>;
export const GetReviewRequestDocument = gql`
    query getReviewRequest($id: UUID!) {
  getReviewRequest(id: $id) {
    id
    title
    description
    reviewType
    createdAt
    createdBy {
      email
      firstName
      lastName
    }
    assignedReviewers {
      id
      email
    }
    ventures {
      ventureId
      status
      venture {
        id
        name
        logo
      }
      latestEvent {
        id
        eventType
        comment
        createdAt
        snapshot
        reviewer {
          email
        }
      }
    }
  }
}
    `;

/**
 * __useGetReviewRequestQuery__
 *
 * To run a query within a Vue component, call `useGetReviewRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewRequestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetReviewRequestQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetReviewRequestQuery(variables: GetReviewRequestQueryVariables | VueCompositionApi.Ref<GetReviewRequestQueryVariables> | ReactiveFunction<GetReviewRequestQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetReviewRequestQuery, GetReviewRequestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetReviewRequestQuery, GetReviewRequestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetReviewRequestQuery, GetReviewRequestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetReviewRequestQuery, GetReviewRequestQueryVariables>(GetReviewRequestDocument, variables, options);
}
export function useGetReviewRequestLazyQuery(variables: GetReviewRequestQueryVariables | VueCompositionApi.Ref<GetReviewRequestQueryVariables> | ReactiveFunction<GetReviewRequestQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetReviewRequestQuery, GetReviewRequestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetReviewRequestQuery, GetReviewRequestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetReviewRequestQuery, GetReviewRequestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetReviewRequestQuery, GetReviewRequestQueryVariables>(GetReviewRequestDocument, variables, options);
}
export type GetReviewRequestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetReviewRequestQuery, GetReviewRequestQueryVariables>;
export const ListReviewEventsDocument = gql`
    query listReviewEvents($filters: ReviewEventFilters!, $offset: Int, $limit: Int) {
  listReviewEvents(filters: $filters, offset: $offset, limit: $limit) {
    id
    eventType
    comment
    createdAt
    ventureId
    reviewer {
      email
    }
    venture {
      id
      name
    }
  }
  countReviewEvents(filters: $filters)
}
    `;

/**
 * __useListReviewEventsQuery__
 *
 * To run a query within a Vue component, call `useListReviewEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListReviewEventsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListReviewEventsQuery({
 *   filters: // value for 'filters'
 *   offset: // value for 'offset'
 *   limit: // value for 'limit'
 * });
 */
export function useListReviewEventsQuery(variables: ListReviewEventsQueryVariables | VueCompositionApi.Ref<ListReviewEventsQueryVariables> | ReactiveFunction<ListReviewEventsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListReviewEventsQuery, ListReviewEventsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListReviewEventsQuery, ListReviewEventsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListReviewEventsQuery, ListReviewEventsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListReviewEventsQuery, ListReviewEventsQueryVariables>(ListReviewEventsDocument, variables, options);
}
export function useListReviewEventsLazyQuery(variables: ListReviewEventsQueryVariables | VueCompositionApi.Ref<ListReviewEventsQueryVariables> | ReactiveFunction<ListReviewEventsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListReviewEventsQuery, ListReviewEventsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListReviewEventsQuery, ListReviewEventsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListReviewEventsQuery, ListReviewEventsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListReviewEventsQuery, ListReviewEventsQueryVariables>(ListReviewEventsDocument, variables, options);
}
export type ListReviewEventsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListReviewEventsQuery, ListReviewEventsQueryVariables>;
export const ListReviewRequestsDocument = gql`
    query listReviewRequests {
  listReviewRequests {
    id
    title
    description
    reviewType
    createdAt
    createdBy {
      email
    }
    assignedReviewers {
      id
      email
    }
    ventures {
      ventureId
      status
      venture {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useListReviewRequestsQuery__
 *
 * To run a query within a Vue component, call `useListReviewRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListReviewRequestsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListReviewRequestsQuery();
 */
export function useListReviewRequestsQuery(options: VueApolloComposable.UseQueryOptions<ListReviewRequestsQuery, ListReviewRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListReviewRequestsQuery, ListReviewRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListReviewRequestsQuery, ListReviewRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListReviewRequestsQuery, ListReviewRequestsQueryVariables>(ListReviewRequestsDocument, {}, options);
}
export function useListReviewRequestsLazyQuery(options: VueApolloComposable.UseQueryOptions<ListReviewRequestsQuery, ListReviewRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListReviewRequestsQuery, ListReviewRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListReviewRequestsQuery, ListReviewRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListReviewRequestsQuery, ListReviewRequestsQueryVariables>(ListReviewRequestsDocument, {}, options);
}
export type ListReviewRequestsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListReviewRequestsQuery, ListReviewRequestsQueryVariables>;
export const GetStakeholderDocument = gql`
    query GetStakeholder($id: UUID!) {
  getStakeholder(id: $id) {
    id
    name
    type
    description
    activityLinks {
      id
      activityId
      activity {
        id
        name
        geographyId
      }
      stakeholderId
      impactMaterial
      financialMaterial
    }
    iroLinks {
      id
      iroId
      iro {
        id
        name
      }
      stakeholderId
      impactMaterial
      financialMaterial
    }
  }
}
    `;

/**
 * __useGetStakeholderQuery__
 *
 * To run a query within a Vue component, call `useGetStakeholderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStakeholderQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStakeholderQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetStakeholderQuery(variables: GetStakeholderQueryVariables | VueCompositionApi.Ref<GetStakeholderQueryVariables> | ReactiveFunction<GetStakeholderQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetStakeholderQuery, GetStakeholderQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetStakeholderQuery, GetStakeholderQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetStakeholderQuery, GetStakeholderQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetStakeholderQuery, GetStakeholderQueryVariables>(GetStakeholderDocument, variables, options);
}
export function useGetStakeholderLazyQuery(variables: GetStakeholderQueryVariables | VueCompositionApi.Ref<GetStakeholderQueryVariables> | ReactiveFunction<GetStakeholderQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetStakeholderQuery, GetStakeholderQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetStakeholderQuery, GetStakeholderQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetStakeholderQuery, GetStakeholderQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetStakeholderQuery, GetStakeholderQueryVariables>(GetStakeholderDocument, variables, options);
}
export type GetStakeholderQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetStakeholderQuery, GetStakeholderQueryVariables>;
export const ListStakeholdersDocument = gql`
    query ListStakeholders($filters: ListStakeholderFilter, $limit: Int, $offset: Int) {
  listStakeholders(filters: $filters, limit: $limit, offset: $offset) {
    id
    name
    type
    description
    activityLinks {
      id
      activityId
      activity {
        id
        name
        type
        geographyId
      }
      stakeholderId
      impactMaterial
      financialMaterial
    }
    iroLinks {
      id
      iroId
      iro {
        id
        name
        levelOfImpact
        type
        overrideStatus
        status
      }
      stakeholderId
      impactMaterial
      financialMaterial
    }
  }
  countStakeholders(filters: $filters)
}
    `;

/**
 * __useListStakeholdersQuery__
 *
 * To run a query within a Vue component, call `useListStakeholdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListStakeholdersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListStakeholdersQuery({
 *   filters: // value for 'filters'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 * });
 */
export function useListStakeholdersQuery(variables: ListStakeholdersQueryVariables | VueCompositionApi.Ref<ListStakeholdersQueryVariables> | ReactiveFunction<ListStakeholdersQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListStakeholdersQuery, ListStakeholdersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListStakeholdersQuery, ListStakeholdersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListStakeholdersQuery, ListStakeholdersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListStakeholdersQuery, ListStakeholdersQueryVariables>(ListStakeholdersDocument, variables, options);
}
export function useListStakeholdersLazyQuery(variables: ListStakeholdersQueryVariables | VueCompositionApi.Ref<ListStakeholdersQueryVariables> | ReactiveFunction<ListStakeholdersQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListStakeholdersQuery, ListStakeholdersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListStakeholdersQuery, ListStakeholdersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListStakeholdersQuery, ListStakeholdersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListStakeholdersQuery, ListStakeholdersQueryVariables>(ListStakeholdersDocument, variables, options);
}
export type ListStakeholdersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListStakeholdersQuery, ListStakeholdersQueryVariables>;
export const ChatgptTranslateDocument = gql`
    query ChatgptTranslate($input: ChatgptTranslationInput!, $prompt: PromptEnum) {
  chatgptTranslate(input: $input, prompt: $prompt) {
    inputText
    sourceLanguage
    translatedText
    targetLanguage
  }
}
    `;

/**
 * __useChatgptTranslateQuery__
 *
 * To run a query within a Vue component, call `useChatgptTranslateQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatgptTranslateQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChatgptTranslateQuery({
 *   input: // value for 'input'
 *   prompt: // value for 'prompt'
 * });
 */
export function useChatgptTranslateQuery(variables: ChatgptTranslateQueryVariables | VueCompositionApi.Ref<ChatgptTranslateQueryVariables> | ReactiveFunction<ChatgptTranslateQueryVariables>, options: VueApolloComposable.UseQueryOptions<ChatgptTranslateQuery, ChatgptTranslateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ChatgptTranslateQuery, ChatgptTranslateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ChatgptTranslateQuery, ChatgptTranslateQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ChatgptTranslateQuery, ChatgptTranslateQueryVariables>(ChatgptTranslateDocument, variables, options);
}
export function useChatgptTranslateLazyQuery(variables: ChatgptTranslateQueryVariables | VueCompositionApi.Ref<ChatgptTranslateQueryVariables> | ReactiveFunction<ChatgptTranslateQueryVariables>, options: VueApolloComposable.UseQueryOptions<ChatgptTranslateQuery, ChatgptTranslateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ChatgptTranslateQuery, ChatgptTranslateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ChatgptTranslateQuery, ChatgptTranslateQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ChatgptTranslateQuery, ChatgptTranslateQueryVariables>(ChatgptTranslateDocument, variables, options);
}
export type ChatgptTranslateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ChatgptTranslateQuery, ChatgptTranslateQueryVariables>;
export const ListUserInputsDocument = gql`
    query listUserInputs($input: [UserInputInput!]!) {
  listUserInputs(input: $input) {
    ventureId
    periodId
    userInput {
      id
      text
      selectedOptions {
        id
        label
      }
      geographyIds
    }
  }
}
    `;

/**
 * __useListUserInputsQuery__
 *
 * To run a query within a Vue component, call `useListUserInputsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUserInputsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListUserInputsQuery({
 *   input: // value for 'input'
 * });
 */
export function useListUserInputsQuery(variables: ListUserInputsQueryVariables | VueCompositionApi.Ref<ListUserInputsQueryVariables> | ReactiveFunction<ListUserInputsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListUserInputsQuery, ListUserInputsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListUserInputsQuery, ListUserInputsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListUserInputsQuery, ListUserInputsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListUserInputsQuery, ListUserInputsQueryVariables>(ListUserInputsDocument, variables, options);
}
export function useListUserInputsLazyQuery(variables: ListUserInputsQueryVariables | VueCompositionApi.Ref<ListUserInputsQueryVariables> | ReactiveFunction<ListUserInputsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListUserInputsQuery, ListUserInputsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListUserInputsQuery, ListUserInputsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListUserInputsQuery, ListUserInputsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListUserInputsQuery, ListUserInputsQueryVariables>(ListUserInputsDocument, variables, options);
}
export type ListUserInputsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListUserInputsQuery, ListUserInputsQueryVariables>;
export const CheckEmailDomainAccountWarningDocument = gql`
    query CheckEmailDomainAccountWarning($email: String!) {
  checkEmailDomainAccountWarning(email: $email) {
    domainMatched
    accountNames
    additionalCount
  }
}
    `;

/**
 * __useCheckEmailDomainAccountWarningQuery__
 *
 * To run a query within a Vue component, call `useCheckEmailDomainAccountWarningQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckEmailDomainAccountWarningQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCheckEmailDomainAccountWarningQuery({
 *   email: // value for 'email'
 * });
 */
export function useCheckEmailDomainAccountWarningQuery(variables: CheckEmailDomainAccountWarningQueryVariables | VueCompositionApi.Ref<CheckEmailDomainAccountWarningQueryVariables> | ReactiveFunction<CheckEmailDomainAccountWarningQueryVariables>, options: VueApolloComposable.UseQueryOptions<CheckEmailDomainAccountWarningQuery, CheckEmailDomainAccountWarningQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CheckEmailDomainAccountWarningQuery, CheckEmailDomainAccountWarningQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CheckEmailDomainAccountWarningQuery, CheckEmailDomainAccountWarningQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CheckEmailDomainAccountWarningQuery, CheckEmailDomainAccountWarningQueryVariables>(CheckEmailDomainAccountWarningDocument, variables, options);
}
export function useCheckEmailDomainAccountWarningLazyQuery(variables: CheckEmailDomainAccountWarningQueryVariables | VueCompositionApi.Ref<CheckEmailDomainAccountWarningQueryVariables> | ReactiveFunction<CheckEmailDomainAccountWarningQueryVariables>, options: VueApolloComposable.UseQueryOptions<CheckEmailDomainAccountWarningQuery, CheckEmailDomainAccountWarningQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CheckEmailDomainAccountWarningQuery, CheckEmailDomainAccountWarningQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CheckEmailDomainAccountWarningQuery, CheckEmailDomainAccountWarningQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CheckEmailDomainAccountWarningQuery, CheckEmailDomainAccountWarningQueryVariables>(CheckEmailDomainAccountWarningDocument, variables, options);
}
export type CheckEmailDomainAccountWarningQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CheckEmailDomainAccountWarningQuery, CheckEmailDomainAccountWarningQueryVariables>;
export const GetUserDocument = gql`
    query getUser {
  getUser {
    id
    isAdmin
    realUserIsAdmin
    isImpersonated
    locale
    email
    firstName
    lastName
    accounts {
      id
      name
      type
      movedToUrls
    }
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a Vue component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUserQuery();
 */
export function useGetUserQuery(options: VueApolloComposable.UseQueryOptions<GetUserQuery, GetUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserQuery, GetUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserQuery, GetUserQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, {}, options);
}
export function useGetUserLazyQuery(options: VueApolloComposable.UseQueryOptions<GetUserQuery, GetUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserQuery, GetUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserQuery, GetUserQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, {}, options);
}
export type GetUserQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetUserQuery, GetUserQueryVariables>;
export const GetUserByIdDocument = gql`
    query getUserById($id: UUID!) {
  getUserById(id: $id) {
    id
    firstName
    lastName
  }
}
    `;

/**
 * __useGetUserByIdQuery__
 *
 * To run a query within a Vue component, call `useGetUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUserByIdQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetUserByIdQuery(variables: GetUserByIdQueryVariables | VueCompositionApi.Ref<GetUserByIdQueryVariables> | ReactiveFunction<GetUserByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetUserByIdQuery, GetUserByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserByIdQuery, GetUserByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserByIdQuery, GetUserByIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, variables, options);
}
export function useGetUserByIdLazyQuery(variables: GetUserByIdQueryVariables | VueCompositionApi.Ref<GetUserByIdQueryVariables> | ReactiveFunction<GetUserByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetUserByIdQuery, GetUserByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserByIdQuery, GetUserByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserByIdQuery, GetUserByIdQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, variables, options);
}
export type GetUserByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetUserByIdQuery, GetUserByIdQueryVariables>;
export const ListUsersDocument = gql`
    query listUsers($accountId: UUID, $search: String, $limit: Int, $offset: Int) {
  listUsers(
    accountId: $accountId
    limit: $limit
    offset: $offset
    search: $search
  ) {
    id
    locale
    firstName
    lastName
    email
    lastLogin
    isIxAdmin
    membershipRolesForAccount(accountId: $accountId)
    accounts {
      id
      name
    }
  }
  countUsers(accountId: $accountId, search: $search)
}
    `;

/**
 * __useListUsersQuery__
 *
 * To run a query within a Vue component, call `useListUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListUsersQuery({
 *   accountId: // value for 'accountId'
 *   search: // value for 'search'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 * });
 */
export function useListUsersQuery(variables: ListUsersQueryVariables | VueCompositionApi.Ref<ListUsersQueryVariables> | ReactiveFunction<ListUsersQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListUsersQuery, ListUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListUsersQuery, ListUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListUsersQuery, ListUsersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, variables, options);
}
export function useListUsersLazyQuery(variables: ListUsersQueryVariables | VueCompositionApi.Ref<ListUsersQueryVariables> | ReactiveFunction<ListUsersQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListUsersQuery, ListUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListUsersQuery, ListUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListUsersQuery, ListUsersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, variables, options);
}
export type ListUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListUsersQuery, ListUsersQueryVariables>;
export const ListUserLogEventsDocument = gql`
    query listUserLogEvents($email: String!, $perPage: Int, $page: Int) {
  listUserLogEvents(email: $email, perPage: $perPage, page: $page)
}
    `;

/**
 * __useListUserLogEventsQuery__
 *
 * To run a query within a Vue component, call `useListUserLogEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUserLogEventsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListUserLogEventsQuery({
 *   email: // value for 'email'
 *   perPage: // value for 'perPage'
 *   page: // value for 'page'
 * });
 */
export function useListUserLogEventsQuery(variables: ListUserLogEventsQueryVariables | VueCompositionApi.Ref<ListUserLogEventsQueryVariables> | ReactiveFunction<ListUserLogEventsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListUserLogEventsQuery, ListUserLogEventsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListUserLogEventsQuery, ListUserLogEventsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListUserLogEventsQuery, ListUserLogEventsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListUserLogEventsQuery, ListUserLogEventsQueryVariables>(ListUserLogEventsDocument, variables, options);
}
export function useListUserLogEventsLazyQuery(variables: ListUserLogEventsQueryVariables | VueCompositionApi.Ref<ListUserLogEventsQueryVariables> | ReactiveFunction<ListUserLogEventsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListUserLogEventsQuery, ListUserLogEventsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListUserLogEventsQuery, ListUserLogEventsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListUserLogEventsQuery, ListUserLogEventsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListUserLogEventsQuery, ListUserLogEventsQueryVariables>(ListUserLogEventsDocument, variables, options);
}
export type ListUserLogEventsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListUserLogEventsQuery, ListUserLogEventsQueryVariables>;
export const ValidateFormulaDocument = gql`
    mutation validateFormula($expression: String!) {
  validateFormula(expression: $expression) {
    formula
    error
    humanReadable {
      type
      value
      variable {
        name
        id
      }
    }
  }
}
    `;

/**
 * __useValidateFormulaMutation__
 *
 * To run a mutation, you first call `useValidateFormulaMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useValidateFormulaMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useValidateFormulaMutation({
 *   variables: {
 *     expression: // value for 'expression'
 *   },
 * });
 */
export function useValidateFormulaMutation(options: VueApolloComposable.UseMutationOptions<ValidateFormulaMutation, ValidateFormulaMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ValidateFormulaMutation, ValidateFormulaMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ValidateFormulaMutation, ValidateFormulaMutationVariables>(ValidateFormulaDocument, options);
}
export type ValidateFormulaMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ValidateFormulaMutation, ValidateFormulaMutationVariables>;
export const ValidateTemplateTextDocument = gql`
    query validateTemplateText($templateText: String!, $fundId: Int, $context: TemplateEngineContext, $impactSolutionId: Int) {
  validateTemplateText(
    templateText: $templateText
    fundId: $fundId
    context: $context
    impactSolutionId: $impactSolutionId
  ) {
    valid
    originalText
    processedText
    error
  }
}
    `;

/**
 * __useValidateTemplateTextQuery__
 *
 * To run a query within a Vue component, call `useValidateTemplateTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateTemplateTextQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useValidateTemplateTextQuery({
 *   templateText: // value for 'templateText'
 *   fundId: // value for 'fundId'
 *   context: // value for 'context'
 *   impactSolutionId: // value for 'impactSolutionId'
 * });
 */
export function useValidateTemplateTextQuery(variables: ValidateTemplateTextQueryVariables | VueCompositionApi.Ref<ValidateTemplateTextQueryVariables> | ReactiveFunction<ValidateTemplateTextQueryVariables>, options: VueApolloComposable.UseQueryOptions<ValidateTemplateTextQuery, ValidateTemplateTextQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ValidateTemplateTextQuery, ValidateTemplateTextQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ValidateTemplateTextQuery, ValidateTemplateTextQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ValidateTemplateTextQuery, ValidateTemplateTextQueryVariables>(ValidateTemplateTextDocument, variables, options);
}
export function useValidateTemplateTextLazyQuery(variables: ValidateTemplateTextQueryVariables | VueCompositionApi.Ref<ValidateTemplateTextQueryVariables> | ReactiveFunction<ValidateTemplateTextQueryVariables>, options: VueApolloComposable.UseQueryOptions<ValidateTemplateTextQuery, ValidateTemplateTextQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ValidateTemplateTextQuery, ValidateTemplateTextQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ValidateTemplateTextQuery, ValidateTemplateTextQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ValidateTemplateTextQuery, ValidateTemplateTextQueryVariables>(ValidateTemplateTextDocument, variables, options);
}
export type ValidateTemplateTextQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ValidateTemplateTextQuery, ValidateTemplateTextQueryVariables>;